export const dropdownOptions = {
    reportTypeRepo: [
        {
            'Report Type': 'Next Voyage Information',
            // "option"
            option: 'NEXT VOYAGEINFO REPORT',
            'Related Service': 'OSR',
            'Report Description':
                'Before departure. (Ocean crossing: 72 hours before COSP)',
        },
        {
            'Report Type': 'Unberthing Report',
            option: 'UNBERTHING REPORT',
            'Related Service': 'CIM',
            'Report Description': 'To be used on departure from berth.',
        },
        {
            'Report Type': 'COSP Report',
            option: 'DEPARTURE REPORT',
            'Related Service': 'OSR/CIM',
            'Report Description':
                'Commencement of Sea Passage – to be used on departure from pilot station when a sea passage begins.',
        },
        {
            'Report Type': 'Noon Report',
            option: 'NOON REPORT',
            'Related Service': 'OSR/CIM',
            'Report Description':
                'Noon report at Sea - to be used on every Noon during a sea passage.',
        },
        {
            'Report Type': 'EOSP Report',
            option: 'ARRIVAL REPORT',
            'Related Service': 'OSR/CIM',
            'Report Description':
                'End of Sea Passage – to be used on arrival at pilot station when a sea passage ends.',
        },
        {
            'Report Type': 'Drifting Start Report',
            option: 'DRIFTING START REPORT',
            'Related Service': 'OSR/CIM',
            'Report Description': 'To be used when drifting starts.',
        },
        {
            'Report Type': 'Drifting End Report',
            option: 'DRIFTING END REPORT',
            'Related Service': 'OSR/CIM',
            'Report Description': 'To be used when drifting ends.',
        },
        {
            'Report Type': 'Anchoring Start Report',
            option: 'ANCHORING START REPORT',
            'Related Service': 'CIM',
            'Report Description': 'To be used on drop anchor.',
        },
        {
            'Report Type': 'Anchoring End Report',
            option: 'ANCHORING END REPORT',
            'Related Service': 'CIM',
            'Report Description': 'To be used on heave anchor.',
        },
        {
            'Report Type': 'In Port Noon Report',
            option: 'INPORT NOON REPORT',
            'Related Service': 'CIM',
            'Report Description':
                'Noon report in Port - to be used on every Noon when a vessel stays in port.',
        },
        {
            'Report Type': 'Berthing Report',
            option: 'BERTHING REPORT',
            'Related Service': 'CIM',
            'Report Description': 'To be used on arrival at berth.',
        },
        {
            'Report Type': 'Bunkering Information',
            option: 'BUNKERING REPORT',
            'Related Service': '',
            'Report Description':
                'Attach "[De]Bunker Delivery Note" or "Bunker Survey Report"',
        },
        {
            'Report Type': 'Cargo Information Report',
            option: 'CARGO INFORMATION REPORT',
            'Related Service': '',
            'Report Description':
                'Attach "Bill of Lading", "Cargo Manifest", "Mate Receipt", and/or "Final Stowage/Discharge Plan".',
        },
        {
            'Report Type': 'Event Information',
            option: 'EVENT REPORT',
            'Related Service': 'OSR',
            'Report Description':
                'Use this form for:\n- Start/End stoppage\n- Start/End transit strait\n- Start/End fuel changeover\n- Speed change\n- Destination change\n- Diverted route\n- Start/End ice passage\n- Start/End rescue\n- Start/End pirate\n- Start/End dry-docking\n- Start/End laid-up',
        },
    ],
    reportWNI: [
        {
            //wni_port_code
            option: 'AAB',
            wni_port_name: 'AABENRAA',
            wni_unlocode: 'DKAAB',
            wni_country: 'DK',
            wni_lat: 55.0361,
            wni_lon: 9.4416,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'AAG',
            wni_port_name: 'ALIAGA',
            wni_unlocode: 'TRALI',
            wni_country: 'TR',
            wni_lat: 38.8397,
            wni_lon: 26.9489,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'AAH',
            wni_port_name: 'AAHEIM',
            wni_unlocode: 'NOAHM',
            wni_country: 'NO',
            wni_lat: 62.0521,
            wni_lon: 5.5082,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'ABB',
            wni_port_name: 'ABBOT POINT',
            wni_unlocode: 'AUABP',
            wni_country: 'AU',
            wni_lat: -19.8723,
            wni_lon: 148.0815,
            wni_tz: 'Australia/Brisbane',
        },
        {
            option: 'ABD',
            wni_port_name: 'ABERDEEN',
            wni_unlocode: 'USAB3',
            wni_country: 'US',
            wni_lat: 46.9675,
            wni_lon: -123.8153,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'ABDLL',
            wni_port_name: 'KING ABDULLAH',
            wni_unlocode: 'SAKAC',
            wni_country: 'SA',
            wni_lat: 22.5179,
            wni_lon: 39.0708,
            wni_tz: 'Asia/Riyadh',
        },
        {
            option: 'ABE',
            wni_port_name: 'ABERDEEN',
            wni_unlocode: 'GBABD',
            wni_country: 'GB',
            wni_lat: 57.1494,
            wni_lon: -2.0459,
            wni_tz: 'Europe/London',
        },
        {
            option: 'ABI',
            wni_port_name: 'ABASHIRI',
            wni_unlocode: 'JPABA',
            wni_country: 'JP',
            wni_lat: 44.03,
            wni_lon: 144.2983,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'ABJ',
            wni_port_name: 'ABIDJAN',
            wni_unlocode: 'CIABJ',
            wni_country: 'CI',
            wni_lat: 5.2388,
            wni_lon: -4.0014,
            wni_tz: 'Africa/Abidjan',
        },
        {
            option: 'ABL',
            wni_port_name: 'AMBARLI',
            wni_unlocode: 'TRAMB',
            wni_country: 'TR',
            wni_lat: 40.9441,
            wni_lon: 28.6738,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'ABN',
            wni_port_name: 'ABADAN',
            wni_unlocode: 'IRABD',
            wni_country: 'IR',
            wni_lat: 30.3343,
            wni_lon: 48.2724,
            wni_tz: 'Asia/Tehran',
        },
        {
            option: 'ABS',
            wni_port_name: 'ABURATSU',
            wni_unlocode: 'JPABU',
            wni_country: 'JP',
            wni_lat: 31.5667,
            wni_lon: 131.4167,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'ABU',
            wni_port_name: 'ABU DHABI',
            wni_unlocode: 'AEAUH',
            wni_country: 'AE',
            wni_lat: 24.5496,
            wni_lon: 54.3823,
            wni_tz: 'Asia/Dubai',
        },
        {
            option: 'ABZ',
            wni_port_name: 'ABU ZENIMA',
            wni_unlocode: 'EGAZA',
            wni_country: 'EG',
            wni_lat: 29.0357,
            wni_lon: 33.1119,
            wni_tz: 'Africa/Cairo',
        },
        {
            option: 'ACA',
            wni_port_name: 'ACAPULCO',
            wni_unlocode: 'MXACA',
            wni_country: 'MX',
            wni_lat: 16.8117,
            wni_lon: -99.8912,
            wni_tz: 'America/Mexico_City',
        },
        {
            option: 'ADA',
            wni_port_name: 'ADABIAH (ADABIYA)',
            wni_unlocode: 'EGADA',
            wni_country: 'EG',
            wni_lat: 29.8744,
            wni_lon: 32.4909,
            wni_tz: 'Africa/Cairo',
        },
        {
            option: 'ADG',
            wni_port_name: 'ADANG BAY',
            wni_unlocode: 'IDADB',
            wni_country: 'ID',
            wni_lat: -1.7167,
            wni_lon: 116.6333,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'ADN',
            wni_port_name: 'ADEN',
            wni_unlocode: 'YEADE',
            wni_country: 'YE',
            wni_lat: 12.7885,
            wni_lon: 44.9635,
            wni_tz: 'Asia/Aden',
        },
        {
            option: 'AFG',
            wni_port_name: 'ANTOFAGASTA',
            wni_unlocode: 'CLANF',
            wni_country: 'CL',
            wni_lat: -23.6493,
            wni_lon: -70.4181,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'AFO',
            wni_port_name: 'AFOGNAK',
            wni_unlocode: 'USAFK',
            wni_country: 'US',
            wni_lat: 58.0038,
            wni_lon: -152.7474,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'AGA',
            wni_port_name: 'AGADIR',
            wni_unlocode: 'MAAGA',
            wni_country: 'MA',
            wni_lat: 30.4077,
            wni_lon: -9.6359,
            wni_tz: 'Africa/Casablanca',
        },
        {
            option: 'AGBM',
            wni_port_name: 'AGBAMI OIL FIELD',
            wni_unlocode: 'NGABM',
            wni_country: 'NG',
            wni_lat: 3.4626,
            wni_lon: 5.5605,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'AGE',
            wni_port_name: 'ALGECIRAS',
            wni_unlocode: 'ESALG',
            wni_country: 'ES',
            wni_lat: 36.1291,
            wni_lon: -5.4119,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'AGH',
            wni_port_name: 'AUGHINISH ISLAND',
            wni_unlocode: 'IEAUG',
            wni_country: 'IE',
            wni_lat: 52.6499,
            wni_lon: -9.0661,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'AHH',
            wni_port_name: 'ASH SHIHR',
            wni_unlocode: 'YEASR',
            wni_country: 'YE',
            wni_lat: 14.7428,
            wni_lon: 49.6152,
            wni_tz: 'Asia/Aden',
        },
        {
            option: 'AHS',
            wni_port_name: 'AHUS',
            wni_unlocode: 'SEAHJ',
            wni_country: 'SE',
            wni_lat: 55.9274,
            wni_lon: 14.344,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'AJCC',
            wni_port_name: 'AJACCIO',
            wni_unlocode: 'FRAJA',
            wni_country: 'FR',
            wni_lat: 41.9139,
            wni_lon: 8.756,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'AJM',
            wni_port_name: 'AJMAN',
            wni_unlocode: 'AEAJM',
            wni_country: 'AE',
            wni_lat: 25.438,
            wni_lon: 55.4413,
            wni_tz: 'Asia/Dubai',
        },
        {
            option: 'AJT',
            wni_port_name: 'ACAJUTLA',
            wni_unlocode: 'SVAQJ',
            wni_country: 'SV',
            wni_lat: 13.5771,
            wni_lon: -89.8497,
            wni_tz: 'America/El_Salvador',
        },
        {
            option: 'AJU',
            wni_port_name: 'AL JUBAIL',
            wni_unlocode: 'SAJBI',
            wni_country: 'SA',
            wni_lat: 27.0243,
            wni_lon: 49.7154,
            wni_tz: 'Asia/Riyadh',
        },
        {
            option: 'AKK',
            wni_port_name: 'AKCANSA CANAKKALE',
            wni_unlocode: 'TRCKZ',
            wni_country: 'TR',
            wni_lat: 39.8837,
            wni_lon: 26.1425,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'AKOH',
            wni_port_name: 'AKO',
            wni_unlocode: 'JPAKO',
            wni_country: 'JP',
            wni_lat: 34.7394,
            wni_lon: 134.3659,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'AKT',
            wni_port_name: 'AKITSU',
            wni_unlocode: 'JPAKT',
            wni_country: 'JP',
            wni_lat: 34.3063,
            wni_lon: 132.8178,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'AL',
            wni_port_name: 'ALMERIA',
            wni_unlocode: 'ESLEI',
            wni_country: 'ES',
            wni_lat: 36.8145,
            wni_lon: -2.4682,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'ALA',
            wni_port_name: 'ALBANY (PORT ALBANY)',
            wni_unlocode: 'AUALH',
            wni_country: 'AU',
            wni_lat: -35.0414,
            wni_lon: 117.8844,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'ALAN',
            wni_port_name: 'ALANG',
            wni_unlocode: 'INALA',
            wni_country: 'IN',
            wni_lat: 21.389,
            wni_lon: 72.22,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'ALB',
            wni_port_name: 'ALBANY',
            wni_unlocode: 'USALB',
            wni_country: 'US',
            wni_lat: 42.6424,
            wni_lon: -73.748,
            wni_tz: 'America/New_York',
        },
        {
            option: 'ALC',
            wni_port_name: 'ALCANAR',
            wni_unlocode: 'ESACA',
            wni_country: 'ES',
            wni_lat: 40.5684,
            wni_lon: 0.5683,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'ALF',
            wni_port_name: 'FUJAIRAH (AL-FUJAIRAH)',
            wni_unlocode: 'AEFJR',
            wni_country: 'AE',
            wni_lat: 25.1748,
            wni_lon: 56.3781,
            wni_tz: 'Asia/Dubai',
        },
        {
            option: 'ALG',
            wni_port_name: 'ALGIERS',
            wni_unlocode: 'DZALG',
            wni_country: 'DZ',
            wni_lat: 36.7793,
            wni_lon: 3.0896,
            wni_tz: 'Africa/Algiers',
        },
        {
            option: 'ALI',
            wni_port_name: 'ALICANTE',
            wni_unlocode: 'ESALC',
            wni_country: 'ES',
            wni_lat: 38.3179,
            wni_lon: -0.4799,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'ALL',
            wni_port_name: 'ALLIANCE',
            wni_unlocode: 'USAIA',
            wni_country: 'US',
            wni_lat: 29.6596,
            wni_lon: -89.9595,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'ALOT',
            wni_port_name: 'ALOTAU',
            wni_unlocode: 'PGGUR',
            wni_country: 'PG',
            wni_lat: -10.3179,
            wni_lon: 150.4459,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'ALS',
            wni_port_name: 'AALESUND',
            wni_unlocode: 'NOAES',
            wni_country: 'NO',
            wni_lat: 62.4606,
            wni_lon: 6.1775,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'ALST',
            wni_port_name: 'AL SHAHEEN TERMINAL',
            wni_unlocode: 'QAASN',
            wni_country: 'QA',
            wni_lat: 26.5833,
            wni_lon: 52,
            wni_tz: 'Asia/Qatar',
        },
        {
            option: 'ALT',
            wni_port_name: 'ALTAMIRA',
            wni_unlocode: 'MXATM',
            wni_country: 'MX',
            wni_lat: 22.4876,
            wni_lon: -97.8415,
            wni_tz: 'America/Monterrey',
        },
        {
            option: 'ALX',
            wni_port_name: 'ALEXANDRIA',
            wni_unlocode: 'EGALY',
            wni_country: 'EG',
            wni_lat: 31.2233,
            wni_lon: 29.8908,
            wni_tz: 'Africa/Cairo',
        },
        {
            option: 'ALXDR',
            wni_port_name: 'ALEXANDROUPOLIS',
            wni_unlocode: 'GRAXD',
            wni_country: 'GR',
            wni_lat: 40.8254,
            wni_lon: 25.9044,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'AMA',
            wni_port_name: 'AMUAY BAY',
            wni_unlocode: 'VEAMY',
            wni_country: 'VE',
            wni_lat: 11.7516,
            wni_lon: -70.2214,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'AME',
            wni_port_name: 'AMAMAPARE',
            wni_unlocode: 'IDAMA',
            wni_country: 'ID',
            wni_lat: -4.8639,
            wni_lon: 136.9707,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'AMNA',
            wni_port_name: 'AMAGASAKI NISHINOMIYA ASHIYA',
            wni_unlocode: 'JPAMA',
            wni_country: 'JP',
            wni_lat: 34.6639,
            wni_lon: 135.3423,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'AMS',
            wni_port_name: 'AMSTERDAM',
            wni_unlocode: 'NLAMS',
            wni_country: 'NL',
            wni_lat: 52.3806,
            wni_lon: 4.903,
            wni_tz: 'Europe/Amsterdam',
        },
        {
            option: 'AMURG',
            wni_port_name: 'AMURANG',
            wni_unlocode: 'IDTZD',
            wni_country: 'ID',
            wni_lat: 1.1994,
            wni_lon: 124.56,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'ANA',
            wni_port_name: 'ANACORTES',
            wni_unlocode: 'USOTS',
            wni_country: 'US',
            wni_lat: 48.5249,
            wni_lon: -122.6162,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'ANC',
            wni_port_name: 'ANCHORAGE',
            wni_unlocode: 'USANC',
            wni_country: 'US',
            wni_lat: 61.2308,
            wni_lon: -149.9227,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'ANG',
            wni_port_name: 'ANGRA DOS REIS',
            wni_unlocode: 'BRADR',
            wni_country: 'BR',
            wni_lat: -23.0436,
            wni_lon: -44.3099,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'ANGSI',
            wni_port_name: 'ANGSI TERMINAL',
            wni_unlocode: 'MYANG',
            wni_country: 'MY',
            wni_lat: 5.0833,
            wni_lon: 104.6833,
            wni_tz: 'Etc/GMT-7',
        },
        {
            option: 'ANI',
            wni_port_name: 'ANCONA',
            wni_unlocode: 'ITAOI',
            wni_country: 'IT',
            wni_lat: 43.632,
            wni_lon: 13.4881,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'ANN',
            wni_port_name: 'ANNABA',
            wni_unlocode: 'DZAAE',
            wni_country: 'DZ',
            wni_lat: 36.9004,
            wni_lon: 7.7951,
            wni_tz: 'Africa/Algiers',
        },
        {
            option: 'ANS',
            wni_port_name: 'ASNAES',
            wni_unlocode: 'DKANS',
            wni_country: 'DK',
            wni_lat: 55.6683,
            wni_lon: 11.0591,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'ANT',
            wni_port_name: 'ANTWERP',
            wni_unlocode: 'BEANR',
            wni_country: 'BE',
            wni_lat: 51.2224,
            wni_lon: 4.394,
            wni_tz: 'Europe/Brussels',
        },
        {
            option: 'ANTFR',
            wni_port_name: 'ANTIFER',
            wni_unlocode: 'FRATF',
            wni_country: 'FR',
            wni_lat: 49.6594,
            wni_lon: 0.1028,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'ANY',
            wni_port_name: 'ANYAR',
            wni_unlocode: 'IDANR',
            wni_country: 'ID',
            wni_lat: -6.0248,
            wni_lon: 105.9264,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'AOM',
            wni_port_name: 'AOMORI',
            wni_unlocode: 'JPAOJ',
            wni_country: 'JP',
            wni_lat: 40.8444,
            wni_lon: 140.7443,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'APG',
            wni_port_name: 'ANPING',
            wni_unlocode: 'TWAPG',
            wni_country: 'TW',
            wni_lat: 22.9575,
            wni_lon: 120.1395,
            wni_tz: 'Asia/Taipei',
        },
        {
            option: 'API',
            wni_port_name: 'APIA',
            wni_unlocode: 'WSAPW',
            wni_country: 'WS',
            wni_lat: -13.8215,
            wni_lon: -171.7495,
            wni_tz: 'Pacific/Apia',
        },
        {
            option: 'APO',
            wni_port_name: 'ANNAPOLIS',
            wni_unlocode: 'USANP',
            wni_country: 'US',
            wni_lat: 38.9675,
            wni_lon: -76.4603,
            wni_tz: 'America/New_York',
        },
        {
            option: 'AQA',
            wni_port_name: 'AQABA',
            wni_unlocode: 'JOAQB',
            wni_country: 'JO',
            wni_lat: 29.5107,
            wni_lon: 34.9808,
            wni_tz: 'Asia/Amman',
        },
        {
            option: 'ARA',
            wni_port_name: 'ARATU',
            wni_unlocode: 'BRARB',
            wni_country: 'BR',
            wni_lat: -12.821,
            wni_lon: -38.522,
            wni_tz: 'America/Bahia',
        },
        {
            option: 'ARC',
            wni_port_name: 'ARICA',
            wni_unlocode: 'CLARI',
            wni_country: 'CL',
            wni_lat: -18.4649,
            wni_lon: -70.3361,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'ARGST',
            wni_port_name: 'ARGOSTOLI',
            wni_unlocode: 'GRARM',
            wni_country: 'GR',
            wni_lat: 38.2049,
            wni_lon: 20.4551,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'ARH',
            wni_port_name: 'AARHUS',
            wni_unlocode: 'DKAAR',
            wni_country: 'DK',
            wni_lat: 56.1592,
            wni_lon: 10.2546,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'ARJ',
            wni_port_name: 'ARDJUNA',
            wni_unlocode: 'IDAJN',
            wni_country: 'ID',
            wni_lat: -5.8833,
            wni_lon: 107.75,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'ARN',
            wni_port_name: 'ARUN',
            wni_unlocode: 'IDAUN',
            wni_country: 'ID',
            wni_lat: 5.2315,
            wni_lon: 97.1096,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'ARR',
            wni_port_name: 'ARRECIFE',
            wni_unlocode: 'ESACE',
            wni_country: 'ES',
            wni_lat: 28.9581,
            wni_lon: -13.5205,
            wni_tz: 'Atlantic/Canary',
        },
        {
            option: 'ARSS',
            wni_port_name: 'ARDROSSAN',
            wni_unlocode: 'AUARD',
            wni_country: 'AU',
            wni_lat: -34.4433,
            wni_lon: 137.9357,
            wni_tz: 'Australia/Adelaide',
        },
        {
            option: 'ARTGN',
            wni_port_name: 'AARDALSTANGEN',
            wni_unlocode: 'NOARD',
            wni_country: 'NO',
            wni_lat: 61.2246,
            wni_lon: 7.6854,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'ARYY',
            wni_port_name: 'AL RAYYAN',
            wni_unlocode: 'QARYN',
            wni_country: 'QA',
            wni_lat: 26.6498,
            wni_lon: 51.5502,
            wni_tz: 'Asia/Qatar',
        },
        {
            option: 'ARZ',
            wni_port_name: 'ARZEW',
            wni_unlocode: 'DZAZW',
            wni_country: 'DZ',
            wni_lat: 35.8428,
            wni_lon: -0.2827,
            wni_tz: 'Africa/Algiers',
        },
        {
            option: 'ASH',
            wni_port_name: 'ASHDOD',
            wni_unlocode: 'ILASH',
            wni_country: 'IL',
            wni_lat: 31.8486,
            wni_lon: 34.6266,
            wni_tz: 'Asia/Jerusalem',
        },
        {
            option: 'ASHK',
            wni_port_name: 'ASHKELON',
            wni_unlocode: 'ILAKL',
            wni_country: 'IL',
            wni_lat: 31.6379,
            wni_lon: 34.4952,
            wni_tz: 'Asia/Jerusalem',
        },
        {
            option: 'ASK',
            wni_port_name: 'AIN SUKHNA',
            wni_unlocode: 'EGAIS',
            wni_country: 'EG',
            wni_lat: 29.6451,
            wni_lon: 32.3796,
            wni_tz: 'Africa/Cairo',
        },
        {
            option: 'ASL',
            wni_port_name: 'ASSALUYEH',
            wni_unlocode: 'IRASA',
            wni_country: 'IR',
            wni_lat: 27.5326,
            wni_lon: 52.5313,
            wni_tz: 'Asia/Tehran',
        },
        {
            option: 'ASNCN',
            wni_port_name: 'ASUNCION',
            wni_unlocode: 'PYASU',
            wni_country: 'PY',
            wni_lat: -25.2695,
            wni_lon: -57.6499,
            wni_tz: 'America/Asuncion',
        },
        {
            option: 'ASS',
            wni_port_name: 'ASSAB',
            wni_unlocode: 'ERASA',
            wni_country: 'ER',
            wni_lat: 12.9992,
            wni_lon: 42.7579,
            wni_tz: 'Africa/Asmara',
        },
        {
            option: 'AST',
            wni_port_name: 'ASTORIA',
            wni_unlocode: 'USAST',
            wni_country: 'US',
            wni_lat: 46.1955,
            wni_lon: -123.865,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'ASTA',
            wni_port_name: 'ASTAKOS',
            wni_unlocode: 'GRAST',
            wni_country: 'GR',
            wni_lat: 38.5238,
            wni_lon: 21.0828,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'ATD',
            wni_port_name: 'AGIOI THEODOROI',
            wni_unlocode: 'GRAGT',
            wni_country: 'GR',
            wni_lat: 37.9034,
            wni_lon: 23.0845,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'ATL',
            wni_port_name: 'ANTALYA',
            wni_unlocode: 'TRAYT',
            wni_country: 'TR',
            wni_lat: 36.8376,
            wni_lon: 30.6246,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'ATS',
            wni_port_name: 'ATSUMI',
            wni_unlocode: 'JPATM',
            wni_country: 'JP',
            wni_lat: 34.6689,
            wni_lon: 137.0754,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'AUG',
            wni_port_name: 'AUGUSTA',
            wni_unlocode: 'ITAUG',
            wni_country: 'IT',
            wni_lat: 37.1911,
            wni_lon: 15.2491,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'AUK',
            wni_port_name: 'AUCKLAND',
            wni_unlocode: 'NZAKL',
            wni_country: 'NZ',
            wni_lat: -36.8359,
            wni_lon: 174.7791,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'AVE',
            wni_port_name: 'AVEIRO',
            wni_unlocode: 'PTAVE',
            wni_country: 'PT',
            wni_lat: 40.6528,
            wni_lon: -8.7325,
            wni_tz: 'Europe/Lisbon',
        },
        {
            option: 'AVL',
            wni_port_name: 'AVILES',
            wni_unlocode: 'ESAVS',
            wni_country: 'ES',
            wni_lat: 43.5968,
            wni_lon: -5.9554,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'AVLN',
            wni_port_name: 'AVALON',
            wni_unlocode: 'USAOU',
            wni_country: 'US',
            wni_lat: 33.35,
            wni_lon: -118.3167,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'AVN',
            wni_port_name: 'AVONMOUTH',
            wni_unlocode: 'GBAVO',
            wni_country: 'GB',
            wni_lat: 51.5173,
            wni_lon: -2.7254,
            wni_tz: 'Europe/London',
        },
        {
            option: 'AYMAH',
            wni_port_name: "JU'AYMAH",
            wni_unlocode: 'SAJUT',
            wni_country: 'SA',
            wni_lat: 26.8737,
            wni_lon: 50.0545,
            wni_tz: 'Asia/Riyadh',
        },
        {
            option: 'BA',
            wni_port_name: 'BARI',
            wni_unlocode: 'ITBRI',
            wni_country: 'IT',
            wni_lat: 41.154,
            wni_lon: 16.8489,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'BAA',
            wni_port_name: 'BANDAR ABBAS',
            wni_unlocode: 'IRBND',
            wni_country: 'IR',
            wni_lat: 27.1194,
            wni_lon: 56.206,
            wni_tz: 'Asia/Tehran',
        },
        {
            option: 'BAC',
            wni_port_name: 'BACOLOD',
            wni_unlocode: 'PHBCD',
            wni_country: 'PH',
            wni_lat: 10.68,
            wni_lon: 122.9226,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'BACI',
            wni_port_name: 'BATULICIN',
            wni_unlocode: 'IDBTW',
            wni_country: 'ID',
            wni_lat: -3.428,
            wni_lon: 116.01,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'BAD',
            wni_port_name: 'BANDAR MAHSHAHR',
            wni_unlocode: 'IRMRX',
            wni_country: 'IR',
            wni_lat: 30.4306,
            wni_lon: 49.1534,
            wni_tz: 'Asia/Tehran',
        },
        {
            option: 'BAE',
            wni_port_name: 'BARCELONA',
            wni_unlocode: 'ESBCN',
            wni_country: 'ES',
            wni_lat: 41.3281,
            wni_lon: 2.1764,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'BAHOPI',
            wni_port_name: 'BAHUDOPI',
            wni_unlocode: 'IDBAH',
            wni_country: 'ID',
            wni_lat: -2.8012,
            wni_lon: 122.1673,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'BAI',
            wni_port_name: 'BAIE COMEAU',
            wni_unlocode: 'CABCO',
            wni_country: 'CA',
            wni_lat: 49.2307,
            wni_lon: -68.1149,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'BAJ',
            wni_port_name: 'BANJUL',
            wni_unlocode: 'GMBJL',
            wni_country: 'GM',
            wni_lat: 13.4454,
            wni_lon: -16.5637,
            wni_tz: 'Africa/Banjul',
        },
        {
            option: 'BAK',
            wni_port_name: 'BAKAR',
            wni_unlocode: 'HRBAK',
            wni_country: 'HR',
            wni_lat: 45.2682,
            wni_lon: 14.5474,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'BAL',
            wni_port_name: 'BALBOA',
            wni_unlocode: 'PABLB',
            wni_country: 'PA',
            wni_lat: 8.9646,
            wni_lon: -79.5197,
            wni_tz: 'America/Panama',
        },
        {
            option: 'BALH',
            wni_port_name: 'BALHAF',
            wni_unlocode: 'YEBLH',
            wni_country: 'YE',
            wni_lat: 13.9728,
            wni_lon: 48.1631,
            wni_tz: 'Asia/Aden',
        },
        {
            option: 'BALT',
            wni_port_name: 'BALTIMORE',
            wni_unlocode: 'USBAL',
            wni_country: 'US',
            wni_lat: 39.256,
            wni_lon: -76.5722,
            wni_tz: 'America/New_York',
        },
        {
            option: 'BALY',
            wni_port_name: 'BALTIYSK',
            wni_unlocode: 'RUBLT',
            wni_country: 'RU',
            wni_lat: 54.6299,
            wni_lon: 19.9569,
            wni_tz: 'Europe/Kaliningrad',
        },
        {
            option: 'BAN',
            wni_port_name: 'BATAAN',
            wni_unlocode: 'PHBTN',
            wni_country: 'PH',
            wni_lat: 14.4238,
            wni_lon: 120.5022,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'BAOS',
            wni_port_name: 'BAOSHAN',
            wni_unlocode: 'CNBOH',
            wni_country: 'CN',
            wni_lat: 31.4287,
            wni_lon: 121.4879,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'BAOT',
            wni_port_name: 'BAOBAB TERMINAL',
            wni_unlocode: 'CIBAO',
            wni_country: 'CI',
            wni_lat: 4.9666,
            wni_lon: -4.5333,
            wni_tz: 'Africa/Abidjan',
        },
        {
            option: 'BAP',
            wni_port_name: 'BALIKPAPAN',
            wni_unlocode: 'IDBPN',
            wni_country: 'ID',
            wni_lat: -1.2569,
            wni_lon: 116.8061,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'BARC',
            wni_port_name: 'BARCARENA',
            wni_unlocode: 'BRBCA',
            wni_country: 'BR',
            wni_lat: -1.4428,
            wni_lon: -48.5971,
            wni_tz: 'America/Belem',
        },
        {
            option: 'BASU',
            wni_port_name: 'BASUO (DONGFANG)',
            wni_unlocode: 'CNBAS',
            wni_country: 'CN',
            wni_lat: 19.1124,
            wni_lon: 108.6129,
            wni_tz: 'Asia/Chongqing',
        },
        {
            option: 'BAT',
            wni_port_name: 'BATON ROUGE',
            wni_unlocode: 'USBTR',
            wni_country: 'US',
            wni_lat: 30.4787,
            wni_lon: -91.1972,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'BATA',
            wni_port_name: 'BATA',
            wni_unlocode: 'GQBSG',
            wni_country: 'GQ',
            wni_lat: 1.88,
            wni_lon: 9.7678,
            wni_tz: 'Africa/Malabo',
        },
        {
            option: 'BAU',
            wni_port_name: 'BAYUQUAN',
            wni_unlocode: 'CNBAY',
            wni_country: 'CN',
            wni_lat: 40.2626,
            wni_lon: 122.0711,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'BAV',
            wni_port_name: 'BAIE VERTE',
            wni_unlocode: 'CABVE',
            wni_country: 'CA',
            wni_lat: 49.95,
            wni_lon: -56.1667,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'BAY',
            wni_port_name: 'BAYONNE',
            wni_unlocode: 'USBAY',
            wni_country: 'US',
            wni_lat: 40.6484,
            wni_lon: -74.0603,
            wni_tz: 'America/New_York',
        },
        {
            option: 'BAZ',
            wni_port_name: 'BANIS (BANIYAS)',
            wni_unlocode: 'SYBAN',
            wni_country: 'SY',
            wni_lat: 35.2197,
            wni_lon: 35.9337,
            wni_tz: 'Asia/Damascus',
        },
        {
            option: 'BBA',
            wni_port_name: 'BELL BAY',
            wni_unlocode: 'AUBEL',
            wni_country: 'AU',
            wni_lat: -41.1486,
            wni_lon: 146.855,
            wni_tz: 'Australia/Hobart',
        },
        {
            option: 'BBG',
            wni_port_name: 'BUNDABERG',
            wni_unlocode: 'AUBDB',
            wni_country: 'AU',
            wni_lat: -24.7492,
            wni_lon: 152.417,
            wni_tz: 'Australia/Brisbane',
        },
        {
            option: 'BBL',
            wni_port_name: 'BRUNSBUTTEL',
            wni_unlocode: 'DEBRB',
            wni_country: 'DE',
            wni_lat: 53.8761,
            wni_lon: 9.1435,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'BCH',
            wni_port_name: 'BENCHAMAS',
            wni_unlocode: 'THBEN',
            wni_country: 'TH',
            wni_lat: 10.5333,
            wni_lon: 101.2667,
            wni_tz: 'Asia/Bangkok',
        },
        {
            option: 'BCT',
            wni_port_name: 'BOCA GRANDE T.',
            wni_unlocode: 'VEBOC',
            wni_country: 'VE',
            wni_lat: 9.9505,
            wni_lon: -61.5833,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'BDC',
            wni_port_name: 'BARRA DOS COQUEIROS',
            wni_unlocode: 'BRBAR',
            wni_country: 'BR',
            wni_lat: -10.9762,
            wni_lon: -37.0302,
            wni_tz: 'America/Maceio',
        },
        {
            option: 'BDI',
            wni_port_name: 'BEDI',
            wni_unlocode: 'INBED',
            wni_country: 'IN',
            wni_lat: 22.5172,
            wni_lon: 70.0285,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'BDK',
            wni_port_name: 'BERDYANSK',
            wni_unlocode: 'UAERD',
            wni_country: 'UA',
            wni_lat: 46.7411,
            wni_lon: 36.7794,
            wni_tz: 'Europe/Kiev',
        },
        {
            option: 'BDX',
            wni_port_name: 'BORDEAUX',
            wni_unlocode: 'FRBOD',
            wni_country: 'FR',
            wni_lat: 44.8513,
            wni_lon: -0.5645,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'BEA',
            wni_port_name: 'BEAUMONT',
            wni_unlocode: 'USBPT',
            wni_country: 'US',
            wni_lat: 30.0861,
            wni_lon: -94.0944,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'BEB',
            wni_port_name: 'BELEM',
            wni_unlocode: 'BRBEL',
            wni_country: 'BR',
            wni_lat: -1.4343,
            wni_lon: -48.5028,
            wni_tz: 'America/Belem',
        },
        {
            option: 'BEC',
            wni_port_name: 'BECANCOUR',
            wni_unlocode: 'CABEC',
            wni_country: 'CA',
            wni_lat: 46.409,
            wni_lon: -72.3819,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'BED',
            wni_port_name: 'BELLEDUNE',
            wni_unlocode: 'CABEL',
            wni_country: 'CA',
            wni_lat: 47.9185,
            wni_lon: -65.8268,
            wni_tz: 'America/Moncton',
        },
        {
            option: 'BEH',
            wni_port_name: 'BEIHAI',
            wni_unlocode: 'CNBHI',
            wni_country: 'CN',
            wni_lat: 21.4909,
            wni_lon: 109.0781,
            wni_tz: 'Asia/Chongqing',
        },
        {
            option: 'BEI',
            wni_port_name: 'BEIRA',
            wni_unlocode: 'MZBEW',
            wni_country: 'MZ',
            wni_lat: -19.8329,
            wni_lon: 34.8207,
            wni_tz: 'Africa/Maputo',
        },
        {
            option: 'BEIL',
            wni_port_name: 'NINGBO/BEILUN',
            wni_unlocode: 'CNBEI',
            wni_country: 'CN',
            wni_lat: 29.9485,
            wni_lon: 121.8638,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'BEL',
            wni_port_name: 'BELLINGHAM',
            wni_unlocode: 'USBLI',
            wni_country: 'US',
            wni_lat: 48.7433,
            wni_lon: -122.5097,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'BEN',
            wni_port_name: 'BENICIA',
            wni_unlocode: 'USBNC',
            wni_country: 'US',
            wni_lat: 38.0481,
            wni_lon: -122.1748,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'BET',
            wni_port_name: 'BETHOUIA',
            wni_unlocode: 'DZBHA',
            wni_country: 'DZ',
            wni_lat: 35.8395,
            wni_lon: -0.2241,
            wni_tz: 'Africa/Algiers',
        },
        {
            option: 'BFA',
            wni_port_name: 'BELFAST',
            wni_unlocode: 'GBBEL',
            wni_country: 'GB',
            wni_lat: 54.6427,
            wni_lon: -5.871,
            wni_tz: 'Europe/London',
        },
        {
            option: 'BGN',
            wni_port_name: 'BERGEN',
            wni_unlocode: 'NOBGO',
            wni_country: 'NO',
            wni_lat: 60.4084,
            wni_lon: 5.2911,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'BGP',
            wni_port_name: 'BANG SAPHAN',
            wni_unlocode: 'THBSP',
            wni_country: 'TH',
            wni_lat: 11.1955,
            wni_lon: 99.5935,
            wni_tz: 'Asia/Bangkok',
        },
        {
            option: 'BGS',
            wni_port_name: 'BOURGAS',
            wni_unlocode: 'BGBOJ',
            wni_country: 'BG',
            wni_lat: 42.4687,
            wni_lon: 27.485,
            wni_tz: 'Europe/Sofia',
        },
        {
            option: 'BGT',
            wni_port_name: 'BRIDGETOWN',
            wni_unlocode: 'BBBGI',
            wni_country: 'BB',
            wni_lat: 13.1045,
            wni_lon: -59.6413,
            wni_tz: 'America/Barbados',
        },
        {
            option: 'BGZ',
            wni_port_name: 'BENGHAZI',
            wni_unlocode: 'LYBEN',
            wni_country: 'LY',
            wni_lat: 32.1166,
            wni_lon: 20.0225,
            wni_tz: 'Africa/Tripoli',
        },
        {
            option: 'BHB',
            wni_port_name: 'BAHIA BLANCA',
            wni_unlocode: 'ARBHI',
            wni_country: 'AR',
            wni_lat: -38.7915,
            wni_lon: -62.2904,
            wni_tz: 'America/Argentina/Buenos_Aires',
        },
        {
            option: 'BHRGN',
            wni_port_name: 'RAS BAHREGAN',
            wni_unlocode: 'IRRBA',
            wni_country: 'IR',
            wni_lat: 29.7166,
            wni_lon: 50.1667,
            wni_tz: 'Asia/Tehran',
        },
        {
            option: 'BHT',
            wni_port_name: 'BACH HO TERMINAL',
            wni_unlocode: 'VNBHO',
            wni_country: 'VN',
            wni_lat: 9.7715,
            wni_lon: 106.6153,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'BIAL',
            wni_port_name: 'BIALLA',
            wni_unlocode: 'PGBAA',
            wni_country: 'PG',
            wni_lat: -5.2982,
            wni_lon: 150.9967,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'BIB',
            wni_port_name: 'BILBAO',
            wni_unlocode: 'ESBIO',
            wni_country: 'ES',
            wni_lat: 43.3841,
            wni_lon: -3.0871,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'BIN',
            wni_port_name: 'BINTAN',
            wni_unlocode: 'IDKID',
            wni_country: 'ID',
            wni_lat: 0.8456,
            wni_lon: 104.612,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'BIT',
            wni_port_name: 'BITUNG',
            wni_unlocode: 'IDBIT',
            wni_country: 'ID',
            wni_lat: 1.4356,
            wni_lon: 125.1968,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'BIZ',
            wni_port_name: 'BIZERTA',
            wni_unlocode: 'TNBIZ',
            wni_country: 'TN',
            wni_lat: 37.2816,
            wni_lon: 9.9066,
            wni_tz: 'Africa/Tunis',
        },
        {
            option: 'BJA',
            wni_port_name: 'BEJAIA',
            wni_unlocode: 'DZBJA',
            wni_country: 'DZ',
            wni_lat: 36.749,
            wni_lon: 5.1127,
            wni_tz: 'Africa/Algiers',
        },
        {
            option: 'BJG',
            wni_port_name: 'BAJO GRANDE',
            wni_unlocode: 'VEBJV',
            wni_country: 'VE',
            wni_lat: 10.4974,
            wni_lon: -71.6216,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'BKI',
            wni_port_name: 'BELEKERI',
            wni_unlocode: 'INBLK',
            wni_country: 'IN',
            wni_lat: 14.7108,
            wni_lon: 74.2526,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'BKK',
            wni_port_name: 'BUNGA KEKWA TERMINAL',
            wni_unlocode: 'MYBGK',
            wni_country: 'MY',
            wni_lat: 6.9666,
            wni_lon: 104.15,
            wni_tz: 'Etc/GMT-8',
        },
        {
            option: 'BKM',
            wni_port_name: 'BANDAR KHOMEINI',
            wni_unlocode: 'IRBIK',
            wni_country: 'IR',
            wni_lat: 30.4172,
            wni_lon: 49.0608,
            wni_tz: 'Asia/Tehran',
        },
        {
            option: 'BLA',
            wni_port_name: 'BELAWAN',
            wni_unlocode: 'IDBLW',
            wni_country: 'ID',
            wni_lat: 3.8031,
            wni_lon: 98.7217,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'BLB',
            wni_port_name: 'BULLEN BAY',
            wni_unlocode: 'CWBUB',
            wni_country: 'CW',
            wni_lat: 12.1763,
            wni_lon: -69.0353,
            wni_tz: 'America/Curacao',
        },
        {
            option: 'BLF',
            wni_port_name: 'BLUFF',
            wni_unlocode: 'NZBLU',
            wni_country: 'NZ',
            wni_lat: -46.6038,
            wni_lon: 168.3643,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'BLN',
            wni_port_name: 'BALONGAN TERMINAL',
            wni_unlocode: 'IDBAL',
            wni_country: 'ID',
            wni_lat: -6.2666,
            wni_lon: 108.45,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'BLNK',
            wni_port_name: 'BELANAK TERMINAL',
            wni_unlocode: 'IDBNT',
            wni_country: 'ID',
            wni_lat: 4.1666,
            wni_lon: 106.2166,
            wni_tz: 'Etc/GMT-7',
        },
        {
            option: 'BLVRC',
            wni_port_name: 'BOLIVAR',
            wni_unlocode: 'VECBL',
            wni_country: 'VE',
            wni_lat: 8.15,
            wni_lon: -63.5419,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'BME',
            wni_port_name: 'BROOME',
            wni_unlocode: 'AUBME',
            wni_country: 'AU',
            wni_lat: -18.007,
            wni_lon: 122.2262,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'BMT',
            wni_port_name: 'BELIDA',
            wni_unlocode: 'IDBET',
            wni_country: 'ID',
            wni_lat: 4.1333,
            wni_lon: 105.1333,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'BNA',
            wni_port_name: 'BONAIRE TERMINAL',
            wni_unlocode: 'ANBON',
            wni_country: 'BQ',
            wni_lat: 12.2111,
            wni_lon: -68.3768,
            wni_tz: 'America/Curacao',
        },
        {
            option: 'BNB',
            wni_port_name: 'BUNBURY',
            wni_unlocode: 'AUBUY',
            wni_country: 'AU',
            wni_lat: -33.3022,
            wni_lon: 115.6545,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'BNG',
            wni_port_name: 'BANGKOK',
            wni_unlocode: 'THBKK',
            wni_country: 'TH',
            wni_lat: 13.7165,
            wni_lon: 100.5107,
            wni_tz: 'Asia/Bangkok',
        },
        {
            option: 'BNJ',
            wni_port_name: 'BANJARMASIN',
            wni_unlocode: 'IDBDJ',
            wni_country: 'ID',
            wni_lat: -3.3303,
            wni_lon: 114.5527,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'BNS',
            wni_port_name: 'BURNSIDE',
            wni_unlocode: 'USBSD',
            wni_country: 'US',
            wni_lat: 30.1276,
            wni_lon: -90.9225,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'BNTH',
            wni_port_name: 'BONTHE',
            wni_unlocode: 'SLBTE',
            wni_country: 'SL',
            wni_lat: 7.5332,
            wni_lon: -12.4987,
            wni_tz: 'Africa/Freetown',
        },
        {
            option: 'BOI',
            wni_port_name: 'BA NGOI',
            wni_unlocode: 'VNBNO',
            wni_country: 'VN',
            wni_lat: 11.8853,
            wni_lon: 109.1583,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'BOLVR',
            wni_port_name: 'PUERTO BOLIVAR',
            wni_unlocode: 'COPBO',
            wni_country: 'CO',
            wni_lat: 12.2635,
            wni_lon: -71.969,
            wni_tz: 'America/Bogota',
        },
        {
            option: 'BOMA',
            wni_port_name: 'BOMA',
            wni_unlocode: 'CDBOA',
            wni_country: 'CD',
            wni_lat: -5.8694,
            wni_lon: 13.0624,
            wni_tz: 'Africa/Kinshasa',
        },
        {
            option: 'BON',
            wni_port_name: 'BONNY',
            wni_unlocode: 'NGBON',
            wni_country: 'NG',
            wni_lat: 4.443,
            wni_lon: 7.1488,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'BONGA',
            wni_port_name: 'BONGA TERMINAL',
            wni_unlocode: 'NGBOT',
            wni_country: 'NG',
            wni_lat: 4.55,
            wni_lon: 4.6167,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'BOS',
            wni_port_name: 'BOSTON',
            wni_unlocode: 'USBOS',
            wni_country: 'US',
            wni_lat: 42.3367,
            wni_lon: -70.9984,
            wni_tz: 'America/New_York',
        },
        {
            option: 'BOT',
            wni_port_name: 'BOTWOOD',
            wni_unlocode: 'CABWD',
            wni_country: 'CA',
            wni_lat: 49.1457,
            wni_lon: -55.322,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'BOURI',
            wni_port_name: 'BOURI TERMINAL',
            wni_unlocode: 'LYBOU',
            wni_country: 'LY',
            wni_lat: 33.9,
            wni_lon: 12.65,
            wni_tz: 'Africa/Tripoli',
        },
        {
            option: 'BPG',
            wni_port_name: 'DONGHAE (BUKPYUNG)',
            wni_unlocode: 'KRTGH',
            wni_country: 'KR',
            wni_lat: 37.5022,
            wni_lon: 129.159,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'BPT',
            wni_port_name: 'BRIDGEPORT',
            wni_unlocode: 'USBDB',
            wni_country: 'US',
            wni_lat: 41.1481,
            wni_lon: -73.1802,
            wni_tz: 'America/New_York',
        },
        {
            option: 'BQL',
            wni_port_name: 'BARRANQUILLA',
            wni_unlocode: 'COBAQ',
            wni_country: 'CO',
            wni_lat: 10.9602,
            wni_lon: -74.7557,
            wni_tz: 'America/Bogota',
        },
        {
            option: 'BRA',
            wni_port_name: 'BASRAH',
            wni_unlocode: 'IQBSR',
            wni_country: 'IQ',
            wni_lat: 30.5247,
            wni_lon: 47.8415,
            wni_tz: 'Asia/Baghdad',
        },
        {
            option: 'BRASS1',
            wni_port_name: 'BRASS',
            wni_unlocode: 'NGBRA',
            wni_country: 'NG',
            wni_lat: 4.278,
            wni_lon: 6.2339,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'BRBRS',
            wni_port_name: 'BARBERS POINT TERMINAL',
            wni_unlocode: 'USNAX',
            wni_country: 'US',
            wni_lat: 21.2667,
            wni_lon: -158.0833,
            wni_tz: 'Pacific/Honolulu',
        },
        {
            option: 'BRD',
            wni_port_name: 'BRINDISI',
            wni_unlocode: 'ITBDS',
            wni_country: 'IT',
            wni_lat: 40.6646,
            wni_lon: 18.0088,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'BRH',
            wni_port_name: 'BREMERHAVEN',
            wni_unlocode: 'DEBRV',
            wni_country: 'DE',
            wni_lat: 53.5466,
            wni_lon: 8.555,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'BRHN',
            wni_port_name: 'BARAHONA',
            wni_unlocode: 'DOBRX',
            wni_country: 'DO',
            wni_lat: 18.207,
            wni_lon: -71.0803,
            wni_tz: 'America/Santo_Domingo',
        },
        {
            option: 'BRI',
            wni_port_name: 'BRISBANE',
            wni_unlocode: 'AUBNE',
            wni_country: 'AU',
            wni_lat: -27.075,
            wni_lon: 153.2767,
            wni_tz: 'Australia/Brisbane',
        },
        {
            option: 'BRIP',
            wni_port_name: 'BRISTOL',
            wni_unlocode: 'USBCO',
            wni_country: 'US',
            wni_lat: 40.0993,
            wni_lon: -74.8412,
            wni_tz: 'America/New_York',
        },
        {
            option: 'BRJ',
            wni_port_name: 'BROFJORDEN',
            wni_unlocode: 'SEBRO',
            wni_country: 'SE',
            wni_lat: 58.3358,
            wni_lon: 11.3909,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'BRK',
            wni_port_name: 'BRAKE',
            wni_unlocode: 'DEBKE',
            wni_country: 'DE',
            wni_lat: 53.3389,
            wni_lon: 8.4971,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'BRM',
            wni_port_name: 'BREMEN',
            wni_unlocode: 'DEBLM',
            wni_country: 'DE',
            wni_lat: 53.0739,
            wni_lon: 8.8031,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'BRN',
            wni_port_name: 'BAHRAIN',
            wni_unlocode: 'BHBAH',
            wni_country: 'BH',
            wni_lat: 26.1964,
            wni_lon: 50.634,
            wni_tz: 'Asia/Bahrain',
        },
        {
            option: 'BRS',
            wni_port_name: 'BREST',
            wni_unlocode: 'FRBES',
            wni_country: 'FR',
            wni_lat: 48.3553,
            wni_lon: -4.4881,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'BRSSL',
            wni_port_name: 'BRUSSELS',
            wni_unlocode: 'BEBRU',
            wni_country: 'BE',
            wni_lat: 50.866,
            wni_lon: 4.3534,
            wni_tz: 'Europe/Brussels',
        },
        {
            option: 'BRSY',
            wni_port_name: 'BERINGOVSKIY',
            wni_unlocode: 'RUBER',
            wni_country: 'RU',
            wni_lat: 63.0236,
            wni_lon: 179.3854,
            wni_tz: 'Asia/Anadyr',
        },
        {
            option: 'BRT',
            wni_port_name: 'BEIRUT',
            wni_unlocode: 'LBBEY',
            wni_country: 'LB',
            wni_lat: 33.9231,
            wni_lon: 35.5275,
            wni_tz: 'Asia/Beirut',
        },
        {
            option: 'BRU',
            wni_port_name: 'BRUNSWICK',
            wni_unlocode: 'USSSI',
            wni_country: 'US',
            wni_lat: 31.1418,
            wni_lon: -81.4978,
            wni_tz: 'America/New_York',
        },
        {
            option: 'BRW',
            wni_port_name: 'BROWNSVILLE',
            wni_unlocode: 'USBRO',
            wni_country: 'US',
            wni_lat: 25.9509,
            wni_lon: -97.3999,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'BRX',
            wni_port_name: 'BRIXHAM',
            wni_unlocode: 'GBBRX',
            wni_country: 'GB',
            wni_lat: 50.4127,
            wni_lon: -3.5155,
            wni_tz: 'Europe/London',
        },
        {
            option: 'BRY',
            wni_port_name: 'BANTRY',
            wni_unlocode: 'IEBYT',
            wni_country: 'IE',
            wni_lat: 51.6841,
            wni_lon: -9.4751,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'BSSTR',
            wni_port_name: 'BASSETERRE',
            wni_unlocode: 'KNBAS',
            wni_country: 'KN',
            wni_lat: 17.2787,
            wni_lon: -62.7232,
            wni_tz: 'America/St_Kitts',
        },
        {
            option: 'BST',
            wni_port_name: 'BASSETERRE',
            wni_unlocode: 'GPBBR',
            wni_country: 'GP',
            wni_lat: 15.9924,
            wni_lon: -61.7417,
            wni_tz: 'America/Guadeloupe',
        },
        {
            option: 'BSTA',
            wni_port_name: 'BASTIA',
            wni_unlocode: 'FRBIA',
            wni_country: 'FR',
            wni_lat: 42.69,
            wni_lon: 9.4625,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'BSTN',
            wni_port_name: 'BOSTON',
            wni_unlocode: 'GBBOS',
            wni_country: 'GB',
            wni_lat: 52.9218,
            wni_lon: 0.0481,
            wni_tz: 'Europe/London',
        },
        {
            option: 'BTA',
            wni_port_name: 'BATANGAS\t LUZON',
            wni_unlocode: 'PHBTG',
            wni_country: 'PH',
            wni_lat: 13.7552,
            wni_lon: 121.0304,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'BTE',
            wni_port_name: 'BENETE',
            wni_unlocode: 'IDBEN',
            wni_country: 'ID',
            wni_lat: -8.8904,
            wni_lon: 116.7445,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'BTG',
            wni_port_name: 'BONTANG',
            wni_unlocode: 'IDBDK',
            wni_country: 'ID',
            wni_lat: 0.0884,
            wni_lon: 117.5003,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'BTM',
            wni_port_name: 'BATAM ISLAND',
            wni_unlocode: 'IDBTM',
            wni_country: 'ID',
            wni_lat: 1.1688,
            wni_lon: 103.9885,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'BTO',
            wni_port_name: 'BRISTOL',
            wni_unlocode: 'GBBRS',
            wni_country: 'GB',
            wni_lat: 51.5053,
            wni_lon: -2.7383,
            wni_tz: 'Europe/London',
        },
        {
            option: 'BTR',
            wni_port_name: 'BINTULU\t SARAWAK',
            wni_unlocode: 'MYBTU',
            wni_country: 'MY',
            wni_lat: 3.2557,
            wni_lon: 113.0492,
            wni_tz: 'Asia/Kuching',
        },
        {
            option: 'BTU',
            wni_port_name: 'BATUMI (BATUM)',
            wni_unlocode: 'GEBUS',
            wni_country: 'GE',
            wni_lat: 41.6628,
            wni_lon: 41.6476,
            wni_tz: 'Asia/Tbilisi',
        },
        {
            option: 'BTW',
            wni_port_name: 'BUTTERWORTH (BAGAN LUAR)',
            wni_unlocode: 'MYBWH',
            wni_country: 'MY',
            wni_lat: 5.3951,
            wni_lon: 100.349,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'BUA',
            wni_port_name: 'BUENOS AIRES',
            wni_unlocode: 'ARBUE',
            wni_country: 'AR',
            wni_lat: -34.5826,
            wni_lon: -58.3482,
            wni_tz: 'America/Argentina/Buenos_Aires',
        },
        {
            option: 'BUC',
            wni_port_name: 'BUCHANAN',
            wni_unlocode: 'LRUCN',
            wni_country: 'LR',
            wni_lat: 5.85,
            wni_lon: -10.0667,
            wni_tz: 'Africa/Monrovia',
        },
        {
            option: 'BUGT',
            wni_port_name: 'BUTINGE TERMINAL',
            wni_unlocode: 'LTBOT',
            wni_country: 'LT',
            wni_lat: 56.0333,
            wni_lon: 20.95,
            wni_tz: 'Europe/Vilnius',
        },
        {
            option: 'BUL',
            wni_port_name: 'BULI',
            wni_unlocode: 'IDTBU',
            wni_country: 'ID',
            wni_lat: 0.8711,
            wni_lon: 128.2986,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'BULA',
            wni_port_name: 'BULA',
            wni_unlocode: 'IDBUA',
            wni_country: 'ID',
            wni_lat: -3.0916,
            wni_lon: 130.5037,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'BUR',
            wni_port_name: 'BURNIE',
            wni_unlocode: 'AUBWT',
            wni_country: 'AU',
            wni_lat: -41.0505,
            wni_lon: 145.9327,
            wni_tz: 'Australia/Hobart',
        },
        {
            option: 'BUS',
            wni_port_name: 'BUSAN',
            wni_unlocode: 'KRPUS',
            wni_country: 'KR',
            wni_lat: 35.1071,
            wni_lon: 129.0541,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'BUSN',
            wni_port_name: 'BUSAN NEW PORT',
            wni_unlocode: 'KRBNP',
            wni_country: 'KR',
            wni_lat: 35.0445,
            wni_lon: 128.7741,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'BUT',
            wni_port_name: 'WOOLLYBUTT TERMINAL',
            wni_unlocode: 'AUWBT',
            wni_country: 'AU',
            wni_lat: -20.9,
            wni_lon: 114.9,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'BVENT',
            wni_port_name: 'BUENA VENTURA',
            wni_unlocode: 'COBUN',
            wni_country: 'CO',
            wni_lat: 3.8859,
            wni_lon: -77.0861,
            wni_tz: 'America/Bogota',
        },
        {
            option: 'BWI',
            wni_port_name: 'BARROW ISLAND',
            wni_unlocode: 'AUBWB',
            wni_country: 'AU',
            wni_lat: -20.7173,
            wni_lon: 115.484,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'BYF',
            wni_port_name: 'BAYONNE',
            wni_unlocode: 'FRBAY',
            wni_country: 'FR',
            wni_lat: 43.4956,
            wni_lon: -1.476,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'BYN',
            wni_port_name: 'BAYTOWN',
            wni_unlocode: 'USHPY',
            wni_country: 'US',
            wni_lat: 29.7284,
            wni_lon: -95.0261,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'BYP',
            wni_port_name: 'BRAYTON POINT',
            wni_unlocode: 'USBNP',
            wni_country: 'US',
            wni_lat: 41.6995,
            wni_lon: -71.1911,
            wni_tz: 'America/New_York',
        },
        {
            option: 'BYT',
            wni_port_name: 'PORT BONYTHON',
            wni_unlocode: 'AUPBY',
            wni_country: 'AU',
            wni_lat: -33.0236,
            wni_lon: 137.7655,
            wni_tz: 'Australia/Adelaide',
        },
        {
            option: 'BZ',
            wni_port_name: 'BELIZE CITY',
            wni_unlocode: 'BZBZE',
            wni_country: 'BZ',
            wni_lat: 17.4669,
            wni_lon: -88.2007,
            wni_tz: 'America/Belize',
        },
        {
            option: 'CAD',
            wni_port_name: 'CARDENAS',
            wni_unlocode: 'CUCAR',
            wni_country: 'CU',
            wni_lat: 23.066,
            wni_lon: -81.1735,
            wni_tz: 'America/Havana',
        },
        {
            option: 'CADZ',
            wni_port_name: 'CADIZ',
            wni_unlocode: 'PHCAZ',
            wni_country: 'PH',
            wni_lat: 10.968,
            wni_lon: 123.3168,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'CAG',
            wni_port_name: 'CAGAYAN DE ORO',
            wni_unlocode: 'PHCGY',
            wni_country: 'PH',
            wni_lat: 8.4978,
            wni_lon: 124.6722,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'CAIL',
            wni_port_name: 'CAI LAN',
            wni_unlocode: 'VNCAI',
            wni_country: 'VN',
            wni_lat: 20.9729,
            wni_lon: 107.0627,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'CAIM',
            wni_port_name: 'CAI MEP',
            wni_unlocode: 'VNTOT',
            wni_country: 'VN',
            wni_lat: 10.5382,
            wni_lon: 107.0267,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'CAL',
            wni_port_name: 'CALLAO',
            wni_unlocode: 'PECLL',
            wni_country: 'PE',
            wni_lat: -12.0784,
            wni_lon: -77.15,
            wni_tz: 'America/Lima',
        },
        {
            option: 'CAMDN',
            wni_port_name: 'CAMDEN',
            wni_unlocode: 'USCAT',
            wni_country: 'US',
            wni_lat: 39.935,
            wni_lon: -75.137,
            wni_tz: 'America/New_York',
        },
        {
            option: 'CAMP',
            wni_port_name: 'CAM PHA',
            wni_unlocode: 'VNCPH',
            wni_country: 'VN',
            wni_lat: 20.9928,
            wni_lon: 107.3194,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'CAN',
            wni_port_name: 'CANAPORT',
            wni_unlocode: 'CACPT',
            wni_country: 'CA',
            wni_lat: 45.1988,
            wni_lon: -65.9859,
            wni_tz: 'America/Moncton',
        },
        {
            option: 'CANH',
            wni_port_name: 'CANSO ANCHORAGE',
            wni_unlocode: 'CACAH',
            wni_country: 'CA',
            wni_lat: 45.4666,
            wni_lon: -61.1999,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'CANVY',
            wni_port_name: 'CANVEY ISLAND',
            wni_unlocode: 'GBCAN',
            wni_country: 'GB',
            wni_lat: 51.503,
            wni_lon: 0.562,
            wni_tz: 'Europe/London',
        },
        {
            option: 'CAOJ',
            wni_port_name: 'CAOJING',
            wni_unlocode: 'CNCJG',
            wni_country: 'CN',
            wni_lat: 30.7465,
            wni_lon: 121.437,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'CAPH',
            wni_port_name: 'CAP HAITIEN',
            wni_unlocode: 'HTCAP',
            wni_country: 'HT',
            wni_lat: 19.7575,
            wni_lon: -72.1854,
            wni_tz: 'America/Port-au-Prince',
        },
        {
            option: 'CAR',
            wni_port_name: 'CARTAGENA',
            wni_unlocode: 'COCTG',
            wni_country: 'CO',
            wni_lat: 10.4027,
            wni_lon: -75.5443,
            wni_tz: 'America/Bogota',
        },
        {
            option: 'CAS',
            wni_port_name: 'CASABLANCA',
            wni_unlocode: 'MACAS',
            wni_country: 'MA',
            wni_lat: 33.6275,
            wni_lon: -7.5959,
            wni_tz: 'Africa/Casablanca',
        },
        {
            option: 'CAT',
            wni_port_name: 'KOLKATA (CALCUTTA)',
            wni_unlocode: 'INCCU',
            wni_country: 'IN',
            wni_lat: 22.5493,
            wni_lon: 88.3145,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'CAU',
            wni_port_name: 'CHACABUCO',
            wni_unlocode: 'CLCHB',
            wni_country: 'CL',
            wni_lat: -45.4637,
            wni_lon: -72.8332,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'CAZOU',
            wni_port_name: 'CHAOZHOU',
            wni_unlocode: 'CNCOZ',
            wni_country: 'CN',
            wni_lat: 23.5458,
            wni_lon: 117.1155,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'CBC',
            wni_port_name: 'COME BY CHANCE',
            wni_unlocode: 'CACBC',
            wni_country: 'CA',
            wni_lat: 47.7835,
            wni_lon: -54.031,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'CBK',
            wni_port_name: 'CORNER BROOK',
            wni_unlocode: 'CACBK',
            wni_country: 'CA',
            wni_lat: 48.9651,
            wni_lon: -57.9536,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'CBN',
            wni_port_name: 'CABINDA',
            wni_unlocode: 'AOCAB',
            wni_country: 'AO',
            wni_lat: -5.5434,
            wni_lon: 12.1788,
            wni_tz: 'Africa/Luanda',
        },
        {
            option: 'CBY',
            wni_port_name: 'COOS BAY',
            wni_unlocode: 'USCOB',
            wni_country: 'US',
            wni_lat: 43.3685,
            wni_lon: -124.2106,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'CCN',
            wni_port_name: 'PORT CANAVERAL',
            wni_unlocode: 'USPCA',
            wni_country: 'US',
            wni_lat: 28.4062,
            wni_lon: -80.5775,
            wni_tz: 'America/New_York',
        },
        {
            option: 'CCV',
            wni_port_name: 'CAPE CUVIER',
            wni_unlocode: 'AUCCU',
            wni_country: 'AU',
            wni_lat: -24.213,
            wni_lon: 113.3925,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'CDI',
            wni_port_name: 'CEDROS ISLAND',
            wni_unlocode: 'MXCED',
            wni_country: 'MX',
            wni_lat: 28.0436,
            wni_lon: -115.1716,
            wni_tz: 'America/Santa_Isabel',
        },
        {
            option: 'CDR',
            wni_port_name: 'CALDERA',
            wni_unlocode: 'CLCLD',
            wni_country: 'CL',
            wni_lat: -27.0427,
            wni_lon: -70.8397,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'CDU',
            wni_port_name: 'CONCEPCION',
            wni_unlocode: 'ARCOU',
            wni_country: 'AR',
            wni_lat: -32.4799,
            wni_lon: -58.2032,
            wni_tz: 'America/Argentina/Cordoba',
        },
        {
            option: 'CDZ',
            wni_port_name: 'CADIZ',
            wni_unlocode: 'ESCAD',
            wni_country: 'ES',
            wni_lat: 36.5364,
            wni_lon: -6.3329,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'CEB',
            wni_port_name: 'CEBU',
            wni_unlocode: 'PHCEB',
            wni_country: 'PH',
            wni_lat: 10.2954,
            wni_lon: 123.9167,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'CEIBA',
            wni_port_name: 'CEIBA',
            wni_unlocode: 'PRCEI',
            wni_country: 'PR',
            wni_lat: 18.202,
            wni_lon: -65.616,
            wni_tz: 'America/Puerto_Rico',
        },
        {
            option: 'CEO',
            wni_port_name: 'CABEDELO',
            wni_unlocode: 'BRCDO',
            wni_country: 'BR',
            wni_lat: -6.9571,
            wni_lon: -34.851,
            wni_tz: 'America/Fortaleza',
        },
        {
            option: 'CEP',
            wni_port_name: 'CHERRYPOINT',
            wni_unlocode: 'USCP4',
            wni_country: 'US',
            wni_lat: 48.8553,
            wni_lon: -122.7704,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'CER',
            wni_port_name: 'CARBONERAS',
            wni_unlocode: 'ESCRS',
            wni_country: 'ES',
            wni_lat: 36.9634,
            wni_lon: -1.883,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'CEU',
            wni_port_name: 'CEUTA',
            wni_unlocode: 'ESCEU',
            wni_country: 'ES',
            wni_lat: 35.9041,
            wni_lon: -5.31,
            wni_tz: 'Africa/Ceuta',
        },
        {
            option: 'CEY',
            wni_port_name: 'CEYHAN',
            wni_unlocode: 'TRCEY',
            wni_country: 'TR',
            wni_lat: 36.858,
            wni_lon: 35.9528,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'CFD',
            wni_port_name: 'CAOFEIDIAN TERMINAL',
            wni_unlocode: 'CNCFD',
            wni_country: 'CN',
            wni_lat: 38.7667,
            wni_lon: 118.7,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'CFE',
            wni_port_name: 'CAPE FLATTERY',
            wni_unlocode: 'AUCQP',
            wni_country: 'AU',
            wni_lat: -14.9933,
            wni_lon: 145.3608,
            wni_tz: 'Australia/Brisbane',
        },
        {
            option: 'CGA',
            wni_port_name: 'CHIOGGIA',
            wni_unlocode: 'ITCHI',
            wni_country: 'IT',
            wni_lat: 45.2297,
            wni_lon: 12.3266,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'CGD',
            wni_port_name: 'CIGADING',
            wni_unlocode: 'IDCIG',
            wni_country: 'ID',
            wni_lat: -6.0026,
            wni_lon: 105.952,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'CGDNO',
            wni_port_name: 'CAGDIANAO',
            wni_unlocode: 'PHCDN',
            wni_country: 'PH',
            wni_lat: 9.9242,
            wni_lon: 125.6889,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'CGL',
            wni_port_name: 'CAGLIARI',
            wni_unlocode: 'ITCAG',
            wni_country: 'IT',
            wni_lat: 39.1874,
            wni_lon: 9.1057,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'CGS',
            wni_port_name: 'CHANGSHU',
            wni_unlocode: 'CNCGS',
            wni_country: 'CN',
            wni_lat: 31.7833,
            wni_lon: 120.955,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'CHA',
            wni_port_name: 'CHARLESTON',
            wni_unlocode: 'USCHS',
            wni_country: 'US',
            wni_lat: 32.785,
            wni_lon: -79.9162,
            wni_tz: 'America/New_York',
        },
        {
            option: 'CHBOT',
            wni_port_name: 'CHIMBOTE',
            wni_unlocode: 'PECHM',
            wni_country: 'PE',
            wni_lat: -9.0874,
            wni_lon: -78.629,
            wni_tz: 'America/Lima',
        },
        {
            option: 'CHI',
            wni_port_name: 'CHIBA',
            wni_unlocode: 'JPCHB',
            wni_country: 'JP',
            wni_lat: 35.5938,
            wni_lon: 140.069,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'CHM',
            wni_port_name: 'CHEMAINUS',
            wni_unlocode: 'CACHM',
            wni_country: 'CA',
            wni_lat: 48.9354,
            wni_lon: -123.7115,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'CHNAK',
            wni_port_name: 'CHINA',
            wni_unlocode: 'JPCHI',
            wni_country: 'JP',
            wni_lat: 27.3215,
            wni_lon: 128.5746,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'CHR',
            wni_port_name: 'CHERBOURG',
            wni_unlocode: 'FRCER',
            wni_country: 'FR',
            wni_lat: 49.6794,
            wni_lon: -1.6136,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'CHS',
            wni_port_name: 'CHESAPEAKE',
            wni_unlocode: 'USUFG',
            wni_country: 'US',
            wni_lat: 36.7961,
            wni_lon: -76.2931,
            wni_tz: 'America/New_York',
        },
        {
            option: 'CHSN',
            wni_port_name: 'JIAXING(ZHAPU)',
            wni_unlocode: 'CNZAP',
            wni_country: 'CN',
            wni_lat: 30.5778,
            wni_lon: 121.1087,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'CHT',
            wni_port_name: 'CHATTOGRAM',
            wni_unlocode: 'BDCGP',
            wni_country: 'BD',
            wni_lat: 22.2202,
            wni_lon: 91.7842,
            wni_tz: 'Asia/Dhaka',
        },
        {
            option: 'CII',
            wni_port_name: 'CHITA',
            wni_unlocode: 'JPCTA',
            wni_country: 'JP',
            wni_lat: 34.9747,
            wni_lon: 136.8126,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'CIN',
            wni_port_name: 'CINTA TERMINAL',
            wni_unlocode: 'IDCIN',
            wni_country: 'ID',
            wni_lat: -5.4666,
            wni_lon: 106.2333,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'CIV',
            wni_port_name: 'CIVITAVECCHIA',
            wni_unlocode: 'ITCVV',
            wni_country: 'IT',
            wni_lat: 42.0876,
            wni_lon: 11.7755,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'CIW',
            wni_port_name: 'CIWANDAN',
            wni_unlocode: 'IDCIW',
            wni_country: 'ID',
            wni_lat: -6.0082,
            wni_lon: 105.9453,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'CLB',
            wni_port_name: 'CALABAR',
            wni_unlocode: 'NGCBQ',
            wni_country: 'NG',
            wni_lat: 4.9667,
            wni_lon: 8.3167,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'CLBC',
            wni_port_name: 'CALBUCO',
            wni_unlocode: 'CLCBC',
            wni_country: 'CL',
            wni_lat: -41.7738,
            wni_lon: -73.1506,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'CLC',
            wni_port_name: 'CILACAP',
            wni_unlocode: 'IDCXP',
            wni_country: 'ID',
            wni_lat: -7.7528,
            wni_lon: 109.029,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'CLV',
            wni_port_name: 'CLEVELAND',
            wni_unlocode: 'USCLE',
            wni_country: 'US',
            wni_lat: 41.5099,
            wni_lon: -81.7174,
            wni_tz: 'America/New_York',
        },
        {
            option: 'CLZ',
            wni_port_name: 'CAPE LOPEZ',
            wni_unlocode: 'GACLZ',
            wni_country: 'GA',
            wni_lat: -0.612,
            wni_lon: 8.6902,
            wni_tz: 'Africa/Libreville',
        },
        {
            option: 'CMAYA',
            wni_port_name: 'COSTA MAYA',
            wni_unlocode: 'MXCOM',
            wni_country: 'MX',
            wni_lat: 18.7243,
            wni_lon: -87.6853,
            wni_tz: 'America/Cancun',
        },
        {
            option: 'CMB',
            wni_port_name: 'COLOMBO',
            wni_unlocode: 'LKCMB',
            wni_country: 'LK',
            wni_lat: 6.9628,
            wni_lon: 79.8417,
            wni_tz: 'Asia/Colombo',
        },
        {
            option: 'CME',
            wni_port_name: 'CAMERON',
            wni_unlocode: 'USAQN',
            wni_country: 'US',
            wni_lat: 29.7954,
            wni_lon: -93.3268,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'CMM',
            wni_port_name: 'CHAN MAY',
            wni_unlocode: 'VNCMY',
            wni_country: 'VN',
            wni_lat: 16.359,
            wni_lon: 108.004,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'CMR',
            wni_port_name: 'CAMPBELL RIVER',
            wni_unlocode: 'CACAM',
            wni_country: 'CA',
            wni_lat: 50.0333,
            wni_lon: -125.2333,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'CNI',
            wni_port_name: 'CHENNAI',
            wni_unlocode: 'INMAA',
            wni_country: 'IN',
            wni_lat: 13.103,
            wni_lon: 80.3162,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'CNK',
            wni_port_name: 'CANAKKALE',
            wni_unlocode: 'TRCKZ',
            wni_country: 'TR',
            wni_lat: 40.1569,
            wni_lon: 26.3917,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'CNL',
            wni_port_name: 'CHANARAL',
            wni_unlocode: 'CLCNR',
            wni_country: 'CL',
            wni_lat: -26.3416,
            wni_lon: -70.6543,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'CNV',
            wni_port_name: 'CONVENT',
            wni_unlocode: 'USCEN',
            wni_country: 'US',
            wni_lat: 30.0163,
            wni_lon: -90.8337,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'COA',
            wni_port_name: 'COATZACOALCOS',
            wni_unlocode: 'MXCOA',
            wni_country: 'MX',
            wni_lat: 18.1669,
            wni_lon: -94.4152,
            wni_tz: 'America/Mexico_City',
        },
        {
            option: 'COC',
            wni_port_name: 'COCHIN',
            wni_unlocode: 'INCOK',
            wni_country: 'IN',
            wni_lat: 9.9628,
            wni_lon: 76.2261,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'COE',
            wni_port_name: 'CROTONE',
            wni_unlocode: 'ITCRV',
            wni_country: 'IT',
            wni_lat: 39.0997,
            wni_lon: 17.1206,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'COLO',
            wni_port_name: 'CALETA COLOSO',
            wni_unlocode: 'CLCOL',
            wni_country: 'CL',
            wni_lat: -23.7478,
            wni_lon: -70.4648,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'COMO',
            wni_port_name: 'COMODORO RIVADAVIA',
            wni_unlocode: 'ARCRD',
            wni_country: 'AR',
            wni_lat: -45.8603,
            wni_lon: -67.4427,
            wni_tz: 'America/Argentina/Catamarca',
        },
        {
            option: 'CONC',
            wni_port_name: 'CONCHAN',
            wni_unlocode: 'PECCH',
            wni_country: 'PE',
            wni_lat: -12.1556,
            wni_lon: -77.0428,
            wni_tz: 'America/Lima',
        },
        {
            option: 'COO',
            wni_port_name: 'CORINTO',
            wni_unlocode: 'NICIO',
            wni_country: 'NI',
            wni_lat: 12.484,
            wni_lon: -87.1907,
            wni_tz: 'America/Managua',
        },
        {
            option: 'COP',
            wni_port_name: 'COPENHAGEN',
            wni_unlocode: 'DKCPH',
            wni_country: 'DK',
            wni_lat: 55.7053,
            wni_lon: 12.6362,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'COQ',
            wni_port_name: 'COQUIMBO',
            wni_unlocode: 'CLCQQ',
            wni_country: 'CL',
            wni_lat: -29.9232,
            wni_lon: -71.3381,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'COR',
            wni_port_name: 'CORPUS CHRISTI',
            wni_unlocode: 'USCRP',
            wni_country: 'US',
            wni_lat: 27.7998,
            wni_lon: -97.3766,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'CORF',
            wni_port_name: 'CORFU',
            wni_unlocode: 'GRCFU',
            wni_country: 'GR',
            wni_lat: 39.6418,
            wni_lon: 19.9385,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'COZ',
            wni_port_name: 'COZUMEL',
            wni_unlocode: 'MXCZM',
            wni_country: 'MX',
            wni_lat: 20.5135,
            wni_lon: -86.965,
            wni_tz: 'America/Cancun',
        },
        {
            option: 'CPN',
            wni_port_name: 'CAMPANA',
            wni_unlocode: 'ARCMP',
            wni_country: 'AR',
            wni_lat: -34.1501,
            wni_lon: -58.94,
            wni_tz: 'America/Argentina/Buenos_Aires',
        },
        {
            option: 'CPT',
            wni_port_name: 'CAPE TOWN',
            wni_unlocode: 'ZACPT',
            wni_country: 'ZA',
            wni_lat: -33.8917,
            wni_lon: 18.4359,
            wni_tz: 'Africa/Johannesburg',
        },
        {
            option: 'CRC',
            wni_port_name: 'CORRAL',
            wni_unlocode: 'CLCRR',
            wni_country: 'CL',
            wni_lat: -39.8379,
            wni_lon: -73.44,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'CRDBA',
            wni_port_name: 'RIO CORDOBA',
            wni_unlocode: 'CORCO',
            wni_country: 'CO',
            wni_lat: 11.0493,
            wni_lon: -74.2491,
            wni_tz: 'America/Bogota',
        },
        {
            option: 'CRDV',
            wni_port_name: 'CALETA CORDOVA',
            wni_unlocode: 'ARCLC',
            wni_country: 'AR',
            wni_lat: -45.74,
            wni_lon: -67.3462,
            wni_tz: 'America/Argentina/Catamarca',
        },
        {
            option: 'CRI',
            wni_port_name: 'CRISTOBAL',
            wni_unlocode: 'PACTB',
            wni_country: 'PA',
            wni_lat: 9.396,
            wni_lon: -79.9227,
            wni_tz: 'America/Panama',
        },
        {
            option: 'CRK',
            wni_port_name: 'CORK',
            wni_unlocode: 'IEORK',
            wni_country: 'IE',
            wni_lat: 51.8954,
            wni_lon: -8.3875,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'CRL',
            wni_port_name: 'CORONEL',
            wni_unlocode: 'CLCNL',
            wni_country: 'CL',
            wni_lat: -37.0367,
            wni_lon: -73.1649,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'CRN',
            wni_port_name: 'CAIRNS',
            wni_unlocode: 'AUCNS',
            wni_country: 'AU',
            wni_lat: -16.9096,
            wni_lon: 145.7835,
            wni_tz: 'Australia/Brisbane',
        },
        {
            option: 'CRO',
            wni_port_name: 'CROFTON',
            wni_unlocode: 'CACRO',
            wni_country: 'CA',
            wni_lat: 48.869,
            wni_lon: -123.6286,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'CROC',
            wni_port_name: 'CROCKETT',
            wni_unlocode: 'USCRM',
            wni_country: 'US',
            wni_lat: 38.0615,
            wni_lon: -122.219,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'CRY',
            wni_port_name: 'CONAKRY',
            wni_unlocode: 'GNCKY',
            wni_country: 'GN',
            wni_lat: 9.5302,
            wni_lon: -13.6987,
            wni_tz: 'Africa/Conakry',
        },
        {
            option: 'CSI',
            wni_port_name: 'CASTRIES',
            wni_unlocode: 'LCCAS',
            wni_country: 'LC',
            wni_lat: 14.0175,
            wni_lon: -61.0082,
            wni_tz: 'America/St_Lucia',
        },
        {
            option: 'CSK',
            wni_port_name: 'COSSACK PIONEER',
            wni_unlocode: 'AUCOP',
            wni_country: 'AU',
            wni_lat: -19.5833,
            wni_lon: 116.45,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'CSS',
            wni_port_name: 'CAPE PASSERO',
            wni_unlocode: 'ITCPS',
            wni_country: 'IT',
            wni_lat: 36.6598,
            wni_lon: 15.1219,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'CTA',
            wni_port_name: 'CATANIA',
            wni_unlocode: 'ITCTA',
            wni_country: 'IT',
            wni_lat: 37.481,
            wni_lon: 15.1101,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'CTIL',
            wni_port_name: 'CHRISTMAS ISLAND',
            wni_unlocode: 'CXXCH',
            wni_country: 'AU',
            wni_lat: -10.42,
            wni_lon: 105.665,
            wni_tz: 'Indian/Christmas',
        },
        {
            option: 'CTL',
            wni_port_name: 'CASTELLON DE LA PLANA',
            wni_unlocode: 'ESCAS',
            wni_country: 'ES',
            wni_lat: 39.9516,
            wni_lon: 0.0391,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'CTS',
            wni_port_name: 'CARTAGENA',
            wni_unlocode: 'ESCAR',
            wni_country: 'ES',
            wni_lat: 37.5628,
            wni_lon: -0.9916,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'CTU',
            wni_port_name: 'COTONOU',
            wni_unlocode: 'BJCOO',
            wni_country: 'BJ',
            wni_lat: 6.3404,
            wni_lon: 2.4386,
            wni_tz: 'Africa/Porto-Novo',
        },
        {
            option: 'CTZ',
            wni_port_name: 'CONSTANTA',
            wni_unlocode: 'ROCND',
            wni_country: 'RO',
            wni_lat: 44.1775,
            wni_lon: 28.6749,
            wni_tz: 'Europe/Bucharest',
        },
        {
            option: 'CUC',
            wni_port_name: 'CAUCEDO',
            wni_unlocode: 'DOCAU',
            wni_country: 'DO',
            wni_lat: 18.4239,
            wni_lon: -69.6208,
            wni_tz: 'America/Santo_Domingo',
        },
        {
            option: 'CUM',
            wni_port_name: 'CUMANA',
            wni_unlocode: 'VECUM',
            wni_country: 'VE',
            wni_lat: 10.4797,
            wni_lon: -64.2026,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'CUR',
            wni_port_name: 'CURACAO (BULLENBAAI TERMINAL)',
            wni_unlocode: 'ANCUR',
            wni_country: 'CW',
            wni_lat: 12.0919,
            wni_lon: -68.9391,
            wni_tz: 'America/Curacao',
        },
        {
            option: 'CVP',
            wni_port_name: 'COVE POINT',
            wni_unlocode: 'USCP6',
            wni_country: 'US',
            wni_lat: 38.3897,
            wni_lon: -76.3721,
            wni_tz: 'America/New_York',
        },
        {
            option: 'CWB',
            wni_port_name: 'COWICHAN BAY',
            wni_unlocode: 'CACCB',
            wni_country: 'CA',
            wni_lat: 48.7469,
            wni_lon: -123.6107,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'CWN',
            wni_port_name: 'CHIWAN',
            wni_unlocode: 'CNCWN',
            wni_country: 'CN',
            wni_lat: 22.4364,
            wni_lon: 113.881,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'CYA',
            wni_port_name: 'CAYO ARCAS TERMINAL',
            wni_unlocode: 'MXCAT',
            wni_country: 'MX',
            wni_lat: 20.1833,
            wni_lon: -91.9833,
            wni_tz: 'America/Merida',
        },
        {
            option: 'CZX',
            wni_port_name: 'CHANGZHOU',
            wni_unlocode: 'CNCHO',
            wni_country: 'CN',
            wni_lat: 31.9673,
            wni_lon: 120.0283,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'DACNG',
            wni_port_name: 'DA CHANG BAY',
            wni_unlocode: 'CNDCH',
            wni_country: 'CN',
            wni_lat: 22.5174,
            wni_lon: 113.8535,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'DAE',
            wni_port_name: 'DAESAN (TAESAN)',
            wni_unlocode: 'KRTSN',
            wni_country: 'KR',
            wni_lat: 37.0282,
            wni_lon: 126.3501,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'DAL',
            wni_port_name: 'DALHOUSIE',
            wni_unlocode: 'CADHS',
            wni_country: 'CA',
            wni_lat: 48.0691,
            wni_lon: -66.3492,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'DALA',
            wni_port_name: 'DALIA TERMINAL',
            wni_unlocode: 'AODAL',
            wni_country: 'AO',
            wni_lat: -7.6833,
            wni_lon: 11.7667,
            wni_tz: 'Africa/Luanda',
        },
        {
            option: 'DAM',
            wni_port_name: 'DAMMAM',
            wni_unlocode: 'SADMM',
            wni_country: 'SA',
            wni_lat: 26.5295,
            wni_lon: 50.2053,
            wni_tz: 'Asia/Riyadh',
        },
        {
            option: 'DAMON',
            wni_port_name: 'DAM MON',
            wni_unlocode: 'VNDMO',
            wni_country: 'VN',
            wni_lat: 12.6666,
            wni_lon: 109.3979,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'DAN',
            wni_port_name: 'DA NANG',
            wni_unlocode: 'VNDAD',
            wni_country: 'VN',
            wni_lat: 16.0997,
            wni_lon: 108.2182,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'DANG',
            wni_port_name: 'DANGJIN',
            wni_unlocode: 'KRTJI',
            wni_country: 'KR',
            wni_lat: 37.0747,
            wni_lon: 126.5115,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'DAR',
            wni_port_name: 'DARICA',
            wni_unlocode: 'TRDAR',
            wni_country: 'TR',
            wni_lat: 40.7459,
            wni_lon: 29.3649,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'DAS',
            wni_port_name: 'DAS ISLAND',
            wni_unlocode: 'AEDAS',
            wni_country: 'AE',
            wni_lat: 25.1305,
            wni_lon: 52.889,
            wni_tz: 'Asia/Dubai',
        },
        {
            option: 'DAV',
            wni_port_name: 'DAVAO',
            wni_unlocode: 'PHBIY',
            wni_country: 'PH',
            wni_lat: 7.0677,
            wni_lon: 125.635,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'DBH',
            wni_port_name: 'DABHOL',
            wni_unlocode: 'INDHP',
            wni_country: 'IN',
            wni_lat: 17.5247,
            wni_lon: 73.1372,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'DBL',
            wni_port_name: 'DUBLIN',
            wni_unlocode: 'IEDUB',
            wni_country: 'IE',
            wni_lat: 53.3437,
            wni_lon: -6.1385,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'DDG',
            wni_port_name: 'DANDONG',
            wni_unlocode: 'CNDDZ',
            wni_country: 'CN',
            wni_lat: 40.113,
            wni_lon: 124.3888,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'DE',
            wni_port_name: 'DELAWARE CITY',
            wni_unlocode: 'USDCI',
            wni_country: 'US',
            wni_lat: 39.5646,
            wni_lon: -75.5488,
            wni_tz: 'America/New_York',
        },
        {
            option: 'DERI',
            wni_port_name: 'DERINCE',
            wni_unlocode: 'TRDRC',
            wni_country: 'TR',
            wni_lat: 40.7412,
            wni_lon: 29.819,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'DES',
            wni_port_name: 'DAR-ES-SALAAM',
            wni_unlocode: 'TZDAR',
            wni_country: 'TZ',
            wni_lat: -6.8285,
            wni_lon: 39.2924,
            wni_tz: 'Africa/Dar_es_Salaam',
        },
        {
            option: 'DGH',
            wni_port_name: 'DIGHI',
            wni_unlocode: 'INDIG',
            wni_country: 'IN',
            wni_lat: 18.2873,
            wni_lon: 72.9706,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'DGSNR',
            wni_port_name: 'DONGGI SENORO LNG TERMINAL',
            wni_unlocode: 'IDDOG',
            wni_country: 'ID',
            wni_lat: -1.2598,
            wni_lon: 122.5974,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'DHJ',
            wni_port_name: 'DAHEJ',
            wni_unlocode: 'INDAH',
            wni_country: 'IN',
            wni_lat: 21.6698,
            wni_lon: 72.4989,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'DHMR',
            wni_port_name: 'DHAMRA',
            wni_unlocode: 'INDHA',
            wni_country: 'IN',
            wni_lat: 20.8196,
            wni_lon: 86.9802,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'DIA',
            wni_port_name: 'DIAMANTE',
            wni_unlocode: 'ARDME',
            wni_country: 'AR',
            wni_lat: -32.0658,
            wni_lon: -60.6593,
            wni_tz: 'America/Argentina/Cordoba',
        },
        {
            option: 'DIDON',
            wni_port_name: 'DIDON',
            wni_unlocode: 'TNDID',
            wni_country: 'TN',
            wni_lat: 33.7833,
            wni_lon: 11.9,
            wni_tz: 'Africa/Tunis',
        },
        {
            option: 'DIK',
            wni_port_name: 'EL DEKHEILA',
            wni_unlocode: 'EGEDK',
            wni_country: 'EG',
            wni_lat: 31.1459,
            wni_lon: 29.8105,
            wni_tz: 'Africa/Cairo',
        },
        {
            option: 'DIN',
            wni_port_name: 'DINAGAT',
            wni_unlocode: 'PHDNG',
            wni_country: 'PH',
            wni_lat: 9.9638,
            wni_lon: 125.5746,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'DJB',
            wni_port_name: 'DJIBOUTI',
            wni_unlocode: 'DJJIB',
            wni_country: 'DJ',
            wni_lat: 11.6016,
            wni_lon: 43.1242,
            wni_tz: 'Africa/Djibouti',
        },
        {
            option: 'DJEN',
            wni_port_name: 'DJEN DJEN',
            wni_unlocode: 'DZDJE',
            wni_country: 'DZ',
            wni_lat: 36.8409,
            wni_lon: 5.8976,
            wni_tz: 'Africa/Algiers',
        },
        {
            option: 'DJENO',
            wni_port_name: 'DJENO TERMINAL',
            wni_unlocode: 'CGDJE',
            wni_country: 'CG',
            wni_lat: -4.9333,
            wni_lon: 11.9,
            wni_tz: 'Africa/Brazzaville',
        },
        {
            option: 'DKILI',
            wni_port_name: 'DIKILI',
            wni_unlocode: 'TRDIK',
            wni_country: 'TR',
            wni_lat: 39.0744,
            wni_lon: 26.8743,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'DKR',
            wni_port_name: 'DAKAR',
            wni_unlocode: 'SNDKR',
            wni_country: 'SN',
            wni_lat: 14.6763,
            wni_lon: -17.4129,
            wni_tz: 'Africa/Dakar',
        },
        {
            option: 'DLK',
            wni_port_name: 'DILISKELESI',
            wni_unlocode: 'TRDIL',
            wni_country: 'TR',
            wni_lat: 40.7489,
            wni_lon: 29.5204,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'DLN',
            wni_port_name: 'DALIAN',
            wni_unlocode: 'CNDAG',
            wni_country: 'CN',
            wni_lat: 38.9449,
            wni_lon: 121.6757,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'DLR',
            wni_port_name: 'HAYPOINT (DALRYMPLE BAY)',
            wni_unlocode: 'AUDEB',
            wni_country: 'AU',
            wni_lat: -21.2526,
            wni_lon: 149.3182,
            wni_tz: 'Australia/Brisbane',
        },
        {
            option: 'DMI',
            wni_port_name: 'DAMIETTA',
            wni_unlocode: 'EGDAM',
            wni_country: 'EG',
            wni_lat: 31.4994,
            wni_lon: 31.751,
            wni_tz: 'Africa/Cairo',
        },
        {
            option: 'DNGJK',
            wni_port_name: 'DONGJIAKOU',
            wni_unlocode: 'CNDJK',
            wni_country: 'CN',
            wni_lat: 35.575,
            wni_lon: 119.7917,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'DOG',
            wni_port_name: 'DONGES',
            wni_unlocode: 'FRDON',
            wni_country: 'FR',
            wni_lat: 47.2934,
            wni_lon: -2.0706,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'DOH',
            wni_port_name: 'DOHA',
            wni_unlocode: 'QADOH',
            wni_country: 'QA',
            wni_lat: 25.3123,
            wni_lon: 51.5671,
            wni_tz: 'Asia/Qatar',
        },
        {
            option: 'DOR',
            wni_port_name: 'DORDRECHT',
            wni_unlocode: 'NLDOR',
            wni_country: 'NL',
            wni_lat: 51.7988,
            wni_lon: 4.6228,
            wni_tz: 'Europe/Amsterdam',
        },
        {
            option: 'DOS',
            wni_port_name: 'DOS BOCAS',
            wni_unlocode: 'MXDBT',
            wni_country: 'MX',
            wni_lat: 18.4579,
            wni_lon: -93.2084,
            wni_tz: 'America/Mexico_City',
        },
        {
            option: 'DOU',
            wni_port_name: 'DOUALA',
            wni_unlocode: 'CMDLA',
            wni_country: 'CM',
            wni_lat: 4.041,
            wni_lon: 9.6647,
            wni_tz: 'Africa/Douala',
        },
        {
            option: 'DOV',
            wni_port_name: 'DOVER',
            wni_unlocode: 'GBDVR',
            wni_country: 'GB',
            wni_lat: 51.102,
            wni_lon: 1.3352,
            wni_tz: 'Europe/London',
        },
        {
            option: 'DPE',
            wni_port_name: 'DIEPPE',
            wni_unlocode: 'FRDPE',
            wni_country: 'FR',
            wni_lat: 49.9447,
            wni_lon: 1.0837,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'DPR',
            wni_port_name: 'DAMPIER',
            wni_unlocode: 'AUDAM',
            wni_country: 'AU',
            wni_lat: -20.6288,
            wni_lon: 116.7207,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'DPY',
            wni_port_name: 'DNEPRO BUGSKY',
            wni_unlocode: 'UADNB',
            wni_country: 'UA',
            wni_lat: 46.7576,
            wni_lon: 31.9269,
            wni_tz: 'Europe/Kiev',
        },
        {
            option: 'DQT',
            wni_port_name: 'DUNG QUAT',
            wni_unlocode: 'VNDQT',
            wni_country: 'VN',
            wni_lat: 15.4084,
            wni_lon: 108.7898,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'DRA',
            wni_port_name: 'DRAMMEN',
            wni_unlocode: 'NODRM',
            wni_country: 'NO',
            wni_lat: 59.7362,
            wni_lon: 10.2623,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'DSN',
            wni_port_name: 'DONGSHAN',
            wni_unlocode: 'CNDSA',
            wni_country: 'CN',
            wni_lat: 23.6844,
            wni_lon: 117.5811,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'DSV',
            wni_port_name: 'DONALDSONVILLE',
            wni_unlocode: 'USDNA',
            wni_country: 'US',
            wni_lat: 30.1061,
            wni_lon: -90.9605,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'DUB',
            wni_port_name: 'DUBAI',
            wni_unlocode: 'AEDXB',
            wni_country: 'AE',
            wni_lat: 25.2891,
            wni_lon: 55.2622,
            wni_tz: 'Asia/Dubai',
        },
        {
            option: 'DUBA',
            wni_port_name: 'DHUBA',
            wni_unlocode: 'SADHU',
            wni_country: 'SA',
            wni_lat: 27.5637,
            wni_lon: 35.5187,
            wni_tz: 'Asia/Riyadh',
        },
        {
            option: 'DUBR',
            wni_port_name: 'DUBROVNIK',
            wni_unlocode: 'HRDBV',
            wni_country: 'HR',
            wni_lat: 42.6489,
            wni_lon: 18.0249,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'DUL',
            wni_port_name: 'DULANG TERMIANAL',
            wni_unlocode: 'MYDTL',
            wni_country: 'MY',
            wni_lat: 5.6666,
            wni_lon: 104.1666,
            wni_tz: 'Etc/GMT-8',
        },
        {
            option: 'DUM',
            wni_port_name: 'DUMAI',
            wni_unlocode: 'IDDUM',
            wni_country: 'ID',
            wni_lat: 1.6973,
            wni_lon: 101.487,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'DUNKK',
            wni_port_name: 'DUNKIRK',
            wni_unlocode: 'FRDKK',
            wni_country: 'FR',
            wni_lat: 51.0677,
            wni_lon: 2.3519,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'DUR',
            wni_port_name: 'DURBAN',
            wni_unlocode: 'ZADUR',
            wni_country: 'ZA',
            wni_lat: -29.8594,
            wni_lon: 31.0654,
            wni_tz: 'Africa/Johannesburg',
        },
        {
            option: 'DUT',
            wni_port_name: 'DUTCH HARBOR',
            wni_unlocode: 'USDUT',
            wni_country: 'US',
            wni_lat: 53.8994,
            wni_lon: -166.501,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'DVS',
            wni_port_name: 'DAVISVILLE',
            wni_unlocode: 'USDVV',
            wni_country: 'US',
            wni_lat: 41.614,
            wni_lon: -71.392,
            wni_tz: 'America/New_York',
        },
        {
            option: 'DVT',
            wni_port_name: 'DAVANT',
            wni_unlocode: 'USDVT',
            wni_country: 'US',
            wni_lat: 29.621,
            wni_lon: -89.9046,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'DWN',
            wni_port_name: 'DARWIN',
            wni_unlocode: 'AUDRW',
            wni_country: 'AU',
            wni_lat: -12.4786,
            wni_lon: 130.8522,
            wni_tz: 'Australia/Darwin',
        },
        {
            option: 'EAT',
            wni_port_name: 'EAST LONDON',
            wni_unlocode: 'ZAELS',
            wni_country: 'ZA',
            wni_lat: -33.0247,
            wni_lon: 27.9271,
            wni_tz: 'Africa/Johannesburg',
        },
        {
            option: 'EBOME',
            wni_port_name: 'EBOME TERMINAL',
            wni_unlocode: 'CMEBT',
            wni_country: 'CM',
            wni_lat: 2.8,
            wni_lon: 9.8167,
            wni_tz: 'Africa/Douala',
        },
        {
            option: 'EDN',
            wni_port_name: 'EDEN',
            wni_unlocode: 'AUQDN',
            wni_country: 'AU',
            wni_lat: -37.1,
            wni_lon: 149.925,
            wni_tz: 'Australia/Melbourne',
        },
        {
            option: 'EIL',
            wni_port_name: 'EILAT',
            wni_unlocode: 'ILETH',
            wni_country: 'IL',
            wni_lat: 29.5344,
            wni_lon: 34.9538,
            wni_tz: 'Asia/Jerusalem',
        },
        {
            option: 'EIMA',
            wni_port_name: 'ESHIMA',
            wni_unlocode: 'JPESM',
            wni_country: 'JP',
            wni_lat: 35.519,
            wni_lon: 133.187,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'ELBI',
            wni_port_name: 'ELBA ISLAND',
            wni_unlocode: 'USEBA',
            wni_country: 'US',
            wni_lat: 32.0786,
            wni_lon: -80.9847,
            wni_tz: 'America/New_York',
        },
        {
            option: 'ELF',
            wni_port_name: 'FERROL',
            wni_unlocode: 'ESFER',
            wni_country: 'ES',
            wni_lat: 43.4412,
            wni_lon: -8.3367,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'ELG',
            wni_port_name: 'EL GUAMACHE',
            wni_unlocode: 'VEEGU',
            wni_country: 'VE',
            wni_lat: 10.8588,
            wni_lon: -64.0707,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'ELP',
            wni_port_name: 'EL PALITO',
            wni_unlocode: 'VEELP',
            wni_country: 'VE',
            wni_lat: 10.5072,
            wni_lon: -68.1213,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'ELT',
            wni_port_name: 'EL TABLAZO',
            wni_unlocode: 'VEETV',
            wni_country: 'VE',
            wni_lat: 10.7451,
            wni_lon: -71.5513,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'ELU',
            wni_port_name: 'ELEUSIS',
            wni_unlocode: 'GRFLS',
            wni_country: 'GR',
            wni_lat: 38.025,
            wni_lon: 23.5428,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'ELZ',
            wni_port_name: 'ELIZABETHPORT',
            wni_unlocode: 'USEZA',
            wni_country: 'US',
            wni_lat: 40.6696,
            wni_lon: -74.1351,
            wni_tz: 'America/New_York',
        },
        {
            option: 'EMD',
            wni_port_name: 'EMDEN',
            wni_unlocode: 'DEEME',
            wni_country: 'DE',
            wni_lat: 53.3261,
            wni_lon: 7.1801,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'ENNO',
            wni_port_name: 'ENNORE',
            wni_unlocode: 'INENR',
            wni_country: 'IN',
            wni_lat: 13.2509,
            wni_lon: 80.3483,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'ENOK',
            wni_port_name: 'KUALA ENOK',
            wni_unlocode: 'IDENO',
            wni_country: 'ID',
            wni_lat: -0.5161,
            wni_lon: 103.393,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'ENS',
            wni_port_name: 'ENSENADA',
            wni_unlocode: 'MXESE',
            wni_country: 'MX',
            wni_lat: 31.8307,
            wni_lon: -116.6264,
            wni_tz: 'America/Tijuana',
        },
        {
            option: 'ENT',
            wni_port_name: 'ENSTEADVAERKET',
            wni_unlocode: 'DKENS',
            wni_country: 'DK',
            wni_lat: 55.0305,
            wni_lon: 9.4405,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'ERG',
            wni_port_name: 'EREGLI',
            wni_unlocode: 'TRELI',
            wni_country: 'TR',
            wni_lat: 41.2744,
            wni_lon: 31.3908,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'ERHA',
            wni_port_name: 'ERHA TERMINAL',
            wni_unlocode: 'NGERT',
            wni_country: 'NG',
            wni_lat: 5.6,
            wni_lon: 4.6,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'ERK',
            wni_port_name: 'EUREKA',
            wni_unlocode: 'USEKA',
            wni_country: 'US',
            wni_lat: 40.7716,
            wni_lon: -124.2501,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'ERT',
            wni_port_name: 'EVERETT\t MA',
            wni_unlocode: 'USEVT',
            wni_country: 'US',
            wni_lat: 42.3865,
            wni_lon: -71.0574,
            wni_tz: 'America/New_York',
        },
        {
            option: 'ESB',
            wni_port_name: 'ESBJERG',
            wni_unlocode: 'DKEBJ',
            wni_country: 'DK',
            wni_lat: 55.4751,
            wni_lon: 8.3957,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'ESC',
            wni_port_name: 'ESCRAVOS',
            wni_unlocode: 'NGESC',
            wni_country: 'NG',
            wni_lat: 5.5,
            wni_lon: 5,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'ESD',
            wni_port_name: 'ES SIDER',
            wni_unlocode: 'LYESI',
            wni_country: 'LY',
            wni_lat: 30.6433,
            wni_lon: 18.3741,
            wni_tz: 'Africa/Tripoli',
        },
        {
            option: 'ESG',
            wni_port_name: 'EL SEGUNDO',
            wni_unlocode: 'USELS',
            wni_country: 'US',
            wni_lat: 33.9548,
            wni_lon: -118.4734,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'ESP',
            wni_port_name: 'ESPERANCE',
            wni_unlocode: 'AUEPR',
            wni_country: 'AU',
            wni_lat: -33.8621,
            wni_lon: 121.911,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'ESPO',
            wni_port_name: 'ESPOIR TERMINAL',
            wni_unlocode: 'CIESP',
            wni_country: 'CI',
            wni_lat: 5.2739,
            wni_lon: -4.0168,
            wni_tz: 'Africa/Abidjan',
        },
        {
            option: 'ESR',
            wni_port_name: 'ESCOBAR',
            wni_unlocode: 'ARBDE',
            wni_country: 'AR',
            wni_lat: -34.2397,
            wni_lon: -58.7611,
            wni_tz: 'America/Argentina/Buenos_Aires',
        },
        {
            option: 'ESS',
            wni_port_name: 'ESMERALDAS',
            wni_unlocode: 'ECESM',
            wni_country: 'EC',
            wni_lat: 1.0012,
            wni_lon: -79.64,
            wni_tz: 'America/Guayaquil',
        },
        {
            option: 'ESSH',
            wni_port_name: 'ESASHI',
            wni_unlocode: 'JPESI',
            wni_country: 'JP',
            wni_lat: 41.8795,
            wni_lon: 140.124,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'ETA',
            wni_port_name: 'ETAJIMA',
            wni_unlocode: 'JPETA',
            wni_country: 'JP',
            wni_lat: 34.1926,
            wni_lon: 132.4914,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'ETAME',
            wni_port_name: 'ETAME TERMINAL',
            wni_unlocode: 'GAETA',
            wni_country: 'GA',
            wni_lat: -3.75,
            wni_lon: 10.5167,
            wni_tz: 'Africa/Libreville',
        },
        {
            option: 'EVE',
            wni_port_name: 'EVERETT',
            wni_unlocode: 'USPAE',
            wni_country: 'US',
            wni_lat: 47.9767,
            wni_lon: -122.2451,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'FAB',
            wni_port_name: 'FORTALEZA',
            wni_unlocode: 'BRFOR',
            wni_country: 'BR',
            wni_lat: -3.7006,
            wni_lon: -38.491,
            wni_tz: 'America/Fortaleza',
        },
        {
            option: 'FAEGG',
            wni_port_name: 'FANGCHENG',
            wni_unlocode: 'CNFAN',
            wni_country: 'CN',
            wni_lat: 21.5842,
            wni_lon: 108.339,
            wni_tz: 'Asia/Chongqing',
        },
        {
            option: 'FAR',
            wni_port_name: 'FARSUND',
            wni_unlocode: 'NOFAN',
            wni_country: 'NO',
            wni_lat: 58.088,
            wni_lon: 6.8239,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'FAT',
            wni_port_name: 'FATEH TERMINAL',
            wni_unlocode: 'AEFAT',
            wni_country: 'AE',
            wni_lat: 25.5833,
            wni_lon: 54.4167,
            wni_tz: 'Asia/Dubai',
        },
        {
            option: 'FAW',
            wni_port_name: 'FAWLEY',
            wni_unlocode: 'GBFAW',
            wni_country: 'GB',
            wni_lat: 50.811,
            wni_lon: -1.288,
            wni_tz: 'Europe/London',
        },
        {
            option: 'FER',
            wni_port_name: 'FERNDALE',
            wni_unlocode: 'USFDT',
            wni_country: 'US',
            wni_lat: 48.8294,
            wni_lon: -122.7364,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'FHL',
            wni_port_name: 'FAIRLESS HILLS',
            wni_unlocode: 'USFAH',
            wni_country: 'US',
            wni_lat: 40.1277,
            wni_lon: -74.8211,
            wni_tz: 'America/New_York',
        },
        {
            option: 'FIN',
            wni_port_name: 'FINNART',
            wni_unlocode: 'GBFNT',
            wni_country: 'GB',
            wni_lat: 56.114,
            wni_lon: -4.8422,
            wni_tz: 'Europe/London',
        },
        {
            option: 'FIU',
            wni_port_name: 'FIUMICINO',
            wni_unlocode: 'ITFCO',
            wni_country: 'IT',
            wni_lat: 41.7712,
            wni_lon: 12.2121,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'FKA',
            wni_port_name: 'AKITA FUNAKAWA',
            wni_unlocode: 'JPAXT',
            wni_country: 'JP',
            wni_lat: 39.7674,
            wni_lon: 140.0023,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'FKY',
            wni_port_name: 'FUKUYAMA',
            wni_unlocode: 'JPFKY',
            wni_country: 'JP',
            wni_lat: 34.4176,
            wni_lon: 133.4394,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'FLM',
            wni_port_name: 'FALMOUTH',
            wni_unlocode: 'GBFAL',
            wni_country: 'GB',
            wni_lat: 50.1364,
            wni_lon: -5.0309,
            wni_tz: 'Europe/London',
        },
        {
            option: 'FLOR',
            wni_port_name: 'FLORIANOPOLIS',
            wni_unlocode: 'BRFLN',
            wni_country: 'BR',
            wni_lat: -27.6141,
            wni_lon: -48.5605,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'FLR',
            wni_port_name: 'FLORO (FLORA)',
            wni_unlocode: 'NOFRO',
            wni_country: 'NO',
            wni_lat: 61.6048,
            wni_lon: 5.0284,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'FLX',
            wni_port_name: 'FELIXSTOWE',
            wni_unlocode: 'GBFXT',
            wni_country: 'GB',
            wni_lat: 51.9255,
            wni_lon: 1.3014,
            wni_tz: 'Europe/London',
        },
        {
            option: 'FNC',
            wni_port_name: 'FUNCHAL',
            wni_unlocode: 'PTFNC',
            wni_country: 'PT',
            wni_lat: 32.6334,
            wni_lon: -16.9032,
            wni_tz: 'Atlantic/Madeira',
        },
        {
            option: 'FON',
            wni_port_name: 'FORNO',
            wni_unlocode: 'BRFNO',
            wni_country: 'BR',
            wni_lat: -22.9745,
            wni_lon: -42.0063,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'FOR',
            wni_port_name: 'FORCADOS',
            wni_unlocode: 'NGFOR',
            wni_country: 'NG',
            wni_lat: 5.3741,
            wni_lon: 5.3058,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'FOS',
            wni_port_name: 'FOS',
            wni_unlocode: 'FRFOS',
            wni_country: 'FR',
            wni_lat: 43.4034,
            wni_lon: 4.9065,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'FOY',
            wni_port_name: 'FOYNES',
            wni_unlocode: 'IEFOV',
            wni_country: 'IE',
            wni_lat: 52.6166,
            wni_lon: -9.1,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'FRAD',
            wni_port_name: 'FRASER SURREY DOCKS',
            wni_unlocode: 'CAFSD',
            wni_country: 'CA',
            wni_lat: 49.18,
            wni_lon: -122.92,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'FRD',
            wni_port_name: 'FREDERICIA',
            wni_unlocode: 'DKFRC',
            wni_country: 'DK',
            wni_lat: 55.5494,
            wni_lon: 9.7509,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'FRE',
            wni_port_name: 'FREEPORT',
            wni_unlocode: 'BSFPO',
            wni_country: 'BS',
            wni_lat: 26.5179,
            wni_lon: -78.7766,
            wni_tz: 'America/Nassau',
        },
        {
            option: 'FRED',
            wni_port_name: 'FREDERIKSTED',
            wni_unlocode: 'VIFRD',
            wni_country: 'VI',
            wni_lat: 17.7112,
            wni_lon: -64.8985,
            wni_tz: 'America/St_Thomas',
        },
        {
            option: 'FREEP',
            wni_port_name: 'FREEPORT',
            wni_unlocode: 'BMFPT',
            wni_country: 'BM',
            wni_lat: 32.3331,
            wni_lon: -64.8271,
            wni_tz: 'Atlantic/Bermuda',
        },
        {
            option: 'FRM',
            wni_port_name: 'FREMANTLE',
            wni_unlocode: 'AUFET',
            wni_country: 'AU',
            wni_lat: -32.0626,
            wni_lon: 115.7222,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'FTF',
            wni_port_name: 'FORT DE FRANCE',
            wni_unlocode: 'MQFDF',
            wni_country: 'MQ',
            wni_lat: 14.5907,
            wni_lon: -61.0663,
            wni_tz: 'America/Martinique',
        },
        {
            option: 'FTG',
            wni_port_name: 'FUTONG',
            wni_unlocode: 'IDFTG',
            wni_country: 'ID',
            wni_lat: 0.8268,
            wni_lon: 102.4055,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'FTN',
            wni_port_name: 'FREETOWN',
            wni_unlocode: 'SLFNA',
            wni_country: 'SL',
            wni_lat: 8.5022,
            wni_lon: -13.2172,
            wni_tz: 'Africa/Freetown',
        },
        {
            option: 'FTTS',
            wni_port_name: 'FUTTSU',
            wni_unlocode: 'JPFTS',
            wni_country: 'JP',
            wni_lat: 35.3521,
            wni_lon: 139.8122,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'FTX',
            wni_port_name: 'FREEPORT',
            wni_unlocode: 'USFEP',
            wni_country: 'US',
            wni_lat: 28.926,
            wni_lon: -95.2872,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'FUJIAN',
            wni_port_name: 'FUJIAN',
            wni_unlocode: 'CNFUQ',
            wni_country: 'CN',
            wni_lat: 25.2029,
            wni_lon: 118.9954,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'FUKI',
            wni_port_name: 'FUKUI',
            wni_unlocode: 'JPFKJ',
            wni_country: 'JP',
            wni_lat: 36.2081,
            wni_lon: 136.1016,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'FUN',
            wni_port_name: 'FUNABASHI',
            wni_unlocode: 'JPFNB',
            wni_country: 'JP',
            wni_lat: 35.6508,
            wni_lon: 139.9821,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'FUS',
            wni_port_name: 'FUSHIKI TOYAMA',
            wni_unlocode: 'JPFSK',
            wni_country: 'JP',
            wni_lat: 36.7761,
            wni_lon: 137.2312,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'FUZ',
            wni_port_name: 'FUZHOU',
            wni_unlocode: 'CNFOC',
            wni_country: 'CN',
            wni_lat: 26.0473,
            wni_lon: 119.3016,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'FYB',
            wni_port_name: 'FRAY BENTOS',
            wni_unlocode: 'UYFZB',
            wni_country: 'UY',
            wni_lat: -33.1223,
            wni_lon: -58.3614,
            wni_tz: 'America/Montevideo',
        },
        {
            option: 'GAB',
            wni_port_name: 'GABES',
            wni_unlocode: 'TNGAE',
            wni_country: 'TN',
            wni_lat: 33.9231,
            wni_lon: 10.1209,
            wni_tz: 'Africa/Tunis',
        },
        {
            option: 'GAL',
            wni_port_name: 'GALVESTON',
            wni_unlocode: 'USGLS',
            wni_country: 'US',
            wni_lat: 29.3099,
            wni_lon: -94.8015,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'GAM',
            wni_port_name: 'GAMAGORI',
            wni_unlocode: 'JPGAM',
            wni_country: 'JP',
            wni_lat: 34.8025,
            wni_lon: 137.222,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'GAP',
            wni_port_name: 'GASPE',
            wni_unlocode: 'CAGPE',
            wni_country: 'CA',
            wni_lat: 48.8318,
            wni_lon: -64.4615,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'GAS',
            wni_port_name: 'GDANSK',
            wni_unlocode: 'PLGDN',
            wni_country: 'PL',
            wni_lat: 54.4002,
            wni_lon: 18.7337,
            wni_tz: 'Europe/Warsaw',
        },
        {
            option: 'GAT',
            wni_port_name: 'GAETA',
            wni_unlocode: 'ITGAE',
            wni_country: 'IT',
            wni_lat: 41.1941,
            wni_lon: 13.6029,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'GBR',
            wni_port_name: 'GIBRALTAR',
            wni_unlocode: 'GIGIB',
            wni_country: 'GI',
            wni_lat: 36.1259,
            wni_lon: -5.3714,
            wni_tz: 'Europe/Gibraltar',
        },
        {
            option: 'GBZ',
            wni_port_name: 'GEBZE',
            wni_unlocode: 'TRGEB',
            wni_country: 'TR',
            wni_lat: 40.7588,
            wni_lon: 29.4251,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'GCA',
            wni_port_name: 'GUAYACAN',
            wni_unlocode: 'CLGYC',
            wni_country: 'CL',
            wni_lat: -29.9644,
            wni_lon: -71.3709,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'GCIG',
            wni_port_name: 'GEORGETOWN',
            wni_unlocode: 'KYGEC',
            wni_country: 'KY',
            wni_lat: 19.2969,
            wni_lon: -81.3933,
            wni_tz: 'America/Cayman',
        },
        {
            option: 'GDT',
            wni_port_name: 'GERALDTON',
            wni_unlocode: 'AUGET',
            wni_country: 'AU',
            wni_lat: -28.7625,
            wni_lon: 114.6011,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'GDY',
            wni_port_name: 'GDYNIA',
            wni_unlocode: 'PLGDY',
            wni_country: 'PL',
            wni_lat: 54.5344,
            wni_lon: 18.5769,
            wni_tz: 'Europe/Warsaw',
        },
        {
            option: 'GEA',
            wni_port_name: 'PULAU GEE',
            wni_unlocode: 'IDGEE',
            wni_country: 'ID',
            wni_lat: 0.836,
            wni_lon: 128.3132,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'GEB',
            wni_port_name: 'GEBE',
            wni_unlocode: 'IDGEB',
            wni_country: 'ID',
            wni_lat: -0.0757,
            wni_lon: 129.4136,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'GEF',
            wni_port_name: 'GAVLE',
            wni_unlocode: 'SEGVX',
            wni_country: 'SE',
            wni_lat: 60.6937,
            wni_lon: 17.2439,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'GEL',
            wni_port_name: 'GELA',
            wni_unlocode: 'ITGEA',
            wni_country: 'IT',
            wni_lat: 37.0456,
            wni_lon: 14.2312,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'GEM',
            wni_port_name: 'GEMLIK',
            wni_unlocode: 'TRGEM',
            wni_country: 'TR',
            wni_lat: 40.4301,
            wni_lon: 29.1432,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'GEN',
            wni_port_name: 'GENOVA',
            wni_unlocode: 'ITGOA',
            wni_country: 'IT',
            wni_lat: 44.3843,
            wni_lon: 8.9147,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'GEO',
            wni_port_name: 'GEORGETOWN',
            wni_unlocode: 'GYGEO',
            wni_country: 'GY',
            wni_lat: 6.8266,
            wni_lon: -58.1738,
            wni_tz: 'America/Guyana',
        },
        {
            option: 'GERG',
            wni_port_name: 'ST. GEORGE',
            wni_unlocode: 'BMSGE',
            wni_country: 'BM',
            wni_lat: 32.3787,
            wni_lon: -64.658,
            wni_tz: 'Atlantic/Bermuda',
        },
        {
            option: 'GFP',
            wni_port_name: 'GULFPORT',
            wni_unlocode: 'USGFP',
            wni_country: 'US',
            wni_lat: 30.3402,
            wni_lon: -89.0776,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'GGVRM',
            wni_port_name: 'GANGAVARAM',
            wni_unlocode: 'INGGV',
            wni_country: 'IN',
            wni_lat: 17.6204,
            wni_lon: 83.2431,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'GGZ',
            wni_port_name: 'GUANGZHOU',
            wni_unlocode: 'CNCAN',
            wni_country: 'CN',
            wni_lat: 23.0843,
            wni_lon: 113.4017,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'GIJ',
            wni_port_name: 'GIJON',
            wni_unlocode: 'ESGIJ',
            wni_country: 'ES',
            wni_lat: 43.569,
            wni_lon: -5.6692,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'GIL',
            wni_port_name: 'PORT GILES',
            wni_unlocode: 'AUPGI',
            wni_country: 'AU',
            wni_lat: -35.0219,
            wni_lon: 137.776,
            wni_tz: 'Australia/Adelaide',
        },
        {
            option: 'GIRA',
            wni_port_name: 'GIRASSOL TERMINAL',
            wni_unlocode: 'AOGIR',
            wni_country: 'AO',
            wni_lat: -7.6331,
            wni_lon: 11.6831,
            wni_tz: 'Africa/Luanda',
        },
        {
            option: 'GIZ',
            wni_port_name: 'GIZAN',
            wni_unlocode: 'WNIIZ',
            wni_country: 'SA',
            wni_lat: 16.8751,
            wni_lon: 42.5257,
            wni_tz: 'Asia/Riyadh',
        },
        {
            option: 'GLA',
            wni_port_name: 'GLADSTONE',
            wni_unlocode: 'AUGLT',
            wni_country: 'AU',
            wni_lat: -23.8256,
            wni_lon: 151.2578,
            wni_tz: 'Australia/Brisbane',
        },
        {
            option: 'GLG',
            wni_port_name: 'GEELONG',
            wni_unlocode: 'AUGEX',
            wni_country: 'AU',
            wni_lat: -38.1356,
            wni_lon: 144.3726,
            wni_tz: 'Australia/Melbourne',
        },
        {
            option: 'GLL',
            wni_port_name: 'GUAYANILLA',
            wni_unlocode: 'PRGUY',
            wni_country: 'PR',
            wni_lat: 17.9574,
            wni_lon: -66.7641,
            wni_tz: 'America/Puerto_Rico',
        },
        {
            option: 'GLLE',
            wni_port_name: 'GALLE',
            wni_unlocode: 'LKGAL',
            wni_country: 'LK',
            wni_lat: 6.0238,
            wni_lon: 80.2239,
            wni_tz: 'Asia/Colombo',
        },
        {
            option: 'GLR',
            wni_port_name: 'GOLD RIVER',
            wni_unlocode: 'CAGOL',
            wni_country: 'CA',
            wni_lat: 49.6692,
            wni_lon: -126.1212,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'GMB',
            wni_port_name: 'GAMBA',
            wni_unlocode: 'GAGAX',
            wni_country: 'GA',
            wni_lat: -2.8333,
            wni_lon: 9.9833,
            wni_tz: 'Africa/Libreville',
        },
        {
            option: 'GME',
            wni_port_name: 'GUAMARE',
            wni_unlocode: 'BRGUA',
            wni_country: 'BR',
            wni_lat: -5.0752,
            wni_lon: -36.3704,
            wni_tz: 'America/Fortaleza',
        },
        {
            option: 'GNE',
            wni_port_name: 'GREENORE',
            wni_unlocode: 'IEGRN',
            wni_country: 'IE',
            wni_lat: 53.9941,
            wni_lon: -6.0717,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'GNG',
            wni_port_name: 'GINGOOG',
            wni_unlocode: 'PHGIN',
            wni_country: 'PH',
            wni_lat: 8.8408,
            wni_lon: 125.0981,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'GNGDNG',
            wni_port_name: 'GUANGDONG TERMINAL',
            wni_unlocode: 'CNGUA',
            wni_country: 'CN',
            wni_lat: 22.568,
            wni_lon: 114.4303,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'GNT',
            wni_port_name: 'GHENT',
            wni_unlocode: 'BEGNE',
            wni_country: 'BE',
            wni_lat: 51.0914,
            wni_lon: 3.7349,
            wni_tz: 'Europe/Brussels',
        },
        {
            option: 'GOA',
            wni_port_name: 'GOA',
            wni_unlocode: 'INGOI',
            wni_country: 'IN',
            wni_lat: 15.4352,
            wni_lon: 73.7774,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'GOLT',
            wni_port_name: 'GOLFITO',
            wni_unlocode: 'CRGLF',
            wni_country: 'CR',
            wni_lat: 8.629,
            wni_lon: -83.17,
            wni_tz: 'America/Costa_Rica',
        },
        {
            option: 'GORE',
            wni_port_name: 'GORE BAY',
            wni_unlocode: 'CAYZE',
            wni_country: 'CA',
            wni_lat: 45.9288,
            wni_lon: -82.4591,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'GOT',
            wni_port_name: 'GIOIA TAURO',
            wni_unlocode: 'ITGIT',
            wni_country: 'IT',
            wni_lat: 38.449,
            wni_lon: 15.881,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'GOV',
            wni_port_name: 'GOVE',
            wni_unlocode: 'AUGOV',
            wni_country: 'AU',
            wni_lat: -12.2186,
            wni_lon: 136.6562,
            wni_tz: 'Australia/Darwin',
        },
        {
            option: 'GPLTN',
            wni_port_name: 'GREATER PLUTONIO TERMINAL',
            wni_unlocode: 'AOGPO',
            wni_country: 'AO',
            wni_lat: -7.83,
            wni_lon: 12.12,
            wni_tz: 'Africa/Luanda',
        },
        {
            option: 'GPT',
            wni_port_name: 'GALEOTA',
            wni_unlocode: 'TTPTG',
            wni_country: 'TT',
            wni_lat: 10.125,
            wni_lon: -61.0028,
            wni_tz: 'America/Port_of_Spain',
        },
        {
            option: 'GRA',
            wni_port_name: 'GRAYS HARBOR',
            wni_unlocode: 'USGHC',
            wni_country: 'US',
            wni_lat: 46.9075,
            wni_lon: -124.1804,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'GRE',
            wni_port_name: 'GRESIK',
            wni_unlocode: 'IDGRE',
            wni_country: 'ID',
            wni_lat: -7.1557,
            wni_lon: 112.6733,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'GRGS',
            wni_port_name: "ST. GEORGE'S",
            wni_unlocode: 'GDSTG',
            wni_country: 'GD',
            wni_lat: 12.0447,
            wni_lon: -61.7568,
            wni_tz: 'America/Grenada',
        },
        {
            option: 'GRH',
            wni_port_name: 'GRENAA HAVN',
            wni_unlocode: 'DKGRE',
            wni_country: 'DK',
            wni_lat: 56.4144,
            wni_lon: 10.9543,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'GRI',
            wni_port_name: 'GROOTE EYLANDT',
            wni_unlocode: 'AUGTE',
            wni_country: 'AU',
            wni_lat: -13.8665,
            wni_lon: 136.4062,
            wni_tz: 'Australia/Darwin',
        },
        {
            option: 'GRM',
            wni_port_name: 'GRANGEMOUTH',
            wni_unlocode: 'GBGRG',
            wni_country: 'GB',
            wni_lat: 56.0366,
            wni_lon: -3.6655,
            wni_tz: 'Europe/London',
        },
        {
            option: 'GRR',
            wni_port_name: 'GARRUCHA',
            wni_unlocode: 'ESGAR',
            wni_country: 'ES',
            wni_lat: 37.1762,
            wni_lon: -1.8061,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'GRU',
            wni_port_name: 'GRUNDARTANGI',
            wni_unlocode: 'ISGRT',
            wni_country: 'IS',
            wni_lat: 64.35,
            wni_lon: -21.7666,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'GSB',
            wni_port_name: 'GISBORNE',
            wni_unlocode: 'NZGIS',
            wni_country: 'NZ',
            wni_lat: -38.7632,
            wni_lon: 178.0375,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'GSC',
            wni_port_name: 'GEORGETOWN',
            wni_unlocode: 'USGGE',
            wni_country: 'US',
            wni_lat: 33.3436,
            wni_lon: -79.2754,
            wni_tz: 'America/New_York',
        },
        {
            option: 'GSG',
            wni_port_name: 'GOSEONG',
            wni_unlocode: 'KRGSO',
            wni_country: 'KR',
            wni_lat: 34.951,
            wni_lon: 128.323,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'GSM',
            wni_port_name: 'GEISMAR',
            wni_unlocode: 'USGSM',
            wni_country: 'US',
            wni_lat: 30.1857,
            wni_lon: -91.0173,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'GST',
            wni_port_name: 'GENERAL SANTOS',
            wni_unlocode: 'PHGES',
            wni_country: 'PH',
            wni_lat: 6.0841,
            wni_lon: 125.1672,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'GTB',
            wni_port_name: 'GOTHENBURG',
            wni_unlocode: 'SEGOT',
            wni_country: 'SE',
            wni_lat: 57.7022,
            wni_lon: 11.9446,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'GUA',
            wni_port_name: 'GUAYMAS',
            wni_unlocode: 'MXGYM',
            wni_country: 'MX',
            wni_lat: 27.898,
            wni_lon: -110.8483,
            wni_tz: 'America/Hermosillo',
        },
        {
            option: 'GUAB',
            wni_port_name: 'GUAIBA ISLAND',
            wni_unlocode: 'BRGIB',
            wni_country: 'BR',
            wni_lat: -23.0227,
            wni_lon: -44.027,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'GUM',
            wni_port_name: 'GUAM (GUAM ISLAND)',
            wni_unlocode: 'GUGUM',
            wni_country: 'GU',
            wni_lat: 13.4545,
            wni_lon: 144.6141,
            wni_tz: 'Pacific/Guam',
        },
        {
            option: 'GUR',
            wni_port_name: 'GUARANAO',
            wni_unlocode: 'VEGUA',
            wni_country: 'VE',
            wni_lat: 11.6699,
            wni_lon: -70.2266,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'GUT',
            wni_port_name: 'GUANTA',
            wni_unlocode: 'VEGUT',
            wni_country: 'VE',
            wni_lat: 10.2554,
            wni_lon: -64.5931,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'GUY',
            wni_port_name: 'GUAYAQUIL',
            wni_unlocode: 'ECGYE',
            wni_country: 'EC',
            wni_lat: -2.2865,
            wni_lon: -79.9019,
            wni_tz: 'America/Guayaquil',
        },
        {
            option: 'GVN',
            wni_port_name: 'GRAVENCHON',
            wni_unlocode: 'FRGRN',
            wni_country: 'FR',
            wni_lat: 49.4685,
            wni_lon: 0.5363,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'GWD',
            wni_port_name: 'GWADAR',
            wni_unlocode: 'PKGWD',
            wni_country: 'PK',
            wni_lat: 25.121,
            wni_lon: 62.3421,
            wni_tz: 'Asia/Karachi',
        },
        {
            option: 'GYA',
            wni_port_name: 'GUAYAMA (LAS MAREAS)',
            wni_unlocode: 'PRLAM',
            wni_country: 'PR',
            wni_lat: 17.9238,
            wni_lon: -66.1634,
            wni_tz: 'America/Puerto_Rico',
        },
        {
            option: 'GYM',
            wni_port_name: 'GREAT YARMOUTH',
            wni_unlocode: 'GBGTY',
            wni_country: 'GB',
            wni_lat: 52.5719,
            wni_lon: 1.7519,
            wni_tz: 'Europe/London',
        },
        {
            option: 'HAAE',
            wni_port_name: 'HAKATA',
            wni_unlocode: 'JPHKT',
            wni_country: 'JP',
            wni_lat: 33.619,
            wni_lon: 130.3817,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HAC',
            wni_port_name: 'HACHINOHE',
            wni_unlocode: 'JPHHE',
            wni_country: 'JP',
            wni_lat: 40.555,
            wni_lon: 141.5311,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HAD',
            wni_port_name: 'HADERA',
            wni_unlocode: 'ILHAD',
            wni_country: 'IL',
            wni_lat: 32.4689,
            wni_lon: 34.8513,
            wni_tz: 'Asia/Jerusalem',
        },
        {
            option: 'HAF',
            wni_port_name: 'HAIFA',
            wni_unlocode: 'ILHFA',
            wni_country: 'IL',
            wni_lat: 32.8675,
            wni_lon: 34.9766,
            wni_tz: 'Asia/Jerusalem',
        },
        {
            option: 'HAG',
            wni_port_name: 'HADONG',
            wni_unlocode: 'KRHDG',
            wni_country: 'KR',
            wni_lat: 34.9354,
            wni_lon: 127.8169,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'HAGI',
            wni_port_name: 'HAGI',
            wni_unlocode: 'JPHAG',
            wni_country: 'JP',
            wni_lat: 34.4374,
            wni_lon: 131.4018,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HAI',
            wni_port_name: 'HAIPHONG',
            wni_unlocode: 'VNHPH',
            wni_country: 'VN',
            wni_lat: 20.8693,
            wni_lon: 106.6892,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'HAK',
            wni_port_name: 'HAKODATE',
            wni_unlocode: 'JPHKD',
            wni_country: 'JP',
            wni_lat: 41.7853,
            wni_lon: 140.6898,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HAL',
            wni_port_name: 'HALIFAX',
            wni_unlocode: 'CAHAL',
            wni_country: 'CA',
            wni_lat: 44.6507,
            wni_lon: -63.5626,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'HALUL',
            wni_port_name: 'HALUL ISLAND TERMINAL',
            wni_unlocode: 'QAHAL',
            wni_country: 'QA',
            wni_lat: 25.6833,
            wni_lon: 52.4167,
            wni_tz: 'Asia/Qatar',
        },
        {
            option: 'HAM',
            wni_port_name: 'HAMBURG',
            wni_unlocode: 'DEHAM',
            wni_country: 'DE',
            wni_lat: 53.5414,
            wni_lon: 9.9769,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'HAMR',
            wni_port_name: 'HAMRAWEIN',
            wni_unlocode: 'EGHAM',
            wni_country: 'EG',
            wni_lat: 26.2545,
            wni_lon: 34.2155,
            wni_tz: 'Africa/Cairo',
        },
        {
            option: 'HAN',
            wni_port_name: 'HANNAN',
            wni_unlocode: 'JPHAN',
            wni_country: 'JP',
            wni_lat: 34.4812,
            wni_lon: 135.3348,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HARA',
            wni_port_name: 'HARAMACHI',
            wni_unlocode: 'JPHRM',
            wni_country: 'JP',
            wni_lat: 37.6646,
            wni_lon: 141.0532,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HAT',
            wni_port_name: 'HAMILTON',
            wni_unlocode: 'BMBDA',
            wni_country: 'BM',
            wni_lat: 32.2873,
            wni_lon: -64.7908,
            wni_tz: 'Atlantic/Bermuda',
        },
        {
            option: 'HAU',
            wni_port_name: 'HAUGESUND LAY-UP',
            wni_unlocode: 'NOHAU',
            wni_country: 'NO',
            wni_lat: 59.3617,
            wni_lon: 5.2917,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'HAV',
            wni_port_name: 'HAVANA',
            wni_unlocode: 'CUHAV',
            wni_country: 'CU',
            wni_lat: 23.1544,
            wni_lon: -82.3651,
            wni_tz: 'America/Havana',
        },
        {
            option: 'HAZ',
            wni_port_name: 'HAZIRA',
            wni_unlocode: 'INHZR',
            wni_country: 'IN',
            wni_lat: 21.0813,
            wni_lon: 72.6101,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'HBK',
            wni_port_name: 'HIBIKINADA TERMINAL',
            wni_unlocode: 'JPHBI',
            wni_country: 'JP',
            wni_lat: 33.9613,
            wni_lon: 130.7679,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HCG',
            wni_port_name: 'HAICANG',
            wni_unlocode: 'CNXMH',
            wni_country: 'CN',
            wni_lat: 24.4236,
            wni_lon: 118.0474,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'HCM',
            wni_port_name: 'HO CHI MINH CITY',
            wni_unlocode: 'VNHCM',
            wni_country: 'VN',
            wni_lat: 10.7798,
            wni_lon: 106.7095,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'HDE',
            wni_port_name: 'HODEIDAH',
            wni_unlocode: 'YEHOD',
            wni_country: 'YE',
            wni_lat: 14.8447,
            wni_lon: 42.9289,
            wni_tz: 'Asia/Aden',
        },
        {
            option: 'HER',
            wni_port_name: 'HEROYA',
            wni_unlocode: 'NOHRY',
            wni_country: 'NO',
            wni_lat: 59.1034,
            wni_lon: 9.6224,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'HGY',
            wni_port_name: 'HONGAI',
            wni_unlocode: 'VNHON',
            wni_country: 'VN',
            wni_lat: 20.9425,
            wni_lon: 107.0657,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'HHR',
            wni_port_name: 'HIGASHI HARIMA',
            wni_unlocode: 'JPHHR',
            wni_country: 'JP',
            wni_lat: 34.6852,
            wni_lon: 134.8279,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HIB',
            wni_port_name: 'HIBI',
            wni_unlocode: 'JPHIB',
            wni_country: 'JP',
            wni_lat: 34.4418,
            wni_lon: 133.9295,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HIK',
            wni_port_name: 'HAIKOU',
            wni_unlocode: 'CNHAK',
            wni_country: 'CN',
            wni_lat: 20.0434,
            wni_lon: 110.2785,
            wni_tz: 'Asia/Chongqing',
        },
        {
            option: 'HIM',
            wni_port_name: 'HIMEJI',
            wni_unlocode: 'JPABO',
            wni_country: 'JP',
            wni_lat: 34.7533,
            wni_lon: 134.6217,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HIR',
            wni_port_name: 'HIROSHIMA',
            wni_unlocode: 'JPCHT',
            wni_country: 'JP',
            wni_lat: 34.3335,
            wni_lon: 132.4423,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HIT',
            wni_port_name: 'HITACHI',
            wni_unlocode: 'JPHTC',
            wni_country: 'JP',
            wni_lat: 36.4873,
            wni_lon: 140.6412,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HKAR',
            wni_port_name: 'HIKARI',
            wni_unlocode: 'JPHKR',
            wni_country: 'JP',
            wni_lat: 33.95,
            wni_lon: 131.92,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HKG',
            wni_port_name: 'HONG KONG',
            wni_unlocode: 'HKHKG',
            wni_country: 'CN',
            wni_lat: 22.2916,
            wni_lon: 114.1596,
            wni_tz: 'Asia/Hong_Kong',
        },
        {
            option: 'HKI',
            wni_port_name: 'HAWK INLET',
            wni_unlocode: 'USHWI',
            wni_country: 'US',
            wni_lat: 58.1172,
            wni_lon: -134.7412,
            wni_tz: 'America/Juneau',
        },
        {
            option: 'HLD',
            wni_port_name: 'HALDIA',
            wni_unlocode: 'INHAL',
            wni_country: 'IN',
            wni_lat: 22.0045,
            wni_lon: 88.0653,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'HLS',
            wni_port_name: 'HELSINKI',
            wni_unlocode: 'FIHEL',
            wni_country: 'FI',
            wni_lat: 60.1401,
            wni_lon: 24.9051,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'HLYLH',
            wni_port_name: 'HULAYLAH TERMINAL',
            wni_unlocode: 'AEHTL',
            wni_country: 'AE',
            wni_lat: 25.9739,
            wni_lon: 55.9364,
            wni_tz: 'Asia/Dubai',
        },
        {
            option: 'HMA',
            wni_port_name: 'HAMINA',
            wni_unlocode: 'FIHMN',
            wni_country: 'FI',
            wni_lat: 60.5137,
            wni_lon: 27.1617,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'HMBT',
            wni_port_name: 'HAMBANTOTA',
            wni_unlocode: 'LKHBA',
            wni_country: 'LK',
            wni_lat: 6.1106,
            wni_lon: 81.1134,
            wni_tz: 'Asia/Colombo',
        },
        {
            option: 'HMC',
            wni_port_name: 'HARMAC',
            wni_unlocode: 'CAHMC',
            wni_country: 'CA',
            wni_lat: 49.1456,
            wni_lon: -123.8602,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'HMD',
            wni_port_name: 'HAMADA',
            wni_unlocode: 'JPHMD',
            wni_country: 'JP',
            wni_lat: 34.9022,
            wni_lon: 132.0403,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HMK',
            wni_port_name: 'HIMEKAWA',
            wni_unlocode: 'JPHMK',
            wni_country: 'JP',
            wni_lat: 37.056,
            wni_lon: 137.8455,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HMKSM',
            wni_port_name: 'HEMIKSEM',
            wni_unlocode: 'BEHEX',
            wni_country: 'BE',
            wni_lat: 51.1503,
            wni_lon: 4.3298,
            wni_tz: 'Europe/Brussels',
        },
        {
            option: 'HMMRF',
            wni_port_name: 'HAMMERFEST',
            wni_unlocode: 'NOHFT',
            wni_country: 'NO',
            wni_lat: 70.6776,
            wni_lon: 23.5596,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'HMN',
            wni_port_name: 'HAIMEN',
            wni_unlocode: 'CNHME',
            wni_country: 'CN',
            wni_lat: 28.6914,
            wni_lon: 121.4465,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'HMR',
            wni_port_name: 'HAMRIYAH (HAMRIYA)',
            wni_unlocode: 'AEHAM',
            wni_country: 'AE',
            wni_lat: 25.483,
            wni_lon: 55.4694,
            wni_tz: 'Asia/Dubai',
        },
        {
            option: 'HNG',
            wni_port_name: 'HUANGPU',
            wni_unlocode: 'CNHUA',
            wni_country: 'CN',
            wni_lat: 23.0919,
            wni_lon: 113.439,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'HNGZH',
            wni_port_name: 'HANGZHOU',
            wni_unlocode: 'CNHGH',
            wni_country: 'CN',
            wni_lat: 30.2065,
            wni_lon: 120.1738,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'HNK',
            wni_port_name: 'HANKO',
            wni_unlocode: 'FIHKO',
            wni_country: 'FI',
            wni_lat: 59.8101,
            wni_lon: 22.9504,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'HNL',
            wni_port_name: 'HONOLULU',
            wni_unlocode: 'USHNL',
            wni_country: 'US',
            wni_lat: 21.3056,
            wni_lon: -157.8685,
            wni_tz: 'Pacific/Honolulu',
        },
        {
            option: 'HNNVG',
            wni_port_name: 'HONNINGSVAAG',
            wni_unlocode: 'NOHNV',
            wni_country: 'NO',
            wni_lat: 70.9676,
            wni_lon: 25.9364,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'HNR',
            wni_port_name: 'HONIARA',
            wni_unlocode: 'SBHIR',
            wni_country: 'SB',
            wni_lat: -9.4217,
            wni_lon: 159.9655,
            wni_tz: 'Pacific/Guadalcanal',
        },
        {
            option: 'HOB',
            wni_port_name: 'HOBART',
            wni_unlocode: 'AUHBA',
            wni_country: 'AU',
            wni_lat: -42.8894,
            wni_lon: 147.3513,
            wni_tz: 'Australia/Hobart',
        },
        {
            option: 'HOM',
            wni_port_name: 'HOMER',
            wni_unlocode: 'USHMH',
            wni_country: 'US',
            wni_lat: 59.5862,
            wni_lon: -151.4304,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'HOMS',
            wni_port_name: 'KHOMS',
            wni_unlocode: 'LYKHM',
            wni_country: 'LY',
            wni_lat: 32.6898,
            wni_lon: 14.2657,
            wni_tz: 'Africa/Tripoli',
        },
        {
            option: 'HOP',
            wni_port_name: 'HOPEWELL',
            wni_unlocode: 'USHEW',
            wni_country: 'US',
            wni_lat: 37.3047,
            wni_lon: -77.2569,
            wni_tz: 'America/New_York',
        },
        {
            option: 'HOPG',
            wni_port_name: 'HOPING',
            wni_unlocode: 'TWHOP',
            wni_country: 'TW',
            wni_lat: 24.2858,
            wni_lon: 121.769,
            wni_tz: 'Asia/Taipei',
        },
        {
            option: 'HOS',
            wni_port_name: 'HOSOSHIMA',
            wni_unlocode: 'JPHSM',
            wni_country: 'JP',
            wni_lat: 32.4547,
            wni_lon: 131.685,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HOU',
            wni_port_name: 'HOUSTON',
            wni_unlocode: 'USHOU',
            wni_country: 'US',
            wni_lat: 29.7589,
            wni_lon: -95.3245,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'HOUND',
            wni_port_name: 'HOUND POINT TERMINAL',
            wni_unlocode: 'GBHPT',
            wni_country: 'GB',
            wni_lat: 56,
            wni_lon: -3.3667,
            wni_tz: 'Europe/London',
        },
        {
            option: 'HPL',
            wni_port_name: 'HARTLEPOOL',
            wni_unlocode: 'GBHTP',
            wni_country: 'GB',
            wni_lat: 54.6878,
            wni_lon: -1.1649,
            wni_tz: 'Europe/London',
        },
        {
            option: 'HPT',
            wni_port_name: 'HAMPTON ROADS',
            wni_unlocode: 'USHR3',
            wni_country: 'US',
            wni_lat: 36.9688,
            wni_lon: -76.3355,
            wni_tz: 'America/New_York',
        },
        {
            option: 'HRA',
            wni_port_name: 'HIRAO',
            wni_unlocode: 'JPHRA',
            wni_country: 'JP',
            wni_lat: 33.9006,
            wni_lon: 132.0566,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HRD',
            wni_port_name: 'HOLYROOD',
            wni_unlocode: 'CAHOD',
            wni_country: 'CA',
            wni_lat: 47.4028,
            wni_lon: -53.135,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'HRE',
            wni_port_name: 'HEREKE',
            wni_unlocode: 'TRHER',
            wni_country: 'TR',
            wni_lat: 40.7727,
            wni_lon: 29.6142,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'HRK',
            wni_port_name: 'HERAKLION',
            wni_unlocode: 'GRHEC',
            wni_country: 'GR',
            wni_lat: 35.3603,
            wni_lon: 25.1556,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'HSC',
            wni_port_name: 'HUASCO',
            wni_unlocode: 'CLHSO',
            wni_country: 'CL',
            wni_lat: -28.461,
            wni_lon: -71.2414,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'HSP',
            wni_port_name: 'HAVRE ST. PIERRE',
            wni_unlocode: 'CAHSP',
            wni_country: 'CA',
            wni_lat: 50.1766,
            wni_lon: -63.5858,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'HTGS',
            wni_port_name: 'HASTINGS',
            wni_unlocode: 'AUHAS',
            wni_country: 'AU',
            wni_lat: -38.3072,
            wni_lon: 145.2424,
            wni_tz: 'Australia/Melbourne',
        },
        {
            option: 'HTK',
            wni_port_name: 'HATSUKAICHI',
            wni_unlocode: 'JPHAT',
            wni_country: 'JP',
            wni_lat: 34.3282,
            wni_lon: 132.3385,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HTNK',
            wni_port_name: 'HITACHINAKA',
            wni_unlocode: 'JPHCN',
            wni_country: 'JP',
            wni_lat: 36.4244,
            wni_lon: 140.6466,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HUA',
            wni_port_name: 'HUALIEN',
            wni_unlocode: 'TWHUN',
            wni_country: 'TW',
            wni_lat: 23.9659,
            wni_lon: 121.636,
            wni_tz: 'Asia/Taipei',
        },
        {
            option: 'HUI',
            wni_port_name: 'HUIZHOU',
            wni_unlocode: 'CNHUI',
            wni_country: 'CN',
            wni_lat: 22.6618,
            wni_lon: 114.6653,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'HUL',
            wni_port_name: 'HULL',
            wni_unlocode: 'GBHUL',
            wni_country: 'GB',
            wni_lat: 53.7247,
            wni_lon: -0.2756,
            wni_tz: 'Europe/London',
        },
        {
            option: 'HUS',
            wni_port_name: 'HUSNES',
            wni_unlocode: 'NOHUS',
            wni_country: 'NO',
            wni_lat: 59.882,
            wni_lon: 5.7535,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'HUT',
            wni_port_name: 'HUNTERSTON',
            wni_unlocode: 'GBHST',
            wni_country: 'GB',
            wni_lat: 55.6977,
            wni_lon: -4.9321,
            wni_tz: 'Europe/London',
        },
        {
            option: 'HUU',
            wni_port_name: 'HUANGHUA\t HEBEI',
            wni_unlocode: 'CNHHA',
            wni_country: 'CN',
            wni_lat: 38.3293,
            wni_lon: 117.8899,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'HVA',
            wni_port_name: 'HUELVA',
            wni_unlocode: 'ESHUV',
            wni_country: 'ES',
            wni_lat: 37.0967,
            wni_lon: -6.8272,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'HYD',
            wni_port_name: 'HYDABURG',
            wni_unlocode: 'USHYG',
            wni_country: 'US',
            wni_lat: 55.197,
            wni_lon: -132.8249,
            wni_tz: 'America/Juneau',
        },
        {
            option: 'IBZ',
            wni_port_name: 'IBIZA',
            wni_unlocode: 'ESIBZ',
            wni_country: 'ES',
            wni_lat: 38.8929,
            wni_lon: 1.4539,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'ICD',
            wni_port_name: 'ICDAS',
            wni_unlocode: 'TRIDS',
            wni_country: 'TR',
            wni_lat: 40.4596,
            wni_lon: 27.1364,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'IDK',
            wni_port_name: 'IDKU',
            wni_unlocode: 'EGIKU',
            wni_country: 'EG',
            wni_lat: 31.3574,
            wni_lon: 30.3003,
            wni_tz: 'Africa/Cairo',
        },
        {
            option: 'IJM',
            wni_port_name: 'IJMUIDEN',
            wni_unlocode: 'NLIJM',
            wni_country: 'NL',
            wni_lat: 52.4692,
            wni_lon: 4.5238,
            wni_tz: 'Europe/Amsterdam',
        },
        {
            option: 'ILC',
            wni_port_name: 'CHORNOMORSK',
            wni_unlocode: 'UAILK',
            wni_country: 'UA',
            wni_lat: 46.3142,
            wni_lon: 30.6872,
            wni_tz: 'Europe/Kiev',
        },
        {
            option: 'ILH',
            wni_port_name: 'ILHEUS',
            wni_unlocode: 'BRIOS',
            wni_country: 'BR',
            wni_lat: -14.7696,
            wni_lon: -39.0198,
            wni_tz: 'America/Bahia',
        },
        {
            option: 'ILI',
            wni_port_name: 'ILIGAN',
            wni_unlocode: 'PHIGN',
            wni_country: 'PH',
            wni_lat: 8.2354,
            wni_lon: 124.2263,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'ILO',
            wni_port_name: 'ILOILO',
            wni_unlocode: 'PHCRT',
            wni_country: 'PH',
            wni_lat: 10.6869,
            wni_lon: 122.5914,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'ILOP',
            wni_port_name: 'ILO',
            wni_unlocode: 'PEILQ',
            wni_country: 'PE',
            wni_lat: -17.6434,
            wni_lon: -71.3625,
            wni_tz: 'America/Lima',
        },
        {
            option: 'IMA',
            wni_port_name: 'IMABARI',
            wni_unlocode: 'JPIMB',
            wni_country: 'JP',
            wni_lat: 34.0601,
            wni_lon: 133.0371,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'IMB',
            wni_port_name: 'IMBITUBA',
            wni_unlocode: 'BRIBB',
            wni_country: 'BR',
            wni_lat: -28.2188,
            wni_lon: -48.6432,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'IMM',
            wni_port_name: 'IMMINGHAM',
            wni_unlocode: 'GBIMM',
            wni_country: 'GB',
            wni_lat: 53.6397,
            wni_lon: -0.1588,
            wni_tz: 'Europe/London',
        },
        {
            option: 'IMR',
            wni_port_name: 'IMARI',
            wni_unlocode: 'JPIMI',
            wni_country: 'JP',
            wni_lat: 33.3345,
            wni_lon: 129.8144,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'INC',
            wni_port_name: 'INCHEON',
            wni_unlocode: 'KRICH',
            wni_country: 'KR',
            wni_lat: 37.423,
            wni_lon: 126.5949,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'INK',
            wni_port_name: 'INKOO',
            wni_unlocode: 'FIINK',
            wni_country: 'FI',
            wni_lat: 59.9611,
            wni_lon: 24.0603,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'INSHK',
            wni_port_name: 'INNOSHIMA',
            wni_unlocode: 'JPINS',
            wni_country: 'JP',
            wni_lat: 34.2682,
            wni_lon: 133.1923,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'IQC',
            wni_port_name: 'IQUIQUE',
            wni_unlocode: 'CLIQQ',
            wni_country: 'CL',
            wni_lat: -20.1945,
            wni_lon: -70.1667,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'IRA',
            wni_port_name: 'IRAGO SUIDO',
            wni_unlocode: 'JPIRK',
            wni_country: 'JP',
            wni_lat: 34.4167,
            wni_lon: 137.0599,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'ISAL',
            wni_port_name: 'ISABEL',
            wni_unlocode: 'PHISL',
            wni_country: 'PH',
            wni_lat: 10.8986,
            wni_lon: 124.4213,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'ISE',
            wni_port_name: 'ISEWAN',
            wni_unlocode: 'JPISE',
            wni_country: 'JP',
            wni_lat: 34.9333,
            wni_lon: 136.725,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'ISH',
            wni_port_name: 'ISHINOMAKI',
            wni_unlocode: 'JPISM',
            wni_country: 'JP',
            wni_lat: 38.3617,
            wni_lon: 141.2633,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'ISHI',
            wni_port_name: 'ISHIGAKI',
            wni_unlocode: 'JPISG',
            wni_country: 'JP',
            wni_lat: 24.3318,
            wni_lon: 124.1273,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'ISIS',
            wni_port_name: 'ISIS TERMINAL',
            wni_unlocode: 'TNISI',
            wni_country: 'TN',
            wni_lat: 34.5666,
            wni_lon: 12.5166,
            wni_tz: 'Africa/Tunis',
        },
        {
            option: 'ISK',
            wni_port_name: 'ISKENDERUN\t HATAY',
            wni_unlocode: 'TRISK',
            wni_country: 'TR',
            wni_lat: 36.6105,
            wni_lon: 36.1793,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'ISKH',
            wni_port_name: 'ISHIKARI BAY',
            wni_unlocode: 'JPICW',
            wni_country: 'JP',
            wni_lat: 43.23,
            wni_lon: 141.2824,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'IST',
            wni_port_name: 'ISTANBUL',
            wni_unlocode: 'TRIST',
            wni_country: 'TR',
            wni_lat: 40.9888,
            wni_lon: 28.9886,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'ITA',
            wni_port_name: 'ITAGUAI',
            wni_unlocode: 'BRIGI',
            wni_country: 'BR',
            wni_lat: -22.9456,
            wni_lon: -43.8393,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'ITC',
            wni_port_name: 'ITACOATIARA',
            wni_unlocode: 'BRITA',
            wni_country: 'BR',
            wni_lat: -3.1551,
            wni_lon: -58.4517,
            wni_tz: 'America/Manaus',
        },
        {
            option: 'ITJ',
            wni_port_name: 'ITAJAI',
            wni_unlocode: 'BRITJ',
            wni_country: 'BR',
            wni_lat: -26.9159,
            wni_lon: -48.6264,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'ITPOA',
            wni_port_name: 'ITAPOA',
            wni_unlocode: 'BRIOA',
            wni_country: 'BR',
            wni_lat: -26.188,
            wni_lon: -48.5939,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'ITQU',
            wni_port_name: 'ITAQUI',
            wni_unlocode: 'BRIQI',
            wni_country: 'BR',
            wni_lat: -2.5645,
            wni_lon: -44.3883,
            wni_tz: 'America/Fortaleza',
        },
        {
            option: 'ITZ',
            wni_port_name: 'ONOMICHI ITOZAKI',
            wni_unlocode: 'JPITO',
            wni_country: 'JP',
            wni_lat: 34.3996,
            wni_lon: 133.1908,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'IWA',
            wni_port_name: 'IWAKUNI',
            wni_unlocode: 'JPIWK',
            wni_country: 'JP',
            wni_lat: 34.1853,
            wni_lon: 132.2551,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'IZD',
            wni_port_name: 'ISDEMIR',
            wni_unlocode: 'TRIDM',
            wni_country: 'TR',
            wni_lat: 36.7242,
            wni_lon: 36.1723,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'IZHR',
            wni_port_name: 'IZUHARA',
            wni_unlocode: 'JPIZH',
            wni_country: 'JP',
            wni_lat: 34.1878,
            wni_lon: 129.3097,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'IZM',
            wni_port_name: 'IZMIR',
            wni_unlocode: 'TRIZM',
            wni_country: 'TR',
            wni_lat: 38.4464,
            wni_lon: 27.1361,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'IZT',
            wni_port_name: 'IZMIT',
            wni_unlocode: 'TRIZT',
            wni_country: 'TR',
            wni_lat: 40.7501,
            wni_lon: 29.9181,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'JAB',
            wni_port_name: 'JABIRU',
            wni_unlocode: 'AUJAB',
            wni_country: 'AU',
            wni_lat: -11.9167,
            wni_lon: 125,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'JAM',
            wni_port_name: 'JAMNAGAR',
            wni_unlocode: 'INJGA',
            wni_country: 'IN',
            wni_lat: 22.5038,
            wni_lon: 69.7874,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'JAX',
            wni_port_name: 'JACKSONVILLE',
            wni_unlocode: 'USJAX',
            wni_country: 'US',
            wni_lat: 30.3195,
            wni_lon: -81.6497,
            wni_tz: 'America/New_York',
        },
        {
            option: 'JBA',
            wni_port_name: 'JEBEL ALI',
            wni_unlocode: 'AEJEA',
            wni_country: 'AE',
            wni_lat: 25.0447,
            wni_lon: 54.9889,
            wni_tz: 'Asia/Dubai',
        },
        {
            option: 'JBD',
            wni_port_name: 'JEBEL DHANA',
            wni_unlocode: 'AEJED',
            wni_country: 'AE',
            wni_lat: 24.2236,
            wni_lon: 52.5949,
            wni_tz: 'Asia/Dubai',
        },
        {
            option: 'JED',
            wni_port_name: 'JEDDAH',
            wni_unlocode: 'SAJED',
            wni_country: 'SA',
            wni_lat: 21.4425,
            wni_lon: 39.1468,
            wni_tz: 'Asia/Riyadh',
        },
        {
            option: 'JGRH',
            wni_port_name: 'JAIGARH',
            wni_unlocode: 'INJGD',
            wni_country: 'IN',
            wni_lat: 17.3119,
            wni_lon: 73.18,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'JHR',
            wni_port_name: 'JOHORE BAHRU',
            wni_unlocode: 'MYJHB',
            wni_country: 'MY',
            wni_lat: 1.4468,
            wni_lon: 103.7564,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'JIA',
            wni_port_name: 'JIANGYIN',
            wni_unlocode: 'CNJGY',
            wni_country: 'CN',
            wni_lat: 31.9314,
            wni_lon: 120.2186,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'JIE',
            wni_port_name: 'JIEH',
            wni_unlocode: 'LBJIE',
            wni_country: 'LB',
            wni_lat: 33.6625,
            wni_lon: 35.3989,
            wni_tz: 'Asia/Beirut',
        },
        {
            option: 'JIM',
            wni_port_name: 'JIMENEZ',
            wni_unlocode: 'PHJNZ',
            wni_country: 'PH',
            wni_lat: 8.3167,
            wni_lon: 123.8692,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'JING',
            wni_port_name: 'JINGTANG',
            wni_unlocode: 'CNJIN',
            wni_country: 'CN',
            wni_lat: 39.1807,
            wni_lon: 119.0313,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'JINZ',
            wni_port_name: 'JINZHOU',
            wni_unlocode: 'CNJNH',
            wni_country: 'CN',
            wni_lat: 40.7881,
            wni_lon: 121.0864,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'JJ',
            wni_port_name: 'CHEJU (JEJU)',
            wni_unlocode: 'KRCHA',
            wni_country: 'KR',
            wni_lat: 33.5363,
            wni_lon: 126.5288,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'JKA',
            wni_port_name: 'JAKHAU',
            wni_unlocode: 'INJAK',
            wni_country: 'IN',
            wni_lat: 23.2332,
            wni_lon: 68.5744,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'JOHOR',
            wni_port_name: 'JOHOR',
            wni_unlocode: 'MYBNT',
            wni_country: 'MY',
            wni_lat: 1.4335,
            wni_lon: 103.8849,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'JOR',
            wni_port_name: 'JORF LASFAR',
            wni_unlocode: 'MAJFL',
            wni_country: 'MA',
            wni_lat: 33.1155,
            wni_lon: -8.6521,
            wni_tz: 'Africa/Casablanca',
        },
        {
            option: 'JRG',
            wni_port_name: 'JORONG ANCHORAGE',
            wni_unlocode: 'IDJOR',
            wni_country: 'ID',
            wni_lat: -4.1833,
            wni_lon: 115.1,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'JTE',
            wni_port_name: 'JOSE TERMINAL',
            wni_unlocode: 'VEJOT',
            wni_country: 'VE',
            wni_lat: 10.1139,
            wni_lon: -64.8792,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'KAA',
            wni_port_name: 'KARWAR',
            wni_unlocode: 'INKRW',
            wni_country: 'IN',
            wni_lat: 14.8169,
            wni_lon: 74.0883,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'KAB',
            wni_port_name: 'KARUMBA',
            wni_unlocode: 'AUKRB',
            wni_country: 'AU',
            wni_lat: -17.463,
            wni_lon: 140.8133,
            wni_tz: 'Australia/Brisbane',
        },
        {
            option: 'KABI',
            wni_port_name: 'KABIL',
            wni_unlocode: 'IDKAB',
            wni_country: 'ID',
            wni_lat: 1.0789,
            wni_lon: 104.1462,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'KAD',
            wni_port_name: 'DEENDAYAL',
            wni_unlocode: 'INIXY',
            wni_country: 'IN',
            wni_lat: 22.9663,
            wni_lon: 70.2356,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'KAF',
            wni_port_name: 'KHAWR FAKKAN',
            wni_unlocode: 'AEKLF',
            wni_country: 'AE',
            wni_lat: 25.3624,
            wni_lon: 56.3736,
            wni_tz: 'Asia/Dubai',
        },
        {
            option: 'KAG',
            wni_port_name: 'KAGOSHIMA',
            wni_unlocode: 'JPFMT',
            wni_country: 'JP',
            wni_lat: 31.579,
            wni_lon: 130.5801,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KAI',
            wni_port_name: 'KAKINADA',
            wni_unlocode: 'INKAK',
            wni_country: 'IN',
            wni_lat: 16.9973,
            wni_lon: 82.3085,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'KAL',
            wni_port_name: 'KALAMA',
            wni_unlocode: 'USKAL',
            wni_country: 'US',
            wni_lat: 46.0245,
            wni_lon: -122.872,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'KALB',
            wni_port_name: 'KALBUT SITUBONDO',
            wni_unlocode: 'IDKSO',
            wni_country: 'ID',
            wni_lat: -7.6166,
            wni_lon: 113.9166,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'KAM',
            wni_port_name: 'KAMAISHI',
            wni_unlocode: 'JPKIS',
            wni_country: 'JP',
            wni_lat: 39.2604,
            wni_lon: 141.9412,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KANE',
            wni_port_name: 'KANMON',
            wni_unlocode: 'JPKNM',
            wni_country: 'JP',
            wni_lat: 33.9973,
            wni_lon: 130.8841,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KAO',
            wni_port_name: 'KAOHSIUNG',
            wni_unlocode: 'TWKHH',
            wni_country: 'TW',
            wni_lat: 22.6214,
            wni_lon: 120.2473,
            wni_tz: 'Asia/Taipei',
        },
        {
            option: 'KAR',
            wni_port_name: 'KARACHI',
            wni_unlocode: 'PKKHI',
            wni_country: 'PK',
            wni_lat: 24.7802,
            wni_lon: 66.9891,
            wni_tz: 'Asia/Karachi',
        },
        {
            option: 'KAS',
            wni_port_name: 'KASHIMA',
            wni_unlocode: 'JPKSC',
            wni_country: 'JP',
            wni_lat: 35.9607,
            wni_lon: 140.7233,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KASOK',
            wni_port_name: 'KASAOKA',
            wni_unlocode: 'JPKSA',
            wni_country: 'JP',
            wni_lat: 34.4972,
            wni_lon: 133.5063,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KAV',
            wni_port_name: 'KAVIENG',
            wni_unlocode: 'PGKVG',
            wni_country: 'PG',
            wni_lat: -2.5839,
            wni_lon: 150.7847,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'KAVZ',
            wni_port_name: 'KAVKAZ',
            wni_unlocode: 'RUKZP',
            wni_country: 'RU',
            wni_lat: 45.3377,
            wni_lon: 36.6419,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'KAW',
            wni_port_name: 'KAWASAKI/HIGASHIOGISHIMA',
            wni_unlocode: 'JPHIO',
            wni_country: 'JP',
            wni_lat: 35.4901,
            wni_lon: 139.7947,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KAY',
            wni_port_name: 'KHOR AL AMAYA TERMINAL',
            wni_unlocode: 'IQKHA',
            wni_country: 'IQ',
            wni_lat: 29.7854,
            wni_lon: 48.8171,
            wni_tz: 'Asia/Baghdad',
        },
        {
            option: 'KBE',
            wni_port_name: 'KIMBE',
            wni_unlocode: 'PGKIM',
            wni_country: 'PG',
            wni_lat: -5.5422,
            wni_lon: 150.1525,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'KCH',
            wni_port_name: 'KERCH',
            wni_unlocode: 'UAKEH',
            wni_country: 'UA',
            wni_lat: 45.344,
            wni_lon: 36.4887,
            wni_tz: 'Europe/Kiev',
        },
        {
            option: 'KDA',
            wni_port_name: 'KANDA',
            wni_unlocode: 'JPKND',
            wni_country: 'JP',
            wni_lat: 33.8366,
            wni_lon: 131.0503,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KDO',
            wni_port_name: 'KASADO',
            wni_unlocode: 'JPKSD',
            wni_country: 'JP',
            wni_lat: 33.9616,
            wni_lon: 131.8405,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KDRNG',
            wni_port_name: 'TANJONG KIDURONG',
            wni_unlocode: 'MYTKI',
            wni_country: 'MY',
            wni_lat: 3.2522,
            wni_lon: 113.0356,
            wni_tz: 'Asia/Kuching',
        },
        {
            option: 'KEE',
            wni_port_name: 'KEELUNG',
            wni_unlocode: 'TWKEL',
            wni_country: 'TW',
            wni_lat: 25.1665,
            wni_lon: 121.749,
            wni_tz: 'Asia/Taipei',
        },
        {
            option: 'KEMEN',
            wni_port_name: 'KEMEN',
            wni_unlocode: 'CNKEM',
            wni_country: 'CN',
            wni_lat: 26.3875,
            wni_lon: 119.7569,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'KEN',
            wni_port_name: 'KENAI',
            wni_unlocode: 'USENA',
            wni_country: 'US',
            wni_lat: 60.5421,
            wni_lon: -151.2819,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'KEND',
            wni_port_name: 'KENDAWAGAN',
            wni_unlocode: 'IDKDW',
            wni_country: 'ID',
            wni_lat: -2.5232,
            wni_lon: 110.1873,
            wni_tz: 'Asia/Pontianak',
        },
        {
            option: 'KER',
            wni_port_name: 'KERTEH',
            wni_unlocode: 'MYKTE',
            wni_country: 'MY',
            wni_lat: 4.5917,
            wni_lon: 103.4633,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'KET',
            wni_port_name: 'KETCHIKAN',
            wni_unlocode: 'USKTN',
            wni_country: 'US',
            wni_lat: 55.3408,
            wni_lon: -131.6624,
            wni_tz: 'America/Juneau',
        },
        {
            option: 'KGSQ',
            wni_port_name: 'KANGERLUSSUAQ',
            wni_unlocode: 'GLKAN',
            wni_country: 'GL',
            wni_lat: 66.9602,
            wni_lon: -50.9594,
            wni_tz: 'AMERICA/Godthab',
        },
        {
            option: 'KGT',
            wni_port_name: 'KINGSTON',
            wni_unlocode: 'JMKIN',
            wni_country: 'JM',
            wni_lat: 17.9639,
            wni_lon: -76.8295,
            wni_tz: 'America/Jamaica',
        },
        {
            option: 'KHA',
            wni_port_name: 'KHARG ISLAND (KHARK ISLAND)',
            wni_unlocode: 'IRKHK',
            wni_country: 'IR',
            wni_lat: 29.2122,
            wni_lon: 50.3463,
            wni_tz: 'Asia/Tehran',
        },
        {
            option: 'KHK',
            wni_port_name: 'KUSHIKINO',
            wni_unlocode: 'JPICO',
            wni_country: 'JP',
            wni_lat: 31.7031,
            wni_lon: 130.2448,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KHM',
            wni_port_name: 'KHANOM',
            wni_unlocode: 'THKHA',
            wni_country: 'TH',
            wni_lat: 9.2092,
            wni_lon: 99.8924,
            wni_tz: 'Asia/Bangkok',
        },
        {
            option: 'KHMBT',
            wni_port_name: 'KHAMBAT',
            wni_unlocode: 'INKBT',
            wni_country: 'IN',
            wni_lat: 22.2767,
            wni_lon: 72.6052,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'KHO',
            wni_port_name: 'KHOLMSK',
            wni_unlocode: 'RUKHO',
            wni_country: 'RU',
            wni_lat: 47.0517,
            wni_lon: 142.0282,
            wni_tz: 'Asia/Sakhalin',
        },
        {
            option: 'KHRBH',
            wni_port_name: 'AL KHURAIBAH',
            wni_unlocode: 'SAAKB',
            wni_country: 'SA',
            wni_lat: 28.0474,
            wni_lon: 35.17,
            wni_tz: 'Asia/Riyadh',
        },
        {
            option: 'KHS',
            wni_port_name: 'KHORRAMSHAHR',
            wni_unlocode: 'IRKHO',
            wni_country: 'IR',
            wni_lat: 30.4292,
            wni_lon: 48.1694,
            wni_tz: 'Asia/Tehran',
        },
        {
            option: 'KHZ',
            wni_port_name: 'KHOR AL ZUBAIR',
            wni_unlocode: 'IQKAZ',
            wni_country: 'IQ',
            wni_lat: 30.1969,
            wni_lon: 47.885,
            wni_tz: 'Asia/Baghdad',
        },
        {
            option: 'KIJ',
            wni_port_name: 'KIJANG',
            wni_unlocode: 'IDKIJ',
            wni_country: 'ID',
            wni_lat: 0.8656,
            wni_lon: 104.6152,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'KIL',
            wni_port_name: 'KIEL',
            wni_unlocode: 'DEKEL',
            wni_country: 'DE',
            wni_lat: 54.3442,
            wni_lon: 10.1631,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'KIN',
            wni_port_name: 'KINUURA',
            wni_unlocode: 'JPKNU',
            wni_country: 'JP',
            wni_lat: 34.8113,
            wni_lon: 136.9488,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KINO',
            wni_port_name: 'KINWAN',
            wni_unlocode: 'JPKIN',
            wni_country: 'JP',
            wni_lat: 26.4161,
            wni_lon: 127.8579,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KINOE',
            wni_port_name: 'KINOE TERMINAL',
            wni_unlocode: 'JPKNE',
            wni_country: 'JP',
            wni_lat: 34.2059,
            wni_lon: 132.841,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KIR',
            wni_port_name: 'KIIRE',
            wni_unlocode: 'JPKII',
            wni_country: 'JP',
            wni_lat: 31.3964,
            wni_lon: 130.5681,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KIRK',
            wni_port_name: 'KIRKENES',
            wni_unlocode: 'NOKKN',
            wni_country: 'NO',
            wni_lat: 69.7331,
            wni_lon: 30.0409,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'KIT',
            wni_port_name: 'KITIMAT',
            wni_unlocode: 'CAKTM',
            wni_country: 'CA',
            wni_lat: 53.9783,
            wni_lon: -128.6848,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'KKA',
            wni_port_name: 'KANOKAWA',
            wni_unlocode: 'JPKKW',
            wni_country: 'JP',
            wni_lat: 34.1645,
            wni_lon: 132.4323,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KKAL',
            wni_port_name: 'KARAIKAL',
            wni_unlocode: 'INKRK',
            wni_country: 'IN',
            wni_lat: 10.9118,
            wni_lon: 79.8633,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'KKB',
            wni_port_name: 'KOTA KINABALU',
            wni_unlocode: 'MYBKI',
            wni_country: 'MY',
            wni_lat: 6.0044,
            wni_lon: 116.076,
            wni_tz: 'Asia/Kuching',
        },
        {
            option: 'KKU',
            wni_port_name: 'KIKUMA',
            wni_unlocode: 'JPKIK',
            wni_country: 'JP',
            wni_lat: 34.0613,
            wni_lon: 132.8501,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KKY',
            wni_port_name: 'KITAKYUSHU',
            wni_unlocode: 'JPKKJ',
            wni_country: 'JP',
            wni_lat: 33.9399,
            wni_lon: 130.9378,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KLAN',
            wni_port_name: 'KOOLAN',
            wni_unlocode: 'AUKOI',
            wni_country: 'AU',
            wni_lat: -16.149,
            wni_lon: 123.748,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'KLG',
            wni_port_name: 'PORT KLANG',
            wni_unlocode: 'MYPKG',
            wni_country: 'MY',
            wni_lat: 3.0344,
            wni_lon: 101.3471,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'KLJK',
            wni_port_name: 'KALAJOKI',
            wni_unlocode: 'FIKJO',
            wni_country: 'FI',
            wni_lat: 64.233,
            wni_lon: 23.7207,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'KLM',
            wni_port_name: 'KALI LIMENES',
            wni_unlocode: 'GRKLL',
            wni_country: 'GR',
            wni_lat: 34.9183,
            wni_lon: 24.8081,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'KLP',
            wni_port_name: 'KLAIPEDA',
            wni_unlocode: 'LTKLJ',
            wni_country: 'LT',
            wni_lat: 55.7243,
            wni_lon: 21.0631,
            wni_tz: 'Europe/Vilnius',
        },
        {
            option: 'KLR',
            wni_port_name: 'KALININGRAD',
            wni_unlocode: 'RUKGD',
            wni_country: 'RU',
            wni_lat: 54.706,
            wni_lon: 20.4976,
            wni_tz: 'Europe/Kaliningrad',
        },
        {
            option: 'KLW',
            wni_port_name: 'KLAWOCK',
            wni_unlocode: 'USKLW',
            wni_country: 'US',
            wni_lat: 55.5375,
            wni_lon: -133.1208,
            wni_tz: 'America/Sitka',
        },
        {
            option: 'KMM',
            wni_port_name: 'KEMAMAN',
            wni_unlocode: 'MYKEM',
            wni_country: 'MY',
            wni_lat: 4.2382,
            wni_lon: 103.477,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'KMN',
            wni_port_name: 'KARIMUN',
            wni_unlocode: 'IDOKA',
            wni_country: 'ID',
            wni_lat: 0.9787,
            wni_lon: 103.416,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'KMNTS',
            wni_port_name: 'KOMENOTSU',
            wni_unlocode: 'JPKKO',
            wni_country: 'JP',
            wni_lat: 32.1409,
            wni_lon: 130.3296,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KMS',
            wni_port_name: 'PORT KAMSAR',
            wni_unlocode: 'GNKMR',
            wni_country: 'GN',
            wni_lat: 10.6387,
            wni_lon: -14.6393,
            wni_tz: 'Africa/Conakry',
        },
        {
            option: 'KMY',
            wni_port_name: 'KARMOY',
            wni_unlocode: 'NOKMY',
            wni_country: 'NO',
            wni_lat: 59.2847,
            wni_lon: 5.3293,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'KNA',
            wni_port_name: 'KANAZAWA',
            wni_unlocode: 'JPKNZ',
            wni_country: 'JP',
            wni_lat: 36.6449,
            wni_lon: 136.5906,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KNE',
            wni_port_name: 'KASKINEN',
            wni_unlocode: 'FIKAS',
            wni_country: 'FI',
            wni_lat: 62.3435,
            wni_lon: 21.2092,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'KNN',
            wni_port_name: 'KAINAN',
            wni_unlocode: 'JPKAI',
            wni_country: 'JP',
            wni_lat: 34.1447,
            wni_lon: 135.1727,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KOA',
            wni_port_name: 'KOUAOUA',
            wni_unlocode: 'NCKOU',
            wni_country: 'NC',
            wni_lat: -21.395,
            wni_lon: 165.8365,
            wni_tz: 'Pacific/Noumea',
        },
        {
            option: 'KOB',
            wni_port_name: 'KOBE',
            wni_unlocode: 'JPUKB',
            wni_country: 'JP',
            wni_lat: 34.6433,
            wni_lon: 135.2667,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KOC',
            wni_port_name: 'KOCHI',
            wni_unlocode: 'JPKCZ',
            wni_country: 'JP',
            wni_lat: 33.4916,
            wni_lon: 133.5997,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KOH',
            wni_port_name: 'KOH SICHANG',
            wni_unlocode: 'THKSI',
            wni_country: 'TH',
            wni_lat: 13.1333,
            wni_lon: 100.8333,
            wni_tz: 'Asia/Bangkok',
        },
        {
            option: 'KOK',
            wni_port_name: 'KOTKA',
            wni_unlocode: 'FIKTK',
            wni_country: 'FI',
            wni_lat: 60.4425,
            wni_lon: 26.9677,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'KOKL',
            wni_port_name: 'KOKKOLA',
            wni_unlocode: 'FIKOK',
            wni_country: 'FI',
            wni_lat: 63.8441,
            wni_lon: 23.008,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'KOLO',
            wni_port_name: 'KOLONODALE',
            wni_unlocode: 'IDKNL',
            wni_country: 'ID',
            wni_lat: -1.9796,
            wni_lon: 121.3501,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'KOM',
            wni_port_name: 'KOMATSU JIMA',
            wni_unlocode: 'JPKOM',
            wni_country: 'JP',
            wni_lat: 34.0075,
            wni_lon: 134.6152,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KOO',
            wni_port_name: 'KORSOR',
            wni_unlocode: 'DKKRR',
            wni_country: 'DK',
            wni_lat: 55.3256,
            wni_lon: 11.0969,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'KOP',
            wni_port_name: 'KOPER',
            wni_unlocode: 'SIKOP',
            wni_country: 'SI',
            wni_lat: 45.5576,
            wni_lon: 13.7181,
            wni_tz: 'Europe/Ljubljana',
        },
        {
            option: 'KOTOR',
            wni_port_name: 'KOTOR',
            wni_unlocode: 'MEKOT',
            wni_country: 'ME',
            wni_lat: 42.4338,
            wni_lon: 18.7607,
            wni_tz: 'Europe/Podgorica',
        },
        {
            option: 'KPE',
            wni_port_name: 'KPEME',
            wni_unlocode: 'TGKPE',
            wni_country: 'TG',
            wni_lat: 6.187,
            wni_lon: 1.5185,
            wni_tz: 'Africa/Lome',
        },
        {
            option: 'KRB',
            wni_port_name: 'KRABI',
            wni_unlocode: 'THKBV',
            wni_country: 'TH',
            wni_lat: 8.0593,
            wni_lon: 98.7296,
            wni_tz: 'Asia/Bangkok',
        },
        {
            option: 'KRBI',
            wni_port_name: 'KARABIGA',
            wni_unlocode: 'TRKRB',
            wni_country: 'TR',
            wni_lat: 40.396,
            wni_lon: 27.3189,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'KRC',
            wni_port_name: 'KOME KRIBI',
            wni_unlocode: 'CMKBI',
            wni_country: 'CM',
            wni_lat: 2.9413,
            wni_lon: 9.8952,
            wni_tz: 'Africa/Douala',
        },
        {
            option: 'KRL',
            wni_port_name: 'KARLSHAMN',
            wni_unlocode: 'SEKAN',
            wni_country: 'SE',
            wni_lat: 56.1333,
            wni_lon: 14.8728,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'KRP',
            wni_port_name: 'KRISHNAPATNAM',
            wni_unlocode: 'INKRI',
            wni_country: 'IN',
            wni_lat: 14.2423,
            wni_lon: 80.15,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'KRTS',
            wni_port_name: 'KARATSU',
            wni_unlocode: 'JPKAR',
            wni_country: 'JP',
            wni_lat: 33.4867,
            wni_lon: 129.9544,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KSV',
            wni_port_name: 'KORSAKOV (OTOMORI)',
            wni_unlocode: 'RUKOR',
            wni_country: 'RU',
            wni_lat: 46.6222,
            wni_lon: 142.7529,
            wni_tz: 'Asia/Sakhalin',
        },
        {
            option: 'KSZ',
            wni_port_name: 'KISARAZU',
            wni_unlocode: 'JPKZU',
            wni_country: 'JP',
            wni_lat: 35.3868,
            wni_lon: 139.8853,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KTB',
            wni_port_name: 'KOTA BARU',
            wni_unlocode: 'IDKBU',
            wni_country: 'ID',
            wni_lat: -3.2312,
            wni_lon: 116.2151,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'KTD',
            wni_port_name: 'KRISTIANSUND',
            wni_unlocode: 'NOKSU',
            wni_country: 'NO',
            wni_lat: 63.0963,
            wni_lon: 7.7544,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'KTJ',
            wni_port_name: 'KUALA TANJUNG',
            wni_unlocode: 'IDKTJ',
            wni_country: 'ID',
            wni_lat: 3.3849,
            wni_lon: 99.4706,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'KTK',
            wni_port_name: 'KATAKOLON',
            wni_unlocode: 'GRKAK',
            wni_country: 'GR',
            wni_lat: 37.6129,
            wni_lon: 21.3186,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'KTL',
            wni_port_name: 'KOLE TERMINAL',
            wni_unlocode: 'CMKOL',
            wni_country: 'CM',
            wni_lat: 4.2158,
            wni_lon: 8.5657,
            wni_tz: 'Africa/Douala',
        },
        {
            option: 'KTN',
            wni_port_name: 'KINGSTOWN',
            wni_unlocode: 'VCKTN',
            wni_country: 'VC',
            wni_lat: 13.1457,
            wni_lon: -61.2347,
            wni_tz: 'America/St_Vincent',
        },
        {
            option: 'KTO',
            wni_port_name: 'KAARSTO',
            wni_unlocode: 'NOKAR',
            wni_country: 'NO',
            wni_lat: 59.2615,
            wni_lon: 5.5037,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'KUA',
            wni_port_name: 'KUANTAN',
            wni_unlocode: 'MYKUA',
            wni_country: 'MY',
            wni_lat: 3.7878,
            wni_lon: 103.3784,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'KUC',
            wni_port_name: 'KUCHING',
            wni_unlocode: 'MYKCH',
            wni_country: 'MY',
            wni_lat: 1.5592,
            wni_lon: 110.3551,
            wni_tz: 'Asia/Kuching',
        },
        {
            option: 'KUD',
            wni_port_name: 'TOKUYAMA KUDAMATSU',
            wni_unlocode: 'JPKUD',
            wni_country: 'JP',
            wni_lat: 34.018,
            wni_lon: 131.7819,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KUI',
            wni_port_name: 'KUITO TERMINAL',
            wni_unlocode: 'AOKOT',
            wni_country: 'AO',
            wni_lat: -5.9667,
            wni_lon: 11.5,
            wni_tz: 'Africa/Luanda',
        },
        {
            option: 'KULV',
            wni_port_name: 'KULEVI',
            wni_unlocode: 'GEKUL',
            wni_country: 'GE',
            wni_lat: 42.2742,
            wni_lon: 41.62,
            wni_tz: 'Asia/Tbilisi',
        },
        {
            option: 'KUM',
            wni_port_name: 'KUMUL MARINE TERMINAL',
            wni_unlocode: 'PGKUL',
            wni_country: 'PG',
            wni_lat: -8.1,
            wni_lon: 144.5667,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'KUMI',
            wni_port_name: 'KUMAI',
            wni_unlocode: 'IDKUM',
            wni_country: 'ID',
            wni_lat: -2.7413,
            wni_lon: 111.731,
            wni_tz: 'Asia/Pontianak',
        },
        {
            option: 'KUN',
            wni_port_name: 'KUNSAN (GUNSAN)',
            wni_unlocode: 'KRKUV',
            wni_country: 'KR',
            wni_lat: 35.9806,
            wni_lon: 126.5441,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'KUNK',
            wni_port_name: 'KUNAK',
            wni_unlocode: 'MYKUN',
            wni_country: 'MY',
            wni_lat: 4.6995,
            wni_lon: 118.2574,
            wni_tz: 'Asia/Kuching',
        },
        {
            option: 'KUR',
            wni_port_name: 'KURE',
            wni_unlocode: 'JPKRE',
            wni_country: 'JP',
            wni_lat: 34.2271,
            wni_lon: 132.5194,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KUS',
            wni_port_name: 'KUSHIRO',
            wni_unlocode: 'JPKUH',
            wni_country: 'JP',
            wni_lat: 42.9832,
            wni_lon: 144.3131,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KUW',
            wni_port_name: 'KUWAIT',
            wni_unlocode: 'KWKWI',
            wni_country: 'KW',
            wni_lat: 29.3623,
            wni_lon: 47.9388,
            wni_tz: 'Asia/Kuwait',
        },
        {
            option: 'KWA',
            wni_port_name: 'MISHIMA KAWANOE',
            wni_unlocode: 'JPKWN',
            wni_country: 'JP',
            wni_lat: 34,
            wni_lon: 133.54,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KWAN',
            wni_port_name: 'GWANGYANG',
            wni_unlocode: 'KRKAN',
            wni_country: 'KR',
            wni_lat: 34.8789,
            wni_lon: 127.7886,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'KWG',
            wni_port_name: 'KAWAGOE',
            wni_unlocode: 'JPKWE',
            wni_country: 'JP',
            wni_lat: 34.9915,
            wni_lon: 136.7038,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KWI',
            wni_port_name: 'KWINANA',
            wni_unlocode: 'AUKNA',
            wni_country: 'AU',
            wni_lat: -32.2409,
            wni_lon: 115.7437,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'KWJRI',
            wni_port_name: 'KAWAJIRI',
            wni_unlocode: 'JPKWJ',
            wni_country: 'JP',
            wni_lat: 34.227,
            wni_lon: 132.7107,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KWT',
            wni_port_name: 'KUJI IWATE',
            wni_unlocode: 'JPKJI',
            wni_country: 'JP',
            wni_lat: 40.2051,
            wni_lon: 141.8137,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'LAA',
            wni_port_name: 'LAAYOUNE',
            wni_unlocode: 'MAEUN',
            wni_country: 'MA',
            wni_lat: 27.0855,
            wni_lon: -13.4509,
            wni_tz: 'Africa/El_Aaiun',
        },
        {
            option: 'LAE',
            wni_port_name: 'LAE',
            wni_unlocode: 'PGLAE',
            wni_country: 'PG',
            wni_lat: -6.7477,
            wni_lon: 147.0082,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'LAG',
            wni_port_name: 'LAGOS',
            wni_unlocode: 'NGLOS',
            wni_country: 'NG',
            wni_lat: 6.4314,
            wni_lon: 3.401,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'LAGOS',
            wni_port_name: 'PORT LAGOS',
            wni_unlocode: 'GRPTL',
            wni_country: 'GR',
            wni_lat: 40.993,
            wni_lon: 25.1208,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'LAH',
            wni_port_name: 'LAHAD DATU',
            wni_unlocode: 'MYLDU',
            wni_country: 'MY',
            wni_lat: 5.002,
            wni_lon: 118.3518,
            wni_tz: 'Asia/Kuching',
        },
        {
            option: 'LALAG',
            wni_port_name: 'LALANG',
            wni_unlocode: 'IDLAT',
            wni_country: 'ID',
            wni_lat: -2.376,
            wni_lon: 104.6357,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'LAP',
            wni_port_name: 'LA PALLICE',
            wni_unlocode: 'FRLPE',
            wni_country: 'FR',
            wni_lat: 46.143,
            wni_lon: -1.2466,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'LAS',
            wni_port_name: 'LA SPEZIA',
            wni_unlocode: 'ITSPE',
            wni_country: 'IT',
            wni_lat: 44.0633,
            wni_lon: 9.8687,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'LAT',
            wni_port_name: 'LATTAKIA',
            wni_unlocode: 'SYLTK',
            wni_country: 'SY',
            wni_lat: 35.5307,
            wni_lon: 35.7435,
            wni_tz: 'Asia/Damascus',
        },
        {
            option: 'LAU',
            wni_port_name: 'LAUTOKA',
            wni_unlocode: 'FJLTK',
            wni_country: 'FJ',
            wni_lat: -17.6046,
            wni_lon: 177.4372,
            wni_tz: 'Pacific/Fiji',
        },
        {
            option: 'LAV',
            wni_port_name: 'LAVERA',
            wni_unlocode: 'FRLAV',
            wni_country: 'FR',
            wni_lat: 43.3897,
            wni_lon: 4.9752,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'LAW',
            wni_port_name: 'LAWI LAWI OIL TERMINAL',
            wni_unlocode: 'IDLLA',
            wni_country: 'ID',
            wni_lat: -1.45,
            wni_lon: 116.75,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'LAX',
            wni_port_name: 'LOS ANGELES',
            wni_unlocode: 'USLAX',
            wni_country: 'US',
            wni_lat: 33.6984,
            wni_lon: -118.243,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'LAZ',
            wni_port_name: 'LAZARO CARDENAS',
            wni_unlocode: 'MXLZC',
            wni_country: 'MX',
            wni_lat: 17.9233,
            wni_lon: -102.1619,
            wni_tz: 'America/Mexico_City',
        },
        {
            option: 'LBE',
            wni_port_name: 'LONG BEACH',
            wni_unlocode: 'USLBC',
            wni_country: 'US',
            wni_lat: 33.7102,
            wni_lon: -118.204,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'LBN',
            wni_port_name: 'LABUAN',
            wni_unlocode: 'MYLBU',
            wni_country: 'MY',
            wni_lat: 5.2664,
            wni_lon: 115.2463,
            wni_tz: 'Asia/Kuching',
        },
        {
            option: 'LCB',
            wni_port_name: 'LAEM CHABANG',
            wni_unlocode: 'THLCH',
            wni_country: 'TH',
            wni_lat: 13.0651,
            wni_lon: 100.8625,
            wni_tz: 'Asia/Bangkok',
        },
        {
            option: 'LCH',
            wni_port_name: 'LAKE CHARLES',
            wni_unlocode: 'USLCH',
            wni_country: 'US',
            wni_lat: 30.2189,
            wni_lon: -93.2517,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'LCO',
            wni_port_name: 'LA CORUNA',
            wni_unlocode: 'ESCRN',
            wni_country: 'ES',
            wni_lat: 43.3957,
            wni_lon: -8.3795,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'LCV',
            wni_port_name: 'LA CEIBA',
            wni_unlocode: 'VELCV',
            wni_country: 'VE',
            wni_lat: 9.4637,
            wni_lon: -71.077,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'LDC',
            wni_port_name: 'CHIRIQUI GRANDE',
            wni_unlocode: 'PACHG',
            wni_country: 'PA',
            wni_lat: 8.9482,
            wni_lon: -82.1033,
            wni_tz: 'America/Panama',
        },
        {
            option: 'LDD',
            wni_port_name: 'LONDONDERRY',
            wni_unlocode: 'GBLDY',
            wni_country: 'GB',
            wni_lat: 55.0099,
            wni_lon: -7.3052,
            wni_tz: 'Europe/London',
        },
        {
            option: 'LDN',
            wni_port_name: 'LONDON',
            wni_unlocode: 'GBBKG',
            wni_country: 'GB',
            wni_lat: 51.5067,
            wni_lon: -0.1197,
            wni_tz: 'Europe/London',
        },
        {
            option: 'LDN2',
            wni_port_name: 'LONDON GATEWAY',
            wni_unlocode: 'GBLGP',
            wni_country: 'GB',
            wni_lat: 51.5,
            wni_lon: 0.5,
            wni_tz: 'Europe/London',
        },
        {
            option: 'LEG',
            wni_port_name: 'LEGASPI (LEGAZPI)',
            wni_unlocode: 'PHLGP',
            wni_country: 'PH',
            wni_lat: 13.1506,
            wni_lon: 123.7678,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'LEH',
            wni_port_name: 'LE HAVRE',
            wni_unlocode: 'FRLEH',
            wni_country: 'FR',
            wni_lat: 49.4801,
            wni_lon: 0.0785,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'LEI',
            wni_port_name: 'LEITH',
            wni_unlocode: 'GBLEI',
            wni_country: 'GB',
            wni_lat: 55.9993,
            wni_lon: -3.184,
            wni_tz: 'Europe/London',
        },
        {
            option: 'LEL',
            wni_port_name: 'LYSEKIL',
            wni_unlocode: 'SELYS',
            wni_country: 'SE',
            wni_lat: 58.2625,
            wni_lon: 11.447,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'LER',
            wni_port_name: 'LERWICK',
            wni_unlocode: 'GBLER',
            wni_country: 'GB',
            wni_lat: 60.1657,
            wni_lon: -1.1514,
            wni_tz: 'Europe/London',
        },
        {
            option: 'LEX',
            wni_port_name: 'LEIXOES (LEIXES)',
            wni_unlocode: 'PTLEI',
            wni_country: 'PT',
            wni_lat: 41.1726,
            wni_lon: -8.7172,
            wni_tz: 'Europe/Lisbon',
        },
        {
            option: 'LGK',
            wni_port_name: 'LONGKOU',
            wni_unlocode: 'CNLGK',
            wni_country: 'CN',
            wni_lat: 37.6456,
            wni_lon: 120.2859,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'LGNDR',
            wni_port_name: 'LEGENDRE TERMINAL',
            wni_unlocode: 'AULGT',
            wni_country: 'AU',
            wni_lat: -19.6833,
            wni_lon: 116.717,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'LGO',
            wni_port_name: 'LA GOULETTE (LA GOULETTE NORD)',
            wni_unlocode: 'TNLGN',
            wni_country: 'TN',
            wni_lat: 36.8032,
            wni_lon: 10.3209,
            wni_tz: 'Africa/Tunis',
        },
        {
            option: 'LGSAT',
            wni_port_name: 'TANJUNG LANGSAT',
            wni_unlocode: 'MYTLA',
            wni_country: 'MY',
            wni_lat: 1.4417,
            wni_lon: 104.0193,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'LGU',
            wni_port_name: 'LA GUAIRA',
            wni_unlocode: 'VELAG',
            wni_country: 'VE',
            wni_lat: 10.6051,
            wni_lon: -66.9535,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'LIB',
            wni_port_name: 'LIBREVILLE',
            wni_unlocode: 'GALBV',
            wni_country: 'GA',
            wni_lat: 0.3961,
            wni_lon: 9.4253,
            wni_tz: 'Africa/Libreville',
        },
        {
            option: 'LIE',
            wni_port_name: 'LEGHORN (LIVORNO)',
            wni_unlocode: 'ITLIV',
            wni_country: 'IT',
            wni_lat: 43.557,
            wni_lon: 10.2778,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'LIM',
            wni_port_name: 'LIMASSOL',
            wni_unlocode: 'CYLMS',
            wni_country: 'CY',
            wni_lat: 34.6447,
            wni_lon: 33.0412,
            wni_tz: 'Asia/Nicosia',
        },
        {
            option: 'LIR',
            wni_port_name: 'LIRQUEN',
            wni_unlocode: 'CLLQN',
            wni_country: 'CL',
            wni_lat: -36.7034,
            wni_lon: -72.9976,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'LIS',
            wni_port_name: 'LISBON',
            wni_unlocode: 'PTLIS',
            wni_country: 'PT',
            wni_lat: 38.6903,
            wni_lon: -9.1722,
            wni_tz: 'Europe/Lisbon',
        },
        {
            option: 'LIV',
            wni_port_name: 'LIVERPOOL',
            wni_unlocode: 'GBLIV',
            wni_country: 'GB',
            wni_lat: 53.4523,
            wni_lon: -3.0445,
            wni_tz: 'Europe/London',
        },
        {
            option: 'LKI',
            wni_port_name: 'LANGKAWI',
            wni_unlocode: 'MYLGK',
            wni_country: 'MY',
            wni_lat: 6.4404,
            wni_lon: 99.7625,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'LLB',
            wni_port_name: 'LA LIBERTAD',
            wni_unlocode: 'ECLLD',
            wni_country: 'EC',
            wni_lat: -2.3484,
            wni_lon: -80.8906,
            wni_tz: 'America/Guayaquil',
        },
        {
            option: 'LMA',
            wni_port_name: 'LIMA',
            wni_unlocode: 'ARLIM',
            wni_country: 'AR',
            wni_lat: -33.96,
            wni_lon: -59.1878,
            wni_tz: 'America/Argentina/Buenos_Aires',
        },
        {
            option: 'LMB',
            wni_port_name: 'LAS MINAS',
            wni_unlocode: 'PAMNP',
            wni_country: 'PA',
            wni_lat: 9.4066,
            wni_lon: -79.8268,
            wni_tz: 'America/Panama',
        },
        {
            option: 'LME',
            wni_port_name: 'LOME',
            wni_unlocode: 'TGLFW',
            wni_country: 'TG',
            wni_lat: 6.1358,
            wni_lon: 1.2894,
            wni_tz: 'Africa/Lome',
        },
        {
            option: 'LMK',
            wni_port_name: 'LIMERICK',
            wni_unlocode: 'IELMK',
            wni_country: 'IE',
            wni_lat: 52.6594,
            wni_lon: -8.6465,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'LNA',
            wni_port_name: 'LONG AN',
            wni_unlocode: 'VNLAP',
            wni_country: 'VN',
            wni_lat: 10.5378,
            wni_lon: 106.7419,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'LNG',
            wni_port_name: 'LIANYUNGANG',
            wni_unlocode: 'CNLYG',
            wni_country: 'CN',
            wni_lat: 34.7432,
            wni_lon: 119.5295,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'LNGSA',
            wni_port_name: 'LANGSA TERMINAL',
            wni_unlocode: 'IDLAS',
            wni_country: 'ID',
            wni_lat: 5.3,
            wni_lon: 98.0333,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'LNS',
            wni_port_name: 'LAUNCESTON',
            wni_unlocode: 'AULST',
            wni_country: 'AU',
            wni_lat: -41.4345,
            wni_lon: 147.1276,
            wni_tz: 'Australia/Hobart',
        },
        {
            option: 'LOB',
            wni_port_name: 'LOBITO',
            wni_unlocode: 'AOLOB',
            wni_country: 'AO',
            wni_lat: -12.3113,
            wni_lon: 13.5763,
            wni_tz: 'Africa/Luanda',
        },
        {
            option: 'LON',
            wni_port_name: 'LONGVIEW',
            wni_unlocode: 'USLOG',
            wni_country: 'US',
            wni_lat: 46.1228,
            wni_lon: -122.9884,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'LONG',
            wni_port_name: 'LONGONI',
            wni_unlocode: 'YTLON',
            wni_country: 'YT',
            wni_lat: -12.7166,
            wni_lon: 45.1568,
            wni_tz: 'Indian/Mayotte',
        },
        {
            option: 'LOOP',
            wni_port_name: 'LOOP TERMINAL',
            wni_unlocode: 'USLO9',
            wni_country: 'US',
            wni_lat: 28.8833,
            wni_lon: -90.0167,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'LOR',
            wni_port_name: 'LORIENT',
            wni_unlocode: 'FRLRT',
            wni_country: 'FR',
            wni_lat: 47.7317,
            wni_lon: -3.3522,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'LOY',
            wni_port_name: 'LUO YUAN WAN',
            wni_unlocode: 'CNLYW',
            wni_country: 'CN',
            wni_lat: 26.4514,
            wni_lon: 119.6966,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'LPJ',
            wni_port_name: 'LIEPAJA',
            wni_unlocode: 'LVLPX',
            wni_country: 'LV',
            wni_lat: 56.5569,
            wni_lon: 20.952,
            wni_tz: 'Europe/Riga',
        },
        {
            option: 'LPM',
            wni_port_name: 'LA PALOMA',
            wni_unlocode: 'UYLAP',
            wni_country: 'UY',
            wni_lat: -34.6403,
            wni_lon: -54.1447,
            wni_tz: 'America/Montevideo',
        },
        {
            option: 'LPZ',
            wni_port_name: 'LA PAZ',
            wni_unlocode: 'MXLAP',
            wni_country: 'MX',
            wni_lat: 24.21,
            wni_lon: -110.3107,
            wni_tz: 'America/Mazatlan',
        },
        {
            option: 'LRM',
            wni_port_name: 'LA ROMANA',
            wni_unlocode: 'DOLRM',
            wni_country: 'DO',
            wni_lat: 18.4011,
            wni_lon: -68.9535,
            wni_tz: 'America/Santo_Domingo',
        },
        {
            option: 'LRN',
            wni_port_name: 'LARNACA',
            wni_unlocode: 'CYLCA',
            wni_country: 'CY',
            wni_lat: 34.9247,
            wni_lon: 33.6594,
            wni_tz: 'Asia/Nicosia',
        },
        {
            option: 'LSA',
            wni_port_name: 'LA SALINA',
            wni_unlocode: 'VELSV',
            wni_country: 'VE',
            wni_lat: 10.3577,
            wni_lon: -71.4757,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'LSH',
            wni_port_name: 'LANSHAN',
            wni_unlocode: 'CNLSN',
            wni_country: 'CN',
            wni_lat: 35.0639,
            wni_lon: 119.3851,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'LSK',
            wni_port_name: 'LA SKHIRA',
            wni_unlocode: 'TNLSK',
            wni_country: 'TN',
            wni_lat: 34.2814,
            wni_lon: 10.1058,
            wni_tz: 'Africa/Tunis',
        },
        {
            option: 'LSP',
            wni_port_name: 'LAS PALMAS',
            wni_unlocode: 'ESLPA',
            wni_country: 'ES',
            wni_lat: 28.1203,
            wni_lon: -15.3952,
            wni_tz: 'Atlantic/Canary',
        },
        {
            option: 'LUA',
            wni_port_name: 'LUANDA',
            wni_unlocode: 'AOLAD',
            wni_country: 'AO',
            wni_lat: -8.7529,
            wni_lon: 13.2604,
            wni_tz: 'Africa/Luanda',
        },
        {
            option: 'LUC',
            wni_port_name: 'LUCINDA',
            wni_unlocode: 'AULUC',
            wni_country: 'AU',
            wni_lat: -18.5167,
            wni_lon: 146.3359,
            wni_tz: 'Australia/Brisbane',
        },
        {
            option: 'LUHUA',
            wni_port_name: 'LU HUA SHAN',
            wni_unlocode: 'CNLUH',
            wni_country: 'CN',
            wni_lat: 30.8073,
            wni_lon: 122.619,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'LUL',
            wni_port_name: 'LULEA',
            wni_unlocode: 'SELLA',
            wni_country: 'SE',
            wni_lat: 65.5367,
            wni_lon: 22.2733,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'LUM',
            wni_port_name: 'LUMUT',
            wni_unlocode: 'MYLMT',
            wni_country: 'MY',
            wni_lat: 4.2383,
            wni_lon: 100.5816,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'LUMT',
            wni_port_name: 'LUMUT',
            wni_unlocode: 'BNLUM',
            wni_country: 'BN',
            wni_lat: 4.7162,
            wni_lon: 114.4392,
            wni_tz: 'Asia/Brunei',
        },
        {
            option: 'LUNJI',
            wni_port_name: 'LUANJIAKOU',
            wni_unlocode: 'CNLJK',
            wni_country: 'CN',
            wni_lat: 37.7996,
            wni_lon: 120.6422,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'LUO',
            wni_port_name: 'LUOJING',
            wni_unlocode: 'CNLJG',
            wni_country: 'CN',
            wni_lat: 31.4757,
            wni_lon: 121.438,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'LVN',
            wni_port_name: 'LAVAN ISLAND',
            wni_unlocode: 'IRLVP',
            wni_country: 'IR',
            wni_lat: 26.778,
            wni_lon: 53.3427,
            wni_tz: 'Asia/Tehran',
        },
        {
            option: 'LVNTE',
            wni_port_name: 'PORTO LEVANTE',
            wni_unlocode: 'ITPVT',
            wni_country: 'IT',
            wni_lat: 45.0543,
            wni_lon: 12.4093,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'LWSTF',
            wni_port_name: 'LOWESTOFT',
            wni_unlocode: 'GBLOW',
            wni_country: 'GB',
            wni_lat: 52.4684,
            wni_lon: 1.7701,
            wni_tz: 'Europe/London',
        },
        {
            option: 'LYB',
            wni_port_name: 'LONGYEARBYEN',
            wni_unlocode: 'SJLYR',
            wni_country: 'NO',
            wni_lat: 78.262,
            wni_lon: 15.54,
            wni_tz: 'Arctic/Longyearbyen',
        },
        {
            option: 'LYLA',
            wni_port_name: 'PUNTA LOYOLA',
            wni_unlocode: 'ARPLO',
            wni_country: 'AR',
            wni_lat: -51.601,
            wni_lon: -68.9329,
            wni_tz: 'America/Argentina/Rio_Gallegos',
        },
        {
            option: 'LYT',
            wni_port_name: 'LYTTELTON',
            wni_unlocode: 'NZLYT',
            wni_country: 'NZ',
            wni_lat: -43.6182,
            wni_lon: 172.7162,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'LZH',
            wni_port_name: 'LAIZHOU',
            wni_unlocode: 'CNLAI',
            wni_country: 'CN',
            wni_lat: 37.4277,
            wni_lon: 119.9353,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'MA',
            wni_port_name: 'MALAGA',
            wni_unlocode: 'EWNIP',
            wni_country: 'ES',
            wni_lat: 36.6868,
            wni_lon: -4.4122,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'MAB',
            wni_port_name: 'MENA ABDULLA (MINA ABD ALLAH)',
            wni_unlocode: 'KWMIB',
            wni_country: 'KW',
            wni_lat: 29.0166,
            wni_lon: 48.1716,
            wni_tz: 'Asia/Kuwait',
        },
        {
            option: 'MADRE',
            wni_port_name: 'MADRE DE DEUS',
            wni_unlocode: 'BRMDD',
            wni_country: 'BR',
            wni_lat: -12.7559,
            wni_lon: -38.6234,
            wni_tz: 'America/Bahia',
        },
        {
            option: 'MAF',
            wni_port_name: 'MINA AL FAHAL (MIN-AL-FAHAL)',
            wni_unlocode: 'OMMFH',
            wni_country: 'OM',
            wni_lat: 23.6437,
            wni_lon: 58.5689,
            wni_tz: 'Asia/Muscat',
        },
        {
            option: 'MAG',
            wni_port_name: 'MARUGAME',
            wni_unlocode: 'JPMAR',
            wni_country: 'JP',
            wni_lat: 34.3123,
            wni_lon: 133.7661,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MAI',
            wni_port_name: 'MAIZURU',
            wni_unlocode: 'JPMAI',
            wni_country: 'JP',
            wni_lat: 35.4948,
            wni_lon: 135.365,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MAJ',
            wni_port_name: 'MAJURO',
            wni_unlocode: 'MHMAJ',
            wni_country: 'MH',
            wni_lat: 7.1028,
            wni_lon: 171.3623,
            wni_tz: 'Pacific/Majuro',
        },
        {
            option: 'MAL',
            wni_port_name: 'MARSEILLE',
            wni_unlocode: 'FRMRS',
            wni_country: 'FR',
            wni_lat: 43.3392,
            wni_lon: 5.3069,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'MALAC',
            wni_port_name: 'MALACCA',
            wni_unlocode: 'MYMKZ',
            wni_country: 'MY',
            wni_lat: 2.1765,
            wni_lon: 102.2344,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'MAMO',
            wni_port_name: 'MAMONAL',
            wni_unlocode: 'COMAM',
            wni_country: 'CO',
            wni_lat: 10.3186,
            wni_lon: -75.5209,
            wni_tz: 'America/Bogota',
        },
        {
            option: 'MAN',
            wni_port_name: 'MANZANILLO',
            wni_unlocode: 'MXZLO',
            wni_country: 'MX',
            wni_lat: 19.0688,
            wni_lon: -104.3187,
            wni_tz: 'America/Mexico_City',
        },
        {
            option: 'MANP',
            wni_port_name: 'MANZANILLO',
            wni_unlocode: 'PAMIT',
            wni_country: 'PA',
            wni_lat: 9.3947,
            wni_lon: -79.917,
            wni_tz: 'America/Panama',
        },
        {
            option: 'MAO',
            wni_port_name: 'MACEIO',
            wni_unlocode: 'BRMCZ',
            wni_country: 'BR',
            wni_lat: -9.6969,
            wni_lon: -35.7195,
            wni_tz: 'America/Maceio',
        },
        {
            option: 'MAP',
            wni_port_name: 'MAPUTO',
            wni_unlocode: 'MZMPM',
            wni_country: 'MZ',
            wni_lat: -25.9644,
            wni_lon: 32.536,
            wni_tz: 'Africa/Maputo',
        },
        {
            option: 'MARB',
            wni_port_name: 'MARACAIBO',
            wni_unlocode: 'VEMAR',
            wni_country: 'VE',
            wni_lat: 10.6333,
            wni_lon: -71.5998,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'MARM',
            wni_port_name: 'MARMARIS',
            wni_unlocode: 'TRMRM',
            wni_country: 'TR',
            wni_lat: 36.8408,
            wni_lon: 28.2692,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'MAS',
            wni_port_name: 'MATSUYAMA',
            wni_unlocode: 'JPMYJ',
            wni_country: 'JP',
            wni_lat: 33.8545,
            wni_lon: 132.6847,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MATI',
            wni_port_name: 'MATI',
            wni_unlocode: 'PHBCU',
            wni_country: 'PH',
            wni_lat: 6.9272,
            wni_lon: 126.2321,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'MAWN',
            wni_port_name: 'MAWAN',
            wni_unlocode: 'CNMWN',
            wni_country: 'CN',
            wni_lat: 22.4815,
            wni_lon: 113.8589,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'MAZ',
            wni_port_name: 'MAZATLAN',
            wni_unlocode: 'MXMZT',
            wni_country: 'MX',
            wni_lat: 23.167,
            wni_lon: -106.4236,
            wni_tz: 'America/Mazatlan',
        },
        {
            option: 'MAZR',
            wni_port_name: 'MINA AL ZOUR',
            wni_unlocode: 'KWMZR',
            wni_country: 'KW',
            wni_lat: 28.71,
            wni_lon: 48.4,
            wni_tz: 'Asia/Kuwait',
        },
        {
            option: 'MBH',
            wni_port_name: 'MIDDLESBROUGH',
            wni_unlocode: 'GBMID',
            wni_country: 'GB',
            wni_lat: 54.5809,
            wni_lon: -1.2137,
            wni_tz: 'Europe/London',
        },
        {
            option: 'MBNI',
            wni_port_name: 'MABINI',
            wni_unlocode: 'PHMAB',
            wni_country: 'PH',
            wni_lat: 13.7315,
            wni_lon: 120.9501,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'MBRK',
            wni_port_name: 'MUBAREK TERMINAL',
            wni_unlocode: 'AEMUB',
            wni_country: 'AE',
            wni_lat: 25.8169,
            wni_lon: 55.1838,
            wni_tz: 'Asia/Dubai',
        },
        {
            option: 'MBRRS',
            wni_port_name: 'MUBARRAS TERMIANAL',
            wni_unlocode: 'AEMBS',
            wni_country: 'AE',
            wni_lat: 24.4333,
            wni_lon: 53.5167,
            wni_tz: 'Asia/Dubai',
        },
        {
            option: 'MC',
            wni_port_name: 'MONTE CARLO',
            wni_unlocode: 'MCMCM',
            wni_country: 'MC',
            wni_lat: 43.7293,
            wni_lon: 7.4378,
            wni_tz: 'Europe/Monaco',
        },
        {
            option: 'MCN',
            wni_port_name: 'MACUN',
            wni_unlocode: 'CNMCN',
            wni_country: 'CN',
            wni_lat: 19.9715,
            wni_lon: 110.032,
            wni_tz: 'Asia/Chongqing',
        },
        {
            option: 'MCP',
            wni_port_name: 'MACAPA',
            wni_unlocode: 'BRMCP',
            wni_country: 'BR',
            wni_lat: 0.0324,
            wni_lon: -51.0364,
            wni_tz: 'America/Belem',
        },
        {
            option: 'MCS',
            wni_port_name: 'MAKASSAR',
            wni_unlocode: 'IDMAK',
            wni_country: 'ID',
            wni_lat: -5.1279,
            wni_lon: 119.3811,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'MCY',
            wni_port_name: 'MACKAY',
            wni_unlocode: 'AUMKY',
            wni_country: 'AU',
            wni_lat: -21.1046,
            wni_lon: 149.2431,
            wni_tz: 'Australia/Brisbane',
        },
        {
            option: 'MDC',
            wni_port_name: 'MARINA DI CARRARA',
            wni_unlocode: 'ITMDC',
            wni_country: 'IT',
            wni_lat: 44.0155,
            wni_lon: 10.0324,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'MDG',
            wni_port_name: 'MADANG',
            wni_unlocode: 'PGMAG',
            wni_country: 'PG',
            wni_lat: -5.2101,
            wni_lon: 145.8234,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'MDRY',
            wni_port_name: 'PUERTO MADRYN',
            wni_unlocode: 'ARPMY',
            wni_country: 'AR',
            wni_lat: -42.7392,
            wni_lon: -65.0077,
            wni_tz: 'America/Argentina/Catamarca',
        },
        {
            option: 'ME',
            wni_port_name: 'MESSINA',
            wni_unlocode: 'ITMSN',
            wni_country: 'IT',
            wni_lat: 38.202,
            wni_lon: 15.5696,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'MEB',
            wni_port_name: 'MARSA BREGA',
            wni_unlocode: 'LYLMQ',
            wni_country: 'LY',
            wni_lat: 30.4275,
            wni_lon: 19.5906,
            wni_tz: 'Africa/Tripoli',
        },
        {
            option: 'MEE',
            wni_port_name: 'MERAUKE',
            wni_unlocode: 'IDMKQ',
            wni_country: 'ID',
            wni_lat: -8.4766,
            wni_lon: 140.3895,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'MEI',
            wni_port_name: 'MELILLA',
            wni_unlocode: 'ESMLN',
            wni_country: 'ES',
            wni_lat: 35.2905,
            wni_lon: -2.9091,
            wni_tz: 'Africa/Ceuta',
        },
        {
            option: 'MEJ',
            wni_port_name: 'MEJILLONES',
            wni_unlocode: 'CLMJS',
            wni_country: 'CL',
            wni_lat: -23.0889,
            wni_lon: -70.4508,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'MEL',
            wni_port_name: 'MELBOURNE',
            wni_unlocode: 'AUMEL',
            wni_country: 'AU',
            wni_lat: -37.8531,
            wni_lon: 144.9248,
            wni_tz: 'Australia/Melbourne',
        },
        {
            option: 'MER',
            wni_port_name: 'MERSIN',
            wni_unlocode: 'TRMER',
            wni_country: 'TR',
            wni_lat: 36.774,
            wni_lon: 34.6429,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'MFC',
            wni_port_name: 'MONFALCONE',
            wni_unlocode: 'ITMNF',
            wni_country: 'IT',
            wni_lat: 45.7685,
            wni_lon: 13.5499,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'MGB',
            wni_port_name: 'MUNGUBA',
            wni_unlocode: 'BRMGU',
            wni_country: 'BR',
            wni_lat: -0.9183,
            wni_lon: -52.4236,
            wni_tz: 'America/Santarem',
        },
        {
            option: 'MGLP',
            wni_port_name: 'MONGLA',
            wni_unlocode: 'BDMGL',
            wni_country: 'BD',
            wni_lat: 22.4892,
            wni_lon: 89.586,
            wni_tz: 'Asia/Dhaka',
        },
        {
            option: 'MGM',
            wni_port_name: 'MOSTAGANEM',
            wni_unlocode: 'DZMOS',
            wni_country: 'DZ',
            wni_lat: 35.9373,
            wni_lon: 0.0585,
            wni_tz: 'Africa/Algiers',
        },
        {
            option: 'MGRDS',
            wni_port_name: 'MUGARDOS',
            wni_unlocode: 'ESMGR',
            wni_country: 'ES',
            wni_lat: 43.4683,
            wni_lon: -8.2378,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'MGS',
            wni_port_name: 'MONGSTAD',
            wni_unlocode: 'NOMON',
            wni_country: 'NO',
            wni_lat: 60.8244,
            wni_lon: 5.0463,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'MHA',
            wni_port_name: 'MARSA EL HARIGA',
            wni_unlocode: 'LYMHR',
            wni_country: 'LY',
            wni_lat: 32.0624,
            wni_lon: 24.0132,
            wni_tz: 'Africa/Tripoli',
        },
        {
            option: 'MHR',
            wni_port_name: 'MUARA',
            wni_unlocode: 'BNMUA',
            wni_country: 'BN',
            wni_lat: 5.059,
            wni_lon: 115.1006,
            wni_tz: 'Asia/Brunei',
        },
        {
            option: 'MIA',
            wni_port_name: 'MAI-LIAO',
            wni_unlocode: 'TWMLI',
            wni_country: 'TW',
            wni_lat: 23.7833,
            wni_lon: 120.15,
            wni_tz: 'Asia/Taipei',
        },
        {
            option: 'MII',
            wni_port_name: 'MILAKI',
            wni_unlocode: 'GRMLK',
            wni_country: 'GR',
            wni_lat: 38.3761,
            wni_lon: 24.0394,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'MIIE',
            wni_port_name: 'MIIKE',
            wni_unlocode: 'JPMII',
            wni_country: 'JP',
            wni_lat: 33.0032,
            wni_lon: 130.3822,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MIK',
            wni_port_name: 'MIKAWA',
            wni_unlocode: 'JPMKW',
            wni_country: 'JP',
            wni_lat: 34.733,
            wni_lon: 137.2974,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MIL',
            wni_port_name: 'MILFORD HAVEN',
            wni_unlocode: 'GBMLF',
            wni_country: 'GB',
            wni_lat: 51.6692,
            wni_lon: -5.1533,
            wni_tz: 'Europe/London',
        },
        {
            option: 'MIM',
            wni_port_name: 'MIAMI',
            wni_unlocode: 'USIMI',
            wni_country: 'US',
            wni_lat: 25.7468,
            wni_lon: -80.1313,
            wni_tz: 'America/New_York',
        },
        {
            option: 'MINA',
            wni_port_name: 'MINA AL AHMADI',
            wni_unlocode: 'KWMEA',
            wni_country: 'KW',
            wni_lat: 29.0638,
            wni_lon: 48.1841,
            wni_tz: 'Asia/Kuwait',
        },
        {
            option: 'MIR',
            wni_port_name: 'MIRI',
            wni_unlocode: 'MYMYY',
            wni_country: 'MY',
            wni_lat: 4.3879,
            wni_lon: 113.9637,
            wni_tz: 'Asia/Kuching',
        },
        {
            option: 'MIRA',
            wni_port_name: 'PUERTO MIRANDA',
            wni_unlocode: 'VEMIV',
            wni_country: 'VE',
            wni_lat: 10.7455,
            wni_lon: -71.5594,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'MISU',
            wni_port_name: 'MISUMI\t SHIMANE',
            wni_unlocode: 'JPMMI',
            wni_country: 'JP',
            wni_lat: 34.8,
            wni_lon: 131.9167,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MITS',
            wni_port_name: 'MITSUKOJIMA',
            wni_unlocode: 'JPMKS',
            wni_country: 'JP',
            wni_lat: 34.1961,
            wni_lon: 132.5,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MIY',
            wni_port_name: 'MIYAKO',
            wni_unlocode: 'JPMYK',
            wni_country: 'JP',
            wni_lat: 39.6387,
            wni_lon: 141.9854,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MIYZ',
            wni_port_name: 'MIYAZAKI',
            wni_unlocode: 'JPFMS',
            wni_country: 'JP',
            wni_lat: 31.9263,
            wni_lon: 131.48,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MIZ',
            wni_port_name: 'MIZUSHIMA',
            wni_unlocode: 'JPMIZ',
            wni_country: 'JP',
            wni_lat: 34.4644,
            wni_lon: 133.734,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MJK',
            wni_port_name: 'MOERDIJK',
            wni_unlocode: 'NLMOE',
            wni_country: 'NL',
            wni_lat: 51.6972,
            wni_lon: 4.5854,
            wni_tz: 'Europe/Amsterdam',
        },
        {
            option: 'MJN',
            wni_port_name: 'MAJISHAN',
            wni_unlocode: 'CNMJS',
            wni_country: 'CN',
            wni_lat: 30.659,
            wni_lon: 122.4136,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'MKO',
            wni_port_name: 'MUGHO (MUKHO)',
            wni_unlocode: 'KRMUK',
            wni_country: 'KR',
            wni_lat: 37.5373,
            wni_lon: 129.1307,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'MLA',
            wni_port_name: 'MANILA',
            wni_unlocode: 'PHMNL',
            wni_country: 'PH',
            wni_lat: 14.5955,
            wni_lon: 120.9335,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'MLB',
            wni_port_name: 'MALABO',
            wni_unlocode: 'GQSSG',
            wni_country: 'GQ',
            wni_lat: 3.766,
            wni_lon: 8.7766,
            wni_tz: 'Africa/Malabo',
        },
        {
            option: 'MLE',
            wni_port_name: 'MALE',
            wni_unlocode: 'MVMAL',
            wni_country: 'MV',
            wni_lat: 4.1896,
            wni_lon: 73.5066,
            wni_tz: 'Indian/Maldives',
        },
        {
            option: 'MLI',
            wni_port_name: 'MALILI',
            wni_unlocode: 'IDMLI',
            wni_country: 'ID',
            wni_lat: -2.6456,
            wni_lon: 120.8232,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'MLO',
            wni_port_name: 'MALMO',
            wni_unlocode: 'SEMMA',
            wni_country: 'SE',
            wni_lat: 55.6267,
            wni_lon: 12.9692,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'MLTH',
            wni_port_name: 'MELLITAH',
            wni_unlocode: 'LYMEL',
            wni_country: 'LY',
            wni_lat: 32.8865,
            wni_lon: 12.2482,
            wni_tz: 'Africa/Tripoli',
        },
        {
            option: 'MLW',
            wni_port_name: 'MILWAUKEE',
            wni_unlocode: 'USMKE',
            wni_country: 'US',
            wni_lat: 43.0263,
            wni_lon: -87.8696,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'MLZ',
            wni_port_name: 'MILAZZO',
            wni_unlocode: 'ITMLZ',
            wni_country: 'IT',
            wni_lat: 38.2204,
            wni_lon: 15.2603,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'MNCI',
            wni_port_name: 'MANICANI ISLAND',
            wni_unlocode: 'PHMNI',
            wni_country: 'PH',
            wni_lat: 11.0133,
            wni_lon: 125.6333,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'MNI',
            wni_port_name: 'MONTOIR',
            wni_unlocode: 'FRML2',
            wni_country: 'FR',
            wni_lat: 47.2547,
            wni_lon: -2.2014,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'MNMT',
            wni_port_name: 'MINAMATA',
            wni_unlocode: 'JPMIN',
            wni_country: 'JP',
            wni_lat: 32.191,
            wni_lon: 130.3666,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MNO',
            wni_port_name: 'BAIE UGUE MONEO',
            wni_unlocode: 'NCBUG',
            wni_country: 'NC',
            wni_lat: -21.1386,
            wni_lon: 165.561,
            wni_tz: 'Pacific/Noumea',
        },
        {
            option: 'MNS',
            wni_port_name: 'MANAUS',
            wni_unlocode: 'BRMAO',
            wni_country: 'BR',
            wni_lat: -3.1488,
            wni_lon: -60.0326,
            wni_tz: 'America/Manaus',
        },
        {
            option: 'MNT',
            wni_port_name: 'MANTA',
            wni_unlocode: 'ECMEC',
            wni_country: 'EC',
            wni_lat: -0.9231,
            wni_lon: -80.7153,
            wni_tz: 'America/Guayaquil',
        },
        {
            option: 'MOA',
            wni_port_name: 'MOCHA',
            wni_unlocode: 'YEMOK',
            wni_country: 'YE',
            wni_lat: 13.3209,
            wni_lon: 43.2246,
            wni_tz: 'Asia/Aden',
        },
        {
            option: 'MOB',
            wni_port_name: 'MOBILE',
            wni_unlocode: 'USMOB',
            wni_country: 'US',
            wni_lat: 30.7044,
            wni_lon: -88.0379,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'MOE',
            wni_port_name: 'MOREHEAD CITY',
            wni_unlocode: 'USMRH',
            wni_country: 'US',
            wni_lat: 34.6843,
            wni_lon: -76.6737,
            wni_tz: 'America/New_York',
        },
        {
            option: 'MOH',
            wni_port_name: 'MOHAMMEDIA',
            wni_unlocode: 'MAMOH',
            wni_country: 'MA',
            wni_lat: 33.7399,
            wni_lon: -7.3921,
            wni_tz: 'Africa/Casablanca',
        },
        {
            option: 'MOI',
            wni_port_name: 'MO I RANA',
            wni_unlocode: 'NOMQN',
            wni_country: 'NO',
            wni_lat: 66.3245,
            wni_lon: 14.1167,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'MOJ',
            wni_port_name: 'MOJI',
            wni_unlocode: 'JPMOJ',
            wni_country: 'JP',
            wni_lat: 33.945,
            wni_lon: 130.9483,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MOK',
            wni_port_name: 'MOKPO',
            wni_unlocode: 'KRMOK',
            wni_country: 'KR',
            wni_lat: 34.7747,
            wni_lon: 126.3832,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'MOM',
            wni_port_name: 'MOMBASA',
            wni_unlocode: 'KEMBA',
            wni_country: 'KE',
            wni_lat: -4.045,
            wni_lon: 39.678,
            wni_tz: 'Africa/Nairobi',
        },
        {
            option: 'MONRO',
            wni_port_name: 'MONROE',
            wni_unlocode: 'USMOI',
            wni_country: 'US',
            wni_lat: 41.8824,
            wni_lon: -83.3249,
            wni_tz: 'America/New_York',
        },
        {
            option: 'MOO',
            wni_port_name: 'MALONGO TERMINAL',
            wni_unlocode: 'AOMAL',
            wni_country: 'AO',
            wni_lat: -5.2,
            wni_lon: 12.05,
            wni_tz: 'Africa/Luanda',
        },
        {
            option: 'MOR',
            wni_port_name: 'MONROVIA',
            wni_unlocode: 'LRMLW',
            wni_country: 'LR',
            wni_lat: 6.3535,
            wni_lon: -10.82,
            wni_tz: 'Africa/Monrovia',
        },
        {
            option: 'MOS',
            wni_port_name: 'MOSJOEN',
            wni_unlocode: 'NOMJF',
            wni_country: 'NO',
            wni_lat: 65.8581,
            wni_lon: 13.1697,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'MOT',
            wni_port_name: 'MONTEVIDEO',
            wni_unlocode: 'UYMVD',
            wni_country: 'UY',
            wni_lat: -34.8982,
            wni_lon: -56.225,
            wni_tz: 'America/Montevideo',
        },
        {
            option: 'MOUDI',
            wni_port_name: 'MOUDI TERMINAL',
            wni_unlocode: 'CMMOU',
            wni_country: 'CM',
            wni_lat: 4.1333,
            wni_lon: 8.45,
            wni_tz: 'Africa/Douala',
        },
        {
            option: 'MOY',
            wni_port_name: 'MONEY POINT',
            wni_unlocode: 'IEMOT',
            wni_country: 'IE',
            wni_lat: 52.595,
            wni_lon: -9.4202,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'MPL',
            wni_port_name: 'MARIUPOL',
            wni_unlocode: 'UAMPW',
            wni_country: 'UA',
            wni_lat: 47.045,
            wni_lon: 37.535,
            wni_tz: 'Europe/Zaporozhye',
        },
        {
            option: 'MPP',
            wni_port_name: 'PALMA MALLORCA',
            wni_unlocode: 'ESPMI',
            wni_country: 'ES',
            wni_lat: 39.5434,
            wni_lon: 2.6456,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'MRGI',
            wni_port_name: 'MERGUI',
            wni_unlocode: 'MMMER',
            wni_country: 'MM',
            wni_lat: 12.4846,
            wni_lon: 98.5896,
            wni_tz: 'Asia/Rangoon',
        },
        {
            option: 'MRH',
            wni_port_name: 'MARCUS HOOK',
            wni_unlocode: 'USMAH',
            wni_country: 'US',
            wni_lat: 39.8012,
            wni_lon: -75.4079,
            wni_tz: 'America/New_York',
        },
        {
            option: 'MRIL',
            wni_port_name: 'MARIEL',
            wni_unlocode: 'CUMAR',
            wni_country: 'CU',
            wni_lat: 23.0317,
            wni_lon: -82.7579,
            wni_tz: 'America/Havana',
        },
        {
            option: 'MRK',
            wni_port_name: 'MERAK',
            wni_unlocode: 'IDMRK',
            wni_country: 'ID',
            wni_lat: -5.9254,
            wni_lon: 105.9797,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'MRL',
            wni_port_name: 'MOURILYAN',
            wni_unlocode: 'AUMOO',
            wni_country: 'AU',
            wni_lat: -17.6,
            wni_lon: 146.1346,
            wni_tz: 'Australia/Brisbane',
        },
        {
            option: 'MRMS',
            wni_port_name: 'EREGLISI',
            wni_unlocode: 'TRMAR',
            wni_country: 'TR',
            wni_lat: 40.9737,
            wni_lon: 27.972,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'MRN',
            wni_port_name: 'MARIN',
            wni_unlocode: 'ESMAR',
            wni_country: 'ES',
            wni_lat: 42.3998,
            wni_lon: -8.7182,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'MRSD',
            wni_port_name: 'MARSDEN POINT',
            wni_unlocode: 'NZMAP',
            wni_country: 'NZ',
            wni_lat: -35.8359,
            wni_lon: 174.5106,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'MRV',
            wni_port_name: 'MORRISVILLE',
            wni_unlocode: 'USMZL',
            wni_country: 'US',
            wni_lat: 40.1756,
            wni_lon: -74.7349,
            wni_tz: 'America/New_York',
        },
        {
            option: 'MSB',
            wni_port_name: 'MOSSEL BAY',
            wni_unlocode: 'ZAMZY',
            wni_country: 'ZA',
            wni_lat: -34.1712,
            wni_lon: 22.1482,
            wni_tz: 'Africa/Johannesburg',
        },
        {
            option: 'MSD',
            wni_port_name: 'MINA SAUD',
            wni_unlocode: 'KWMIS',
            wni_country: 'KW',
            wni_lat: 28.7459,
            wni_lon: 48.4025,
            wni_tz: 'Asia/Kuwait',
        },
        {
            option: 'MSK',
            wni_port_name: 'MURMANSK',
            wni_unlocode: 'RUMMK',
            wni_country: 'RU',
            wni_lat: 69.003,
            wni_lon: 33.0394,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'MSN',
            wni_port_name: 'MASAN',
            wni_unlocode: 'KRMAS',
            wni_country: 'KR',
            wni_lat: 35.1867,
            wni_lon: 128.5806,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'MSQ',
            wni_port_name: 'MINA SAQR',
            wni_unlocode: 'AEMSA',
            wni_country: 'AE',
            wni_lat: 25.9881,
            wni_lon: 56.0455,
            wni_tz: 'Asia/Dubai',
        },
        {
            option: 'MSR',
            wni_port_name: 'MISURATA',
            wni_unlocode: 'LYMRA',
            wni_country: 'LY',
            wni_lat: 32.3722,
            wni_lon: 15.2344,
            wni_tz: 'Africa/Tripoli',
        },
        {
            option: 'MSU',
            wni_port_name: 'MISUMI\t KUMAMOTO',
            wni_unlocode: 'JPMIS',
            wni_country: 'JP',
            wni_lat: 32.5959,
            wni_lon: 130.4643,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MSW',
            wni_port_name: 'MASSAWA',
            wni_unlocode: 'ERMSW',
            wni_country: 'ER',
            wni_lat: 15.5967,
            wni_lon: 39.4894,
            wni_tz: 'Africa/Asmara',
        },
        {
            option: 'MTB',
            wni_port_name: 'MONTEGO BAY',
            wni_unlocode: 'JMMBJ',
            wni_country: 'JM',
            wni_lat: 18.4746,
            wni_lon: -77.9376,
            wni_tz: 'America/Jamaica',
        },
        {
            option: 'MTD',
            wni_port_name: 'MATADI',
            wni_unlocode: 'CDMAT',
            wni_country: 'CD',
            wni_lat: -5.8066,
            wni_lon: 13.4642,
            wni_tz: 'Africa/Kinshasa',
        },
        {
            option: 'MTI',
            wni_port_name: 'MATARANI',
            wni_unlocode: 'PEMRI',
            wni_country: 'PE',
            wni_lat: -16.997,
            wni_lon: -72.1194,
            wni_tz: 'America/Lima',
        },
        {
            option: 'MTK',
            wni_port_name: 'MUNTOK',
            wni_unlocode: 'IDMUO',
            wni_country: 'ID',
            wni_lat: -2.0813,
            wni_lon: 105.1604,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'MTK2',
            wni_port_name: 'EXSPAN TERMINAL',
            wni_unlocode: 'IDEXS',
            wni_country: 'ID',
            wni_lat: -1.8333,
            wni_lon: 105.1366,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'MTL',
            wni_port_name: 'MONTREAL',
            wni_unlocode: 'CALAC',
            wni_country: 'CA',
            wni_lat: 45.5032,
            wni_lon: -73.5393,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'MTM',
            wni_port_name: 'MOUNT MAUNGANUI',
            wni_unlocode: 'NZMMU',
            wni_country: 'NZ',
            wni_lat: -37.6183,
            wni_lon: 176.1795,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'MTN',
            wni_port_name: 'MARTINEZ',
            wni_unlocode: 'USMRZ',
            wni_country: 'US',
            wni_lat: 38.0372,
            wni_lon: -122.1302,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'MTR',
            wni_port_name: 'MOTRIL',
            wni_unlocode: 'ESMOT',
            wni_country: 'ES',
            wni_lat: 36.7059,
            wni_lon: -3.5189,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'MTSMA',
            wni_port_name: 'MATSUSHIMA',
            wni_unlocode: 'JPMAT',
            wni_country: 'JP',
            wni_lat: 32.9579,
            wni_lon: 129.608,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MTSU',
            wni_port_name: 'MATSUURA',
            wni_unlocode: 'JPMTS',
            wni_country: 'JP',
            wni_lat: 33.3833,
            wni_lon: 129.7167,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MTT',
            wni_port_name: 'MAP TA PHUT',
            wni_unlocode: 'THMTP',
            wni_country: 'TH',
            wni_lat: 12.6312,
            wni_lon: 101.1569,
            wni_tz: 'Asia/Bangkok',
        },
        {
            option: 'MUAR',
            wni_port_name: 'MUARA JAWA',
            wni_unlocode: 'IDMUD',
            wni_country: 'ID',
            wni_lat: -0.9666,
            wni_lon: 117.2166,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'MUM',
            wni_port_name: 'MUMBAI',
            wni_unlocode: 'INBOM',
            wni_country: 'IN',
            wni_lat: 18.93,
            wni_lon: 72.8107,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'MUN',
            wni_port_name: 'MUNDRA',
            wni_unlocode: 'INMUN',
            wni_country: 'IN',
            wni_lat: 22.736,
            wni_lon: 69.7213,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'MUOG',
            wni_port_name: 'MUTSU OGAWARA',
            wni_unlocode: 'JPMUT',
            wni_country: 'JP',
            wni_lat: 40.9273,
            wni_lon: 141.4159,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MUR',
            wni_port_name: 'MURORAN',
            wni_unlocode: 'JPMRR',
            wni_country: 'JP',
            wni_lat: 42.3476,
            wni_lon: 140.9146,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MUS',
            wni_port_name: 'MUSCAT',
            wni_unlocode: 'OMMCT',
            wni_country: 'OM',
            wni_lat: 23.6167,
            wni_lon: 58.6086,
            wni_tz: 'Asia/Muscat',
        },
        {
            option: 'MUSEL',
            wni_port_name: 'MUSEL',
            wni_unlocode: 'ESMUS',
            wni_country: 'ES',
            wni_lat: 43.5713,
            wni_lon: -5.6633,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'MUT',
            wni_port_name: 'MUTSURE',
            wni_unlocode: 'JPMTR',
            wni_country: 'JP',
            wni_lat: 33.9695,
            wni_lon: 130.8779,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MUU',
            wni_port_name: 'MUUGA',
            wni_unlocode: 'EEMUG',
            wni_country: 'EE',
            wni_lat: 59.5085,
            wni_lon: 24.971,
            wni_tz: 'Europe/Tallinn',
        },
        {
            option: 'MWR',
            wni_port_name: 'MTWARA',
            wni_unlocode: 'TZMYW',
            wni_country: 'TZ',
            wni_lat: -10.2508,
            wni_lon: 40.1915,
            wni_tz: 'Africa/Dar_es_Salaam',
        },
        {
            option: 'MXK',
            wni_port_name: 'MARSAXLOKK',
            wni_unlocode: 'MTMAR',
            wni_country: 'MT',
            wni_lat: 35.8075,
            wni_lon: 14.5566,
            wni_tz: 'Europe/Malta',
        },
        {
            option: 'MYA',
            wni_port_name: 'MIYAZU',
            wni_unlocode: 'JPMIY',
            wni_country: 'JP',
            wni_lat: 35.5651,
            wni_lon: 135.1701,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MYKON',
            wni_port_name: 'MYKONOS',
            wni_unlocode: 'GRJMK',
            wni_country: 'GR',
            wni_lat: 37.4504,
            wni_lon: 25.29,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'NAC',
            wni_port_name: 'NACALA',
            wni_unlocode: 'MZMNC',
            wni_country: 'MZ',
            wni_lat: -14.5356,
            wni_lon: 40.6587,
            wni_tz: 'Africa/Maputo',
        },
        {
            option: 'NAD',
            wni_port_name: 'NADAHAMA',
            wni_unlocode: 'JPNAD',
            wni_country: 'JP',
            wni_lat: 34.6918,
            wni_lon: 135.2419,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NAE',
            wni_port_name: 'NAOETSU',
            wni_unlocode: 'JPNAO',
            wni_country: 'JP',
            wni_lat: 37.2153,
            wni_lon: 138.2539,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NAG',
            wni_port_name: 'NAGOYA',
            wni_unlocode: 'JPNGO',
            wni_country: 'JP',
            wni_lat: 35.0233,
            wni_lon: 136.845,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NAGK',
            wni_port_name: 'NAGASAKI',
            wni_unlocode: 'JPAIW',
            wni_country: 'JP',
            wni_lat: 32.7352,
            wni_lon: 129.8619,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NAH',
            wni_port_name: 'NAHA',
            wni_unlocode: 'JPNAH',
            wni_country: 'JP',
            wni_lat: 26.2567,
            wni_lon: 127.6475,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NAK',
            wni_port_name: 'NAKHODKA',
            wni_unlocode: 'RUNJK',
            wni_country: 'RU',
            wni_lat: 42.8213,
            wni_lon: 132.932,
            wni_tz: 'Asia/Vladivostok',
        },
        {
            option: 'NAM',
            wni_port_name: 'NAMIKATA',
            wni_unlocode: 'JPNIT',
            wni_country: 'JP',
            wni_lat: 34.1311,
            wni_lon: 132.9617,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NAN',
            wni_port_name: 'NANAIMO',
            wni_unlocode: 'CANNO',
            wni_country: 'CA',
            wni_lat: 49.1642,
            wni_lon: -123.9094,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'NAO',
            wni_port_name: 'NAOSHIMA',
            wni_unlocode: 'JPNAS',
            wni_country: 'JP',
            wni_lat: 34.4803,
            wni_lon: 133.9848,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NAP',
            wni_port_name: 'NAPIER',
            wni_unlocode: 'NZNPE',
            wni_country: 'NZ',
            wni_lat: -39.4607,
            wni_lon: 176.9161,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'NAPO',
            wni_port_name: 'NAPLES(NAPOLI)',
            wni_unlocode: 'ITNAP',
            wni_country: 'IT',
            wni_lat: 40.8194,
            wni_lon: 14.2769,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'NAS',
            wni_port_name: 'NASSAU',
            wni_unlocode: 'BSNAS',
            wni_country: 'BS',
            wni_lat: 25.0927,
            wni_lon: -77.3586,
            wni_tz: 'America/Nassau',
        },
        {
            option: 'NAT',
            wni_port_name: 'NANTES',
            wni_unlocode: 'FRNTE',
            wni_country: 'FR',
            wni_lat: 47.2314,
            wni_lon: -1.5485,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'NAV',
            wni_port_name: 'NAVALAKHI (NAVLAKHI)',
            wni_unlocode: 'INNAV',
            wni_country: 'IN',
            wni_lat: 22.9637,
            wni_lon: 70.4348,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'NAZE',
            wni_port_name: 'NAZE',
            wni_unlocode: 'JPNAZ',
            wni_country: 'JP',
            wni_lat: 28.4063,
            wni_lon: 129.501,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NCC',
            wni_port_name: 'NECOCHEA',
            wni_unlocode: 'ARNEC',
            wni_country: 'AR',
            wni_lat: -38.5936,
            wni_lon: -58.6884,
            wni_tz: 'America/Argentina/Buenos_Aires',
        },
        {
            option: 'NCE',
            wni_port_name: 'NEWCASTLE',
            wni_unlocode: 'GBNCS',
            wni_country: 'GB',
            wni_lat: 54.9869,
            wni_lon: -1.4595,
            wni_tz: 'Europe/London',
        },
        {
            option: 'NCHS',
            wni_port_name: 'PORT NECHES',
            wni_unlocode: 'USPON',
            wni_country: 'US',
            wni_lat: 30.0005,
            wni_lon: -93.9539,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'NCL',
            wni_port_name: 'SINT NICOLAAS',
            wni_unlocode: 'AWSNL',
            wni_country: 'AW',
            wni_lat: 12.4135,
            wni_lon: -69.9123,
            wni_tz: 'America/Aruba',
        },
        {
            option: 'NDH',
            wni_port_name: 'NORDENHAM',
            wni_unlocode: 'DENHA',
            wni_country: 'DE',
            wni_lat: 53.4848,
            wni_lon: 8.4975,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'NDR',
            wni_port_name: 'NADOR',
            wni_unlocode: 'MANDR',
            wni_country: 'MA',
            wni_lat: 35.2021,
            wni_lon: -2.8293,
            wni_tz: 'Africa/Casablanca',
        },
        {
            option: 'NEC',
            wni_port_name: 'NEWCASTLE',
            wni_unlocode: 'AUNTL',
            wni_country: 'AU',
            wni_lat: -32.9171,
            wni_lon: 151.8154,
            wni_tz: 'Australia/Sydney',
        },
        {
            option: 'NED',
            wni_port_name: 'NEDERLAND',
            wni_unlocode: 'USNDX',
            wni_country: 'US',
            wni_lat: 30.0083,
            wni_lon: -93.9833,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'NEG',
            wni_port_name: 'NEGISHI',
            wni_unlocode: 'JPNGI',
            wni_country: 'JP',
            wni_lat: 35.4003,
            wni_lon: 139.6528,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NEGRO',
            wni_port_name: 'CABO NEGRO',
            wni_unlocode: 'CLCNX',
            wni_country: 'CL',
            wni_lat: -52.942,
            wni_lon: -70.7599,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'NEL',
            wni_port_name: 'NELSON',
            wni_unlocode: 'NZNSN',
            wni_country: 'NZ',
            wni_lat: -41.2487,
            wni_lon: 173.2897,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'NEM',
            wni_port_name: 'NEMURO',
            wni_unlocode: 'JPNEM',
            wni_country: 'JP',
            wni_lat: 43.349,
            wni_lon: 145.5716,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NEPO',
            wni_port_name: 'NEPOUI',
            wni_unlocode: 'NCNEP',
            wni_country: 'NC',
            wni_lat: -21.3433,
            wni_lon: 164.986,
            wni_tz: 'Pacific/Noumea',
        },
        {
            option: 'NGB',
            wni_port_name: 'NIGG BAY',
            wni_unlocode: 'GBNGG',
            wni_country: 'GB',
            wni_lat: 57.6789,
            wni_lon: -3.9808,
            wni_tz: 'Europe/London',
        },
        {
            option: 'NGQR',
            wni_port_name: 'NGQURA',
            wni_unlocode: 'ZANGQ',
            wni_country: 'ZA',
            wni_lat: -33.8279,
            wni_lon: 25.6932,
            wni_tz: 'Africa/Johannesburg',
        },
        {
            option: 'NGSN',
            wni_port_name: 'NGHI SON',
            wni_unlocode: 'VNNGH',
            wni_country: 'VN',
            wni_lat: 19.3501,
            wni_lon: 105.828,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'NHA',
            wni_port_name: 'NHAVA SHEVA',
            wni_unlocode: 'INNAH',
            wni_country: 'IN',
            wni_lat: 18.9566,
            wni_lon: 72.9414,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'NHAT',
            wni_port_name: 'NHATRANG (NHA TRANG)',
            wni_unlocode: 'VNNHA',
            wni_country: 'VN',
            wni_lat: 12.2008,
            wni_lon: 109.2201,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'NHV',
            wni_port_name: 'NEW HAVEN',
            wni_unlocode: 'USHVN',
            wni_country: 'US',
            wni_lat: 41.2629,
            wni_lon: -72.9148,
            wni_tz: 'America/New_York',
        },
        {
            option: 'NIC',
            wni_port_name: 'NICE',
            wni_unlocode: 'FRNCE',
            wni_country: 'FR',
            wni_lat: 43.6657,
            wni_lon: 7.288,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'NIHE',
            wni_port_name: 'NIIHAMA',
            wni_unlocode: 'JPIHA',
            wni_country: 'JP',
            wni_lat: 33.99,
            wni_lon: 133.2617,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NII',
            wni_port_name: 'NIIGATA',
            wni_unlocode: 'JPAIK',
            wni_country: 'JP',
            wni_lat: 38.0367,
            wni_lon: 139.2383,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NIKI',
            wni_port_name: 'NIKISKI',
            wni_unlocode: 'USNIK',
            wni_country: 'US',
            wni_lat: 60.6786,
            wni_lon: -151.4101,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'NIPAH',
            wni_port_name: 'NIPAH ANCHORAGE',
            wni_unlocode: 'IDNIP',
            wni_country: 'ID',
            wni_lat: 1.1069,
            wni_lon: 103.635,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'NKG',
            wni_port_name: 'KIN NAKAGUSUKU',
            wni_unlocode: 'JPKNX',
            wni_country: 'JP',
            wni_lat: 26.2164,
            wni_lon: 127.8063,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NKL',
            wni_port_name: 'NIKOLAYEV',
            wni_unlocode: 'UANIK',
            wni_country: 'UA',
            wni_lat: 46.9303,
            wni_lon: 32.0066,
            wni_tz: 'Europe/Zaporozhye',
        },
        {
            option: 'NKLOS',
            wni_port_name: 'AGIOS NIKOLAOS',
            wni_unlocode: 'GRTHI',
            wni_country: 'GR',
            wni_lat: 38.3511,
            wni_lon: 22.6675,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'NKT',
            wni_port_name: 'NOUAKCHOTT',
            wni_unlocode: 'MRNKC',
            wni_country: 'MR',
            wni_lat: 18.0363,
            wni_lon: -16.0365,
            wni_tz: 'Africa/Nouakchott',
        },
        {
            option: 'NKTSU',
            wni_port_name: 'NAKATSU',
            wni_unlocode: 'JPNAT',
            wni_country: 'JP',
            wni_lat: 33.6225,
            wni_lon: 131.2598,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NLD',
            wni_port_name: 'NEW LONDON',
            wni_unlocode: 'USGON',
            wni_country: 'US',
            wni_lat: 41.3102,
            wni_lon: -72.0799,
            wni_tz: 'America/New_York',
        },
        {
            option: 'NMB',
            wni_port_name: 'NAMIBE',
            wni_unlocode: 'AOMSZ',
            wni_country: 'AO',
            wni_lat: -15.1591,
            wni_lon: 12.0786,
            wni_tz: 'Africa/Luanda',
        },
        {
            option: 'NMG',
            wni_port_name: 'NEW MANGALORE',
            wni_unlocode: 'INNML',
            wni_country: 'IN',
            wni_lat: 12.9227,
            wni_lon: 74.7903,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'NMR',
            wni_port_name: 'NEMRUT BAY',
            wni_unlocode: 'TRNEM',
            wni_country: 'TR',
            wni_lat: 38.7761,
            wni_lon: 26.9092,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'NNK',
            wni_port_name: 'NANJING',
            wni_unlocode: 'CNNJG',
            wni_country: 'CN',
            wni_lat: 32.1178,
            wni_lon: 118.7444,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'NNKAN',
            wni_port_name: 'NUNUKAN',
            wni_unlocode: 'IDNNX',
            wni_country: 'ID',
            wni_lat: 4.1532,
            wni_lon: 117.6458,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'NNO',
            wni_port_name: 'NANAO',
            wni_unlocode: 'JPNNO',
            wni_country: 'JP',
            wni_lat: 37.0619,
            wni_lon: 136.9824,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NOC',
            wni_port_name: 'NORCO',
            wni_unlocode: 'USNCM',
            wni_country: 'US',
            wni_lat: 29.9773,
            wni_lon: -90.3976,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'NOLA',
            wni_port_name: 'NEW ORLEANS',
            wni_unlocode: 'USMSY',
            wni_country: 'US',
            wni_lat: 29.9489,
            wni_lon: -90.0587,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'NOMOT',
            wni_port_name: 'NISHINOOMOTE',
            wni_unlocode: 'JPIIN',
            wni_country: 'JP',
            wni_lat: 30.7351,
            wni_lon: 130.9736,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NOR',
            wni_port_name: 'NORFOLK',
            wni_unlocode: 'USNFF',
            wni_country: 'US',
            wni_lat: 36.849,
            wni_lon: -76.3007,
            wni_tz: 'America/New_York',
        },
        {
            option: 'NOUM',
            wni_port_name: 'NOUMEA',
            wni_unlocode: 'NCNOU',
            wni_country: 'NC',
            wni_lat: -22.2911,
            wni_lon: 166.4163,
            wni_tz: 'Pacific/Noumea',
        },
        {
            option: 'NOV',
            wni_port_name: 'NOVOROSSIJSK',
            wni_unlocode: 'RUNOI',
            wni_country: 'RU',
            wni_lat: 44.7073,
            wni_lon: 37.811,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'NPN',
            wni_port_name: 'NEWPORT NEWS',
            wni_unlocode: 'USNEN',
            wni_country: 'US',
            wni_lat: 36.9637,
            wni_lon: -76.4416,
            wni_tz: 'America/New_York',
        },
        {
            option: 'NPP',
            wni_port_name: 'NORTH PULAU LAUT',
            wni_unlocode: 'IDNPL',
            wni_country: 'ID',
            wni_lat: -3.1993,
            wni_lon: 116.2921,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'NPPT',
            wni_port_name: 'NAGAPPATTINAM',
            wni_unlocode: 'INNPT',
            wni_country: 'IN',
            wni_lat: 10.7648,
            wni_lon: 79.8633,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'NPU',
            wni_port_name: 'NEWPORT',
            wni_unlocode: 'GBPRU',
            wni_country: 'GB',
            wni_lat: 51.5278,
            wni_lon: -2.984,
            wni_tz: 'Europe/London',
        },
        {
            option: 'NRK',
            wni_port_name: 'NORRKOPING',
            wni_unlocode: 'SENRK',
            wni_country: 'SE',
            wni_lat: 58.6169,
            wni_lon: 16.2619,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'NRO',
            wni_port_name: 'NORO',
            wni_unlocode: 'SBNOR',
            wni_country: 'SB',
            wni_lat: -8.1981,
            wni_lon: 157.1992,
            wni_tz: 'Pacific/Guadalcanal',
        },
        {
            option: 'NSA',
            wni_port_name: 'NANSHA',
            wni_unlocode: 'CNNSA',
            wni_country: 'CN',
            wni_lat: 22.6325,
            wni_lon: 113.6947,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'NSH',
            wni_port_name: 'NOSHIRO',
            wni_unlocode: 'JPNSR',
            wni_country: 'JP',
            wni_lat: 40.2069,
            wni_lon: 139.9708,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NSK',
            wni_port_name: 'MITAJIRI NAKANOSEKI',
            wni_unlocode: 'JPNAN',
            wni_country: 'JP',
            wni_lat: 33.9856,
            wni_lon: 131.5428,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NTO',
            wni_port_name: 'NANTONG',
            wni_unlocode: 'CNHIM',
            wni_country: 'CN',
            wni_lat: 31.9863,
            wni_lon: 120.8214,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'NTY',
            wni_port_name: 'NAKETY',
            wni_unlocode: 'NCNAK',
            wni_country: 'NC',
            wni_lat: -21.52,
            wni_lon: 166.0834,
            wni_tz: 'Pacific/Noumea',
        },
        {
            option: 'NUD',
            wni_port_name: 'NOUADHIBOU (PORT ETIENNE)',
            wni_unlocode: 'MRNDB',
            wni_country: 'MR',
            wni_lat: 20.8097,
            wni_lon: -17.0269,
            wni_tz: 'Africa/Nouakchott',
        },
        {
            option: 'NUE',
            wni_port_name: 'NUEVA PALMIRA',
            wni_unlocode: 'UYNVP',
            wni_country: 'UY',
            wni_lat: -33.881,
            wni_lon: -58.4354,
            wni_tz: 'America/Montevideo',
        },
        {
            option: 'NUK',
            wni_port_name: 'NEWHAVEN',
            wni_unlocode: 'GBNHV',
            wni_country: 'GB',
            wni_lat: 50.7643,
            wni_lon: 0.0523,
            wni_tz: 'Europe/London',
        },
        {
            option: 'NUUK',
            wni_port_name: 'PORT OF NUUK',
            wni_unlocode: 'GLGOH',
            wni_country: 'GL',
            wni_lat: 64.1635,
            wni_lon: -51.7718,
            wni_tz: 'America/Godthab',
        },
        {
            option: 'NVGNT',
            wni_port_name: 'NAVEGANTES',
            wni_unlocode: 'BRNVT',
            wni_country: 'BR',
            wni_lat: -26.8994,
            wni_lon: -48.6632,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'NVK',
            wni_port_name: 'NARVIK',
            wni_unlocode: 'NONVK',
            wni_country: 'NO',
            wni_lat: 68.423,
            wni_lon: 17.4086,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'NWA',
            wni_port_name: 'NEW AMSTERDAM',
            wni_unlocode: 'GYNAM',
            wni_country: 'GY',
            wni_lat: 6.2507,
            wni_lon: -57.53,
            wni_tz: 'America/Guyana',
        },
        {
            option: 'NWK',
            wni_port_name: 'NEWARK',
            wni_unlocode: 'USEWR',
            wni_country: 'US',
            wni_lat: 40.7122,
            wni_lon: -74.1126,
            wni_tz: 'America/New_York',
        },
        {
            option: 'NWM',
            wni_port_name: 'NEW WESTMINSTER',
            wni_unlocode: 'CANWE',
            wni_country: 'CA',
            wni_lat: 49.1978,
            wni_lon: -122.9105,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'NWP',
            wni_port_name: 'NEW PLYMOUTH',
            wni_unlocode: 'NZNPL',
            wni_country: 'NZ',
            wni_lat: -39.0411,
            wni_lon: 174.0426,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'NYHAM',
            wni_port_name: 'NYHAMNA',
            wni_unlocode: 'NONYH',
            wni_country: 'NO',
            wni_lat: 62.859,
            wni_lon: 6.9638,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'NYK',
            wni_port_name: 'NEW YORK',
            wni_unlocode: 'USBOY',
            wni_country: 'US',
            wni_lat: 40.6985,
            wni_lon: -74.0071,
            wni_tz: 'America/New_York',
        },
        {
            option: 'OAK',
            wni_port_name: 'OAKLAND',
            wni_unlocode: 'USKND',
            wni_country: 'US',
            wni_lat: 37.8009,
            wni_lon: -122.352,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'OCBY',
            wni_port_name: 'OCOA BAY',
            wni_unlocode: 'DOOCO',
            wni_country: 'DO',
            wni_lat: 18.351,
            wni_lon: -70.641,
            wni_tz: 'America/Santo_Domingo',
        },
        {
            option: 'OCR',
            wni_port_name: 'OCHO RIOS',
            wni_unlocode: 'JMOCJ',
            wni_country: 'JM',
            wni_lat: 18.4183,
            wni_lon: -77.1153,
            wni_tz: 'America/Jamaica',
        },
        {
            option: 'ODN',
            wni_port_name: 'ODENSE',
            wni_unlocode: 'DKODE',
            wni_country: 'DK',
            wni_lat: 55.4419,
            wni_lon: 10.4393,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'ODS',
            wni_port_name: 'ODESSA',
            wni_unlocode: 'UAODS',
            wni_country: 'UA',
            wni_lat: 46.5087,
            wni_lon: 30.7859,
            wni_tz: 'Europe/Zaporozhye',
        },
        {
            option: 'ODUDU',
            wni_port_name: 'ODUDU',
            wni_unlocode: 'NGODU',
            wni_country: 'NG',
            wni_lat: 4.0083,
            wni_lon: 7.7578,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'OFU',
            wni_port_name: 'OFUNATO',
            wni_unlocode: 'JPOFT',
            wni_country: 'JP',
            wni_lat: 39.0477,
            wni_lon: 141.7284,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'OHAO',
            wni_port_name: 'OLHAO',
            wni_unlocode: 'PTOLH',
            wni_country: 'PT',
            wni_lat: 36.997,
            wni_lon: -7.788,
            wni_tz: 'Europe/Lisbon',
        },
        {
            option: 'OIT',
            wni_port_name: 'OITA',
            wni_unlocode: 'JPBPU',
            wni_country: 'JP',
            wni_lat: 33.2655,
            wni_lon: 131.7682,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'OKH',
            wni_port_name: 'OKHA',
            wni_unlocode: 'INOKH',
            wni_country: 'IN',
            wni_lat: 22.4802,
            wni_lon: 69.0882,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'OKK',
            wni_port_name: 'OKKE',
            wni_unlocode: 'KROKK',
            wni_country: 'KR',
            wni_lat: 37.6277,
            wni_lon: 129.0708,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'OKONO',
            wni_port_name: 'OKONO TERMINAL',
            wni_unlocode: 'NGOKN',
            wni_country: 'NG',
            wni_lat: 3.9833,
            wni_lon: 7.2833,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'OKP',
            wni_port_name: 'OKPO',
            wni_unlocode: 'KROKP',
            wni_country: 'KR',
            wni_lat: 34.9012,
            wni_lon: 128.7231,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'OKWRI',
            wni_port_name: 'OKWORI TERMINAL',
            wni_unlocode: 'NGOKW',
            wni_country: 'NG',
            wni_lat: 3.85,
            wni_lon: 6.9833,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'OLY',
            wni_port_name: 'OLYMPIA',
            wni_unlocode: 'USOLM',
            wni_country: 'US',
            wni_lat: 47.0647,
            wni_lon: -122.9061,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'OMA',
            wni_port_name: 'OMAEZAKI',
            wni_unlocode: 'JPOMZ',
            wni_country: 'JP',
            wni_lat: 34.65,
            wni_lon: 138.2324,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'OMSLJ',
            wni_port_name: 'OMISALJ',
            wni_unlocode: 'HROMI',
            wni_country: 'HR',
            wni_lat: 45.235,
            wni_lon: 14.5262,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'ONA',
            wni_port_name: 'ONAHAMA',
            wni_unlocode: 'JPONA',
            wni_country: 'JP',
            wni_lat: 36.9018,
            wni_lon: 140.8921,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'ONN',
            wni_port_name: 'ONNE',
            wni_unlocode: 'NGONN',
            wni_country: 'NG',
            wni_lat: 4.6499,
            wni_lon: 7.1492,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'ONS',
            wni_port_name: 'ONSAN',
            wni_unlocode: 'KRONS',
            wni_country: 'KR',
            wni_lat: 35.4497,
            wni_lon: 129.3917,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'ONSL',
            wni_port_name: 'ONSLOW',
            wni_unlocode: 'AUONS',
            wni_country: 'AU',
            wni_lat: -21.6235,
            wni_lon: 115.1106,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'OONS',
            wni_port_name: 'OHNISHI',
            wni_unlocode: 'JPONS',
            wni_country: 'JP',
            wni_lat: 34.0741,
            wni_lon: 132.9067,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'ORA',
            wni_port_name: 'ORAN',
            wni_unlocode: 'DZORN',
            wni_country: 'DZ',
            wni_lat: 35.7207,
            wni_lon: -0.6397,
            wni_tz: 'Africa/Algiers',
        },
        {
            option: 'ORJ',
            wni_port_name: 'ORANJESTAD',
            wni_unlocode: 'AWORJ',
            wni_country: 'AW',
            wni_lat: 12.5067,
            wni_lon: -70.0466,
            wni_tz: 'America/Aruba',
        },
        {
            option: 'ORKG',
            wni_port_name: 'ORKANGER',
            wni_unlocode: 'NOORK',
            wni_country: 'NO',
            wni_lat: 63.3256,
            wni_lon: 9.8639,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'ORM',
            wni_port_name: 'ORMOC',
            wni_unlocode: 'PHORC',
            wni_country: 'PH',
            wni_lat: 10.9927,
            wni_lon: 124.6027,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'ORO',
            wni_port_name: 'ORISTANO',
            wni_unlocode: 'ITQOS',
            wni_country: 'IT',
            wni_lat: 39.8639,
            wni_lon: 8.5253,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'OSA',
            wni_port_name: 'OSAKA',
            wni_unlocode: 'JPHOO',
            wni_country: 'JP',
            wni_lat: 34.6229,
            wni_lon: 135.3749,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'OSO',
            wni_port_name: 'OSLO',
            wni_unlocode: 'NOOSL',
            wni_country: 'NO',
            wni_lat: 59.8971,
            wni_lon: 10.7195,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'OTA',
            wni_port_name: 'OTARU',
            wni_unlocode: 'JPOTR',
            wni_country: 'JP',
            wni_lat: 43.2,
            wni_lon: 141.0272,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'OUDN',
            wni_port_name: 'OUDNA TERMINAL',
            wni_unlocode: 'TNOUD',
            wni_country: 'TN',
            wni_lat: 34.5666,
            wni_lon: 12.5166,
            wni_tz: 'Africa/Tunis',
        },
        {
            option: 'OWD',
            wni_port_name: 'OWENDO',
            wni_unlocode: 'GAOWE',
            wni_country: 'GA',
            wni_lat: 0.2763,
            wni_lon: 9.4899,
            wni_tz: 'Africa/Libreville',
        },
        {
            option: 'OWS',
            wni_port_name: 'OWASE',
            wni_unlocode: 'JPOWA',
            wni_country: 'JP',
            wni_lat: 34.0475,
            wni_lon: 136.2931,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'OXL',
            wni_port_name: 'OXELOSUND',
            wni_unlocode: 'SEOXE',
            wni_country: 'SE',
            wni_lat: 58.6784,
            wni_lon: 17.1726,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'PA',
            wni_port_name: 'PANAMA CANAL',
            wni_unlocode: 'PACAN',
            wni_country: 'PA',
            wni_lat: 9.1207,
            wni_lon: -79.75,
            wni_tz: 'America/Panama',
        },
        {
            option: 'PAB',
            wni_port_name: 'PORTO ALEGRE',
            wni_unlocode: 'BRPOA',
            wni_country: 'BR',
            wni_lat: -30.0477,
            wni_lon: -51.2472,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'PACHI',
            wni_port_name: 'PACHI',
            wni_unlocode: 'GRPME',
            wni_country: 'GR',
            wni_lat: 37.9605,
            wni_lon: 23.3826,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'PAD',
            wni_port_name: 'ADELAIDE',
            wni_unlocode: 'AUADL',
            wni_country: 'AU',
            wni_lat: -34.8425,
            wni_lon: 138.5005,
            wni_tz: 'Australia/Adelaide',
        },
        {
            option: 'PAG',
            wni_port_name: 'PORT ANGELES',
            wni_unlocode: 'USCLM',
            wni_country: 'US',
            wni_lat: 48.1466,
            wni_lon: -123.399,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'PAGB',
            wni_port_name: 'PAGBILAO',
            wni_unlocode: 'PHSOR',
            wni_country: 'PH',
            wni_lat: 13.8868,
            wni_lon: 121.7336,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'PAGE',
            wni_port_name: 'PAAGOUMENE',
            wni_unlocode: 'NCPAA',
            wni_country: 'NC',
            wni_lat: -20.4986,
            wni_lon: 164.1614,
            wni_tz: 'Pacific/Noumea',
        },
        {
            option: 'PAGM',
            wni_port_name: 'PUERTO ANGAMOS',
            wni_unlocode: 'CLPAG',
            wni_country: 'CL',
            wni_lat: -23.059,
            wni_lon: -70.3942,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'PAH',
            wni_port_name: 'PORT ARTHUR',
            wni_unlocode: 'USBMT',
            wni_country: 'US',
            wni_lat: 29.8601,
            wni_lon: -93.9143,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'PAI',
            wni_port_name: 'PAITA',
            wni_unlocode: 'PEPAI',
            wni_country: 'PE',
            wni_lat: -5.0782,
            wni_lon: -81.1112,
            wni_tz: 'America/Lima',
        },
        {
            option: 'PAJ',
            wni_port_name: 'PASAJES',
            wni_unlocode: 'ESPAS',
            wni_country: 'ES',
            wni_lat: 43.3361,
            wni_lon: -1.9309,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'PAO',
            wni_port_name: 'PAGO PAGO',
            wni_unlocode: 'ASPPG',
            wni_country: 'AS',
            wni_lat: -14.2964,
            wni_lon: -170.6692,
            wni_tz: 'Pacific/Pago_Pago',
        },
        {
            option: 'PAP',
            wni_port_name: 'PAPEETE',
            wni_unlocode: 'PFPPT',
            wni_country: 'PF',
            wni_lat: -17.5275,
            wni_lon: -149.5903,
            wni_tz: 'Pacific/Tahiti',
        },
        {
            option: 'PAT',
            wni_port_name: 'CALETA PATILLOS',
            wni_unlocode: 'CLCAL',
            wni_country: 'CL',
            wni_lat: -20.7401,
            wni_lon: -70.1985,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'PAU',
            wni_port_name: 'PORT AU PRINCE',
            wni_unlocode: 'HTPAP',
            wni_country: 'HT',
            wni_lat: 18.5538,
            wni_lon: -72.3643,
            wni_tz: 'America/Port-au-Prince',
        },
        {
            option: 'PBA',
            wni_port_name: 'PUERTO BARRIOS',
            wni_unlocode: 'GTPBR',
            wni_country: 'GT',
            wni_lat: 15.7414,
            wni_lon: -88.6126,
            wni_tz: 'America/Guatemala',
        },
        {
            option: 'PBC',
            wni_port_name: 'PITTSBURG',
            wni_unlocode: 'USPBG',
            wni_country: 'US',
            wni_lat: 38.0468,
            wni_lon: -121.8891,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'PBCH',
            wni_port_name: 'PALM BEACH',
            wni_unlocode: 'USPAB',
            wni_country: 'US',
            wni_lat: 26.7711,
            wni_lon: -80.0223,
            wni_tz: 'America/New_York',
        },
        {
            option: 'PBG',
            wni_port_name: 'PALEMBANG',
            wni_unlocode: 'IDPLM',
            wni_country: 'ID',
            wni_lat: -2.983,
            wni_lon: 104.7812,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'PBN',
            wni_port_name: 'PORBANDAR',
            wni_unlocode: 'INPBD',
            wni_country: 'IN',
            wni_lat: 21.6208,
            wni_lon: 69.5993,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'PBP',
            wni_port_name: 'PUERTO BAYOVAR',
            wni_unlocode: 'PEPUB',
            wni_country: 'PE',
            wni_lat: -5.8053,
            wni_lon: -81.0384,
            wni_tz: 'America/Lima',
        },
        {
            option: 'PBQ',
            wni_port_name: 'MUHAMMAD BIN QASIM',
            wni_unlocode: 'PKBQM',
            wni_country: 'PK',
            wni_lat: 24.7716,
            wni_lon: 67.3046,
            wni_tz: 'Asia/Karachi',
        },
        {
            option: 'PBY',
            wni_port_name: 'PULAU BUNYU',
            wni_unlocode: 'IDPBJ',
            wni_country: 'ID',
            wni_lat: 3.454,
            wni_lon: 117.8265,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'PCA',
            wni_port_name: 'PUNTA CARDON',
            wni_unlocode: 'VEPCN',
            wni_country: 'VE',
            wni_lat: 11.6183,
            wni_lon: -70.2445,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'PCB',
            wni_port_name: 'PRACHUAP',
            wni_unlocode: 'THPKK',
            wni_country: 'TH',
            wni_lat: 11.1954,
            wni_lon: 99.5919,
            wni_tz: 'Asia/Bangkok',
        },
        {
            option: 'PCE',
            wni_port_name: 'PONCE',
            wni_unlocode: 'PRPSE',
            wni_country: 'PR',
            wni_lat: 17.9664,
            wni_lon: -66.6287,
            wni_tz: 'America/Puerto_Rico',
        },
        {
            option: 'PCG',
            wni_port_name: 'TANJUNG PEMANCINGAN',
            wni_unlocode: 'IDTPN',
            wni_country: 'ID',
            wni_lat: -3.203,
            wni_lon: 116.2938,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'PCH',
            wni_port_name: 'PORT CHALMERS',
            wni_unlocode: 'NZPOE',
            wni_country: 'NZ',
            wni_lat: -45.8127,
            wni_lon: 170.6392,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'PCHU',
            wni_port_name: 'PUNTA CHUNGO',
            wni_unlocode: 'CLPTC',
            wni_country: 'CL',
            wni_lat: -31.8892,
            wni_lon: -71.5181,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'PCK',
            wni_port_name: 'PECKET',
            wni_unlocode: 'CLPCK',
            wni_country: 'CL',
            wni_lat: -52.9421,
            wni_lon: -71.2001,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'PCL',
            wni_port_name: 'PORTOCEL',
            wni_unlocode: 'BRPCL',
            wni_country: 'BR',
            wni_lat: -19.8459,
            wni_lon: -40.0439,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'PCOV',
            wni_port_name: 'COVENAS',
            wni_unlocode: 'COCVE',
            wni_country: 'CO',
            wni_lat: 9.4205,
            wni_lon: -75.691,
            wni_tz: 'America/Bogota',
        },
        {
            option: 'PCR',
            wni_port_name: 'PORT CARTIER',
            wni_unlocode: 'CAPCA',
            wni_country: 'CA',
            wni_lat: 50.0044,
            wni_lon: -66.8101,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'PCT',
            wni_port_name: 'POINT COMFORT',
            wni_unlocode: 'USPCR',
            wni_country: 'US',
            wni_lat: 28.5983,
            wni_lon: -96.5543,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'PCY',
            wni_port_name: 'PANAMA CITY',
            wni_unlocode: 'USPFN',
            wni_country: 'US',
            wni_lat: 30.17,
            wni_lon: -85.7302,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'PDB',
            wni_port_name: 'PORT DE BOUC',
            wni_unlocode: 'FRPDB',
            wni_country: 'FR',
            wni_lat: 43.394,
            wni_lon: 4.9829,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'PDE',
            wni_port_name: 'PONTA DELGADA',
            wni_unlocode: 'PTPDL',
            wni_country: 'PT',
            wni_lat: 37.7257,
            wni_lon: -25.6545,
            wni_tz: 'Atlantic/Azores',
        },
        {
            option: 'PDK',
            wni_port_name: 'PALDISKI',
            wni_unlocode: 'EEPLA',
            wni_country: 'EE',
            wni_lat: 59.3719,
            wni_lon: 23.967,
            wni_tz: 'Europe/Tallinn',
        },
        {
            option: 'PDN',
            wni_port_name: 'PADANG',
            wni_unlocode: 'IDPDG',
            wni_country: 'ID',
            wni_lat: -0.9616,
            wni_lon: 100.343,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'PDR',
            wni_port_name: 'POINTE DES GALETS',
            wni_unlocode: 'REPDG',
            wni_country: 'RE',
            wni_lat: -20.9333,
            wni_lon: 55.2731,
            wni_tz: 'Indian/Reunion',
        },
        {
            option: 'PDRU',
            wni_port_name: 'PUERTO DRUMMOND',
            wni_unlocode: 'COPDO',
            wni_country: 'CO',
            wni_lat: 11.0771,
            wni_lon: -74.241,
            wni_tz: 'America/Bogota',
        },
        {
            option: 'PDS',
            wni_port_name: 'PORT DICKSON',
            wni_unlocode: 'MYPDI',
            wni_country: 'MY',
            wni_lat: 2.5181,
            wni_lon: 101.7752,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'PDT',
            wni_port_name: 'PORTLAND\t OR',
            wni_unlocode: 'USPDX',
            wni_country: 'US',
            wni_lat: 45.5358,
            wni_lon: -122.6794,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'PDY',
            wni_port_name: 'PORT MOODY',
            wni_unlocode: 'CAPMO',
            wni_country: 'CA',
            wni_lat: 49.2892,
            wni_lon: -122.8611,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'PEA',
            wni_port_name: 'PERTH AMBOY',
            wni_unlocode: 'USPAY',
            wni_country: 'US',
            wni_lat: 40.4887,
            wni_lon: -74.2608,
            wni_tz: 'America/New_York',
        },
        {
            option: 'PEE',
            wni_port_name: 'PECEM',
            wni_unlocode: 'BRPEC',
            wni_country: 'BR',
            wni_lat: -3.526,
            wni_lon: -38.7884,
            wni_tz: 'America/Fortaleza',
        },
        {
            option: 'PEG',
            wni_port_name: 'PENGLAI',
            wni_unlocode: 'CNPLA',
            wni_country: 'CN',
            wni_lat: 37.8374,
            wni_lon: 120.7254,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'PEL',
            wni_port_name: 'PORT ELIZABETH',
            wni_unlocode: 'ZAPLZ',
            wni_country: 'ZA',
            wni_lat: -33.945,
            wni_lon: 25.6422,
            wni_tz: 'Africa/Johannesburg',
        },
        {
            option: 'PEP',
            wni_port_name: 'PEPEL',
            wni_unlocode: 'SLPEP',
            wni_country: 'SL',
            wni_lat: 8.5663,
            wni_lon: -13.0527,
            wni_tz: 'Africa/Freetown',
        },
        {
            option: 'PEU',
            wni_port_name: 'PUNTA DEL ESTE',
            wni_unlocode: 'UYPDP',
            wni_country: 'UY',
            wni_lat: -34.9616,
            wni_lon: -54.9618,
            wni_tz: 'America/Montevideo',
        },
        {
            option: 'PEV',
            wni_port_name: 'PORT EVERGLADES',
            wni_unlocode: 'USPEF',
            wni_country: 'US',
            wni_lat: 26.0937,
            wni_lon: -80.0951,
            wni_tz: 'America/New_York',
        },
        {
            option: 'PFT',
            wni_port_name: 'POINT FORTIN',
            wni_unlocode: 'TTPTF',
            wni_country: 'TT',
            wni_lat: 10.214,
            wni_lon: -61.7112,
            wni_tz: 'America/Port_of_Spain',
        },
        {
            option: 'PGD',
            wni_port_name: 'PORTO GRANDE ( MINDELO )',
            wni_unlocode: 'CVGRA',
            wni_country: 'CV',
            wni_lat: 16.9016,
            wni_lon: -25.0204,
            wni_tz: 'Atlantic/Cape_Verde',
        },
        {
            option: 'PGN',
            wni_port_name: 'PORT GENTIL',
            wni_unlocode: 'GAPOG',
            wni_country: 'GA',
            wni_lat: -0.678,
            wni_lon: 8.7849,
            wni_tz: 'Africa/Libreville',
        },
        {
            option: 'PGR',
            wni_port_name: 'PROGRESO',
            wni_unlocode: 'MXPGO',
            wni_country: 'MX',
            wni_lat: 21.3462,
            wni_lon: -89.6911,
            wni_tz: 'America/Merida',
        },
        {
            option: 'PGT',
            wni_port_name: 'PENNINGTON TERMINAL',
            wni_unlocode: 'NGPEN',
            wni_country: 'NG',
            wni_lat: 4.6333,
            wni_lon: 5.4333,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'PHA',
            wni_port_name: 'PORT HARCOURT',
            wni_unlocode: 'NGPHC',
            wni_country: 'NG',
            wni_lat: 4.7726,
            wni_lon: 7.0031,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'PHG',
            wni_port_name: 'PHILIPSBURG',
            wni_unlocode: 'ANPHI',
            wni_country: 'SX',
            wni_lat: 18.0055,
            wni_lon: -63.0537,
            wni_tz: 'America/Curacao',
        },
        {
            option: 'PHK',
            wni_port_name: 'PORT HAWKESBURY',
            wni_unlocode: 'CAPHW',
            wni_country: 'CA',
            wni_lat: 45.611,
            wni_lon: -61.3789,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'PHL',
            wni_port_name: 'PHILADELPHIA',
            wni_unlocode: 'USPDP',
            wni_country: 'US',
            wni_lat: 39.9504,
            wni_lon: -75.1346,
            wni_tz: 'America/New_York',
        },
        {
            option: 'PHMY',
            wni_port_name: 'PHU MY',
            wni_unlocode: 'VNPHU',
            wni_country: 'VN',
            wni_lat: 10.5856,
            wni_lon: 107.026,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'PHU',
            wni_port_name: 'PORT HUENEME',
            wni_unlocode: 'USNTD',
            wni_country: 'US',
            wni_lat: 34.1383,
            wni_lon: -119.2183,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'PHW',
            wni_port_name: 'PORT HEDLAND',
            wni_unlocode: 'AUPHE',
            wni_country: 'AU',
            wni_lat: -20.2938,
            wni_lon: 118.5817,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'PIA',
            wni_port_name: 'PITEA',
            wni_unlocode: 'SEPIT',
            wni_country: 'SE',
            wni_lat: 65.2196,
            wni_lon: 21.5525,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'PILO',
            wni_port_name: 'PYLOS',
            wni_unlocode: 'GRPYL',
            wni_country: 'GR',
            wni_lat: 36.9249,
            wni_lon: 21.692,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'PIO',
            wni_port_name: 'PIOMBINO',
            wni_unlocode: 'ITPIO',
            wni_country: 'IT',
            wni_lat: 42.9183,
            wni_lon: 10.5639,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'PIP',
            wni_port_name: 'PIPAVAV',
            wni_unlocode: 'INPAV',
            wni_country: 'IN',
            wni_lat: 20.894,
            wni_lon: 71.5242,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'PIR',
            wni_port_name: 'PIRAEUS',
            wni_unlocode: 'GRPIR',
            wni_country: 'GR',
            wni_lat: 37.9281,
            wni_lon: 23.61,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'PITN',
            wni_port_name: 'PICTON',
            wni_unlocode: 'NZPCN',
            wni_country: 'NZ',
            wni_lat: -41.264,
            wni_lon: 174.0159,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'PJR',
            wni_port_name: 'PAJARITOS',
            wni_unlocode: 'MXPAJ',
            wni_country: 'MX',
            wni_lat: 18.1278,
            wni_lon: -94.4028,
            wni_tz: 'America/Mexico_City',
        },
        {
            option: 'PJX',
            wni_port_name: 'POMALAA',
            wni_unlocode: 'IDPUM',
            wni_country: 'ID',
            wni_lat: -4.2181,
            wni_lon: 121.5686,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'PKE',
            wni_port_name: 'PORT KEMBLA',
            wni_unlocode: 'AUKGA',
            wni_country: 'AU',
            wni_lat: -34.4666,
            wni_lon: 150.9081,
            wni_tz: 'Australia/Sydney',
        },
        {
            option: 'PLAT',
            wni_port_name: 'PLATONG TERMINAL',
            wni_unlocode: 'THPLA',
            wni_country: 'TH',
            wni_lat: 9.6667,
            wni_lon: 101.4333,
            wni_tz: 'Asia/Bangkok',
        },
        {
            option: 'PLATA',
            wni_port_name: 'LA PLATA (EVA PERON)',
            wni_unlocode: 'ARLPG',
            wni_country: 'AR',
            wni_lat: -34.8211,
            wni_lon: -57.8747,
            wni_tz: 'America/Argentina/Buenos_Aires',
        },
        {
            option: 'PLB',
            wni_port_name: 'PORT ALBERNI',
            wni_unlocode: 'CAPAB',
            wni_country: 'CA',
            wni_lat: 49.2311,
            wni_lon: -124.8255,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'PLC',
            wni_port_name: 'PORT LINCOLN',
            wni_unlocode: 'AUPLO',
            wni_country: 'AU',
            wni_lat: -34.7027,
            wni_lon: 135.9715,
            wni_tz: 'Australia/Adelaide',
        },
        {
            option: 'PLD',
            wni_port_name: 'PLAJU',
            wni_unlocode: 'IDPLA',
            wni_country: 'ID',
            wni_lat: -2.9864,
            wni_lon: 104.834,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'PLI',
            wni_port_name: 'POINT LISAS',
            wni_unlocode: 'TTPTS',
            wni_country: 'TT',
            wni_lat: 10.3935,
            wni_lon: -61.5044,
            wni_tz: 'America/Port_of_Spain',
        },
        {
            option: 'PLIB',
            wni_port_name: 'PUERTO LIBERTAD',
            wni_unlocode: 'MXPTL',
            wni_country: 'MX',
            wni_lat: 29.8841,
            wni_lon: -112.7048,
            wni_tz: 'America/Hermosillo',
        },
        {
            option: 'PLK',
            wni_port_name: 'PETROPAVLOSK-KAMCHATSKIY',
            wni_unlocode: 'RUPKC',
            wni_country: 'RU',
            wni_lat: 52.8868,
            wni_lon: 158.6697,
            wni_tz: 'Asia/Kamchatka',
        },
        {
            option: 'PLL',
            wni_port_name: 'POLICE',
            wni_unlocode: 'PLPLC',
            wni_country: 'PL',
            wni_lat: 53.563,
            wni_lon: 14.5971,
            wni_tz: 'Europe/Warsaw',
        },
        {
            option: 'PLM',
            wni_port_name: 'PUERTO LIMON',
            wni_unlocode: 'CRLIO',
            wni_country: 'CR',
            wni_lat: 9.9829,
            wni_lon: -83.0147,
            wni_tz: 'America/Costa_Rica',
        },
        {
            option: 'PLN',
            wni_port_name: 'PORTLAND',
            wni_unlocode: 'AUPTJ',
            wni_country: 'AU',
            wni_lat: -38.338,
            wni_lon: 141.6292,
            wni_tz: 'Australia/Melbourne',
        },
        {
            option: 'PLNCA',
            wni_port_name: 'PALANCA TERMINAL',
            wni_unlocode: 'AOPAT',
            wni_country: 'AO',
            wni_lat: -6.95,
            wni_lon: 12.4,
            wni_tz: 'Africa/Luanda',
        },
        {
            option: 'PLNQ',
            wni_port_name: 'PALENQUE',
            wni_unlocode: 'DOPAL',
            wni_country: 'DO',
            wni_lat: 18.2166,
            wni_lon: -70.1666,
            wni_tz: 'America/Santo_Domingo',
        },
        {
            option: 'PLO',
            wni_port_name: 'PLOCE',
            wni_unlocode: 'HRPLE',
            wni_country: 'HR',
            wni_lat: 43.0273,
            wni_lon: 17.4093,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'PLOS',
            wni_port_name: 'PUNTA LOBITOS',
            wni_unlocode: 'PEPLO',
            wni_country: 'PE',
            wni_lat: -10.0969,
            wni_lon: -78.1903,
            wni_tz: 'America/Lima',
        },
        {
            option: 'PLT',
            wni_port_name: 'PORT LATTA',
            wni_unlocode: 'AUPLA',
            wni_country: 'AU',
            wni_lat: -40.8263,
            wni_lon: 145.391,
            wni_tz: 'Australia/Hobart',
        },
        {
            option: 'PLV',
            wni_port_name: 'PORT LAVACA',
            wni_unlocode: 'USPLV',
            wni_country: 'US',
            wni_lat: 28.6223,
            wni_lon: -96.6117,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'PLY',
            wni_port_name: 'PLYMOUTH',
            wni_unlocode: 'GBPLY',
            wni_country: 'GB',
            wni_lat: 50.3275,
            wni_lon: -4.17,
            wni_tz: 'Europe/London',
        },
        {
            option: 'PLZ',
            wni_port_name: 'PUERTO LA CRUZ',
            wni_unlocode: 'VEPCZ',
            wni_country: 'VE',
            wni_lat: 10.2277,
            wni_lon: -64.7075,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'PMA',
            wni_port_name: 'PONTA DA MADEIRA',
            wni_unlocode: 'BRPMA',
            wni_country: 'BR',
            wni_lat: -2.5572,
            wni_lon: -44.3877,
            wni_tz: 'America/Fortaleza',
        },
        {
            option: 'PMB',
            wni_port_name: 'PEMBROKE',
            wni_unlocode: 'GBPEM',
            wni_country: 'GB',
            wni_lat: 51.6946,
            wni_lon: -4.9757,
            wni_tz: 'Europe/London',
        },
        {
            option: 'PMD',
            wni_port_name: 'PALERMO',
            wni_unlocode: 'ITPMO',
            wni_country: 'IT',
            wni_lat: 38.1213,
            wni_lon: 13.3912,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'PML',
            wni_port_name: 'PUERTO ARMUELLES',
            wni_unlocode: 'PAAML',
            wni_country: 'PA',
            wni_lat: 8.2608,
            wni_lon: -82.8482,
            wni_tz: 'America/Panama',
        },
        {
            option: 'PMOI',
            wni_port_name: 'PUERTO MOIN',
            wni_unlocode: 'CRMOB',
            wni_country: 'CR',
            wni_lat: 10.0184,
            wni_lon: -83.0876,
            wni_tz: 'America/Costa_Rica',
        },
        {
            option: 'PMOL',
            wni_port_name: 'PRAIA MOLE',
            wni_unlocode: 'BRPML',
            wni_country: 'BR',
            wni_lat: -20.314,
            wni_lon: -40.2322,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'PMP',
            wni_port_name: 'PANAMA',
            wni_unlocode: 'PAPTY',
            wni_country: 'PA',
            wni_lat: 8.8911,
            wni_lon: -79.5213,
            wni_tz: 'America/Panama',
        },
        {
            option: 'PNA',
            wni_port_name: 'PUNTA ARENAS',
            wni_unlocode: 'CRPAS',
            wni_country: 'CR',
            wni_lat: 9.9666,
            wni_lon: -84.8166,
            wni_tz: 'America/Costa_Rica',
        },
        {
            option: 'PNAR',
            wni_port_name: 'PENARA TERMINAL',
            wni_unlocode: 'MYPMT',
            wni_country: 'MY',
            wni_lat: 6.2833,
            wni_lon: 105.0333,
            wni_tz: 'Etc/GMT-7',
        },
        {
            option: 'PNC',
            wni_port_name: 'PENSACOLA',
            wni_unlocode: 'USPNS',
            wni_country: 'US',
            wni_lat: 30.3863,
            wni_lon: -87.211,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'PND',
            wni_port_name: 'PORTLAND HARBOR',
            wni_unlocode: 'GBPRH',
            wni_country: 'GB',
            wni_lat: 50.5906,
            wni_lon: -2.4049,
            wni_tz: 'Europe/London',
        },
        {
            option: 'PNG',
            wni_port_name: 'PARANAGUA',
            wni_unlocode: 'BRPNG',
            wni_country: 'BR',
            wni_lat: -25.4893,
            wni_lon: -48.5411,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'PNI',
            wni_port_name: 'MUARA PANTAI',
            wni_unlocode: 'IDMUT',
            wni_country: 'ID',
            wni_lat: 1.9833,
            wni_lon: 118.1333,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'PNJ',
            wni_port_name: 'PANJANG',
            wni_unlocode: 'IDPNJ',
            wni_country: 'ID',
            wni_lat: -5.4848,
            wni_lon: 105.3068,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'PNL',
            wni_port_name: 'PENUELAS',
            wni_unlocode: 'PRPEN',
            wni_country: 'PR',
            wni_lat: 17.9599,
            wni_lon: -66.7605,
            wni_tz: 'America/Puerto_Rico',
        },
        {
            option: 'PNM',
            wni_port_name: 'PARANAM',
            wni_unlocode: 'SRPRM',
            wni_country: 'SR',
            wni_lat: 5.6146,
            wni_lon: -55.0898,
            wni_tz: 'America/Paramaribo',
        },
        {
            option: 'PNO',
            wni_port_name: 'POINTE NOIRE',
            wni_unlocode: 'CGPNR',
            wni_country: 'CG',
            wni_lat: -4.7834,
            wni_lon: 11.8076,
            wni_tz: 'Africa/Brazzaville',
        },
        {
            option: 'PNP',
            wni_port_name: 'POINTE A PITRE',
            wni_unlocode: 'GPPTP',
            wni_country: 'GP',
            wni_lat: 16.209,
            wni_lon: -61.5312,
            wni_tz: 'America/Guadeloupe',
        },
        {
            option: 'PNR',
            wni_port_name: 'POINTE NOIRE (CANADA)',
            wni_unlocode: 'CAPNO',
            wni_country: 'CA',
            wni_lat: 50.1744,
            wni_lon: -66.4832,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'PNTA',
            wni_port_name: 'PUNTA ARENAS',
            wni_unlocode: 'CLPUQ',
            wni_country: 'CL',
            wni_lat: -53.1764,
            wni_lon: -70.8968,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'PNTC',
            wni_port_name: 'PUERTO CALDERA',
            wni_unlocode: 'CRCAL',
            wni_country: 'CR',
            wni_lat: 9.9204,
            wni_lon: -84.7324,
            wni_tz: 'America/Costa_Rica',
        },
        {
            option: 'POB',
            wni_port_name: 'PORTBURY',
            wni_unlocode: 'GBPRU',
            wni_country: 'GB',
            wni_lat: 51.5051,
            wni_lon: -2.7384,
            wni_tz: 'Europe/London',
        },
        {
            option: 'POC',
            wni_port_name: 'PUERTO CABELLO',
            wni_unlocode: 'VEPBL',
            wni_country: 'VE',
            wni_lat: 10.4815,
            wni_lon: -68.0188,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'POF',
            wni_port_name: 'PORT ALFRED',
            wni_unlocode: 'CAALF',
            wni_country: 'CA',
            wni_lat: 48.3359,
            wni_lon: -70.8571,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'POH',
            wni_port_name: 'POHANG',
            wni_unlocode: 'KRKPO',
            wni_country: 'KR',
            wni_lat: 36.0374,
            wni_lon: 129.4356,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'POI',
            wni_port_name: 'PORT KAISER',
            wni_unlocode: 'JMPKS',
            wni_country: 'JM',
            wni_lat: 17.8467,
            wni_lon: -77.6041,
            wni_tz: 'America/Jamaica',
        },
        {
            option: 'POL',
            wni_port_name: 'PORT LOUIS',
            wni_unlocode: 'MUPLU',
            wni_country: 'MU',
            wni_lat: -20.1404,
            wni_lon: 57.4774,
            wni_tz: 'Indian/Mauritius',
        },
        {
            option: 'POOL',
            wni_port_name: 'POOLE BAY',
            wni_unlocode: 'GBPOO',
            wni_country: 'GB',
            wni_lat: 50.6756,
            wni_lon: -1.939,
            wni_tz: 'Europe/London',
        },
        {
            option: 'PORI',
            wni_port_name: 'PORI',
            wni_unlocode: 'FIMTL',
            wni_country: 'FI',
            wni_lat: 61.4908,
            wni_lon: 21.7992,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'PORO',
            wni_port_name: 'BAIE DE PORO',
            wni_unlocode: 'NCPOR',
            wni_country: 'NC',
            wni_lat: -21.2838,
            wni_lon: 165.7249,
            wni_tz: 'Pacific/Noumea',
        },
        {
            option: 'POT',
            wni_port_name: 'PORT TALBOT',
            wni_unlocode: 'GBPTB',
            wni_country: 'GB',
            wni_lat: 51.5731,
            wni_lon: -3.8297,
            wni_tz: 'Europe/London',
        },
        {
            option: 'POV',
            wni_port_name: 'PORVOO',
            wni_unlocode: 'FIPRV',
            wni_country: 'FI',
            wni_lat: 60.3,
            wni_lon: 25.5595,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'POZZ',
            wni_port_name: 'POZZALLO',
            wni_unlocode: 'ITPZL',
            wni_country: 'IT',
            wni_lat: 36.7096,
            wni_lon: 14.849,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'PPE',
            wni_port_name: 'PUERTO PRODECO',
            wni_unlocode: 'COPPR',
            wni_country: 'CO',
            wni_lat: 11.076,
            wni_lon: -74.262,
            wni_tz: 'America/Bogota',
        },
        {
            option: 'PPI',
            wni_port_name: 'PORT PIRIE',
            wni_unlocode: 'AUPPI',
            wni_country: 'AU',
            wni_lat: -33.1361,
            wni_lon: 138.0164,
            wni_tz: 'Australia/Adelaide',
        },
        {
            option: 'PPL',
            wni_port_name: 'PUERTO PLATA',
            wni_unlocode: 'DOPOP',
            wni_country: 'DO',
            wni_lat: 19.8129,
            wni_lon: -70.6918,
            wni_tz: 'America/Santo_Domingo',
        },
        {
            option: 'PPR',
            wni_port_name: 'PRAIA',
            wni_unlocode: 'CVRAI',
            wni_country: 'CV',
            wni_lat: 14.9,
            wni_lon: -23.5167,
            wni_tz: 'Atlantic/Cape_Verde',
        },
        {
            option: 'PPS',
            wni_port_name: 'PATRAS',
            wni_unlocode: 'GRGPA',
            wni_country: 'GR',
            wni_lat: 38.256,
            wni_lon: 21.7208,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'PQL',
            wni_port_name: 'PUERTO QUETZAL',
            wni_unlocode: 'GTAAZ',
            wni_country: 'GT',
            wni_lat: 13.9086,
            wni_lon: -90.7784,
            wni_tz: 'America/Guatemala',
        },
        {
            option: 'PRA',
            wni_port_name: 'PARADIP',
            wni_unlocode: 'INPRT',
            wni_country: 'IN',
            wni_lat: 20.2552,
            wni_lon: 86.6869,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'PRC',
            wni_port_name: 'PUERTO SUCRE',
            wni_unlocode: 'VEPSU',
            wni_country: 'VE',
            wni_lat: 10.4794,
            wni_lon: -64.1995,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'PREIR',
            wni_port_name: 'PUNTA PEREIRA',
            wni_unlocode: 'UYPTP',
            wni_country: 'UY',
            wni_lat: -34.2163,
            wni_lon: -58.0816,
            wni_tz: 'America/Montevideo',
        },
        {
            option: 'PRH',
            wni_port_name: 'PORT RHOADES',
            wni_unlocode: 'JMPRH',
            wni_country: 'JM',
            wni_lat: 18.4709,
            wni_lon: -77.408,
            wni_tz: 'America/Jamaica',
        },
        {
            option: 'PRI',
            wni_port_name: 'PRINCE RUPERT',
            wni_unlocode: 'CAPRR',
            wni_country: 'CA',
            wni_lat: 54.3248,
            wni_lon: -130.3242,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'PRIG',
            wni_port_name: 'PRIGORODNOYE',
            wni_unlocode: 'RUPGN',
            wni_country: 'RU',
            wni_lat: 46.6084,
            wni_lon: 142.9053,
            wni_tz: 'Asia/Sakhalin',
        },
        {
            option: 'PRIM',
            wni_port_name: 'PRIMORSK',
            wni_unlocode: 'RUPRI',
            wni_country: 'RU',
            wni_lat: 60.3502,
            wni_lon: 28.5952,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'PRM',
            wni_port_name: 'PORT MORESBY',
            wni_unlocode: 'PGPOM',
            wni_country: 'PG',
            wni_lat: -9.4908,
            wni_lon: 147.1539,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'PRO',
            wni_port_name: 'PROVIDENCE',
            wni_unlocode: 'USPV5',
            wni_country: 'US',
            wni_lat: 41.7744,
            wni_lon: -71.3799,
            wni_tz: 'America/New_York',
        },
        {
            option: 'PROS',
            wni_port_name: 'PUERTO ROSALES',
            wni_unlocode: 'ARPRS',
            wni_country: 'AR',
            wni_lat: -38.9387,
            wni_lon: -62.0718,
            wni_tz: 'America/Argentina/Buenos_Aires',
        },
        {
            option: 'PRTFN',
            wni_port_name: 'PORTOFINO',
            wni_unlocode: 'ITPTF',
            wni_country: 'IT',
            wni_lat: 44.2865,
            wni_lon: 9.2279,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'PRTLD',
            wni_port_name: 'PORTLAND\t CT',
            wni_unlocode: 'USPTQ',
            wni_country: 'US',
            wni_lat: 41.5604,
            wni_lon: -72.6416,
            wni_tz: 'America/New_York',
        },
        {
            option: 'PRTSM',
            wni_port_name: 'PORTSMOUTH\t OH',
            wni_unlocode: 'USPMH',
            wni_country: 'US',
            wni_lat: 38.726,
            wni_lon: -82.996,
            wni_tz: 'America/New_York',
        },
        {
            option: 'PSA',
            wni_port_name: 'PORT SAID',
            wni_unlocode: 'EGPSD',
            wni_country: 'EG',
            wni_lat: 31.305,
            wni_lon: 32.3507,
            wni_tz: 'Africa/Cairo',
        },
        {
            option: 'PSD',
            wni_port_name: 'PORT SUDAN',
            wni_unlocode: 'SDPZU',
            wni_country: 'SD',
            wni_lat: 19.6025,
            wni_lon: 37.2407,
            wni_tz: 'Africa/Khartoum',
        },
        {
            option: 'PSE',
            wni_port_name: 'PORTSMOUTH HARBOR',
            wni_unlocode: 'GBPME',
            wni_country: 'GB',
            wni_lat: 50.779,
            wni_lon: -1.1105,
            wni_tz: 'Europe/London',
        },
        {
            option: 'PSG',
            wni_port_name: 'PASCAGOULA',
            wni_unlocode: 'USPGL',
            wni_country: 'US',
            wni_lat: 30.3226,
            wni_lon: -88.5623,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'PSI',
            wni_port_name: 'PASIR GUDANG',
            wni_unlocode: 'MYPGU',
            wni_country: 'MY',
            wni_lat: 1.4287,
            wni_lon: 103.8992,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'PSNN',
            wni_port_name: 'PORT OF SPAIN',
            wni_unlocode: 'TTPOS',
            wni_country: 'TT',
            wni_lat: 10.6456,
            wni_lon: -61.5355,
            wni_tz: 'America/Port_of_Spain',
        },
        {
            option: 'PSP',
            wni_port_name: 'PISCO',
            wni_unlocode: 'PEPIO',
            wni_country: 'PE',
            wni_lat: -13.7955,
            wni_lon: -76.274,
            wni_tz: 'America/Lima',
        },
        {
            option: 'PSQ',
            wni_port_name: 'PT SULTAN QABOOS',
            wni_unlocode: 'OMSUL',
            wni_country: 'OM',
            wni_lat: 23.5993,
            wni_lon: 58.6099,
            wni_tz: 'Asia/Muscat',
        },
        {
            option: 'PTD',
            wni_port_name: 'FORT DAUPHIN',
            wni_unlocode: 'MGFTU',
            wni_country: 'MG',
            wni_lat: -25.0556,
            wni_lon: 46.9666,
            wni_tz: 'Indian/Antananarivo',
        },
        {
            option: 'PTI',
            wni_port_name: 'POTI',
            wni_unlocode: 'GEPOT',
            wni_country: 'GE',
            wni_lat: 42.1541,
            wni_lon: 41.6381,
            wni_tz: 'Asia/Tbilisi',
        },
        {
            option: 'PTK',
            wni_port_name: 'PONTIANAK',
            wni_unlocode: 'IDPNK',
            wni_country: 'ID',
            wni_lat: -0.0146,
            wni_lon: 109.3346,
            wni_tz: 'Asia/Pontianak',
        },
        {
            option: 'PTL',
            wni_port_name: 'PORTLAND\t ME',
            wni_unlocode: 'USPWM',
            wni_country: 'US',
            wni_lat: 43.663,
            wni_lon: -70.232,
            wni_tz: 'America/New_York',
        },
        {
            option: 'PTPN',
            wni_port_name: 'POINT A PIERRE',
            wni_unlocode: 'TTPTP',
            wni_country: 'TT',
            wni_lat: 10.3112,
            wni_lon: -61.4867,
            wni_tz: 'America/Port_of_Spain',
        },
        {
            option: 'PTS',
            wni_port_name: 'PORTSMOUTH\t NH',
            wni_unlocode: 'USPSM',
            wni_country: 'US',
            wni_lat: 43.0745,
            wni_lon: -70.74,
            wni_tz: 'America/New_York',
        },
        {
            option: 'PTT',
            wni_port_name: 'PORTO TORRES',
            wni_unlocode: 'ITPTO',
            wni_country: 'IT',
            wni_lat: 40.8605,
            wni_lon: 8.3891,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'PUB',
            wni_port_name: 'PUERTO BOLIVAR',
            wni_unlocode: 'ECPBO',
            wni_country: 'EC',
            wni_lat: -3.2531,
            wni_lon: -80.0079,
            wni_tz: 'America/Guayaquil',
        },
        {
            option: 'PUC',
            wni_port_name: 'PUERTO CORTES',
            wni_unlocode: 'HNPCR',
            wni_country: 'HN',
            wni_lat: 15.8324,
            wni_lon: -87.9466,
            wni_tz: 'America/Tegucigalpa',
        },
        {
            option: 'PUET',
            wni_port_name: 'PUNTA EUROPA TERMINAL',
            wni_unlocode: 'GQPET',
            wni_country: 'GQ',
            wni_lat: 3.7969,
            wni_lon: 8.7137,
            wni_tz: 'Africa/Malabo',
        },
        {
            option: 'PULU',
            wni_port_name: 'PULUPANDAN',
            wni_unlocode: 'PHPUL',
            wni_country: 'PH',
            wni_lat: 10.5073,
            wni_lon: 122.7729,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'PUM',
            wni_port_name: 'PUERTO MONTT',
            wni_unlocode: 'CLPMC',
            wni_country: 'CL',
            wni_lat: -41.486,
            wni_lon: -72.9404,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'PUMR',
            wni_port_name: 'PUNTA MORALES',
            wni_unlocode: 'CRPUM',
            wni_country: 'CR',
            wni_lat: 10.0565,
            wni_lon: -84.9755,
            wni_tz: 'America/Costa_Rica',
        },
        {
            option: 'PUP',
            wni_port_name: 'POINT TUPPER',
            wni_unlocode: 'CAPTU',
            wni_country: 'CA',
            wni_lat: 45.5617,
            wni_lon: -61.3413,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'PUPA',
            wni_port_name: 'CALETA PATACHE',
            wni_unlocode: 'CLPAT',
            wni_country: 'CL',
            wni_lat: -20.7961,
            wni_lon: -70.2038,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'PUR',
            wni_port_name: 'PUERTO ORDES',
            wni_unlocode: 'VEPZO',
            wni_country: 'VE',
            wni_lat: 8.3485,
            wni_lon: -62.7207,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'PUS',
            wni_port_name: 'PUERTO SANDINO',
            wni_unlocode: 'NIPSN',
            wni_country: 'NI',
            wni_lat: 12.1944,
            wni_lon: -86.7758,
            wni_tz: 'America/Managua',
        },
        {
            option: 'PVI',
            wni_port_name: 'PORT VILA',
            wni_unlocode: 'VUVLI',
            wni_country: 'VU',
            wni_lat: -17.7488,
            wni_lon: 168.2854,
            wni_tz: 'Pacific/Efate',
        },
        {
            option: 'PVS',
            wni_port_name: 'PORT VESME',
            wni_unlocode: 'ITPVE',
            wni_country: 'IT',
            wni_lat: 39.1849,
            wni_lon: 8.3799,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'PWC',
            wni_port_name: 'PORTWALCOTT',
            wni_unlocode: 'AUPWL',
            wni_country: 'AU',
            wni_lat: -20.5688,
            wni_lon: 117.2085,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'PYG',
            wni_port_name: 'BORYEONG',
            wni_unlocode: 'KRBOR',
            wni_country: 'KR',
            wni_lat: 36.4047,
            wni_lon: 126.4746,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'PYO',
            wni_port_name: 'PYEONGTAEK',
            wni_unlocode: 'KRPTK',
            wni_country: 'KR',
            wni_lat: 36.9989,
            wni_lon: 126.767,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'PYP',
            wni_port_name: 'PINEY POINT',
            wni_unlocode: 'USPYP',
            wni_country: 'US',
            wni_lat: 38.1196,
            wni_lon: -76.5398,
            wni_tz: 'America/New_York',
        },
        {
            option: 'PYT',
            wni_port_name: 'POSYET',
            wni_unlocode: 'RUPSE',
            wni_country: 'RU',
            wni_lat: 42.6069,
            wni_lon: 130.8001,
            wni_tz: 'Asia/Vladivostok',
        },
        {
            option: 'QAL',
            wni_port_name: 'QALHAT',
            wni_unlocode: 'OMQAL',
            wni_country: 'OM',
            wni_lat: 22.6648,
            wni_lon: 59.4299,
            wni_tz: 'Asia/Muscat',
        },
        {
            option: 'QC',
            wni_port_name: 'QUEBEC',
            wni_unlocode: 'CAQUE',
            wni_country: 'CA',
            wni_lat: 46.8315,
            wni_lon: -71.1825,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'QIB',
            wni_port_name: 'QUA IBOE (KWA IBO)',
            wni_unlocode: 'NGOBO',
            wni_country: 'NG',
            wni_lat: 4.5269,
            wni_lon: 7.992,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'QIDG',
            wni_port_name: 'QIDONG',
            wni_unlocode: 'CNQID',
            wni_country: 'CN',
            wni_lat: 31.6729,
            wni_lon: 121.8639,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'QIN',
            wni_port_name: 'QINHUANGDAO',
            wni_unlocode: 'CNQHA',
            wni_country: 'CN',
            wni_lat: 39.8905,
            wni_lon: 119.5863,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'QIZ',
            wni_port_name: 'QINZHOU',
            wni_unlocode: 'CNQZH',
            wni_country: 'CN',
            wni_lat: 21.8592,
            wni_lon: 108.5505,
            wni_tz: 'Asia/Chongqing',
        },
        {
            option: 'QSHM',
            wni_port_name: 'QESHM',
            wni_unlocode: 'IRQSM',
            wni_country: 'IR',
            wni_lat: 26.5499,
            wni_lon: 55.75,
            wni_tz: 'Asia/Tehran',
        },
        {
            option: 'QTE',
            wni_port_name: 'QUINTERO',
            wni_unlocode: 'CLQTV',
            wni_country: 'CL',
            wni_lat: -32.7461,
            wni_lon: -71.5378,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'QUI',
            wni_port_name: 'QUI NHON',
            wni_unlocode: 'VNUIH',
            wni_country: 'VN',
            wni_lat: 13.7886,
            wni_lon: 109.2493,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'QUN',
            wni_port_name: 'QINGDAO',
            wni_unlocode: 'CNQDG',
            wni_country: 'CN',
            wni_lat: 36.0822,
            wni_lon: 120.2905,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'QWAN',
            wni_port_name: 'QIANWAN',
            wni_unlocode: 'CNQAW',
            wni_country: 'CN',
            wni_lat: 36.0252,
            wni_lon: 120.2458,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'QZH',
            wni_port_name: 'QUANZHOU',
            wni_unlocode: 'CNQZJ',
            wni_country: 'CN',
            wni_lat: 24.8858,
            wni_lon: 118.584,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'RAA',
            wni_port_name: 'RAAHE',
            wni_unlocode: 'FIRAA',
            wni_country: 'FI',
            wni_lat: 64.628,
            wni_lon: 24.3305,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'RAB',
            wni_port_name: 'RABAUL',
            wni_unlocode: 'PGRAB',
            wni_country: 'PG',
            wni_lat: -4.2138,
            wni_lon: 152.1675,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'RAI',
            wni_port_name: 'RAS ISA TERMINAL',
            wni_unlocode: 'YERAI',
            wni_country: 'YE',
            wni_lat: 15.1167,
            wni_lon: 42.6,
            wni_tz: 'Asia/Aden',
        },
        {
            option: 'RAK',
            wni_port_name: 'RAS AL KHAFJI',
            wni_unlocode: 'SARAR',
            wni_country: 'SA',
            wni_lat: 28.4217,
            wni_lon: 48.5364,
            wni_tz: 'Asia/Riyadh',
        },
        {
            option: 'RAM',
            wni_port_name: 'RAUMA',
            wni_unlocode: 'FIRAU',
            wni_country: 'FI',
            wni_lat: 61.128,
            wni_lon: 21.2852,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'RASAH',
            wni_port_name: 'RASA',
            wni_unlocode: 'HRRAS',
            wni_country: 'HR',
            wni_lat: 45.0141,
            wni_lon: 14.0526,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'RAV',
            wni_port_name: 'RAVENNA',
            wni_unlocode: 'ITRAN',
            wni_country: 'IT',
            wni_lat: 44.4971,
            wni_lon: 12.3255,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'RAYA',
            wni_port_name: 'BUNGA RAYA',
            wni_unlocode: 'MYBGR',
            wni_country: 'MY',
            wni_lat: 6.9666,
            wni_lon: 104.15,
            wni_tz: 'Etc/GMT-8',
        },
        {
            option: 'RBA',
            wni_port_name: 'RICHARDS BAY',
            wni_unlocode: 'ZARCB',
            wni_country: 'ZA',
            wni_lat: -28.818,
            wni_lon: 32.1065,
            wni_tz: 'Africa/Johannesburg',
        },
        {
            option: 'RBGH',
            wni_port_name: 'RABIGH',
            wni_unlocode: 'SARAB',
            wni_country: 'SA',
            wni_lat: 22.7298,
            wni_lon: 38.9809,
            wni_tz: 'Asia/Riyadh',
        },
        {
            option: 'RCR',
            wni_port_name: 'REDCAR',
            wni_unlocode: 'GBRER',
            wni_country: 'GB',
            wni_lat: 54.6532,
            wni_lon: -1.1344,
            wni_tz: 'Europe/London',
        },
        {
            option: 'RDG',
            wni_port_name: 'RED DOG',
            wni_unlocode: 'USRDB',
            wni_country: 'US',
            wni_lat: 67.5654,
            wni_lon: -164.0851,
            wni_tz: 'America/Nome',
        },
        {
            option: 'RDI',
            wni_port_name: 'REDI',
            wni_unlocode: 'INRED',
            wni_country: 'IN',
            wni_lat: 15.7537,
            wni_lon: 73.648,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'RDJ',
            wni_port_name: 'RIO DE JANEIRO',
            wni_unlocode: 'BRRIO',
            wni_country: 'BR',
            wni_lat: -22.9691,
            wni_lon: -43.1347,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'RDNG',
            wni_port_name: 'PORT READING',
            wni_unlocode: 'USPRD',
            wni_country: 'US',
            wni_lat: 40.5574,
            wni_lon: -74.2303,
            wni_tz: 'America/New_York',
        },
        {
            option: 'REA',
            wni_port_name: 'REVDANDA',
            wni_unlocode: 'INRVD',
            wni_country: 'IN',
            wni_lat: 18.5464,
            wni_lon: 72.9002,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'REC',
            wni_port_name: 'RECIFE',
            wni_unlocode: 'BRREC',
            wni_country: 'BR',
            wni_lat: -8.0479,
            wni_lon: -34.8419,
            wni_tz: 'America/Recife',
        },
        {
            option: 'REI',
            wni_port_name: 'REIHOKU',
            wni_unlocode: 'JPRHK',
            wni_country: 'JP',
            wni_lat: 32.4857,
            wni_lon: 130.0186,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'RES',
            wni_port_name: 'RESERVE',
            wni_unlocode: 'USRSF',
            wni_country: 'US',
            wni_lat: 30.0477,
            wni_lon: -90.5498,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'REY',
            wni_port_name: 'REYDARFJORDUR',
            wni_unlocode: 'ISRFJ',
            wni_country: 'IS',
            wni_lat: 65.0308,
            wni_lon: -13.9545,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'RGB',
            wni_port_name: 'RIO GRANDE',
            wni_unlocode: 'BRRIG',
            wni_country: 'BR',
            wni_lat: -32.0541,
            wni_lon: -52.0645,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'RGDG',
            wni_port_name: 'RANG DONG',
            wni_unlocode: 'VNRDG',
            wni_country: 'VN',
            wni_lat: 10.2743,
            wni_lon: 107.0903,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'RGH',
            wni_port_name: 'RAS GHARIB',
            wni_unlocode: 'EGRAG',
            wni_country: 'EG',
            wni_lat: 28.3467,
            wni_lon: 33.1234,
            wni_tz: 'Africa/Cairo',
        },
        {
            option: 'RGKDD',
            wni_port_name: 'RINGASKIDDY',
            wni_unlocode: 'IERIN',
            wni_country: 'IE',
            wni_lat: 51.84,
            wni_lon: -8.32,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'RHA',
            wni_port_name: 'RIO HAINA',
            wni_unlocode: 'DOHAI',
            wni_country: 'DO',
            wni_lat: 18.4085,
            wni_lon: -70.0115,
            wni_tz: 'America/Santo_Domingo',
        },
        {
            option: 'RHD',
            wni_port_name: 'RIVERHEAD',
            wni_unlocode: 'USRHD',
            wni_country: 'US',
            wni_lat: 41,
            wni_lon: -72.65,
            wni_tz: 'America/New_York',
        },
        {
            option: 'RHDS',
            wni_port_name: 'RHODES',
            wni_unlocode: 'GRRHO',
            wni_country: 'GR',
            wni_lat: 36.4469,
            wni_lon: 28.2304,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'RIC',
            wni_port_name: 'RICHMOND',
            wni_unlocode: 'USRCH',
            wni_country: 'US',
            wni_lat: 37.9028,
            wni_lon: -122.359,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'RIG',
            wni_port_name: 'RIGA',
            wni_unlocode: 'LVRIX',
            wni_country: 'LV',
            wni_lat: 56.9845,
            wni_lon: 24.092,
            wni_tz: 'Europe/Riga',
        },
        {
            option: 'RIOC',
            wni_port_name: 'RIO CULLEN TERMINAL',
            wni_unlocode: 'ARRIC',
            wni_country: 'AR',
            wni_lat: -52.8,
            wni_lon: -68.2167,
            wni_tz: 'America/Argentina/Ushuaia',
        },
        {
            option: 'RJK',
            wni_port_name: 'RIJEKA',
            wni_unlocode: 'HRRIJ',
            wni_country: 'HR',
            wni_lat: 45.308,
            wni_lon: 14.4249,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'RKP',
            wni_port_name: 'ROCKY POINT',
            wni_unlocode: 'JMROP',
            wni_country: 'JM',
            wni_lat: 17.8152,
            wni_lon: -77.131,
            wni_tz: 'America/Jamaica',
        },
        {
            option: 'RLA',
            wni_port_name: 'RAS LANUF',
            wni_unlocode: 'LYRLA',
            wni_country: 'LY',
            wni_lat: 30.5118,
            wni_lon: 18.6051,
            wni_tz: 'Africa/Tripoli',
        },
        {
            option: 'RLF',
            wni_port_name: 'RAS LAFFAN',
            wni_unlocode: 'QARLF',
            wni_country: 'QA',
            wni_lat: 25.9297,
            wni_lon: 51.6325,
            wni_tz: 'Asia/Qatar',
        },
        {
            option: 'RLL',
            wni_port_name: 'RAMALLO',
            wni_unlocode: 'ARRAM',
            wni_country: 'AR',
            wni_lat: -33.476,
            wni_lon: -59.989,
            wni_tz: 'America/Argentina/Buenos_Aires',
        },
        {
            option: 'ROA',
            wni_port_name: 'ROTA',
            wni_unlocode: 'ESROT',
            wni_country: 'ES',
            wni_lat: 36.596,
            wni_lon: -6.3915,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'ROB',
            wni_port_name: 'ROBERTS BANK',
            wni_unlocode: 'CARBK',
            wni_country: 'CA',
            wni_lat: 49.0069,
            wni_lon: -123.1638,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'ROS',
            wni_port_name: 'ROSTOCK',
            wni_unlocode: 'DERSK',
            wni_country: 'DE',
            wni_lat: 54.1927,
            wni_lon: 12.0847,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'ROSA',
            wni_port_name: 'ROSARIO',
            wni_unlocode: 'PHRSO',
            wni_country: 'PH',
            wni_lat: 14.4266,
            wni_lon: 120.8369,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'ROT',
            wni_port_name: 'ROTTERDAM',
            wni_unlocode: 'NLRTM',
            wni_country: 'NL',
            wni_lat: 51.9987,
            wni_lon: 4.0314,
            wni_tz: 'Europe/Amsterdam',
        },
        {
            option: 'ROU',
            wni_port_name: 'ROUEN',
            wni_unlocode: 'FRURO',
            wni_country: 'FR',
            wni_lat: 49.4394,
            wni_lon: 1.0455,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'ROXP',
            wni_port_name: 'ROXAS (CULASI)',
            wni_unlocode: 'PHRXS',
            wni_country: 'PH',
            wni_lat: 11.5967,
            wni_lon: 122.7038,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'RPG',
            wni_port_name: 'RAOPING',
            wni_unlocode: 'CNRPG',
            wni_country: 'CN',
            wni_lat: 23.6642,
            wni_lon: 117.0125,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'RSA',
            wni_port_name: 'ROSARIO',
            wni_unlocode: 'ARROS',
            wni_country: 'AR',
            wni_lat: -32.871,
            wni_lon: -60.684,
            wni_tz: 'America/Argentina/Cordoba',
        },
        {
            option: 'RSH',
            wni_port_name: 'RAS SHUKHEIR',
            wni_unlocode: 'EGRSH',
            wni_country: 'EG',
            wni_lat: 28.1355,
            wni_lon: 33.2907,
            wni_tz: 'Africa/Cairo',
        },
        {
            option: 'RSU',
            wni_port_name: 'ROSEAU',
            wni_unlocode: 'DMRSU',
            wni_country: 'DM',
            wni_lat: 15.2931,
            wni_lon: -61.3982,
            wni_tz: 'America/Dominica',
        },
        {
            option: 'RTN',
            wni_port_name: 'ROATAN ISLAND',
            wni_unlocode: 'HNRTB',
            wni_country: 'HN',
            wni_lat: 16.3018,
            wni_lon: -86.5453,
            wni_tz: 'America/Tegucigalpa',
        },
        {
            option: 'RTO',
            wni_port_name: 'ROSARITO',
            wni_unlocode: 'MXZRO',
            wni_country: 'MX',
            wni_lat: 32.3643,
            wni_lon: -117.0853,
            wni_tz: 'America/Tijuana',
        },
        {
            option: 'RTUBA',
            wni_port_name: 'RIO TUBA',
            wni_unlocode: 'PHRTB',
            wni_country: 'PH',
            wni_lat: 8.4902,
            wni_lon: 117.4389,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'RUDOG',
            wni_port_name: 'RUDONG',
            wni_unlocode: 'CNRDO',
            wni_country: 'CN',
            wni_lat: 32.5389,
            wni_lon: 121.4316,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'RUGAO',
            wni_port_name: 'RUGAO',
            wni_unlocode: 'CNRUG',
            wni_country: 'CN',
            wni_lat: 32.0065,
            wni_lon: 120.592,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'RUM',
            wni_port_name: 'RUMOI',
            wni_unlocode: 'JPRMI',
            wni_country: 'JP',
            wni_lat: 43.9691,
            wni_lon: 141.6181,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'RUW',
            wni_port_name: 'RUWAIS',
            wni_unlocode: 'AERUW',
            wni_country: 'AE',
            wni_lat: 24.1768,
            wni_lon: 52.7215,
            wni_tz: 'Asia/Dubai',
        },
        {
            option: 'RVG',
            wni_port_name: 'ROVIGO LNG TERMINAL',
            wni_unlocode: 'ITRVO',
            wni_country: 'IT',
            wni_lat: 45.0917,
            wni_lon: 12.5861,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'RVTHS',
            wni_port_name: 'REVITHOUSSA',
            wni_unlocode: 'GRREV',
            wni_country: 'GR',
            wni_lat: 37.9664,
            wni_lon: 23.4069,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'RYT',
            wni_port_name: 'RAYONG',
            wni_unlocode: 'THRYG',
            wni_country: 'TH',
            wni_lat: 12.627,
            wni_lon: 101.2979,
            wni_tz: 'Asia/Bangkok',
        },
        {
            option: 'RZH',
            wni_port_name: 'RIZHAO',
            wni_unlocode: 'CNRDJ',
            wni_country: 'CN',
            wni_lat: 35.3624,
            wni_lon: 119.5793,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'SAA',
            wni_port_name: 'SAKAIDE',
            wni_unlocode: 'JPSKD',
            wni_country: 'JP',
            wni_lat: 34.3486,
            wni_lon: 133.8684,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SABIN',
            wni_port_name: 'SABINE LIGHTERING AREA',
            wni_unlocode: 'USSAB',
            wni_country: 'US',
            wni_lat: 28.5833,
            wni_lon: -93.75,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'SABIN1',
            wni_port_name: 'SABINE PASS',
            wni_unlocode: 'USNSS',
            wni_country: 'US',
            wni_lat: 29.7391,
            wni_lon: -93.8742,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'SAC',
            wni_port_name: 'SACRAMENTO',
            wni_unlocode: 'USSAC',
            wni_country: 'US',
            wni_lat: 38.5826,
            wni_lon: -121.5078,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'SAD',
            wni_port_name: 'SANTAN TERMINAL',
            wni_unlocode: 'IDSAT',
            wni_country: 'ID',
            wni_lat: -0.0939,
            wni_lon: 117.4537,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'SADO',
            wni_port_name: 'RYOTSU',
            wni_unlocode: 'JPRYO',
            wni_country: 'JP',
            wni_lat: 38.0892,
            wni_lon: 138.4502,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SAE',
            wni_port_name: 'SAIKI',
            wni_unlocode: 'JPSAE',
            wni_country: 'JP',
            wni_lat: 32.9766,
            wni_lon: 131.9382,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SAF',
            wni_port_name: 'SANTO DOMINGO',
            wni_unlocode: 'DOSDQ',
            wni_country: 'DO',
            wni_lat: 18.4599,
            wni_lon: -69.8894,
            wni_tz: 'America/Santo_Domingo',
        },
        {
            option: 'SAH',
            wni_port_name: 'SRIRACHA',
            wni_unlocode: 'THSRI',
            wni_country: 'TH',
            wni_lat: 13.1159,
            wni_lon: 100.8666,
            wni_tz: 'Asia/Bangkok',
        },
        {
            option: 'SAIDA',
            wni_port_name: 'SIDON',
            wni_unlocode: 'LBSDN',
            wni_country: 'LB',
            wni_lat: 33.5723,
            wni_lon: 35.3588,
            wni_tz: 'Asia/Beirut',
        },
        {
            option: 'SAL',
            wni_port_name: 'SALVADOR',
            wni_unlocode: 'BRSSA',
            wni_country: 'BR',
            wni_lat: -12.9714,
            wni_lon: -38.5287,
            wni_tz: 'America/Bahia',
        },
        {
            option: 'SALA',
            wni_port_name: 'SALADIN TERMINAL',
            wni_unlocode: 'AUSMT',
            wni_country: 'AU',
            wni_lat: -21.4,
            wni_lon: 115.05,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'SAMC',
            wni_port_name: 'SAMCHONPO',
            wni_unlocode: 'KRSCP',
            wni_country: 'KR',
            wni_lat: 34.8886,
            wni_lon: 128.1029,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'SAO',
            wni_port_name: 'SAO SEBASTIAO',
            wni_unlocode: 'BRSSO',
            wni_country: 'BR',
            wni_lat: -23.8129,
            wni_lon: -45.3843,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'SAOE',
            wni_port_name: 'SAN ANTONIO',
            wni_unlocode: 'AROES',
            wni_country: 'AR',
            wni_lat: -40.788,
            wni_lon: -64.8925,
            wni_tz: 'America/Argentina/Salta',
        },
        {
            option: 'SAP',
            wni_port_name: 'SAIPAN',
            wni_unlocode: 'MPSPN',
            wni_country: 'MP',
            wni_lat: 15.2335,
            wni_lon: 145.7298,
            wni_tz: 'Pacific/Saipan',
        },
        {
            option: 'SAQ',
            wni_port_name: 'SAN PEDRO DE MACORIS',
            wni_unlocode: 'DOSPM',
            wni_country: 'DO',
            wni_lat: 18.4299,
            wni_lon: -69.3094,
            wni_tz: 'America/Santo_Domingo',
        },
        {
            option: 'SARI',
            wni_port_name: 'SARIAYA',
            wni_unlocode: 'PHSRY',
            wni_country: 'PH',
            wni_lat: 13.8581,
            wni_lon: 121.55,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'SASB',
            wni_port_name: 'SAN SEBASTIAN TERMINAL',
            wni_unlocode: 'ARSSN',
            wni_country: 'AR',
            wni_lat: -53.3073,
            wni_lon: -68.2751,
            wni_tz: 'America/Argentina/Ushuaia',
        },
        {
            option: 'SATU',
            wni_port_name: 'SATUI',
            wni_unlocode: 'IDSTU',
            wni_country: 'ID',
            wni_lat: -3.8263,
            wni_lon: 115.4885,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'SAU',
            wni_port_name: 'SAUDA',
            wni_unlocode: 'NOSAU',
            wni_country: 'NO',
            wni_lat: 59.6388,
            wni_lon: 6.3443,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SAV',
            wni_port_name: 'SAVONA',
            wni_unlocode: 'ITSVN',
            wni_country: 'IT',
            wni_lat: 44.3077,
            wni_lon: 8.5136,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'SBR',
            wni_port_name: 'SANTANA',
            wni_unlocode: 'BRSAN',
            wni_country: 'BR',
            wni_lat: -0.0634,
            wni_lon: -51.1682,
            wni_tz: 'America/Belem',
        },
        {
            option: 'SBTT',
            wni_port_name: 'SABETTA',
            wni_unlocode: 'RUSAB',
            wni_country: 'RU',
            wni_lat: 71.2792,
            wni_lon: 72.0822,
            wni_tz: 'Asia/Yekaterinburg',
        },
        {
            option: 'SBU',
            wni_port_name: 'SHIBUSHI',
            wni_unlocode: 'JPSBS',
            wni_country: 'JP',
            wni_lat: 31.4,
            wni_lon: 131.0833,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SBY',
            wni_port_name: 'SALDANHA BAY',
            wni_unlocode: 'ZASDB',
            wni_country: 'ZA',
            wni_lat: -33.0439,
            wni_lon: 17.9829,
            wni_tz: 'Africa/Johannesburg',
        },
        {
            option: 'SCR',
            wni_port_name: 'TENERIFE',
            wni_unlocode: 'ESTCI',
            wni_country: 'ES',
            wni_lat: 28.4515,
            wni_lon: -16.2377,
            wni_tz: 'Atlantic/Canary',
        },
        {
            option: 'SCT',
            wni_port_name: 'SANTO TOMAS',
            wni_unlocode: 'GTSTZ',
            wni_country: 'GT',
            wni_lat: 15.7042,
            wni_lon: -88.6191,
            wni_tz: 'America/Guatemala',
        },
        {
            option: 'SCY',
            wni_port_name: 'SAN CIPRIAN',
            wni_unlocode: 'ESSCI',
            wni_country: 'ES',
            wni_lat: 43.7154,
            wni_lon: -7.4446,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'SCZ',
            wni_port_name: 'SALINA CRUZ',
            wni_unlocode: 'MXSCX',
            wni_country: 'MX',
            wni_lat: 16.1391,
            wni_lon: -95.2067,
            wni_tz: 'America/Mexico_City',
        },
        {
            option: 'SDA',
            wni_port_name: 'SETODA',
            wni_unlocode: 'JPSTD',
            wni_country: 'JP',
            wni_lat: 34.3159,
            wni_lon: 133.0993,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SDH',
            wni_port_name: 'SODERHAMN',
            wni_unlocode: 'SESOO',
            wni_country: 'SE',
            wni_lat: 61.3028,
            wni_lon: 17.1195,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'SDI',
            wni_port_name: 'SAN DIEGO',
            wni_unlocode: 'USPGY',
            wni_country: 'US',
            wni_lat: 32.7185,
            wni_lon: -117.1876,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'SDN',
            wni_port_name: 'STOCKHOLM',
            wni_unlocode: 'SEGKS',
            wni_country: 'SE',
            wni_lat: 59.3343,
            wni_lon: 18.1567,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'SDW',
            wni_port_name: 'SANDWICH',
            wni_unlocode: 'USSWC',
            wni_country: 'US',
            wni_lat: 41.7773,
            wni_lon: -70.4873,
            wni_tz: 'America/New_York',
        },
        {
            option: 'SDY',
            wni_port_name: 'SYDNEY (BOTANY BAY)',
            wni_unlocode: 'AUBTB',
            wni_country: 'AU',
            wni_lat: -34.0124,
            wni_lon: 151.2458,
            wni_tz: 'Australia/Sydney',
        },
        {
            option: 'SEA',
            wni_port_name: 'SEATTLE',
            wni_unlocode: 'USSEA',
            wni_country: 'US',
            wni_lat: 47.5957,
            wni_lon: -122.3653,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'SEE',
            wni_port_name: 'SETE',
            wni_unlocode: 'FRSET',
            wni_country: 'FR',
            wni_lat: 43.3918,
            wni_lon: 3.7424,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'SEKPO',
            wni_port_name: 'SEOGWIPO',
            wni_unlocode: 'KRSPO',
            wni_country: 'KR',
            wni_lat: 33.2309,
            wni_lon: 126.5665,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'SEM',
            wni_port_name: 'SEMARANG',
            wni_unlocode: 'IDSRG',
            wni_country: 'ID',
            wni_lat: -6.9331,
            wni_lon: 110.4206,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'SEMI',
            wni_port_name: 'SEMIRARA',
            wni_unlocode: 'PHSMR',
            wni_country: 'PH',
            wni_lat: 12.0918,
            wni_lon: 121.4211,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'SER',
            wni_port_name: 'SERIA',
            wni_unlocode: 'BNSER',
            wni_country: 'BN',
            wni_lat: 4.6225,
            wni_lon: 114.3094,
            wni_tz: 'Asia/Brunei',
        },
        {
            option: 'SES',
            wni_port_name: 'SINES',
            wni_unlocode: 'PTSIE',
            wni_country: 'PT',
            wni_lat: 37.9406,
            wni_lon: -8.8766,
            wni_tz: 'Europe/Lisbon',
        },
        {
            option: 'SET',
            wni_port_name: 'SETUBAL',
            wni_unlocode: 'PTSET',
            wni_country: 'PT',
            wni_lat: 38.482,
            wni_lon: -8.9243,
            wni_tz: 'Europe/Lisbon',
        },
        {
            option: 'SEW',
            wni_port_name: 'SEWARD',
            wni_unlocode: 'USSEW',
            wni_country: 'US',
            wni_lat: 60.1118,
            wni_lon: -149.4146,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'SFA',
            wni_port_name: 'SAFAGA',
            wni_unlocode: 'EGSGA',
            wni_country: 'EG',
            wni_lat: 26.7337,
            wni_lon: 33.9537,
            wni_tz: 'Africa/Cairo',
        },
        {
            option: 'SFI',
            wni_port_name: 'SAFI',
            wni_unlocode: 'MASFI',
            wni_country: 'MA',
            wni_lat: 32.304,
            wni_lon: -9.2646,
            wni_tz: 'Africa/Casablanca',
        },
        {
            option: 'SFL',
            wni_port_name: 'SAN FERNANDO',
            wni_unlocode: 'PHPRO',
            wni_country: 'PH',
            wni_lat: 16.6243,
            wni_lon: 120.3016,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'SFO',
            wni_port_name: 'SAN FRANCISCO',
            wni_unlocode: 'USSFO',
            wni_country: 'US',
            wni_lat: 37.8202,
            wni_lon: -122.4147,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'SFS',
            wni_port_name: 'SAO FRANCISCO DO SUL',
            wni_unlocode: 'BRSFS',
            wni_country: 'BR',
            wni_lat: -26.2109,
            wni_lon: -48.5005,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'SFX',
            wni_port_name: 'SFAX',
            wni_unlocode: 'TNSFA',
            wni_country: 'TN',
            wni_lat: 34.7118,
            wni_lon: 10.7821,
            wni_tz: 'Africa/Tunis',
        },
        {
            option: 'SGD',
            wni_port_name: 'SUNGAI UDANG',
            wni_unlocode: 'MYSUP',
            wni_country: 'MY',
            wni_lat: 2.2378,
            wni_lon: 102.116,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'SGE',
            wni_port_name: 'STIGSNAESVAERKETS HAVN',
            wni_unlocode: 'DKSTG',
            wni_country: 'DK',
            wni_lat: 55.2008,
            wni_lon: 11.2358,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'SGN',
            wni_port_name: 'WNIUNTO',
            wni_unlocode: 'ESWNI',
            wni_country: 'ES',
            wni_lat: 39.621,
            wni_lon: -0.1938,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'SGP',
            wni_port_name: 'SINGAPORE',
            wni_unlocode: 'SGJUR',
            wni_country: 'SG',
            wni_lat: 1.2064,
            wni_lon: 103.6842,
            wni_tz: 'Asia/Singapore',
        },
        {
            option: 'SGSKI',
            wni_port_name: 'WNIANOSEKI',
            wni_unlocode: 'JPWNI',
            wni_country: 'JP',
            wni_lat: 33.2595,
            wni_lon: 131.8611,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SGU',
            wni_port_name: 'SHINGU',
            wni_unlocode: 'JPSHN',
            wni_country: 'JP',
            wni_lat: 33.67,
            wni_lon: 135.9952,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SHA',
            wni_port_name: 'SHANGHAI',
            wni_unlocode: 'CNSGP',
            wni_country: 'CN',
            wni_lat: 31.3739,
            wni_lon: 121.602,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'SHB',
            wni_port_name: 'SHARK BAY',
            wni_unlocode: 'AUSHB',
            wni_country: 'AU',
            wni_lat: -24.915,
            wni_lon: 113.6421,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'SHBYG',
            wni_port_name: 'SHEBOYGAN',
            wni_unlocode: 'USSBM',
            wni_country: 'US',
            wni_lat: 43.7483,
            wni_lon: -87.6931,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'SHD',
            wni_port_name: 'SHUIDONG',
            wni_unlocode: 'CNHIG',
            wni_country: 'CN',
            wni_lat: 21.5053,
            wni_lon: 111.0229,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'SHG',
            wni_port_name: 'SHA LUNG OIL TERMINAL',
            wni_unlocode: 'TWSHL',
            wni_country: 'TW',
            wni_lat: 25.1497,
            wni_lon: 121.1831,
            wni_tz: 'Asia/Taipei',
        },
        {
            option: 'SHGI',
            wni_port_name: 'SHIGEI',
            wni_unlocode: 'JPSIG',
            wni_country: 'JP',
            wni_lat: 34.3527,
            wni_lon: 133.1456,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SHJ',
            wni_port_name: 'SHARJAH',
            wni_unlocode: 'AESHJ',
            wni_country: 'AE',
            wni_lat: 25.386,
            wni_lon: 55.3863,
            wni_tz: 'Asia/Dubai',
        },
        {
            option: 'SHK',
            wni_port_name: 'SHEKOU',
            wni_unlocode: 'CNSHK',
            wni_country: 'CN',
            wni_lat: 22.472,
            wni_lon: 113.918,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'SHM',
            wni_port_name: 'SHIMIZU',
            wni_unlocode: 'JPSMZ',
            wni_country: 'JP',
            wni_lat: 35.03,
            wni_lon: 138.54,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SHNE',
            wni_port_name: 'SHEERNESS',
            wni_unlocode: 'GBSHS',
            wni_country: 'GB',
            wni_lat: 51.4554,
            wni_lon: 0.7483,
            wni_tz: 'Europe/London',
        },
        {
            option: 'SHNKU',
            wni_port_name: 'SIHANOUKVILLE',
            wni_unlocode: 'KHSIH',
            wni_country: 'KH',
            wni_lat: 10.6533,
            wni_lon: 103.4939,
            wni_tz: 'Asia/Phnom_Penh',
        },
        {
            option: 'SHO',
            wni_port_name: 'SENDAI SHIOGAMA',
            wni_unlocode: 'JPSDJ',
            wni_country: 'JP',
            wni_lat: 38.295,
            wni_lon: 141.1717,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SHS',
            wni_port_name: 'SHIMONOSEKI',
            wni_unlocode: 'JPSHS',
            wni_country: 'JP',
            wni_lat: 33.9375,
            wni_lon: 130.9365,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SHT',
            wni_port_name: 'WAKAYAMA SHIMOZU',
            wni_unlocode: 'JPSMT',
            wni_country: 'JP',
            wni_lat: 34.2114,
            wni_lon: 135.112,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SHTHA',
            wni_port_name: 'SAHATHAI',
            wni_unlocode: 'THSCS',
            wni_country: 'TH',
            wni_lat: 13.6585,
            wni_lon: 100.5477,
            wni_tz: 'Asia/Bangkok',
        },
        {
            option: 'SIAM',
            wni_port_name: 'SIAM SEAPORT',
            wni_unlocode: 'THSCT',
            wni_country: 'TH',
            wni_lat: 13.1286,
            wni_lon: 100.8633,
            wni_tz: 'Asia/Bangkok',
        },
        {
            option: 'SIDIK',
            wni_port_name: 'SIDI KERIR TERMINAL',
            wni_unlocode: 'EGSKT',
            wni_country: 'EG',
            wni_lat: 31.1,
            wni_lon: 29.6167,
            wni_tz: 'Africa/Cairo',
        },
        {
            option: 'SIE',
            wni_port_name: 'SLITE',
            wni_unlocode: 'SESLI',
            wni_country: 'SE',
            wni_lat: 57.6746,
            wni_lon: 18.8241,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'SIG',
            wni_port_name: 'SIPITANG',
            wni_unlocode: 'MYSPT',
            wni_country: 'MY',
            wni_lat: 5.0835,
            wni_lon: 115.5416,
            wni_tz: 'Asia/Kuching',
        },
        {
            option: 'SIH',
            wni_port_name: 'SATTAHIP',
            wni_unlocode: 'THSAT',
            wni_country: 'TH',
            wni_lat: 12.6123,
            wni_lon: 100.9122,
            wni_tz: 'Asia/Bangkok',
        },
        {
            option: 'SIK',
            wni_port_name: 'SIKKA',
            wni_unlocode: 'INSIK',
            wni_country: 'IN',
            wni_lat: 22.5916,
            wni_lon: 69.8084,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'SITT',
            wni_port_name: 'SITRA',
            wni_unlocode: 'BHSIT',
            wni_country: 'BH',
            wni_lat: 26.1654,
            wni_lon: 50.6797,
            wni_tz: 'Asia/Bahrain',
        },
        {
            option: 'SJA',
            wni_port_name: "ST. JOHN'S",
            wni_unlocode: 'AGSJO',
            wni_country: 'AG',
            wni_lat: 17.1227,
            wni_lon: -61.8602,
            wni_tz: 'America/Antigua',
        },
        {
            option: 'SJO',
            wni_port_name: 'SAN JOSE',
            wni_unlocode: 'GTSNJ',
            wni_country: 'GT',
            wni_lat: 13.9043,
            wni_lon: -90.7837,
            wni_tz: 'America/Guatemala',
        },
        {
            option: 'SJS',
            wni_port_name: 'SAN JUAN DEL SUR',
            wni_unlocode: 'NISJS',
            wni_country: 'NI',
            wni_lat: 11.2504,
            wni_lon: -85.8885,
            wni_tz: 'America/Managua',
        },
        {
            option: 'SJU',
            wni_port_name: 'SAN JUAN',
            wni_unlocode: 'PRSJU',
            wni_country: 'PR',
            wni_lat: 18.4502,
            wni_lon: -66.1142,
            wni_tz: 'America/Puerto_Rico',
        },
        {
            option: 'SKAS',
            wni_port_name: 'SKAGWAY',
            wni_unlocode: 'USSGY',
            wni_country: 'US',
            wni_lat: 59.4413,
            wni_lon: -135.3446,
            wni_tz: 'America/Juneau',
        },
        {
            option: 'SKE',
            wni_port_name: 'SKELLEFTEA',
            wni_unlocode: 'SESFT',
            wni_country: 'SE',
            wni_lat: 64.6744,
            wni_lon: 21.2344,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'SKG',
            wni_port_name: 'SKAGEN',
            wni_unlocode: 'DKSKA',
            wni_country: 'DK',
            wni_lat: 57.7069,
            wni_lon: 10.6052,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'SKH',
            wni_port_name: 'SOKHNA',
            wni_unlocode: 'EGSOK',
            wni_country: 'EG',
            wni_lat: 29.6455,
            wni_lon: 32.3755,
            wni_tz: 'Africa/Cairo',
        },
        {
            option: 'SKI',
            wni_port_name: 'SKIKDA (PHILIPPEVILLE)',
            wni_unlocode: 'DZSKI',
            wni_country: 'DZ',
            wni_lat: 36.8994,
            wni_lon: 6.9101,
            wni_tz: 'Africa/Algiers',
        },
        {
            option: 'SKM',
            wni_port_name: 'SUKUMO',
            wni_unlocode: 'JPSUK',
            wni_country: 'JP',
            wni_lat: 32.9127,
            wni_lon: 132.6746,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SKN',
            wni_port_name: 'SAKAIMINATO',
            wni_unlocode: 'JPSKM',
            wni_country: 'JP',
            wni_lat: 35.5341,
            wni_lon: 133.2733,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SKNDI',
            wni_port_name: 'SEKONDI',
            wni_unlocode: 'GHSEK',
            wni_country: 'GH',
            wni_lat: 4.9448,
            wni_lon: -1.6848,
            wni_tz: 'Africa/Accra',
        },
        {
            option: 'SKT',
            wni_port_name: 'SAKATA',
            wni_unlocode: 'JPSKT',
            wni_country: 'JP',
            wni_lat: 38.933,
            wni_lon: 139.7816,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SLB',
            wni_port_name: 'SAO LUIZ',
            wni_unlocode: 'BRSLZ',
            wni_country: 'BR',
            wni_lat: -2.5139,
            wni_lon: -44.3392,
            wni_tz: 'America/Fortaleza',
        },
        {
            option: 'SLG',
            wni_port_name: 'SLAGEN',
            wni_unlocode: 'NOSGE',
            wni_country: 'NO',
            wni_lat: 59.3302,
            wni_lon: 10.5276,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SLL',
            wni_port_name: 'SALALAH',
            wni_unlocode: 'OMSLL',
            wni_country: 'OM',
            wni_lat: 16.9282,
            wni_lon: 54.0249,
            wni_tz: 'Asia/Muscat',
        },
        {
            option: 'SLLM',
            wni_port_name: 'SILLAMAE',
            wni_unlocode: 'EESLM',
            wni_country: 'EE',
            wni_lat: 59.4295,
            wni_lon: 27.7328,
            wni_tz: 'Europe/Tallinn',
        },
        {
            option: 'SLM',
            wni_port_name: 'SULLOM VOE',
            wni_unlocode: 'GBSUL',
            wni_country: 'GB',
            wni_lat: 60.4503,
            wni_lon: -1.3044,
            wni_tz: 'Europe/London',
        },
        {
            option: 'SLO',
            wni_port_name: 'SALERNO',
            wni_unlocode: 'ITSAL',
            wni_country: 'IT',
            wni_lat: 40.6551,
            wni_lon: 14.7453,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'SLR',
            wni_port_name: 'SAN LORENZO',
            wni_unlocode: 'ARQBR',
            wni_country: 'AR',
            wni_lat: -32.7361,
            wni_lon: -60.7232,
            wni_tz: 'America/Argentina/Cordoba',
        },
        {
            option: 'SLRH',
            wni_port_name: 'SAN LORENZO',
            wni_unlocode: 'HNSLO',
            wni_country: 'HN',
            wni_lat: 13.3897,
            wni_lon: -87.4263,
            wni_tz: 'America/Tegucigalpa',
        },
        {
            option: 'SLU',
            wni_port_name: 'SLUISKIL',
            wni_unlocode: 'NLSLU',
            wni_country: 'NL',
            wni_lat: 51.275,
            wni_lon: 3.8417,
            wni_tz: 'Europe/Amsterdam',
        },
        {
            option: 'SLVY',
            wni_port_name: 'SLAVYANKA',
            wni_unlocode: 'RUSKA',
            wni_country: 'RU',
            wni_lat: 42.9,
            wni_lon: 131.48,
            wni_tz: 'Asia/Vladivostok',
        },
        {
            option: 'SLY',
            wni_port_name: 'SALAVERRY',
            wni_unlocode: 'PESVY',
            wni_country: 'PE',
            wni_lat: -8.2324,
            wni_lon: -78.9974,
            wni_tz: 'America/Lima',
        },
        {
            option: 'SMCHK',
            wni_port_name: 'SAMCHOK',
            wni_unlocode: 'KRSUK',
            wni_country: 'KR',
            wni_lat: 37.4295,
            wni_lon: 129.1998,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'SMMSD',
            wni_port_name: 'SLEMMESTAD',
            wni_unlocode: 'NOSLM',
            wni_country: 'NO',
            wni_lat: 59.7832,
            wni_lon: 10.5184,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SMN',
            wni_port_name: 'SAMSUN',
            wni_unlocode: 'TRSSX',
            wni_country: 'TR',
            wni_lat: 41.3051,
            wni_lon: 36.3692,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'SMNGK',
            wni_port_name: 'SEMANGKA BAY TERMINAL',
            wni_unlocode: 'IDSMB',
            wni_country: 'ID',
            wni_lat: -5.5833,
            wni_lon: 104.6166,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'SMNGK2',
            wni_port_name: 'TELUK SEMANGKA',
            wni_unlocode: 'IDTLS',
            wni_country: 'ID',
            wni_lat: -5.5633,
            wni_lon: 104.6333,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'SMO',
            wni_port_name: 'SAINT MALO',
            wni_unlocode: 'FRSML',
            wni_country: 'FR',
            wni_lat: 48.6447,
            wni_lon: -2.0431,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'SMR',
            wni_port_name: 'SANTA MARTA',
            wni_unlocode: 'COSMR',
            wni_country: 'CO',
            wni_lat: 11.2423,
            wni_lon: -74.2238,
            wni_tz: 'America/Bogota',
        },
        {
            option: 'SMUT',
            wni_port_name: 'SISIMIUT',
            wni_unlocode: 'GLJHS',
            wni_country: 'GL',
            wni_lat: 66.9441,
            wni_lon: -53.6967,
            wni_tz: 'AMERICA/Godthab',
        },
        {
            option: 'SNA',
            wni_port_name: 'SAMANA',
            wni_unlocode: 'DOAZS',
            wni_country: 'DO',
            wni_lat: 19.1974,
            wni_lon: -69.3264,
            wni_tz: 'America/Santo_Domingo',
        },
        {
            option: 'SNB',
            wni_port_name: 'SAKAI SENBOKU',
            wni_unlocode: 'JPSAK',
            wni_country: 'JP',
            wni_lat: 34.55,
            wni_lon: 135.325,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SNDR',
            wni_port_name: 'SUNDALSORA',
            wni_unlocode: 'NOSUN',
            wni_country: 'NO',
            wni_lat: 62.6862,
            wni_lon: 8.5335,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SNGX',
            wni_port_name: 'SONGXIA',
            wni_unlocode: 'CNSON',
            wni_country: 'CN',
            wni_lat: 25.6814,
            wni_lon: 119.5787,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'SNHVT',
            wni_port_name: 'SNOHVIT',
            wni_unlocode: 'NOSHV',
            wni_country: 'NO',
            wni_lat: 70.9596,
            wni_lon: 22.8378,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SNI',
            wni_port_name: 'SAN NICOLAS',
            wni_unlocode: 'ARSNS',
            wni_country: 'AR',
            wni_lat: -33.348,
            wni_lon: -60.1718,
            wni_tz: 'America/Argentina/Buenos_Aires',
        },
        {
            option: 'SNK',
            wni_port_name: 'SENDAI KAGOSHIMA',
            wni_unlocode: 'JPSEN',
            wni_country: 'JP',
            wni_lat: 31.8667,
            wni_lon: 130.1667,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SNN',
            wni_port_name: 'SANDAKAN',
            wni_unlocode: 'MYSDK',
            wni_country: 'MY',
            wni_lat: 5.8289,
            wni_lon: 118.1249,
            wni_tz: 'Asia/Kuching',
        },
        {
            option: 'SNP',
            wni_port_name: 'SAN PEDRO\t CA',
            wni_unlocode: 'USSPQ',
            wni_country: 'US',
            wni_lat: 33.6989,
            wni_lon: -118.2617,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'SNT',
            wni_port_name: 'SAN ANTONIO',
            wni_unlocode: 'CLSAI',
            wni_country: 'CL',
            wni_lat: -33.5859,
            wni_lon: -71.6348,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'SNU',
            wni_port_name: 'SHANTOU',
            wni_unlocode: 'CNSWA',
            wni_country: 'CN',
            wni_lat: 23.3477,
            wni_lon: 116.689,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'SNX',
            wni_port_name: 'SAN NICOLAS BAY',
            wni_unlocode: 'PESNX',
            wni_country: 'PE',
            wni_lat: -15.2549,
            wni_lon: -75.233,
            wni_tz: 'America/Lima',
        },
        {
            option: 'SNZAK',
            wni_port_name: 'SENZAKI',
            wni_unlocode: 'JPSZK',
            wni_country: 'JP',
            wni_lat: 34.3827,
            wni_lon: 131.2156,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SOA',
            wni_port_name: 'SOMA',
            wni_unlocode: 'JPSMA',
            wni_country: 'JP',
            wni_lat: 37.85,
            wni_lon: 140.9833,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SOD',
            wni_port_name: 'SODEGAURA',
            wni_unlocode: 'JPSDU',
            wni_country: 'JP',
            wni_lat: 35.4838,
            wni_lon: 139.979,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SOLA',
            wni_port_name: 'SOLA',
            wni_unlocode: 'NOSLA',
            wni_country: 'NO',
            wni_lat: 58.9254,
            wni_lon: 5.5524,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SONG',
            wni_port_name: 'SONGKHLA',
            wni_unlocode: 'THSGZ',
            wni_country: 'TH',
            wni_lat: 7.2363,
            wni_lon: 100.587,
            wni_tz: 'Asia/Bangkok',
        },
        {
            option: 'SORO',
            wni_port_name: 'SOROOSH TERMINAL',
            wni_unlocode: 'IRCYT',
            wni_country: 'IR',
            wni_lat: 29.0167,
            wni_lon: 49.4669,
            wni_tz: 'Asia/Tehran',
        },
        {
            option: 'SOU',
            wni_port_name: 'SOUTHAMPTON',
            wni_unlocode: 'GBSOU',
            wni_country: 'GB',
            wni_lat: 50.8789,
            wni_lon: -1.3827,
            wni_tz: 'Europe/London',
        },
        {
            option: 'SOUS',
            wni_port_name: 'SOUSSE',
            wni_unlocode: 'TNSUS',
            wni_country: 'TN',
            wni_lat: 35.8236,
            wni_lon: 10.6587,
            wni_tz: 'Africa/Tunis',
        },
        {
            option: 'SOY',
            wni_port_name: 'SOYO',
            wni_unlocode: 'AOSZA',
            wni_country: 'AO',
            wni_lat: -6.1136,
            wni_lon: 12.3231,
            wni_tz: 'Africa/Luanda',
        },
        {
            option: 'SPB',
            wni_port_name: 'SPRING BAY',
            wni_unlocode: 'AUSPB',
            wni_country: 'AU',
            wni_lat: -42.5608,
            wni_lon: 147.9253,
            wni_tz: 'Australia/Hobart',
        },
        {
            option: 'SPEDRX',
            wni_port_name: 'SAN PEDRO',
            wni_unlocode: 'CISPY',
            wni_country: 'CI',
            wni_lat: 4.7322,
            wni_lon: -6.6053,
            wni_tz: 'Africa/Abidjan',
        },
        {
            option: 'SPH',
            wni_port_name: 'SENIPAH',
            wni_unlocode: 'IDSPH',
            wni_country: 'ID',
            wni_lat: -1.05,
            wni_lon: 117.2166,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'SPM',
            wni_port_name: 'SERPENTINA TERMINAL',
            wni_unlocode: 'GQSER',
            wni_country: 'GQ',
            wni_lat: 3.7833,
            wni_lon: 8.0667,
            wni_tz: 'Africa/Malabo',
        },
        {
            option: 'SPO',
            wni_port_name: 'SEARSPORT',
            wni_unlocode: 'USSRP',
            wni_country: 'US',
            wni_lat: 44.4429,
            wni_lon: -68.908,
            wni_tz: 'America/New_York',
        },
        {
            option: 'SQB',
            wni_port_name: 'PORT QUABOOS',
            wni_unlocode: 'OMOPQ',
            wni_country: 'OM',
            wni_lat: 23.6355,
            wni_lon: 58.5772,
            wni_tz: 'Asia/Muscat',
        },
        {
            option: 'SQU',
            wni_port_name: 'SQUAMISH',
            wni_unlocode: 'CASQA',
            wni_country: 'CA',
            wni_lat: 49.6731,
            wni_lon: -123.1802,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'SRB',
            wni_port_name: 'SURABAYA',
            wni_unlocode: 'IDSUB',
            wni_country: 'ID',
            wni_lat: -7.1906,
            wni_lon: 112.7213,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'SRD',
            wni_port_name: 'SAMARINDA',
            wni_unlocode: 'IDSRI',
            wni_country: 'ID',
            wni_lat: -0.5091,
            wni_lon: 117.1502,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'SRE',
            wni_port_name: 'STURE',
            wni_unlocode: 'NOSTU',
            wni_country: 'NO',
            wni_lat: 60.6239,
            wni_lon: 4.8736,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SRG',
            wni_port_name: 'SOUTH RIDING POINT',
            wni_unlocode: 'BSSRP',
            wni_country: 'BS',
            wni_lat: 26.6067,
            wni_lon: -78.2299,
            wni_tz: 'America/Nassau',
        },
        {
            option: 'SRH',
            wni_port_name: 'SARROCH',
            wni_unlocode: 'ITPFX',
            wni_country: 'IT',
            wni_lat: 39.0859,
            wni_lon: 9.0564,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'SRL',
            wni_port_name: 'SOREL',
            wni_unlocode: 'CASOR',
            wni_country: 'CA',
            wni_lat: 46.0536,
            wni_lon: -73.1147,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'SRLY',
            wni_port_name: 'SURALAYA',
            wni_unlocode: 'IDSRL',
            wni_country: 'ID',
            wni_lat: -5.8786,
            wni_lon: 106.0225,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'SRR',
            wni_port_name: 'SHEET HARBOR',
            wni_unlocode: 'CASHH',
            wni_country: 'CA',
            wni_lat: 44.8988,
            wni_lon: -62.4908,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'SRRIS',
            wni_port_name: 'SIRRI ISLAND',
            wni_unlocode: 'IRSXI',
            wni_country: 'IR',
            wni_lat: 25.8882,
            wni_lon: 54.5609,
            wni_tz: 'Asia/Tehran',
        },
        {
            option: 'SRS',
            wni_port_name: 'SYROS',
            wni_unlocode: 'GRJSY',
            wni_country: 'GR',
            wni_lat: 37.4351,
            wni_lon: 24.9473,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'SSB',
            wni_port_name: 'SASEBO',
            wni_unlocode: 'JPAIN',
            wni_country: 'JP',
            wni_lat: 33.1171,
            wni_lon: 129.7194,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SSK',
            wni_port_name: 'SUSAKI',
            wni_unlocode: 'JPSUZ',
            wni_country: 'JP',
            wni_lat: 33.3643,
            wni_lon: 133.2865,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'STA',
            wni_port_name: 'SANTAREM',
            wni_unlocode: 'BRSTM',
            wni_country: 'BR',
            wni_lat: -2.4248,
            wni_lon: -54.6815,
            wni_tz: 'America/Santarem',
        },
        {
            option: 'STC',
            wni_port_name: 'ST CROIX ISLAND',
            wni_unlocode: 'VISTX',
            wni_country: 'VI',
            wni_lat: 17.6835,
            wni_lon: -64.7414,
            wni_tz: 'America/St_Thomas',
        },
        {
            option: 'STD',
            wni_port_name: 'STADE',
            wni_unlocode: 'DESTA',
            wni_country: 'DE',
            wni_lat: 53.6519,
            wni_lon: 9.5173,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'STDEN',
            wni_port_name: 'SU TU DEN TERMINAL',
            wni_unlocode: 'VNSTD',
            wni_country: 'VN',
            wni_lat: 10.1667,
            wni_lon: 108.4,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'STHWL',
            wni_port_name: 'SOUTHWOLD',
            wni_unlocode: 'GBSWD',
            wni_country: 'GB',
            wni_lat: 52.3281,
            wni_lon: 1.7001,
            wni_tz: 'Europe/London',
        },
        {
            option: 'STJ',
            wni_port_name: 'ST JOHN',
            wni_unlocode: 'CASJB',
            wni_country: 'CA',
            wni_lat: 45.2056,
            wni_lon: -66.0529,
            wni_tz: 'America/Moncton',
        },
        {
            option: 'STMFR',
            wni_port_name: 'STAMFORD',
            wni_unlocode: 'USXLX',
            wni_country: 'US',
            wni_lat: 41.0147,
            wni_lon: -73.5365,
            wni_tz: 'America/New_York',
        },
        {
            option: 'STO',
            wni_port_name: 'STOCKTON',
            wni_unlocode: 'USSCK',
            wni_country: 'US',
            wni_lat: 37.9533,
            wni_lon: -121.3005,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'STPG',
            wni_port_name: 'ST. PETERSBURG',
            wni_unlocode: 'RULED',
            wni_country: 'RU',
            wni_lat: 59.9208,
            wni_lon: 30.2014,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'STR',
            wni_port_name: 'SANTANDER',
            wni_unlocode: 'ESSDR',
            wni_country: 'ES',
            wni_lat: 43.4446,
            wni_lon: -3.8033,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'STRO',
            wni_port_name: 'ST. ROSE',
            wni_unlocode: 'USSRE',
            wni_country: 'US',
            wni_lat: 29.9274,
            wni_lon: -90.1898,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'STS',
            wni_port_name: 'SANTOS',
            wni_unlocode: 'BRSSZ',
            wni_country: 'BR',
            wni_lat: -23.9225,
            wni_lon: -46.3389,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'STU',
            wni_port_name: 'ST. EUSTATIUS',
            wni_unlocode: 'ANEUX',
            wni_country: 'BQ',
            wni_lat: 17.4917,
            wni_lon: -63.0159,
            wni_tz: 'America/Curacao',
        },
        {
            option: 'STX',
            wni_port_name: 'SANTO',
            wni_unlocode: 'VUSAN',
            wni_country: 'VU',
            wni_lat: -15.5246,
            wni_lon: 167.1877,
            wni_tz: 'Pacific/Efate',
        },
        {
            option: 'SUAL',
            wni_port_name: 'SUAL',
            wni_unlocode: 'PHMSC',
            wni_country: 'PH',
            wni_lat: 16.0653,
            wni_lon: 120.1135,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'SUAO',
            wni_port_name: 'SU AO',
            wni_unlocode: 'TWSUO',
            wni_country: 'TW',
            wni_lat: 24.5903,
            wni_lon: 121.8929,
            wni_tz: 'Asia/Taipei',
        },
        {
            option: 'SUAP',
            wni_port_name: 'SUAPE',
            wni_unlocode: 'BRSUA',
            wni_country: 'BR',
            wni_lat: -8.3991,
            wni_lon: -34.9371,
            wni_tz: 'America/Recife',
        },
        {
            option: 'SUB',
            wni_port_name: 'SUBIC BAY',
            wni_unlocode: 'PHSFS',
            wni_country: 'PH',
            wni_lat: 14.8064,
            wni_lon: 120.2818,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'SUE',
            wni_port_name: 'SUEZ CANAL',
            wni_unlocode: 'EGSUC',
            wni_country: 'EG',
            wni_lat: 30.578,
            wni_lon: 32.2858,
            wni_tz: 'Africa/Cairo',
        },
        {
            option: 'SUE1',
            wni_port_name: 'SUEZ',
            wni_unlocode: 'EGSUZ',
            wni_country: 'EG',
            wni_lat: 29.9315,
            wni_lon: 32.5378,
            wni_tz: 'Africa/Cairo',
        },
        {
            option: 'SUG',
            wni_port_name: 'SUNGAI PAKNING',
            wni_unlocode: 'IDSEQ',
            wni_country: 'ID',
            wni_lat: 1.3831,
            wni_lon: 102.1535,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'SUH',
            wni_port_name: 'SOHAR',
            wni_unlocode: 'OMSOH',
            wni_country: 'OM',
            wni_lat: 24.5181,
            wni_lon: 56.6326,
            wni_tz: 'Asia/Muscat',
        },
        {
            option: 'SUPS',
            wni_port_name: 'SUPSA TERMINAL',
            wni_unlocode: 'GESPS',
            wni_country: 'GE',
            wni_lat: 42.0167,
            wni_lon: 41.7166,
            wni_tz: 'Asia/Tbilisi',
        },
        {
            option: 'SUR',
            wni_port_name: 'NONOC ISLAND/SURIGAO DEL NORTE',
            wni_unlocode: 'PHNON',
            wni_country: 'PH',
            wni_lat: 9.754,
            wni_lon: 125.7128,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'SUR2',
            wni_port_name: 'SURIGAO',
            wni_unlocode: 'PHCNT',
            wni_country: 'PH',
            wni_lat: 9.7903,
            wni_lon: 125.5075,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'SUSOH',
            wni_port_name: 'SUSOH',
            wni_unlocode: 'IDSUS',
            wni_country: 'ID',
            wni_lat: 3.7193,
            wni_lon: 96.8015,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'SUV',
            wni_port_name: 'SUVA',
            wni_unlocode: 'FJSUV',
            wni_country: 'FJ',
            wni_lat: -18.1649,
            wni_lon: 178.4139,
            wni_tz: 'Pacific/Fiji',
        },
        {
            option: 'SVA',
            wni_port_name: 'SAVANNAH',
            wni_unlocode: 'USSAV',
            wni_country: 'US',
            wni_lat: 32.1325,
            wni_lon: -81.1381,
            wni_tz: 'America/New_York',
        },
        {
            option: 'SVE',
            wni_port_name: 'SAN VICENTE',
            wni_unlocode: 'CLSVE',
            wni_country: 'CL',
            wni_lat: -36.7268,
            wni_lon: -73.1872,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'SVI',
            wni_port_name: 'SEPT ILES (SEVEN ISLANDS)',
            wni_unlocode: 'CASEI',
            wni_country: 'CA',
            wni_lat: 50.1921,
            wni_lon: -66.3939,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'SVPL',
            wni_port_name: 'SEVASTOPOL',
            wni_unlocode: 'UASVP',
            wni_country: 'UA',
            wni_lat: 44.6244,
            wni_lon: 33.4977,
            wni_tz: 'Europe/Simferopol',
        },
        {
            option: 'SVR',
            wni_port_name: 'STAVANGER',
            wni_unlocode: 'NOSVG',
            wni_country: 'NO',
            wni_lat: 58.9437,
            wni_lon: 5.7712,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SVU',
            wni_port_name: 'SVEAGRUVA',
            wni_unlocode: 'SJSVE',
            wni_country: 'SJ',
            wni_lat: 77.8298,
            wni_lon: 16.6244,
            wni_tz: 'Arctic/Longyearbyen',
        },
        {
            option: 'SVY',
            wni_port_name: 'SVETLYY',
            wni_unlocode: 'RUSTY',
            wni_country: 'RU',
            wni_lat: 54.6514,
            wni_lon: 20.1307,
            wni_tz: 'Europe/Kaliningrad',
        },
        {
            option: 'SWA',
            wni_port_name: 'SWANSEA',
            wni_unlocode: 'GBSWA',
            wni_country: 'GB',
            wni_lat: 51.6062,
            wni_lon: -3.9285,
            wni_tz: 'Europe/London',
        },
        {
            option: 'SWI',
            wni_port_name: 'SWINOUJSCIE',
            wni_unlocode: 'PLSWI',
            wni_country: 'PL',
            wni_lat: 53.9344,
            wni_lon: 14.269,
            wni_tz: 'Europe/Warsaw',
        },
        {
            option: 'SWP',
            wni_port_name: 'SOUTHWEST PASS',
            wni_unlocode: 'USSW8',
            wni_country: 'US',
            wni_lat: 28.2833,
            wni_lon: -90.55,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'SWT',
            wni_port_name: 'STEWART',
            wni_unlocode: 'CASTW',
            wni_country: 'CA',
            wni_lat: 55.9141,
            wni_lon: -130,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'SZC',
            wni_port_name: 'SZCZECIN',
            wni_unlocode: 'PLSZZ',
            wni_country: 'PL',
            wni_lat: 53.4343,
            wni_lon: 14.578,
            wni_tz: 'Europe/Warsaw',
        },
        {
            option: 'SZH',
            wni_port_name: 'SHENZHEN',
            wni_unlocode: 'CNSZX',
            wni_country: 'CN',
            wni_lat: 22.4927,
            wni_lon: 113.8558,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'TAA',
            wni_port_name: 'TACHIBANA',
            wni_unlocode: 'JPTBN',
            wni_country: 'JP',
            wni_lat: 33.8707,
            wni_lon: 134.6653,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TAB',
            wni_port_name: 'TABACO',
            wni_unlocode: 'PHTBC',
            wni_country: 'PH',
            wni_lat: 13.4217,
            wni_lon: 123.735,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'TABG',
            wni_port_name: 'TABOGUILLA ISLAND',
            wni_unlocode: 'PATBG',
            wni_country: 'PA',
            wni_lat: 8.8087,
            wni_lon: -79.525,
            wni_tz: 'America/Panama',
        },
        {
            option: 'TAC',
            wni_port_name: 'TACOMA',
            wni_unlocode: 'USTIW',
            wni_country: 'US',
            wni_lat: 47.276,
            wni_lon: -122.4371,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'TAE',
            wni_port_name: 'TAKEHARA',
            wni_unlocode: 'JPTHR',
            wni_country: 'JP',
            wni_lat: 34.3167,
            wni_lon: 132.9144,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TAEN',
            wni_port_name: 'TAEAN',
            wni_unlocode: 'KRTAN',
            wni_country: 'KR',
            wni_lat: 36.9188,
            wni_lon: 126.2377,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'TAF',
            wni_port_name: 'TAFT',
            wni_unlocode: 'USTFT',
            wni_country: 'US',
            wni_lat: 29.9971,
            wni_lon: -90.4585,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'TAG',
            wni_port_name: 'TAGONOURA',
            wni_unlocode: 'JPTGN',
            wni_country: 'JP',
            wni_lat: 35.1227,
            wni_lon: 138.7022,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TAJ',
            wni_port_name: 'TANJUNG MANIS',
            wni_unlocode: 'MYTMP',
            wni_country: 'MY',
            wni_lat: 2.1431,
            wni_lon: 111.2501,
            wni_tz: 'Asia/Kuching',
        },
        {
            option: 'TAMS',
            wni_port_name: 'THAMESPORT/ISLE OF GRAIN',
            wni_unlocode: 'GBIOG',
            wni_country: 'GB',
            wni_lat: 51.4553,
            wni_lon: 0.7434,
            wni_tz: 'Europe/London',
        },
        {
            option: 'TAN',
            wni_port_name: 'TANABE',
            wni_unlocode: 'JPTAE',
            wni_country: 'JP',
            wni_lat: 33.7153,
            wni_lon: 135.364,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TAP',
            wni_port_name: 'TALARA',
            wni_unlocode: 'PETYL',
            wni_country: 'PE',
            wni_lat: -4.5667,
            wni_lon: -81.2833,
            wni_tz: 'America/Lima',
        },
        {
            option: 'TAR',
            wni_port_name: 'TARANTO',
            wni_unlocode: 'ITTAR',
            wni_country: 'IT',
            wni_lat: 40.4652,
            wni_lon: 17.21,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'TARA',
            wni_port_name: 'TARAHAN\t SUMATRA',
            wni_unlocode: 'IDTRH',
            wni_country: 'ID',
            wni_lat: -5.4711,
            wni_lon: 105.3089,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'TAT',
            wni_port_name: 'TAIPEI',
            wni_unlocode: 'TWTPE',
            wni_country: 'TW',
            wni_lat: 25.1516,
            wni_lon: 121.3428,
            wni_tz: 'Asia/Taipei',
        },
        {
            option: 'TATU',
            wni_port_name: 'TAITUNG',
            wni_unlocode: 'TWTTT',
            wni_country: 'TW',
            wni_lat: 22.45,
            wni_lon: 121.08,
            wni_tz: 'Asia/Taipei',
        },
        {
            option: 'TAU',
            wni_port_name: 'TAURANGA',
            wni_unlocode: 'NZTRG',
            wni_country: 'NZ',
            wni_lat: -37.65,
            wni_lon: 176.1673,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'TAW',
            wni_port_name: 'TAWAU',
            wni_unlocode: 'MYTWU',
            wni_country: 'MY',
            wni_lat: 4.2328,
            wni_lon: 117.8753,
            wni_tz: 'Asia/Kuching',
        },
        {
            option: 'TBAN',
            wni_port_name: 'TUBAN',
            wni_unlocode: 'IDTBN',
            wni_country: 'ID',
            wni_lat: -6.8798,
            wni_lon: 112.0713,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'TBN',
            wni_port_name: 'TABONEO',
            wni_unlocode: 'IDTAB',
            wni_country: 'ID',
            wni_lat: -3.7,
            wni_lon: 114.5,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'TBO',
            wni_port_name: 'TURBO',
            wni_unlocode: 'COTRB',
            wni_country: 'CO',
            wni_lat: 8.0591,
            wni_lon: -76.7305,
            wni_tz: 'America/Bogota',
        },
        {
            option: 'TCG',
            wni_port_name: 'TAICANG',
            wni_unlocode: 'CNTAC',
            wni_country: 'CN',
            wni_lat: 31.6524,
            wni_lon: 121.2286,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'TCH',
            wni_port_name: 'TALCAHUANO',
            wni_unlocode: 'CLTAL',
            wni_country: 'CL',
            wni_lat: -36.7006,
            wni_lon: -73.0856,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'TCL',
            wni_port_name: 'TRINCOMALEE',
            wni_unlocode: 'TKTRR',
            wni_country: 'LK',
            wni_lat: 8.5562,
            wni_lon: 81.2136,
            wni_tz: 'Asia/Colombo',
        },
        {
            option: 'TCN',
            wni_port_name: 'TAICHUNG',
            wni_unlocode: 'TWTXG',
            wni_country: 'TW',
            wni_lat: 24.3027,
            wni_lon: 120.4738,
            wni_tz: 'Asia/Taipei',
        },
        {
            option: 'TDO',
            wni_port_name: 'TADOTSU',
            wni_unlocode: 'JPTAD',
            wni_country: 'JP',
            wni_lat: 34.2886,
            wni_lon: 133.7341,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TEE',
            wni_port_name: 'TEESPORT',
            wni_unlocode: 'GBTEE',
            wni_country: 'GB',
            wni_lat: 54.6533,
            wni_lon: -1.1483,
            wni_tz: 'Europe/London',
        },
        {
            option: 'TEK',
            wni_port_name: 'TEKIRDAG',
            wni_unlocode: 'TRTEK',
            wni_country: 'TR',
            wni_lat: 40.9596,
            wni_lon: 27.5193,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'TEM',
            wni_port_name: 'TEMA',
            wni_unlocode: 'GHTEM',
            wni_country: 'GH',
            wni_lat: 5.6279,
            wni_lon: 0.0262,
            wni_tz: 'Africa/Accra',
        },
        {
            option: 'TEO',
            wni_port_name: 'TEOUDIE',
            wni_unlocode: 'NCTOD',
            wni_country: 'NC',
            wni_lat: -20.75,
            wni_lon: 164.35,
            wni_tz: 'Pacific/Noumea',
        },
        {
            option: 'TER',
            wni_port_name: 'TERNEUZEN',
            wni_unlocode: 'NLTNZ',
            wni_country: 'NL',
            wni_lat: 51.35,
            wni_lon: 3.8121,
            wni_tz: 'Europe/Amsterdam',
        },
        {
            option: 'TGMD',
            wni_port_name: 'TANGER MED',
            wni_unlocode: 'MAPTM',
            wni_country: 'MA',
            wni_lat: 35.9077,
            wni_lon: -5.5,
            wni_tz: 'Africa/Casablanca',
        },
        {
            option: 'TGP',
            wni_port_name: 'TANJUNG PELEPAS',
            wni_unlocode: 'MYTPP',
            wni_country: 'MY',
            wni_lat: 1.3531,
            wni_lon: 103.542,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'TGRM',
            wni_port_name: 'TANGIER\tMOR',
            wni_unlocode: 'MATNG',
            wni_country: 'MA',
            wni_lat: 35.7984,
            wni_lon: -5.7942,
            wni_tz: 'Africa/Casablanca',
        },
        {
            option: 'THA',
            wni_port_name: 'TAHARA',
            wni_unlocode: 'JPTAR',
            wni_country: 'JP',
            wni_lat: 34.7499,
            wni_lon: 137.2762,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'THH',
            wni_port_name: 'TAHAROA',
            wni_unlocode: 'NZTHH',
            wni_country: 'NZ',
            wni_lat: -38.1763,
            wni_lon: 174.6929,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'THI',
            wni_port_name: 'THURSDAY ISLAND',
            wni_unlocode: 'AUTIS',
            wni_country: 'AU',
            wni_lat: -10.5968,
            wni_lon: 142.2217,
            wni_tz: 'Australia/Brisbane',
        },
        {
            option: 'THR',
            wni_port_name: 'THORSHAVN',
            wni_unlocode: 'FOTHO',
            wni_country: 'FO',
            wni_lat: 61.974,
            wni_lon: -6.7079,
            wni_tz: 'Atlantic/Faroe',
        },
        {
            option: 'THRA',
            wni_port_name: 'THIRA',
            wni_unlocode: 'GRJTR',
            wni_country: 'GR',
            wni_lat: 36.3919,
            wni_lon: 25.4204,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'TIL',
            wni_port_name: 'TILBURY',
            wni_unlocode: 'GBTIL',
            wni_country: 'GB',
            wni_lat: 51.4532,
            wni_lon: 0.3344,
            wni_tz: 'Europe/London',
        },
        {
            option: 'TIM',
            wni_port_name: 'TIMARU',
            wni_unlocode: 'NZTIU',
            wni_country: 'NZ',
            wni_lat: -44.3891,
            wni_lon: 171.2777,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'TIO',
            wni_port_name: 'THIO',
            wni_unlocode: 'NCTHI',
            wni_country: 'NC',
            wni_lat: -21.6065,
            wni_lon: 166.2478,
            wni_tz: 'Pacific/Noumea',
        },
        {
            option: 'TISN',
            wni_port_name: 'TIESHAN',
            wni_unlocode: 'CNBHT',
            wni_country: 'CN',
            wni_lat: 21.471,
            wni_lon: 109.558,
            wni_tz: 'Asia/Chongqing',
        },
        {
            option: 'TJB',
            wni_port_name: 'TANJUNG BARA',
            wni_unlocode: 'IDTBA',
            wni_country: 'ID',
            wni_lat: 0.5329,
            wni_lon: 117.6697,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'TJP',
            wni_port_name: 'TANJUNG PRIOK (JAKARTA)',
            wni_unlocode: 'IDJKT',
            wni_country: 'ID',
            wni_lat: -6.0715,
            wni_lon: 106.8825,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'TJU',
            wni_port_name: 'TANJUNGUBAN',
            wni_unlocode: 'IDTAN',
            wni_country: 'ID',
            wni_lat: 1.0829,
            wni_lon: 104.2054,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'TKM',
            wni_port_name: 'TAKAMATSU',
            wni_unlocode: 'JPTAK',
            wni_country: 'JP',
            wni_lat: 34.37,
            wni_lon: 134.0581,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TKTH',
            wni_port_name: "TA'KUNTAH",
            wni_unlocode: 'MXTAK',
            wni_country: 'MX',
            wni_lat: 19.683,
            wni_lon: -92.0835,
            wni_tz: 'America/Merida',
        },
        {
            option: 'TKU',
            wni_port_name: 'TAKUMA',
            wni_unlocode: 'JPTKM',
            wni_country: 'JP',
            wni_lat: 34.2448,
            wni_lon: 133.6827,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TLL',
            wni_port_name: 'TALLINN',
            wni_unlocode: 'EETLL',
            wni_country: 'EE',
            wni_lat: 59.4564,
            wni_lon: 24.7634,
            wni_tz: 'Europe/Tallinn',
        },
        {
            option: 'TLY',
            wni_port_name: 'TOLIARY',
            wni_unlocode: 'MGTLE',
            wni_country: 'MG',
            wni_lat: -23.3832,
            wni_lon: 43.6565,
            wni_tz: 'Indian/Antananarivo',
        },
        {
            option: 'TMB',
            wni_port_name: 'TEMBLADORA',
            wni_unlocode: 'TTTEM',
            wni_country: 'TT',
            wni_lat: 10.6694,
            wni_lon: -61.5977,
            wni_tz: 'America/Port_of_Spain',
        },
        {
            option: 'TMC',
            wni_port_name: 'TAMPICO',
            wni_unlocode: 'MXTAM',
            wni_country: 'MX',
            wni_lat: 22.2078,
            wni_lon: -97.8543,
            wni_tz: 'America/Monterrey',
        },
        {
            option: 'TMS',
            wni_port_name: 'TROMSO',
            wni_unlocode: 'NOTOS',
            wni_country: 'NO',
            wni_lat: 69.6474,
            wni_lon: 18.9707,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'TMT',
            wni_port_name: 'TOAMASINA (TAMATAVE)',
            wni_unlocode: 'MGTMM',
            wni_country: 'MG',
            wni_lat: -18.1518,
            wni_lon: 49.4383,
            wni_tz: 'Indian/Antananarivo',
        },
        {
            option: 'TNG',
            wni_port_name: 'TANGA',
            wni_unlocode: 'TZTGT',
            wni_country: 'TZ',
            wni_lat: -5.0531,
            wni_lon: 39.1402,
            wni_tz: 'Africa/Dar_es_Salaam',
        },
        {
            option: 'TNGTO',
            wni_port_name: 'TAGANITO',
            wni_unlocode: 'PHTTO',
            wni_country: 'PH',
            wni_lat: 9.5553,
            wni_lon: 125.8188,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'TNGU',
            wni_port_name: 'TANGGUH',
            wni_unlocode: 'IDTNG',
            wni_country: 'ID',
            wni_lat: -2.4273,
            wni_lon: 133.1314,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'TNGYNG',
            wni_port_name: 'TONGYONG',
            wni_unlocode: 'KRTYG',
            wni_country: 'KR',
            wni_lat: 34.8301,
            wni_lon: 128.452,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'TNJ',
            wni_port_name: 'XINGANG/TIANJIN',
            wni_unlocode: 'CNTNG',
            wni_country: 'CN',
            wni_lat: 38.958,
            wni_lon: 117.8196,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'TNJNG',
            wni_port_name: 'TANJUNG PANDAN',
            wni_unlocode: 'IDTJQ',
            wni_country: 'ID',
            wni_lat: -2.734,
            wni_lon: 107.5858,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'TNRA',
            wni_port_name: 'RAS TANURA',
            wni_unlocode: 'SARTA',
            wni_country: 'SA',
            wni_lat: 26.6502,
            wni_lon: 50.1797,
            wni_tz: 'Asia/Riyadh',
        },
        {
            option: 'TNS',
            wni_port_name: 'TOWNSVILLE',
            wni_unlocode: 'AUTSV',
            wni_country: 'AU',
            wni_lat: -19.2345,
            wni_lon: 146.8353,
            wni_tz: 'Australia/Brisbane',
        },
        {
            option: 'TNZ',
            wni_port_name: 'TORRE ANNUNZIATA',
            wni_unlocode: 'ITTOA',
            wni_country: 'IT',
            wni_lat: 40.7368,
            wni_lon: 14.4412,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'TOBA',
            wni_port_name: 'TOBA',
            wni_unlocode: 'JPTOB',
            wni_country: 'JP',
            wni_lat: 34.4975,
            wni_lon: 136.8518,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TOBOS',
            wni_port_name: 'TOBOSO',
            wni_unlocode: 'PHTOB',
            wni_country: 'PH',
            wni_lat: 10.7251,
            wni_lon: 123.5266,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'TOCP',
            wni_port_name: 'TOCOPILLA',
            wni_unlocode: 'CLTOQ',
            wni_country: 'CL',
            wni_lat: -22.0866,
            wni_lon: -70.2135,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'TOD',
            wni_port_name: 'TAKORADI',
            wni_unlocode: 'GHTKD',
            wni_country: 'GH',
            wni_lat: 4.8819,
            wni_lon: -1.7251,
            wni_tz: 'Africa/Accra',
        },
        {
            option: 'TOH',
            wni_port_name: 'TOKACHI',
            wni_unlocode: 'JPTOK',
            wni_country: 'JP',
            wni_lat: 42.3083,
            wni_lon: 143.356,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TOK',
            wni_port_name: 'TOKYO',
            wni_unlocode: 'JPHAU',
            wni_country: 'JP',
            wni_lat: 35.5784,
            wni_lon: 139.8255,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TOL',
            wni_port_name: 'TOLEDO',
            wni_unlocode: 'USTOL',
            wni_country: 'US',
            wni_lat: 41.6979,
            wni_lon: -83.4643,
            wni_tz: 'America/New_York',
        },
        {
            option: 'TOM',
            wni_port_name: 'TOMAKOMAI',
            wni_unlocode: 'JPTMK',
            wni_country: 'JP',
            wni_lat: 42.6114,
            wni_lon: 141.6235,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TOR',
            wni_port_name: 'TORONTO',
            wni_unlocode: 'CATOR',
            wni_country: 'CA',
            wni_lat: 43.6095,
            wni_lon: -79.3596,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'TOU',
            wni_port_name: 'TOULON',
            wni_unlocode: 'FRTLN',
            wni_country: 'FR',
            wni_lat: 43.1079,
            wni_lon: 5.919,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'TOY',
            wni_port_name: 'TOYOHASHI',
            wni_unlocode: 'JPTHS',
            wni_country: 'JP',
            wni_lat: 34.7367,
            wni_lon: 137.2609,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TPA',
            wni_port_name: 'TAMPA',
            wni_unlocode: 'USTPA',
            wni_country: 'US',
            wni_lat: 27.9,
            wni_lon: -82.4438,
            wni_tz: 'America/New_York',
        },
        {
            option: 'TPL',
            wni_port_name: 'TRIPOLI',
            wni_unlocode: 'LYTIP',
            wni_country: 'LY',
            wni_lat: 32.9282,
            wni_lon: 13.2175,
            wni_tz: 'Africa/Tripoli',
        },
        {
            option: 'TPP',
            wni_port_name: 'TOPOLOBAMPO',
            wni_unlocode: 'MXTPB',
            wni_country: 'MX',
            wni_lat: 25.5733,
            wni_lon: -109.0698,
            wni_tz: 'America/Hermosillo',
        },
        {
            option: 'TPS',
            wni_port_name: 'TUAPSE',
            wni_unlocode: 'RUTUA',
            wni_country: 'RU',
            wni_lat: 44.0764,
            wni_lon: 39.0622,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'TRA',
            wni_port_name: 'TARRAGONA',
            wni_unlocode: 'ESTAR',
            wni_country: 'ES',
            wni_lat: 41.0779,
            wni_lon: 1.2237,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'TRBLS',
            wni_port_name: 'TRIPOLI',
            wni_unlocode: 'LBKYE',
            wni_country: 'LB',
            wni_lat: 34.4689,
            wni_lon: 35.8364,
            wni_tz: 'Asia/Beirut',
        },
        {
            option: 'TRET',
            wni_port_name: 'TRIESTE',
            wni_unlocode: 'ITTRS',
            wni_country: 'IT',
            wni_lat: 45.6426,
            wni_lon: 13.7255,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'TRJ',
            wni_port_name: 'TARJUN',
            wni_unlocode: 'IDTAR',
            wni_country: 'ID',
            wni_lat: -3.2895,
            wni_lon: 116.1181,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'TRK',
            wni_port_name: 'TARAKAN',
            wni_unlocode: 'IDTRK',
            wni_country: 'ID',
            wni_lat: 3.2677,
            wni_lon: 117.5919,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'TRM',
            wni_port_name: 'TROMBETAS',
            wni_unlocode: 'BRTMT',
            wni_country: 'BR',
            wni_lat: -1.4593,
            wni_lon: -56.3804,
            wni_tz: 'America/Santarem',
        },
        {
            option: 'TRMB',
            wni_port_name: 'TERMISA',
            wni_unlocode: 'BRTET',
            wni_country: 'BR',
            wni_lat: -4.816,
            wni_lon: -37.0333,
            wni_tz: 'America/Fortaleza',
        },
        {
            option: 'TRN',
            wni_port_name: 'TRAMANDAI',
            wni_unlocode: 'BRTRM',
            wni_country: 'BR',
            wni_lat: -29.977,
            wni_lon: -50.1126,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'TRPZ',
            wni_port_name: 'ST. TROPEZ',
            wni_unlocode: 'FRSTP',
            wni_country: 'FR',
            wni_lat: 43.2949,
            wni_lon: 6.7282,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'TRV',
            wni_port_name: 'THREE RIVERS',
            wni_unlocode: 'CATRR',
            wni_country: 'CA',
            wni_lat: 46.323,
            wni_lon: -72.5412,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'TRW',
            wni_port_name: 'TARAWA',
            wni_unlocode: 'KITRW',
            wni_country: 'KI',
            wni_lat: 1.3169,
            wni_lon: 172.9769,
            wni_tz: 'Pacific/Tarawa',
        },
        {
            option: 'TSHM',
            wni_port_name: 'TOKUSHIMA',
            wni_unlocode: 'JPTKS',
            wni_country: 'JP',
            wni_lat: 34.0493,
            wni_lon: 134.6198,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TSHN',
            wni_port_name: 'TAISHAN',
            wni_unlocode: 'CNTIS',
            wni_country: 'CN',
            wni_lat: 21.8361,
            wni_lon: 112.9116,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'TSK',
            wni_port_name: 'TSUKUMI',
            wni_unlocode: 'JPTMI',
            wni_country: 'JP',
            wni_lat: 33.0884,
            wni_lon: 131.8936,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TSL',
            wni_port_name: 'THESSALONIKI',
            wni_unlocode: 'GRSKG',
            wni_country: 'GR',
            wni_lat: 40.6239,
            wni_lon: 22.9153,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'TSR',
            wni_port_name: 'TURUGA',
            wni_unlocode: 'JPTRG',
            wni_country: 'JP',
            wni_lat: 35.6833,
            wni_lon: 136.05,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TSV',
            wni_port_name: 'THISVI',
            wni_unlocode: 'GRTHI',
            wni_country: 'GR',
            wni_lat: 38.2087,
            wni_lon: 22.9474,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'TTN',
            wni_port_name: 'TANTAWAN TERMINAL',
            wni_unlocode: 'THTTE',
            wni_country: 'TH',
            wni_lat: 10.0833,
            wni_lon: 101.4166,
            wni_tz: 'Asia/Bangkok',
        },
        {
            option: 'TTO',
            wni_port_name: 'TONTOUTA',
            wni_unlocode: 'NCTON',
            wni_country: 'NC',
            wni_lat: -22.0458,
            wni_lon: 166.0782,
            wni_tz: 'Pacific/Noumea',
        },
        {
            option: 'TTS',
            wni_port_name: 'TARTOUS',
            wni_unlocode: 'SYTTS',
            wni_country: 'SY',
            wni_lat: 34.9133,
            wni_lon: 35.8434,
            wni_tz: 'Asia/Damascus',
        },
        {
            option: 'TUB',
            wni_port_name: 'TUBARAO',
            wni_unlocode: 'BRTUB',
            wni_country: 'BR',
            wni_lat: -20.3086,
            wni_lon: -40.2348,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'TUK',
            wni_port_name: 'ABO (TURKU)',
            wni_unlocode: 'FITKU',
            wni_country: 'FI',
            wni_lat: 60.4271,
            wni_lon: 22.1943,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'TUN',
            wni_port_name: 'TUNIS',
            wni_unlocode: 'TNRDS',
            wni_country: 'TN',
            wni_lat: 36.7998,
            wni_lon: 10.3193,
            wni_tz: 'Africa/Tunis',
        },
        {
            option: 'TUT',
            wni_port_name: 'TUTICORIN',
            wni_unlocode: 'INTUT',
            wni_country: 'IN',
            wni_lat: 8.743,
            wni_lon: 78.2348,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'TUTU',
            wni_port_name: 'TUTUNCIFTLIK/KORFEZ',
            wni_unlocode: 'TRTUT',
            wni_country: 'TR',
            wni_lat: 40.7395,
            wni_lon: 29.7457,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'TUX',
            wni_port_name: 'TUXPAN',
            wni_unlocode: 'MXTUX',
            wni_country: 'MX',
            wni_lat: 20.9466,
            wni_lon: -97.3949,
            wni_tz: 'America/Mexico_City',
        },
        {
            option: 'TVN',
            wni_port_name: 'THEVENARD',
            wni_unlocode: 'AUTHE',
            wni_country: 'AU',
            wni_lat: -32.1638,
            wni_lon: 133.646,
            wni_tz: 'Australia/Adelaide',
        },
        {
            option: 'TXAS',
            wni_port_name: 'TEXAS CITY',
            wni_unlocode: 'USTXS',
            wni_country: 'US',
            wni_lat: 29.3767,
            wni_lon: -94.8875,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'TXNG',
            wni_port_name: 'TAIXING',
            wni_unlocode: 'CNTAX',
            wni_country: 'CN',
            wni_lat: 32.1355,
            wni_lon: 119.9034,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'TYN',
            wni_port_name: 'TYNE',
            wni_unlocode: 'GBTYN',
            wni_country: 'GB',
            wni_lat: 55.0147,
            wni_lon: -1.3856,
            wni_tz: 'Europe/London',
        },
        {
            option: 'TZH',
            wni_port_name: 'TAIZHOU',
            wni_unlocode: 'CNTZO',
            wni_country: 'CN',
            wni_lat: 32.2722,
            wni_lon: 119.8608,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'UAQ',
            wni_port_name: 'UMM AL QAYWAYN',
            wni_unlocode: 'AEQIW',
            wni_country: 'AE',
            wni_lat: 25.5999,
            wni_lon: 55.5879,
            wni_tz: 'Asia/Dubai',
        },
        {
            option: 'UBE',
            wni_port_name: 'UBE',
            wni_unlocode: 'JPUBE',
            wni_country: 'JP',
            wni_lat: 33.9219,
            wni_lon: 131.2189,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'UBU',
            wni_port_name: 'UBU',
            wni_unlocode: 'BRUBU',
            wni_country: 'BR',
            wni_lat: -20.7987,
            wni_lon: -40.5614,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'UCMI',
            wni_port_name: 'UCHIUMI',
            wni_unlocode: 'JPUCH',
            wni_country: 'JP',
            wni_lat: 31.7481,
            wni_lon: 131.4758,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'UDD',
            wni_port_name: 'UDDEVALLA',
            wni_unlocode: 'SEUDD',
            wni_country: 'SE',
            wni_lat: 58.3371,
            wni_lon: 11.8888,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'ULN',
            wni_port_name: 'ULSAN',
            wni_unlocode: 'KRUSN',
            wni_country: 'KR',
            wni_lat: 35.4571,
            wni_lon: 129.4002,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'ULUGA',
            wni_port_name: 'UST-LUGA',
            wni_unlocode: 'RUULU',
            wni_country: 'RU',
            wni_lat: 59.6866,
            wni_lon: 28.4033,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'UMM',
            wni_port_name: 'UMM SAID (MESAIEED)',
            wni_unlocode: 'QAMES',
            wni_country: 'QA',
            wni_lat: 24.9577,
            wni_lon: 51.6048,
            wni_tz: 'Asia/Qatar',
        },
        {
            option: 'UNA',
            wni_port_name: 'TUNA',
            wni_unlocode: 'INTUN',
            wni_country: 'IN',
            wni_lat: 22.58,
            wni_lon: 70.14,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'UNO',
            wni_port_name: 'UNO',
            wni_unlocode: 'JPUNO',
            wni_country: 'JP',
            wni_lat: 34.481,
            wni_lon: 133.9583,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'UQA',
            wni_port_name: 'UMM QASR',
            wni_unlocode: 'IQUQR',
            wni_country: 'IQ',
            wni_lat: 30.0339,
            wni_lon: 47.9552,
            wni_tz: 'Asia/Baghdad',
        },
        {
            option: 'URG',
            wni_port_name: 'URAGA SUIDO',
            wni_unlocode: 'JPURG',
            wni_country: 'JP',
            wni_lat: 35.2083,
            wni_lon: 139.78,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'USK',
            wni_port_name: 'USUKI',
            wni_unlocode: 'JPUSK',
            wni_country: 'JP',
            wni_lat: 33.1328,
            wni_lon: 131.8214,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'VAI',
            wni_port_name: 'VADINAR',
            wni_unlocode: 'INVAD',
            wni_country: 'IN',
            wni_lat: 22.5,
            wni_lon: 69.7,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'VAL',
            wni_port_name: 'VALENCIA',
            wni_unlocode: 'ESVLC',
            wni_country: 'ES',
            wni_lat: 39.4265,
            wni_lon: -0.2921,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'VANG',
            wni_port_name: 'VUNG ANG',
            wni_unlocode: 'VNVAG',
            wni_country: 'VN',
            wni_lat: 18.1119,
            wni_lon: 106.399,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'VAO',
            wni_port_name: 'VANINO',
            wni_unlocode: 'RUVNN',
            wni_country: 'RU',
            wni_lat: 49.0845,
            wni_lon: 140.272,
            wni_tz: 'Asia/Vladivostok',
        },
        {
            option: 'VAR',
            wni_port_name: 'VARNA',
            wni_unlocode: 'BGVAR',
            wni_country: 'BG',
            wni_lat: 43.1859,
            wni_lon: 27.933,
            wni_tz: 'Europe/Sofia',
        },
        {
            option: 'VARB',
            wni_port_name: 'VARBERG',
            wni_unlocode: 'SEVAG',
            wni_country: 'SE',
            wni_lat: 57.1085,
            wni_lon: 12.2311,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'VBC',
            wni_port_name: 'VANCOUVER',
            wni_unlocode: 'CAVAN',
            wni_country: 'CA',
            wni_lat: 49.2978,
            wni_lon: -123.0999,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'VCS',
            wni_port_name: 'PORT VICTORIA',
            wni_unlocode: 'SCPOV',
            wni_country: 'SC',
            wni_lat: -4.6188,
            wni_lon: 55.4805,
            wni_tz: 'Indian/Mahe',
        },
        {
            option: 'VDC',
            wni_port_name: 'VILA DO CONDE',
            wni_unlocode: 'BRVIC',
            wni_country: 'BR',
            wni_lat: -1.5416,
            wni_lon: -48.7713,
            wni_tz: 'America/Belem',
        },
        {
            option: 'VDZ',
            wni_port_name: 'VALDEZ',
            wni_unlocode: 'USVDZ',
            wni_country: 'US',
            wni_lat: 61.1103,
            wni_lon: -146.3614,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'VE',
            wni_port_name: 'VENEZIA',
            wni_unlocode: 'ITVCE',
            wni_country: 'IT',
            wni_lat: 45.4479,
            wni_lon: 12.2894,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'VER',
            wni_port_name: 'VERA CRUZ',
            wni_unlocode: 'MXVER',
            wni_country: 'MX',
            wni_lat: 19.2023,
            wni_lon: -96.1113,
            wni_tz: 'America/Mexico_City',
        },
        {
            option: 'VFT',
            wni_port_name: 'VIEUX FORT',
            wni_unlocode: 'LCVIF',
            wni_country: 'LC',
            wni_lat: 13.717,
            wni_lon: -60.9637,
            wni_tz: 'America/St_Lucia',
        },
        {
            option: 'VGOGH',
            wni_port_name: 'VAN GOGH',
            wni_unlocode: 'AUVGH',
            wni_country: 'AU',
            wni_lat: -21.3999,
            wni_lon: 114.0666,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'VGT',
            wni_port_name: 'VUNG TAU',
            wni_unlocode: 'VNVUN',
            wni_country: 'VN',
            wni_lat: 10.3458,
            wni_lon: 107.0596,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'VIB',
            wni_port_name: 'VITORIA',
            wni_unlocode: 'BRVIX',
            wni_country: 'BR',
            wni_lat: -20.3234,
            wni_lon: -40.3379,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'VIG',
            wni_port_name: 'VIGO',
            wni_unlocode: 'ESVGO',
            wni_country: 'ES',
            wni_lat: 42.2417,
            wni_lon: -8.7462,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'VIL',
            wni_port_name: 'VILLANUEVA',
            wni_unlocode: 'PHVNV',
            wni_country: 'PH',
            wni_lat: 8.5834,
            wni_lon: 124.7513,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'VINA',
            wni_port_name: 'HYUNDAI-VINASHIN SHIPYARD',
            wni_unlocode: 'VNNIH',
            wni_country: 'VN',
            wni_lat: 12.5023,
            wni_lon: 109.2771,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'VIS',
            wni_port_name: 'VISAKHAPATNAM',
            wni_unlocode: 'INVPM',
            wni_country: 'IN',
            wni_lat: 17.6865,
            wni_lon: 83.3157,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'VISBY',
            wni_port_name: 'VISBY',
            wni_unlocode: 'SEVBY',
            wni_country: 'SE',
            wni_lat: 57.6372,
            wni_lon: 18.2555,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'VLA',
            wni_port_name: 'VLADIVOSTOK',
            wni_unlocode: 'RUVVO',
            wni_country: 'RU',
            wni_lat: 43.0716,
            wni_lon: 131.8698,
            wni_tz: 'Asia/Vladivostok',
        },
        {
            option: 'VLG',
            wni_port_name: 'VLISSINGEN (FLUSHING)',
            wni_unlocode: 'NLVLI',
            wni_country: 'NL',
            wni_lat: 51.4273,
            wni_lon: 3.5936,
            wni_tz: 'Europe/Amsterdam',
        },
        {
            option: 'VLL',
            wni_port_name: 'VILLAGARCIA',
            wni_unlocode: 'ESVIL',
            wni_country: 'ES',
            wni_lat: 42.6002,
            wni_lon: -8.7965,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'VLP',
            wni_port_name: 'VALPARAISO',
            wni_unlocode: 'CLVAP',
            wni_country: 'CL',
            wni_lat: -33.0338,
            wni_lon: -71.6136,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'VLT',
            wni_port_name: 'VALLETTA',
            wni_unlocode: 'MTMLA',
            wni_country: 'MT',
            wni_lat: 35.9077,
            wni_lon: 14.5302,
            wni_tz: 'Europe/Malta',
        },
        {
            option: 'VNT',
            wni_port_name: 'VENTSPILS',
            wni_unlocode: 'LVVNT',
            wni_country: 'LV',
            wni_lat: 57.4123,
            wni_lon: 21.5117,
            wni_tz: 'Europe/Riga',
        },
        {
            option: 'VNTR',
            wni_port_name: 'VENTURA',
            wni_unlocode: 'USVNT',
            wni_country: 'US',
            wni_lat: 34.2449,
            wni_lon: -119.2834,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'VOL',
            wni_port_name: 'VOLOS',
            wni_unlocode: 'GRVOL',
            wni_country: 'GR',
            wni_lat: 39.3397,
            wni_lon: 22.9533,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'VOST',
            wni_port_name: 'VOSTOCHNYY\t PRIMORSKY',
            wni_unlocode: 'RUVYP',
            wni_country: 'RU',
            wni_lat: 42.7532,
            wni_lon: 133.0399,
            wni_tz: 'Asia/Vladivostok',
        },
        {
            option: 'VRN',
            wni_port_name: 'VARANUS ISLAND TERMINAL',
            wni_unlocode: 'AUVAR',
            wni_country: 'AU',
            wni_lat: -20.6333,
            wni_lon: 115.6,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'VTI',
            wni_port_name: 'VITINO',
            wni_unlocode: 'RUVIT',
            wni_country: 'RU',
            wni_lat: 67.0784,
            wni_lon: 32.3552,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'VWA',
            wni_port_name: 'VANCOUVER',
            wni_unlocode: 'USBCC',
            wni_country: 'US',
            wni_lat: 45.6069,
            wni_lon: -122.6417,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'VYS',
            wni_port_name: 'VYSOTSK',
            wni_unlocode: 'RUVYS',
            wni_country: 'RU',
            wni_lat: 60.6235,
            wni_lon: 28.5532,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'WADO',
            wni_port_name: 'WANDOO',
            wni_unlocode: 'AUWNT',
            wni_country: 'AU',
            wni_lat: -20.1333,
            wni_lon: 116.467,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'WAL',
            wni_port_name: 'WALVIS BAY',
            wni_unlocode: 'NAWVB',
            wni_country: 'NA',
            wni_lat: -22.9351,
            wni_lon: 14.4855,
            wni_tz: 'Africa/Windhoek',
        },
        {
            option: 'WDF',
            wni_port_name: 'WOODFIBRE',
            wni_unlocode: 'CAWOO',
            wni_country: 'CA',
            wni_lat: 49.6518,
            wni_lon: -123.243,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'WED',
            wni_port_name: 'WEDEL',
            wni_unlocode: 'DEWED',
            wni_country: 'DE',
            wni_lat: 53.5629,
            wni_lon: 9.7239,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'WEH',
            wni_port_name: 'WEI HAI',
            wni_unlocode: 'CNWEI',
            wni_country: 'CN',
            wni_lat: 37.476,
            wni_lon: 122.2139,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'WEL',
            wni_port_name: 'WELLINGTON',
            wni_unlocode: 'NZWLG',
            wni_country: 'NZ',
            wni_lat: -41.2853,
            wni_lon: 174.792,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'WEN',
            wni_port_name: 'WENZHOU',
            wni_unlocode: 'CNWNZ',
            wni_country: 'CN',
            wni_lat: 28.0328,
            wni_lon: 120.65,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'WEW',
            wni_port_name: 'WEWAK',
            wni_unlocode: 'PGWWK',
            wni_country: 'PG',
            wni_lat: -3.56,
            wni_lon: 143.6507,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'WFN',
            wni_port_name: 'WADI FEIRAN',
            wni_unlocode: 'EGWAF',
            wni_country: 'EG',
            wni_lat: 28.7357,
            wni_lon: 33.2077,
            wni_tz: 'Africa/Cairo',
        },
        {
            option: 'WGAN',
            wni_port_name: 'WAGGAMAN',
            wni_unlocode: 'USWG2',
            wni_country: 'US',
            wni_lat: 29.9231,
            wni_lon: -90.1994,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'WHA',
            wni_port_name: 'WHANGAREI',
            wni_unlocode: 'NZWRE',
            wni_country: 'NZ',
            wni_lat: -35.7782,
            wni_lon: 174.3739,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'WHH',
            wni_port_name: 'WILHELMSHAVEN',
            wni_unlocode: 'DEWVN',
            wni_country: 'DE',
            wni_lat: 53.5421,
            wni_lon: 8.1941,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'WHT',
            wni_port_name: 'WHITEGATE',
            wni_unlocode: 'IEWHI',
            wni_country: 'IE',
            wni_lat: 51.7303,
            wni_lon: -8.232,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'WHY',
            wni_port_name: 'WHYALLA',
            wni_unlocode: 'AUWYA',
            wni_country: 'AU',
            wni_lat: -33.0258,
            wni_lon: 137.609,
            wni_tz: 'Australia/Adelaide',
        },
        {
            option: 'WID',
            wni_port_name: 'WIDURI TERMINAL',
            wni_unlocode: 'IDWRT',
            wni_country: 'ID',
            wni_lat: -4.6666,
            wni_lon: 106.65,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'WKK',
            wni_port_name: 'WAKKANAI',
            wni_unlocode: 'JPWKJ',
            wni_country: 'JP',
            wni_lat: 45.4203,
            wni_lon: 141.7067,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'WLG',
            wni_port_name: 'WILMINGTON',
            wni_unlocode: 'USILG',
            wni_country: 'US',
            wni_lat: 39.7438,
            wni_lon: -75.4861,
            wni_tz: 'America/New_York',
        },
        {
            option: 'WLH',
            wni_port_name: 'WALLHAMN',
            wni_unlocode: 'SEWAL',
            wni_country: 'SE',
            wni_lat: 58.0009,
            wni_lon: 11.7043,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'WLM',
            wni_port_name: 'WILMINGTON\t CA',
            wni_unlocode: 'USWTN',
            wni_country: 'US',
            wni_lat: 33.7075,
            wni_lon: -118.2188,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'WLN',
            wni_port_name: 'WILMINGTON\t NC',
            wni_unlocode: 'USILM',
            wni_country: 'US',
            wni_lat: 34.2043,
            wni_lon: -77.9592,
            wni_tz: 'America/New_York',
        },
        {
            option: 'WNLL',
            wni_port_name: 'WITHNELL BAY',
            wni_unlocode: 'AUWNB',
            wni_country: 'AU',
            wni_lat: -20.5779,
            wni_lon: 116.7618,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'WPA',
            wni_port_name: 'WEIPA',
            wni_unlocode: 'AUWEI',
            wni_country: 'AU',
            wni_lat: -12.673,
            wni_lon: 141.866,
            wni_tz: 'Australia/Brisbane',
        },
        {
            option: 'WPT',
            wni_port_name: 'WESTERNPORT',
            wni_unlocode: 'AUWEP',
            wni_country: 'AU',
            wni_lat: -38.3521,
            wni_lon: 145.2335,
            wni_tz: 'Australia/Melbourne',
        },
        {
            option: 'WSGDC',
            wni_port_name: 'WASHINGTON',
            wni_unlocode: 'USKJH',
            wni_country: 'US',
            wni_lat: 38.8781,
            wni_lon: -77.0272,
            wni_tz: 'America/New_York',
        },
        {
            option: 'WUHAN',
            wni_port_name: 'WUHAN',
            wni_unlocode: 'CNWUH',
            wni_country: 'CN',
            wni_lat: 30.5644,
            wni_lon: 114.2918,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'WYMTH',
            wni_port_name: 'WEYMOUTH HARBOR',
            wni_unlocode: 'GBWEY',
            wni_country: 'GB',
            wni_lat: 50.6105,
            wni_lon: -2.4288,
            wni_tz: 'Europe/London',
        },
        {
            option: 'WYN',
            wni_port_name: 'WYNDHAM',
            wni_unlocode: 'AUWYD',
            wni_country: 'AU',
            wni_lat: -15.4492,
            wni_lon: 128.0902,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'XIA',
            wni_port_name: 'XIAMEN',
            wni_unlocode: 'CNXMN',
            wni_country: 'CN',
            wni_lat: 24.4966,
            wni_lon: 118.0661,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'XIJ',
            wni_port_name: 'XIJIANG TERMINAL',
            wni_unlocode: 'CNXIJ',
            wni_country: 'CN',
            wni_lat: 21.3,
            wni_lon: 114.95,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'XIU',
            wni_port_name: 'XIUYU',
            wni_unlocode: 'CNXIU',
            wni_country: 'CN',
            wni_lat: 25.2083,
            wni_lon: 118.9767,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'XNSH',
            wni_port_name: 'XINSHA',
            wni_unlocode: 'CNXNA',
            wni_country: 'CN',
            wni_lat: 23.0162,
            wni_lon: 113.5198,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'YAB',
            wni_port_name: 'YABUCOA',
            wni_unlocode: 'PRYAB',
            wni_country: 'PR',
            wni_lat: 18.0421,
            wni_lon: -65.8236,
            wni_tz: 'America/Puerto_Rico',
        },
        {
            option: 'YAKU',
            wni_port_name: 'ANBOU\t YAKUSHIMA',
            wni_unlocode: 'JPIIN',
            wni_country: 'JP',
            wni_lat: 30.3168,
            wni_lon: 130.6784,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'YAM',
            wni_port_name: 'YAMPI SOUND',
            wni_unlocode: 'AUYAM',
            wni_country: 'AU',
            wni_lat: -16.2167,
            wni_lon: 123.55,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'YANG',
            wni_port_name: 'YANGON',
            wni_unlocode: 'MMRGN',
            wni_country: 'MM',
            wni_lat: 16.759,
            wni_lon: 96.1768,
            wni_tz: 'Asia/Rangoon',
        },
        {
            option: 'YATE',
            wni_port_name: 'YATSUSHIRO',
            wni_unlocode: 'JPYAT',
            wni_country: 'JP',
            wni_lat: 32.5077,
            wni_lon: 130.5168,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'YAU',
            wni_port_name: 'YANBU (YANBO)',
            wni_unlocode: 'SAYBI',
            wni_country: 'SA',
            wni_lat: 24.0574,
            wni_lon: 38.0488,
            wni_tz: 'Asia/Riyadh',
        },
        {
            option: 'YGSH',
            wni_port_name: 'YANGSHAN TERMINAL',
            wni_unlocode: 'CNMJS',
            wni_country: 'CN',
            wni_lat: 30.6225,
            wni_lon: 122.043,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'YGZ',
            wni_port_name: 'YANGZHOU',
            wni_unlocode: 'CNYZH',
            wni_country: 'CN',
            wni_lat: 32.2607,
            wni_lon: 119.4303,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'YHT',
            wni_port_name: 'YAWATA',
            wni_unlocode: 'JPYWA',
            wni_country: 'JP',
            wni_lat: 33.9069,
            wni_lon: 130.8217,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'YIN',
            wni_port_name: 'YING KOU',
            wni_unlocode: 'CNYIK',
            wni_country: 'CN',
            wni_lat: 40.6742,
            wni_lon: 122.147,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'YIZ',
            wni_port_name: 'YIZHENG',
            wni_unlocode: 'CNYIZ',
            wni_country: 'CN',
            wni_lat: 32.247,
            wni_lon: 119.1327,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'YKK',
            wni_port_name: 'YOKKAICHI',
            wni_unlocode: 'JPYKK',
            wni_country: 'JP',
            wni_lat: 34.9657,
            wni_lon: 136.6801,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'YLT',
            wni_port_name: 'YALTA',
            wni_unlocode: 'UAYAL',
            wni_country: 'UA',
            wni_lat: 44.4883,
            wni_lon: 34.2072,
            wni_tz: 'Europe/Simferopol',
        },
        {
            option: 'YNAI',
            wni_port_name: 'YANAI',
            wni_unlocode: 'JPYAN',
            wni_country: 'JP',
            wni_lat: 33.9408,
            wni_lon: 132.138,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'YNGN',
            wni_port_name: 'YUNGAN',
            wni_unlocode: 'TWYAN',
            wni_country: 'TW',
            wni_lat: 22.8177,
            wni_lon: 120.1803,
            wni_tz: 'Asia/Taipei',
        },
        {
            option: 'YNT',
            wni_port_name: 'YANTIAN',
            wni_unlocode: 'CNYIT',
            wni_country: 'CN',
            wni_lat: 22.56,
            wni_lon: 114.3,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'YOK',
            wni_port_name: 'YOKOHAMA',
            wni_unlocode: 'JPYOK',
            wni_country: 'JP',
            wni_lat: 35.437,
            wni_lon: 139.702,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'YOM',
            wni_port_name: 'YOMBO TERMINAL',
            wni_unlocode: 'CGYOM',
            wni_country: 'CG',
            wni_lat: -4.45,
            wni_lon: 11.1,
            wni_tz: 'Africa/Brazzaville',
        },
        {
            option: 'YOR',
            wni_port_name: 'YORKTOWN',
            wni_unlocode: 'USYKT',
            wni_country: 'US',
            wni_lat: 37.2333,
            wni_lon: -76.4375,
            wni_tz: 'America/New_York',
        },
        {
            option: 'YOS',
            wni_port_name: 'YOKOSUKA',
            wni_unlocode: 'JPNGR',
            wni_country: 'JP',
            wni_lat: 35.2863,
            wni_lon: 139.7012,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'YOU',
            wni_port_name: 'YEOSU',
            wni_unlocode: 'KRYOS',
            wni_country: 'KR',
            wni_lat: 34.7537,
            wni_lon: 127.7745,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'YPU',
            wni_port_name: 'YANGPU',
            wni_unlocode: 'CNYGP',
            wni_country: 'CN',
            wni_lat: 19.6999,
            wni_lon: 109.1642,
            wni_tz: 'Asia/Chongqing',
        },
        {
            option: 'YRM',
            wni_port_name: 'YARIMCA',
            wni_unlocode: 'TRYAR',
            wni_country: 'TR',
            wni_lat: 40.7551,
            wni_lon: 29.5348,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'YTA',
            wni_port_name: 'YANTAI',
            wni_unlocode: 'CNCFO',
            wni_country: 'CN',
            wni_lat: 37.5576,
            wni_lon: 121.4098,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'YUBA',
            wni_port_name: 'YUMURTALIK BAY',
            wni_unlocode: 'TRYUM',
            wni_country: 'TR',
            wni_lat: 36.46,
            wni_lon: 35.45,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'YUHUN',
            wni_port_name: 'YUHUAN',
            wni_unlocode: 'CNYUH',
            wni_country: 'CN',
            wni_lat: 28.1084,
            wni_lon: 121.1254,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'YUKAB',
            wni_port_name: "YUUM K'AK' NAAB",
            wni_unlocode: 'MXYKN',
            wni_country: 'MX',
            wni_lat: 19.6032,
            wni_lon: -92.294,
            wni_tz: 'America/Merida',
        },
        {
            option: 'YUR',
            wni_port_name: 'YURA',
            wni_unlocode: 'JPYRA',
            wni_country: 'JP',
            wni_lat: 33.9542,
            wni_lon: 135.0989,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'YUZ',
            wni_port_name: 'YUZHNYY',
            wni_unlocode: 'UAYUZ',
            wni_country: 'UA',
            wni_lat: 46.5911,
            wni_lon: 31.0191,
            wni_tz: 'Europe/Kiev',
        },
        {
            option: 'YYJ',
            wni_port_name: 'YANGJIANG',
            wni_unlocode: 'CNYGG',
            wni_country: 'CN',
            wni_lat: 21.6928,
            wni_lon: 111.8125,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'ZAF',
            wni_port_name: 'ZAFIRO TERMINAL',
            wni_unlocode: 'GQZAF',
            wni_country: 'GQ',
            wni_lat: 3.86,
            wni_lon: 8.13,
            wni_tz: 'Africa/Malabo',
        },
        {
            option: 'ZAM',
            wni_port_name: 'ZAMBOANGA',
            wni_unlocode: 'PHBLU',
            wni_country: 'PH',
            wni_lat: 6.8922,
            wni_lon: 122.0722,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'ZAN',
            wni_port_name: 'ZANZIBAR',
            wni_unlocode: 'TZMKO',
            wni_country: 'TZ',
            wni_lat: -6.1501,
            wni_lon: 39.1853,
            wni_tz: 'Africa/Dar_es_Salaam',
        },
        {
            option: 'ZAR',
            wni_port_name: 'ZARATE',
            wni_unlocode: 'ARZAE',
            wni_country: 'AR',
            wni_lat: -34.1464,
            wni_lon: -58.9746,
            wni_tz: 'America/Argentina/Buenos_Aires',
        },
        {
            option: 'ZAW',
            wni_port_name: 'ZAWIA TERMINAL',
            wni_unlocode: 'LYZAW',
            wni_country: 'LY',
            wni_lat: 32.8167,
            wni_lon: 12.6833,
            wni_tz: 'Africa/Tripoli',
        },
        {
            option: 'ZBNO',
            wni_port_name: 'ZARUBINO',
            wni_unlocode: 'RUZAR',
            wni_country: 'RU',
            wni_lat: 42.6,
            wni_lon: 131.1056,
            wni_tz: 'Asia/Vladivostok',
        },
        {
            option: 'ZEE',
            wni_port_name: 'ZEEBRUGGE',
            wni_unlocode: 'BEZEB',
            wni_country: 'BE',
            wni_lat: 51.3705,
            wni_lon: 3.1872,
            wni_tz: 'Europe/Brussels',
        },
        {
            option: 'ZHE',
            wni_port_name: 'ZHENHAI',
            wni_unlocode: 'CNZHI',
            wni_country: 'CN',
            wni_lat: 29.9484,
            wni_lon: 121.7015,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'ZHG',
            wni_port_name: 'ZHANGJIAGANG',
            wni_unlocode: 'CNZJG',
            wni_country: 'CN',
            wni_lat: 31.9306,
            wni_lon: 120.1807,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'ZHH',
            wni_port_name: 'ZHUHAI (GAOLAN DAO)',
            wni_unlocode: 'CNQSN',
            wni_country: 'CN',
            wni_lat: 21.9417,
            wni_lon: 113.19,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'ZHS',
            wni_port_name: 'ZHOUSHAN',
            wni_unlocode: 'CNMAJ',
            wni_country: 'CN',
            wni_lat: 29.9911,
            wni_lon: 122.1038,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'ZHZ',
            wni_port_name: 'ZHANGZHOU',
            wni_unlocode: 'CNZZU',
            wni_country: 'CN',
            wni_lat: 24.4213,
            wni_lon: 118.0545,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'ZIR',
            wni_port_name: 'ZIRKU ISLAND (ZURKU ISLAND)',
            wni_unlocode: 'AEZUR',
            wni_country: 'AE',
            wni_lat: 24.8685,
            wni_lon: 53.1012,
            wni_tz: 'Asia/Dubai',
        },
        {
            option: 'ZJG',
            wni_port_name: 'ZHANJIANG',
            wni_unlocode: 'CNZHA',
            wni_country: 'CN',
            wni_lat: 21.1707,
            wni_lon: 110.4181,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'ZJN',
            wni_port_name: 'ZHENJIANG',
            wni_unlocode: 'CNZHE',
            wni_country: 'CN',
            wni_lat: 32.2235,
            wni_lon: 119.4366,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'ZNGLD',
            wni_port_name: 'ZONGULDAK',
            wni_unlocode: 'TRZON',
            wni_country: 'TR',
            wni_lat: 41.4646,
            wni_lon: 31.7729,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'ZUE',
            wni_port_name: 'ZUEITINA',
            wni_unlocode: 'LYZUE',
            wni_country: 'LY',
            wni_lat: 30.85,
            wni_lon: 20,
            wni_tz: 'Africa/Tripoli',
        },
        {
            option: 'ACUB',
            wni_port_name: 'ACU',
            wni_unlocode: 'BRACX',
            wni_country: 'BR',
            wni_lat: -21.84,
            wni_lon: -40.99,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'ADRS',
            wni_port_name: 'ANDRES',
            wni_unlocode: 'DOBCC',
            wni_country: 'DO',
            wni_lat: 18.39,
            wni_lon: -69.61,
            wni_tz: 'America/Santo_Domingo',
        },
        {
            option: 'AMN',
            wni_port_name: 'AMBON',
            wni_unlocode: 'IDAMQ',
            wni_country: 'ID',
            wni_lat: -3.68,
            wni_lon: 128.17,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'AMRN',
            wni_port_name: 'AMRUN',
            wni_unlocode: 'AUAMR',
            wni_country: 'AU',
            wni_lat: -12.93,
            wni_lon: 141.62,
            wni_tz: 'Australia/Brisbane',
        },
        {
            option: 'AOKAT',
            wni_port_name: 'AOKATA',
            wni_unlocode: 'JPAOK',
            wni_country: 'JP',
            wni_lat: 32.98,
            wni_lon: 129.05,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'ARBT',
            wni_port_name: 'ARUBA TRANSHIPMENT',
            wni_unlocode: 'AWORJ',
            wni_country: 'AW',
            wni_lat: 12.5,
            wni_lon: -70.12,
            wni_tz: 'America/Aruba',
        },
        {
            option: 'ARK',
            wni_port_name: 'ARKHANGELSK',
            wni_unlocode: 'RUARH',
            wni_country: 'RU',
            wni_lat: 64.53,
            wni_lon: 40.52,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'ARKE',
            wni_port_name: 'ARIAKE',
            wni_unlocode: 'JPARI',
            wni_country: 'JP',
            wni_lat: 32.9,
            wni_lon: 130.45,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'ASASM',
            wni_port_name: 'ASAM ASAM',
            wni_unlocode: 'IDIAM',
            wni_country: 'ID',
            wni_lat: -4.13,
            wni_lon: 115.2,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'ASBTN',
            wni_port_name: 'ASHBURTON',
            wni_unlocode: 'AUASB',
            wni_country: 'AU',
            wni_lat: -21.68,
            wni_lon: 115.01,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'ASPR',
            wni_port_name: 'ASPROPYRGOS',
            wni_unlocode: 'GRASS',
            wni_country: 'GR',
            wni_lat: 38.03,
            wni_lon: 23.56,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'AZU',
            wni_port_name: 'PUERTO VIEJO DE AZUA',
            wni_unlocode: 'DOPVA',
            wni_country: 'DO',
            wni_lat: 18.33,
            wni_lon: -70.83,
            wni_tz: 'America/Santo_Domingo',
        },
        {
            option: 'BANAS',
            wni_port_name: 'BANIAS',
            wni_unlocode: 'PGGUR',
            wni_country: 'PG',
            wni_lat: -9.78,
            wni_lon: 149.86,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'BASH',
            wni_port_name: 'BASHAYER',
            wni_unlocode: 'SDMBH',
            wni_country: 'SD',
            wni_lat: 19.4,
            wni_lon: 37.33,
            wni_tz: 'Africa/Khartoum',
        },
        {
            option: 'BAUAN',
            wni_port_name: 'BAUAN',
            wni_unlocode: 'PHBTG',
            wni_country: 'PH',
            wni_lat: 13.77,
            wni_lon: 121,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'BCDR',
            wni_port_name: 'BARCADERA',
            wni_unlocode: 'AWBAR',
            wni_country: 'AW',
            wni_lat: 12.48,
            wni_lon: -69.99,
            wni_tz: 'America/Aruba',
        },
        {
            option: 'BCE',
            wni_port_name: 'BIG CREEK',
            wni_unlocode: 'BZBGK',
            wni_country: 'BZ',
            wni_lat: 16.51,
            wni_lon: -88.4,
            wni_tz: 'America/Belize',
        },
        {
            option: 'BCHSS',
            wni_port_name: 'BELLE CHASSE',
            wni_unlocode: 'USBCS',
            wni_country: 'US',
            wni_lat: 29.85,
            wni_lon: -89.98,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'BERAU',
            wni_port_name: 'MUARA BERAU',
            wni_unlocode: 'IDSRI',
            wni_country: 'ID',
            wni_lat: -0.3,
            wni_lon: 117.6,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'BHMO',
            wni_port_name: 'BAHAMAS OFFSHORE STS',
            wni_unlocode: 'BSFPO',
            wni_country: 'BS',
            wni_lat: 26.25,
            wni_lon: -79.08,
            wni_tz: 'America/Nassau',
        },
        {
            option: 'BING',
            wni_port_name: 'BING BONG',
            wni_unlocode: 'AUBBG',
            wni_country: 'AU',
            wni_lat: -15.63,
            wni_lon: 136.39,
            wni_tz: 'Australia/Darwin',
        },
        {
            option: 'BINM',
            wni_port_name: 'TANJUNG BIN',
            wni_unlocode: 'MYTPP',
            wni_country: 'MY',
            wni_lat: 1.33,
            wni_lon: 103.55,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'BDM',
            wni_port_name: 'BANDIRMA',
            wni_unlocode: 'TRBDM',
            wni_country: 'TR',
            wni_lat: 40.35,
            wni_lon: 27.97,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'BNN',
            wni_port_name: 'BANANA',
            wni_unlocode: 'CDBNW',
            wni_country: 'CD',
            wni_lat: -6.02,
            wni_lon: 12.4,
            wni_tz: 'Africa/Kinshasa',
        },
        {
            option: 'BNO',
            wni_port_name: 'BENOA-UJUNG',
            wni_unlocode: 'IDBOA',
            wni_country: 'ID',
            wni_lat: -8.75,
            wni_lon: 115.22,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'BPR',
            wni_port_name: 'BAIE DE PRONY',
            wni_unlocode: 'NCDUS',
            wni_country: 'NC',
            wni_lat: -22.21,
            wni_lon: 166.53,
            wni_tz: 'Pacific/Noumea',
        },
        {
            option: 'BQT',
            wni_port_name: 'BARQUITO',
            wni_unlocode: 'CLBAR',
            wni_country: 'CL',
            wni_lat: -26.36,
            wni_lon: -70.65,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'BRASS',
            wni_port_name: 'BRASS OFF-SHORE TERMINAL',
            wni_unlocode: 'NGBRA',
            wni_country: 'NG',
            wni_lat: 4.07,
            wni_lon: 6.28,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'BRISA',
            wni_port_name: 'PUERTO BRISA',
            wni_unlocode: 'COPPR',
            wni_country: 'CO',
            wni_lat: 11.26,
            wni_lon: -73.38,
            wni_tz: 'America/Bogota',
        },
        {
            option: 'BROG',
            wni_port_name: 'BERONG',
            wni_unlocode: 'PHPPS',
            wni_country: 'PH',
            wni_lat: 9.47,
            wni_lon: 118.17,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'BSFT',
            wni_port_name: 'BOTAS SAROS FSRU TERMINAL',
            wni_unlocode: 'TRCKZ',
            wni_country: 'TR',
            wni_lat: 40.64,
            wni_lon: 26.64,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'BSH',
            wni_port_name: 'BUSHEHR',
            wni_unlocode: 'IRBUZ',
            wni_country: 'IR',
            wni_lat: 29,
            wni_lon: 50.75,
            wni_tz: 'Asia/Tehran',
        },
        {
            option: 'BSMK',
            wni_port_name: 'BASAMUK',
            wni_unlocode: 'PGMAG',
            wni_country: 'PG',
            wni_lat: -5.54,
            wni_lon: 146.14,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'BSNKV',
            wni_port_name: 'BOSHNYAKOVO',
            wni_unlocode: 'RUBOS',
            wni_country: 'RU',
            wni_lat: 49.64,
            wni_lon: 142.14,
            wni_tz: 'Asia/Sakhalin',
        },
        {
            option: 'BSPSN',
            wni_port_name: 'BOSPHORAS NORTH ENTRANCE ANCHORAGE',
            wni_unlocode: 'TRIST',
            wni_country: 'TR',
            wni_lat: 41.27,
            wni_lon: 29.07,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'BSU',
            wni_port_name: 'BISSAU',
            wni_unlocode: 'GWOXB',
            wni_country: 'GW',
            wni_lat: 11.87,
            wni_lon: -15.63,
            wni_tz: 'Africa/Bissau',
        },
        {
            option: 'BURNI',
            wni_port_name: 'BURNS HARBOR',
            wni_unlocode: 'USBNB',
            wni_country: 'US',
            wni_lat: 41.65,
            wni_lon: -87.14,
            wni_tz: 'America/Indiana/Indianapolis',
        },
        {
            option: 'CAYO',
            wni_port_name: 'PUERTO DE CAYO',
            wni_unlocode: 'ECMEC',
            wni_country: 'EC',
            wni_lat: -1.36,
            wni_lon: -80.75,
            wni_tz: 'America/Guayaquil',
        },
        {
            option: 'CDSAC',
            wni_port_name: 'CUL DE SAC',
            wni_unlocode: 'LCCDS',
            wni_country: 'LC',
            wni_lat: 14,
            wni_lon: -61.03,
            wni_tz: 'America/St_Lucia',
        },
        {
            option: 'CFD2',
            wni_port_name: 'CAOFEIDIAN',
            wni_unlocode: 'CNCFD',
            wni_country: 'CN',
            wni_lat: 38.91,
            wni_lon: 118.51,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'CHLAI',
            wni_port_name: 'CHU LAI',
            wni_unlocode: 'VNDAD',
            wni_country: 'VN',
            wni_lat: 15.48,
            wni_lon: 108.63,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'CHNJK',
            wni_port_name: 'CHANG JIANG KOU',
            wni_unlocode: 'CNTAC',
            wni_country: 'CN',
            wni_lat: 31.07,
            wni_lon: 122.42,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'CHOFU',
            wni_port_name: 'CHOFU',
            wni_unlocode: 'JPCHF',
            wni_country: 'JP',
            wni_lat: 34.01,
            wni_lon: 131.01,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'CHOGM',
            wni_port_name: 'CHONGMING',
            wni_unlocode: 'CNCMG',
            wni_country: 'CN',
            wni_lat: 31.62,
            wni_lon: 121.39,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'CHU',
            wni_port_name: 'CHURCHILL',
            wni_unlocode: 'CACHV',
            wni_country: 'CA',
            wni_lat: 58.78,
            wni_lon: -94.18,
            wni_tz: 'America/Winnipeg',
        },
        {
            option: 'CHW',
            wni_port_name: 'CHW0102 WIND FARM',
            wni_unlocode: 'TWMLI',
            wni_country: 'TW',
            wni_lat: 24.16,
            wni_lon: 119.9,
            wni_tz: 'Asia/Taipei',
        },
        {
            option: 'CIMY',
            wni_port_name: 'CILAMAYA',
            wni_unlocode: 'IDARJ',
            wni_country: 'ID',
            wni_lat: -6.14,
            wni_lon: 107.48,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'CKSB',
            wni_port_name: 'CHIBA KEIYO SEA BERTH',
            wni_unlocode: 'JPCHB',
            wni_country: 'JP',
            wni_lat: 35.51,
            wni_lon: 139.94,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'CLOVT',
            wni_port_name: 'CLOV TERMINAL',
            wni_unlocode: 'AOCLV',
            wni_country: 'AO',
            wni_lat: -7.46,
            wni_lon: 11.57,
            wni_tz: 'Africa/Luanda',
        },
        {
            option: 'CLS',
            wni_port_name: 'CALAIS',
            wni_unlocode: 'FRCQF',
            wni_country: 'FR',
            wni_lat: 50.97,
            wni_lon: 1.85,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'CNA',
            wni_port_name: 'CHALNA',
            wni_unlocode: 'BDCHL',
            wni_country: 'BD',
            wni_lat: 22.58,
            wni_lon: 89.53,
            wni_tz: 'Asia/Dhaka',
        },
        {
            option: 'CNF',
            wni_port_name: 'CIENFUEGOS',
            wni_unlocode: 'CUCFG',
            wni_country: 'CU',
            wni_lat: 22.15,
            wni_lon: -80.45,
            wni_tz: 'America/Havana',
        },
        {
            option: 'CNNS',
            wni_port_name: 'CANNES',
            wni_unlocode: 'FRCEQ',
            wni_country: 'FR',
            wni_lat: 43.55,
            wni_lon: 7.02,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'COR2',
            wni_port_name: 'CORPUS CHRISTI LIGHTERING AREA',
            wni_unlocode: 'USDTP',
            wni_country: 'US',
            wni_lat: 27.77,
            wni_lon: -96.42,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'CPCH',
            wni_port_name: 'CAPE CHARLES',
            wni_unlocode: 'USCCJ',
            wni_country: 'US',
            wni_lat: 37.27,
            wni_lon: -76.02,
            wni_tz: 'America/New_York',
        },
        {
            option: 'CSTZL',
            wni_port_name: 'COSTA AZUL',
            wni_unlocode: 'MXESE',
            wni_country: 'MX',
            wni_lat: 31.98,
            wni_lon: -116.85,
            wni_tz: 'America/Tijuana',
        },
        {
            option: 'CTHAI',
            wni_port_name: 'CAT HAI OFF',
            wni_unlocode: 'VNHPH',
            wni_country: 'VN',
            wni_lat: 20.57,
            wni_lon: 106.98,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'CUALO',
            wni_port_name: 'CUA LO',
            wni_unlocode: 'VNCUA',
            wni_country: 'VN',
            wni_lat: 18.5,
            wni_lon: 105.42,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'CUX',
            wni_port_name: 'CUXHAVEN',
            wni_unlocode: 'DECUX',
            wni_country: 'DE',
            wni_lat: 53.87,
            wni_lon: 8.72,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'CXD',
            wni_port_name: 'CHANG XING DAO',
            wni_unlocode: 'CNPAJ',
            wni_country: 'CN',
            wni_lat: 39.56,
            wni_lon: 121.23,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'PANJIN',
            wni_port_name: 'PANJIN',
            wni_unlocode: 'CNPAJ',
            wni_country: 'CN',
            wni_lat: 40.41,
            wni_lon: 121.59,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'DAF',
            wni_port_name: 'DAFENG',
            wni_unlocode: 'CNDFG',
            wni_country: 'CN',
            wni_lat: 33.21,
            wni_lon: 120.83,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'DAH',
            wni_port_name: 'DAHANU',
            wni_unlocode: 'INDHU',
            wni_country: 'IN',
            wni_lat: 19.99,
            wni_lon: 72.7,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'DGU',
            wni_port_name: 'DONGGUAN',
            wni_unlocode: 'CNDGG',
            wni_country: 'CN',
            wni_lat: 23.05,
            wni_lon: 113.74,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'DHKL',
            wni_port_name: 'DHEKELIA',
            wni_unlocode: 'CYDHK',
            wni_country: 'CY',
            wni_lat: 34.97,
            wni_lon: 33.72,
            wni_tz: 'Asia/Nicosia',
        },
        {
            option: 'DILI',
            wni_port_name: 'DILI',
            wni_unlocode: 'TLDIL',
            wni_country: 'TL',
            wni_lat: -8.53,
            wni_lon: 125.58,
            wni_tz: 'Asia/Dili',
        },
        {
            option: 'DONI',
            wni_port_name: 'DONG NAI',
            wni_unlocode: 'VNDNA',
            wni_country: 'VN',
            wni_lat: 10.9,
            wni_lon: 106.84,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'DOT',
            wni_port_name: 'DORTYOL TERMINAL',
            wni_unlocode: 'TRDYL',
            wni_country: 'TR',
            wni_lat: 36.85,
            wni_lon: 36.13,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'DPLG',
            wni_port_name: 'DIPOLOG',
            wni_unlocode: 'PHDPL',
            wni_country: 'PH',
            wni_lat: 8.58,
            wni_lon: 123.33,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'DRS',
            wni_port_name: 'DURRES',
            wni_unlocode: 'ALDRZ',
            wni_country: 'AL',
            wni_lat: 41.32,
            wni_lon: 19.45,
            wni_tz: 'Europe/Tirane',
        },
        {
            option: 'DRTMT',
            wni_port_name: 'DARTMOUTH HARBOR',
            wni_unlocode: 'GBDTM',
            wni_country: 'GB',
            wni_lat: 50.35,
            wni_lon: -3.58,
            wni_tz: 'Europe/London',
        },
        {
            option: 'DUPON',
            wni_port_name: 'DUPON BAY',
            wni_unlocode: 'PHISL',
            wni_country: 'PH',
            wni_lat: 10.9,
            wni_lon: 124.42,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'DUQM',
            wni_port_name: 'DUQM',
            wni_unlocode: 'OMDQM',
            wni_country: 'OM',
            wni_lat: 19.67,
            wni_lon: 57.72,
            wni_tz: 'Asia/Muscat',
        },
        {
            option: 'DUSN',
            wni_port_name: 'DUSHAN',
            wni_unlocode: 'CNJNS',
            wni_country: 'CN',
            wni_lat: 30.67,
            wni_lon: 121.27,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'JNSAN',
            wni_port_name: 'JINSHAN',
            wni_unlocode: 'CNJNS',
            wni_country: 'CN',
            wni_lat: 30.69,
            wni_lon: 121.29,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'SHLNG',
            wni_port_name: 'SHULANGHU',
            wni_unlocode: 'CNJNS',
            wni_country: 'CN',
            wni_lat: 30.42,
            wni_lon: 122.45,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'DWANC',
            wni_port_name: 'DW ANCHORAGE',
            wni_unlocode: 'DEWVN',
            wni_country: 'DE',
            wni_lat: 54.07,
            wni_lon: 7.46,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'DYG',
            wni_port_name: 'DONGYING',
            wni_unlocode: 'CNDGY',
            wni_country: 'CN',
            wni_lat: 38.09,
            wni_lon: 118.98,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'EAP',
            wni_port_name: 'EASTPORT',
            wni_unlocode: 'USEPM',
            wni_country: 'US',
            wni_lat: 44.9,
            wni_lon: -66.98,
            wni_tz: 'America/New_York',
        },
        {
            option: 'EEM',
            wni_port_name: 'EEMSHAVEN',
            wni_unlocode: 'NLEEM',
            wni_country: 'NL',
            wni_lat: 53.45,
            wni_lon: 6.83,
            wni_tz: 'Europe/Amsterdam',
        },
        {
            option: 'EGS',
            wni_port_name: 'EGERSUND',
            wni_unlocode: 'NOEGD',
            wni_country: 'NO',
            wni_lat: 58.45,
            wni_lon: 6,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'EREN',
            wni_port_name: 'EREN',
            wni_unlocode: 'TRZON',
            wni_country: 'TR',
            wni_lat: 41.52,
            wni_lon: 31.9,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'ESG2',
            wni_port_name: 'EL SEGUNDO OFF SHORE OIL TERMINAL',
            wni_unlocode: 'USELS',
            wni_country: 'US',
            wni_lat: 33.87,
            wni_lon: -118.5,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'EUR',
            wni_port_name: 'EUROPOORT',
            wni_unlocode: 'NLEUR',
            wni_country: 'NL',
            wni_lat: 51.95,
            wni_lon: 4.13,
            wni_tz: 'Europe/Amsterdam',
        },
        {
            option: 'FDS',
            wni_port_name: 'FREDRIKSTAD',
            wni_unlocode: 'NOFRK',
            wni_country: 'NO',
            wni_lat: 59.2,
            wni_lon: 10.95,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'FENE',
            wni_port_name: 'FENE',
            wni_unlocode: 'ESMGR',
            wni_country: 'ES',
            wni_lat: 43.47,
            wni_lon: -8.2,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'FNUKI',
            wni_port_name: 'FUNAUKI',
            wni_unlocode: 'JPISG',
            wni_country: 'JP',
            wni_lat: 24.34,
            wni_lon: 123.73,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'FUQ',
            wni_port_name: 'FUQING',
            wni_unlocode: 'CNFQG',
            wni_country: 'CN',
            wni_lat: 25.51,
            wni_lon: 119.58,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'FUSA',
            wni_port_name: 'FUSA',
            wni_unlocode: 'NOFUS',
            wni_country: 'NO',
            wni_lat: 60.2,
            wni_lon: 5.6,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'GAL_LT',
            wni_port_name: 'GALVESTON LIGHTERING AREA',
            wni_unlocode: 'USFPO',
            wni_country: 'US',
            wni_lat: 28.5,
            wni_lon: -94.5,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'GBREL',
            wni_port_name: 'ST. GABRIEL',
            wni_unlocode: 'USPLQ',
            wni_country: 'US',
            wni_lat: 30.27,
            wni_lon: -91.12,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'GCTA',
            wni_port_name: 'CAN THO',
            wni_unlocode: 'VNVCA',
            wni_country: 'VN',
            wni_lat: 10.03,
            wni_lon: 105.78,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'GDAN',
            wni_port_name: 'GYDAN',
            wni_unlocode: 'RUSAB',
            wni_country: 'RU',
            wni_lat: 71.01,
            wni_lon: 73.79,
            wni_tz: 'Asia/Yekaterinburg',
        },
        {
            option: 'GHZ',
            wni_port_name: 'GARCIA HERNANDEZ',
            wni_unlocode: 'PHGHE',
            wni_country: 'PH',
            wni_lat: 9.62,
            wni_lon: 124.29,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'GLDEN',
            wni_port_name: 'GOLDEN PASS',
            wni_unlocode: 'USPOA',
            wni_country: 'US',
            wni_lat: 29.77,
            wni_lon: -93.92,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'GLNA',
            wni_port_name: 'GALENA PARK',
            wni_unlocode: 'USGPK',
            wni_country: 'US',
            wni_lat: 29.72,
            wni_lon: -95.22,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'GLNG',
            wni_port_name: 'GALANG LAY-UP',
            wni_unlocode: 'IDKAB',
            wni_country: 'ID',
            wni_lat: 0.7,
            wni_lon: 104.18,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'GMBA',
            wni_port_name: 'GAMBOA',
            wni_unlocode: 'PAGBA',
            wni_country: 'PA',
            wni_lat: 9.11,
            wni_lon: -79.7,
            wni_tz: 'America/Panama',
        },
        {
            option: 'GMS',
            wni_port_name: 'GRIMSBY',
            wni_unlocode: 'GBGSY',
            wni_country: 'GB',
            wni_lat: 53.57,
            wni_lon: -0.07,
            wni_tz: 'Europe/London',
        },
        {
            option: 'GNBRA',
            wni_port_name: 'GUANABARA BAY',
            wni_unlocode: 'BRRIO',
            wni_country: 'BR',
            wni_lat: -22.82,
            wni_lon: -43.15,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'GNU',
            wni_port_name: 'GANYU',
            wni_unlocode: 'CNRZH',
            wni_country: 'CN',
            wni_lat: 35.03,
            wni_lon: 119.29,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'GOP',
            wni_port_name: 'GOPALPUR',
            wni_unlocode: 'INGPR',
            wni_country: 'IN',
            wni_lat: 19.3,
            wni_lon: 84.96,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'GOURA',
            wni_port_name: 'GOUNOURA',
            wni_unlocode: 'JPKAR',
            wni_country: 'JP',
            wni_lat: 33.75,
            wni_lon: 129.68,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'GUIS',
            wni_port_name: 'GUISHAN',
            wni_unlocode: 'CNHUA',
            wni_country: 'CN',
            wni_lat: 22.15,
            wni_lon: 113.82,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'GULEI',
            wni_port_name: 'GULEI',
            wni_unlocode: 'CNDSN',
            wni_country: 'CN',
            wni_lat: 23.69,
            wni_lon: 117.59,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'HEL',
            wni_port_name: 'HELSINGBORG',
            wni_unlocode: 'SEHEL',
            wni_country: 'SE',
            wni_lat: 56.05,
            wni_lon: 12.7,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'HIRO',
            wni_port_name: 'HIRO',
            wni_unlocode: 'JPHRO',
            wni_country: 'JP',
            wni_lat: 34.21,
            wni_lon: 132.62,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HK',
            wni_port_name: 'HONG KONG STS OPERATION AREA',
            wni_unlocode: 'HKHKG',
            wni_country: 'CN',
            wni_lat: 21.4,
            wni_lon: 114.4,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'LNGHK',
            wni_port_name: 'HONG KONG OFFSHORE LNG TERMINAL',
            wni_unlocode: 'HKHKG',
            wni_country: 'CN',
            wni_lat: 22.16,
            wni_lon: 113.96,
            wni_tz: 'Asia/Hong_Kong',
        },
        {
            option: 'HLDAO',
            wni_port_name: 'HULUDAO',
            wni_unlocode: 'CNHUD',
            wni_country: 'CN',
            wni_lat: 40.7,
            wni_lon: 121,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'HLM',
            wni_port_name: 'HALMSTAD',
            wni_unlocode: 'SEHAD',
            wni_country: 'SE',
            wni_lat: 56.67,
            wni_lon: 12.87,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'HMAD',
            wni_port_name: 'HAMAD',
            wni_unlocode: 'QAHMD',
            wni_country: 'QA',
            wni_lat: 25.02,
            wni_lon: 51.6,
            wni_tz: 'Asia/Qatar',
        },
        {
            option: 'HML',
            wni_port_name: 'HAMILTON',
            wni_unlocode: 'CAHAM',
            wni_country: 'CA',
            wni_lat: 43.25,
            wni_lon: -79.85,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'HNSN',
            wni_port_name: 'HANSHIN',
            wni_unlocode: 'JPOSA',
            wni_country: 'JP',
            wni_lat: 34.58,
            wni_lon: 135.26,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'OSB',
            wni_port_name: 'TOMOGASHIMA',
            wni_unlocode: 'JPOSA',
            wni_country: 'JP',
            wni_lat: 34.17,
            wni_lon: 135,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HOSN',
            wni_port_name: 'HOSAN',
            wni_unlocode: 'KRHAS',
            wni_country: 'KR',
            wni_lat: 37.18,
            wni_lon: 129.35,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'ICO',
            wni_port_name: 'ICORACI',
            wni_unlocode: 'BRBEL',
            wni_country: 'BR',
            wni_lat: -1.3,
            wni_lon: -48.5,
            wni_tz: 'America/Belem',
        },
        {
            option: 'IGO',
            wni_port_name: 'IGOUMENITSA',
            wni_unlocode: 'GRIGO',
            wni_country: 'GR',
            wni_lat: 39.49,
            wni_lon: 20.25,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'IHTS',
            wni_port_name: 'ICHTHYS',
            wni_unlocode: 'AUDRW',
            wni_country: 'AU',
            wni_lat: -12.51,
            wni_lon: 130.91,
            wni_tz: 'Australia/Darwin',
        },
        {
            option: 'IMANG',
            wni_port_name: 'IMA TERMINAL',
            wni_unlocode: 'NGBON',
            wni_country: 'NG',
            wni_lat: 4.22,
            wni_lon: 7.38,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'YOH',
            wni_port_name: 'YOHO TARMINAL',
            wni_unlocode: 'NGBON',
            wni_country: 'NG',
            wni_lat: 4.42,
            wni_lon: 7.13,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'IRA2',
            wni_port_name: 'IRAGO',
            wni_unlocode: 'JPIRK',
            wni_country: 'JP',
            wni_lat: 34.6,
            wni_lon: 137.01,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'IRVIN',
            wni_port_name: 'IRVINE BAY',
            wni_unlocode: 'GBIRV',
            wni_country: 'GB',
            wni_lat: 55.6,
            wni_lon: -4.7,
            wni_tz: 'Europe/London',
        },
        {
            option: 'IYO',
            wni_port_name: 'IYO NADA',
            wni_unlocode: 'JPNGH',
            wni_country: 'JP',
            wni_lat: 33.6,
            wni_lon: 132.25,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'IZSNO',
            wni_port_name: 'IZUMISANO',
            wni_unlocode: 'JPIZS',
            wni_country: 'JP',
            wni_lat: 34.42,
            wni_lon: 135.31,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SNSHU',
            wni_port_name: 'SENSHU',
            wni_unlocode: 'JPIZS',
            wni_country: 'JP',
            wni_lat: 34.45,
            wni_lon: 135.27,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'JASN',
            wni_port_name: 'JASAAN',
            wni_unlocode: 'PHJAS',
            wni_country: 'PH',
            wni_lat: 8.64,
            wni_lon: 124.76,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'JBEE',
            wni_port_name: 'JUBILEE',
            wni_unlocode: 'GHJUB',
            wni_country: 'GH',
            wni_lat: 4.63,
            wni_lon: -2.82,
            wni_tz: 'Africa/Accra',
        },
        {
            option: 'JGNG',
            wni_port_name: 'JUN GONG LU',
            wni_unlocode: 'CNSGH',
            wni_country: 'CN',
            wni_lat: 31.35,
            wni_lon: 121.51,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'SGA',
            wni_port_name: 'SHANGHAI - NANGANG',
            wni_unlocode: 'CNSGH',
            wni_country: 'CN',
            wni_lat: 30.84,
            wni_lon: 121.84,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'JIBI',
            wni_port_name: 'JIANGSU BINHAI',
            wni_unlocode: 'CNBHX',
            wni_country: 'CN',
            wni_lat: 34.3,
            wni_lon: 120.27,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'JNGSU',
            wni_port_name: 'JINGJIANG',
            wni_unlocode: 'CNJIJ',
            wni_country: 'CN',
            wni_lat: 32.01,
            wni_lon: 120.26,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'JNGU',
            wni_port_name: 'JIANGSU',
            wni_unlocode: 'CNNTG',
            wni_country: 'CN',
            wni_lat: 32.55,
            wni_lon: 121.43,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'JURG',
            wni_port_name: 'JURONG',
            wni_unlocode: 'SGJUR',
            wni_country: 'SG',
            wni_lat: 1.3,
            wni_lon: 103.72,
            wni_tz: 'Asia/Singapore',
        },
        {
            option: 'KAMSF',
            wni_port_name: 'KAOMBO SUL FPSO',
            wni_unlocode: 'AOKAO',
            wni_country: 'AO',
            wni_lat: -7.36,
            wni_lon: 11.38,
            wni_tz: 'Africa/Luanda',
        },
        {
            option: 'KANO',
            wni_port_name: 'KAOMBO NORTE',
            wni_unlocode: 'AOKAO',
            wni_country: 'AO',
            wni_lat: -7.23,
            wni_lon: 11.28,
            wni_tz: 'Africa/Luanda',
        },
        {
            option: 'KHKNG',
            wni_port_name: 'KOH KONG',
            wni_unlocode: 'KHKOS',
            wni_country: 'KH',
            wni_lat: 11.61,
            wni_lon: 102.98,
            wni_tz: 'Asia/Phnom_Penh',
        },
        {
            option: 'KIKEH',
            wni_port_name: 'KIKEH OIL FIELD',
            wni_unlocode: 'MYLUT',
            wni_country: 'MY',
            wni_lat: 6.12,
            wni_lon: 112.84,
            wni_tz: 'Asia/Kuching',
        },
        {
            option: 'KLD',
            wni_port_name: 'KALUNDBORG',
            wni_unlocode: 'DKKAL',
            wni_country: 'DK',
            wni_lat: 55.68,
            wni_lon: 11.1,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'KLT',
            wni_port_name: 'KUALA TERENGGANU',
            wni_unlocode: 'MYTGG',
            wni_country: 'MY',
            wni_lat: 5.35,
            wni_lon: 103.13,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'KLYMNS',
            wni_port_name: 'KALYMNOS',
            wni_unlocode: 'GRKMI',
            wni_country: 'GR',
            wni_lat: 36.94,
            wni_lon: 27,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'KMI',
            wni_port_name: 'KAMIISO',
            wni_unlocode: 'JPHKD',
            wni_country: 'JP',
            wni_lat: 41.81,
            wni_lon: 140.66,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KOJI',
            wni_port_name: 'KEOJE',
            wni_unlocode: 'KRJGE',
            wni_country: 'KR',
            wni_lat: 34.93,
            wni_lon: 128.58,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'KRSAK',
            wni_port_name: 'KUROSAKI',
            wni_unlocode: 'JPKSK',
            wni_country: 'JP',
            wni_lat: 33.88,
            wni_lon: 130.78,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KRT',
            wni_port_name: 'KRISTIANSAND',
            wni_unlocode: 'NOKRS',
            wni_country: 'NO',
            wni_lat: 58.13,
            wni_lon: 8,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'KTSGT',
            wni_port_name: 'KUTSUGATA',
            wni_unlocode: 'JPWKJ',
            wni_country: 'JP',
            wni_lat: 45.2,
            wni_lon: 141.13,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KTTPL',
            wni_port_name: 'KATTUPALLI',
            wni_unlocode: 'INKAT',
            wni_country: 'IN',
            wni_lat: 13.28,
            wni_lon: 80.36,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'KTZB',
            wni_port_name: 'KOTZEBUE',
            wni_unlocode: 'USOTZ',
            wni_country: 'US',
            wni_lat: 66.92,
            wni_lon: -162.58,
            wni_tz: 'America/Nome',
        },
        {
            option: 'KUMILA',
            wni_port_name: 'KUMAI LIGHTERING AREA',
            wni_unlocode: 'IDKUM',
            wni_country: 'ID',
            wni_lat: -3.2,
            wni_lon: 111.6,
            wni_tz: 'Asia/Pontianak',
        },
        {
            option: 'KZMNO',
            wni_port_name: 'KOZMINO',
            wni_unlocode: 'RUKZM',
            wni_country: 'RU',
            wni_lat: 42.72,
            wni_lon: 133.02,
            wni_tz: 'Asia/Vladivostok',
        },
        {
            option: 'LIMAY',
            wni_port_name: 'LIMAY',
            wni_unlocode: 'PHLIM',
            wni_country: 'PH',
            wni_lat: 14.5,
            wni_lon: 120.63,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'LNGYAN',
            wni_port_name: 'LONGYAN',
            wni_unlocode: 'CNLGY',
            wni_country: 'CN',
            wni_lat: 37.42,
            wni_lon: 122.64,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'LRV',
            wni_port_name: 'LARVIK',
            wni_unlocode: 'NOLAR',
            wni_country: 'NO',
            wni_lat: 59.07,
            wni_lon: 10.03,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'LTHNH',
            wni_port_name: 'LONG THANH',
            wni_unlocode: 'VNLTH',
            wni_country: 'VN',
            wni_lat: 10.65,
            wni_lon: 107.01,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'LUD',
            wni_port_name: 'LUDERITZ',
            wni_unlocode: 'NALUD',
            wni_country: 'NA',
            wni_lat: -26.65,
            wni_lon: 15.15,
            wni_tz: 'Africa/Windhoek',
        },
        {
            option: 'LUGNG',
            wni_port_name: 'LUBUK GAUNG',
            wni_unlocode: 'IDDUM',
            wni_country: 'ID',
            wni_lat: 1.75,
            wni_lon: 101.37,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'LUY',
            wni_port_name: 'LUOYU',
            wni_unlocode: 'CNJLY',
            wni_country: 'CN',
            wni_lat: 25.18,
            wni_lon: 119.01,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'LWK',
            wni_port_name: 'LUWUK',
            wni_unlocode: 'IDLUW',
            wni_country: 'ID',
            wni_lat: -0.95,
            wni_lon: 122.8,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'POHID',
            wni_port_name: 'POH',
            wni_unlocode: 'IDLUW',
            wni_country: 'ID',
            wni_lat: -0.76,
            wni_lon: 122.85,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'LYNNT',
            wni_port_name: 'LYNN TERM',
            wni_unlocode: 'CANEP',
            wni_country: 'CA',
            wni_lat: 49.3,
            wni_lon: -123.04,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'MADEIS',
            wni_port_name: 'MADE ISLAND',
            wni_unlocode: 'MMKYP',
            wni_country: 'MM',
            wni_lat: 19.37,
            wni_lon: 93.69,
            wni_tz: 'Asia/Rangoon',
        },
        {
            option: 'MANA',
            wni_port_name: 'PORT MANATEE',
            wni_unlocode: 'USPME',
            wni_country: 'US',
            wni_lat: 27.63,
            wni_lon: -82.57,
            wni_tz: 'America/New_York',
        },
        {
            option: 'MBU',
            wni_port_name: 'MONBETSU',
            wni_unlocode: 'JPMBE',
            wni_country: 'JP',
            wni_lat: 44.35,
            wni_lon: 143.4,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MDP',
            wni_port_name: 'MAR DEL PLATA',
            wni_unlocode: 'ARMDQ',
            wni_country: 'AR',
            wni_lat: -38.03,
            wni_lon: -57.53,
            wni_tz: 'America/Argentina/Buenos_Aires',
        },
        {
            option: 'MENRC',
            wni_port_name: 'MENORCA',
            wni_unlocode: 'ESMAH',
            wni_country: 'ES',
            wni_lat: 39.89,
            wni_lon: 4.27,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'MEU',
            wni_port_name: 'MEULABOH',
            wni_unlocode: 'IDMEQ',
            wni_country: 'ID',
            wni_lat: 4.13,
            wni_lon: 96.13,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'MEVILL',
            wni_port_name: 'PORT MELVILLE',
            wni_unlocode: 'AUMLE',
            wni_country: 'AU',
            wni_lat: -11.42,
            wni_lon: 130.41,
            wni_tz: 'Australia/Darwin',
        },
        {
            option: 'MLCRT',
            wni_port_name: 'PAMPA MELCHORITA',
            wni_unlocode: 'PEPMC',
            wni_country: 'PE',
            wni_lat: -13.27,
            wni_lon: -76.33,
            wni_tz: 'America/Lima',
        },
        {
            option: 'MLY',
            wni_port_name: 'MAALOEY',
            wni_unlocode: 'NOMAY',
            wni_country: 'NO',
            wni_lat: 61.93,
            wni_lon: 5.12,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'MNK',
            wni_port_name: 'MURMANSK LNG STS',
            wni_unlocode: 'RUKDN',
            wni_country: 'RU',
            wni_lat: 69.32,
            wni_lon: 34.28,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'MOKL',
            wni_port_name: 'MOHESKHALI',
            wni_unlocode: 'BDCGP',
            wni_country: 'BD',
            wni_lat: 21.56,
            wni_lon: 91.82,
            wni_tz: 'Asia/Dhaka',
        },
        {
            option: 'MTRBR',
            wni_port_name: 'MATARBARI',
            wni_unlocode: 'BDCGP',
            wni_country: 'BD',
            wni_lat: 21.7,
            wni_lon: 91.86,
            wni_tz: 'Asia/Dhaka',
        },
        {
            option: 'MOLOR',
            wni_port_name: 'MOLORE',
            wni_unlocode: 'IDBAH',
            wni_country: 'ID',
            wni_lat: -3.31,
            wni_lon: 122.29,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'MOMA',
            wni_port_name: 'PORTO DE MOMA',
            wni_unlocode: 'MZMMW',
            wni_country: 'MZ',
            wni_lat: -16.77,
            wni_lon: 39.23,
            wni_tz: 'Africa/Maputo',
        },
        {
            option: 'MRG',
            wni_port_name: 'MARGATE',
            wni_unlocode: 'GBMGT',
            wni_country: 'GB',
            wni_lat: 51.39,
            wni_lon: 1.38,
            wni_tz: 'Europe/London',
        },
        {
            option: 'TNGUG',
            wni_port_name: 'TONGUE DW ANCHORAGE',
            wni_unlocode: 'GBMGT',
            wni_country: 'GB',
            wni_lat: 51.5,
            wni_lon: 1.5,
            wni_tz: 'Europe/London',
        },
        {
            option: 'MRI',
            wni_port_name: 'MORONI',
            wni_unlocode: 'KMYVA',
            wni_country: 'KM',
            wni_lat: -11.7,
            wni_lon: 43.25,
            wni_tz: 'Indian/Comoro',
        },
        {
            option: 'MRM',
            wni_port_name: 'MORMUGAO',
            wni_unlocode: 'INMRM',
            wni_country: 'IN',
            wni_lat: 15.43,
            wni_lon: 73.78,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'MSC',
            wni_port_name: 'MASINLOC',
            wni_unlocode: 'PHMSC',
            wni_country: 'PH',
            wni_lat: 15.55,
            wni_lon: 119.95,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'MSGT',
            wni_port_name: 'MASSONGO TERMINAL',
            wni_unlocode: 'CMMSG',
            wni_country: 'CM',
            wni_lat: 4.22,
            wni_lon: 8.78,
            wni_tz: 'Africa/Douala',
        },
        {
            option: 'MSS',
            wni_port_name: 'MOSS',
            wni_unlocode: 'NOMSS',
            wni_country: 'NO',
            wni_lat: 59.43,
            wni_lon: 10.67,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'MTE',
            wni_port_name: 'MATANE',
            wni_unlocode: 'CAMNE',
            wni_country: 'CA',
            wni_lat: 48.85,
            wni_lon: -67.53,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'MTY',
            wni_port_name: 'MANTYLUOTO',
            wni_unlocode: 'FIMTL',
            wni_country: 'FI',
            wni_lat: 61.6,
            wni_lon: 21.48,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'MUB',
            wni_port_name: 'MAUBAN',
            wni_unlocode: 'PHMAU',
            wni_country: 'PH',
            wni_lat: 14.2,
            wni_lon: 121.73,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'MUTS',
            wni_port_name: 'MUTSAMUDU',
            wni_unlocode: 'KMMUT',
            wni_country: 'KM',
            wni_lat: -12.15,
            wni_lon: 44.4,
            wni_tz: 'Indian/Comoro',
        },
        {
            option: 'MWAR',
            wni_port_name: 'MULDWARKA',
            wni_unlocode: 'INMDK',
            wni_country: 'IN',
            wni_lat: 20.75,
            wni_lon: 70.66,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'MX2',
            wni_port_name: 'GULFMEX',
            wni_unlocode: 'USSW8',
            wni_country: 'US',
            wni_lat: 28,
            wni_lon: -89.5,
            wni_tz: 'Etc/GMT+6',
        },
        {
            option: 'MYAV',
            wni_port_name: 'MY A',
            wni_unlocode: 'VNUIH',
            wni_country: 'VN',
            wni_lat: 14.85,
            wni_lon: 109.03,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'MYNUR',
            wni_port_name: 'MIYANOURA',
            wni_unlocode: 'JPIIN',
            wni_country: 'JP',
            wni_lat: 30.43,
            wni_lon: 130.58,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NGONC',
            wni_port_name: 'NGO BAY',
            wni_unlocode: 'NCPNY',
            wni_country: 'NC',
            wni_lat: -22.33,
            wni_lon: 166.7,
            wni_tz: 'Pacific/Noumea',
        },
        {
            option: 'NHABE',
            wni_port_name: 'NHABE',
            wni_unlocode: 'VNPHU',
            wni_country: 'VN',
            wni_lat: 10.7,
            wni_lon: 106.76,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'NKA',
            wni_port_name: 'NUKUALOFA',
            wni_unlocode: 'TOTBU',
            wni_country: 'TO',
            wni_lat: -21.13,
            wni_lon: -175.2,
            wni_tz: 'Pacific/Tongatapu',
        },
        {
            option: 'NNGD',
            wni_port_name: 'NING DE',
            wni_unlocode: 'CNNDE',
            wni_country: 'CN',
            wni_lat: 26.65,
            wni_lon: 119.53,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'NOM',
            wni_port_name: 'NOME',
            wni_unlocode: 'USOME',
            wni_country: 'US',
            wni_lat: 64.5,
            wni_lon: -165.42,
            wni_tz: 'America/Nome',
        },
        {
            option: 'NPFL',
            wni_port_name: 'NAPLES(FLORIDA)',
            wni_unlocode: 'USBCG',
            wni_country: 'US',
            wni_lat: 26.15,
            wni_lon: -81.8,
            wni_tz: 'America/New_York',
        },
        {
            option: 'NWCT',
            wni_port_name: 'NEWCASTLE',
            wni_unlocode: 'CANCT',
            wni_country: 'CA',
            wni_lat: 47.04,
            wni_lon: -65.47,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'OLBIA',
            wni_port_name: 'OLBIA',
            wni_unlocode: 'ITOLB',
            wni_country: 'IT',
            wni_lat: 40.92,
            wni_lon: 9.5,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'OSM',
            wni_port_name: 'BIZENOSHIMA',
            wni_unlocode: 'JPOSM',
            wni_country: 'JP',
            wni_lat: 33.05,
            wni_lon: 129.64,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'OTAKE',
            wni_port_name: 'OTAKE',
            wni_unlocode: 'JPOTK',
            wni_country: 'JP',
            wni_lat: 34.24,
            wni_lon: 132.24,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'OUINN',
            wni_port_name: 'OUINNE',
            wni_unlocode: 'NCNOU',
            wni_country: 'NC',
            wni_lat: -21.97,
            wni_lon: 166.7,
            wni_tz: 'Pacific/Noumea',
        },
        {
            option: 'OUL',
            wni_port_name: 'OULU',
            wni_unlocode: 'FIOUL',
            wni_country: 'FI',
            wni_lat: 65.02,
            wni_lon: 25.47,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'PAS',
            wni_port_name: 'PARAMARIBO',
            wni_unlocode: 'SRPBM',
            wni_country: 'SR',
            wni_lat: 5.82,
            wni_lon: -55.15,
            wni_tz: 'America/Paramaribo',
        },
        {
            option: 'PDKE',
            wni_port_name: 'PORT DE BOKE',
            wni_unlocode: 'GNBRP',
            wni_country: 'GN',
            wni_lat: 10.87,
            wni_lon: -14.47,
            wni_tz: 'Africa/Conakry',
        },
        {
            option: 'PENGH',
            wni_port_name: 'PENGHU',
            wni_unlocode: 'TWMZG',
            wni_country: 'TW',
            wni_lat: 23.57,
            wni_lon: 119.52,
            wni_tz: 'Asia/Taipei',
        },
        {
            option: 'PENGR',
            wni_port_name: 'PENGERANG',
            wni_unlocode: 'MYPGG',
            wni_country: 'MY',
            wni_lat: 1.33,
            wni_lon: 104.17,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'PJI',
            wni_port_name: 'PANAJI',
            wni_unlocode: 'INPAN',
            wni_country: 'IN',
            wni_lat: 15.49,
            wni_lon: 73.82,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'PLMS',
            wni_port_name: 'PALAMOS',
            wni_unlocode: 'ESPAL',
            wni_country: 'ES',
            wni_lat: 41.83,
            wni_lon: 3.12,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'PLTNG',
            wni_port_name: 'PELINTUNG',
            wni_unlocode: 'IDPLG',
            wni_country: 'ID',
            wni_lat: 1.67,
            wni_lon: 101.63,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'PLUT',
            wni_port_name: 'PLUTO',
            wni_unlocode: 'AUDAM',
            wni_country: 'AU',
            wni_lat: -20.35,
            wni_lon: 116.85,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'PME',
            wni_port_name: 'PORT MELLON',
            wni_unlocode: 'CAPML',
            wni_country: 'CA',
            wni_lat: 49.52,
            wni_lon: -123.48,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'POLI',
            wni_port_name: 'POLIPORT',
            wni_unlocode: 'TRPLP',
            wni_country: 'TR',
            wni_lat: 40.77,
            wni_lon: 29.53,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'PONA',
            wni_port_name: 'POHNPEI',
            wni_unlocode: 'FMPNI',
            wni_country: 'FM',
            wni_lat: 6.98,
            wni_lon: 158.2,
            wni_tz: 'Pacific/Pohnpei',
        },
        {
            option: 'PQC',
            wni_port_name: 'POZOS COLORADOS',
            wni_unlocode: 'COPOC',
            wni_country: 'CO',
            wni_lat: 11.15,
            wni_lon: -74.25,
            wni_tz: 'America/Bogota',
        },
        {
            option: 'PRGRN',
            wni_port_name: 'PEREGRINO OIL FIELD',
            wni_unlocode: 'BRFNO',
            wni_country: 'BR',
            wni_lat: -23.34,
            wni_lon: -41.25,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'PRTN',
            wni_port_name: 'CAPE PRESTON',
            wni_unlocode: 'AUCPN',
            wni_country: 'AU',
            wni_lat: -20.83,
            wni_lon: 116.19,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'PSBU',
            wni_port_name: 'SAMBU',
            wni_unlocode: 'IDPSS',
            wni_country: 'ID',
            wni_lat: 1.17,
            wni_lon: 103.9,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'PUD',
            wni_port_name: 'PUERTO DESEADO',
            wni_unlocode: 'ARPUD',
            wni_country: 'AR',
            wni_lat: -47.75,
            wni_lon: -65.9,
            wni_tz: 'America/Argentina/Rio_Gallegos',
        },
        {
            option: 'PURI',
            wni_port_name: 'PUNTA RINCON',
            wni_unlocode: 'PACTB',
            wni_country: 'PA',
            wni_lat: 9.03,
            wni_lon: -80.7,
            wni_tz: 'America/Panama',
        },
        {
            option: 'PW',
            wni_port_name: 'PALAU',
            wni_unlocode: 'PWROR',
            wni_country: 'PW',
            wni_lat: 7.32,
            wni_lon: 134.46,
            wni_tz: 'Pacific/Palau',
        },
        {
            option: 'QIZ2',
            wni_port_name: 'QINZHOU STS OPERATION AREA',
            wni_unlocode: 'CNQZH',
            wni_country: 'CN',
            wni_lat: 21.03,
            wni_lon: 108.3,
            wni_tz: 'Asia/Chongqing',
        },
        {
            option: 'RAALKA',
            wni_port_name: 'RAS AL KHAIR',
            wni_unlocode: 'SARAZ',
            wni_country: 'SA',
            wni_lat: 27.56,
            wni_lon: 49.18,
            wni_tz: 'Asia/Riyadh',
        },
        {
            option: 'RAH',
            wni_port_name: 'RAS AL HADD',
            wni_unlocode: 'OMQAL',
            wni_country: 'OM',
            wni_lat: 22.54,
            wni_lon: 59.76,
            wni_tz: 'Asia/Muscat',
        },
        {
            option: 'RE',
            wni_port_name: 'PORT REUNION',
            wni_unlocode: 'REPD2',
            wni_country: 'RE',
            wni_lat: -20.92,
            wni_lon: 55.32,
            wni_tz: 'Indian/Reunion',
        },
        {
            option: 'ROEN',
            wni_port_name: 'RONNSKAR',
            wni_unlocode: 'SEROR',
            wni_country: 'SE',
            wni_lat: 64.68,
            wni_lon: 21.27,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'ROQUE',
            wni_port_name: 'SAN ROQUE',
            wni_unlocode: 'ESSRQ',
            wni_country: 'ES',
            wni_lat: 36.17,
            wni_lon: -5.4,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'ROTC',
            wni_port_name: 'ROTTERDAM CENTRUM',
            wni_unlocode: 'NLRTM',
            wni_country: 'NL',
            wni_lat: 51.9,
            wni_lon: 4.48,
            wni_tz: 'Europe/Amsterdam',
        },
        {
            option: 'WNIP',
            wni_port_name: 'WNIAR ISLAND',
            wni_unlocode: 'INSGR',
            wni_country: 'IN',
            wni_lat: 21.69,
            wni_lon: 88.03,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'SBAK',
            wni_port_name: 'MUARA SABAK',
            wni_unlocode: 'IDMSK',
            wni_country: 'ID',
            wni_lat: -1.02,
            wni_lon: 103.82,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'SBT',
            wni_port_name: 'SAHABAT',
            wni_unlocode: 'MYBKP',
            wni_country: 'MY',
            wni_lat: 5.06,
            wni_lon: 118.99,
            wni_tz: 'Asia/Kuching',
        },
        {
            option: 'SBW',
            wni_port_name: 'SEMBAWANG',
            wni_unlocode: 'SGSEM',
            wni_country: 'SG',
            wni_lat: 1.45,
            wni_lon: 103.82,
            wni_tz: 'Asia/Singapore',
        },
        {
            option: 'SDC',
            wni_port_name: 'SANTIAGO DE CUBA',
            wni_unlocode: 'CUSCU',
            wni_country: 'CU',
            wni_lat: 20.02,
            wni_lon: -75.83,
            wni_tz: 'America/Havana',
        },
        {
            option: 'SDJ',
            wni_port_name: 'SANDEFJORD',
            wni_unlocode: 'NOSAD',
            wni_country: 'NO',
            wni_lat: 59.12,
            wni_lon: 10.23,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SDY2',
            wni_port_name: 'SYDNEY',
            wni_unlocode: 'AUSYD',
            wni_country: 'AU',
            wni_lat: -33.85,
            wni_lon: 151.2,
            wni_tz: 'Australia/Sydney',
        },
        {
            option: 'SEBP',
            wni_port_name: 'SEBUKU',
            wni_unlocode: 'IDSEB',
            wni_country: 'ID',
            wni_lat: -3.7,
            wni_lon: 116.4,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'SENQ',
            wni_port_name: 'SHENQUAN',
            wni_unlocode: 'CNSTG',
            wni_country: 'CN',
            wni_lat: 22.92,
            wni_lon: 116.37,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'YEDG',
            wni_port_name: 'YUEDONG',
            wni_unlocode: 'CNSTG',
            wni_country: 'CN',
            wni_lat: 22.92,
            wni_lon: 116.37,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'SGI',
            wni_port_name: 'SANGI',
            wni_unlocode: 'PHSNG',
            wni_country: 'PH',
            wni_lat: 10.37,
            wni_lon: 123.63,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'SGSKI2',
            wni_port_name: 'SEKI SAKI',
            wni_unlocode: 'JPWNI',
            wni_country: 'JP',
            wni_lat: 33.3,
            wni_lon: 131.9,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SHAN',
            wni_port_name: 'SHANHAIGUAN',
            wni_unlocode: 'CNSHH',
            wni_country: 'CN',
            wni_lat: 40,
            wni_lon: 119.76,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'SHDO',
            wni_port_name: 'SHIDAO',
            wni_unlocode: 'CNSHD',
            wni_country: 'CN',
            wni_lat: 36.88,
            wni_lon: 122.44,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'SHOOK',
            wni_port_name: 'SOUTH HOOK',
            wni_unlocode: 'GBMLF',
            wni_country: 'GB',
            wni_lat: 51.7,
            wni_lon: -5.1,
            wni_tz: 'Europe/London',
        },
        {
            option: 'SHR',
            wni_port_name: 'SHIRIYA SAKI',
            wni_unlocode: 'JPSYZ',
            wni_country: 'JP',
            wni_lat: 41.41,
            wni_lon: 141.43,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SHUBA',
            wni_port_name: 'SHUAIBA',
            wni_unlocode: 'KWSAA',
            wni_country: 'KW',
            wni_lat: 29.04,
            wni_lon: 48.18,
            wni_tz: 'Asia/Kuwait',
        },
        {
            option: 'SISM',
            wni_port_name: 'SHIRASHIMA',
            wni_unlocode: 'JPHBK',
            wni_country: 'JP',
            wni_lat: 34.02,
            wni_lon: 130.74,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SJM',
            wni_port_name: 'ST. JAMES',
            wni_unlocode: 'USSNJ',
            wni_country: 'US',
            wni_lat: 29.99,
            wni_lon: -90.83,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'SKCH',
            wni_port_name: 'SOKCHO',
            wni_unlocode: 'KRSHO',
            wni_country: 'KR',
            wni_lat: 38.2,
            wni_lon: 128.61,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'SKP',
            wni_port_name: 'STEENBANK PILOT',
            wni_unlocode: 'BEGNE',
            wni_country: 'BE',
            wni_lat: 51.75,
            wni_lon: 3.21,
            wni_tz: 'Europe/Brussels',
        },
        {
            option: 'WDT',
            wni_port_name: 'WANDELAAR PILOT',
            wni_unlocode: 'BEGNE',
            wni_country: 'BE',
            wni_lat: 51.38,
            wni_lon: 2.72,
            wni_tz: 'Europe/Brussels',
        },
        {
            option: 'SKRSK',
            wni_port_name: 'SHAKHTERSK',
            wni_unlocode: 'RUSHA',
            wni_country: 'RU',
            wni_lat: 49.17,
            wni_lon: 142.03,
            wni_tz: 'Asia/Sakhalin',
        },
        {
            option: 'SLF',
            wni_port_name: 'AS-SALIF',
            wni_unlocode: 'YESAL',
            wni_country: 'YE',
            wni_lat: 15.31,
            wni_lon: 42.67,
            wni_tz: 'Asia/Aden',
        },
        {
            option: 'SMLJ',
            wni_port_name: 'SAMALAJU',
            wni_unlocode: 'MYBTU',
            wni_country: 'MY',
            wni_lat: 3.57,
            wni_lon: 113.32,
            wni_tz: 'Asia/Kuching',
        },
        {
            option: 'SMOJ',
            wni_port_name: 'SHINMOJI',
            wni_unlocode: 'JPSMJ',
            wni_country: 'JP',
            wni_lat: 33.87,
            wni_lon: 131.01,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SMTPRK',
            wni_port_name: 'Samut Prakan',
            wni_unlocode: 'THSAP',
            wni_country: 'TH',
            wni_lat: 13.58,
            wni_lon: 100.59,
            wni_tz: 'Asia/Bangkok',
        },
        {
            option: 'SNM',
            wni_port_name: 'SAN MARCOS ISLAND',
            wni_unlocode: 'MXSMI',
            wni_country: 'MX',
            wni_lat: 27.19,
            wni_lon: -112.1,
            wni_tz: 'America/Mazatlan',
        },
        {
            option: 'SOCHI',
            wni_port_name: 'SOCHI',
            wni_unlocode: 'RUSOC',
            wni_country: 'RU',
            wni_lat: 43.58,
            wni_lon: 39.73,
            wni_tz: 'Europe/Volgograd',
        },
        {
            option: 'SPL',
            wni_port_name: 'SPLIT',
            wni_unlocode: 'HRSPU',
            wni_country: 'HR',
            wni_lat: 43.5,
            wni_lon: 16.43,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'STAG',
            wni_port_name: 'STAG TERMINAL',
            wni_unlocode: 'AUSTT',
            wni_country: 'AU',
            wni_lat: -20.28,
            wni_lon: 116.25,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'STK',
            wni_port_name: 'STRAUMSVIK',
            wni_unlocode: 'ISSTR',
            wni_country: 'IS',
            wni_lat: 64.05,
            wni_lon: -22.04,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'SSD',
            wni_port_name: 'STENUNGSUND',
            wni_unlocode: 'SESTE',
            wni_country: 'SE',
            wni_lat: 58.08,
            wni_lon: 11.8,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'SUT',
            wni_port_name: 'SURAT THANI',
            wni_unlocode: 'THURT',
            wni_country: 'TH',
            wni_lat: 9.14,
            wni_lon: 99.32,
            wni_tz: 'Asia/Bangkok',
        },
        {
            option: 'SYODA',
            wni_port_name: 'ONODA',
            wni_unlocode: 'JPOND',
            wni_country: 'JP',
            wni_lat: 33.97,
            wni_lon: 131.16,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TAY',
            wni_port_name: 'TANIYAMA',
            wni_unlocode: 'JPTNY',
            wni_country: 'JP',
            wni_lat: 31.49,
            wni_lon: 130.52,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'THWA',
            wni_port_name: 'THILAWA',
            wni_unlocode: 'MMTLA',
            wni_country: 'MM',
            wni_lat: 16.65,
            wni_lon: 96.25,
            wni_tz: 'Asia/Rangoon',
        },
        {
            option: 'TINC',
            wni_port_name: 'TIN CAN ISLAND PORT',
            wni_unlocode: 'NGTIN',
            wni_country: 'NG',
            wni_lat: 6.43,
            wni_lon: 3.35,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'TMNRU',
            wni_port_name: 'TAMAN',
            wni_unlocode: 'RUTAM',
            wni_country: 'RU',
            wni_lat: 45.12,
            wni_lon: 36.66,
            wni_tz: 'Europe/Volgograd',
        },
        {
            option: 'TNJG',
            wni_port_name: 'TANJUNG SEKONG',
            wni_unlocode: 'IDTSE',
            wni_country: 'ID',
            wni_lat: -5.92,
            wni_lon: 106,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'TOB',
            wni_port_name: 'TOBATA',
            wni_unlocode: 'JPTBT',
            wni_country: 'JP',
            wni_lat: 33.91,
            wni_lon: 130.82,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TORS',
            wni_port_name: 'TOROS',
            wni_unlocode: 'TRTGT',
            wni_country: 'TR',
            wni_lat: 36.9,
            wni_lon: 35.99,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'TPI',
            wni_port_name: 'TRAPANI',
            wni_unlocode: 'ITTPS',
            wni_country: 'IT',
            wni_lat: 38,
            wni_lon: 12.5,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'TRIO',
            wni_port_name: 'TORNIO',
            wni_unlocode: 'FITOR',
            wni_country: 'FI',
            wni_lat: 65.84,
            wni_lon: 24.15,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'TTHNG',
            wni_port_name: 'THATONG',
            wni_unlocode: 'THKHA',
            wni_country: 'TH',
            wni_lat: 9.62,
            wni_lon: 99.6,
            wni_tz: 'Asia/Bangkok',
        },
        {
            option: 'TTM',
            wni_port_name: 'TRANMERE',
            wni_unlocode: 'GBTRA',
            wni_country: 'GB',
            wni_lat: 53.38,
            wni_lon: -3,
            wni_tz: 'Europe/London',
        },
        {
            option: 'TUZ',
            wni_port_name: 'TUZLA',
            wni_unlocode: 'TRTUZ',
            wni_country: 'TR',
            wni_lat: 40.78,
            wni_lon: 29.33,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'UGSK',
            wni_port_name: 'UGLEGORSK',
            wni_unlocode: 'RUUGL',
            wni_country: 'RU',
            wni_lat: 49.08,
            wni_lon: 142.03,
            wni_tz: 'Asia/Sakhalin',
        },
        {
            option: 'USU',
            wni_port_name: 'USHUAIA',
            wni_unlocode: 'ARUSH',
            wni_country: 'AR',
            wni_lat: -54.82,
            wni_lon: -68.3,
            wni_tz: 'America/Argentina/Ushuaia',
        },
        {
            option: 'VET',
            wni_port_name: 'LAS VENTANAS',
            wni_unlocode: 'CLLVS',
            wni_country: 'CL',
            wni_lat: -33.28,
            wni_lon: -71.65,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'VICMY',
            wni_port_name: 'VICTORIA',
            wni_unlocode: 'MYLBU',
            wni_country: 'MY',
            wni_lat: 5.26,
            wni_lon: 115.26,
            wni_tz: 'Asia/Kuching',
        },
        {
            option: 'VIZM',
            wni_port_name: 'VIZHINJAM',
            wni_unlocode: 'INTRV',
            wni_country: 'IN',
            wni_lat: 8.37,
            wni_lon: 76.99,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'VLGOS',
            wni_port_name: 'VLISSINGEN OOST',
            wni_unlocode: 'NLVLI',
            wni_country: 'NL',
            wni_lat: 51.44,
            wni_lon: 3.67,
            wni_tz: 'Europe/Amsterdam',
        },
        {
            option: 'VLLFR',
            wni_port_name: 'VILLEFRANCHE',
            wni_unlocode: 'FRVFM',
            wni_country: 'FR',
            wni_lat: 43.7,
            wni_lon: 7.32,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'WAIRK',
            wni_port_name: 'WAIRIKI',
            wni_unlocode: 'FJWAI',
            wni_country: 'FJ',
            wni_lat: -16.95,
            wni_lon: 178.65,
            wni_tz: 'Pacific/Fiji',
        },
        {
            option: 'WFNG',
            wni_port_name: 'WEIFANG',
            wni_unlocode: 'CNWEF',
            wni_country: 'CN',
            wni_lat: 37.32,
            wni_lon: 119.28,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'WJM',
            wni_port_name: 'WAJIMA',
            wni_unlocode: 'JPWJM',
            wni_country: 'JP',
            wni_lat: 37.4,
            wni_lon: 136.9,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'WLO',
            wni_port_name: 'WALLAROO',
            wni_unlocode: 'AUWAL',
            wni_country: 'AU',
            wni_lat: -33.93,
            wni_lon: 137.61,
            wni_tz: 'Australia/Adelaide',
        },
        {
            option: 'WLS',
            wni_port_name: 'WILLEMSTAD',
            wni_unlocode: 'CWWIL',
            wni_country: 'CW',
            wni_lat: 12.12,
            wni_lon: -68.93,
            wni_tz: 'America/Curacao',
        },
        {
            option: 'XAMO',
            wni_port_name: 'XIAOMO',
            wni_unlocode: 'CNSWE',
            wni_country: 'CN',
            wni_lat: 22.74,
            wni_lon: 115.05,
            wni_tz: 'Asia/Hong_Kong',
        },
        {
            option: 'XZHIS',
            wni_port_name: 'XIAZHI MEN SOUTHERN ANCHORAGE',
            wni_unlocode: 'CNZOS',
            wni_country: 'CN',
            wni_lat: 29.67,
            wni_lon: 122.35,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'YGHG',
            wni_port_name: 'YEONGHUENG',
            wni_unlocode: 'KRINC',
            wni_country: 'KR',
            wni_lat: 37.24,
            wni_lon: 126.42,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'YNKY',
            wni_port_name: 'Autoport(YENIKOY)',
            wni_unlocode: 'TRAUT',
            wni_country: 'TR',
            wni_lat: 40.73,
            wni_lon: 29.86,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'YOKMH',
            wni_port_name: 'YOKOHAMA(MINAMI HONMOKU)',
            wni_unlocode: 'JPYOK',
            wni_country: 'JP',
            wni_lat: 35.4,
            wni_lon: 139.68,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'YSLVC',
            wni_port_name: 'YESILOVACIK',
            wni_unlocode: 'TRYIK',
            wni_country: 'TR',
            wni_lat: 36.19,
            wni_lon: 33.66,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'ZCAN',
            wni_port_name: 'ZONA COMUN ANCH',
            wni_unlocode: 'ARLPG',
            wni_country: 'AR',
            wni_lat: -34.75,
            wni_lon: -57.83,
            wni_tz: 'America/Argentina/Buenos_Aires',
        },
        {
            option: 'ZKNTH',
            wni_port_name: 'ZAKYNTHOS',
            wni_unlocode: 'GRZTH',
            wni_country: 'GR',
            wni_lat: 37.78,
            wni_lon: 20.9,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'ZLZT',
            wni_port_name: 'ZELZATE',
            wni_unlocode: 'BEZEL',
            wni_country: 'BE',
            wni_lat: 51.2,
            wni_lon: 3.81,
            wni_tz: 'Europe/Brussels',
        },
        {
            option: 'ABKR',
            wni_port_name: 'BASRAH OIL TERMINAL',
            wni_unlocode: 'IQKHA',
            wni_country: 'IQ',
            wni_lat: 29.68,
            wni_lon: 48.82,
            wni_tz: 'Asia/Baghdad',
        },
        {
            option: 'BHLNG',
            wni_port_name: 'BAHRAIN  LNG TERMINAL',
            wni_unlocode: 'BHBAH',
            wni_country: 'BH',
            wni_lat: 26.23,
            wni_lon: 50.75,
            wni_tz: 'Asia/Bahrain',
        },
        {
            option: 'BUNTI',
            wni_port_name: 'BUNATI',
            wni_unlocode: 'IDSTU',
            wni_country: 'ID',
            wni_lat: -3.75,
            wni_lon: 115.65,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'CHMSO',
            wni_port_name: 'CHIM SAO',
            wni_unlocode: 'VNBHO',
            wni_country: 'VN',
            wni_lat: 7.33,
            wni_lon: 108.3,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'DAWE',
            wni_port_name: 'DAWEI',
            wni_unlocode: 'MMMER',
            wni_country: 'MM',
            wni_lat: 14.07,
            wni_lon: 98.18,
            wni_tz: 'Asia/Rangoon',
        },
        {
            option: 'DRPNO',
            wni_port_name: 'DREPANO',
            wni_unlocode: 'GRGPA',
            wni_country: 'GR',
            wni_lat: 38.34,
            wni_lon: 21.85,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'EBOK',
            wni_port_name: 'EBOK OILFIELD',
            wni_unlocode: 'NGODU',
            wni_country: 'NG',
            wni_lat: 4,
            wni_lon: 8,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'EFESN',
            wni_port_name: 'EFESAN',
            wni_unlocode: 'TRDIL',
            wni_country: 'TR',
            wni_lat: 40.76,
            wni_lon: 29.55,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'HADJ',
            wni_port_name: 'MERS EL HADJADJ',
            wni_unlocode: 'DZBHA',
            wni_country: 'DZ',
            wni_lat: 35.8,
            wni_lon: -0.18,
            wni_tz: 'Africa/Algiers',
        },
        {
            option: 'HMHN',
            wni_port_name: 'HOMONHON',
            wni_unlocode: 'PHMNI',
            wni_country: 'PH',
            wni_lat: 10.76,
            wni_lon: 125.64,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'JAX1',
            wni_port_name: 'JACKSONVILLE LAY-UP',
            wni_unlocode: 'USJAX',
            wni_country: 'US',
            wni_lat: 30.4,
            wni_lon: -81.32,
            wni_tz: 'America/New_York',
        },
        {
            option: 'EGGK',
            wni_port_name: 'EGEGIK',
            wni_unlocode: 'USNNK',
            wni_country: 'US',
            wni_lat: 58.2,
            wni_lon: -157.37,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'KME',
            wni_port_name: 'KAREMBE',
            wni_unlocode: 'NCTUD',
            wni_country: 'NC',
            wni_lat: -20.62,
            wni_lon: 164.29,
            wni_tz: 'Pacific/Noumea',
        },
        {
            option: 'KOMDO',
            wni_port_name: 'KOMODO',
            wni_unlocode: 'IDKOI',
            wni_country: 'ID',
            wni_lat: -8.58,
            wni_lon: 119.51,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'KRO',
            wni_port_name: 'KRONSHTADT',
            wni_unlocode: 'RULED',
            wni_country: 'RU',
            wni_lat: 59.98,
            wni_lon: 29.78,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'LUHNG',
            wni_port_name: 'LIUHENG',
            wni_unlocode: 'CNZOS',
            wni_country: 'CN',
            wni_lat: 29.75,
            wni_lon: 122.15,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'MICLL',
            wni_port_name: 'CALETA MICHILLA',
            wni_unlocode: 'CLPAG',
            wni_country: 'CL',
            wni_lat: -22.71,
            wni_lon: -70.29,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'MTSKA',
            wni_port_name: 'MATSUSAKA',
            wni_unlocode: 'JPTOB',
            wni_country: 'JP',
            wni_lat: 34.61,
            wni_lon: 136.56,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'ONNH',
            wni_port_name: 'OFF NAGASAKI NORTH',
            wni_unlocode: 'JPNGS',
            wni_country: 'JP',
            wni_lat: 32.13,
            wni_lon: 129.08,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'ONSH',
            wni_port_name: 'OFF NAGASAKI SOUTH',
            wni_unlocode: 'JPSEN',
            wni_country: 'JP',
            wni_lat: 31.67,
            wni_lon: 129.38,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'OTHM',
            wni_port_name: 'OFF TSUSHIMA',
            wni_unlocode: 'JPIZH',
            wni_country: 'JP',
            wni_lat: 34.5,
            wni_lon: 130,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'PCFC',
            wni_port_name: 'PACIFIC AREA LIGHTERING',
            wni_unlocode: 'USENC',
            wni_country: 'US',
            wni_lat: 33.15,
            wni_lon: -117.92,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'PMPT',
            wni_port_name: 'PORT MORESBY PNG TERMINAL',
            wni_unlocode: 'PGPOM',
            wni_country: 'PG',
            wni_lat: -9.34,
            wni_lon: 146.99,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'POUM',
            wni_port_name: 'POUM',
            wni_unlocode: 'NCTUD',
            wni_country: 'NC',
            wni_lat: -20.22,
            wni_lon: 164.04,
            wni_tz: 'Pacific/Noumea',
        },
        {
            option: 'PSBY',
            wni_port_name: 'POSSESSION BAY',
            wni_unlocode: 'CLPCK',
            wni_country: 'CL',
            wni_lat: -52.37,
            wni_lon: -69.03,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'PZFLR',
            wni_port_name: 'PAZFLOR OIL TERMINAL',
            wni_unlocode: 'AOGIR',
            wni_country: 'AO',
            wni_lat: -7.51,
            wni_lon: 12.11,
            wni_tz: 'Africa/Luanda',
        },
        {
            option: 'QIBOT',
            wni_port_name: 'QUA IBOE OIL TERMINAL',
            wni_unlocode: 'NGODU',
            wni_country: 'NG',
            wni_lat: 4.22,
            wni_lon: 8.06,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'RANH',
            wni_port_name: 'CAM RANH',
            wni_unlocode: 'VNBNO',
            wni_country: 'VN',
            wni_lat: 11.81,
            wni_lon: 109.21,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'RDLY',
            wni_port_name: 'RIDLEY',
            wni_unlocode: 'CAPRR',
            wni_country: 'CA',
            wni_lat: 54.22,
            wni_lon: -130.35,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'SHVP',
            wni_port_name: 'SOUTH VAN PHONG',
            wni_unlocode: 'VNVPH',
            wni_country: 'VN',
            wni_lat: 12.46,
            wni_lon: 109.31,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'SOV',
            wni_port_name: 'SOVETSKAYA GAVAN',
            wni_unlocode: 'RUVNN',
            wni_country: 'RU',
            wni_lat: 48.97,
            wni_lon: 140.28,
            wni_tz: 'Asia/Vladivostok',
        },
        {
            option: 'SUD',
            wni_port_name: 'ORMOS SOUDHA',
            wni_unlocode: 'GRSUD',
            wni_country: 'GR',
            wni_lat: 35.48,
            wni_lon: 24.18,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'TLSTI',
            wni_port_name: 'TOLSTOI BAY',
            wni_unlocode: 'USKTB',
            wni_country: 'US',
            wni_lat: 55.65,
            wni_lon: -132.43,
            wni_tz: 'America/Sitka',
        },
        {
            option: 'TOG',
            wni_port_name: 'TOGIAK',
            wni_unlocode: 'USDLG',
            wni_country: 'US',
            wni_lat: 59.05,
            wni_lon: -160.41,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'URAGO',
            wni_port_name: 'URAGO',
            wni_unlocode: 'JPSMN',
            wni_country: 'JP',
            wni_lat: 36.08,
            wni_lon: 133,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'VNCN',
            wni_port_name: 'VINCENT',
            wni_unlocode: 'AUPYE',
            wni_country: 'AU',
            wni_lat: -21.43,
            wni_lon: 114.07,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'VPHB',
            wni_port_name: 'VAN PHONG BAY',
            wni_unlocode: 'VNVPH',
            wni_country: 'VN',
            wni_lat: 12.53,
            wni_lon: 109.37,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'WJAVA',
            wni_port_name: 'WEST JAVA LNG TERMINAL',
            wni_unlocode: 'IDTPP',
            wni_country: 'ID',
            wni_lat: -5.98,
            wni_lon: 106.8,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'XIO',
            wni_port_name: 'XIAOCUO',
            wni_unlocode: 'CNMEZ',
            wni_country: 'CN',
            wni_lat: 25.21,
            wni_lon: 118.96,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'AAO',
            wni_port_name: 'PASACAO',
            wni_unlocode: 'PHMBT',
            wni_country: 'PH',
            wni_lat: 13.5,
            wni_lon: 123.05,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'AAPI',
            wni_port_name: 'TANJUNG APIAPI',
            wni_unlocode: 'IDMUO',
            wni_country: 'ID',
            wni_lat: -2.28,
            wni_lon: 104.84,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'AGGRK',
            wni_port_name: 'ANGGREK',
            wni_unlocode: 'IDTZD',
            wni_country: 'ID',
            wni_lat: 0.86,
            wni_lon: 122.8,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'AKOT',
            wni_port_name: 'AKPO Offshore Terminal',
            wni_unlocode: 'NG566',
            wni_country: 'NG',
            wni_lat: 3.13,
            wni_lon: 6.82,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'AMLN',
            wni_port_name: 'AMLAN',
            wni_unlocode: 'PHTAN',
            wni_country: 'PH',
            wni_lat: 9.44,
            wni_lon: 123.24,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'ANOAI',
            wni_port_name: 'ANOA TERMINAL',
            wni_unlocode: 'XZANU',
            wni_country: 'ID',
            wni_lat: 5.22,
            wni_lon: 105.6,
            wni_tz: 'Etc/GMT-7',
        },
        {
            option: 'APAR',
            wni_port_name: 'APAR BAY',
            wni_unlocode: 'IDADB',
            wni_country: 'ID',
            wni_lat: -1.9,
            wni_lon: 116.62,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'AWANA',
            wni_port_name: 'LANGKAWI (AWANA PORT)',
            wni_unlocode: 'MYLGK',
            wni_country: 'MY',
            wni_lat: 6.25,
            wni_lon: 99.73,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'BATG',
            wni_port_name: 'BABATNGON',
            wni_unlocode: 'PHTAC',
            wni_country: 'PH',
            wni_lat: 11.41,
            wni_lon: 124.81,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'BDOC',
            wni_port_name: 'BADOC',
            wni_unlocode: 'PHCMO',
            wni_country: 'PH',
            wni_lat: 17.98,
            wni_lon: 120.47,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'BONGO',
            wni_port_name: 'BONGAO',
            wni_unlocode: 'PHJOL',
            wni_country: 'PH',
            wni_lat: 5.03,
            wni_lon: 119.77,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'BRUSN',
            wni_port_name: 'BORUSAN',
            wni_unlocode: 'TRGEM',
            wni_country: 'TR',
            wni_lat: 40.42,
            wni_lon: 29.08,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'BUMB',
            wni_port_name: 'BUMBULAN',
            wni_unlocode: 'IDTZD',
            wni_country: 'ID',
            wni_lat: 0.42,
            wni_lon: 122.12,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'BZ34C',
            wni_port_name: 'BZ 34 TERMINAL',
            wni_unlocode: 'CNDGY',
            wni_country: 'CN',
            wni_lat: 38.12,
            wni_lon: 119.55,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'CIB',
            wni_port_name: 'CEIBA MARINE TERMINAL',
            wni_unlocode: 'GQCOG',
            wni_country: 'GQ',
            wni_lat: 1.4,
            wni_lon: 9.22,
            wni_tz: 'Africa/Malabo',
        },
        {
            option: 'DEGI',
            wni_port_name: 'DEGI',
            wni_unlocode: 'ARWNI',
            wni_country: 'VN',
            wni_lat: 14.12,
            wni_lon: 109.22,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'DZA',
            wni_port_name: 'DZAOUDZI',
            wni_unlocode: 'YTMAM',
            wni_country: 'YT',
            wni_lat: -12.78,
            wni_lon: 45.27,
            wni_tz: 'Indian/Mayotte',
        },
        {
            option: 'FRWH',
            wni_port_name: 'FARWAH TERMINAL',
            wni_unlocode: 'LYBOU',
            wni_country: 'LY',
            wni_lat: 33.85,
            wni_lon: 12.03,
            wni_tz: 'Africa/Tripoli',
        },
        {
            option: 'GCE',
            wni_port_name: 'GRANDE ANSE',
            wni_unlocode: 'CAGAE',
            wni_country: 'CN',
            wni_lat: 48.4,
            wni_lon: -70.83,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'HANRO',
            wni_port_name: 'HANGA ROA',
            wni_unlocode: 'CLIPC',
            wni_country: 'CL',
            wni_lat: -27.14,
            wni_lon: -109.44,
            wni_tz: 'Pacific/Easter',
        },
        {
            option: 'HIZO',
            wni_port_name: 'HUIZHOU TERMINAL',
            wni_unlocode: 'CNHUI',
            wni_country: 'CN',
            wni_lat: 21.35,
            wni_lon: 115.4,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'HOYOE',
            wni_port_name: 'BANCO DEL HOYO',
            wni_unlocode: 'ESPUS',
            wni_country: 'ES',
            wni_lat: 36.08,
            wni_lon: -6.16,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'JFPS',
            wni_port_name: 'JAWA1 FSRU PROJECT SITE',
            wni_unlocode: 'IDARJ',
            wni_country: 'ID',
            wni_lat: -6.14,
            wni_lon: 107.74,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'JIP',
            wni_port_name: 'JISEPO LAY-UP',
            wni_unlocode: 'KROKP',
            wni_country: 'KR',
            wni_lat: 34.82,
            wni_lon: 128.81,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'KILD',
            wni_port_name: 'KRK ISLAND',
            wni_unlocode: 'HRKRM',
            wni_country: 'HR',
            wni_lat: 45.03,
            wni_lon: 14.08,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'KIZ',
            wni_port_name: 'KIZOMBA TERMINAL',
            wni_unlocode: 'AOKOT',
            wni_country: 'AO',
            wni_lat: -6.35,
            wni_lon: 11.15,
            wni_tz: 'Africa/Luanda',
        },
        {
            option: 'KLRNG',
            wni_port_name: 'KALIORANG',
            wni_unlocode: 'IDLTT',
            wni_country: 'ID',
            wni_lat: 0.78,
            wni_lon: 117.88,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'KLST',
            wni_port_name: 'KALAMATA STS',
            wni_unlocode: 'GRVAB',
            wni_country: 'GR',
            wni_lat: 36.52,
            wni_lon: 22.7,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'KLTUS',
            wni_port_name: 'KULTUS COVE',
            wni_unlocode: 'CARUI',
            wni_country: 'CA',
            wni_lat: 50.48,
            wni_lon: -127.62,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'KMNNY',
            wni_port_name: 'MYS KAMENNYY',
            wni_unlocode: 'RUSAB',
            wni_country: 'RU',
            wni_lat: 68.6,
            wni_lon: 73.59,
            wni_tz: 'Asia/Yekaterinburg',
        },
        {
            option: 'LARAK',
            wni_port_name: 'LARAK ISLAND',
            wni_unlocode: 'IRHOR',
            wni_country: 'IR',
            wni_lat: 26.86,
            wni_lon: 56.46,
            wni_tz: 'Asia/Tehran',
        },
        {
            option: 'LNGGI',
            wni_port_name: 'KUALA LINGGI',
            wni_unlocode: 'MYSUP',
            wni_country: 'MY',
            wni_lat: 2.39,
            wni_lon: 101.98,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'MANI',
            wni_port_name: 'MANURAN',
            wni_unlocode: 'IDSOQ',
            wni_country: 'ID',
            wni_lat: 0.01,
            wni_lon: 130.88,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'MEK',
            wni_port_name: 'MEKAR PUTIH',
            wni_unlocode: 'IDIBT',
            wni_country: 'ID',
            wni_lat: -4.02,
            wni_lon: 116.03,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'MKYU',
            wni_port_name: 'MEKORYUK',
            wni_unlocode: 'USBTJ',
            wni_country: 'US',
            wni_lat: 60.39,
            wni_lon: -166.18,
            wni_tz: 'America/Nome',
        },
        {
            option: 'MMK',
            wni_port_name: 'MURMANSK FSU PS',
            wni_unlocode: 'RUMMK',
            wni_country: 'RU',
            wni_lat: 69.46,
            wni_lon: 33.13,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'MRT',
            wni_port_name: 'MARTAS',
            wni_unlocode: 'TRMAR',
            wni_country: 'TR',
            wni_lat: 40.96,
            wni_lon: 27.93,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'MSNDM',
            wni_port_name: 'MUSANDAM GAS PLANT',
            wni_unlocode: 'OMKHS',
            wni_country: 'OM',
            wni_lat: 26.07,
            wni_lon: 56.05,
            wni_tz: 'Asia/Muscat',
        },
        {
            option: 'MUBAN',
            wni_port_name: 'MUARA BANYUASIN',
            wni_unlocode: 'IDMUO',
            wni_country: 'ID',
            wni_lat: -2.18,
            wni_lon: 104.95,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'NARRA',
            wni_port_name: 'NARRA',
            wni_unlocode: 'PHQUE',
            wni_country: 'PH',
            wni_lat: 9.15,
            wni_lon: 118.28,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'NGFP',
            wni_port_name: "N'GOMA FPSO",
            wni_unlocode: 'AOKOT',
            wni_country: 'AO',
            wni_lat: -6.14,
            wni_lon: 11.03,
            wni_tz: 'Africa/Luanda',
        },
        {
            option: 'NUVK',
            wni_port_name: 'NUNIVAK ISLAND SE',
            wni_unlocode: 'USBTJ',
            wni_country: 'US',
            wni_lat: 59.86,
            wni_lon: -165.86,
            wni_tz: 'America/Nome',
        },
        {
            option: 'OCH',
            wni_port_name: 'OCHAKIV',
            wni_unlocode: 'UAYUZ',
            wni_country: 'UA',
            wni_lat: 46.62,
            wni_lon: 31.53,
            wni_tz: 'Europe/Kiev',
        },
        {
            option: 'OLMDO',
            wni_port_name: 'ARMADA OLOMBENDO FPSO',
            wni_unlocode: 'AOKOT',
            wni_country: 'AO',
            wni_lat: -6.07,
            wni_lon: 11.36,
            wni_tz: 'ANGOLA/S.W.AFRICA',
        },
        {
            option: 'PMN',
            wni_port_name: 'PATIMBAN',
            wni_unlocode: 'IDARJ',
            wni_country: 'ID',
            wni_lat: -6.23,
            wni_lon: 107.91,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'PSVM',
            wni_port_name: 'PSVM TERMINAL',
            wni_unlocode: 'AOKOT',
            wni_country: 'AO',
            wni_lat: -6.24,
            wni_lon: 10.72,
            wni_tz: 'Africa/Luanda',
        },
        {
            option: 'PUCC',
            wni_port_name: 'PUERTO CHINCUI',
            wni_unlocode: 'CLCBC',
            wni_country: 'CL',
            wni_lat: -41.53,
            wni_lon: -73.04,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'RAUSU',
            wni_port_name: 'RAUSU',
            wni_unlocode: 'JPABA',
            wni_country: 'JP',
            wni_lat: 44.01,
            wni_lon: 145.2,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'RBIAH',
            wni_port_name: 'TELUK RUBIAH',
            wni_unlocode: 'MYTRB',
            wni_country: 'MY',
            wni_lat: 4.14,
            wni_lon: 100.62,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'RCA',
            wni_port_name: 'RECALADA',
            wni_unlocode: 'ARROC',
            wni_country: 'AR',
            wni_lat: -35.2,
            wni_lon: -56.3,
            wni_tz: 'America/Argentina/Buenos_Aires',
        },
        {
            option: 'SCRZP',
            wni_port_name: 'SANTA CRUZ(LUZON ISLAMD)',
            wni_unlocode: 'PHSCR',
            wni_country: 'PH',
            wni_lat: 15.76,
            wni_lon: 119.89,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'SDD',
            wni_port_name: 'SANDHEADS',
            wni_unlocode: 'INSGR',
            wni_country: 'IN',
            wni_lat: 21.45,
            wni_lon: 89.2,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'SHEN',
            wni_port_name: 'SHENAO',
            wni_unlocode: 'TWTPE',
            wni_country: 'TW',
            wni_lat: 25.13,
            wni_lon: 121.83,
            wni_tz: 'Asia/Taipei',
        },
        {
            option: 'SODNG',
            wni_port_name: 'SON DUONG',
            wni_unlocode: 'VNQBH',
            wni_country: 'VN',
            wni_lat: 18.06,
            wni_lon: 106.45,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'TABU',
            wni_port_name: 'TANJUNG BAKAU',
            wni_unlocode: 'IDPTL',
            wni_country: 'ID',
            wni_lat: -1.14,
            wni_lon: 119.39,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'TAKL',
            wni_port_name: 'TANJUNG KLUANG',
            wni_unlocode: 'IDBLT',
            wni_country: 'ID',
            wni_lat: -2.62,
            wni_lon: 108.18,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'TMBGN',
            wni_port_name: 'TUMBAGAAN',
            wni_unlocode: 'PHJOL',
            wni_country: 'PH',
            wni_lat: 5.36,
            wni_lon: 120.3,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'TMTA',
            wni_port_name: 'JUAN DE FUCA OFFSHORE AREA',
            wni_unlocode: 'CAVIC',
            wni_country: 'CA',
            wni_lat: 48.12,
            wni_lon: -125.12,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'TTRLL',
            wni_port_name: 'PUNTA TOTORALILLO',
            wni_unlocode: 'CLPPD',
            wni_country: 'CL',
            wni_lat: -26.84,
            wni_lon: -70.82,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'VSTCH',
            wni_port_name: 'VOSTOCHNYY(SAKHALIN)',
            wni_unlocode: 'RUPRN',
            wni_country: 'RU',
            wni_lat: 48.27,
            wni_lon: 142.64,
            wni_tz: 'Asia/Sakhalin',
        },
        {
            option: 'WPCFC',
            wni_port_name: 'WEST OF PAL',
            wni_unlocode: 'MXESE',
            wni_country: 'MX',
            wni_lat: 30,
            wni_lon: -121,
            wni_tz: 'America/Santa_Isabel',
        },
        {
            option: 'XIAHD',
            wni_port_name: 'XIAOHUDAO',
            wni_unlocode: 'CNXHO',
            wni_country: 'CN',
            wni_lat: 22.63,
            wni_lon: 113.69,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'XIZ',
            wni_port_name: 'XIKOMBA',
            wni_unlocode: 'AOKOT',
            wni_country: 'AO',
            wni_lat: -6.05,
            wni_lon: 11.03,
            wni_tz: 'Africa/Luanda',
        },
        {
            option: 'VOT',
            wni_port_name: 'VITYAZ TERMINAL',
            wni_unlocode: 'BEMLW',
            wni_country: 'RU',
            wni_lat: 52.68,
            wni_lon: 143.55,
            wni_tz: 'Asia/Sakhalin',
        },
        {
            option: 'MAHON',
            wni_port_name: 'MAHON',
            wni_unlocode: 'ESMAH',
            wni_country: 'ES',
            wni_lat: 39.89,
            wni_lon: 4.27,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'ARZNH',
            wni_port_name: 'ARZANAH ISLAND',
            wni_unlocode: 'AEARZ',
            wni_country: 'AE',
            wni_lat: 24.78,
            wni_lon: 52.57,
            wni_tz: 'Asia/Dubai',
        },
        {
            option: 'MZD',
            wni_port_name: 'MINA ZAYED',
            wni_unlocode: 'AEMZD',
            wni_country: 'AE',
            wni_lat: 24.53,
            wni_lon: 54.39,
            wni_tz: 'Asia/Dubai',
        },
        {
            option: 'RSD',
            wni_port_name: 'PORT RASHID',
            wni_unlocode: 'AEPRA',
            wni_country: 'AE',
            wni_lat: 25.26,
            wni_lon: 55.28,
            wni_tz: 'Asia/Dubai',
        },
        {
            option: 'SHNGJ',
            wni_port_name: 'SHENGJIN',
            wni_unlocode: 'ALSHG',
            wni_country: 'AL',
            wni_lat: 41.82,
            wni_lon: 19.6,
            wni_tz: 'Europe/Tirane',
        },
        {
            option: 'AMBM',
            wni_port_name: 'PORTO AMBOIM',
            wni_unlocode: 'AOPBN',
            wni_country: 'AO',
            wni_lat: -10.73,
            wni_lon: 13.75,
            wni_tz: 'Africa/Luanda',
        },
        {
            option: 'AMI',
            wni_port_name: 'AMBRIZ',
            wni_unlocode: 'AOAZZ',
            wni_country: 'AO',
            wni_lat: -7.83,
            wni_lon: 13.1,
            wni_tz: 'Africa/Luanda',
        },
        {
            option: 'PCN',
            wni_port_name: 'PALANCA TERMINAL',
            wni_unlocode: 'AOPAT',
            wni_country: 'AO',
            wni_lat: -6.95,
            wni_lon: 12.4,
            wni_tz: 'Africa/Luanda',
        },
        {
            option: 'QNFQN',
            wni_port_name: 'QUINFUQUENA TERMINAL',
            wni_unlocode: 'AOSOQ',
            wni_country: 'AO',
            wni_lat: -6.33,
            wni_lon: 12.23,
            wni_tz: 'Africa/Luanda',
        },
        {
            option: 'ARRO',
            wni_port_name: 'ARROYO SECO',
            wni_unlocode: 'ARASO',
            wni_country: 'AR',
            wni_lat: -33.16,
            wni_lon: -60.51,
            wni_tz: 'America/Argentina/Cordoba',
        },
        {
            option: 'GLVN',
            wni_port_name: 'PUERTO GALVAN',
            wni_unlocode: 'ARPGV',
            wni_country: 'AR',
            wni_lat: -38.78,
            wni_lon: -62.3,
            wni_tz: 'America/Argentina/Buenos_Aires',
        },
        {
            option: 'JLN',
            wni_port_name: 'SAN JULIAN',
            wni_unlocode: 'ARULA',
            wni_country: 'AR',
            wni_lat: -49.32,
            wni_lon: -67.7,
            wni_tz: 'America/Argentina/Rio_Gallegos',
        },
        {
            option: 'LPA',
            wni_port_name: 'LA PLATA',
            wni_unlocode: 'ARLPG',
            wni_country: 'AR',
            wni_lat: -34.9,
            wni_lon: -57.93,
            wni_tz: 'America/Argentina/Buenos_Aires',
        },
        {
            option: 'PBO',
            wni_port_name: 'PUERTO BELGRANO',
            wni_unlocode: 'ARPBG',
            wni_country: 'AR',
            wni_lat: -38.88,
            wni_lon: -62.1,
            wni_tz: 'America/Argentina/Buenos_Aires',
        },
        {
            option: 'PRNA',
            wni_port_name: 'PARANA',
            wni_unlocode: 'ARPRA',
            wni_country: 'AR',
            wni_lat: -31.72,
            wni_lon: -60.53,
            wni_tz: 'America/Argentina/Cordoba',
        },
        {
            option: 'QQN',
            wni_port_name: 'QUEQUEN',
            wni_unlocode: 'ARQQN',
            wni_country: 'AR',
            wni_lat: -38.58,
            wni_lon: -58.7,
            wni_tz: 'America/Argentina/Buenos_Aires',
        },
        {
            option: 'RGL',
            wni_port_name: 'RIO GALLEGOS',
            wni_unlocode: 'ARRGL',
            wni_country: 'AR',
            wni_lat: -51.62,
            wni_lon: -69.22,
            wni_tz: 'America/Argentina/Rio_Gallegos',
        },
        {
            option: 'SCZA',
            wni_port_name: 'SANTA CRUZ',
            wni_unlocode: 'ARRZA',
            wni_country: 'AR',
            wni_lat: -50.02,
            wni_lon: -68.52,
            wni_tz: 'America/Argentina/Rio_Gallegos',
        },
        {
            option: 'SNF',
            wni_port_name: 'SANTA FE',
            wni_unlocode: 'ARSFN',
            wni_country: 'AR',
            wni_lat: -31.65,
            wni_lon: -60.7,
            wni_tz: 'America/Argentina/Cordoba',
        },
        {
            option: 'SNPA',
            wni_port_name: 'SAN PEDRO',
            wni_unlocode: 'ARXPD',
            wni_country: 'AR',
            wni_lat: -33.68,
            wni_lon: -59.66,
            wni_tz: 'America/Argentina/Buenos_Aires',
        },
        {
            option: 'VLC',
            wni_port_name: 'VILLA CONSTITUCION',
            wni_unlocode: 'ARVCN',
            wni_country: 'AR',
            wni_lat: -33.23,
            wni_lon: -60.33,
            wni_tz: 'America/Argentina/Cordoba',
        },
        {
            option: 'BEATY',
            wni_port_name: 'BEAUTY POINT',
            wni_unlocode: 'AUBYP',
            wni_country: 'AU',
            wni_lat: -41.15,
            wni_lon: 146.82,
            wni_tz: 'Australia/Hobart',
        },
        {
            option: 'BLLST',
            wni_port_name: 'BALLAST HEAD',
            wni_unlocode: 'AUBAH',
            wni_country: 'AU',
            wni_lat: -35.75,
            wni_lon: 137.8,
            wni_tz: 'Australia/Adelaide',
        },
        {
            option: 'BOW',
            wni_port_name: 'BOWEN',
            wni_unlocode: 'AUZBO',
            wni_country: 'AU',
            wni_lat: -20.02,
            wni_lon: 148.25,
            wni_tz: 'Australia/Brisbane',
        },
        {
            option: 'BSSLT',
            wni_port_name: 'BUSSELTON',
            wni_unlocode: 'AUBUS',
            wni_country: 'AU',
            wni_lat: -33.65,
            wni_lon: 115.33,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'BTB',
            wni_port_name: 'BOTANY BAY',
            wni_unlocode: 'AUBTB',
            wni_country: 'AU',
            wni_lat: -34,
            wni_lon: 151.23,
            wni_tz: 'Australia/Sydney',
        },
        {
            option: 'CHRBR',
            wni_port_name: 'COFFS HARBOUR',
            wni_unlocode: 'AUCFS',
            wni_country: 'AU',
            wni_lat: -30.3,
            wni_lon: 153.13,
            wni_tz: 'Australia/Sydney',
        },
        {
            option: 'CKTWN',
            wni_port_name: 'COOKTOWN',
            wni_unlocode: 'AUCTN',
            wni_country: 'AU',
            wni_lat: -15.47,
            wni_lon: 145.25,
            wni_tz: 'Australia/Brisbane',
        },
        {
            option: 'CMT',
            wni_port_name: 'CAPE LAMBERT',
            wni_unlocode: 'AUCLT',
            wni_country: 'AU',
            wni_lat: -20.59,
            wni_lon: 117.18,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'CRNRV',
            wni_port_name: 'CARNARVON',
            wni_unlocode: 'AUCVQ',
            wni_country: 'AU',
            wni_lat: -24.88,
            wni_lon: 113.65,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'CTHLN',
            wni_port_name: 'CATHERINE HILL BAY',
            wni_unlocode: 'AUCHB',
            wni_country: 'AU',
            wni_lat: -33.15,
            wni_lon: 151.63,
            wni_tz: 'Australia/Sydney',
        },
        {
            option: 'DALR',
            wni_port_name: 'PORT DALRYMPLE',
            wni_unlocode: 'AUPTD',
            wni_country: 'AU',
            wni_lat: -41.1,
            wni_lon: 146.83,
            wni_tz: 'Australia/Hobart',
        },
        {
            option: 'DEV',
            wni_port_name: 'DEVONPORT',
            wni_unlocode: 'AUDPO',
            wni_country: 'AU',
            wni_lat: -41.18,
            wni_lon: 146.37,
            wni_tz: 'Australia/Hobart',
        },
        {
            option: 'DRR',
            wni_port_name: 'DERBY',
            wni_unlocode: 'GBDXY',
            wni_country: 'AU',
            wni_lat: -17.33,
            wni_lon: 123.63,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'GRIF',
            wni_port_name: 'GRIFFIN VENTURE',
            wni_unlocode: 'AUGRV',
            wni_country: 'AU',
            wni_lat: -20,
            wni_lon: 114,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'HAY',
            wni_port_name: 'HAY POINT',
            wni_unlocode: 'AUHPT',
            wni_country: 'AU',
            wni_lat: -21.27,
            wni_lon: 149.32,
            wni_tz: 'Australia/Brisbane',
        },
        {
            option: 'KNGSC',
            wni_port_name: 'KINGSCOTE',
            wni_unlocode: 'AUKGC',
            wni_country: 'AU',
            wni_lat: -35.63,
            wni_lon: 137.63,
            wni_tz: 'Australia/Adelaide',
        },
        {
            option: 'MLNR',
            wni_port_name: 'MILNER BAY',
            wni_unlocode: 'AUMIB',
            wni_country: 'AU',
            wni_lat: -13.87,
            wni_lon: 136.42,
            wni_tz: 'Australia/Darwin',
        },
        {
            option: 'MRYBR',
            wni_port_name: 'MARYBOROUGH',
            wni_unlocode: 'AUMBH',
            wni_country: 'AU',
            wni_lat: -25.55,
            wni_lon: 152.72,
            wni_tz: 'Australia/Brisbane',
        },
        {
            option: 'PER',
            wni_port_name: 'PERTH',
            wni_unlocode: 'AUPER',
            wni_country: 'AU',
            wni_lat: -31.96,
            wni_lon: 115.86,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'PHT',
            wni_port_name: 'PORT HUON',
            wni_unlocode: 'AUPHU',
            wni_country: 'AU',
            wni_lat: -43.17,
            wni_lon: 146.98,
            wni_tz: 'Australia/Hobart',
        },
        {
            option: 'PLA',
            wni_port_name: 'PORT ALMA',
            wni_unlocode: 'AUPTL',
            wni_country: 'AU',
            wni_lat: -23.6,
            wni_lon: 150.87,
            wni_tz: 'Australia/Brisbane',
        },
        {
            option: 'POA',
            wni_port_name: 'PORT AUGUSTA',
            wni_unlocode: 'AUPUG',
            wni_country: 'AU',
            wni_lat: -32.5,
            wni_lon: 137.77,
            wni_tz: 'Australia/Adelaide',
        },
        {
            option: 'RAPID',
            wni_port_name: 'RAPID BAY',
            wni_unlocode: 'AURAB',
            wni_country: 'AU',
            wni_lat: -35.53,
            wni_lon: 138.18,
            wni_tz: 'Australia/Adelaide',
        },
        {
            option: 'STNVC',
            wni_port_name: 'PORT STANVAC',
            wni_unlocode: 'AUPST',
            wni_country: 'AU',
            wni_lat: -35.1,
            wni_lon: 138.47,
            wni_tz: 'Australia/Adelaide',
        },
        {
            option: 'STRHN',
            wni_port_name: 'STRAHAN',
            wni_unlocode: 'AUSRN',
            wni_country: 'AU',
            wni_lat: -42.17,
            wni_lon: 145.33,
            wni_tz: 'Australia/Hobart',
        },
        {
            option: 'STY',
            wni_port_name: 'STANLEY',
            wni_unlocode: 'AUSTA',
            wni_country: 'AU',
            wni_lat: -40.77,
            wni_lon: 145.28,
            wni_tz: 'Australia/Hobart',
        },
        {
            option: 'USL',
            wni_port_name: 'USELESS LOOP',
            wni_unlocode: 'AUUSL',
            wni_country: 'AU',
            wni_lat: -26.12,
            wni_lon: 113.4,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'WRRNM',
            wni_port_name: 'WARRNAMBOOL',
            wni_unlocode: 'AUWMB',
            wni_country: 'AU',
            wni_lat: -38.4,
            wni_lon: 142.48,
            wni_tz: 'Australia/Melbourne',
        },
        {
            option: 'YBA',
            wni_port_name: 'YAMBA',
            wni_unlocode: 'AUYBA',
            wni_country: 'AU',
            wni_lat: -29.43,
            wni_lon: 153.35,
            wni_tz: 'Australia/Sydney',
        },
        {
            option: 'YRR',
            wni_port_name: 'YARRAVILLE',
            wni_unlocode: 'AUYRV',
            wni_country: 'AU',
            wni_lat: -37.82,
            wni_lon: 144.9,
            wni_tz: 'Australia/Melbourne',
        },
        {
            option: 'ORNJS',
            wni_port_name: 'ORANJESTAD',
            wni_unlocode: 'AWORJ',
            wni_country: 'AW',
            wni_lat: 12.52,
            wni_lon: -70.04,
            wni_tz: 'America/Curacao',
        },
        {
            option: 'MRHMN',
            wni_port_name: 'MARIEHAMN',
            wni_unlocode: 'FIMHQ',
            wni_country: 'AX',
            wni_lat: 60.1,
            wni_lon: 19.92,
            wni_tz: 'Europe/Mariehamn',
        },
        {
            option: 'BAKU',
            wni_port_name: 'BAKU',
            wni_unlocode: 'AZBAK',
            wni_country: 'AZ',
            wni_lat: 40.37,
            wni_lon: 49.87,
            wni_tz: 'Asia/Baku',
        },
        {
            option: 'BGGE',
            wni_port_name: 'BRUGGE',
            wni_unlocode: 'BEZEE',
            wni_country: 'BE',
            wni_lat: 51.22,
            wni_lon: 3.22,
            wni_tz: 'Europe/Brussels',
        },
        {
            option: 'GENT',
            wni_port_name: 'GENT',
            wni_unlocode: 'NLSVG',
            wni_country: 'BE',
            wni_lat: 51.07,
            wni_lon: 3.73,
            wni_tz: 'Europe/Brussels',
        },
        {
            option: 'NWPOO',
            wni_port_name: 'NIEUWPOORT',
            wni_unlocode: 'BENIE',
            wni_country: 'BE',
            wni_lat: 51.13,
            wni_lon: 2.75,
            wni_tz: 'Europe/Brussels',
        },
        {
            option: 'MSM',
            wni_port_name: 'MINA SULMAN',
            wni_unlocode: 'BHMIN',
            wni_country: 'BH',
            wni_lat: 26.22,
            wni_lon: 50.63,
            wni_tz: 'Asia/Bahrain',
        },
        {
            option: 'SEMEB',
            wni_port_name: 'SEME TERMINAL',
            wni_unlocode: 'BJSEM',
            wni_country: 'BJ',
            wni_lat: 6.3,
            wni_lon: 2.65,
            wni_tz: 'Africa/Porto-Novo',
        },
        {
            option: 'BN',
            wni_port_name: 'BRUNEI',
            wni_unlocode: 'BNLUM',
            wni_country: 'BN',
            wni_lat: 4.88,
            wni_lon: 114.93,
            wni_tz: 'Asia/Brunei',
        },
        {
            option: 'TJG',
            wni_port_name: 'TANJONG SALIRONG',
            wni_unlocode: 'BNTAS',
            wni_country: 'BN',
            wni_lat: 4.88,
            wni_lon: 115.1,
            wni_tz: 'Asia/Brunei',
        },
        {
            option: 'BONA',
            wni_port_name: 'BONAIRE TERMINAL',
            wni_unlocode: 'BQBON',
            wni_country: 'BQ',
            wni_lat: 12.21,
            wni_lon: -68.38,
            wni_tz: 'America/Kralendijk',
        },
        {
            option: 'KRLND',
            wni_port_name: 'KRALENDIJK',
            wni_unlocode: 'BQKRA',
            wni_country: 'BQ',
            wni_lat: 12.17,
            wni_lon: -68.28,
            wni_tz: 'America/Kralendijk',
        },
        {
            option: 'ACJ',
            wni_port_name: 'ARACAJU',
            wni_unlocode: 'BRAJU',
            wni_country: 'BR',
            wni_lat: -10.92,
            wni_lon: -37.05,
            wni_tz: 'America/Maceio',
        },
        {
            option: 'ALGRE',
            wni_port_name: 'PORTO ALEGRE',
            wni_unlocode: 'BRPOA',
            wni_country: 'BR',
            wni_lat: -30.03,
            wni_lon: -51.23,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'ANTO',
            wni_port_name: 'ANTONINA',
            wni_unlocode: 'BRANT',
            wni_country: 'BR',
            wni_lat: -25.43,
            wni_lon: -48.7,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'ARB',
            wni_port_name: 'AREIA BRANCA',
            wni_unlocode: 'BRARE',
            wni_country: 'BR',
            wni_lat: -4.96,
            wni_lon: -37.14,
            wni_tz: 'America/Fortaleza',
        },
        {
            option: 'AUR',
            wni_port_name: 'ALUMAR',
            wni_unlocode: 'BRALU',
            wni_country: 'BR',
            wni_lat: -2.68,
            wni_lon: -44.36,
            wni_tz: 'America/Fortaleza',
        },
        {
            option: 'BREV',
            wni_port_name: 'BREVES',
            wni_unlocode: 'BRBVS',
            wni_country: 'BR',
            wni_lat: -1.68,
            wni_lon: -50.48,
            wni_tz: 'America/Belem',
        },
        {
            option: 'CFT',
            wni_port_name: 'CABO FRIO',
            wni_unlocode: 'BRQCK',
            wni_country: 'BR',
            wni_lat: -22.88,
            wni_lon: -42,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'LGNA',
            wni_port_name: 'LAGUNA',
            wni_unlocode: 'PHLGU',
            wni_country: 'BR',
            wni_lat: -28.5,
            wni_lon: -48.78,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'MCE',
            wni_port_name: 'MACAE',
            wni_unlocode: 'BRMEA',
            wni_country: 'BR',
            wni_lat: -22.37,
            wni_lon: -41.77,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'NAL',
            wni_port_name: 'NATAL',
            wni_unlocode: 'BRNAT',
            wni_country: 'BR',
            wni_lat: -5.78,
            wni_lon: -35.2,
            wni_tz: 'America/Fortaleza',
        },
        {
            option: 'NTR',
            wni_port_name: 'NITEROI',
            wni_unlocode: 'BRNTR',
            wni_country: 'BR',
            wni_lat: -22.88,
            wni_lon: -43.12,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'OBD',
            wni_port_name: 'OBIDOS',
            wni_unlocode: 'BROBI',
            wni_country: 'BR',
            wni_lat: -1.92,
            wni_lon: -55.52,
            wni_tz: 'America/Santarem',
        },
        {
            option: 'PLTS',
            wni_port_name: 'PELOTAS',
            wni_unlocode: 'BRPET',
            wni_country: 'BR',
            wni_lat: -31.78,
            wni_lon: -52.33,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'SEP',
            wni_port_name: 'SEPETIBA',
            wni_unlocode: 'BRSPB',
            wni_country: 'BR',
            wni_lat: -23.02,
            wni_lon: -44.03,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'AGT',
            wni_port_name: 'ARGENTIA',
            wni_unlocode: 'CANWP',
            wni_country: 'CA',
            wni_lat: 47.3,
            wni_lon: -53.98,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'AMHBG',
            wni_port_name: 'AMHERSTBURG',
            wni_unlocode: 'CAAMH',
            wni_country: 'CA',
            wni_lat: 42.1,
            wni_lon: -83.1,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'ARCHT',
            wni_port_name: 'ARICHAT',
            wni_unlocode: 'CAARI',
            wni_country: 'CA',
            wni_lat: 45.52,
            wni_lon: -61.02,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'BATHC',
            wni_port_name: 'BATH',
            wni_unlocode: 'CABTH',
            wni_country: 'CA',
            wni_lat: 44.18,
            wni_lon: -76.77,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'BDDCK',
            wni_port_name: 'BADDECK',
            wni_unlocode: 'CABAD',
            wni_country: 'CA',
            wni_lat: 46.1,
            wni_lon: -60.75,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'BELL',
            wni_port_name: 'BELLA COOLA',
            wni_unlocode: 'CABLC',
            wni_country: 'CA',
            wni_lat: 52.38,
            wni_lon: -126.77,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'BLIND',
            wni_port_name: 'BLIND RIVER',
            wni_unlocode: 'CABLR',
            wni_country: 'CA',
            wni_lat: 46.18,
            wni_lon: -82.95,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'BMBRT',
            wni_port_name: 'BAMBERTON',
            wni_unlocode: 'CABAM',
            wni_country: 'CA',
            wni_lat: 48.55,
            wni_lon: -123.52,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'BRGE',
            wni_port_name: 'BURGEO',
            wni_unlocode: 'CABUO',
            wni_country: 'CA',
            wni_lat: 47.6,
            wni_lon: -57.62,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'BTHN',
            wni_port_name: 'BATHURST',
            wni_unlocode: 'CABAT',
            wni_country: 'CA',
            wni_lat: 47.62,
            wni_lon: -65.65,
            wni_tz: 'America/Moncton',
        },
        {
            option: 'BWR',
            wni_port_name: 'BRIDGEWATER',
            wni_unlocode: 'CABRW',
            wni_country: 'CA',
            wni_lat: 44.38,
            wni_lon: -64.52,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'CARBR',
            wni_port_name: 'CARBONEAR',
            wni_unlocode: 'CACRB',
            wni_country: 'CA',
            wni_lat: 47.73,
            wni_lon: -53.22,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'CBGC',
            wni_port_name: 'CAMBRIDGE BAY',
            wni_unlocode: 'CAYCB',
            wni_country: 'CA',
            wni_lat: 69.12,
            wni_lon: -105.07,
            wni_tz: 'America/Cambridge_Bay',
        },
        {
            option: 'CCU',
            wni_port_name: 'CACOUNA',
            wni_unlocode: 'CAGCA',
            wni_country: 'CA',
            wni_lat: 47.93,
            wni_lon: -69.51,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'CDL',
            wni_port_name: 'CHANDLER',
            wni_unlocode: 'CACHR',
            wni_country: 'CA',
            wni_lat: 48.37,
            wni_lon: -64.67,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'CGWD',
            wni_port_name: 'COLLINGWOOD',
            wni_unlocode: 'CACOL',
            wni_country: 'CA',
            wni_lat: 44.5,
            wni_lon: -80.23,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'CHAN',
            wni_port_name: 'CHATHAM',
            wni_unlocode: 'CACHN',
            wni_country: 'CA',
            wni_lat: 47.03,
            wni_lon: -65.47,
            wni_tz: 'America/Moncton',
        },
        {
            option: 'CHCTM',
            wni_port_name: 'CHICOUTIMI',
            wni_unlocode: 'CACHI',
            wni_country: 'CA',
            wni_lat: 48.43,
            wni_lon: -71.07,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'CLRKS',
            wni_port_name: 'CLARKSON',
            wni_unlocode: 'CACSN',
            wni_country: 'CA',
            wni_lat: 43.5,
            wni_lon: -79.6,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'CLT',
            wni_port_name: 'CARLETON',
            wni_unlocode: 'CACLT',
            wni_country: 'CA',
            wni_lat: 48.1,
            wni_lon: -66.11,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'CNW',
            wni_port_name: 'CORNWALL',
            wni_unlocode: 'CACWL',
            wni_country: 'CA',
            wni_lat: 45.02,
            wni_lon: -74.73,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'COMAU',
            wni_port_name: 'BAIE COMEAU',
            wni_unlocode: 'CABCO',
            wni_country: 'CA',
            wni_lat: 49.23,
            wni_lon: -68.13,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'CON',
            wni_port_name: 'CONTRECOEUR',
            wni_unlocode: 'CACOC',
            wni_country: 'CA',
            wni_lat: 45.86,
            wni_lon: -73.24,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'CRDNL',
            wni_port_name: 'CARDINAL',
            wni_unlocode: 'CACDN',
            wni_country: 'CA',
            wni_lat: 44.78,
            wni_lon: -75.38,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'CRM',
            wni_port_name: 'CARMANVILLE',
            wni_unlocode: 'CACMV',
            wni_country: 'CA',
            wni_lat: 49.4,
            wni_lon: -54.28,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'CRQT',
            wni_port_name: 'CARAQUET',
            wni_unlocode: 'CACAQ',
            wni_country: 'CA',
            wni_lat: 47.8,
            wni_lon: -64.93,
            wni_tz: 'America/Moncton',
        },
        {
            option: 'CRTRG',
            wni_port_name: 'COURTRIGHT',
            wni_unlocode: 'CACRR',
            wni_country: 'CA',
            wni_lat: 42.82,
            wni_lon: -82.47,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'CTLNA',
            wni_port_name: 'CATALINA',
            wni_unlocode: 'CACAT',
            wni_country: 'CA',
            wni_lat: 48.5,
            wni_lon: -53.08,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'CTT',
            wni_port_name: 'CHARLOTTETOWN',
            wni_unlocode: 'CACHA',
            wni_country: 'CA',
            wni_lat: 46.23,
            wni_lon: -63.13,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'CVL',
            wni_port_name: 'CLARENVILLE',
            wni_unlocode: 'CACLE',
            wni_country: 'CA',
            wni_lat: 48.15,
            wni_lon: -53.95,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'DIG',
            wni_port_name: 'DIGBY',
            wni_unlocode: 'CADIG',
            wni_country: 'CA',
            wni_lat: 44.62,
            wni_lon: -65.77,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'DNS',
            wni_port_name: 'DARTMOUTH',
            wni_unlocode: 'CADAR',
            wni_country: 'CA',
            wni_lat: 44.67,
            wni_lon: -63.59,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'DUC',
            wni_port_name: 'DUNCAN BAY',
            wni_unlocode: 'CADCN',
            wni_country: 'CA',
            wni_lat: 50.07,
            wni_lon: -125.28,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'FRSTV',
            wni_port_name: 'FORESTVILLE',
            wni_unlocode: 'CAFRV',
            wni_country: 'CA',
            wni_lat: 48.73,
            wni_lon: -69.07,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'GODRH',
            wni_port_name: 'GODERICH',
            wni_unlocode: 'CAGOH',
            wni_country: 'CA',
            wni_lat: 43.75,
            wni_lon: -81.73,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'GPE',
            wni_port_name: 'GEORGETOWN',
            wni_unlocode: 'CAGGW',
            wni_country: 'CA',
            wni_lat: 46.18,
            wni_lon: -62.53,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'GRNDC',
            wni_port_name: 'GRAND BANK',
            wni_unlocode: 'CAGRB',
            wni_country: 'CA',
            wni_lat: 47.1,
            wni_lon: -55.75,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'HANS',
            wni_port_name: 'HANTSPORT',
            wni_unlocode: 'CAHPT',
            wni_country: 'CA',
            wni_lat: 45.06,
            wni_lon: -64.19,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'HGR',
            wni_port_name: 'HARBOUR GRACE',
            wni_unlocode: 'CAHRE',
            wni_country: 'CA',
            wni_lat: 47.68,
            wni_lon: -53.22,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'HOPC',
            wni_port_name: 'PORT HOPE',
            wni_unlocode: 'CAOPE',
            wni_country: 'CA',
            wni_lat: 43.93,
            wni_lon: -78.28,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'HRONC',
            wni_port_name: 'HERON BAY',
            wni_unlocode: 'CAHBY',
            wni_country: 'CA',
            wni_lat: 48.65,
            wni_lon: -86.32,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'ILS',
            wni_port_name: 'ILES DE LA MADELEINE',
            wni_unlocode: 'CAYGR',
            wni_country: 'CA',
            wni_lat: 47.38,
            wni_lon: -61.86,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'IOCO',
            wni_port_name: 'IOCO',
            wni_unlocode: 'CAIOC',
            wni_country: 'CA',
            wni_lat: 49.3,
            wni_lon: -122.88,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'ION',
            wni_port_name: 'IONA',
            wni_unlocode: 'CAION',
            wni_country: 'CA',
            wni_lat: 45.96,
            wni_lon: -60.8,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'KNGSV',
            wni_port_name: 'KINGSVILLE',
            wni_unlocode: 'CAKVL',
            wni_country: 'CA',
            wni_lat: 42.02,
            wni_lon: -82.73,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'KNGTG',
            wni_port_name: 'KINGSTON',
            wni_unlocode: 'CAKIN',
            wni_country: 'CA',
            wni_lat: 44.23,
            wni_lon: -76.5,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'LAO',
            wni_port_name: 'LANORAIE',
            wni_unlocode: 'CALRI',
            wni_country: 'CA',
            wni_lat: 45.96,
            wni_lon: -73.22,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'LCKPR',
            wni_port_name: 'LOCKEPORT',
            wni_unlocode: 'CALCP',
            wni_country: 'CA',
            wni_lat: 43.7,
            wni_lon: -65.12,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'LDY',
            wni_port_name: 'LADYSMITH',
            wni_unlocode: 'CALAD',
            wni_country: 'CA',
            wni_lat: 48.98,
            wni_lon: -123.78,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'LEW',
            wni_port_name: 'LEWISPORTE',
            wni_unlocode: 'CALWP',
            wni_country: 'CA',
            wni_lat: 49.25,
            wni_lon: -55.05,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'LHA',
            wni_port_name: 'LONG HARBOUR',
            wni_unlocode: 'CALOH',
            wni_country: 'CA',
            wni_lat: 47.42,
            wni_lon: -53.82,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'LMNGT',
            wni_port_name: 'LEAMINGTON',
            wni_unlocode: 'CALMN',
            wni_country: 'CA',
            wni_lat: 42.03,
            wni_lon: -82.6,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'LNNBR',
            wni_port_name: 'LUNENBURG',
            wni_unlocode: 'CALUN',
            wni_country: 'CA',
            wni_lat: 44.38,
            wni_lon: -64.32,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'LVP',
            wni_port_name: 'LIVERPOOL',
            wni_unlocode: 'CALIV',
            wni_country: 'CA',
            wni_lat: 44.03,
            wni_lon: -64.65,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'MCHPC',
            wni_port_name: 'MICHIPICOTEN',
            wni_unlocode: 'CAMIH',
            wni_country: 'CA',
            wni_lat: 47.97,
            wni_lon: -84.9,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'MCNLL',
            wni_port_name: 'PORT MCNEILL',
            wni_unlocode: 'CAPMA',
            wni_country: 'CA',
            wni_lat: 50.58,
            wni_lon: -127.08,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'MDDC',
            wni_port_name: 'MIDLAND',
            wni_unlocode: 'CAMID',
            wni_country: 'CA',
            wni_lat: 44.75,
            wni_lon: -79.92,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'MLDRM',
            wni_port_name: 'MELDRUM BAY',
            wni_unlocode: 'CAMDB',
            wni_country: 'CA',
            wni_lat: 45.93,
            wni_lon: -83.12,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'MRS',
            wni_port_name: 'MARYSTOWN',
            wni_unlocode: 'CAMTN',
            wni_country: 'CA',
            wni_lat: 47.17,
            wni_lon: -55.16,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'MRTWN',
            wni_port_name: 'MOORETOWN',
            wni_unlocode: 'CAMRW',
            wni_country: 'CA',
            wni_lat: 42.83,
            wni_lon: -82.47,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'MSSSS',
            wni_port_name: 'MISSISSAUGA',
            wni_unlocode: 'CAMIS',
            wni_country: 'CA',
            wni_lat: 43.55,
            wni_lon: -79.57,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'MUL',
            wni_port_name: 'MULGRAVE',
            wni_unlocode: 'CAMUL',
            wni_country: 'CA',
            wni_lat: 45.61,
            wni_lon: -61.39,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'NAIN',
            wni_port_name: 'NAIN',
            wni_unlocode: 'CANAI',
            wni_country: 'CA',
            wni_lat: 56.55,
            wni_lon: -61.68,
            wni_tz: 'America/Goose_Bay',
        },
        {
            option: 'NCB',
            wni_port_name: 'NEWCASTLE',
            wni_unlocode: 'CANCT',
            wni_country: 'CA',
            wni_lat: 47,
            wni_lon: -65.57,
            wni_tz: 'America/Moncton',
        },
        {
            option: 'NSDYC',
            wni_port_name: 'NORTH SYDNEY',
            wni_unlocode: 'CANSY',
            wni_country: 'CA',
            wni_lat: 46.22,
            wni_lon: -60.25,
            wni_tz: 'America/Glace_Bay',
        },
        {
            option: 'NTT',
            wni_port_name: 'NEPTUNE TERMINAL',
            wni_unlocode: 'CANEP',
            wni_country: 'CA',
            wni_lat: 49.31,
            wni_lon: -123.06,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'OCF',
            wni_port_name: 'OCEAN FALLS',
            wni_unlocode: 'CAOFA',
            wni_country: 'CA',
            wni_lat: 52.35,
            wni_lon: -127.68,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'OKV',
            wni_port_name: 'OAKVILLE',
            wni_unlocode: 'CAOAK',
            wni_country: 'CA',
            wni_lat: 43.43,
            wni_lon: -79.67,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'ONG',
            wni_port_name: 'LONG POND',
            wni_unlocode: 'CALOP',
            wni_country: 'CA',
            wni_lat: 47.52,
            wni_lon: -52.96,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'OSH',
            wni_port_name: 'OSHAWA',
            wni_unlocode: 'CAOSH',
            wni_country: 'CA',
            wni_lat: 43.87,
            wni_lon: -78.82,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'OWNCA',
            wni_port_name: 'OWEN SOUND',
            wni_unlocode: 'CAOWS',
            wni_country: 'CA',
            wni_lat: 44.58,
            wni_lon: -80.93,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'PAC',
            wni_port_name: 'PORT ALICE',
            wni_unlocode: 'CAPAC',
            wni_country: 'CA',
            wni_lat: 50.38,
            wni_lon: -127.45,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'PBR',
            wni_port_name: 'PARRSBORO',
            wni_unlocode: 'CAPAR',
            wni_country: 'CA',
            wni_lat: 45.4,
            wni_lon: -64.33,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'PCOL',
            wni_port_name: 'PORT COLBORNE',
            wni_unlocode: 'CAPCO',
            wni_country: 'CA',
            wni_lat: 42.88,
            wni_lon: -79.25,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'PCTN',
            wni_port_name: 'PICTON',
            wni_unlocode: 'CAPIC',
            wni_country: 'CA',
            wni_lat: 44.02,
            wni_lon: -77.13,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'PIU',
            wni_port_name: 'PICTOU',
            wni_unlocode: 'CAPTO',
            wni_country: 'CA',
            wni_lat: 45.67,
            wni_lon: -62.72,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'PNTAG',
            wni_port_name: 'PENETANGUISHENE',
            wni_unlocode: 'CAPTH',
            wni_country: 'CA',
            wni_lat: 44.77,
            wni_lon: -79.93,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'POW',
            wni_port_name: 'POWELL RIVER',
            wni_unlocode: 'CAPOW',
            wni_country: 'CA',
            wni_lat: 49.87,
            wni_lon: -124.55,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'PRRY',
            wni_port_name: 'PARRY SOUND',
            wni_unlocode: 'CAPRS',
            wni_country: 'CA',
            wni_lat: 45.33,
            wni_lon: -80.03,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'PSCTT',
            wni_port_name: 'PRESCOTT',
            wni_unlocode: 'CAPRE',
            wni_country: 'CA',
            wni_lat: 44.7,
            wni_lon: -75.52,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'PSPBC',
            wni_port_name: 'PASPEBIAC',
            wni_unlocode: 'CAPAS',
            wni_country: 'CA',
            wni_lat: 48.03,
            wni_lon: -65.25,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'PTH',
            wni_port_name: 'PORT HARDY',
            wni_unlocode: 'CAPHY',
            wni_country: 'CA',
            wni_lat: 50.72,
            wni_lon: -127.48,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'PUGW',
            wni_port_name: 'PUGWASH',
            wni_unlocode: 'CAPUG',
            wni_country: 'CA',
            wni_lat: 45.85,
            wni_lon: -63.67,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'PXB',
            wni_port_name: 'PORT AUX BASQUES',
            wni_unlocode: 'CAPBQ',
            wni_country: 'CA',
            wni_lat: 47.57,
            wni_lon: -59.13,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'QUE',
            wni_port_name: 'QUEBEC',
            wni_unlocode: 'CAQUE',
            wni_country: 'CA',
            wni_lat: 46.82,
            wni_lon: -71.22,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'RCH',
            wni_port_name: 'RICHMOND',
            wni_unlocode: 'CARBC',
            wni_country: 'CA',
            wni_lat: 49.2,
            wni_lon: -123.13,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'RCHBC',
            wni_port_name: 'RICHIBUCTO',
            wni_unlocode: 'CARBT',
            wni_country: 'CA',
            wni_lat: 46.68,
            wni_lon: -64.87,
            wni_tz: 'America/Moncton',
        },
        {
            option: 'RIM',
            wni_port_name: 'RIMOUSKI',
            wni_unlocode: 'CARIM',
            wni_country: 'CA',
            wni_lat: 48.45,
            wni_lon: -68.52,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'ROBT',
            wni_port_name: 'BAY ROBERTS',
            wni_unlocode: 'CABYR',
            wni_country: 'CA',
            wni_lat: 47.58,
            wni_lon: -53.27,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'SATN',
            wni_port_name: 'ST ANTHONY',
            wni_unlocode: 'CASAT',
            wni_country: 'CA',
            wni_lat: 51.37,
            wni_lon: -55.58,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'SDYCA',
            wni_port_name: 'SYDNEY',
            wni_unlocode: 'CASYD',
            wni_country: 'CA',
            wni_lat: 46.15,
            wni_lon: -60.2,
            wni_tz: 'America/Goose_Bay',
        },
        {
            option: 'SGDLE',
            wni_port_name: 'SPRINGDALE',
            wni_unlocode: 'CASPD',
            wni_country: 'CA',
            wni_lat: 49.5,
            wni_lon: -56.07,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'SHDC',
            wni_port_name: 'SHEDIAC',
            wni_unlocode: 'CASHE',
            wni_country: 'CA',
            wni_lat: 46.22,
            wni_lon: -64.55,
            wni_tz: 'America/Moncton',
        },
        {
            option: 'SHP',
            wni_port_name: 'SHIPPEGAN',
            wni_unlocode: 'CASHP',
            wni_country: 'CA',
            wni_lat: 47.75,
            wni_lon: -64.7,
            wni_tz: 'America/Moncton',
        },
        {
            option: 'SHRN',
            wni_port_name: 'SHELBURNE',
            wni_unlocode: 'CASBU',
            wni_country: 'CA',
            wni_lat: 43.75,
            wni_lon: -65.32,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'SMBRA',
            wni_port_name: 'SOMBRA',
            wni_unlocode: 'CASOM',
            wni_country: 'CA',
            wni_lat: 42.72,
            wni_lon: -82.48,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'SMS',
            wni_port_name: 'SUMMERSIDE',
            wni_unlocode: 'CASUM',
            wni_country: 'CA',
            wni_lat: 46.4,
            wni_lon: -63.78,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'SND',
            wni_port_name: 'ST ANDREWS',
            wni_unlocode: 'CASAD',
            wni_country: 'CA',
            wni_lat: 45.07,
            wni_lon: -67.05,
            wni_tz: 'America/Moncton',
        },
        {
            option: 'SOS',
            wni_port_name: 'SOURIS',
            wni_unlocode: 'CASOU',
            wni_country: 'CA',
            wni_lat: 46.35,
            wni_lon: -62.25,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'SPV',
            wni_port_name: 'STEPHENVILLE',
            wni_unlocode: 'CASTV',
            wni_country: 'CA',
            wni_lat: 48.52,
            wni_lon: -58.53,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'SRN',
            wni_port_name: 'SARNIA',
            wni_unlocode: 'CASNI',
            wni_country: 'CA',
            wni_lat: 42.98,
            wni_lon: -82.42,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'STNLY',
            wni_port_name: 'PORT STANLEY',
            wni_unlocode: 'CAPST',
            wni_country: 'CA',
            wni_lat: 42.67,
            wni_lon: -81.2,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'TDSSC',
            wni_port_name: 'TADOUSSAC',
            wni_unlocode: 'CATAD',
            wni_country: 'CA',
            wni_lat: 48.15,
            wni_lon: -69.72,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'THB',
            wni_port_name: 'THUNDER BAY',
            wni_unlocode: 'CATHU',
            wni_country: 'CA',
            wni_lat: 48.41,
            wni_lon: -89.22,
            wni_tz: 'America/Thunder_Bay',
        },
        {
            option: 'THO',
            wni_port_name: 'THOROLD',
            wni_unlocode: 'CATHD',
            wni_country: 'CA',
            wni_lat: 43.08,
            wni_lon: -79.72,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'THS',
            wni_port_name: 'TAHSIS',
            wni_unlocode: 'CAPTA',
            wni_country: 'CA',
            wni_lat: 49.92,
            wni_lon: -126.67,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'THSSL',
            wni_port_name: 'THESSALON',
            wni_unlocode: 'CATHS',
            wni_country: 'CA',
            wni_lat: 46.25,
            wni_lon: -83.57,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'TUKT',
            wni_port_name: 'TUKTOYAKTUK',
            wni_unlocode: 'CATUK',
            wni_country: 'CA',
            wni_lat: 69.45,
            wni_lon: -133,
            wni_tz: 'America/Inuvik',
        },
        {
            option: 'TWLG',
            wni_port_name: 'TWILLINGATE',
            wni_unlocode: 'CATWI',
            wni_country: 'CA',
            wni_lat: 49.67,
            wni_lon: -54.77,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'VLF',
            wni_port_name: 'VALLEYFIELD',
            wni_unlocode: 'CAVLF',
            wni_country: 'CA',
            wni_lat: 45.26,
            wni_lon: -74.13,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'WEY',
            wni_port_name: 'WEYMOUTH',
            wni_unlocode: 'CAWEY',
            wni_country: 'CA',
            wni_lat: 44.39,
            wni_lon: -65.99,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'WIF',
            wni_port_name: 'WHIFFEN HEAD',
            wni_unlocode: 'CAWHH',
            wni_country: 'CA',
            wni_lat: 47.8,
            wni_lon: -54.01,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'WLLD',
            wni_port_name: 'WELLAND',
            wni_unlocode: 'CAWEL',
            wni_country: 'CA',
            wni_lat: 43,
            wni_lon: -79.25,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'WLLR',
            wni_port_name: 'PORT WELLER',
            wni_unlocode: 'CAPWE',
            wni_country: 'CA',
            wni_lat: 43.23,
            wni_lon: -79.22,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'WNDSR',
            wni_port_name: 'WINDSOR',
            wni_unlocode: 'CAWND',
            wni_country: 'CA',
            wni_lat: 42.32,
            wni_lon: -83.03,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'YAR',
            wni_port_name: 'YARMOUTH',
            wni_unlocode: 'CAYRH',
            wni_country: 'CA',
            wni_lat: 43.83,
            wni_lon: -66.12,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'MNDA',
            wni_port_name: 'MOANDA',
            wni_unlocode: 'CDMNB',
            wni_country: 'CD',
            wni_lat: -6,
            wni_lon: 12.4,
            wni_tz: 'Africa/Kinshasa',
        },
        {
            option: 'BOUET',
            wni_port_name: 'PORT BOUET',
            wni_unlocode: 'CIPBT',
            wni_country: 'CI',
            wni_lat: 5.23,
            wni_lon: -3.97,
            wni_tz: 'Africa/Abidjan',
        },
        {
            option: 'SPD',
            wni_port_name: 'SAN PEDRO',
            wni_unlocode: 'CISPY',
            wni_country: 'CI',
            wni_lat: 4.73,
            wni_lon: -6.62,
            wni_tz: 'Africa/Abidjan',
        },
        {
            option: 'AVAT',
            wni_port_name: 'AVATIU',
            wni_unlocode: 'CKRAR',
            wni_country: 'CK',
            wni_lat: -21.2,
            wni_lon: -159.78,
            wni_tz: 'Pacific/Rarotonga',
        },
        {
            option: 'ACD',
            wni_port_name: 'ANCUD',
            wni_unlocode: 'CLZUD',
            wni_country: 'CL',
            wni_lat: -41.87,
            wni_lon: -73.83,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'CLAR',
            wni_port_name: 'CALETA CLARENCIA',
            wni_unlocode: 'CLCLR',
            wni_country: 'CL',
            wni_lat: -52.9,
            wni_lon: -70.1,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'HUP',
            wni_port_name: 'HUACHIPATO',
            wni_unlocode: 'CLHPO',
            wni_country: 'CL',
            wni_lat: -36.73,
            wni_lon: -73.13,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'LOTA',
            wni_port_name: 'LOTA',
            wni_unlocode: 'CLLTA',
            wni_country: 'CL',
            wni_lat: -37.1,
            wni_lon: -73.15,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'PEO',
            wni_port_name: 'PENCO',
            wni_unlocode: 'CLPEO',
            wni_country: 'CL',
            wni_lat: -36.72,
            wni_lon: -73,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'PWMS',
            wni_port_name: 'PUERTO WILLIAMS',
            wni_unlocode: 'CLWPU',
            wni_country: 'CL',
            wni_lat: -54.93,
            wni_lon: -67.62,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'VAC',
            wni_port_name: 'VALDIVIA',
            wni_unlocode: 'CLZAL',
            wni_country: 'CL',
            wni_lat: -39.8,
            wni_lon: -73.25,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'LMBE',
            wni_port_name: 'LIMBE',
            wni_unlocode: 'CMLIM',
            wni_country: 'CM',
            wni_lat: 4.02,
            wni_lon: 9.2,
            wni_tz: 'Africa/Douala',
        },
        {
            option: 'TIKO',
            wni_port_name: 'TIKO',
            wni_unlocode: 'CMTKC',
            wni_country: 'CM',
            wni_lat: 4.07,
            wni_lon: 9.37,
            wni_tz: 'Africa/Douala',
        },
        {
            option: 'ANQNG',
            wni_port_name: 'ANQING',
            wni_unlocode: 'CNAQG',
            wni_country: 'CN',
            wni_lat: 30.52,
            wni_lon: 117.03,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'CHF',
            wni_port_name: 'CHEFOO',
            wni_unlocode: 'CNYAN',
            wni_country: 'CN',
            wni_lat: 37.6,
            wni_lon: 121.4,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'CXI',
            wni_port_name: 'CHENGXI',
            wni_unlocode: 'CNSGH',
            wni_country: 'CN',
            wni_lat: 31.35,
            wni_lon: 121.64,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'DGNG',
            wni_port_name: 'DIGANG',
            wni_unlocode: 'CNDIA',
            wni_country: 'CN',
            wni_lat: 31.08,
            wni_lon: 117.93,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'GGANG',
            wni_port_name: 'GAOGANG',
            wni_unlocode: 'CNGAO',
            wni_country: 'CN',
            wni_lat: 32.28,
            wni_lon: 119.85,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'JIAM',
            wni_port_name: 'JIANGMEN',
            wni_unlocode: 'CNJMN',
            wni_country: 'CN',
            wni_lat: 22.58,
            wni_lon: 113.09,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'JJNG',
            wni_port_name: 'JIUJIANG',
            wni_unlocode: 'CNJIU',
            wni_country: 'CN',
            wni_lat: 29.72,
            wni_lon: 115.98,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'MAW',
            wni_port_name: 'MAWEI',
            wni_unlocode: 'CNMAW',
            wni_country: 'CN',
            wni_lat: 25.98,
            wni_lon: 119.43,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'MMG',
            wni_port_name: 'MAOMING',
            wni_unlocode: 'CNMMI',
            wni_country: 'CN',
            wni_lat: 21.25,
            wni_lon: 111.4,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'SNYA',
            wni_port_name: 'SANYA',
            wni_unlocode: 'CNSYX',
            wni_country: 'CN',
            wni_lat: 18.25,
            wni_lon: 109.49,
            wni_tz: 'Asia/Chongqing',
        },
        {
            option: 'TSN',
            wni_port_name: 'TANGSHAN',
            wni_unlocode: 'CNTGS',
            wni_country: 'CN',
            wni_lat: 39.2,
            wni_lon: 119,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'XIN',
            wni_port_name: 'XINGANG',
            wni_unlocode: 'CNTXG',
            wni_country: 'CN',
            wni_lat: 38.98,
            wni_lon: 117.74,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'ZHU',
            wni_port_name: 'JIUZHOU',
            wni_unlocode: 'CNJZU',
            wni_country: 'CN',
            wni_lat: 22.24,
            wni_lon: 113.58,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'ZPU',
            wni_port_name: 'ZHAPU',
            wni_unlocode: 'CNZPU',
            wni_country: 'CN',
            wni_lat: 30.59,
            wni_lon: 121.09,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'BUV',
            wni_port_name: 'BUENAVENTURA',
            wni_unlocode: 'COBUN',
            wni_country: 'CO',
            wni_lat: 3.9,
            wni_lon: -77.08,
            wni_tz: 'America/Bogota',
        },
        {
            option: 'CIE',
            wni_port_name: 'CIENAGA',
            wni_unlocode: 'COCIE',
            wni_country: 'CO',
            wni_lat: 11.08,
            wni_lon: -74.22,
            wni_tz: 'America/Bogota',
        },
        {
            option: 'PURV',
            wni_port_name: 'PUERTO BOLIVAR',
            wni_unlocode: 'COPBO',
            wni_country: 'CO',
            wni_lat: 12.25,
            wni_lon: -71.97,
            wni_tz: 'America/Bogota',
        },
        {
            option: 'TLU',
            wni_port_name: 'TOLU',
            wni_unlocode: 'COTLU',
            wni_country: 'CO',
            wni_lat: 9.52,
            wni_lon: -75.59,
            wni_tz: 'America/Bogota',
        },
        {
            option: 'TUMC',
            wni_port_name: 'TUMACO',
            wni_unlocode: 'COTCO',
            wni_country: 'CO',
            wni_lat: 1.82,
            wni_lon: -78.75,
            wni_tz: 'America/Bogota',
        },
        {
            option: 'CCR',
            wni_port_name: 'CALDERA',
            wni_unlocode: 'CRCAL',
            wni_country: 'CR',
            wni_lat: 9.93,
            wni_lon: -84.72,
            wni_tz: 'America/Costa_Rica',
        },
        {
            option: 'QEP',
            wni_port_name: 'QUEPOS',
            wni_unlocode: 'CRXQP',
            wni_country: 'CR',
            wni_lat: 9.4,
            wni_lon: -84.17,
            wni_tz: 'America/Costa_Rica',
        },
        {
            option: 'ANL',
            wni_port_name: 'ANTILLA',
            wni_unlocode: 'CUANT',
            wni_country: 'CU',
            wni_lat: 20.83,
            wni_lon: -75.73,
            wni_tz: 'America/Havana',
        },
        {
            option: 'BANES',
            wni_port_name: 'BANES',
            wni_unlocode: 'CUBAN',
            wni_country: 'CU',
            wni_lat: 20.83,
            wni_lon: -75.7,
            wni_tz: 'America/Havana',
        },
        {
            option: 'BRCA',
            wni_port_name: 'BARACOA',
            wni_unlocode: 'CUBCA',
            wni_country: 'CU',
            wni_lat: 20.35,
            wni_lon: -74.5,
            wni_tz: 'America/Havana',
        },
        {
            option: 'CBNS',
            wni_port_name: 'CABANAS',
            wni_unlocode: 'CUCAB',
            wni_country: 'CU',
            wni_lat: 23,
            wni_lon: -82.97,
            wni_tz: 'America/Havana',
        },
        {
            option: 'CBRN',
            wni_port_name: 'CAIBARIEN',
            wni_unlocode: 'CUCAI',
            wni_country: 'CU',
            wni_lat: 22.53,
            wni_lon: -79.47,
            wni_tz: 'America/Havana',
        },
        {
            option: 'CCH',
            wni_port_name: 'CEIBA HUECA',
            wni_unlocode: 'CUCEI',
            wni_country: 'CU',
            wni_lat: 20.22,
            wni_lon: -77.33,
            wni_tz: 'America/Havana',
        },
        {
            option: 'CSLD',
            wni_port_name: 'CASILDA',
            wni_unlocode: 'CUCAS',
            wni_country: 'CU',
            wni_lat: 21.75,
            wni_lon: -79.98,
            wni_tz: 'America/Havana',
        },
        {
            option: 'GRNN',
            wni_port_name: 'NUEVA GERONA',
            wni_unlocode: 'CUGER',
            wni_country: 'CU',
            wni_lat: 21.88,
            wni_lon: -82.8,
            wni_tz: 'America/Havana',
        },
        {
            option: 'GYB',
            wni_port_name: 'GUAYABAL',
            wni_unlocode: 'CUGYB',
            wni_country: 'CU',
            wni_lat: 20.68,
            wni_lon: -77.62,
            wni_tz: 'America/Havana',
        },
        {
            option: 'HOND',
            wni_port_name: 'BAHIA HONDA',
            wni_unlocode: 'CUBHO',
            wni_country: 'CU',
            wni_lat: 22.97,
            wni_lon: -83.17,
            wni_tz: 'America/Havana',
        },
        {
            option: 'JUCA',
            wni_port_name: 'JUCARO',
            wni_unlocode: 'CUJUC',
            wni_country: 'CU',
            wni_lat: 21.62,
            wni_lon: -78.85,
            wni_tz: 'America/Havana',
        },
        {
            option: 'MANC',
            wni_port_name: 'MANZANILLO',
            wni_unlocode: 'CUMZO',
            wni_country: 'CU',
            wni_lat: 20.35,
            wni_lon: -77.12,
            wni_tz: 'America/Havana',
        },
        {
            option: 'MOAC',
            wni_port_name: 'MOA',
            wni_unlocode: 'CUMOA',
            wni_country: 'CU',
            wni_lat: 20.66,
            wni_lon: -74.91,
            wni_tz: 'America/Havana',
        },
        {
            option: 'MTZC',
            wni_port_name: 'MATANZAS',
            wni_unlocode: 'CUQMA',
            wni_country: 'CU',
            wni_lat: 23.05,
            wni_lon: -81.58,
            wni_tz: 'America/Havana',
        },
        {
            option: 'NICRO',
            wni_port_name: 'NICARO',
            wni_unlocode: 'CUICR',
            wni_country: 'CU',
            wni_lat: 20.72,
            wni_lon: -75.55,
            wni_tz: 'America/Havana',
        },
        {
            option: 'NVS',
            wni_port_name: 'NUEVITAS',
            wni_unlocode: 'CUNVT',
            wni_country: 'CU',
            wni_lat: 21.55,
            wni_lon: -77.27,
            wni_tz: 'America/Havana',
        },
        {
            option: 'PALA',
            wni_port_name: 'PALO ALTO',
            wni_unlocode: 'CUPAL',
            wni_country: 'CU',
            wni_lat: 21.6,
            wni_lon: -78.97,
            wni_tz: 'America/Havana',
        },
        {
            option: 'PPD',
            wni_port_name: 'PUERTO PADRE',
            wni_unlocode: 'CUPPA',
            wni_country: 'CU',
            wni_lat: 21.2,
            wni_lon: -76.6,
            wni_tz: 'America/Havana',
        },
        {
            option: 'PSTON',
            wni_port_name: 'PRESTON',
            wni_unlocode: 'CUPST',
            wni_country: 'CU',
            wni_lat: 20.77,
            wni_lon: -75.65,
            wni_tz: 'America/Havana',
        },
        {
            option: 'SCDS',
            wni_port_name: 'SANTA CRUZ DEL SUR',
            wni_unlocode: 'CUSCS',
            wni_country: 'CU',
            wni_lat: 20.7,
            wni_lon: -77.98,
            wni_tz: 'America/Havana',
        },
        {
            option: 'ZAZA',
            wni_port_name: 'TUNAS DE ZAZA',
            wni_unlocode: 'CUTDZ',
            wni_country: 'CU',
            wni_lat: 21.63,
            wni_lon: -79.55,
            wni_tz: 'America/Havana',
        },
        {
            option: 'MND',
            wni_port_name: 'MINDELO',
            wni_unlocode: 'CVMIN',
            wni_country: 'CV',
            wni_lat: 16.89,
            wni_lon: -25,
            wni_tz: 'Atlantic/Cape_Verde',
        },
        {
            option: 'EMA',
            wni_port_name: 'EMMASTAD',
            wni_unlocode: 'CWEMM',
            wni_country: 'CW',
            wni_lat: 12.12,
            wni_lon: -68.92,
            wni_tz: 'America/Curacao',
        },
        {
            option: 'FAM',
            wni_port_name: 'FAMAGUSTA',
            wni_unlocode: 'CYFMG',
            wni_country: 'CY',
            wni_lat: 35.12,
            wni_lon: 33.93,
            wni_tz: 'Asia/Nicosia',
        },
        {
            option: 'KYRN',
            wni_port_name: 'KYRENIA',
            wni_unlocode: 'CYKYR',
            wni_country: 'CY',
            wni_lat: 35.33,
            wni_lon: 33.32,
            wni_tz: 'Asia/Nicosia',
        },
        {
            option: 'PPHS',
            wni_port_name: 'PAPHOS',
            wni_unlocode: 'CYPFO',
            wni_country: 'CY',
            wni_lat: 34.75,
            wni_lon: 32.42,
            wni_tz: 'Asia/Nicosia',
        },
        {
            option: 'VAS',
            wni_port_name: 'VASSILIKO',
            wni_unlocode: 'CYVAS',
            wni_country: 'CY',
            wni_lat: 34.7,
            wni_lon: 33.3,
            wni_tz: 'Asia/Nicosia',
        },
        {
            option: 'XEROS',
            wni_port_name: 'XEROS',
            wni_unlocode: 'CYZER',
            wni_country: 'CY',
            wni_lat: 35.13,
            wni_lon: 32.83,
            wni_tz: 'Asia/Nicosia',
        },
        {
            option: 'ECKRN',
            wni_port_name: 'ECKERNFORDE',
            wni_unlocode: 'DEECK',
            wni_country: 'DE',
            wni_lat: 54.48,
            wni_lon: 9.83,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'ELSFL',
            wni_port_name: 'ELSFLETH',
            wni_unlocode: 'DEELS',
            wni_country: 'DE',
            wni_lat: 53.23,
            wni_lon: 8.47,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'FLN',
            wni_port_name: 'FLENSBURG',
            wni_unlocode: 'DEFLF',
            wni_country: 'DE',
            wni_lat: 54.8,
            wni_lon: 9.43,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'GUC',
            wni_port_name: 'GLUCKSTADT',
            wni_unlocode: 'DEGLU',
            wni_country: 'DE',
            wni_lat: 53.78,
            wni_lon: 9.42,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'HBURG',
            wni_port_name: 'HARBURG',
            wni_unlocode: 'DEHBU',
            wni_country: 'DE',
            wni_lat: 53.47,
            wni_lon: 9.98,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'HLGLN',
            wni_port_name: 'HELGOLAND',
            wni_unlocode: 'DEHGL',
            wni_country: 'DE',
            wni_lat: 54.18,
            wni_lon: 7.88,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'HLGNH',
            wni_port_name: 'HEILIGENHAFEN',
            wni_unlocode: 'DEHHF',
            wni_country: 'DE',
            wni_lat: 54.37,
            wni_lon: 10.98,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'HLT',
            wni_port_name: 'HOLTENAU',
            wni_unlocode: 'DEKCH',
            wni_country: 'DE',
            wni_lat: 54.36,
            wni_lon: 10.15,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'HUSUM',
            wni_port_name: 'HUSUM',
            wni_unlocode: 'DEHUS',
            wni_country: 'DE',
            wni_lat: 54.48,
            wni_lon: 9.05,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'KPPLN',
            wni_port_name: 'KAPPELN',
            wni_unlocode: 'DEKAP',
            wni_country: 'DE',
            wni_lat: 54.67,
            wni_lon: 9.93,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'LEER',
            wni_port_name: 'LEER',
            wni_unlocode: 'DELEE',
            wni_country: 'DE',
            wni_lat: 53.23,
            wni_lon: 7.45,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'LUB',
            wni_port_name: 'LUBECK',
            wni_unlocode: 'DELBC',
            wni_country: 'DE',
            wni_lat: 53.87,
            wni_lon: 10.68,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'MUKR',
            wni_port_name: 'MUKRAN',
            wni_unlocode: 'DEMUK',
            wni_country: 'DE',
            wni_lat: 54.48,
            wni_lon: 13.59,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'NHOLS',
            wni_port_name: 'NEUSTADT',
            wni_unlocode: 'DENHO',
            wni_country: 'DE',
            wni_lat: 54.1,
            wni_lon: 10.82,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'OLDNB',
            wni_port_name: 'OLDENBURG',
            wni_unlocode: 'DEOLO',
            wni_country: 'DE',
            wni_lat: 53.12,
            wni_lon: 8.22,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'PABG',
            wni_port_name: 'PAPENBURG',
            wni_unlocode: 'DEPAP',
            wni_country: 'DE',
            wni_lat: 53.1,
            wni_lon: 7.38,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'REN',
            wni_port_name: 'RENDSBURG',
            wni_unlocode: 'DEREN',
            wni_country: 'DE',
            wni_lat: 54.3,
            wni_lon: 9.68,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'SCHLS',
            wni_port_name: 'SCHLESWIG',
            wni_unlocode: 'DESLS',
            wni_country: 'DE',
            wni_lat: 54.52,
            wni_lon: 9.57,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'SSSNT',
            wni_port_name: 'SASSNITZ',
            wni_unlocode: 'DESAS',
            wni_country: 'DE',
            wni_lat: 54.52,
            wni_lon: 13.65,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'STRLS',
            wni_port_name: 'STRALSUND',
            wni_unlocode: 'DESTL',
            wni_country: 'DE',
            wni_lat: 54.32,
            wni_lon: 13.1,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'TRVMN',
            wni_port_name: 'TRAVEMUNDE',
            wni_unlocode: 'DETRV',
            wni_country: 'DE',
            wni_lat: 53.97,
            wni_lon: 10.88,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'WLGST',
            wni_port_name: 'WOLGAST',
            wni_unlocode: 'DEWOL',
            wni_country: 'DE',
            wni_lat: 54.05,
            wni_lon: 13.78,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'WRNMN',
            wni_port_name: 'WARNEMUNDE',
            wni_unlocode: 'DEWAR',
            wni_country: 'DE',
            wni_lat: 54.18,
            wni_lon: 12.1,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'WSM',
            wni_port_name: 'WISMAR',
            wni_unlocode: 'DEWIS',
            wni_country: 'DE',
            wni_lat: 53.9,
            wni_lon: 11.47,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'DJ',
            wni_port_name: 'DJIBOUTI',
            wni_unlocode: 'DJJIB',
            wni_country: 'DJ',
            wni_lat: 11.6,
            wni_lon: 43.13,
            wni_tz: 'Africa/Djibouti',
        },
        {
            option: 'AAL',
            wni_port_name: 'AALBORG',
            wni_unlocode: 'DKAAL',
            wni_country: 'DK',
            wni_lat: 57.05,
            wni_lon: 9.93,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'AAS',
            wni_port_name: 'AARHUS',
            wni_unlocode: 'DKAAR',
            wni_country: 'DK',
            wni_lat: 56.15,
            wni_lon: 10.22,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'ALLGE',
            wni_port_name: 'ALLINGE',
            wni_unlocode: 'DKAGE',
            wni_country: 'DK',
            wni_lat: 55.28,
            wni_lon: 14.8,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'ARSKB',
            wni_port_name: 'AEROSKOBING',
            wni_unlocode: 'DKARK',
            wni_country: 'DK',
            wni_lat: 54.88,
            wni_lon: 10.42,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'ASE',
            wni_port_name: 'ASSENS',
            wni_unlocode: 'DKASN',
            wni_country: 'DK',
            wni_lat: 55.27,
            wni_lon: 9.88,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'BDHLM',
            wni_port_name: 'BANDHOLM',
            wni_unlocode: 'DKBDX',
            wni_country: 'DK',
            wni_lat: 54.83,
            wni_lon: 11.5,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'FRDRD',
            wni_port_name: 'FREDERIKSSUND',
            wni_unlocode: 'DKFDS',
            wni_country: 'DK',
            wni_lat: 55.83,
            wni_lon: 12.05,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'FRK',
            wni_port_name: 'FREDERIKSHAVN',
            wni_unlocode: 'DKFDH',
            wni_country: 'DK',
            wni_lat: 57.43,
            wni_lon: 10.55,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'FRKVK',
            wni_port_name: 'FREDERIKSVAERK',
            wni_unlocode: 'DKFDV',
            wni_country: 'DK',
            wni_lat: 55.97,
            wni_lon: 12.02,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'GED',
            wni_port_name: 'GEDSER',
            wni_unlocode: 'DKGED',
            wni_country: 'DK',
            wni_lat: 54.57,
            wni_lon: 11.93,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'GLF',
            wni_port_name: 'GULFHAVN',
            wni_unlocode: 'DKGFH',
            wni_country: 'DK',
            wni_lat: 55.2,
            wni_lon: 11.24,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'HASLE',
            wni_port_name: 'HASLE',
            wni_unlocode: 'DKHSL',
            wni_country: 'DK',
            wni_lat: 55.18,
            wni_lon: 14.7,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'HDD',
            wni_port_name: 'HUNDESTED',
            wni_unlocode: 'DKHUN',
            wni_country: 'DK',
            wni_lat: 55.97,
            wni_lon: 11.85,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'HDSLV',
            wni_port_name: 'HADERSLEV',
            wni_unlocode: 'DKHAD',
            wni_country: 'DK',
            wni_lat: 55.25,
            wni_lon: 9.5,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'HDSND',
            wni_port_name: 'HADSUND',
            wni_unlocode: 'DKHSU',
            wni_country: 'DK',
            wni_lat: 56.72,
            wni_lon: 10.12,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'HLBK',
            wni_port_name: 'HOLBAEK',
            wni_unlocode: 'DKHBK',
            wni_country: 'DK',
            wni_lat: 55.72,
            wni_lon: 11.72,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'HLSNG',
            wni_port_name: 'HELSINGOR',
            wni_unlocode: 'DKHLS',
            wni_country: 'DK',
            wni_lat: 56.03,
            wni_lon: 12.62,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'HOBRO',
            wni_port_name: 'HOBRO',
            wni_unlocode: 'DKHBO',
            wni_country: 'DK',
            wni_lat: 56.63,
            wni_lon: 9.8,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'HRS',
            wni_port_name: 'HORSENS',
            wni_unlocode: 'DKHOR',
            wni_country: 'DK',
            wni_lat: 55.87,
            wni_lon: 9.85,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'KLDNG',
            wni_port_name: 'KOLDING',
            wni_unlocode: 'DKKOL',
            wni_country: 'DK',
            wni_lat: 55.48,
            wni_lon: 9.5,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'KOGDK',
            wni_port_name: 'KOGE',
            wni_unlocode: 'DKKOG',
            wni_country: 'DK',
            wni_lat: 55.45,
            wni_lon: 12.2,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'KRE',
            wni_port_name: 'KERTEMINDE',
            wni_unlocode: 'DKKTD',
            wni_country: 'DK',
            wni_lat: 55.45,
            wni_lon: 10.67,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'KSTRP',
            wni_port_name: 'KASTRUP',
            wni_unlocode: 'DKKTP',
            wni_country: 'DK',
            wni_lat: 55.63,
            wni_lon: 12.65,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'LDPLD',
            wni_port_name: 'FAKSE LADEPLADS',
            wni_unlocode: 'DKFAK',
            wni_country: 'DK',
            wni_lat: 55.22,
            wni_lon: 12.17,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'LMVG',
            wni_port_name: 'LEMVIG',
            wni_unlocode: 'DKLVG',
            wni_country: 'DK',
            wni_lat: 56.55,
            wni_lon: 8.32,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'MARGR',
            wni_port_name: 'MARIAGER',
            wni_unlocode: 'DKMRR',
            wni_country: 'DK',
            wni_lat: 56.65,
            wni_lon: 9.98,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'MDDLF',
            wni_port_name: 'MIDDLEFART',
            wni_unlocode: 'DKMID',
            wni_country: 'DK',
            wni_lat: 55.5,
            wni_lon: 9.73,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'MRSTL',
            wni_port_name: 'MARSTAL',
            wni_unlocode: 'DKMRS',
            wni_country: 'DK',
            wni_lat: 54.85,
            wni_lon: 10.52,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'NBY',
            wni_port_name: 'NORRESUNDBY',
            wni_unlocode: 'DKNRS',
            wni_country: 'DK',
            wni_lat: 57.06,
            wni_lon: 9.92,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'NEK',
            wni_port_name: 'NEKSO',
            wni_unlocode: 'DKNEX',
            wni_country: 'DK',
            wni_lat: 55.07,
            wni_lon: 15.13,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'NSKV',
            wni_port_name: 'NAKSKOV',
            wni_unlocode: 'DKNAK',
            wni_country: 'DK',
            wni_lat: 54.83,
            wni_lon: 11.13,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'NSTVD',
            wni_port_name: 'NAESTVED',
            wni_unlocode: 'DKNVD',
            wni_country: 'DK',
            wni_lat: 55.23,
            wni_lon: 11.75,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'NYB',
            wni_port_name: 'NYBORG',
            wni_unlocode: 'DKNBG',
            wni_country: 'DK',
            wni_lat: 55.32,
            wni_lon: 10.8,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'NYKBG',
            wni_port_name: 'NYKOBING',
            wni_unlocode: 'DKNYS',
            wni_country: 'DK',
            wni_lat: 55.92,
            wni_lon: 11.68,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'NYKBN1',
            wni_port_name: 'NYKOBING',
            wni_unlocode: 'DKNYF',
            wni_country: 'DK',
            wni_lat: 54.77,
            wni_lon: 11.87,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'RDKBN',
            wni_port_name: 'RUDKOBING',
            wni_unlocode: 'DKRKB',
            wni_country: 'DK',
            wni_lat: 54.93,
            wni_lon: 10.72,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'RKBNG',
            wni_port_name: 'RINGKOBING',
            wni_unlocode: 'DKRKG',
            wni_country: 'DK',
            wni_lat: 56.08,
            wni_lon: 8.25,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'RNDRS',
            wni_port_name: 'RANDERS',
            wni_unlocode: 'DKRAN',
            wni_country: 'DK',
            wni_lat: 56.47,
            wni_lon: 10.05,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'RONNE',
            wni_port_name: 'RONNE',
            wni_unlocode: 'DKRNN',
            wni_country: 'DK',
            wni_lat: 55.1,
            wni_lon: 14.7,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'SDB',
            wni_port_name: 'SONDERBORG',
            wni_unlocode: 'DKSGD',
            wni_country: 'DK',
            wni_lat: 54.92,
            wni_lon: 9.78,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'SDS',
            wni_port_name: 'STUDSTRUP',
            wni_unlocode: 'DKSSV',
            wni_country: 'DK',
            wni_lat: 56.25,
            wni_lon: 10.35,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'SKIVE',
            wni_port_name: 'SKIVE',
            wni_unlocode: 'DKSKV',
            wni_country: 'DK',
            wni_lat: 56.55,
            wni_lon: 9.07,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'SKLSK',
            wni_port_name: 'SKAELSKOR',
            wni_unlocode: 'DKSSK',
            wni_country: 'DK',
            wni_lat: 55.25,
            wni_lon: 11.3,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'STBBK',
            wni_port_name: 'STUBBEKOBING',
            wni_unlocode: 'DKSBK',
            wni_country: 'DK',
            wni_lat: 54.88,
            wni_lon: 12.05,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'STEGE',
            wni_port_name: 'STEGE',
            wni_unlocode: 'DKSTE',
            wni_country: 'DK',
            wni_lat: 54.98,
            wni_lon: 12.28,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'SVNDB',
            wni_port_name: 'SVENDBORG',
            wni_unlocode: 'DKSVE',
            wni_country: 'DK',
            wni_lat: 55.07,
            wni_lon: 10.62,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'SVNKE',
            wni_port_name: 'SVANEKE',
            wni_unlocode: 'DKSVA',
            wni_country: 'DK',
            wni_lat: 55.13,
            wni_lon: 15.15,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'THSTD',
            wni_port_name: 'THISTED',
            wni_unlocode: 'DKTED',
            wni_country: 'DK',
            wni_lat: 56.95,
            wni_lon: 8.7,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'THYBR',
            wni_port_name: 'THYBORON',
            wni_unlocode: 'DKTHN',
            wni_country: 'DK',
            wni_lat: 56.7,
            wni_lon: 8.22,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'VEJLE',
            wni_port_name: 'VEJLE',
            wni_unlocode: 'DKVEJ',
            wni_country: 'DK',
            wni_lat: 55.72,
            wni_lon: 9.55,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'VRDNG',
            wni_port_name: 'VORDINGBORG',
            wni_unlocode: 'DKVOR',
            wni_country: 'DK',
            wni_lat: 55,
            wni_lon: 11.9,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'POTSM',
            wni_port_name: 'PORTSMOUTH',
            wni_unlocode: 'DMPOR',
            wni_country: 'DM',
            wni_lat: 15.57,
            wni_lon: -61.47,
            wni_tz: 'America/Dominica',
        },
        {
            option: 'BOC',
            wni_port_name: 'BOCA CHICA',
            wni_unlocode: 'DOBCC',
            wni_country: 'DO',
            wni_lat: 18.44,
            wni_lon: -69.61,
            wni_tz: 'America/Santo_Domingo',
        },
        {
            option: 'CRJ',
            wni_port_name: 'CABO ROJO',
            wni_unlocode: 'DOCBJ',
            wni_country: 'DO',
            wni_lat: 17.92,
            wni_lon: -71.65,
            wni_tz: 'America/Santo_Domingo',
        },
        {
            option: 'MAND',
            wni_port_name: 'MANZANILLO',
            wni_unlocode: 'DOMAN',
            wni_country: 'DO',
            wni_lat: 19.71,
            wni_lon: -71.74,
            wni_tz: 'America/Santo_Domingo',
        },
        {
            option: 'SNCHZ',
            wni_port_name: 'SANCHEZ',
            wni_unlocode: 'DOSNZ',
            wni_country: 'DO',
            wni_lat: 19.23,
            wni_lon: -69.62,
            wni_tz: 'America/Santo_Domingo',
        },
        {
            option: 'BENI',
            wni_port_name: 'BENI SAF',
            wni_unlocode: 'DZBSF',
            wni_country: 'DZ',
            wni_lat: 35.3,
            wni_lon: -1.38,
            wni_tz: 'Africa/Algiers',
        },
        {
            option: 'CCHEL',
            wni_port_name: 'CHERCHEL',
            wni_unlocode: 'DZCHE',
            wni_country: 'DZ',
            wni_lat: 36.62,
            wni_lon: 2.18,
            wni_tz: 'Africa/Algiers',
        },
        {
            option: 'COLLO',
            wni_port_name: 'COLLO',
            wni_unlocode: 'DZCOL',
            wni_country: 'DZ',
            wni_lat: 37.02,
            wni_lon: 6.58,
            wni_tz: 'Africa/Algiers',
        },
        {
            option: 'DLLYS',
            wni_port_name: 'DELLYS',
            wni_unlocode: 'DZDEL',
            wni_country: 'DZ',
            wni_lat: 36.92,
            wni_lon: 3.92,
            wni_tz: 'Africa/Algiers',
        },
        {
            option: 'GAZ',
            wni_port_name: 'GHAZAOUET',
            wni_unlocode: 'DZGHA',
            wni_country: 'DZ',
            wni_lat: 35.1,
            wni_lon: -1.85,
            wni_tz: 'Africa/Algiers',
        },
        {
            option: 'JIJ',
            wni_port_name: 'JIJEL',
            wni_unlocode: 'DZDJI',
            wni_country: 'DZ',
            wni_lat: 36.83,
            wni_lon: 5.78,
            wni_tz: 'Africa/Algiers',
        },
        {
            option: 'TEA',
            wni_port_name: 'TENES',
            wni_unlocode: 'DZTEN',
            wni_country: 'DZ',
            wni_lat: 36.53,
            wni_lon: 1.32,
            wni_tz: 'Africa/Algiers',
        },
        {
            option: 'BAO',
            wni_port_name: 'BALAO TERMINAL',
            wni_unlocode: 'ECEBL',
            wni_country: 'EC',
            wni_lat: 1.06,
            wni_lon: -79.72,
            wni_tz: 'America/Guayaquil',
        },
        {
            option: 'CRQZ',
            wni_port_name: 'BAHIA DE CARAQUEZ',
            wni_unlocode: 'ECBHA',
            wni_country: 'EC',
            wni_lat: 0.58,
            wni_lon: -80.42,
            wni_tz: 'America/Guayaquil',
        },
        {
            option: 'ESSM',
            wni_port_name: 'ESMERALDAS',
            wni_unlocode: 'ECESM',
            wni_country: 'EC',
            wni_lat: 1,
            wni_lon: -79.65,
            wni_tz: 'America/Guayaquil',
        },
        {
            option: 'HLTRM',
            wni_port_name: 'HELTERMAA',
            wni_unlocode: 'EEHLT',
            wni_country: 'EE',
            wni_lat: 58.87,
            wni_lon: 23,
            wni_tz: 'Europe/Tallinn',
        },
        {
            option: 'KPLI',
            wni_port_name: 'KOPLI',
            wni_unlocode: 'EETLL',
            wni_country: 'EE',
            wni_lat: 59.45,
            wni_lon: 24.66,
            wni_tz: 'Europe/Tallinn',
        },
        {
            option: 'KUNDA',
            wni_port_name: 'KUNDA',
            wni_unlocode: 'EEKND',
            wni_country: 'EE',
            wni_lat: 59.52,
            wni_lon: 26.55,
            wni_tz: 'Europe/Tallinn',
        },
        {
            option: 'PARNU',
            wni_port_name: 'PARNU',
            wni_unlocode: 'EEPRN',
            wni_country: 'EE',
            wni_lat: 58.38,
            wni_lon: 24.5,
            wni_tz: 'Europe/Tallinn',
        },
        {
            option: 'ABK',
            wni_port_name: 'ABU QIR',
            wni_unlocode: 'EGAKI',
            wni_country: 'EG',
            wni_lat: 31.32,
            wni_lon: 30.07,
            wni_tz: 'Africa/Cairo',
        },
        {
            option: 'GESUM',
            wni_port_name: 'GEISUM',
            wni_unlocode: 'EGGEI',
            wni_country: 'EG',
            wni_lat: 27.8,
            wni_lon: 33.72,
            wni_tz: 'Africa/Cairo',
        },
        {
            option: 'MTRH',
            wni_port_name: 'MATRUH',
            wni_unlocode: 'EGMMU',
            wni_country: 'EG',
            wni_lat: 31.37,
            wni_lon: 27.23,
            wni_tz: 'Africa/Cairo',
        },
        {
            option: 'SKR',
            wni_port_name: 'SIDI KERIR',
            wni_unlocode: 'EGSKT',
            wni_country: 'EG',
            wni_lat: 31.1,
            wni_lon: 29.62,
            wni_tz: 'Africa/Cairo',
        },
        {
            option: 'ZEIT',
            wni_port_name: 'ZEIT BAY TERMINAL',
            wni_unlocode: 'EGZTB',
            wni_country: 'EG',
            wni_lat: 27.85,
            wni_lon: 33.6,
            wni_tz: 'Africa/Cairo',
        },
        {
            option: 'DKHL',
            wni_port_name: 'DAKHLA',
            wni_unlocode: 'EHVIC',
            wni_country: 'EH',
            wni_lat: 23.7,
            wni_lon: -15.92,
            wni_tz: 'Africa/El_Aaiun',
        },
        {
            option: 'ADRA',
            wni_port_name: 'ADRA',
            wni_unlocode: 'ESADR',
            wni_country: 'ES',
            wni_lat: 36.75,
            wni_lon: -3.02,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'AGU',
            wni_port_name: 'AGUILAS',
            wni_unlocode: 'EWNIU',
            wni_country: 'ES',
            wni_lat: 37.4,
            wni_lon: -1.57,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'AMR',
            wni_port_name: 'ALMERIA',
            wni_unlocode: 'ESLEI',
            wni_country: 'ES',
            wni_lat: 36.83,
            wni_lon: -2.47,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'ARGN',
            wni_port_name: 'ARGUINEGUIN',
            wni_unlocode: 'ESARI',
            wni_country: 'ES',
            wni_lat: 27.76,
            wni_lon: -15.68,
            wni_tz: 'Atlantic/Canary',
        },
        {
            option: 'BMO',
            wni_port_name: 'BERMEO',
            wni_unlocode: 'ESBRM',
            wni_country: 'ES',
            wni_lat: 43.42,
            wni_lon: -2.72,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'BRRN',
            wni_port_name: 'BURRIANA',
            wni_unlocode: 'ESBRX',
            wni_country: 'ES',
            wni_lat: 39.88,
            wni_lon: -0.05,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'DEA',
            wni_port_name: 'DENIA',
            wni_unlocode: 'ESDNA',
            wni_country: 'ES',
            wni_lat: 38.87,
            wni_lon: 0.12,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'ESCO',
            wni_port_name: 'ESCOMBRERAS',
            wni_unlocode: 'ESESC',
            wni_country: 'ES',
            wni_lat: 37.57,
            wni_lon: -0.95,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'GAN',
            wni_port_name: 'GANDIA',
            wni_unlocode: 'ESGAN',
            wni_country: 'ES',
            wni_lat: 39,
            wni_lon: -0.15,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'GXLS',
            wni_port_name: 'SAN FELIU DE GUIXOLS',
            wni_unlocode: 'ESSFU',
            wni_country: 'ES',
            wni_lat: 41.78,
            wni_lon: 3.03,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'MLG',
            wni_port_name: 'MALAGA',
            wni_unlocode: 'EWNIP',
            wni_country: 'ES',
            wni_lat: 36.72,
            wni_lon: -4.42,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'MUROS',
            wni_port_name: 'MUROS',
            wni_unlocode: 'ESMRS',
            wni_country: 'ES',
            wni_lat: 42.78,
            wni_lon: -9.05,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'PRD',
            wni_port_name: 'PUERTO DE SANTA MARIA',
            wni_unlocode: 'ESPSM',
            wni_country: 'ES',
            wni_lat: 36.6,
            wni_lon: -6.23,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'RBD',
            wni_port_name: 'RIBADEO',
            wni_unlocode: 'ESRIB',
            wni_country: 'ES',
            wni_lat: 43.53,
            wni_lon: -7.03,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'ROSES',
            wni_port_name: 'ROSAS',
            wni_unlocode: 'ESROS',
            wni_country: 'ES',
            wni_lat: 42.27,
            wni_lon: 3.18,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'RSR',
            wni_port_name: 'PUERTO DEL ROSARIO',
            wni_unlocode: 'ESFVE',
            wni_country: 'ES',
            wni_lat: 28.48,
            wni_lon: -13.85,
            wni_tz: 'Atlantic/Canary',
        },
        {
            option: 'SBSTN',
            wni_port_name: 'SAN SEBASTIAN',
            wni_unlocode: 'ESEAS',
            wni_country: 'ES',
            wni_lat: 43.32,
            wni_lon: -1.98,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'SCLP',
            wni_port_name: 'SANTA CRUZ DE LA PALMA',
            wni_unlocode: 'ESSPC',
            wni_country: 'ES',
            wni_lat: 28.67,
            wni_lon: -17.75,
            wni_tz: 'Atlantic/Canary',
        },
        {
            option: 'TRR',
            wni_port_name: 'TORREVIEJA',
            wni_unlocode: 'ESTOR',
            wni_country: 'ES',
            wni_lat: 37.97,
            wni_lon: -0.68,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'VIV',
            wni_port_name: 'VIVERO',
            wni_unlocode: 'ESVIV',
            wni_country: 'ES',
            wni_lat: 43.67,
            wni_lon: -7.6,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'HANKO',
            wni_port_name: 'HANKO',
            wni_unlocode: 'FIHKO',
            wni_country: 'FI',
            wni_lat: 59.82,
            wni_lon: 22.95,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'HKPDS',
            wni_port_name: 'HAUKIPUDAS',
            wni_unlocode: 'FIHAU',
            wni_country: 'FI',
            wni_lat: 65.18,
            wni_lon: 25.38,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'KEMI',
            wni_port_name: 'KEMI',
            wni_unlocode: 'FIKEM',
            wni_country: 'FI',
            wni_lat: 65.73,
            wni_lon: 24.57,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'KOV',
            wni_port_name: 'KOVERHAR',
            wni_unlocode: 'FIKVH',
            wni_country: 'FI',
            wni_lat: 59.88,
            wni_lon: 23.22,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'KSK',
            wni_port_name: 'KASKO',
            wni_unlocode: 'FIKAS',
            wni_country: 'FI',
            wni_lat: 62.38,
            wni_lon: 21.23,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'KTE',
            wni_port_name: 'KRISTINESTAD',
            wni_unlocode: 'FIKRS',
            wni_country: 'FI',
            wni_lat: 62.28,
            wni_lon: 21.4,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'KVK',
            wni_port_name: 'KANTVIK',
            wni_unlocode: 'FIKNT',
            wni_country: 'FI',
            wni_lat: 60.08,
            wni_lon: 24.38,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'LOV',
            wni_port_name: 'LOVIISA',
            wni_unlocode: 'FILOV',
            wni_country: 'FI',
            wni_lat: 60.45,
            wni_lon: 26.23,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'NAA',
            wni_port_name: 'NAANTALI',
            wni_unlocode: 'FINLI',
            wni_country: 'FI',
            wni_lat: 60.47,
            wni_lon: 22.02,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'PRGS',
            wni_port_name: 'PARGAS',
            wni_unlocode: 'FIPAR',
            wni_country: 'FI',
            wni_lat: 60.28,
            wni_lon: 22.3,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'PTAR',
            wni_port_name: 'PIETARSAARI',
            wni_unlocode: 'FIPRS',
            wni_country: 'FI',
            wni_lat: 63.68,
            wni_lon: 22.67,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'PTNM',
            wni_port_name: 'PATENIEMI',
            wni_unlocode: 'FIPNI',
            wni_country: 'FI',
            wni_lat: 65.1,
            wni_lon: 25.38,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'ROY',
            wni_port_name: 'ROYTTA',
            wni_unlocode: 'FIROY',
            wni_country: 'FI',
            wni_lat: 65.77,
            wni_lon: 24.17,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'ROY1',
            wni_port_name: 'ROYTTA',
            wni_unlocode: 'FIROY',
            wni_country: 'FI',
            wni_lat: 65.27,
            wni_lon: 25.2,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'RPSR',
            wni_port_name: 'REPOSAARI',
            wni_unlocode: 'FIREP',
            wni_country: 'FI',
            wni_lat: 61.62,
            wni_lon: 21.45,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'TKL',
            wni_port_name: 'TAHKOLUOTO',
            wni_unlocode: 'FITHK',
            wni_country: 'FI',
            wni_lat: 61.63,
            wni_lon: 21.4,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'TMMSR',
            wni_port_name: 'TAMMISAARI',
            wni_unlocode: 'FITAI',
            wni_country: 'FI',
            wni_lat: 59.98,
            wni_lon: 23.43,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'UUSN',
            wni_port_name: 'UUSIKAUPUNKI',
            wni_unlocode: 'FIUKI',
            wni_country: 'FI',
            wni_lat: 60.8,
            wni_lon: 21.4,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'VAASA',
            wni_port_name: 'VAASA',
            wni_unlocode: 'FIVAA',
            wni_country: 'FI',
            wni_lat: 63.08,
            wni_lon: 21.58,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'VLK',
            wni_port_name: 'VALKOM',
            wni_unlocode: 'FIVKO',
            wni_country: 'FI',
            wni_lat: 60.41,
            wni_lon: 26.26,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'VTSLT',
            wni_port_name: 'VEITSILUOTO',
            wni_unlocode: 'FIVEI',
            wni_country: 'FI',
            wni_lat: 65.7,
            wni_lon: 24.62,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'LABA',
            wni_port_name: 'LABASA',
            wni_unlocode: 'FJLBS',
            wni_country: 'FJ',
            wni_lat: -16.47,
            wni_lon: 179.34,
            wni_tz: 'Pacific/Fiji',
        },
        {
            option: 'LVK',
            wni_port_name: 'LEVUKA',
            wni_unlocode: 'FJLEV',
            wni_country: 'FJ',
            wni_lat: -17.68,
            wni_lon: 178.83,
            wni_tz: 'Pacific/Fiji',
        },
        {
            option: 'MLU',
            wni_port_name: 'MALAU',
            wni_unlocode: 'FJMAL',
            wni_country: 'FJ',
            wni_lat: -16.43,
            wni_lon: 179.37,
            wni_tz: 'Pacific/Fiji',
        },
        {
            option: 'STAN',
            wni_port_name: 'STANLEY',
            wni_unlocode: 'FKPSY',
            wni_country: 'FK',
            wni_lat: -51.7,
            wni_lon: -57.83,
            wni_tz: 'Atlantic/Stanley',
        },
        {
            option: 'KFD',
            wni_port_name: 'KOLLAFJORDUR',
            wni_unlocode: 'FOKOL',
            wni_country: 'FO',
            wni_lat: 62.12,
            wni_lon: -6.9,
            wni_tz: 'Atlantic/Faroe',
        },
        {
            option: 'KLA',
            wni_port_name: 'KLAKSVIK',
            wni_unlocode: 'FOKVI',
            wni_country: 'FO',
            wni_lat: 62.23,
            wni_lon: -6.58,
            wni_tz: 'Atlantic/Faroe',
        },
        {
            option: 'RUNA',
            wni_port_name: 'RUNAVIK',
            wni_unlocode: 'FORVK',
            wni_country: 'FO',
            wni_lat: 62.11,
            wni_lon: -6.73,
            wni_tz: 'Atlantic/Faroe',
        },
        {
            option: 'TVRYR',
            wni_port_name: 'TVOROYRI',
            wni_unlocode: 'FOTVO',
            wni_country: 'FO',
            wni_lat: 61.55,
            wni_lon: -6.8,
            wni_tz: 'Atlantic/Faroe',
        },
        {
            option: 'VAG',
            wni_port_name: 'VAGUR',
            wni_unlocode: 'FOVAZ',
            wni_country: 'FO',
            wni_lat: 61.48,
            wni_lon: -6.81,
            wni_tz: 'Atlantic/Faroe',
        },
        {
            option: 'AMBES',
            wni_port_name: 'AMBES',
            wni_unlocode: 'FRAMS',
            wni_country: 'FR',
            wni_lat: 45.02,
            wni_lon: -0.53,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'ARCCH',
            wni_port_name: 'ARCACHON',
            wni_unlocode: 'FRARC',
            wni_country: 'FR',
            wni_lat: 44.67,
            wni_lon: -1.17,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'ATB',
            wni_port_name: 'ANTIBES',
            wni_unlocode: 'FRANT',
            wni_country: 'FR',
            wni_lat: 43.58,
            wni_lon: 7.12,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'BASE',
            wni_port_name: 'BASSENS',
            wni_unlocode: 'FRBAS',
            wni_country: 'FR',
            wni_lat: 45.03,
            wni_lon: -0.58,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'BASSE',
            wni_port_name: 'BASSE INDRE',
            wni_unlocode: 'FRBAI',
            wni_country: 'FR',
            wni_lat: 47.27,
            wni_lon: -1.62,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'BLY',
            wni_port_name: 'BLAYE',
            wni_unlocode: 'FRBYE',
            wni_country: 'FR',
            wni_lat: 45.13,
            wni_lon: -0.67,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'BNF',
            wni_port_name: 'BONIFACIO',
            wni_unlocode: 'FRBON',
            wni_country: 'FR',
            wni_lat: 41.38,
            wni_lon: 9.15,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'BOL',
            wni_port_name: 'BOULOGNE',
            wni_unlocode: 'FRBOL',
            wni_country: 'FR',
            wni_lat: 50.73,
            wni_lon: 1.6,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'CALVI',
            wni_port_name: 'CALVI',
            wni_unlocode: 'FRCLY',
            wni_country: 'FR',
            wni_lat: 42.57,
            wni_lon: 8.77,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'CNCRN',
            wni_port_name: 'CONCARNEAU',
            wni_unlocode: 'FRCOC',
            wni_country: 'FR',
            wni_lat: 47.87,
            wni_lon: -3.92,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'CNE',
            wni_port_name: 'CAEN',
            wni_unlocode: 'FRCFR',
            wni_country: 'FR',
            wni_lat: 49.18,
            wni_lon: -0.35,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'CORD',
            wni_port_name: 'CORDEMAIS',
            wni_unlocode: 'FRCXY',
            wni_country: 'FR',
            wni_lat: 47.28,
            wni_lon: -1.88,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'COTAT',
            wni_port_name: 'LA CIOTAT',
            wni_unlocode: 'FRLCT',
            wni_country: 'FR',
            wni_lat: 43.17,
            wni_lon: 5.62,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'CTE',
            wni_port_name: 'CARONTE',
            wni_unlocode: 'FRCOZ',
            wni_country: 'FR',
            wni_lat: 43.34,
            wni_lon: 5.34,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'FCMP',
            wni_port_name: 'FECAMP',
            wni_unlocode: 'FRFEC',
            wni_country: 'FR',
            wni_lat: 49.77,
            wni_lon: 0.37,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'GON',
            wni_port_name: 'GONFREVILLE',
            wni_unlocode: 'FRGLO',
            wni_country: 'FR',
            wni_lat: 49.5,
            wni_lon: 0.23,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'GRNV',
            wni_port_name: 'GRANVILLE',
            wni_unlocode: 'FRGFR',
            wni_country: 'FR',
            wni_lat: 48.83,
            wni_lon: -1.6,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'GRVLS',
            wni_port_name: 'GRAVELINES',
            wni_unlocode: 'FRGRV',
            wni_country: 'FR',
            wni_lat: 51,
            wni_lon: 2.12,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'HNF',
            wni_port_name: 'HONFLEUR',
            wni_unlocode: 'FRHON',
            wni_country: 'FR',
            wni_lat: 49.42,
            wni_lon: 0.22,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'LAR',
            wni_port_name: 'LA ROCHELLE',
            wni_unlocode: 'FRLRH',
            wni_country: 'FR',
            wni_lat: 46.15,
            wni_lon: -1.15,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'LEGUE',
            wni_port_name: 'LE LEGUE',
            wni_unlocode: 'FRSBK',
            wni_country: 'FR',
            wni_lat: 48.53,
            wni_lon: -2.75,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'LET',
            wni_port_name: 'LE TRAIT',
            wni_unlocode: 'FRLTT',
            wni_country: 'FR',
            wni_lat: 49.48,
            wni_lon: 0.8,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'LSY',
            wni_port_name: 'LA SEYNE',
            wni_unlocode: 'FRTLN',
            wni_country: 'FR',
            wni_lat: 43.11,
            wni_lon: 5.91,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'LTP',
            wni_port_name: 'LE TREPORT',
            wni_unlocode: 'FRLTR',
            wni_country: 'FR',
            wni_lat: 50.07,
            wni_lon: 1.37,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'LVR',
            wni_port_name: 'LE VERDON',
            wni_unlocode: 'FRLVE',
            wni_country: 'FR',
            wni_lat: 45.55,
            wni_lon: -1.05,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'MRLX',
            wni_port_name: 'MORLAIX',
            wni_unlocode: 'FRMXN',
            wni_country: 'FR',
            wni_lat: 48.58,
            wni_lon: -3.83,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'OSHAM',
            wni_port_name: 'OUISTREHAM',
            wni_unlocode: 'FROUI',
            wni_country: 'FR',
            wni_lat: 49.28,
            wni_lon: -0.25,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'PLLC',
            wni_port_name: 'PAUILLAC',
            wni_unlocode: 'FRPAP',
            wni_country: 'FR',
            wni_lat: 45.2,
            wni_lon: -0.75,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'PMPL',
            wni_port_name: 'PAIMPOL',
            wni_unlocode: 'FRPAI',
            wni_country: 'FR',
            wni_lat: 48.78,
            wni_lon: -3.05,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'POJ',
            wni_port_name: 'PORT JEROME',
            wni_unlocode: 'FRPJE',
            wni_country: 'FR',
            wni_lat: 49.47,
            wni_lon: 0.54,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'PRPRN',
            wni_port_name: 'PROPRIANO',
            wni_unlocode: 'FRPRP',
            wni_country: 'FR',
            wni_lat: 41.68,
            wni_lon: 8.9,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'PTCR',
            wni_port_name: 'PETIT COURONNE',
            wni_unlocode: 'FRPET',
            wni_country: 'FR',
            wni_lat: 49.38,
            wni_lon: 1.01,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'PVD',
            wni_port_name: 'PORT VENDRES',
            wni_unlocode: 'FRPOV',
            wni_country: 'FR',
            wni_lat: 42.52,
            wni_lon: 3.12,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'RHF',
            wni_port_name: 'ROCHEFORT',
            wni_unlocode: 'FRRCO',
            wni_country: 'FR',
            wni_lat: 45.93,
            wni_lon: -0.95,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'ROF',
            wni_port_name: 'ROSCOFF',
            wni_unlocode: 'FRROS',
            wni_country: 'FR',
            wni_lat: 48.73,
            wni_lon: -3.98,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'STN',
            wni_port_name: 'ST NAZAIRE',
            wni_unlocode: 'FRSNR',
            wni_country: 'FR',
            wni_lat: 47.28,
            wni_lon: -2.2,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'TRGR',
            wni_port_name: 'TREGUIER',
            wni_unlocode: 'FRTRE',
            wni_country: 'FR',
            wni_lat: 48.78,
            wni_lon: -3.23,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'VCCH',
            wni_port_name: 'PORTO VECCHIO',
            wni_unlocode: 'FRPVO',
            wni_country: 'FR',
            wni_lat: 41.58,
            wni_lon: 9.28,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'VNNS',
            wni_port_name: 'VANNES',
            wni_unlocode: 'FRVNE',
            wni_country: 'FR',
            wni_lat: 47.65,
            wni_lon: -2.75,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'OGU',
            wni_port_name: 'OGUENDJO TERMINAL',
            wni_unlocode: 'GAOGU',
            wni_country: 'GA',
            wni_lat: -1.45,
            wni_lon: 8.92,
            wni_tz: 'Africa/Libreville',
        },
        {
            option: 'ABRDV',
            wni_port_name: 'ABERDOVEY',
            wni_unlocode: 'GBABV',
            wni_country: 'GB',
            wni_lat: 52.52,
            wni_lon: -4.05,
            wni_tz: 'Europe/London',
        },
        {
            option: 'ALDRN',
            wni_port_name: 'ALDERNEY',
            wni_unlocode: 'GGACI',
            wni_country: 'GB',
            wni_lat: 49.73,
            wni_lon: -2.2,
            wni_tz: 'Europe/London',
        },
        {
            option: 'ALTB',
            wni_port_name: 'AULTBEA',
            wni_unlocode: 'GBAUL',
            wni_country: 'GB',
            wni_lat: 57.83,
            wni_lon: -5.58,
            wni_tz: 'Europe/London',
        },
        {
            option: 'ARBRT',
            wni_port_name: 'ARBROATH',
            wni_unlocode: 'GBARB',
            wni_country: 'GB',
            wni_lat: 56.55,
            wni_lon: -2.58,
            wni_tz: 'Europe/London',
        },
        {
            option: 'ARDGL',
            wni_port_name: 'ARDGLASS',
            wni_unlocode: 'GBAGL',
            wni_country: 'GB',
            wni_lat: 54.27,
            wni_lon: -5.62,
            wni_tz: 'Europe/London',
        },
        {
            option: 'ARDRG',
            wni_port_name: 'ARDRISHAIG',
            wni_unlocode: 'GBASG',
            wni_country: 'GB',
            wni_lat: 56.02,
            wni_lon: -5.45,
            wni_tz: 'Europe/London',
        },
        {
            option: 'ARDRS',
            wni_port_name: 'ARDROSSAN',
            wni_unlocode: 'GBARD',
            wni_country: 'GB',
            wni_lat: 55.65,
            wni_lon: -4.82,
            wni_tz: 'Europe/London',
        },
        {
            option: 'AYR',
            wni_port_name: 'AYR',
            wni_unlocode: 'GBAYR',
            wni_country: 'GB',
            wni_lat: 55.47,
            wni_lon: -4.63,
            wni_tz: 'Europe/London',
        },
        {
            option: 'BIDFD',
            wni_port_name: 'BIDEFORD',
            wni_unlocode: 'GBBID',
            wni_country: 'GB',
            wni_lat: 51.02,
            wni_lon: -4.2,
            wni_tz: 'Europe/London',
        },
        {
            option: 'BIR',
            wni_port_name: 'BIRKENHEAD',
            wni_unlocode: 'GBBRK',
            wni_country: 'GB',
            wni_lat: 53.4,
            wni_lon: -3.03,
            wni_tz: 'Europe/London',
        },
        {
            option: 'BLH',
            wni_port_name: 'BLYTH',
            wni_unlocode: 'GBBLY',
            wni_country: 'GB',
            wni_lat: 55.12,
            wni_lon: -1.5,
            wni_tz: 'Europe/London',
        },
        {
            option: 'BOWLG',
            wni_port_name: 'BOWLING',
            wni_unlocode: 'GBBOW',
            wni_country: 'GB',
            wni_lat: 55.93,
            wni_lon: -4.48,
            wni_tz: 'Europe/London',
        },
        {
            option: 'BRDGW',
            wni_port_name: 'BRIDGWATER',
            wni_unlocode: 'GBBRW',
            wni_country: 'GB',
            wni_lat: 51.13,
            wni_lon: -3,
            wni_tz: 'Europe/London',
        },
        {
            option: 'BRDLN',
            wni_port_name: 'BRIDLINGTON',
            wni_unlocode: 'GBBRT',
            wni_country: 'GB',
            wni_lat: 54.08,
            wni_lon: -0.18,
            wni_tz: 'Europe/London',
        },
        {
            option: 'BRDPR',
            wni_port_name: 'BRIDPORT',
            wni_unlocode: 'GBBRP',
            wni_country: 'GB',
            wni_lat: 50.72,
            wni_lon: -2.77,
            wni_tz: 'Europe/London',
        },
        {
            option: 'BRGHD',
            wni_port_name: 'BURGHEAD',
            wni_unlocode: 'GBBUH',
            wni_country: 'GB',
            wni_lat: 57.7,
            wni_lon: -3.5,
            wni_tz: 'Europe/London',
        },
        {
            option: 'BRGHT',
            wni_port_name: 'BRIGHTON',
            wni_unlocode: 'GBBSH',
            wni_country: 'GB',
            wni_lat: 50.82,
            wni_lon: -0.12,
            wni_tz: 'Europe/London',
        },
        {
            option: 'BRL',
            wni_port_name: 'BURNTISLAND',
            wni_unlocode: 'GBBTL',
            wni_country: 'GB',
            wni_lat: 56.05,
            wni_lon: -3.23,
            wni_tz: 'Europe/London',
        },
        {
            option: 'BRMTH',
            wni_port_name: 'BARMOUTH',
            wni_unlocode: 'GBBMU',
            wni_country: 'GB',
            wni_lat: 52.72,
            wni_lon: -4.05,
            wni_tz: 'Europe/London',
        },
        {
            option: 'BROM',
            wni_port_name: 'BROMBOROUGH',
            wni_unlocode: 'GBBHK',
            wni_country: 'GB',
            wni_lat: 53.45,
            wni_lon: -3.02,
            wni_tz: 'Europe/London',
        },
        {
            option: 'BRWCK',
            wni_port_name: 'BERWICK',
            wni_unlocode: 'GBBWK',
            wni_country: 'GB',
            wni_lat: 55.77,
            wni_lon: -2,
            wni_tz: 'Europe/London',
        },
        {
            option: 'BUK',
            wni_port_name: 'BARRY',
            wni_unlocode: 'GBBAD',
            wni_country: 'GB',
            wni_lat: 51.4,
            wni_lon: -3.27,
            wni_tz: 'Europe/London',
        },
        {
            option: 'CASLE',
            wni_port_name: 'CASTLE BAY',
            wni_unlocode: 'GBCBA',
            wni_country: 'GB',
            wni_lat: 56.95,
            wni_lon: -7.48,
            wni_tz: 'Europe/London',
        },
        {
            option: 'CCKNZ',
            wni_port_name: 'COCKENZIE',
            wni_unlocode: 'GBCNZ',
            wni_country: 'GB',
            wni_lat: 55.97,
            wni_lon: -2.97,
            wni_tz: 'Europe/London',
        },
        {
            option: 'CEA',
            wni_port_name: 'CREEKSEA',
            wni_unlocode: 'GBCKS',
            wni_country: 'GB',
            wni_lat: 51.79,
            wni_lon: 1.03,
            wni_tz: 'Europe/London',
        },
        {
            option: 'CHAT',
            wni_port_name: 'CHATHAM DOCKS',
            wni_unlocode: 'GBCTM',
            wni_country: 'GB',
            wni_lat: 51.4,
            wni_lon: 0.55,
            wni_tz: 'Europe/London',
        },
        {
            option: 'CLCHS',
            wni_port_name: 'COLCHESTER',
            wni_unlocode: 'GBCOL',
            wni_country: 'GB',
            wni_lat: 51.9,
            wni_lon: 0.92,
            wni_tz: 'Europe/London',
        },
        {
            option: 'CLER',
            wni_port_name: 'COLERAINE',
            wni_unlocode: 'GBCLR',
            wni_country: 'GB',
            wni_lat: 55.13,
            wni_lon: -6.67,
            wni_tz: 'Europe/London',
        },
        {
            option: 'CPBEL',
            wni_port_name: 'CAMPBELTOWN',
            wni_unlocode: 'GBCBT',
            wni_country: 'GB',
            wni_lat: 55.43,
            wni_lon: -5.6,
            wni_tz: 'Europe/London',
        },
        {
            option: 'CRD',
            wni_port_name: 'CARDIFF',
            wni_unlocode: 'GBCDF',
            wni_country: 'GB',
            wni_lat: 51.45,
            wni_lon: -3.17,
            wni_tz: 'Europe/London',
        },
        {
            option: 'CROM',
            wni_port_name: 'CROMARTY',
            wni_unlocode: 'GBCRN',
            wni_country: 'GB',
            wni_lat: 57.68,
            wni_lon: -4.03,
            wni_tz: 'Europe/London',
        },
        {
            option: 'CRPCH',
            wni_port_name: 'CORPACH',
            wni_unlocode: 'GBCOR',
            wni_country: 'GB',
            wni_lat: 56.85,
            wni_lon: -5.12,
            wni_tz: 'Europe/London',
        },
        {
            option: 'CTN',
            wni_port_name: 'CORYTON',
            wni_unlocode: 'GBCOY',
            wni_country: 'GB',
            wni_lat: 51.5,
            wni_lon: 0.53,
            wni_tz: 'Europe/London',
        },
        {
            option: 'DAG',
            wni_port_name: 'DAGENHAM',
            wni_unlocode: 'GBDAG',
            wni_country: 'GB',
            wni_lat: 51.51,
            wni_lon: 0.14,
            wni_tz: 'Europe/London',
        },
        {
            option: 'DDE',
            wni_port_name: 'DUNDEE',
            wni_unlocode: 'GBDUN',
            wni_country: 'GB',
            wni_lat: 56.47,
            wni_lon: -2.97,
            wni_tz: 'Europe/London',
        },
        {
            option: 'DGN',
            wni_port_name: 'DUNGENESS',
            wni_unlocode: 'GBDSS',
            wni_country: 'GB',
            wni_lat: 50.92,
            wni_lon: 0.97,
            wni_tz: 'Europe/London',
        },
        {
            option: 'DNBR',
            wni_port_name: 'DUNBAR',
            wni_unlocode: 'GBDBR',
            wni_country: 'GB',
            wni_lat: 56,
            wni_lon: -2.52,
            wni_tz: 'Europe/London',
        },
        {
            option: 'EAS',
            wni_port_name: 'EASTHAM',
            wni_unlocode: 'GBEAM',
            wni_country: 'GB',
            wni_lat: 53.32,
            wni_lon: -2.95,
            wni_tz: 'Europe/London',
        },
        {
            option: 'EDB',
            wni_port_name: 'EDINBURGH',
            wni_unlocode: 'GBEDI',
            wni_country: 'GB',
            wni_lat: 55.98,
            wni_lon: -3.18,
            wni_tz: 'Europe/London',
        },
        {
            option: 'ELL',
            wni_port_name: 'ELLESMERE PORT',
            wni_unlocode: 'GBELL',
            wni_country: 'GB',
            wni_lat: 53.29,
            wni_lon: -2.89,
            wni_tz: 'Europe/London',
        },
        {
            option: 'ELLEN',
            wni_port_name: 'PORT ELLEN',
            wni_unlocode: 'GBPLN',
            wni_country: 'GB',
            wni_lat: 55.62,
            wni_lon: -6.2,
            wni_tz: 'Europe/London',
        },
        {
            option: 'FLTWD',
            wni_port_name: 'FLEETWOOD',
            wni_unlocode: 'GBFLE',
            wni_country: 'GB',
            wni_lat: 53.92,
            wni_lon: -3.02,
            wni_tz: 'Europe/London',
        },
        {
            option: 'FOW',
            wni_port_name: 'FOWEY',
            wni_unlocode: 'GBFOY',
            wni_country: 'GB',
            wni_lat: 50.33,
            wni_lon: -4.63,
            wni_tz: 'Europe/London',
        },
        {
            option: 'FSHGR',
            wni_port_name: 'FISHGUARD',
            wni_unlocode: 'GBFIS',
            wni_country: 'GB',
            wni_lat: 52.02,
            wni_lon: -4.98,
            wni_tz: 'Europe/London',
        },
        {
            option: 'GEE',
            wni_port_name: 'GREENOCK',
            wni_unlocode: 'GBGRK',
            wni_country: 'GB',
            wni_lat: 55.95,
            wni_lon: -4.75,
            wni_tz: 'Europe/London',
        },
        {
            option: 'GLE',
            wni_port_name: 'GOOLE',
            wni_unlocode: 'GBGOO',
            wni_country: 'GB',
            wni_lat: 53.7,
            wni_lon: -0.87,
            wni_tz: 'Europe/London',
        },
        {
            option: 'GLO',
            wni_port_name: 'GLOUCESTER',
            wni_unlocode: 'GBGLO',
            wni_country: 'GB',
            wni_lat: 51.87,
            wni_lon: -2.25,
            wni_tz: 'Europe/London',
        },
        {
            option: 'GLS',
            wni_port_name: 'GLASGOW',
            wni_unlocode: 'GBGLW',
            wni_country: 'GB',
            wni_lat: 55.87,
            wni_lon: -4.28,
            wni_tz: 'Europe/London',
        },
        {
            option: 'GRCK',
            wni_port_name: 'GOUROCK',
            wni_unlocode: 'GBGUR',
            wni_country: 'GB',
            wni_lat: 55.97,
            wni_lon: -4.8,
            wni_tz: 'Europe/London',
        },
        {
            option: 'GRNTN',
            wni_port_name: 'GRANTON',
            wni_unlocode: 'GBGRN',
            wni_country: 'GB',
            wni_lat: 55.98,
            wni_lon: -3.23,
            wni_tz: 'Europe/London',
        },
        {
            option: 'GRNWH',
            wni_port_name: 'GREENWICH',
            wni_unlocode: 'GBGNW',
            wni_country: 'GB',
            wni_lat: 51.48,
            wni_lon: 0,
            wni_tz: 'Europe/London',
        },
        {
            option: 'GRS',
            wni_port_name: 'GARSTON',
            wni_unlocode: 'GBGTN',
            wni_country: 'GB',
            wni_lat: 53.35,
            wni_lon: -2.9,
            wni_tz: 'Europe/London',
        },
        {
            option: 'GRV',
            wni_port_name: 'GRAVESEND',
            wni_unlocode: 'GBGVS',
            wni_country: 'GB',
            wni_lat: 51.45,
            wni_lon: 0.37,
            wni_tz: 'Europe/London',
        },
        {
            option: 'HBE',
            wni_port_name: 'HAMBLE',
            wni_unlocode: 'GBHAM',
            wni_country: 'GB',
            wni_lat: 50.86,
            wni_lon: -1.3,
            wni_tz: 'Europe/London',
        },
        {
            option: 'HEY',
            wni_port_name: 'HEYSHAM',
            wni_unlocode: 'GBHYM',
            wni_country: 'GB',
            wni_lat: 54.03,
            wni_lon: -2.92,
            wni_tz: 'Europe/London',
        },
        {
            option: 'HLY',
            wni_port_name: 'HOLYHEAD',
            wni_unlocode: 'GBHLY',
            wni_country: 'GB',
            wni_lat: 53.32,
            wni_lon: -4.63,
            wni_tz: 'Europe/London',
        },
        {
            option: 'HRW',
            wni_port_name: 'HARWICH',
            wni_unlocode: 'GBHRW',
            wni_country: 'GB',
            wni_lat: 51.95,
            wni_lon: 1.28,
            wni_tz: 'Europe/London',
        },
        {
            option: 'ING',
            wni_port_name: 'INVERGORDON',
            wni_unlocode: 'GBIVG',
            wni_country: 'GB',
            wni_lat: 57.68,
            wni_lon: -4.17,
            wni_tz: 'Europe/London',
        },
        {
            option: 'INVNS',
            wni_port_name: 'INVERNESS',
            wni_unlocode: 'GBINV',
            wni_country: 'GB',
            wni_lat: 57.48,
            wni_lon: -4.23,
            wni_tz: 'Europe/London',
        },
        {
            option: 'INVRK',
            wni_port_name: 'INVERKEITHING',
            wni_unlocode: 'GBINK',
            wni_country: 'GB',
            wni_lat: 56.03,
            wni_lon: -3.4,
            wni_tz: 'Europe/London',
        },
        {
            option: 'IOG',
            wni_port_name: 'ISLE OF GRAIN',
            wni_unlocode: 'GBIOG',
            wni_country: 'GB',
            wni_lat: 51.43,
            wni_lon: 0.7,
            wni_tz: 'Europe/London',
        },
        {
            option: 'IPS',
            wni_port_name: 'IPSWICH',
            wni_unlocode: 'GBIPS',
            wni_country: 'GB',
            wni_lat: 52.05,
            wni_lon: 1.17,
            wni_tz: 'Europe/London',
        },
        {
            option: 'JAR',
            wni_port_name: 'JARROW',
            wni_unlocode: 'GBJAR',
            wni_country: 'GB',
            wni_lat: 54.98,
            wni_lon: -1.48,
            wni_tz: 'Europe/London',
        },
        {
            option: 'KEAD',
            wni_port_name: 'KEADBY',
            wni_unlocode: 'GBKEA',
            wni_country: 'GB',
            wni_lat: 53.58,
            wni_lon: -0.74,
            wni_tz: 'Europe/London',
        },
        {
            option: 'KGM',
            wni_port_name: 'KILLINGHOLME',
            wni_unlocode: 'GBKGH',
            wni_country: 'GB',
            wni_lat: 53.65,
            wni_lon: -0.21,
            wni_tz: 'Europe/London',
        },
        {
            option: 'KGSN',
            wni_port_name: 'KINGSNORTH',
            wni_unlocode: 'GBKNK',
            wni_country: 'GB',
            wni_lat: 51.41,
            wni_lon: 0.6,
            wni_tz: 'Europe/London',
        },
        {
            option: 'KLPTR',
            wni_port_name: 'OLD KILPATRICK',
            wni_unlocode: 'GBOKK',
            wni_country: 'GB',
            wni_lat: 55.92,
            wni_lon: -4.45,
            wni_tz: 'Europe/London',
        },
        {
            option: 'KRK',
            wni_port_name: 'KIRKWALL',
            wni_unlocode: 'GBKWL',
            wni_country: 'GB',
            wni_lat: 58.98,
            wni_lon: -2.95,
            wni_tz: 'Europe/London',
        },
        {
            option: 'KRKCL',
            wni_port_name: 'KIRKCALDY',
            wni_unlocode: 'GBKKD',
            wni_country: 'GB',
            wni_lat: 56.12,
            wni_lon: -3.15,
            wni_tz: 'Europe/London',
        },
        {
            option: 'LARGS',
            wni_port_name: 'LARGS',
            wni_unlocode: 'GBLGS',
            wni_country: 'GB',
            wni_lat: 55.8,
            wni_lon: -4.87,
            wni_tz: 'Europe/London',
        },
        {
            option: 'LARNE',
            wni_port_name: 'LARNE',
            wni_unlocode: 'GBLAR',
            wni_country: 'GB',
            wni_lat: 54.85,
            wni_lon: -5.8,
            wni_tz: 'Europe/London',
        },
        {
            option: 'LCHLS',
            wni_port_name: 'KYLE OF LOCHALSH',
            wni_unlocode: 'GBKYL',
            wni_country: 'GB',
            wni_lat: 57.28,
            wni_lon: -5.72,
            wni_tz: 'Europe/London',
        },
        {
            option: 'LOCH',
            wni_port_name: 'LOCH STRIVEN',
            wni_unlocode: 'GBLHS',
            wni_country: 'GB',
            wni_lat: 55.89,
            wni_lon: -5.04,
            wni_tz: 'Europe/London',
        },
        {
            option: 'LSSMT',
            wni_port_name: 'LOSSIEMOUTH',
            wni_unlocode: 'GBLSS',
            wni_country: 'GB',
            wni_lat: 57.72,
            wni_lon: -3.28,
            wni_tz: 'Europe/London',
        },
        {
            option: 'LTTLH',
            wni_port_name: 'LITTLEHAMPTON',
            wni_unlocode: 'GBLIT',
            wni_country: 'GB',
            wni_lat: 50.78,
            wni_lon: -0.53,
            wni_tz: 'Europe/London',
        },
        {
            option: 'LYDNY',
            wni_port_name: 'LYDNEY',
            wni_unlocode: 'GBLYD',
            wni_country: 'GB',
            wni_lat: 51.72,
            wni_lon: -2.5,
            wni_tz: 'Europe/London',
        },
        {
            option: 'LYNSS',
            wni_port_name: 'LYNESS',
            wni_unlocode: 'GBLYS',
            wni_country: 'GB',
            wni_lat: 58.83,
            wni_lon: -3.2,
            wni_tz: 'Europe/London',
        },
        {
            option: 'MCDFF',
            wni_port_name: 'MACDUFF',
            wni_unlocode: 'GBMCD',
            wni_country: 'GB',
            wni_lat: 57.67,
            wni_lon: -2.5,
            wni_tz: 'Europe/London',
        },
        {
            option: 'MCH',
            wni_port_name: 'MANCHESTER',
            wni_unlocode: 'GBMNC',
            wni_country: 'GB',
            wni_lat: 53.48,
            wni_lon: -2.23,
            wni_tz: 'Europe/London',
        },
        {
            option: 'MNR',
            wni_port_name: 'MONTROSE',
            wni_unlocode: 'GBMON',
            wni_country: 'GB',
            wni_lat: 56.72,
            wni_lon: -2.47,
            wni_tz: 'Europe/London',
        },
        {
            option: 'MTHL',
            wni_port_name: 'METHIL',
            wni_unlocode: 'GBMTH',
            wni_country: 'GB',
            wni_lat: 56.18,
            wni_lon: -3,
            wni_tz: 'Europe/London',
        },
        {
            option: 'MWD',
            wni_port_name: 'MARCHWOOD',
            wni_unlocode: 'GBMAW',
            wni_country: 'GB',
            wni_lat: 50.9,
            wni_lon: -1.42,
            wni_tz: 'Europe/London',
        },
        {
            option: 'MYN',
            wni_port_name: 'MOSTYN',
            wni_unlocode: 'GBCHE',
            wni_country: 'GB',
            wni_lat: 53.32,
            wni_lon: -3.26,
            wni_tz: 'Europe/London',
        },
        {
            option: 'NDL',
            wni_port_name: 'NEEDLES',
            wni_unlocode: 'USEED',
            wni_country: 'GB',
            wni_lat: 50.66,
            wni_lon: -1.59,
            wni_tz: 'Europe/London',
        },
        {
            option: 'NEATH',
            wni_port_name: 'NEATH',
            wni_unlocode: 'GBNEA',
            wni_country: 'GB',
            wni_lat: 51.57,
            wni_lon: -3.8,
            wni_tz: 'Europe/London',
        },
        {
            option: 'NHO',
            wni_port_name: 'NEW HOLLAND',
            wni_unlocode: 'GBNHO',
            wni_country: 'GB',
            wni_lat: 53.71,
            wni_lon: -0.37,
            wni_tz: 'Europe/London',
        },
        {
            option: 'NPT',
            wni_port_name: 'NEWPORT',
            wni_unlocode: 'GBNPT',
            wni_country: 'GB',
            wni_lat: 51.55,
            wni_lon: -2.98,
            wni_tz: 'Europe/London',
        },
        {
            option: 'NWLYN',
            wni_port_name: 'NEWLYN',
            wni_unlocode: 'GBNYL',
            wni_country: 'GB',
            wni_lat: 50.1,
            wni_lon: -5.55,
            wni_tz: 'Europe/London',
        },
        {
            option: 'OBAN',
            wni_port_name: 'OBAN',
            wni_unlocode: 'GBOBA',
            wni_country: 'GB',
            wni_lat: 56.42,
            wni_lon: -5.47,
            wni_tz: 'Europe/London',
        },
        {
            option: 'PARGB',
            wni_port_name: 'PAR',
            wni_unlocode: 'GBPAR',
            wni_country: 'GB',
            wni_lat: 50.35,
            wni_lon: -4.7,
            wni_tz: 'Europe/London',
        },
        {
            option: 'PDSTW',
            wni_port_name: 'PADSTOW',
            wni_unlocode: 'GBPAD',
            wni_country: 'GB',
            wni_lat: 50.55,
            wni_lon: -4.93,
            wni_tz: 'Europe/London',
        },
        {
            option: 'PERTH',
            wni_port_name: 'PERTH',
            wni_unlocode: 'GBPER',
            wni_country: 'GB',
            wni_lat: 56.4,
            wni_lon: -3.45,
            wni_tz: 'Europe/London',
        },
        {
            option: 'PETE',
            wni_port_name: 'PETERHEAD',
            wni_unlocode: 'GBPHD',
            wni_country: 'GB',
            wni_lat: 57.5,
            wni_lon: -1.78,
            wni_tz: 'Europe/London',
        },
        {
            option: 'PNZ',
            wni_port_name: 'PENZANCE',
            wni_unlocode: 'GBPEN',
            wni_country: 'GB',
            wni_lat: 50.12,
            wni_lon: -5.53,
            wni_tz: 'Europe/London',
        },
        {
            option: 'PRF',
            wni_port_name: 'PURFLEET',
            wni_unlocode: 'GBPFT',
            wni_country: 'GB',
            wni_lat: 51.47,
            wni_lon: 0.25,
            wni_tz: 'Europe/London',
        },
        {
            option: 'PRTRS',
            wni_port_name: 'PORTRUSH',
            wni_unlocode: 'GBPTR',
            wni_country: 'GB',
            wni_lat: 55.22,
            wni_lon: -6.67,
            wni_tz: 'Europe/London',
        },
        {
            option: 'PRTSH',
            wni_port_name: 'PORTISHEAD',
            wni_unlocode: 'GBPTH',
            wni_country: 'GB',
            wni_lat: 51.5,
            wni_lon: -2.75,
            wni_tz: 'Europe/London',
        },
        {
            option: 'PRWLL',
            wni_port_name: 'PIEROWALL',
            wni_unlocode: 'GBPIE',
            wni_country: 'GB',
            wni_lat: 59.3,
            wni_lon: -2.98,
            wni_tz: 'Europe/London',
        },
        {
            option: 'PTMDG',
            wni_port_name: 'PORTHMADOG',
            wni_unlocode: 'GBPMD',
            wni_country: 'GB',
            wni_lat: 52.92,
            wni_lon: -4.13,
            wni_tz: 'Europe/London',
        },
        {
            option: 'RMGT',
            wni_port_name: 'RAMSGATE',
            wni_unlocode: 'GBRMG',
            wni_country: 'GB',
            wni_lat: 51.33,
            wni_lon: 1.42,
            wni_tz: 'Europe/London',
        },
        {
            option: 'ROC',
            wni_port_name: 'ROCHESTER',
            wni_unlocode: 'GBRCS',
            wni_country: 'GB',
            wni_lat: 51.39,
            wni_lon: 0.5,
            wni_tz: 'Europe/London',
        },
        {
            option: 'RUN',
            wni_port_name: 'RUNCORN',
            wni_unlocode: 'GBRUN',
            wni_country: 'GB',
            wni_lat: 53.34,
            wni_lon: -2.75,
            wni_tz: 'Europe/London',
        },
        {
            option: 'RYE',
            wni_port_name: 'RYE',
            wni_unlocode: 'GBRYE',
            wni_country: 'GB',
            wni_lat: 50.95,
            wni_lon: 0.73,
            wni_tz: 'Europe/London',
        },
        {
            option: 'SCF',
            wni_port_name: 'SCAPA FLOW',
            wni_unlocode: 'GBSFW',
            wni_country: 'GB',
            wni_lat: 58.89,
            wni_lon: -3.05,
            wni_tz: 'Europe/London',
        },
        {
            option: 'SCLLW',
            wni_port_name: 'SCALLOWAY',
            wni_unlocode: 'GBSWY',
            wni_country: 'GB',
            wni_lat: 60.13,
            wni_lon: -1.28,
            wni_tz: 'Europe/London',
        },
        {
            option: 'SCRBR',
            wni_port_name: 'SCARBOROUGH',
            wni_unlocode: 'GBSCA',
            wni_country: 'GB',
            wni_lat: 54.28,
            wni_lon: -0.4,
            wni_tz: 'Europe/London',
        },
        {
            option: 'SDR',
            wni_port_name: 'SUNDERLAND',
            wni_unlocode: 'GBSUN',
            wni_country: 'GB',
            wni_lat: 54.9,
            wni_lon: -1.37,
            wni_tz: 'Europe/London',
        },
        {
            option: 'SEF',
            wni_port_name: 'SEAFORTH',
            wni_unlocode: 'GBSEF',
            wni_country: 'GB',
            wni_lat: 53.46,
            wni_lon: -3.02,
            wni_tz: 'Europe/London',
        },
        {
            option: 'SEHM',
            wni_port_name: 'SEAHAM',
            wni_unlocode: 'GBSEA',
            wni_country: 'GB',
            wni_lat: 54.83,
            wni_lon: -1.32,
            wni_tz: 'Europe/London',
        },
        {
            option: 'SHAR',
            wni_port_name: 'SHARPNESS',
            wni_unlocode: 'GBSSS',
            wni_country: 'GB',
            wni_lat: 51.72,
            wni_lon: -2.48,
            wni_tz: 'Europe/London',
        },
        {
            option: 'SHV',
            wni_port_name: 'SHELL HAVEN',
            wni_unlocode: 'GBSHV',
            wni_country: 'GB',
            wni_lat: 51.5,
            wni_lon: 0.49,
            wni_tz: 'Europe/London',
        },
        {
            option: 'SLLTH',
            wni_port_name: 'SILLOTH',
            wni_unlocode: 'GBSIL',
            wni_country: 'GB',
            wni_lat: 54.87,
            wni_lon: -3.4,
            wni_tz: 'Europe/London',
        },
        {
            option: 'SLV',
            wni_port_name: 'SILVERTOWN',
            wni_unlocode: 'GBSVT',
            wni_country: 'GB',
            wni_lat: 51.5,
            wni_lon: 0.04,
            wni_tz: 'Europe/London',
        },
        {
            option: 'SSS',
            wni_port_name: 'SOUTH SHIELDS',
            wni_unlocode: 'GBSSH',
            wni_country: 'GB',
            wni_lat: 54.99,
            wni_lon: -1.45,
            wni_tz: 'Europe/London',
        },
        {
            option: 'STOMN',
            wni_port_name: 'STROMNESS',
            wni_unlocode: 'GBSNS',
            wni_country: 'GB',
            wni_lat: 58.97,
            wni_lon: -3.3,
            wni_tz: 'Europe/London',
        },
        {
            option: 'STRNG',
            wni_port_name: 'STRANGFORD',
            wni_unlocode: 'GBSJL',
            wni_country: 'GB',
            wni_lat: 54.37,
            wni_lon: -5.55,
            wni_tz: 'Europe/London',
        },
        {
            option: 'STRNR',
            wni_port_name: 'STRANRAER',
            wni_unlocode: 'GBSTR',
            wni_country: 'GB',
            wni_lat: 54.9,
            wni_lon: -5.03,
            wni_tz: 'Europe/London',
        },
        {
            option: 'STW',
            wni_port_name: 'STANLOW',
            wni_unlocode: 'GBSOW',
            wni_country: 'GB',
            wni_lat: 53.29,
            wni_lon: -2.87,
            wni_tz: 'Europe/London',
        },
        {
            option: 'THM',
            wni_port_name: 'THAMESHAVEN',
            wni_unlocode: 'GBTHS',
            wni_country: 'GB',
            wni_lat: 51.5,
            wni_lon: 0.49,
            wni_tz: 'Europe/London',
        },
        {
            option: 'THU',
            wni_port_name: 'THURSO',
            wni_unlocode: 'GBTHR',
            wni_country: 'GB',
            wni_lat: 58.61,
            wni_lon: -3.55,
            wni_tz: 'Europe/London',
        },
        {
            option: 'TRBRT',
            wni_port_name: 'TARBERT',
            wni_unlocode: 'GBTAB',
            wni_country: 'GB',
            wni_lat: 55.87,
            wni_lon: -5.42,
            wni_tz: 'Europe/London',
        },
        {
            option: 'TROO',
            wni_port_name: 'TROON',
            wni_unlocode: 'GBTRN',
            wni_country: 'GB',
            wni_lat: 55.55,
            wni_lon: -4.68,
            wni_tz: 'Europe/London',
        },
        {
            option: 'TRQY',
            wni_port_name: 'TORQUAY',
            wni_unlocode: 'GBTOR',
            wni_country: 'GB',
            wni_lat: 50.47,
            wni_lon: -3.53,
            wni_tz: 'Europe/London',
        },
        {
            option: 'ULL',
            wni_port_name: 'ULLAPOOL',
            wni_unlocode: 'GBULL',
            wni_country: 'GB',
            wni_lat: 57.9,
            wni_lon: -5.15,
            wni_tz: 'Europe/London',
        },
        {
            option: 'WALL',
            wni_port_name: 'WALLSEND',
            wni_unlocode: 'GBWTW',
            wni_country: 'GB',
            wni_lat: 54.98,
            wni_lon: -1.5,
            wni_tz: 'Europe/London',
        },
        {
            option: 'WHTBY',
            wni_port_name: 'WHITBY',
            wni_unlocode: 'GBWTB',
            wni_country: 'GB',
            wni_lat: 54.48,
            wni_lon: -0.62,
            wni_tz: 'Europe/London',
        },
        {
            option: 'WHTST',
            wni_port_name: 'WHITSTABLE',
            wni_unlocode: 'GBWTS',
            wni_country: 'GB',
            wni_lat: 51.37,
            wni_lon: 1.03,
            wni_tz: 'Europe/London',
        },
        {
            option: 'WHV',
            wni_port_name: 'WHITEHAVEN',
            wni_unlocode: 'GBWHV',
            wni_country: 'GB',
            wni_lat: 54.55,
            wni_lon: -3.6,
            wni_tz: 'Europe/London',
        },
        {
            option: 'WICK',
            wni_port_name: 'WICK',
            wni_unlocode: 'GBWIC',
            wni_country: 'GB',
            wni_lat: 58.43,
            wni_lon: -3.08,
            wni_tz: 'Europe/London',
        },
        {
            option: 'WLWCH',
            wni_port_name: 'WOOLWICH',
            wni_unlocode: 'GBWLW',
            wni_country: 'GB',
            wni_lat: 51.5,
            wni_lon: 0.07,
            wni_tz: 'Europe/London',
        },
        {
            option: 'WRK',
            wni_port_name: 'WORKINGTON',
            wni_unlocode: 'GBWOR',
            wni_country: 'GB',
            wni_lat: 54.65,
            wni_lon: -3.57,
            wni_tz: 'Europe/London',
        },
        {
            option: 'WRP',
            wni_port_name: 'WARRENPOINT',
            wni_unlocode: 'GBWPT',
            wni_country: 'GB',
            wni_lat: 54.1,
            wni_lon: -6.26,
            wni_tz: 'Europe/London',
        },
        {
            option: 'WVNH',
            wni_port_name: 'WIVENHOE',
            wni_unlocode: 'GBWIV',
            wni_country: 'GB',
            wni_lat: 51.85,
            wni_lon: 0.97,
            wni_tz: 'Europe/London',
        },
        {
            option: 'CYN',
            wni_port_name: 'CAYENNE',
            wni_unlocode: 'GFCAY',
            wni_country: 'GF',
            wni_lat: 4.93,
            wni_lon: -52.33,
            wni_tz: 'America/Cayenne',
        },
        {
            option: 'DDC',
            wni_port_name: 'DEGRAD DES CANNES',
            wni_unlocode: 'GFDDC',
            wni_country: 'GF',
            wni_lat: 4.85,
            wni_lon: -52.27,
            wni_tz: 'America/Cayenne',
        },
        {
            option: 'KOU',
            wni_port_name: 'KOUROU',
            wni_unlocode: 'GFQKR',
            wni_country: 'GF',
            wni_lat: 5.16,
            wni_lon: -52.63,
            wni_tz: 'America/Cayenne',
        },
        {
            option: 'LRNT',
            wni_port_name: 'ST LAURENT',
            wni_unlocode: 'GFSLM',
            wni_country: 'GF',
            wni_lat: 5.5,
            wni_lon: -54.03,
            wni_tz: 'America/Cayenne',
        },
        {
            option: 'PETER',
            wni_port_name: 'ST PETER PORT',
            wni_unlocode: 'GGSPT',
            wni_country: 'GG',
            wni_lat: 49.45,
            wni_lon: -2.53,
            wni_tz: 'Europe/Guernsey',
        },
        {
            option: 'SLP',
            wni_port_name: 'SALTPOND',
            wni_unlocode: 'GHSPD',
            wni_country: 'GH',
            wni_lat: 5.2,
            wni_lon: -1.05,
            wni_tz: 'Africa/Accra',
        },
        {
            option: 'EGDS',
            wni_port_name: 'EGEDESMINDE',
            wni_unlocode: 'GLJEG',
            wni_country: 'GL',
            wni_lat: 68.7,
            wni_lon: -52.87,
            wni_tz: 'America/Godthab',
        },
        {
            option: 'FAE',
            wni_port_name: 'FAERINGEHAVN',
            wni_unlocode: 'GLFHN',
            wni_country: 'GL',
            wni_lat: 63.7,
            wni_lon: -51.55,
            wni_tz: 'America/Godthab',
        },
        {
            option: 'GDHVN',
            wni_port_name: 'GODHAVN',
            wni_unlocode: 'GLJGO',
            wni_country: 'GL',
            wni_lat: 69.23,
            wni_lon: -53.53,
            wni_tz: 'America/Godthab',
        },
        {
            option: 'HLST',
            wni_port_name: 'HOLSTEINSBORG',
            wni_unlocode: 'GLJHS',
            wni_country: 'GL',
            wni_lat: 66.92,
            wni_lon: -53.7,
            wni_tz: 'America/Godthab',
        },
        {
            option: 'IVGTT',
            wni_port_name: 'IVIGTUT',
            wni_unlocode: 'GLIUT',
            wni_country: 'GL',
            wni_lat: 61.2,
            wni_lon: -48.18,
            wni_tz: 'America/Godthab',
        },
        {
            option: 'JKBH',
            wni_port_name: 'JAKOBSHAVN',
            wni_unlocode: 'GLJAV',
            wni_country: 'GL',
            wni_lat: 69.22,
            wni_lon: -51.1,
            wni_tz: 'America/Godthab',
        },
        {
            option: 'MLK',
            wni_port_name: 'MARMORILIK',
            wni_unlocode: 'GLMML',
            wni_country: 'GL',
            wni_lat: 71.13,
            wni_lon: -51.28,
            wni_tz: 'America/Godthab',
        },
        {
            option: 'NRSRS',
            wni_port_name: 'NARSSARSSUAQ',
            wni_unlocode: 'GLUAK',
            wni_country: 'GL',
            wni_lat: 61.15,
            wni_lon: -45.43,
            wni_tz: 'America/Godthab',
        },
        {
            option: 'QSGN',
            wni_port_name: 'QASIGIANNGUIT',
            wni_unlocode: 'GLJCH',
            wni_country: 'GL',
            wni_lat: 68.82,
            wni_lon: -51.18,
            wni_tz: 'America/Godthab',
        },
        {
            option: 'SKKT',
            wni_port_name: 'SUKKERTOPPEN',
            wni_unlocode: 'GLJSU',
            wni_country: 'GL',
            wni_lat: 65.42,
            wni_lon: -52.92,
            wni_tz: 'America/Godthab',
        },
        {
            option: 'UPRNV',
            wni_port_name: 'UPERNAVIK',
            wni_unlocode: 'GLJUV',
            wni_country: 'GL',
            wni_lat: 72.77,
            wni_lon: -56.15,
            wni_tz: 'America/Godthab',
        },
        {
            option: 'COGO',
            wni_port_name: 'COGO',
            wni_unlocode: 'GQCOG',
            wni_country: 'GQ',
            wni_lat: 1.08,
            wni_lon: 9.7,
            wni_tz: 'Africa/Malabo',
        },
        {
            option: 'LUBA',
            wni_port_name: 'LUBA',
            wni_unlocode: 'GQLUB',
            wni_country: 'GQ',
            wni_lat: 3.5,
            wni_lon: 8.57,
            wni_tz: 'Africa/Malabo',
        },
        {
            option: 'ACHL',
            wni_port_name: 'ACHLADI',
            wni_unlocode: 'GRACL',
            wni_country: 'GR',
            wni_lat: 38.89,
            wni_lon: 22.82,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'AVRON',
            wni_port_name: 'ALIVERION',
            wni_unlocode: 'GRALV',
            wni_country: 'GR',
            wni_lat: 38.38,
            wni_lon: 24.05,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'AYIOS',
            wni_port_name: 'AYIOS NIKOLAOS',
            wni_unlocode: 'GRANI',
            wni_country: 'GR',
            wni_lat: 35.19,
            wni_lon: 25.72,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'CLK',
            wni_port_name: 'CHALKIS',
            wni_unlocode: 'GRQKG',
            wni_country: 'GR',
            wni_lat: 38.47,
            wni_lon: 23.59,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'GVRIN',
            wni_port_name: 'GAVRION',
            wni_unlocode: 'GRGAV',
            wni_country: 'GR',
            wni_lat: 37.88,
            wni_lon: 24.73,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'ITE',
            wni_port_name: 'ITEA',
            wni_unlocode: 'GRITA',
            wni_country: 'GR',
            wni_lat: 38.43,
            wni_lon: 22.42,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'KLKI',
            wni_port_name: 'KALAMAKI',
            wni_unlocode: 'GRKLM',
            wni_country: 'GR',
            wni_lat: 37.92,
            wni_lon: 23.02,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'KOSX',
            wni_port_name: 'KOS',
            wni_unlocode: 'GRKGS',
            wni_country: 'GR',
            wni_lat: 36.9,
            wni_lon: 27.28,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'KYM',
            wni_port_name: 'KYMASSI',
            wni_unlocode: 'GRKYM',
            wni_country: 'GR',
            wni_lat: 38.81,
            wni_lon: 23.52,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'LRI',
            wni_port_name: 'LAVRION',
            wni_unlocode: 'GRLAV',
            wni_country: 'GR',
            wni_lat: 37.71,
            wni_lon: 24.06,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'MEGRA',
            wni_port_name: 'MEGARA OIL TERMINAL',
            wni_unlocode: 'GRMGR',
            wni_country: 'GR',
            wni_lat: 37.98,
            wni_lon: 23.33,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'NEAM',
            wni_port_name: 'NEA MOUDHANIA',
            wni_unlocode: 'GRNMA',
            wni_country: 'GR',
            wni_lat: 40.24,
            wni_lon: 23.28,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'NKV',
            wni_port_name: 'NEA KARVALI',
            wni_unlocode: 'GRNKV',
            wni_country: 'GR',
            wni_lat: 40.95,
            wni_lon: 24.48,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'PAROS',
            wni_port_name: 'PAROS',
            wni_unlocode: 'GRPAS',
            wni_country: 'GR',
            wni_lat: 37.08,
            wni_lon: 25.15,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'PRAMA',
            wni_port_name: 'PERAMA',
            wni_unlocode: 'GRPER',
            wni_country: 'GR',
            wni_lat: 37.97,
            wni_lon: 23.57,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'PRV',
            wni_port_name: 'PREVEZA',
            wni_unlocode: 'GRPVK',
            wni_country: 'GR',
            wni_lat: 38.95,
            wni_lon: 20.75,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'YER',
            wni_port_name: 'YERAKINI',
            wni_unlocode: 'GRYER',
            wni_country: 'GR',
            wni_lat: 40.27,
            wni_lon: 23.47,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'GRYT',
            wni_port_name: 'GRYTVIKEN',
            wni_unlocode: 'GSGRV',
            wni_country: 'GS',
            wni_lat: -54.27,
            wni_lon: -36.52,
            wni_tz: 'Atlantic/South_Georgia',
        },
        {
            option: 'CHP',
            wni_port_name: 'CHAMPERICO',
            wni_unlocode: 'GTCHR',
            wni_country: 'GT',
            wni_lat: 14.3,
            wni_lon: -91.93,
            wni_tz: 'America/Guatemala',
        },
        {
            option: 'PQZ',
            wni_port_name: 'PUERTO QUETZAL',
            wni_unlocode: 'GTPRQ',
            wni_country: 'GT',
            wni_lat: 13.92,
            wni_lon: -90.8,
            wni_tz: 'America/Guatemala',
        },
        {
            option: 'BLME',
            wni_port_name: 'BOLAMA',
            wni_unlocode: 'GWBOL',
            wni_country: 'GW',
            wni_lat: 11.58,
            wni_lon: -15.48,
            wni_tz: 'Africa/Bissau',
        },
        {
            option: 'EVER',
            wni_port_name: 'EVERTON',
            wni_unlocode: 'GYQSK',
            wni_country: 'GY',
            wni_lat: 6.25,
            wni_lon: -57.55,
            wni_tz: 'America/Guyana',
        },
        {
            option: 'LIND',
            wni_port_name: 'LINDEN',
            wni_unlocode: 'GYLDN',
            wni_country: 'GY',
            wni_lat: 6,
            wni_lon: -58.3,
            wni_tz: 'America/Guyana',
        },
        {
            option: 'TOLO',
            wni_port_name: 'TOLO HARBOUR',
            wni_unlocode: 'HKTOL',
            wni_country: 'HK',
            wni_lat: 22.43,
            wni_lon: 114.22,
            wni_tz: 'Asia/Hong_Kong',
        },
        {
            option: 'LAC',
            wni_port_name: 'LA CEIBA',
            wni_unlocode: 'HNLCE',
            wni_country: 'HN',
            wni_lat: 15.77,
            wni_lon: -86.83,
            wni_tz: 'America/Tegucigalpa',
        },
        {
            option: 'PUCS',
            wni_port_name: 'PUERTO CASTILLA',
            wni_unlocode: 'HNPCA',
            wni_country: 'HN',
            wni_lat: 16,
            wni_lon: -85.98,
            wni_tz: 'America/Tegucigalpa',
        },
        {
            option: 'TLA',
            wni_port_name: 'TELA',
            wni_unlocode: 'HNTEA',
            wni_country: 'HN',
            wni_lat: 15.77,
            wni_lon: -87.45,
            wni_tz: 'America/Tegucigalpa',
        },
        {
            option: 'MSJ',
            wni_port_name: 'MALI LOSINJ',
            wni_unlocode: 'HRLSZ',
            wni_country: 'HR',
            wni_lat: 44.53,
            wni_lon: 14.47,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'MSLNC',
            wni_port_name: 'MASLENICA',
            wni_unlocode: 'HRMAS',
            wni_country: 'HR',
            wni_lat: 44.22,
            wni_lon: 15.55,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'PLMN',
            wni_port_name: 'PLOMIN',
            wni_unlocode: 'HRPLM',
            wni_country: 'HR',
            wni_lat: 45.12,
            wni_lon: 14.19,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'PUY',
            wni_port_name: 'PULA',
            wni_unlocode: 'HRPUY',
            wni_country: 'HR',
            wni_lat: 44.87,
            wni_lon: 13.83,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'RVNJ',
            wni_port_name: 'ROVINJ',
            wni_unlocode: 'HRROV',
            wni_country: 'HR',
            wni_lat: 45.08,
            wni_lon: 13.63,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'SBN',
            wni_port_name: 'SIBENIK',
            wni_unlocode: 'HRSIB',
            wni_country: 'HR',
            wni_lat: 43.73,
            wni_lon: 15.88,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'ZAD',
            wni_port_name: 'ZADAR',
            wni_unlocode: 'HRZAD',
            wni_country: 'HR',
            wni_lat: 44.12,
            wni_lon: 15.22,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'MIRG',
            wni_port_name: 'MIRAGOANE',
            wni_unlocode: 'HTMIR',
            wni_country: 'HT',
            wni_lat: 18.47,
            wni_lon: -73.1,
            wni_tz: 'America/Port-au-Prince',
        },
        {
            option: 'BARAI',
            wni_port_name: 'TANJUNG BARA',
            wni_unlocode: 'IDTBA',
            wni_country: 'ID',
            wni_lat: 0.53,
            wni_lon: 117.66,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'BATU',
            wni_port_name: 'BATU AMPAR',
            wni_unlocode: 'IDBAP',
            wni_country: 'ID',
            wni_lat: 1.17,
            wni_lon: 104,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'BENG',
            wni_port_name: 'BENGKULU',
            wni_unlocode: 'IDBKS',
            wni_country: 'ID',
            wni_lat: -3.78,
            wni_lon: 102.25,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'BETG',
            wni_port_name: 'BELITUNG',
            wni_unlocode: 'IDBLT',
            wni_country: 'ID',
            wni_lat: -2.81,
            wni_lon: 107.92,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'BGG',
            wni_port_name: 'BLANG LANCANG',
            wni_unlocode: 'IDBLL',
            wni_country: 'ID',
            wni_lat: 5.22,
            wni_lon: 97.1,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'BIAK',
            wni_port_name: 'BIAK',
            wni_unlocode: 'IDBIK',
            wni_country: 'ID',
            wni_lat: -1.17,
            wni_lon: 136.06,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'BIM',
            wni_port_name: 'BIMA',
            wni_unlocode: 'IDBMU',
            wni_country: 'ID',
            wni_lat: -8.45,
            wni_lon: 118.72,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'BNGKL',
            wni_port_name: 'BENGKULU',
            wni_unlocode: 'IDBKS',
            wni_country: 'ID',
            wni_lat: -3.78,
            wni_lon: 102.25,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'BNGKS',
            wni_port_name: 'BENGKALIS',
            wni_unlocode: 'INDKI',
            wni_country: 'ID',
            wni_lat: 1.47,
            wni_lon: 102.1,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'BNTN',
            wni_port_name: 'BANTEN',
            wni_unlocode: 'IDBTN',
            wni_country: 'ID',
            wni_lat: -6.01,
            wni_lon: 105.96,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'BNYW',
            wni_port_name: 'BANYUWANGI',
            wni_unlocode: 'IDBJU',
            wni_country: 'ID',
            wni_lat: -8.12,
            wni_lon: 114.38,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'BTLCN',
            wni_port_name: 'BATULICIN',
            wni_unlocode: 'IDBTW',
            wni_country: 'ID',
            wni_lat: -3.43,
            wni_lon: 116.01,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'CIR',
            wni_port_name: 'CIREBON',
            wni_unlocode: 'IDCBN',
            wni_country: 'ID',
            wni_lat: -6.72,
            wni_lon: 108.57,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'DABO',
            wni_port_name: 'DABO',
            wni_unlocode: 'IDDAS',
            wni_country: 'ID',
            wni_lat: -0.5,
            wni_lon: 104.57,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'DJA',
            wni_port_name: 'JAKARTA',
            wni_unlocode: 'IDJKT',
            wni_country: 'ID',
            wni_lat: -6.07,
            wni_lon: 106.8,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'DOBO',
            wni_port_name: 'DOBO',
            wni_unlocode: 'IDDOB',
            wni_country: 'ID',
            wni_lat: -5.75,
            wni_lon: 134.22,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'EDA',
            wni_port_name: 'MEDAN',
            wni_unlocode: 'IDMES',
            wni_country: 'ID',
            wni_lat: 3.79,
            wni_lon: 98.7,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'ENDE',
            wni_port_name: 'ENDE',
            wni_unlocode: 'IDENE',
            wni_country: 'ID',
            wni_lat: -8.83,
            wni_lon: 121.65,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'GRNTL',
            wni_port_name: 'GORONTALO',
            wni_unlocode: 'IDGTO',
            wni_country: 'ID',
            wni_lat: 0.5,
            wni_lon: 123.05,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'JAP',
            wni_port_name: 'JAYAPURA',
            wni_unlocode: 'IDDJJ',
            wni_country: 'ID',
            wni_lat: -2.53,
            wni_lon: 140.72,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'JMB',
            wni_port_name: 'JAMBI',
            wni_unlocode: 'IDDJB',
            wni_country: 'ID',
            wni_lat: -1.6,
            wni_lon: 103.62,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'KAMI',
            wni_port_name: 'KAIMANA',
            wni_unlocode: 'IDKNG',
            wni_country: 'ID',
            wni_lat: -3.66,
            wni_lon: 133.76,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'KETA',
            wni_port_name: 'KETAPANG',
            wni_unlocode: 'IDKTG',
            wni_country: 'ID',
            wni_lat: -1.86,
            wni_lon: 109.97,
            wni_tz: 'Asia/Pontianak',
        },
        {
            option: 'KLBH',
            wni_port_name: 'KALABAHI',
            wni_unlocode: 'IDKBH',
            wni_country: 'ID',
            wni_lat: -8.2,
            wni_lon: 124.52,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'KNDR',
            wni_port_name: 'KENDARI',
            wni_unlocode: 'IDKDI',
            wni_country: 'ID',
            wni_lat: -3.97,
            wni_lon: 122.58,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'KSM',
            wni_port_name: 'KASIM',
            wni_unlocode: 'IDKAS',
            wni_country: 'ID',
            wni_lat: -1.31,
            wni_lon: 131.02,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'KUALA',
            wni_port_name: 'KUALA TANJUNG',
            wni_unlocode: 'IDKTJ',
            wni_country: 'ID',
            wni_lat: 3.37,
            wni_lon: 99.45,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'KUP',
            wni_port_name: 'KUPANG',
            wni_unlocode: 'IDKOE',
            wni_country: 'ID',
            wni_lat: -10.17,
            wni_lon: 123.58,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'LAB',
            wni_port_name: 'LABUHA',
            wni_unlocode: 'IDLAH',
            wni_country: 'ID',
            wni_lat: -0.63,
            wni_lon: 127.47,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'LEM',
            wni_port_name: 'LEMBAR',
            wni_unlocode: 'IDLBR',
            wni_country: 'ID',
            wni_lat: -8.73,
            wni_lon: 116.07,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'LHO',
            wni_port_name: 'LHOKSEUMAWE',
            wni_unlocode: 'IDLKS',
            wni_country: 'ID',
            wni_lat: 5.17,
            wni_lon: 97.15,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'LRTK',
            wni_port_name: 'LARANTUKA',
            wni_unlocode: 'IDLKA',
            wni_country: 'ID',
            wni_lat: -8.35,
            wni_lon: 122.98,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'MADO',
            wni_port_name: 'MANADO',
            wni_unlocode: 'IDMDC',
            wni_country: 'ID',
            wni_lat: 1.5,
            wni_lon: 124.83,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'MANK',
            wni_port_name: 'MANOKWARI',
            wni_unlocode: 'IDMKW',
            wni_country: 'ID',
            wni_lat: -0.87,
            wni_lon: 134.08,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'MDNI',
            wni_port_name: 'MEDAN',
            wni_unlocode: 'IDMES',
            wni_country: 'ID',
            wni_lat: 3.79,
            wni_lon: 98.7,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'MGJ',
            wni_port_name: 'MANGKAJANG',
            wni_unlocode: 'IDMKJ',
            wni_country: 'ID',
            wni_lat: 2.02,
            wni_lon: 117.76,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'MMR',
            wni_port_name: 'MAUMERE',
            wni_unlocode: 'IDMOF',
            wni_country: 'ID',
            wni_lat: -8.62,
            wni_lon: 122.22,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'MPI',
            wni_port_name: 'MORNOPO',
            wni_unlocode: 'IDMOR',
            wni_country: 'ID',
            wni_lat: 0.78,
            wni_lon: 128.21,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'NMLA',
            wni_port_name: 'NAMLEA',
            wni_unlocode: 'IDNAM',
            wni_country: 'ID',
            wni_lat: -3.28,
            wni_lon: 127.08,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'PAL',
            wni_port_name: 'PALU',
            wni_unlocode: 'IDPAL',
            wni_country: 'ID',
            wni_lat: -0.9,
            wni_lon: 119.86,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'PANT',
            wni_port_name: 'PANTOLOAN',
            wni_unlocode: 'IDPTL',
            wni_country: 'ID',
            wni_lat: -0.71,
            wni_lon: 119.86,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'PGG',
            wni_port_name: 'PROBOLINGGO',
            wni_unlocode: 'IDPRO',
            wni_country: 'ID',
            wni_lat: -7.72,
            wni_lon: 113.22,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'PLP',
            wni_port_name: 'PALOPO',
            wni_unlocode: 'IDPPO',
            wni_country: 'ID',
            wni_lat: -2.99,
            wni_lon: 120.2,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'PMLAA',
            wni_port_name: 'POMALAA',
            wni_unlocode: 'IDPUM',
            wni_country: 'ID',
            wni_lat: -4.17,
            wni_lon: 121.6,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'PNK',
            wni_port_name: 'PANARUKAN',
            wni_unlocode: 'IDPRN',
            wni_country: 'ID',
            wni_lat: -7.7,
            wni_lon: 113.93,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'POSO',
            wni_port_name: 'POSO',
            wni_unlocode: 'IDPSJ',
            wni_country: 'ID',
            wni_lat: -1.37,
            wni_lon: 120.75,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'PSL',
            wni_port_name: 'PANGKALAN SUSU',
            wni_unlocode: 'IDPSU',
            wni_country: 'ID',
            wni_lat: 4.12,
            wni_lon: 98.22,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'RAHA',
            wni_port_name: 'RAHA',
            wni_unlocode: 'IDRAQ',
            wni_country: 'ID',
            wni_lat: -4.85,
            wni_lon: 122.73,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'SAM',
            wni_port_name: 'SAMPIT',
            wni_unlocode: 'IDSMQ',
            wni_country: 'ID',
            wni_lat: -2.52,
            wni_lon: 113,
            wni_tz: 'Asia/Pontianak',
        },
        {
            option: 'SBNG',
            wni_port_name: 'SABANG',
            wni_unlocode: 'IDSBG',
            wni_country: 'ID',
            wni_lat: 5.88,
            wni_lon: 95.32,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'SBO',
            wni_port_name: 'SIBOLGA',
            wni_unlocode: 'IDSLG',
            wni_country: 'ID',
            wni_lat: 1.73,
            wni_lon: 98.77,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'SGK',
            wni_port_name: 'SANGKULIRANG',
            wni_unlocode: 'IDSKI',
            wni_country: 'ID',
            wni_lat: 1,
            wni_lon: 118,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'SMBS',
            wni_port_name: 'SAMBAS',
            wni_unlocode: 'IDSBS',
            wni_country: 'ID',
            wni_lat: 1.37,
            wni_lon: 109.3,
            wni_tz: 'Asia/Pontianak',
        },
        {
            option: 'SMLK',
            wni_port_name: 'SAUMLAKI',
            wni_unlocode: 'IDSXK',
            wni_country: 'ID',
            wni_lat: -7.98,
            wni_lon: 131.3,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'SNGKP',
            wni_port_name: 'DABO',
            wni_unlocode: 'IDDAS',
            wni_country: 'ID',
            wni_lat: -0.5,
            wni_lon: 104.57,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'SNNA',
            wni_port_name: 'SANANA',
            wni_unlocode: 'IDSQN',
            wni_country: 'ID',
            wni_lat: -2.05,
            wni_lon: 125.98,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'SOR',
            wni_port_name: 'SORONG',
            wni_unlocode: 'IDSOQ',
            wni_country: 'ID',
            wni_lat: -0.88,
            wni_lon: 131.23,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'SRUI',
            wni_port_name: 'SERUI',
            wni_unlocode: 'IDZRI',
            wni_country: 'ID',
            wni_lat: -1.9,
            wni_lon: 136.25,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'SUBA',
            wni_port_name: 'SUBAIM',
            wni_unlocode: 'IDSBM',
            wni_country: 'ID',
            wni_lat: 1.11,
            wni_lon: 128.14,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'TBELO',
            wni_port_name: 'TOBELO',
            wni_unlocode: 'IDTBO',
            wni_country: 'ID',
            wni_lat: 1.73,
            wni_lon: 128.02,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'TEGAL',
            wni_port_name: 'TEGAL',
            wni_unlocode: 'IDTEG',
            wni_country: 'ID',
            wni_lat: -6.85,
            wni_lon: 109.13,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'TET',
            wni_port_name: 'TERNATE',
            wni_unlocode: 'IDTTE',
            wni_country: 'ID',
            wni_lat: 0.78,
            wni_lon: 127.38,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'TMH',
            wni_port_name: 'TANAH MERAH',
            wni_unlocode: 'IDTMH',
            wni_country: 'ID',
            wni_lat: -1.79,
            wni_lon: 116.23,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'TTUNG',
            wni_port_name: 'LUBUK TUTUNG',
            wni_unlocode: 'IDLTT',
            wni_country: 'ID',
            wni_lat: 0.73,
            wni_lon: 117.74,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'TUAL',
            wni_port_name: 'TUAL',
            wni_unlocode: 'IDTUA',
            wni_country: 'ID',
            wni_lat: -5.63,
            wni_lon: 132.73,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'UJP',
            wni_port_name: 'UJUNG PANDANG',
            wni_unlocode: 'IDUPG',
            wni_country: 'ID',
            wni_lat: -5.13,
            wni_lon: 119.4,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'WEDA',
            wni_port_name: 'WEDA',
            wni_unlocode: 'IDWED',
            wni_country: 'ID',
            wni_lat: 0.33,
            wni_lon: 127.88,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'WNGP',
            wni_port_name: 'WAINGAPU',
            wni_unlocode: 'IDWGP',
            wni_country: 'ID',
            wni_lat: -9.63,
            wni_lon: 120.27,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'ARKLW',
            wni_port_name: 'ARKLOW',
            wni_unlocode: 'IEARK',
            wni_country: 'IE',
            wni_lat: 52.8,
            wni_lon: -6.15,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'BLLNT',
            wni_port_name: 'BALLINA',
            wni_unlocode: 'IEBLL',
            wni_country: 'IE',
            wni_lat: 54.12,
            wni_lon: -9.17,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'BLTMR',
            wni_port_name: 'BALTIMORE',
            wni_unlocode: 'IEBTM',
            wni_country: 'IE',
            wni_lat: 51.48,
            wni_lon: -9.38,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'COB',
            wni_port_name: 'COBH',
            wni_unlocode: 'IECOB',
            wni_country: 'IE',
            wni_lat: 51.85,
            wni_lon: -8.3,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'CRLNG',
            wni_port_name: 'CARLINGFORD',
            wni_unlocode: 'IECAR',
            wni_country: 'IE',
            wni_lat: 54.05,
            wni_lon: -6.18,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'CTLB',
            wni_port_name: 'CASTLETOWN BERE',
            wni_unlocode: 'IECTB',
            wni_country: 'IE',
            wni_lat: 51.65,
            wni_lon: -9.91,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'DDK',
            wni_port_name: 'DUNDALK',
            wni_unlocode: 'IEDLK',
            wni_country: 'IE',
            wni_lat: 54,
            wni_lon: -6.4,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'DRGHD',
            wni_port_name: 'DROGHEDA',
            wni_unlocode: 'IEDRO',
            wni_country: 'IE',
            wni_lat: 53.72,
            wni_lon: -6.35,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'FIT',
            wni_port_name: 'FENIT',
            wni_unlocode: 'IEFEN',
            wni_country: 'IE',
            wni_lat: 52.27,
            wni_lon: -9.87,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'GWA',
            wni_port_name: 'GALWAY',
            wni_unlocode: 'IEGWY',
            wni_country: 'IE',
            wni_lat: 53.27,
            wni_lon: -9.05,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'KNSL',
            wni_port_name: 'KINSALE',
            wni_unlocode: 'IEKLN',
            wni_country: 'IE',
            wni_lat: 51.7,
            wni_lon: -8.52,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'LGHRE',
            wni_port_name: 'DUN LAOGHAIRE',
            wni_unlocode: 'IEDLG',
            wni_country: 'IE',
            wni_lat: 53.3,
            wni_lon: -6.13,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'NROS',
            wni_port_name: 'NEW ROSS',
            wni_unlocode: 'IENRS',
            wni_country: 'IE',
            wni_lat: 52.4,
            wni_lon: -6.95,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'RGK',
            wni_port_name: 'RINGASKIDDY',
            wni_unlocode: 'IERIN',
            wni_country: 'IE',
            wni_lat: 51.9,
            wni_lon: -8.41,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'ROSS',
            wni_port_name: 'ROSSLARE',
            wni_unlocode: 'IEROS',
            wni_country: 'IE',
            wni_lat: 52.25,
            wni_lon: -6.33,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'SLIGO',
            wni_port_name: 'SLIGO',
            wni_unlocode: 'IESLI',
            wni_country: 'IE',
            wni_lat: 54.27,
            wni_lon: -8.47,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'TARB',
            wni_port_name: 'TARBERT',
            wni_unlocode: 'IETAR',
            wni_country: 'IE',
            wni_lat: 52.57,
            wni_lon: -9.37,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'WCKLW',
            wni_port_name: 'WICKLOW',
            wni_unlocode: 'IEWIC',
            wni_country: 'IE',
            wni_lat: 52.98,
            wni_lon: -6.03,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'WSTPR',
            wni_port_name: 'WESTPORT',
            wni_unlocode: 'IEWES',
            wni_country: 'IE',
            wni_lat: 53.8,
            wni_lon: -9.53,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'WTF',
            wni_port_name: 'WATERFORD',
            wni_unlocode: 'IEWAT',
            wni_country: 'IE',
            wni_lat: 52.13,
            wni_lon: -6.95,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'DGLS',
            wni_port_name: 'DOUGLAS',
            wni_unlocode: 'GBDGS',
            wni_country: 'IM',
            wni_lat: 54.15,
            wni_lon: -4.47,
            wni_tz: 'Europe/Isle_of_Man',
        },
        {
            option: 'PEEL',
            wni_port_name: 'PEEL',
            wni_unlocode: 'GBPEL',
            wni_country: 'IM',
            wni_lat: 54.23,
            wni_lon: -4.7,
            wni_tz: 'Europe/Isle_of_Man',
        },
        {
            option: 'RMSY',
            wni_port_name: 'RAMSEY',
            wni_unlocode: 'GBRSY',
            wni_country: 'IM',
            wni_lat: 54.32,
            wni_lon: -4.37,
            wni_tz: 'Europe/Isle_of_Man',
        },
        {
            option: 'BEY',
            wni_port_name: 'BEYPORE',
            wni_unlocode: 'INBEY',
            wni_country: 'IN',
            wni_lat: 11.17,
            wni_lon: 75.8,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'BNR',
            wni_port_name: 'BHAVNAGAR',
            wni_unlocode: 'INBHU',
            wni_country: 'IN',
            wni_lat: 21.78,
            wni_lon: 72.15,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'CLCT',
            wni_port_name: 'CALICUT',
            wni_unlocode: 'INCCJ',
            wni_country: 'IN',
            wni_lat: 11.25,
            wni_lon: 75.77,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'CNNR',
            wni_port_name: 'CANNANORE',
            wni_unlocode: 'INCNN',
            wni_country: 'IN',
            wni_lat: 11.87,
            wni_lon: 75.37,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'CUD',
            wni_port_name: 'CUDDALORE',
            wni_unlocode: 'INCDL',
            wni_country: 'IN',
            wni_lat: 11.72,
            wni_lon: 79.77,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'DHA',
            wni_port_name: 'DHARAMTAR',
            wni_unlocode: 'INDMT',
            wni_country: 'IN',
            wni_lat: 18.9,
            wni_lon: 72.81,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'DRMTR',
            wni_port_name: 'DHARAMTAR',
            wni_unlocode: 'INDMT',
            wni_country: 'IN',
            wni_lat: 18.55,
            wni_lon: 72.4,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'HNVR',
            wni_port_name: 'HONAVAR',
            wni_unlocode: 'INHON',
            wni_country: 'IN',
            wni_lat: 14.28,
            wni_lon: 74.45,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'JAFA',
            wni_port_name: 'JAFARABAD',
            wni_unlocode: 'INJBD',
            wni_country: 'IN',
            wni_lat: 20.87,
            wni_lon: 71.38,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'JAW',
            wni_port_name: 'JAWAHARLAL NEHRU PORT',
            wni_unlocode: 'INNSA',
            wni_country: 'IN',
            wni_lat: 18.95,
            wni_lon: 72.87,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'KAI1',
            wni_port_name: 'KAKINADA',
            wni_unlocode: 'INKAK',
            wni_country: 'IN',
            wni_lat: 16.98,
            wni_lon: 82.28,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'MAD',
            wni_port_name: 'MADRAS',
            wni_unlocode: 'INMAA',
            wni_country: 'IN',
            wni_lat: 13.1,
            wni_lon: 80.3,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'MDVI',
            wni_port_name: 'MANDVI',
            wni_unlocode: 'INMDV',
            wni_country: 'IN',
            wni_lat: 22.83,
            wni_lon: 69.35,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'MGA',
            wni_port_name: 'MANGALORE',
            wni_unlocode: 'INIXE',
            wni_country: 'IN',
            wni_lat: 12.85,
            wni_lon: 74.83,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'MGL',
            wni_port_name: 'MAGDALLA',
            wni_unlocode: 'INMDA',
            wni_country: 'IN',
            wni_lat: 21.14,
            wni_lon: 72.74,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'NEE',
            wni_port_name: 'NEENDAKARA',
            wni_unlocode: 'INNEE',
            wni_country: 'IN',
            wni_lat: 8.88,
            wni_lon: 76.58,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'PBLR',
            wni_port_name: 'PORT BLAIR',
            wni_unlocode: 'INIXZ',
            wni_country: 'IN',
            wni_lat: 11.68,
            wni_lon: 92.75,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'PON',
            wni_port_name: 'PONDICHERRY',
            wni_unlocode: 'INPNY',
            wni_country: 'IN',
            wni_lat: 11.93,
            wni_lon: 79.83,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'SAY',
            wni_port_name: 'SALAYA',
            wni_unlocode: 'INSAL',
            wni_country: 'IN',
            wni_lat: 22.31,
            wni_lon: 69.6,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'THLSS',
            wni_port_name: 'TELLICHERRY',
            wni_unlocode: 'INTEL',
            wni_country: 'IN',
            wni_lat: 11.75,
            wni_lon: 75.48,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'TRVND',
            wni_port_name: 'TRIVANDRUM',
            wni_unlocode: 'INTRV',
            wni_country: 'IN',
            wni_lat: 8.48,
            wni_lon: 76.95,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'VRV',
            wni_port_name: 'VERAVAL',
            wni_unlocode: 'INVVA',
            wni_country: 'IN',
            wni_lat: 20.9,
            wni_lon: 70.37,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'DIEG',
            wni_port_name: 'DIEGO GARCIA',
            wni_unlocode: 'IODGA',
            wni_country: 'IO',
            wni_lat: -7.35,
            wni_lon: 72.47,
            wni_tz: 'Indian/Chagos',
        },
        {
            option: 'BASR',
            wni_port_name: 'BANDAR SHAHID REJAIE',
            wni_unlocode: 'IRBSR',
            wni_country: 'IR',
            wni_lat: 27.1,
            wni_lon: 56.07,
            wni_tz: 'Asia/Tehran',
        },
        {
            option: 'BDRI',
            wni_port_name: 'BANDAR IMAM',
            wni_unlocode: 'IRBKM',
            wni_country: 'IR',
            wni_lat: 30.42,
            wni_lon: 49.09,
            wni_tz: 'Asia/Tehran',
        },
        {
            option: 'AKR',
            wni_port_name: 'AKRANES',
            wni_unlocode: 'ISAKR',
            wni_country: 'IS',
            wni_lat: 64.31,
            wni_lon: -22.08,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'AKU',
            wni_port_name: 'AKUREYRI',
            wni_unlocode: 'ISAKU',
            wni_country: 'IS',
            wni_lat: 65.68,
            wni_lon: -18.08,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'DJPVG',
            wni_port_name: 'DJUPIVOGUR',
            wni_unlocode: 'ISDJU',
            wni_country: 'IS',
            wni_lat: 64.67,
            wni_lon: -14.28,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'ESF',
            wni_port_name: 'ESKIFJORDUR',
            wni_unlocode: 'ISESK',
            wni_country: 'IS',
            wni_lat: 65.07,
            wni_lon: -14.02,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'GFJ',
            wni_port_name: 'GRUNDARFJORD',
            wni_unlocode: 'ISGRF',
            wni_country: 'IS',
            wni_lat: 64.92,
            wni_lon: -23.25,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'GRVK',
            wni_port_name: 'GRINDAVIK',
            wni_unlocode: 'ISGRI',
            wni_country: 'IS',
            wni_lat: 63.84,
            wni_lon: -22.42,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'HFDR',
            wni_port_name: 'HAFNARFJORDUR',
            wni_unlocode: 'ISHAF',
            wni_country: 'IS',
            wni_lat: 64.07,
            wni_lon: -21.95,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'HOEFN',
            wni_port_name: 'HOFN',
            wni_unlocode: 'ISHFN',
            wni_country: 'IS',
            wni_lat: 64.25,
            wni_lon: -15.23,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'HUSVK',
            wni_port_name: 'HUSAVIK',
            wni_unlocode: 'ISHUS',
            wni_country: 'IS',
            wni_lat: 66.03,
            wni_lon: -17.33,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'HVLFJ',
            wni_port_name: 'HVALFJORDUR',
            wni_unlocode: 'ISHVR',
            wni_country: 'IS',
            wni_lat: 64.27,
            wni_lon: -22,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'ISFJR',
            wni_port_name: 'ISAFJORDUR',
            wni_unlocode: 'ISISA',
            wni_country: 'IS',
            wni_lat: 66.07,
            wni_lon: -23.12,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'KEF',
            wni_port_name: 'KEFLAVIK',
            wni_unlocode: 'ISKEF',
            wni_country: 'IS',
            wni_lat: 64,
            wni_lon: -22.55,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'NES',
            wni_port_name: 'NESKAUPSTADUR',
            wni_unlocode: 'ISNES',
            wni_country: 'IS',
            wni_lat: 65.15,
            wni_lon: -13.68,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'RFRHF',
            wni_port_name: 'RAUFARHOFN',
            wni_unlocode: 'ISRAU',
            wni_country: 'IS',
            wni_lat: 66.45,
            wni_lon: -15.93,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'RYK',
            wni_port_name: 'REYKJAVIK',
            wni_unlocode: 'ISREY',
            wni_country: 'IS',
            wni_lat: 64.15,
            wni_lon: -21.93,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'SDRKR',
            wni_port_name: 'SAUDARKROKUR',
            wni_unlocode: 'ISSAU',
            wni_country: 'IS',
            wni_lat: 65.75,
            wni_lon: -19.67,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'SKGST',
            wni_port_name: 'SKAGASTROND',
            wni_unlocode: 'ISSKA',
            wni_country: 'IS',
            wni_lat: 65.83,
            wni_lon: -20.32,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'SKRJF',
            wni_port_name: 'SKERJAFJORDUR',
            wni_unlocode: 'ISKJF',
            wni_country: 'IS',
            wni_lat: 64.15,
            wni_lon: -22.02,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'STYKK',
            wni_port_name: 'STYKKISHOLMUR',
            wni_unlocode: 'ISSTY',
            wni_country: 'IS',
            wni_lat: 65.08,
            wni_lon: -22.72,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'ALGHR',
            wni_port_name: 'ALGHERO',
            wni_unlocode: 'ITAHO',
            wni_country: 'IT',
            wni_lat: 40.57,
            wni_lon: 8.32,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'ANZIO',
            wni_port_name: 'ANZIO',
            wni_unlocode: 'ITANZ',
            wni_country: 'IT',
            wni_lat: 41.45,
            wni_lon: 12.63,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'ATX',
            wni_port_name: 'ARBATAX',
            wni_unlocode: 'ITATX',
            wni_country: 'IT',
            wni_lat: 39.93,
            wni_lon: 9.72,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'AZZRR',
            wni_port_name: 'PORTO AZZURRO',
            wni_unlocode: 'ITPAZ',
            wni_country: 'IT',
            wni_lat: 42.77,
            wni_lon: 10.4,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'BAG',
            wni_port_name: 'BAGNOLI',
            wni_unlocode: 'ITBLN',
            wni_country: 'IT',
            wni_lat: 40.82,
            wni_lon: 14.17,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'BAIA',
            wni_port_name: 'BAIA',
            wni_unlocode: 'ITBAI',
            wni_country: 'IT',
            wni_lat: 40.82,
            wni_lon: 14.07,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'BARI',
            wni_port_name: 'BARI',
            wni_unlocode: 'ITBRI',
            wni_country: 'IT',
            wni_lat: 41.13,
            wni_lon: 16.87,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'BTT',
            wni_port_name: 'BARLETTA',
            wni_unlocode: 'ITBLT',
            wni_country: 'IT',
            wni_lat: 41.32,
            wni_lon: 16.28,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'CCE',
            wni_port_name: 'CASTELLAMMARE DI STABIA',
            wni_unlocode: 'ITCAS',
            wni_country: 'IT',
            wni_lat: 40.68,
            wni_lon: 14.48,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'CIO',
            wni_port_name: 'CIRO MARINA',
            wni_unlocode: 'ITMRM',
            wni_country: 'IT',
            wni_lat: 39.37,
            wni_lon: 17.14,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'CRLF',
            wni_port_name: 'CARLOFORTE',
            wni_unlocode: 'ITCLF',
            wni_country: 'IT',
            wni_lat: 39.15,
            wni_lon: 8.32,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'CRSNI',
            wni_port_name: 'PORTO CORSINI',
            wni_unlocode: 'ITPCS',
            wni_country: 'IT',
            wni_lat: 44.48,
            wni_lon: 12.28,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'FLC',
            wni_port_name: 'FOLLONICA',
            wni_unlocode: 'ITFOL',
            wni_country: 'IT',
            wni_lat: 42.92,
            wni_lon: 10.77,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'FLCNA',
            wni_port_name: 'FALCONARA',
            wni_unlocode: 'ITFAL',
            wni_country: 'IT',
            wni_lat: 43.65,
            wni_lon: 13.4,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'FORMA',
            wni_port_name: 'FORMIA',
            wni_unlocode: 'ITFOM',
            wni_country: 'IT',
            wni_lat: 41.25,
            wni_lon: 13.6,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'FSA',
            wni_port_name: 'FUSINA',
            wni_unlocode: 'ITFSA',
            wni_country: 'IT',
            wni_lat: 45.42,
            wni_lon: 12.26,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'GIP',
            wni_port_name: 'GALLIPOLI',
            wni_unlocode: 'ITGAL',
            wni_country: 'IT',
            wni_lat: 40.05,
            wni_lon: 17.98,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'IMP',
            wni_port_name: 'IMPERIA',
            wni_unlocode: 'ITIMP',
            wni_country: 'IT',
            wni_lat: 43.88,
            wni_lon: 8.02,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'IMRS',
            wni_port_name: 'TERMINI IMERESE',
            wni_unlocode: 'ITTRI',
            wni_country: 'IT',
            wni_lat: 37.98,
            wni_lon: 13.7,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'LAMP',
            wni_port_name: 'LAMPEDUSA',
            wni_unlocode: 'ITLMP',
            wni_country: 'IT',
            wni_lat: 35.5,
            wni_lon: 12.6,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'LGH',
            wni_port_name: 'LEGHORN',
            wni_unlocode: 'ITLIV',
            wni_country: 'IT',
            wni_lat: 43.55,
            wni_lon: 10.29,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'LIC',
            wni_port_name: 'LICATA',
            wni_unlocode: 'ITLIC',
            wni_country: 'IT',
            wni_lat: 37.1,
            wni_lon: 13.93,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'LIP',
            wni_port_name: 'LIPARI',
            wni_unlocode: 'ITLIP',
            wni_country: 'IT',
            wni_lat: 38.47,
            wni_lon: 14.95,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'MARZ',
            wni_port_name: 'MARSALA',
            wni_unlocode: 'ITMRA',
            wni_country: 'IT',
            wni_lat: 37.78,
            wni_lon: 12.43,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'MDDLN',
            wni_port_name: 'MADDALENA',
            wni_unlocode: 'ITMDA',
            wni_country: 'IT',
            wni_lat: 41.22,
            wni_lon: 9.43,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'MDO',
            wni_port_name: 'MAZARA DEL VALLO',
            wni_unlocode: 'ITMAZ',
            wni_country: 'IT',
            wni_lat: 37.65,
            wni_lon: 12.55,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'MES',
            wni_port_name: 'MESSINA',
            wni_unlocode: 'ITMSN',
            wni_country: 'IT',
            wni_lat: 38.2,
            wni_lon: 15.57,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'MFD',
            wni_port_name: 'MANFREDONIA',
            wni_unlocode: 'ITMFR',
            wni_country: 'IT',
            wni_lat: 41.62,
            wni_lon: 15.92,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'MGH',
            wni_port_name: 'MARGHERA',
            wni_unlocode: 'ITPMA',
            wni_country: 'IT',
            wni_lat: 45.45,
            wni_lon: 12.26,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'MLFTT',
            wni_port_name: 'MOLFETTA',
            wni_unlocode: 'ITMOL',
            wni_country: 'IT',
            wni_lat: 41.2,
            wni_lon: 16.6,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'MNPL',
            wni_port_name: 'MONOPOLI',
            wni_unlocode: 'ITMNP',
            wni_country: 'IT',
            wni_lat: 40.95,
            wni_lon: 17.3,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'MRNR',
            wni_port_name: 'RIO MARINA',
            wni_unlocode: 'ITRMA',
            wni_country: 'IT',
            wni_lat: 42.82,
            wni_lon: 10.43,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'NGO',
            wni_port_name: 'PORTO NOGARO',
            wni_unlocode: 'ITPNG',
            wni_country: 'IT',
            wni_lat: 45.8,
            wni_lon: 13.23,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'ORT',
            wni_port_name: 'ORTONA',
            wni_unlocode: 'ITOTN',
            wni_country: 'IT',
            wni_lat: 42.35,
            wni_lon: 14.42,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'OTRTO',
            wni_port_name: 'OTRANTO',
            wni_unlocode: 'ITOTO',
            wni_country: 'IT',
            wni_lat: 40.15,
            wni_lon: 18.5,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'PALAU',
            wni_port_name: 'PALAU',
            wni_unlocode: 'ITPAU',
            wni_country: 'IT',
            wni_lat: 41.18,
            wni_lon: 9.38,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'PEM',
            wni_port_name: 'PORTO EMPEDOCLE',
            wni_unlocode: 'ITPEM',
            wni_country: 'IT',
            wni_lat: 37.28,
            wni_lon: 13.53,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'PESRO',
            wni_port_name: 'PESARO',
            wni_unlocode: 'ITPES',
            wni_country: 'IT',
            wni_lat: 43.92,
            wni_lon: 12.9,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'PNTLL',
            wni_port_name: 'PANTELLERIA',
            wni_unlocode: 'ITPNL',
            wni_country: 'IT',
            wni_lat: 36.83,
            wni_lon: 11.95,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'POZ',
            wni_port_name: 'POZZUOLI',
            wni_unlocode: 'ITPOZ',
            wni_country: 'IT',
            wni_lat: 40.83,
            wni_lon: 14.12,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'PRL',
            wni_port_name: 'PRIOLO',
            wni_unlocode: 'ITPRI',
            wni_country: 'IT',
            wni_lat: 37.16,
            wni_lon: 15.21,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'PRTCE',
            wni_port_name: 'PORTICI',
            wni_unlocode: 'ITPTC',
            wni_country: 'IT',
            wni_lat: 40.82,
            wni_lon: 14.33,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'PRTFR',
            wni_port_name: 'PORTOFERRAIO',
            wni_unlocode: 'ITPFE',
            wni_country: 'IT',
            wni_lat: 42.82,
            wni_lon: 10.33,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'PSCR',
            wni_port_name: 'PESCARA',
            wni_unlocode: 'ITPSR',
            wni_country: 'IT',
            wni_lat: 42.47,
            wni_lon: 14.23,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'SANR',
            wni_port_name: 'SAN REMO',
            wni_unlocode: 'ITSRE',
            wni_country: 'IT',
            wni_lat: 43.82,
            wni_lon: 7.77,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'SPGA',
            wni_port_name: 'SANTA PANAGIA',
            wni_unlocode: 'ITSPA',
            wni_country: 'IT',
            wni_lat: 37.12,
            wni_lon: 15.27,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'SRRNT',
            wni_port_name: 'SORRENTO',
            wni_unlocode: 'ITRRO',
            wni_country: 'IT',
            wni_lat: 40.63,
            wni_lon: 14.38,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'SRU',
            wni_port_name: 'SIRACUSA',
            wni_unlocode: 'ITSIR',
            wni_country: 'IT',
            wni_lat: 37.05,
            wni_lon: 15.28,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'STFN',
            wni_port_name: 'PORTO SANTO STEFANO',
            wni_unlocode: 'ITPSS',
            wni_country: 'IT',
            wni_lat: 42.43,
            wni_lon: 11.12,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'TLM',
            wni_port_name: 'TALAMONE',
            wni_unlocode: 'ITTAL',
            wni_country: 'IT',
            wni_lat: 42.56,
            wni_lon: 11.13,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'VADA',
            wni_port_name: 'VADA',
            wni_unlocode: 'ITVDA',
            wni_country: 'IT',
            wni_lat: 43.35,
            wni_lon: 10.47,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'VDO',
            wni_port_name: 'VADO LIGURE',
            wni_unlocode: 'ITVDL',
            wni_country: 'IT',
            wni_lat: 44.27,
            wni_lon: 8.45,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'VTO',
            wni_port_name: 'VASTO',
            wni_unlocode: 'ITVSO',
            wni_country: 'IT',
            wni_lat: 42.12,
            wni_lon: 14.72,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'VVA',
            wni_port_name: 'VIBO VALENTIA MARINA',
            wni_unlocode: 'ITVVA',
            wni_country: 'IT',
            wni_lat: 38.72,
            wni_lon: 16.13,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'BLKJM',
            wni_port_name: 'BLACK RIVER',
            wni_unlocode: 'JMBLR',
            wni_country: 'JM',
            wni_lat: 18,
            wni_lon: -77.88,
            wni_tz: 'America/Jamaica',
        },
        {
            option: 'BUENO',
            wni_port_name: 'RIO BUENO',
            wni_unlocode: 'JMRIB',
            wni_country: 'JM',
            wni_lat: 18.47,
            wni_lon: -77.47,
            wni_tz: 'America/Jamaica',
        },
        {
            option: 'DSCVR',
            wni_port_name: 'DISCOVERY BAY',
            wni_unlocode: 'USDYY',
            wni_country: 'JM',
            wni_lat: 18.47,
            wni_lon: -77.4,
            wni_tz: 'America/Jamaica',
        },
        {
            option: 'LUCEA',
            wni_port_name: 'LUCEA',
            wni_unlocode: 'JMLUC',
            wni_country: 'JM',
            wni_lat: 18.45,
            wni_lon: -78.17,
            wni_tz: 'America/Jamaica',
        },
        {
            option: 'PES',
            wni_port_name: 'PORT ESQUIVEL',
            wni_unlocode: 'JMPEV',
            wni_country: 'JM',
            wni_lat: 17.89,
            wni_lon: -77.13,
            wni_tz: 'America/Jamaica',
        },
        {
            option: 'PJM',
            wni_port_name: 'PORT ANTONIO',
            wni_unlocode: 'JMPOT',
            wni_country: 'JM',
            wni_lat: 18.18,
            wni_lon: -76.45,
            wni_tz: 'America/Jamaica',
        },
        {
            option: 'SVNN',
            wni_port_name: 'SAVANNA LA MAR',
            wni_unlocode: 'JMSLM',
            wni_country: 'JM',
            wni_lat: 18.2,
            wni_lon: -78.13,
            wni_tz: 'America/Jamaica',
        },
        {
            option: 'ISW',
            wni_port_name: 'ISHIKAWA',
            wni_unlocode: 'JPFRJ',
            wni_country: 'JP',
            wni_lat: 26.43,
            wni_lon: 127.83,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SKIT',
            wni_port_name: 'SAKITO',
            wni_unlocode: 'JPSTO',
            wni_country: 'JP',
            wni_lat: 33.02,
            wni_lon: 129.57,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HAA',
            wni_port_name: 'HAKATA',
            wni_unlocode: 'JPHKT',
            wni_country: 'JP',
            wni_lat: 33.6,
            wni_lon: 130.4,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MIIK',
            wni_port_name: 'MIIKE',
            wni_unlocode: 'JPMII',
            wni_country: 'JP',
            wni_lat: 33,
            wni_lon: 130.42,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'YAT',
            wni_port_name: 'YATSUSHIRO',
            wni_unlocode: 'JPYAT',
            wni_country: 'JP',
            wni_lat: 32.5,
            wni_lon: 130.58,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KANMN',
            wni_port_name: 'KANMON',
            wni_unlocode: 'JPKNM',
            wni_country: 'JP',
            wni_lat: 33.91,
            wni_lon: 130.82,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KKR',
            wni_port_name: 'KOKURA',
            wni_unlocode: 'JPKOK',
            wni_country: 'JP',
            wni_lat: 33.88,
            wni_lon: 130.88,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KANDA',
            wni_port_name: 'KANDA',
            wni_unlocode: 'JPKND',
            wni_country: 'JP',
            wni_lat: 33.78,
            wni_lon: 130.98,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KSH',
            wni_port_name: 'KUSHIMA',
            wni_unlocode: 'JPFKF',
            wni_country: 'JP',
            wni_lat: 31.45,
            wni_lon: 131.2,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MTJ',
            wni_port_name: 'MITAJIRI',
            wni_unlocode: 'JPMJR',
            wni_country: 'JP',
            wni_lat: 34,
            wni_lon: 131.55,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HOFU',
            wni_port_name: 'HOFU',
            wni_unlocode: 'JPCHF',
            wni_country: 'JP',
            wni_lat: 34.03,
            wni_lon: 131.6,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NGH',
            wni_port_name: 'NAGAHAMA',
            wni_unlocode: 'JPNGH',
            wni_country: 'JP',
            wni_lat: 33.27,
            wni_lon: 131.63,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SHUNN',
            wni_port_name: 'TOKUYAMA',
            wni_unlocode: 'JPTKY',
            wni_country: 'JP',
            wni_lat: 34.03,
            wni_lon: 131.82,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HKR',
            wni_port_name: 'HIKARI',
            wni_unlocode: 'JPHKR',
            wni_country: 'JP',
            wni_lat: 33.95,
            wni_lon: 131.95,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HAMDA',
            wni_port_name: 'HAMADA',
            wni_unlocode: 'JPHMD',
            wni_country: 'JP',
            wni_lat: 34.9,
            wni_lon: 132.08,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'IWKN',
            wni_port_name: 'IWAKUNI',
            wni_unlocode: 'JPIWK',
            wni_country: 'JP',
            wni_lat: 34.18,
            wni_lon: 132.25,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'IKA',
            wni_port_name: 'IKATA',
            wni_unlocode: 'JPNIT',
            wni_country: 'JP',
            wni_lat: 33.48,
            wni_lon: 132.35,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'YWTHM',
            wni_port_name: 'YAWATAHAMA',
            wni_unlocode: 'JPYWH',
            wni_country: 'JP',
            wni_lat: 33.45,
            wni_lon: 132.42,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NGAHM',
            wni_port_name: 'NAGAHAMA',
            wni_unlocode: 'JPNGH',
            wni_country: 'JP',
            wni_lat: 33.62,
            wni_lon: 132.49,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'UWJ',
            wni_port_name: 'UWAJIMA',
            wni_unlocode: 'JPUWA',
            wni_country: 'JP',
            wni_lat: 33.22,
            wni_lon: 132.57,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KNO',
            wni_port_name: 'KINOE',
            wni_unlocode: 'JPKNE',
            wni_country: 'JP',
            wni_lat: 34.24,
            wni_lon: 132.92,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SAIJE',
            wni_port_name: 'SAIJO',
            wni_unlocode: 'JPSAJ',
            wni_country: 'JP',
            wni_lat: 33.94,
            wni_lon: 133.14,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'ONOM',
            wni_port_name: 'ONOMICHI',
            wni_unlocode: 'JPONO',
            wni_country: 'JP',
            wni_lat: 34.4,
            wni_lon: 133.2,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NIIHM',
            wni_port_name: 'NIIHAMA',
            wni_unlocode: 'JPIHA',
            wni_country: 'JP',
            wni_lat: 33.97,
            wni_lon: 133.27,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TAM',
            wni_port_name: 'TAMANO',
            wni_unlocode: 'JPTAM',
            wni_country: 'JP',
            wni_lat: 34.49,
            wni_lon: 133.95,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TOT',
            wni_port_name: 'TOTTORI',
            wni_unlocode: 'JPAZJ',
            wni_country: 'JP',
            wni_lat: 35.54,
            wni_lon: 134.19,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'AIO',
            wni_port_name: 'AIOI',
            wni_unlocode: 'JPAIO',
            wni_country: 'JP',
            wni_lat: 34.78,
            wni_lon: 134.47,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'ABO',
            wni_port_name: 'ABOSHI',
            wni_unlocode: 'JPABO',
            wni_country: 'JP',
            wni_lat: 34.78,
            wni_lon: 134.61,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HRH',
            wni_port_name: 'HIROHATA',
            wni_unlocode: 'JPHRH',
            wni_country: 'JP',
            wni_lat: 34.78,
            wni_lon: 134.63,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SIKM',
            wni_port_name: 'SHIKAMA',
            wni_unlocode: 'JPSKM',
            wni_country: 'JP',
            wni_lat: 34.78,
            wni_lon: 134.66,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TKSG',
            wni_port_name: 'TAKAWNIO',
            wni_unlocode: 'JPTSG',
            wni_country: 'JP',
            wni_lat: 34.79,
            wni_lon: 134.66,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'AAN',
            wni_port_name: 'ANAN',
            wni_unlocode: 'JPANA',
            wni_country: 'JP',
            wni_lat: 33.87,
            wni_lon: 134.69,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KAK',
            wni_port_name: 'KAKOGAWA',
            wni_unlocode: 'JPKGA',
            wni_country: 'JP',
            wni_lat: 34.7,
            wni_lon: 134.83,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HDK',
            wni_port_name: 'HIDAKA',
            wni_unlocode: 'JPHDK',
            wni_country: 'JP',
            wni_lat: 33.88,
            wni_lon: 135.13,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'WAK',
            wni_port_name: 'WAKAYAMA',
            wni_unlocode: 'JPWAK',
            wni_country: 'JP',
            wni_lat: 34.23,
            wni_lon: 135.13,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'AMG',
            wni_port_name: 'AMAGASAKI',
            wni_unlocode: 'JPAMA',
            wni_country: 'JP',
            wni_lat: 34.68,
            wni_lon: 135.35,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KIS',
            wni_port_name: 'KISHIWADA',
            wni_unlocode: 'JPKDA',
            wni_country: 'JP',
            wni_lat: 34.47,
            wni_lon: 135.36,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'UCH',
            wni_port_name: 'UCHIURA',
            wni_unlocode: 'JPUCR',
            wni_country: 'JP',
            wni_lat: 35.53,
            wni_lon: 135.5,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TAKAS',
            wni_port_name: 'TAKASU',
            wni_unlocode: 'JPTXK',
            wni_country: 'JP',
            wni_lat: 36.13,
            wni_lon: 136.06,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TSRG',
            wni_port_name: 'TSURUGA',
            wni_unlocode: 'JPTRG',
            wni_country: 'JP',
            wni_lat: 35.65,
            wni_lon: 136.07,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TSMSK',
            wni_port_name: 'TSUMATSUSAKA',
            wni_unlocode: 'JPTSU',
            wni_country: 'JP',
            wni_lat: 34.71,
            wni_lon: 136.54,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TSU',
            wni_port_name: 'TSU',
            wni_unlocode: 'JPTSU',
            wni_country: 'JP',
            wni_lat: 34.68,
            wni_lon: 136.55,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TKN',
            wni_port_name: 'TOKAI',
            wni_unlocode: 'JPTKA',
            wni_country: 'JP',
            wni_lat: 35.07,
            wni_lon: 136.87,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TKIS',
            wni_port_name: 'TOKAI',
            wni_unlocode: 'JPTKA',
            wni_country: 'JP',
            wni_lat: 35.05,
            wni_lon: 136.88,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HEK',
            wni_port_name: 'HEKINAN',
            wni_unlocode: 'JPHKN',
            wni_country: 'JP',
            wni_lat: 34.89,
            wni_lon: 136.97,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TOY3',
            wni_port_name: 'TOYAMA-SHINKO',
            wni_unlocode: 'JPTOS',
            wni_country: 'JP',
            wni_lat: 36.77,
            wni_lon: 137.11,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'THYSH',
            wni_port_name: 'TOYOHASHI',
            wni_unlocode: 'JPTHS',
            wni_country: 'JP',
            wni_lat: 34.72,
            wni_lon: 137.33,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NOU',
            wni_port_name: 'NO',
            wni_unlocode: 'JPUTO',
            wni_country: 'JP',
            wni_lat: 37.11,
            wni_lon: 137.99,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KAZ',
            wni_port_name: 'KASHIWAZAKI',
            wni_unlocode: 'JPKWZ',
            wni_country: 'JP',
            wni_lat: 37.37,
            wni_lon: 138.54,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KRI',
            wni_port_name: 'KURIHAMA',
            wni_unlocode: 'JPKRH',
            wni_country: 'JP',
            wni_lat: 35.22,
            wni_lon: 139.72,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'OGI',
            wni_port_name: 'OGISHIMA',
            wni_unlocode: 'JPHIO',
            wni_country: 'JP',
            wni_lat: 35.48,
            wni_lon: 139.72,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KIM',
            wni_port_name: 'KIMITSU',
            wni_unlocode: 'JPKMT',
            wni_country: 'JP',
            wni_lat: 35.33,
            wni_lon: 139.82,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NSR',
            wni_port_name: 'NOSHIRO',
            wni_unlocode: 'JPNSR',
            wni_country: 'JP',
            wni_lat: 40.2,
            wni_lon: 140,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'CHB',
            wni_port_name: 'CHIBA',
            wni_unlocode: 'JPCHB',
            wni_country: 'JP',
            wni_lat: 35.58,
            wni_lon: 140.03,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'IHA',
            wni_port_name: 'ICHIHARA',
            wni_unlocode: 'JPICH',
            wni_country: 'JP',
            wni_lat: 35.55,
            wni_lon: 140.06,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'AKI',
            wni_port_name: 'AKITA',
            wni_unlocode: 'JPAXT',
            wni_country: 'JP',
            wni_lat: 39.75,
            wni_lon: 140.07,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KSIMA',
            wni_port_name: 'KASHIMA',
            wni_unlocode: 'JPKSM',
            wni_country: 'JP',
            wni_lat: 35.93,
            wni_lon: 140.7,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'OTR',
            wni_port_name: 'OTARU',
            wni_unlocode: 'JPOTR',
            wni_country: 'JP',
            wni_lat: 43.2,
            wni_lon: 141.02,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SEN',
            wni_port_name: 'SENDAI',
            wni_unlocode: 'JPSGM',
            wni_country: 'JP',
            wni_lat: 38.27,
            wni_lon: 141.02,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SNSGM',
            wni_port_name: 'SENDAISHIOGAMA',
            wni_unlocode: 'JPSGM',
            wni_country: 'JP',
            wni_lat: 38.29,
            wni_lon: 141.09,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'ISHMK',
            wni_port_name: 'ISHINOMAKI',
            wni_unlocode: 'JPISM',
            wni_country: 'JP',
            wni_lat: 38.45,
            wni_lon: 141.32,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'ONGW',
            wni_port_name: 'ONAGAWA',
            wni_unlocode: 'JPONG',
            wni_country: 'JP',
            wni_lat: 38.45,
            wni_lon: 141.45,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KSU',
            wni_port_name: 'KESENNUMA',
            wni_unlocode: 'JPKSN',
            wni_country: 'JP',
            wni_lat: 38.87,
            wni_lon: 141.6,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KUJI',
            wni_port_name: 'KUJI',
            wni_unlocode: 'JPKJI',
            wni_country: 'JP',
            wni_lat: 40.19,
            wni_lon: 141.81,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'YAMAD',
            wni_port_name: 'YAMADA',
            wni_unlocode: 'JPYQD',
            wni_country: 'JP',
            wni_lat: 39.47,
            wni_lon: 141.97,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'LAMU',
            wni_port_name: 'LAMU',
            wni_unlocode: 'KELAU',
            wni_country: 'KE',
            wni_lat: -2.25,
            wni_lon: 40.9,
            wni_tz: 'Africa/Nairobi',
        },
        {
            option: 'MLND',
            wni_port_name: 'MALINDI',
            wni_unlocode: 'KEMYD',
            wni_country: 'KE',
            wni_lat: -3.22,
            wni_lon: 40.13,
            wni_tz: 'Africa/Nairobi',
        },
        {
            option: 'KMPOT',
            wni_port_name: 'KAMPOT',
            wni_unlocode: 'KHKMT',
            wni_country: 'KH',
            wni_lat: 10.6,
            wni_lon: 104.18,
            wni_tz: 'Asia/Phnom_Penh',
        },
        {
            option: 'FMBN',
            wni_port_name: 'FOMBONI',
            wni_unlocode: 'KMFOU',
            wni_country: 'KM',
            wni_lat: -12.27,
            wni_lon: 43.75,
            wni_tz: 'Indian/Comoro',
        },
        {
            option: 'CTW',
            wni_port_name: 'CHARLESTOWN',
            wni_unlocode: 'KNNEV',
            wni_country: 'KN',
            wni_lat: 17.13,
            wni_lon: -62.62,
            wni_tz: 'America/St_Kitts',
        },
        {
            option: 'CNG',
            wni_port_name: 'CHONGJIN',
            wni_unlocode: 'KPCHO',
            wni_country: 'KP',
            wni_lat: 41.77,
            wni_lon: 129.82,
            wni_tz: 'Asia/Pyongyang',
        },
        {
            option: 'HAE',
            wni_port_name: 'HAEJU',
            wni_unlocode: 'KPHAE',
            wni_country: 'KP',
            wni_lat: 37.99,
            wni_lon: 125.7,
            wni_tz: 'Asia/Pyongyang',
        },
        {
            option: 'HUG',
            wni_port_name: 'HUNGNAM',
            wni_unlocode: 'KPHGM',
            wni_country: 'KP',
            wni_lat: 39.83,
            wni_lon: 127.62,
            wni_tz: 'Asia/Pyongyang',
        },
        {
            option: 'WON',
            wni_port_name: 'WONSAN',
            wni_unlocode: 'KPWON',
            wni_country: 'KP',
            wni_lat: 39.17,
            wni_lon: 127.45,
            wni_tz: 'Asia/Pyongyang',
        },
        {
            option: 'CHN',
            wni_port_name: 'CHINHAE',
            wni_unlocode: 'KRCHF',
            wni_country: 'KR',
            wni_lat: 35.09,
            wni_lon: 128.76,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'DAEB',
            wni_port_name: 'DAEBUL',
            wni_unlocode: 'KRDBL',
            wni_country: 'KR',
            wni_lat: 34.83,
            wni_lon: 126.46,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'DNG',
            wni_port_name: 'DONGHAE',
            wni_unlocode: 'KRTGH',
            wni_country: 'KR',
            wni_lat: 37.49,
            wni_lon: 129.14,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'JIN',
            wni_port_name: 'JINHAE',
            wni_unlocode: 'KRCHF',
            wni_country: 'KR',
            wni_lat: 35.15,
            wni_lon: 128.67,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'SWK',
            wni_port_name: 'SHUWAIKH',
            wni_unlocode: 'KWSWK',
            wni_country: 'KW',
            wni_lat: 29.35,
            wni_lon: 47.93,
            wni_tz: 'Asia/Kuwait',
        },
        {
            option: 'KRYK',
            wni_port_name: 'KURYK',
            wni_unlocode: 'KZKUR',
            wni_country: 'KZ',
            wni_lat: 43.18,
            wni_lon: 51.6,
            wni_tz: 'Asia/Oral',
        },
        {
            option: 'CKA',
            wni_port_name: 'CHEKKA',
            wni_unlocode: 'LBCHK',
            wni_country: 'LB',
            wni_lat: 34.37,
            wni_lon: 35.75,
            wni_tz: 'Asia/Beirut',
        },
        {
            option: 'SELA',
            wni_port_name: 'SELAATA',
            wni_unlocode: 'LBSEL',
            wni_country: 'LB',
            wni_lat: 34.28,
            wni_lon: 35.66,
            wni_tz: 'Asia/Beirut',
        },
        {
            option: 'KKS',
            wni_port_name: 'KANKESANTURAI',
            wni_unlocode: 'LKKNK',
            wni_country: 'LK',
            wni_lat: 9.82,
            wni_lon: 80.05,
            wni_tz: 'Asia/Colombo',
        },
        {
            option: 'CPP',
            wni_port_name: 'CAPE PALMAS',
            wni_unlocode: 'LRCPA',
            wni_country: 'LR',
            wni_lat: 4.37,
            wni_lon: -7.72,
            wni_tz: 'Africa/Monrovia',
        },
        {
            option: 'GVILL',
            wni_port_name: 'GREENVILLE',
            wni_unlocode: 'LRGRE',
            wni_country: 'LR',
            wni_lat: 4.98,
            wni_lon: -9.05,
            wni_tz: 'Africa/Monrovia',
        },
        {
            option: 'SLCGR',
            wni_port_name: 'SALACGRIVA',
            wni_unlocode: 'LVSAL',
            wni_country: 'LV',
            wni_lat: 57.76,
            wni_lon: 24.35,
            wni_tz: 'Europe/Riga',
        },
        {
            option: 'ABUK',
            wni_port_name: 'ABU KAMMASH',
            wni_unlocode: 'LYABK',
            wni_country: 'LY',
            wni_lat: 33.08,
            wni_lon: 11.83,
            wni_tz: 'Africa/Tripoli',
        },
        {
            option: 'ESSR',
            wni_port_name: 'ESSAOUIRA',
            wni_unlocode: 'MAESS',
            wni_country: 'MA',
            wni_lat: 31.5,
            wni_lon: -9.78,
            wni_tz: 'Africa/Casablanca',
        },
        {
            option: 'HCMM',
            wni_port_name: 'AL HOCEIMA',
            wni_unlocode: 'MAAHU',
            wni_country: 'MA',
            wni_lat: 35.25,
            wni_lon: -3.92,
            wni_tz: 'Africa/Casablanca',
        },
        {
            option: 'JDID',
            wni_port_name: 'EL JADIDA',
            wni_unlocode: 'MAELJ',
            wni_country: 'MA',
            wni_lat: 33.25,
            wni_lon: -8.5,
            wni_tz: 'Africa/Casablanca',
        },
        {
            option: 'KNI',
            wni_port_name: 'KENITRA',
            wni_unlocode: 'MANNA',
            wni_country: 'MA',
            wni_lat: 34.3,
            wni_lon: -6.6,
            wni_tz: 'Africa/Casablanca',
        },
        {
            option: 'LRCH',
            wni_port_name: 'LARACHE',
            wni_unlocode: 'MALAR',
            wni_country: 'MA',
            wni_lat: 35.2,
            wni_lon: -6.15,
            wni_tz: 'Africa/Casablanca',
        },
        {
            option: 'RABAT',
            wni_port_name: 'RABAT',
            wni_unlocode: 'MARBA',
            wni_country: 'MA',
            wni_lat: 34.03,
            wni_lon: -6.83,
            wni_tz: 'Africa/Casablanca',
        },
        {
            option: 'BARY',
            wni_port_name: 'BAR',
            wni_unlocode: 'MEBAR',
            wni_country: 'ME',
            wni_lat: 42.08,
            wni_lon: 19.08,
            wni_tz: 'Europe/Podgorica',
        },
        {
            option: 'BIJ',
            wni_port_name: 'BIJELA',
            wni_unlocode: 'MEBIJ',
            wni_country: 'ME',
            wni_lat: 42.45,
            wni_lon: 18.66,
            wni_tz: 'Europe/Podgorica',
        },
        {
            option: 'TIVAT',
            wni_port_name: 'TIVAT',
            wni_unlocode: 'METIV',
            wni_country: 'ME',
            wni_lat: 42.43,
            wni_lon: 18.7,
            wni_tz: 'Europe/Podgorica',
        },
        {
            option: 'MF',
            wni_port_name: 'MARIGOT',
            wni_unlocode: 'SVMAR',
            wni_country: 'MF',
            wni_lat: 18.07,
            wni_lon: -63.08,
            wni_tz: 'America/Marigot',
        },
        {
            option: 'MGOT',
            wni_port_name: 'MARIGOT',
            wni_unlocode: 'SVMAR',
            wni_country: 'MF',
            wni_lat: 18.07,
            wni_lon: -63.08,
            wni_tz: 'America/Marigot',
        },
        {
            option: 'MRIGT',
            wni_port_name: 'MARIGOT',
            wni_unlocode: 'SVMAR',
            wni_country: 'MF',
            wni_lat: 18.07,
            wni_lon: -63.08,
            wni_tz: 'America/Marigot',
        },
        {
            option: 'ANTS',
            wni_port_name: 'ANTSIRANANA',
            wni_unlocode: 'MGDIE',
            wni_country: 'MG',
            wni_lat: -12.27,
            wni_lon: 49.28,
            wni_tz: 'Indian/Antananarivo',
        },
        {
            option: 'MDV',
            wni_port_name: 'MORONDAVA',
            wni_unlocode: 'MGMOQ',
            wni_country: 'MG',
            wni_lat: -20.28,
            wni_lon: 44.3,
            wni_tz: 'Indian/Antananarivo',
        },
        {
            option: 'MHJ',
            wni_port_name: 'MAHAJANGA',
            wni_unlocode: 'MGMJN',
            wni_country: 'MG',
            wni_lat: -15.7,
            wni_lon: 46.32,
            wni_tz: 'Indian/Antananarivo',
        },
        {
            option: 'MNKR',
            wni_port_name: 'MANAKARA',
            wni_unlocode: 'MGWVK',
            wni_country: 'MG',
            wni_lat: -22.12,
            wni_lon: 48.05,
            wni_tz: 'Indian/Antananarivo',
        },
        {
            option: 'MRMB',
            wni_port_name: 'MOROMBE',
            wni_unlocode: 'MGMXM',
            wni_country: 'MG',
            wni_lat: -21.75,
            wni_lon: 43.37,
            wni_tz: 'Indian/Antananarivo',
        },
        {
            option: 'MRY',
            wni_port_name: 'MANANJARY',
            wni_unlocode: 'MGMNJ',
            wni_country: 'MG',
            wni_lat: -21.25,
            wni_lon: 48.33,
            wni_tz: 'Indian/Antananarivo',
        },
        {
            option: 'KWJ',
            wni_port_name: 'KWAJALEIN',
            wni_unlocode: 'MHKWA',
            wni_country: 'MH',
            wni_lat: 8.72,
            wni_lon: 167.73,
            wni_tz: 'Pacific/Kwajalein',
        },
        {
            option: 'BSSN',
            wni_port_name: 'BASSEIN',
            wni_unlocode: 'MMBSX',
            wni_country: 'MM',
            wni_lat: 16.78,
            wni_lon: 94.73,
            wni_tz: 'Asia/Rangoon',
        },
        {
            option: 'KYKPY',
            wni_port_name: 'KYAUKPYU',
            wni_unlocode: 'MMKYP',
            wni_country: 'MM',
            wni_lat: 19.42,
            wni_lon: 93.55,
            wni_tz: 'Asia/Rangoon',
        },
        {
            option: 'MLMN',
            wni_port_name: 'MOULMEIN',
            wni_unlocode: 'MMMNU',
            wni_country: 'MM',
            wni_lat: 16.48,
            wni_lon: 97.62,
            wni_tz: 'Asia/Rangoon',
        },
        {
            option: 'ROTA',
            wni_port_name: 'ROTA',
            wni_unlocode: 'MPROP',
            wni_country: 'MP',
            wni_lat: 14.13,
            wni_lon: 145.15,
            wni_tz: 'Pacific/Saipan',
        },
        {
            option: 'TNI',
            wni_port_name: 'TINIAN',
            wni_unlocode: 'MPTIQ',
            wni_country: 'MP',
            wni_lat: 14.97,
            wni_lon: 145.62,
            wni_tz: 'Pacific/Saipan',
        },
        {
            option: 'PYMTH',
            wni_port_name: 'PLYMOUTH',
            wni_unlocode: 'MSPLY',
            wni_country: 'MS',
            wni_lat: 16.7,
            wni_lon: -62.22,
            wni_tz: 'America/Montserrat',
        },
        {
            option: 'ALVDO',
            wni_port_name: 'ALVARADO',
            wni_unlocode: 'MXAVD',
            wni_country: 'MX',
            wni_lat: 18.78,
            wni_lon: -95.77,
            wni_tz: 'America/Mexico_City',
        },
        {
            option: 'BCA',
            wni_port_name: 'CAMPECHE',
            wni_unlocode: 'MXCPE',
            wni_country: 'MX',
            wni_lat: 19.85,
            wni_lon: -90.55,
            wni_tz: 'America/Merida',
        },
        {
            option: 'CDC',
            wni_port_name: 'CARMEN',
            wni_unlocode: 'MXCME',
            wni_country: 'MX',
            wni_lat: 18.63,
            wni_lon: -91.87,
            wni_tz: 'America/Merida',
        },
        {
            option: 'CMAD',
            wni_port_name: 'CIUDAD MADERO',
            wni_unlocode: 'MXCDD',
            wni_country: 'MX',
            wni_lat: 22.26,
            wni_lon: -97.8,
            wni_tz: 'America/Monterrey',
        },
        {
            option: 'CSL',
            wni_port_name: 'SAN LUCAS',
            wni_unlocode: 'MXCSL',
            wni_country: 'MX',
            wni_lat: 22.88,
            wni_lon: -109.9,
            wni_tz: 'America/Mazatlan',
        },
        {
            option: 'FRX',
            wni_port_name: 'FRONTERA',
            wni_unlocode: 'MXFRN',
            wni_country: 'MX',
            wni_lat: 18.58,
            wni_lon: -92.65,
            wni_tz: 'America/Mexico_City',
        },
        {
            option: 'LAZR',
            wni_port_name: 'LAZARO CARDENAS',
            wni_unlocode: 'MXLZC',
            wni_country: 'MX',
            wni_lat: 17.93,
            wni_lon: -102.17,
            wni_tz: 'America/Mexico_City',
        },
        {
            option: 'LRT',
            wni_port_name: 'LORETO',
            wni_unlocode: 'MXLTO',
            wni_country: 'MX',
            wni_lat: 26.02,
            wni_lon: -111.35,
            wni_tz: 'America/Mazatlan',
        },
        {
            option: 'MNTTL',
            wni_port_name: 'MINATITLAN',
            wni_unlocode: 'MXMTT',
            wni_country: 'MX',
            wni_lat: 18,
            wni_lon: -94.53,
            wni_tz: 'America/Mexico_City',
        },
        {
            option: 'NNCHT',
            wni_port_name: 'NANCHITAL',
            wni_unlocode: 'MXNAN',
            wni_country: 'MX',
            wni_lat: 18.07,
            wni_lon: -94.42,
            wni_tz: 'America/Mexico_City',
        },
        {
            option: 'PICH',
            wni_port_name: 'PICHILINGUE',
            wni_unlocode: 'MXPIC',
            wni_country: 'MX',
            wni_lat: 24.27,
            wni_lon: -110.33,
            wni_tz: 'America/Mazatlan',
        },
        {
            option: 'PMR',
            wni_port_name: 'PUERTO MADERO',
            wni_unlocode: 'MXPMD',
            wni_country: 'MX',
            wni_lat: 14.7,
            wni_lon: -92.45,
            wni_tz: 'America/Mexico_City',
        },
        {
            option: 'PVA',
            wni_port_name: 'PUERTO VALLARTA',
            wni_unlocode: 'MXPVR',
            wni_country: 'MX',
            wni_lat: 20.62,
            wni_lon: -105.27,
            wni_tz: 'America/Mexico_City',
        },
        {
            option: 'SCA',
            wni_port_name: 'SAN CARLOS',
            wni_unlocode: 'MXSCR',
            wni_country: 'MX',
            wni_lat: 24.78,
            wni_lon: -112.12,
            wni_tz: 'America/Mazatlan',
        },
        {
            option: 'SJDC',
            wni_port_name: 'SAN JUAN DE LA COSTA',
            wni_unlocode: 'MXSJC',
            wni_country: 'MX',
            wni_lat: 24.4,
            wni_lon: -110.7,
            wni_tz: 'America/Mazatlan',
        },
        {
            option: 'SNR',
            wni_port_name: 'SANTA ROSALIA',
            wni_unlocode: 'MXSRL',
            wni_country: 'MX',
            wni_lat: 27.33,
            wni_lon: -112.28,
            wni_tz: 'America/Mazatlan',
        },
        {
            option: 'ZHTNJ',
            wni_port_name: 'ZIHUATANEJO',
            wni_unlocode: 'MXXIH',
            wni_country: 'MX',
            wni_lat: 17.64,
            wni_lon: -101.59,
            wni_tz: 'America/Mexico_City',
        },
        {
            option: 'BAM',
            wni_port_name: 'BARAM',
            wni_unlocode: 'MYKBA',
            wni_country: 'MY',
            wni_lat: 4.39,
            wni_lon: 113.98,
            wni_tz: 'Asia/Kuching',
        },
        {
            option: 'KDT',
            wni_port_name: 'KUDAT',
            wni_unlocode: 'MYKUD',
            wni_country: 'MY',
            wni_lat: 6.88,
            wni_lon: 116.85,
            wni_tz: 'Asia/Kuching',
        },
        {
            option: 'KIMNS',
            wni_port_name: 'KIMANIS',
            wni_unlocode: 'MYKIM',
            wni_country: 'MY',
            wni_lat: 5.75,
            wni_lon: 115.82,
            wni_tz: 'Asia/Kuching',
        },
        {
            option: 'LUTNG',
            wni_port_name: 'LUTONG',
            wni_unlocode: 'MYLUT',
            wni_country: 'MY',
            wni_lat: 4.47,
            wni_lon: 114,
            wni_tz: 'Asia/Kuching',
        },
        {
            option: 'PRY',
            wni_port_name: 'PRAI',
            wni_unlocode: 'MYPRA',
            wni_country: 'MY',
            wni_lat: 5.37,
            wni_lon: 100.36,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'SARKE',
            wni_port_name: 'SARIKEI',
            wni_unlocode: 'MYSAR',
            wni_country: 'MY',
            wni_lat: 2.13,
            wni_lon: 111.53,
            wni_tz: 'Asia/Kuching',
        },
        {
            option: 'SIBU',
            wni_port_name: 'SIBU',
            wni_unlocode: 'MYSBW',
            wni_country: 'MY',
            wni_lat: 2.28,
            wni_lon: 111.82,
            wni_tz: 'Asia/Kuching',
        },
        {
            option: 'BLOMZ',
            wni_port_name: 'PORTO BELO',
            wni_unlocode: 'MZPBE',
            wni_country: 'MZ',
            wni_lat: -17.7,
            wni_lon: 37.18,
            wni_tz: 'Africa/Maputo',
        },
        {
            option: 'INHMB',
            wni_port_name: 'INHAMBANE',
            wni_unlocode: 'MZINH',
            wni_country: 'MZ',
            wni_lat: -23.87,
            wni_lon: 35.38,
            wni_tz: 'Africa/Maputo',
        },
        {
            option: 'MTO',
            wni_port_name: 'MATOLA',
            wni_unlocode: 'MZMAT',
            wni_country: 'MZ',
            wni_lat: -25.97,
            wni_lon: 32.47,
            wni_tz: 'Africa/Maputo',
        },
        {
            option: 'PEB',
            wni_port_name: 'PEMBA',
            wni_unlocode: 'MZPOL',
            wni_country: 'MZ',
            wni_lat: -12.97,
            wni_lon: 40.49,
            wni_tz: 'Africa/Maputo',
        },
        {
            option: 'BUE',
            wni_port_name: 'BAIE UGUE',
            wni_unlocode: 'NCBUG',
            wni_country: 'NC',
            wni_lat: -21.15,
            wni_lon: 165.55,
            wni_tz: 'Pacific/Noumea',
        },
        {
            option: 'APP',
            wni_port_name: 'APAPA',
            wni_unlocode: 'NGAPP',
            wni_country: 'NG',
            wni_lat: 6.46,
            wni_lon: 3.42,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'BURUT',
            wni_port_name: 'BURUTU',
            wni_unlocode: 'NGBUR',
            wni_country: 'NG',
            wni_lat: 5.35,
            wni_lon: 5.5,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'KKO',
            wni_port_name: 'KOKO',
            wni_unlocode: 'NGKOK',
            wni_country: 'NG',
            wni_lat: 6,
            wni_lon: 5.47,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'OKR',
            wni_port_name: 'OKRIKA',
            wni_unlocode: 'NGOKR',
            wni_country: 'NG',
            wni_lat: 4.72,
            wni_lon: 7.08,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'SPE',
            wni_port_name: 'SAPELE',
            wni_unlocode: 'NGSPL',
            wni_country: 'NG',
            wni_lat: 5.9,
            wni_lon: 5.68,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'WAR',
            wni_port_name: 'WARRI',
            wni_unlocode: 'NGWAR',
            wni_country: 'NG',
            wni_lat: 5.52,
            wni_lon: 5.73,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'BLEF',
            wni_port_name: 'BLUEFIELDS',
            wni_unlocode: 'NIBEF',
            wni_country: 'NI',
            wni_lat: 12.02,
            wni_lon: -83.75,
            wni_tz: 'America/Managua',
        },
        {
            option: 'PCZ',
            wni_port_name: 'PUERTO CABEZAS',
            wni_unlocode: 'NIPUZ',
            wni_country: 'NI',
            wni_lat: 14.02,
            wni_lon: -83.38,
            wni_tz: 'America/Managua',
        },
        {
            option: 'BEV',
            wni_port_name: 'BEVERWIJK',
            wni_unlocode: 'NLBEV',
            wni_country: 'NL',
            wni_lat: 52.49,
            wni_lon: 4.66,
            wni_tz: 'Europe/Amsterdam',
        },
        {
            option: 'DEH',
            wni_port_name: 'DEN HELDER',
            wni_unlocode: 'NLDHR',
            wni_country: 'NL',
            wni_lat: 52.97,
            wni_lon: 4.78,
            wni_tz: 'Europe/Amsterdam',
        },
        {
            option: 'DFZ',
            wni_port_name: 'DELFZIJL',
            wni_unlocode: 'NLDZL',
            wni_country: 'NL',
            wni_lat: 53.33,
            wni_lon: 6.93,
            wni_tz: 'Europe/Amsterdam',
        },
        {
            option: 'HLLVT',
            wni_port_name: 'HELLEVOETSLUIS',
            wni_unlocode: 'NLHSL',
            wni_country: 'NL',
            wni_lat: 51.82,
            wni_lon: 4.13,
            wni_tz: 'Europe/Amsterdam',
        },
        {
            option: 'HOH',
            wni_port_name: 'HOEK VAN HOLLAND',
            wni_unlocode: 'NLHVH',
            wni_country: 'NL',
            wni_lat: 51.95,
            wni_lon: 4.13,
            wni_tz: 'Europe/Amsterdam',
        },
        {
            option: 'HRL',
            wni_port_name: 'HARLINGEN',
            wni_unlocode: 'NLHAR',
            wni_country: 'NL',
            wni_lat: 53.18,
            wni_lon: 5.42,
            wni_tz: 'Europe/Amsterdam',
        },
        {
            option: 'MDLBG',
            wni_port_name: 'MIDDELBURG',
            wni_unlocode: 'NLMID',
            wni_country: 'NL',
            wni_lat: 51.5,
            wni_lon: 3.62,
            wni_tz: 'Europe/Amsterdam',
        },
        {
            option: 'MSSLS',
            wni_port_name: 'MAASSLUIS',
            wni_unlocode: 'NLMSL',
            wni_country: 'NL',
            wni_lat: 51.92,
            wni_lon: 4.25,
            wni_tz: 'Europe/Amsterdam',
        },
        {
            option: 'SCH',
            wni_port_name: 'SCHEVENINGEN',
            wni_unlocode: 'NLSCE',
            wni_country: 'NL',
            wni_lat: 52.1,
            wni_lon: 4.27,
            wni_tz: 'Europe/Amsterdam',
        },
        {
            option: 'SCHD',
            wni_port_name: 'SCHIEDAM',
            wni_unlocode: 'NLSCI',
            wni_country: 'NL',
            wni_lat: 51.9,
            wni_lon: 4.4,
            wni_tz: 'Europe/Amsterdam',
        },
        {
            option: 'VAA',
            wni_port_name: 'VLAARDINGEN',
            wni_unlocode: 'NLVLA',
            wni_country: 'NL',
            wni_lat: 51.9,
            wni_lon: 4.35,
            wni_tz: 'Europe/Amsterdam',
        },
        {
            option: 'VEL',
            wni_port_name: 'VELSEN',
            wni_unlocode: 'NLVEL',
            wni_country: 'NL',
            wni_lat: 52.46,
            wni_lon: 4.64,
            wni_tz: 'Europe/Amsterdam',
        },
        {
            option: 'ZAAN',
            wni_port_name: 'ZAANDAM',
            wni_unlocode: 'NLZAA',
            wni_country: 'NL',
            wni_lat: 52.43,
            wni_lon: 4.83,
            wni_tz: 'Europe/Amsterdam',
        },
        {
            option: 'AAGN',
            wni_port_name: 'AGOTNES',
            wni_unlocode: 'NOAGO',
            wni_country: 'NO',
            wni_lat: 60.42,
            wni_lon: 5.02,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'AKRHM',
            wni_port_name: 'AKREHAMN',
            wni_unlocode: 'NOAKM',
            wni_country: 'NO',
            wni_lat: 59.27,
            wni_lon: 5.18,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'ALTA',
            wni_port_name: 'ALTA',
            wni_unlocode: 'NOALF',
            wni_country: 'NO',
            wni_lat: 69.97,
            wni_lon: 23.25,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'ALV',
            wni_port_name: 'ALVIK',
            wni_unlocode: 'NOAAV',
            wni_country: 'NO',
            wni_lat: 60.43,
            wni_lon: 6.43,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'AND',
            wni_port_name: 'ANDALSNES',
            wni_unlocode: 'NOAND',
            wni_country: 'NO',
            wni_lat: 62.57,
            wni_lon: 7.68,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'ANDNS',
            wni_port_name: 'ANDENES',
            wni_unlocode: 'NOADN',
            wni_country: 'NO',
            wni_lat: 69.33,
            wni_lon: 16.13,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'ARNDL',
            wni_port_name: 'ARENDAL',
            wni_unlocode: 'NOARE',
            wni_country: 'NO',
            wni_lat: 58.45,
            wni_lon: 8.8,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'BML',
            wni_port_name: 'BOMLO',
            wni_unlocode: 'NOBOM',
            wni_country: 'NO',
            wni_lat: 59.78,
            wni_lon: 5.3,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'BODO',
            wni_port_name: 'BODO',
            wni_unlocode: 'NOBOO',
            wni_country: 'NO',
            wni_lat: 67.28,
            wni_lon: 14.38,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'BRLV',
            wni_port_name: 'BERLEVAG',
            wni_unlocode: 'NOBVG',
            wni_country: 'NO',
            wni_lat: 70.87,
            wni_lon: 29.1,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'BRNNY',
            wni_port_name: 'BRONNOYSUND',
            wni_unlocode: 'NOBNN',
            wni_country: 'NO',
            wni_lat: 65.47,
            wni_lon: 12.2,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'BROBK',
            wni_port_name: 'DROBAK',
            wni_unlocode: 'NODRK',
            wni_country: 'NO',
            wni_lat: 59.65,
            wni_lon: 10.65,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'BVK',
            wni_port_name: 'BREVIK',
            wni_unlocode: 'NOBVK',
            wni_country: 'NO',
            wni_lat: 59.07,
            wni_lon: 9.7,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'DRAG',
            wni_port_name: 'DRAG',
            wni_unlocode: 'NODRG',
            wni_country: 'NO',
            wni_lat: 68.05,
            wni_lon: 16.08,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'DRO',
            wni_port_name: 'STORD',
            wni_unlocode: 'NOSRP',
            wni_country: 'NO',
            wni_lat: 59.78,
            wni_lon: 5.5,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'DUS',
            wni_port_name: 'DUSAVIK',
            wni_unlocode: 'NODUS',
            wni_country: 'NO',
            wni_lat: 59,
            wni_lon: 5.67,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'EKF',
            wni_port_name: 'EIKEFET',
            wni_unlocode: 'NOEKF',
            wni_country: 'NO',
            wni_lat: 60.75,
            wni_lon: 5.82,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'FED',
            wni_port_name: 'FEDJE',
            wni_unlocode: 'NOFED',
            wni_country: 'NO',
            wni_lat: 60.78,
            wni_lon: 4.71,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'FNNS',
            wni_port_name: 'FINNSNES',
            wni_unlocode: 'NOFNE',
            wni_country: 'NO',
            wni_lat: 69.23,
            wni_lon: 17.97,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'GRIM',
            wni_port_name: 'GRIMSTAD',
            wni_unlocode: 'NOGTD',
            wni_country: 'NO',
            wni_lat: 58.33,
            wni_lon: 8.6,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'HARED',
            wni_port_name: 'HAREID',
            wni_unlocode: 'NOHRI',
            wni_country: 'NO',
            wni_lat: 62.37,
            wni_lon: 6.03,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'HLN',
            wni_port_name: 'HALDEN',
            wni_unlocode: 'NOHAL',
            wni_country: 'NO',
            wni_lat: 59.12,
            wni_lon: 11.38,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'HOA',
            wni_port_name: 'HOLLA',
            wni_unlocode: 'NOHOA',
            wni_country: 'NO',
            wni_lat: 63.31,
            wni_lon: 9.14,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'HOLMS',
            wni_port_name: 'HOLMESTRAND',
            wni_unlocode: 'NOHOL',
            wni_country: 'NO',
            wni_lat: 59.48,
            wni_lon: 10.3,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'HOMM',
            wni_port_name: 'HOMMELVIK',
            wni_unlocode: 'NOHOK',
            wni_country: 'NO',
            wni_lat: 63.42,
            wni_lon: 10.8,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'HOY',
            wni_port_name: 'HOYANGER',
            wni_unlocode: 'NOHYR',
            wni_country: 'NO',
            wni_lat: 61.22,
            wni_lon: 6.07,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'HRT',
            wni_port_name: 'HORTEN',
            wni_unlocode: 'NOHOR',
            wni_country: 'NO',
            wni_lat: 59.42,
            wni_lon: 10.5,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'HSD',
            wni_port_name: 'HARSTAD',
            wni_unlocode: 'NOHRD',
            wni_country: 'NO',
            wni_lat: 68.8,
            wni_lon: 16.55,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'KAMBO',
            wni_port_name: 'KAMBO',
            wni_unlocode: 'NOKMO',
            wni_country: 'NO',
            wni_lat: 59.47,
            wni_lon: 10.68,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'KJP',
            wni_port_name: 'KJOPSVIK',
            wni_unlocode: 'NOKJK',
            wni_country: 'NO',
            wni_lat: 68.1,
            wni_lon: 16.37,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'KJV',
            wni_port_name: 'KJOPSVIK',
            wni_unlocode: 'NOKJK',
            wni_country: 'NO',
            wni_lat: 68.09,
            wni_lon: 16.36,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'KLNS',
            wni_port_name: 'KALNESET',
            wni_unlocode: 'NOKAL',
            wni_country: 'NO',
            wni_lat: 62.11,
            wni_lon: 6.55,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'KOPR',
            wni_port_name: 'KOPERVIK',
            wni_unlocode: 'NOKOP',
            wni_country: 'NO',
            wni_lat: 59.28,
            wni_lon: 5.32,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'KRGR',
            wni_port_name: 'KRAGERO',
            wni_unlocode: 'NOKRA',
            wni_country: 'NO',
            wni_lat: 58.87,
            wni_lon: 9.42,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'LEIR',
            wni_port_name: 'LEIRVIK',
            wni_unlocode: 'NOLRI',
            wni_country: 'NO',
            wni_lat: 59.78,
            wni_lon: 5.52,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'LGS',
            wni_port_name: 'LANGESUND',
            wni_unlocode: 'NOLAD',
            wni_country: 'NO',
            wni_lat: 59.13,
            wni_lon: 9.62,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'LLLSN',
            wni_port_name: 'LILLESAND',
            wni_unlocode: 'NOLIL',
            wni_country: 'NO',
            wni_lat: 58.25,
            wni_lon: 8.4,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'LOD',
            wni_port_name: 'LODINGEN',
            wni_unlocode: 'NOLOD',
            wni_country: 'NO',
            wni_lat: 68.42,
            wni_lon: 16,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'LVNGR',
            wni_port_name: 'LEVANGER',
            wni_unlocode: 'NOLEV',
            wni_country: 'NO',
            wni_lat: 63.75,
            wni_lon: 11.3,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'MALM',
            wni_port_name: 'MALM',
            wni_unlocode: 'NOMLM',
            wni_country: 'NO',
            wni_lat: 64.07,
            wni_lon: 11.23,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'MANDL',
            wni_port_name: 'MANDAL',
            wni_unlocode: 'NOMAN',
            wni_country: 'NO',
            wni_lat: 58.02,
            wni_lon: 7.47,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'MELBU',
            wni_port_name: 'MELBU',
            wni_unlocode: 'DEHMB',
            wni_country: 'NO',
            wni_lat: 68.5,
            wni_lon: 14.82,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'MOLDE',
            wni_port_name: 'MOLDE',
            wni_unlocode: 'NOMOL',
            wni_country: 'NO',
            wni_lat: 62.73,
            wni_lon: 7.17,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'NMSS',
            wni_port_name: 'NAMSOS',
            wni_unlocode: 'NOOSY',
            wni_country: 'NO',
            wni_lat: 64.47,
            wni_lon: 11.5,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'ODD',
            wni_port_name: 'ODDA',
            wni_unlocode: 'NOODD',
            wni_country: 'NO',
            wni_lat: 60.08,
            wni_lon: 6.55,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'PLNNO',
            wni_port_name: 'OLEN',
            wni_unlocode: 'AUMDI',
            wni_country: 'NO',
            wni_lat: 59.6,
            wni_lon: 5.82,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'POG',
            wni_port_name: 'PORSGRUNN',
            wni_unlocode: 'NOPOR',
            wni_country: 'NO',
            wni_lat: 59.15,
            wni_lon: 9.67,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'RAF',
            wni_port_name: 'RAFNES',
            wni_unlocode: 'NORAF',
            wni_country: 'NO',
            wni_lat: 59.13,
            wni_lon: 9.62,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'RAU',
            wni_port_name: 'RAUBERGVIKA',
            wni_unlocode: 'NORBV',
            wni_country: 'NO',
            wni_lat: 62.27,
            wni_lon: 7.05,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'RISOR',
            wni_port_name: 'RISOR',
            wni_unlocode: 'NORIS',
            wni_country: 'NO',
            wni_lat: 58.72,
            wni_lon: 9.23,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'ROGNN',
            wni_port_name: 'ROGNAN',
            wni_unlocode: 'NOROG',
            wni_country: 'NO',
            wni_lat: 67.1,
            wni_lon: 15.42,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'RRVK',
            wni_port_name: 'RORVIK',
            wni_unlocode: 'NORVK',
            wni_country: 'NO',
            wni_lat: 64.87,
            wni_lon: 11.23,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SARB',
            wni_port_name: 'SARPSBORG',
            wni_unlocode: 'NOSPG',
            wni_country: 'NO',
            wni_lat: 59.28,
            wni_lon: 11.12,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SEZ',
            wni_port_name: 'SANDNESSJOEN',
            wni_unlocode: 'NOSSJ',
            wni_country: 'NO',
            wni_lat: 66.02,
            wni_lon: 12.63,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SGND',
            wni_port_name: 'SOGNDAL',
            wni_unlocode: 'NOSOG',
            wni_country: 'NO',
            wni_lat: 61.23,
            wni_lon: 7.1,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SKDNS',
            wni_port_name: 'SKUDENESHAVN',
            wni_unlocode: 'NOSKU',
            wni_country: 'NO',
            wni_lat: 59.15,
            wni_lon: 5.27,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SKIEN',
            wni_port_name: 'SKIEN',
            wni_unlocode: 'NOSKE',
            wni_country: 'NO',
            wni_lat: 59.2,
            wni_lon: 9.6,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SNS',
            wni_port_name: 'SANDNES',
            wni_unlocode: 'NOSAS',
            wni_country: 'NO',
            wni_lat: 58.85,
            wni_lon: 5.75,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SRTL',
            wni_port_name: 'SORTLAND',
            wni_unlocode: 'NOSLX',
            wni_country: 'NO',
            wni_lat: 68.7,
            wni_lon: 15.42,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'STMSN',
            wni_port_name: 'STAMSUND',
            wni_unlocode: 'NOSUZ',
            wni_country: 'NO',
            wni_lat: 68.12,
            wni_lon: 13.85,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'STNKJ',
            wni_port_name: 'STEINKJER',
            wni_unlocode: 'NOSTE',
            wni_country: 'NO',
            wni_lat: 64.02,
            wni_lon: 11.5,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'STTE',
            wni_port_name: 'STEINSHAMN',
            wni_unlocode: 'NOSTH',
            wni_country: 'NO',
            wni_lat: 62.78,
            wni_lon: 6.47,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SVEL',
            wni_port_name: 'SVELVIK',
            wni_unlocode: 'NOSVV',
            wni_country: 'NO',
            wni_lat: 59.62,
            wni_lon: 10.4,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SVG',
            wni_port_name: 'SVELGEN',
            wni_unlocode: 'NOSVE',
            wni_country: 'NO',
            wni_lat: 61.77,
            wni_lon: 5.28,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SVLVR',
            wni_port_name: 'SVOLVAER',
            wni_unlocode: 'NOSVJ',
            wni_country: 'NO',
            wni_lat: 68.23,
            wni_lon: 14.58,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'TNN',
            wni_port_name: 'TANANGER',
            wni_unlocode: 'NOTAE',
            wni_country: 'NO',
            wni_lat: 58.92,
            wni_lon: 5.59,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'TON',
            wni_port_name: 'TONSBERG',
            wni_unlocode: 'NOTON',
            wni_country: 'NO',
            wni_lat: 59.28,
            wni_lon: 10.42,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'TRO',
            wni_port_name: 'TRONDHEIM',
            wni_unlocode: 'NOTRD',
            wni_country: 'NO',
            wni_lat: 63.43,
            wni_lon: 10.4,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'TRY',
            wni_port_name: 'TRANOY',
            wni_unlocode: 'NOTRY',
            wni_country: 'NO',
            wni_lat: 68.18,
            wni_lon: 15.67,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'TVDST',
            wni_port_name: 'TVEDESTRAND',
            wni_unlocode: 'NOTVE',
            wni_country: 'NO',
            wni_lat: 58.62,
            wni_lon: 8.93,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'TYS',
            wni_port_name: 'TYSSEDAL',
            wni_unlocode: 'NOTSX',
            wni_country: 'NO',
            wni_lat: 60.12,
            wni_lon: 6.56,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'ULS',
            wni_port_name: 'ULSTEINVIK',
            wni_unlocode: 'NOULS',
            wni_country: 'NO',
            wni_lat: 62.35,
            wni_lon: 5.85,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'VADSO',
            wni_port_name: 'VADSO',
            wni_unlocode: 'NOVDS',
            wni_country: 'NO',
            wni_lat: 70.07,
            wni_lon: 29.73,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'VKSDL',
            wni_port_name: 'VAKSDAL',
            wni_unlocode: 'NOVAK',
            wni_country: 'NO',
            wni_lat: 60.48,
            wni_lon: 5.73,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'VLLOY',
            wni_port_name: 'VALLOY',
            wni_unlocode: 'NOVAL',
            wni_country: 'NO',
            wni_lat: 59.27,
            wni_lon: 10.5,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'VRDE',
            wni_port_name: 'VARDO',
            wni_unlocode: 'NOVAO',
            wni_country: 'NO',
            wni_lat: 70.37,
            wni_lon: 31.12,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'NR',
            wni_port_name: 'NAURU',
            wni_unlocode: 'NRINU',
            wni_country: 'NR',
            wni_lat: -0.53,
            wni_lon: 166.92,
            wni_tz: 'Pacific/Nauru',
        },
        {
            option: 'AKROA',
            wni_port_name: 'AKAROA',
            wni_unlocode: 'NZAKA',
            wni_country: 'NZ',
            wni_lat: -43.8,
            wni_lon: 172.97,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'CHCH',
            wni_port_name: 'CHRISTCHURCH',
            wni_unlocode: 'NZCHC',
            wni_country: 'NZ',
            wni_lat: -43.61,
            wni_lon: 172.72,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'DND',
            wni_port_name: 'DUNEDIN',
            wni_unlocode: 'NZDUD',
            wni_country: 'NZ',
            wni_lat: -45.88,
            wni_lon: 170.51,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'GRYMT',
            wni_port_name: 'GREYMOUTH',
            wni_unlocode: 'NZGMN',
            wni_country: 'NZ',
            wni_lat: -42.43,
            wni_lon: 171.22,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'OPUA',
            wni_port_name: 'OPUA',
            wni_unlocode: 'NZOPX',
            wni_country: 'NZ',
            wni_lat: -35.32,
            wni_lon: 174.12,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'PIC',
            wni_port_name: 'PICTON',
            wni_unlocode: 'NZPCN',
            wni_country: 'NZ',
            wni_lat: -41.28,
            wni_lon: 174.02,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'WAN',
            wni_port_name: 'WANGANUI',
            wni_unlocode: 'NZWAG',
            wni_country: 'NZ',
            wni_lat: -39.93,
            wni_lon: 175.05,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'WAV',
            wni_port_name: 'WAVERLEY',
            wni_unlocode: 'NZWAV',
            wni_country: 'NZ',
            wni_lat: -39.76,
            wni_lon: 174.63,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'WPO',
            wni_port_name: 'WESTPORT',
            wni_unlocode: 'NZWSZ',
            wni_country: 'NZ',
            wni_lat: -41.75,
            wni_lon: 171.6,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'RST',
            wni_port_name: 'MINA RAYSUT',
            wni_unlocode: 'OMRAY',
            wni_country: 'OM',
            wni_lat: 16.93,
            wni_lon: 54.02,
            wni_tz: 'Asia/Muscat',
        },
        {
            option: 'SQB1',
            wni_port_name: 'MUSCAT',
            wni_unlocode: 'OMMCT',
            wni_country: 'OM',
            wni_lat: 23.63,
            wni_lon: 58.58,
            wni_tz: 'Asia/Muscat',
        },
        {
            option: 'AGDLC',
            wni_port_name: 'AGUADULCE',
            wni_unlocode: 'PAAGD',
            wni_country: 'PA',
            wni_lat: 8.23,
            wni_lon: -80.5,
            wni_tz: 'America/Panama',
        },
        {
            option: 'ALR',
            wni_port_name: 'ALMIRANTE',
            wni_unlocode: 'PAPAM',
            wni_country: 'PA',
            wni_lat: 9.3,
            wni_lon: -82.4,
            wni_tz: 'America/Panama',
        },
        {
            option: 'BOCAS',
            wni_port_name: 'BOCAS DEL TORO',
            wni_unlocode: 'PABOC',
            wni_country: 'PA',
            wni_lat: 9.35,
            wni_lon: -82.23,
            wni_tz: 'America/Panama',
        },
        {
            option: 'CLN',
            wni_port_name: 'COLON',
            wni_unlocode: 'PAONX',
            wni_country: 'PA',
            wni_lat: 9.35,
            wni_lon: -79.92,
            wni_tz: 'America/Panama',
        },
        {
            option: 'PDRGL',
            wni_port_name: 'PEDREGAL',
            wni_unlocode: 'PAPED',
            wni_country: 'PA',
            wni_lat: 8.37,
            wni_lon: -82.43,
            wni_tz: 'America/Panama',
        },
        {
            option: 'PRTBL',
            wni_port_name: 'PORTOBELO',
            wni_unlocode: 'PAPBE',
            wni_country: 'PA',
            wni_lat: 9.55,
            wni_lon: -79.67,
            wni_tz: 'America/Panama',
        },
        {
            option: 'ATI',
            wni_port_name: 'ATICO',
            wni_unlocode: 'PEATI',
            wni_country: 'PE',
            wni_lat: -16.23,
            wni_lon: -73.61,
            wni_tz: 'America/Lima',
        },
        {
            option: 'BLNC',
            wni_port_name: 'CABO BLANCO',
            wni_unlocode: 'PECAB',
            wni_country: 'PE',
            wni_lat: -4.27,
            wni_lon: -81.25,
            wni_tz: 'America/Lima',
        },
        {
            option: 'CCM',
            wni_port_name: 'PUERTO CHICAMA',
            wni_unlocode: 'PEPCH',
            wni_country: 'PE',
            wni_lat: -7.7,
            wni_lon: -79.45,
            wni_tz: 'America/Lima',
        },
        {
            option: 'CHNY',
            wni_port_name: 'CHANCAY',
            wni_unlocode: 'PECHY',
            wni_country: 'PE',
            wni_lat: -11.58,
            wni_lon: -77.28,
            wni_tz: 'America/Lima',
        },
        {
            option: 'HCH',
            wni_port_name: 'HUACHO',
            wni_unlocode: 'PEHCO',
            wni_country: 'PE',
            wni_lat: -11.12,
            wni_lon: -77.62,
            wni_tz: 'America/Lima',
        },
        {
            option: 'HRMY',
            wni_port_name: 'HUARMEY',
            wni_unlocode: 'PEHUY',
            wni_country: 'PE',
            wni_lat: -10.1,
            wni_lon: -78.17,
            wni_tz: 'America/Lima',
        },
        {
            option: 'IQTS',
            wni_port_name: 'IQUITOS',
            wni_unlocode: 'PEIQT',
            wni_country: 'PE',
            wni_lat: -3.75,
            wni_lon: -73.23,
            wni_tz: 'America/Lima',
        },
        {
            option: 'LMP',
            wni_port_name: 'LA PAMPILLA',
            wni_unlocode: 'PELPP',
            wni_country: 'PE',
            wni_lat: -11.93,
            wni_lon: -77.17,
            wni_tz: 'America/Lima',
        },
        {
            option: 'NGRTS',
            wni_port_name: 'NEGRITOS',
            wni_unlocode: 'PENGS',
            wni_country: 'PE',
            wni_lat: -4.67,
            wni_lon: -81.32,
            wni_tz: 'America/Lima',
        },
        {
            option: 'ORGNS',
            wni_port_name: 'LOS ORGANOS',
            wni_unlocode: 'PELOO',
            wni_country: 'PE',
            wni_lat: -4.25,
            wni_lon: -81.13,
            wni_tz: 'America/Lima',
        },
        {
            option: 'PCS',
            wni_port_name: 'PACASMAYO',
            wni_unlocode: 'PEPAC',
            wni_country: 'PE',
            wni_lat: -7.4,
            wni_lon: -79.58,
            wni_tz: 'America/Lima',
        },
        {
            option: 'ANE',
            wni_port_name: 'ANEWA BAY',
            wni_unlocode: 'PGANB',
            wni_country: 'PG',
            wni_lat: -6.2,
            wni_lon: 155.55,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'DRU',
            wni_port_name: 'DARU',
            wni_unlocode: 'PGDAU',
            wni_country: 'PG',
            wni_lat: -9.07,
            wni_lon: 143.2,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'KIE',
            wni_port_name: 'KIETA',
            wni_unlocode: 'PGKIE',
            wni_country: 'PG',
            wni_lat: -6.2,
            wni_lon: 155.67,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'KUMUL',
            wni_port_name: 'KUMUL MARINE TERMINAL',
            wni_unlocode: 'PGKUL',
            wni_country: 'PG',
            wni_lat: -8.13,
            wni_lon: 144.57,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'LRNGU',
            wni_port_name: 'LORENGAU',
            wni_unlocode: 'PGLOR',
            wni_country: 'PG',
            wni_lat: -2.02,
            wni_lon: 147.28,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'ORB',
            wni_port_name: 'ORO BAY',
            wni_unlocode: 'PGROR',
            wni_country: 'PG',
            wni_lat: -8.88,
            wni_lon: 148.48,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'SAMRI',
            wni_port_name: 'SAMARAI',
            wni_unlocode: 'PGSQT',
            wni_country: 'PG',
            wni_lat: -10.62,
            wni_lon: 150.67,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'VAN',
            wni_port_name: 'VANIMO',
            wni_unlocode: 'PGVAI',
            wni_country: 'PG',
            wni_lat: -2.68,
            wni_lon: 141.13,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'AIM',
            wni_port_name: 'ATIMONAN',
            wni_unlocode: 'PHATI',
            wni_country: 'PH',
            wni_lat: 14,
            wni_lon: 121.92,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'APA',
            wni_port_name: 'APARRI',
            wni_unlocode: 'PHAPR',
            wni_country: 'PH',
            wni_lat: 18.37,
            wni_lon: 121.63,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'BACO',
            wni_port_name: 'BACONG',
            wni_unlocode: 'PHBAC',
            wni_country: 'PH',
            wni_lat: 9.24,
            wni_lon: 123.29,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'BAIS',
            wni_port_name: 'BAIS',
            wni_unlocode: 'PHBAI',
            wni_country: 'PH',
            wni_lat: 9.6,
            wni_lon: 123.13,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'BASCO',
            wni_port_name: 'BASCO',
            wni_unlocode: 'PHBSO',
            wni_country: 'PH',
            wni_lat: 20.45,
            wni_lon: 121.97,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'BIL',
            wni_port_name: 'BISLIG',
            wni_unlocode: 'PHBPH',
            wni_country: 'PH',
            wni_lat: 8.23,
            wni_lon: 126.37,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'BTN',
            wni_port_name: 'BUTUAN',
            wni_unlocode: 'PHBXU',
            wni_country: 'PH',
            wni_lat: 8.95,
            wni_lon: 125.53,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'BUGO',
            wni_port_name: 'BUGO',
            wni_unlocode: 'PHBUG',
            wni_country: 'PH',
            wni_lat: 8.52,
            wni_lon: 124.75,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'CALB',
            wni_port_name: 'CALBAYOG',
            wni_unlocode: 'PHCBY',
            wni_country: 'PH',
            wni_lat: 12.06,
            wni_lon: 124.59,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'CALC',
            wni_port_name: 'CALACA',
            wni_unlocode: 'PHCAA',
            wni_country: 'PH',
            wni_lat: 13.94,
            wni_lon: 120.8,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'CIM',
            wni_port_name: 'CURRIMAO',
            wni_unlocode: 'PHCMO',
            wni_country: 'PH',
            wni_lat: 18.02,
            wni_lon: 120.48,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'CLA',
            wni_port_name: 'CLAVERIA',
            wni_unlocode: 'PHCLV',
            wni_country: 'PH',
            wni_lat: 18.62,
            wni_lon: 121.08,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'COTA',
            wni_port_name: 'COTABATO',
            wni_unlocode: 'PHCBO',
            wni_country: 'PH',
            wni_lat: 7.23,
            wni_lon: 124.25,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'CRLOS',
            wni_port_name: 'SAN CARLOS',
            wni_unlocode: 'PHSCA',
            wni_country: 'PH',
            wni_lat: 10.48,
            wni_lon: 123.42,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'CTBLG',
            wni_port_name: 'CATBALOGAN',
            wni_unlocode: 'PHCTS',
            wni_country: 'PH',
            wni_lat: 11.77,
            wni_lon: 124.88,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'DUA',
            wni_port_name: 'DUMAGUETE',
            wni_unlocode: 'PHDGT',
            wni_country: 'PH',
            wni_lat: 9.32,
            wni_lon: 123.3,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'HNTUN',
            wni_port_name: 'HINATUAN',
            wni_unlocode: 'PHHNT',
            wni_country: 'PH',
            wni_lat: 8.37,
            wni_lon: 126.33,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'HOD',
            wni_port_name: 'HONDAGUA',
            wni_unlocode: 'PHHON',
            wni_country: 'PH',
            wni_lat: 13.95,
            wni_lon: 122.23,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'ISA',
            wni_port_name: 'ISABELA',
            wni_unlocode: 'PHISB',
            wni_country: 'PH',
            wni_lat: 6.72,
            wni_lon: 121.97,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'ISIDR',
            wni_port_name: 'SAN ISIDRO',
            wni_unlocode: 'PHSIS',
            wni_country: 'PH',
            wni_lat: 11.42,
            wni_lon: 124.33,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'JOL',
            wni_port_name: 'JOLO',
            wni_unlocode: 'PHJOL',
            wni_country: 'PH',
            wni_lat: 6.05,
            wni_lon: 121,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'JPA',
            wni_port_name: 'JOSE PANGANIBAN',
            wni_unlocode: 'PHJPM',
            wni_country: 'PH',
            wni_lat: 14.3,
            wni_lon: 122.68,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'LUG',
            wni_port_name: 'LUGAIT',
            wni_unlocode: 'PHLUG',
            wni_country: 'PH',
            wni_lat: 8.34,
            wni_lon: 124.27,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'MLMPY',
            wni_port_name: 'MALAMPAYA',
            wni_unlocode: 'PHMAL',
            wni_country: 'PH',
            wni_lat: 11.52,
            wni_lon: 119.12,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'MNDUE',
            wni_port_name: 'MANDAUE',
            wni_unlocode: 'PHMAN',
            wni_country: 'PH',
            wni_lat: 10.33,
            wni_lon: 123.93,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'MSBT',
            wni_port_name: 'MASBATE',
            wni_unlocode: 'PHMBT',
            wni_country: 'PH',
            wni_lat: 12.37,
            wni_lon: 123.62,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'MSIN',
            wni_port_name: 'MAASIN',
            wni_unlocode: 'PHMAA',
            wni_country: 'PH',
            wni_lat: 10.13,
            wni_lon: 124.83,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'MSO',
            wni_port_name: 'MASAO',
            wni_unlocode: 'PHMAS',
            wni_country: 'PH',
            wni_lat: 9.01,
            wni_lon: 125.5,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'MVL',
            wni_port_name: 'MARIVELES',
            wni_unlocode: 'PHMVS',
            wni_country: 'PH',
            wni_lat: 14.43,
            wni_lon: 120.48,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'NSP',
            wni_port_name: 'NASIPIT',
            wni_unlocode: 'PHNSP',
            wni_country: 'PH',
            wni_lat: 8.98,
            wni_lon: 125.33,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'OLNGP',
            wni_port_name: 'OLONGAPO',
            wni_unlocode: 'PHOLO',
            wni_country: 'PH',
            wni_lat: 14.82,
            wni_lon: 120.27,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'POLLC',
            wni_port_name: 'POLLOC',
            wni_unlocode: 'PHPLC',
            wni_country: 'PH',
            wni_lat: 7.35,
            wni_lon: 124.22,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'PPN',
            wni_port_name: 'PALOMPON',
            wni_unlocode: 'PHPPN',
            wni_country: 'PH',
            wni_lat: 11.05,
            wni_lon: 124.38,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'PRZ',
            wni_port_name: 'PORO',
            wni_unlocode: 'PHPRO',
            wni_country: 'PH',
            wni_lat: 16.62,
            wni_lon: 120.3,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'PUW',
            wni_port_name: 'PUERTO PRINCESA',
            wni_unlocode: 'PHPPS',
            wni_country: 'PH',
            wni_lat: 9.73,
            wni_lon: 118.73,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'SIAIN',
            wni_port_name: 'SIAIN',
            wni_unlocode: 'PHSIN',
            wni_country: 'PH',
            wni_lat: 13.97,
            wni_lon: 122.02,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'TAL',
            wni_port_name: 'TACLOBAN',
            wni_unlocode: 'PHTAC',
            wni_country: 'PH',
            wni_lat: 11.25,
            wni_lon: 125,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'TGBLR',
            wni_port_name: 'TAGBILARAN',
            wni_unlocode: 'PHTAG',
            wni_country: 'PH',
            wni_lat: 9.65,
            wni_lon: 123.85,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'TNDC',
            wni_port_name: 'TANDOC',
            wni_unlocode: 'PHTDC',
            wni_country: 'PH',
            wni_lat: 14.07,
            wni_lon: 123.3,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'TOP',
            wni_port_name: 'TOLEDO',
            wni_unlocode: 'PHTLD',
            wni_country: 'PH',
            wni_lat: 10.38,
            wni_lon: 123.63,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'DRLW',
            wni_port_name: 'DARLOWO',
            wni_unlocode: 'PLDAR',
            wni_country: 'PL',
            wni_lat: 54.43,
            wni_lon: 16.42,
            wni_tz: 'Europe/Warsaw',
        },
        {
            option: 'KLBRZ',
            wni_port_name: 'KOLOBRZEG',
            wni_unlocode: 'PLKOL',
            wni_country: 'PL',
            wni_lat: 54.18,
            wni_lon: 15.57,
            wni_tz: 'Europe/Warsaw',
        },
        {
            option: 'USTK',
            wni_port_name: 'USTKA',
            wni_unlocode: 'PLUST',
            wni_country: 'PL',
            wni_lat: 54.58,
            wni_lon: 16.87,
            wni_tz: 'Europe/Warsaw',
        },
        {
            option: 'AGDLL',
            wni_port_name: 'AGUADILLA',
            wni_unlocode: 'PRBQN',
            wni_country: 'PR',
            wni_lat: 18.43,
            wni_lon: -67.15,
            wni_tz: 'America/Puerto_Rico',
        },
        {
            option: 'ARCB',
            wni_port_name: 'ARECIBO',
            wni_unlocode: 'PRARE',
            wni_country: 'PR',
            wni_lat: 18.48,
            wni_lon: -66.7,
            wni_tz: 'America/Puerto_Rico',
        },
        {
            option: 'GPR',
            wni_port_name: 'GUANICA',
            wni_unlocode: 'PRGUX',
            wni_country: 'PR',
            wni_lat: 17.97,
            wni_lon: -66.92,
            wni_tz: 'America/Puerto_Rico',
        },
        {
            option: 'LSM',
            wni_port_name: 'LAS MAREAS',
            wni_unlocode: 'PRLAM',
            wni_country: 'PR',
            wni_lat: 17.92,
            wni_lon: -66.17,
            wni_tz: 'America/Puerto_Rico',
        },
        {
            option: 'MAY',
            wni_port_name: 'MAYAGUEZ',
            wni_unlocode: 'PRMAZ',
            wni_country: 'PR',
            wni_lat: 18.2,
            wni_lon: -67.15,
            wni_tz: 'America/Puerto_Rico',
        },
        {
            option: 'BARO',
            wni_port_name: 'BARREIRO',
            wni_unlocode: 'PTBRO',
            wni_country: 'PT',
            wni_lat: 38.67,
            wni_lon: -9.08,
            wni_tz: 'Europe/Lisbon',
        },
        {
            option: 'CSC',
            wni_port_name: 'CASCAIS',
            wni_unlocode: 'PTCAS',
            wni_country: 'PT',
            wni_lat: 38.7,
            wni_lon: -9.42,
            wni_tz: 'Europe/Lisbon',
        },
        {
            option: 'FDF',
            wni_port_name: 'FIGUEIRA DA FOZ',
            wni_unlocode: 'PTFDF',
            wni_country: 'PT',
            wni_lat: 40.15,
            wni_lon: -8.85,
            wni_tz: 'Europe/Lisbon',
        },
        {
            option: 'FRO',
            wni_port_name: 'FARO',
            wni_unlocode: 'PTFAO',
            wni_country: 'PT',
            wni_lat: 37.03,
            wni_lon: -7.93,
            wni_tz: 'Europe/Lisbon',
        },
        {
            option: 'HRSM',
            wni_port_name: 'ANGRA DO HEROISMO',
            wni_unlocode: 'PTADH',
            wni_country: 'PT',
            wni_lat: 38.65,
            wni_lon: -27.22,
            wni_tz: 'Atlantic/Azores',
        },
        {
            option: 'HTA',
            wni_port_name: 'HORTA',
            wni_unlocode: 'PTHOR',
            wni_country: 'PT',
            wni_lat: 38.53,
            wni_lon: -28.63,
            wni_tz: 'Atlantic/Azores',
        },
        {
            option: 'LAGP',
            wni_port_name: 'LAGOS',
            wni_unlocode: 'PTLOS',
            wni_country: 'PT',
            wni_lat: 37.1,
            wni_lon: -8.67,
            wni_tz: 'Europe/Lisbon',
        },
        {
            option: 'OPO',
            wni_port_name: 'OPORTO',
            wni_unlocode: 'PTOPO',
            wni_country: 'PT',
            wni_lat: 41.15,
            wni_lon: -8.6,
            wni_tz: 'Europe/Lisbon',
        },
        {
            option: 'PMAO',
            wni_port_name: 'PORTIMAO',
            wni_unlocode: 'PTPRM',
            wni_country: 'PT',
            wni_lat: 37.13,
            wni_lon: -8.53,
            wni_tz: 'Europe/Lisbon',
        },
        {
            option: 'VNC',
            wni_port_name: 'VIANA DO CASTELO',
            wni_unlocode: 'PTVDC',
            wni_country: 'PT',
            wni_lat: 41.68,
            wni_lon: -8.83,
            wni_tz: 'Europe/Lisbon',
        },
        {
            option: 'KRR',
            wni_port_name: 'KOROR',
            wni_unlocode: 'PWROR',
            wni_country: 'PW',
            wni_lat: 7.34,
            wni_lon: 134.48,
            wni_tz: 'Pacific/Palau',
        },
        {
            option: 'BIA',
            wni_port_name: 'BRAILA',
            wni_unlocode: 'ROBRA',
            wni_country: 'RO',
            wni_lat: 45.25,
            wni_lon: 27.98,
            wni_tz: 'Europe/Bucharest',
        },
        {
            option: 'ISCC',
            wni_port_name: 'ISACCEA',
            wni_unlocode: 'ROISC',
            wni_country: 'RO',
            wni_lat: 45.25,
            wni_lon: 28.48,
            wni_tz: 'Europe/Bucharest',
        },
        {
            option: 'MNGL',
            wni_port_name: 'MANGALIA',
            wni_unlocode: 'ROMAG',
            wni_country: 'RO',
            wni_lat: 43.82,
            wni_lon: 28.58,
            wni_tz: 'Europe/Bucharest',
        },
        {
            option: 'SLA',
            wni_port_name: 'SULINA',
            wni_unlocode: 'ROSUL',
            wni_country: 'RO',
            wni_lat: 45.17,
            wni_lon: 29.67,
            wni_tz: 'Europe/Bucharest',
        },
        {
            option: 'ANAPA',
            wni_port_name: 'ANAPA',
            wni_unlocode: 'RUAAQ',
            wni_country: 'RU',
            wni_lat: 44.88,
            wni_lon: 37.32,
            wni_tz: 'Europe/Volgograd',
        },
        {
            option: 'AZOV',
            wni_port_name: 'AZOV',
            wni_unlocode: 'RUAZO',
            wni_country: 'RU',
            wni_lat: 47.1,
            wni_lon: 39.43,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'DDNK',
            wni_port_name: 'DUDINKA',
            wni_unlocode: 'RUDUD',
            wni_country: 'RU',
            wni_lat: 69.4,
            wni_lon: 86.17,
            wni_tz: 'Asia/Krasnoyarsk',
        },
        {
            option: 'DEK',
            wni_port_name: 'DE KASTRI',
            wni_unlocode: 'RUDKA',
            wni_country: 'RU',
            wni_lat: 51.47,
            wni_lon: 140.78,
            wni_tz: 'Asia/Vladivostok',
        },
        {
            option: 'DKSN',
            wni_port_name: 'DIKSON',
            wni_unlocode: 'RUDKS',
            wni_country: 'RU',
            wni_lat: 73.5,
            wni_lon: 80.45,
            wni_tz: 'Asia/Krasnoyarsk',
        },
        {
            option: 'IGRK',
            wni_port_name: 'IGARKA',
            wni_unlocode: 'RUIAA',
            wni_country: 'RU',
            wni_lat: 67.47,
            wni_lon: 86.58,
            wni_tz: 'Asia/Krasnoyarsk',
        },
        {
            option: 'KMCHT',
            wni_port_name: 'UST KAMCHATSK',
            wni_unlocode: 'RUUKK',
            wni_country: 'RU',
            wni_lat: 56.22,
            wni_lon: 162.42,
            wni_tz: 'Asia/Kamchatka',
        },
        {
            option: 'KND',
            wni_port_name: 'KANDALAKSHA',
            wni_unlocode: 'RUKAN',
            wni_country: 'RU',
            wni_lat: 67.13,
            wni_lon: 32.42,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'LMNSV',
            wni_port_name: 'LOMONOSOV',
            wni_unlocode: 'RULOM',
            wni_country: 'RU',
            wni_lat: 59.92,
            wni_lon: 29.77,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'LZRV',
            wni_port_name: 'LAZAREV',
            wni_unlocode: 'RULAZ',
            wni_country: 'RU',
            wni_lat: 52.2,
            wni_lon: 141.53,
            wni_tz: 'Asia/Vladivostok',
        },
        {
            option: 'MAGA',
            wni_port_name: 'MAGADAN',
            wni_unlocode: 'RUMAG',
            wni_country: 'RU',
            wni_lat: 59.54,
            wni_lon: 150.77,
            wni_tz: 'Asia/Magadan',
        },
        {
            option: 'MEZEN',
            wni_port_name: 'MEZEN',
            wni_unlocode: 'RUMEZ',
            wni_country: 'RU',
            wni_lat: 66.17,
            wni_lon: 44,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'NVLSK',
            wni_port_name: 'NEVELSK',
            wni_unlocode: 'RUNEV',
            wni_country: 'RU',
            wni_lat: 46.67,
            wni_lon: 141.87,
            wni_tz: 'Asia/Sakhalin',
        },
        {
            option: 'OLGA',
            wni_port_name: 'OLGA',
            wni_unlocode: 'RUOLB',
            wni_country: 'RU',
            wni_lat: 43.73,
            wni_lon: 135.28,
            wni_tz: 'Asia/Vladivostok',
        },
        {
            option: 'PET',
            wni_port_name: 'PETROPAVLOVSK',
            wni_unlocode: 'RUPKC',
            wni_country: 'RU',
            wni_lat: 53.02,
            wni_lon: 158.65,
            wni_tz: 'Asia/Kamchatka',
        },
        {
            option: 'PRNJS',
            wni_port_name: 'PORONAYSK',
            wni_unlocode: 'RUPRN',
            wni_country: 'RU',
            wni_lat: 49.22,
            wni_lon: 143.13,
            wni_tz: 'Asia/Sakhalin',
        },
        {
            option: 'PVK',
            wni_port_name: 'PEVEK',
            wni_unlocode: 'RUPWE',
            wni_country: 'RU',
            wni_lat: 69.72,
            wni_lon: 170.3,
            wni_tz: 'Asia/Anadyr',
        },
        {
            option: 'SVO',
            wni_port_name: 'SEVERODVINSK',
            wni_unlocode: 'RUSEW',
            wni_country: 'RU',
            wni_lat: 64.57,
            wni_lon: 39.78,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'TGNRG',
            wni_port_name: 'TAGANROG',
            wni_unlocode: 'RUTAG',
            wni_country: 'RU',
            wni_lat: 47.2,
            wni_lon: 38.95,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'TIKSI',
            wni_port_name: 'TIKSI',
            wni_unlocode: 'RUIKS',
            wni_country: 'RU',
            wni_lat: 71.63,
            wni_lon: 128.87,
            wni_tz: 'Asia/Yakutsk',
        },
        {
            option: 'VYB',
            wni_port_name: 'VYBORG',
            wni_unlocode: 'RUVYG',
            wni_country: 'RU',
            wni_lat: 60.72,
            wni_lon: 28.75,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'YYSK',
            wni_port_name: 'YEYSK',
            wni_unlocode: 'RUYEY',
            wni_country: 'RU',
            wni_lat: 46.73,
            wni_lon: 38.27,
            wni_tz: 'Europe/Volgograd',
        },
        {
            option: 'DHB',
            wni_port_name: 'DHIBA',
            wni_unlocode: 'SADHU',
            wni_country: 'SA',
            wni_lat: 27.56,
            wni_lon: 35.55,
            wni_tz: 'Asia/Riyadh',
        },
        {
            option: 'RMB',
            wni_port_name: 'RAS AL MISHAB',
            wni_unlocode: 'SARAM',
            wni_country: 'SA',
            wni_lat: 28.12,
            wni_lon: 48.63,
            wni_tz: 'Asia/Riyadh',
        },
        {
            option: 'AOLA',
            wni_port_name: 'AOLA BAY',
            wni_unlocode: 'SBAOB',
            wni_country: 'SB',
            wni_lat: -9.53,
            wni_lon: 160.5,
            wni_tz: 'Pacific/Guadalcanal',
        },
        {
            option: 'LOP',
            wni_port_name: 'LOFUNG',
            wni_unlocode: 'SBLOF',
            wni_country: 'SB',
            wni_lat: -7.07,
            wni_lon: 155.87,
            wni_tz: 'Pacific/Guadalcanal',
        },
        {
            option: 'RNG',
            wni_port_name: 'RINGI COVE',
            wni_unlocode: 'SBRIN',
            wni_country: 'SB',
            wni_lat: -8.12,
            wni_lon: 157.12,
            wni_tz: 'Pacific/Guadalcanal',
        },
        {
            option: 'YAN',
            wni_port_name: 'YANDINA',
            wni_unlocode: 'SBXYA',
            wni_country: 'SB',
            wni_lat: -9.08,
            wni_lon: 159.22,
            wni_tz: 'Pacific/Guadalcanal',
        },
        {
            option: 'SUAK',
            wni_port_name: 'SUAKIN',
            wni_unlocode: 'SDSWA',
            wni_country: 'SD',
            wni_lat: 19.12,
            wni_lon: 37.34,
            wni_tz: 'Africa/Khartoum',
        },
        {
            option: 'AXELS',
            wni_port_name: 'AXELSVIK',
            wni_unlocode: 'SEAXE',
            wni_country: 'SE',
            wni_lat: 65.77,
            wni_lon: 23.37,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'BOLST',
            wni_port_name: 'BOLLSTA',
            wni_unlocode: 'SEBOL',
            wni_country: 'SE',
            wni_lat: 62.98,
            wni_lon: 17.7,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'BOR',
            wni_port_name: 'BORGHOLM',
            wni_unlocode: 'SEBOM',
            wni_country: 'SE',
            wni_lat: 56.88,
            wni_lon: 16.65,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'BRFJN',
            wni_port_name: 'BROFJORDEN',
            wni_unlocode: 'SEBRO',
            wni_country: 'SE',
            wni_lat: 58.35,
            wni_lon: 11.44,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'DGRHM',
            wni_port_name: 'DEGERHAMN',
            wni_unlocode: 'SEDEG',
            wni_country: 'SE',
            wni_lat: 56.35,
            wni_lon: 16.42,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'DMSJ',
            wni_port_name: 'DOMSJO',
            wni_unlocode: 'SEDOM',
            wni_country: 'SE',
            wni_lat: 63.27,
            wni_lon: 18.73,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'FALKN',
            wni_port_name: 'FALKENBERG',
            wni_unlocode: 'SEFAG',
            wni_country: 'SE',
            wni_lat: 56.9,
            wni_lon: 12.5,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'HDKSV',
            wni_port_name: 'HUDIKSVALL',
            wni_unlocode: 'SEHUV',
            wni_country: 'SE',
            wni_lat: 61.73,
            wni_lon: 17.12,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'HLMSN',
            wni_port_name: 'HOLMSUND',
            wni_unlocode: 'SEHLD',
            wni_country: 'SE',
            wni_lat: 63.7,
            wni_lon: 20.33,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'HLSTA',
            wni_port_name: 'HALLSTAVIK',
            wni_unlocode: 'SEHAK',
            wni_country: 'SE',
            wni_lat: 60.05,
            wni_lon: 18.58,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'HOG',
            wni_port_name: 'HOGANAS',
            wni_unlocode: 'SEHOG',
            wni_country: 'SE',
            wni_lat: 56.2,
            wni_lon: 12.55,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'HRGSH',
            wni_port_name: 'HARGSHAMN',
            wni_unlocode: 'SEHAN',
            wni_country: 'SE',
            wni_lat: 60.18,
            wni_lon: 18.45,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'HRNFR',
            wni_port_name: 'HORNEFORS',
            wni_unlocode: 'SEHNF',
            wni_country: 'SE',
            wni_lat: 63.62,
            wni_lon: 19.9,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'HRNSN',
            wni_port_name: 'HARNOSAND',
            wni_unlocode: 'SEHND',
            wni_country: 'SE',
            wni_lat: 62.63,
            wni_lon: 17.95,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'HSMN',
            wni_port_name: 'HUSUM',
            wni_unlocode: 'SEHUS',
            wni_country: 'SE',
            wni_lat: 63.33,
            wni_lon: 19.15,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'IGGSN',
            wni_port_name: 'IGGESUND',
            wni_unlocode: 'SEIGG',
            wni_country: 'SE',
            wni_lat: 61.63,
            wni_lon: 17.12,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'KALIX',
            wni_port_name: 'KALIX',
            wni_unlocode: 'SEKAX',
            wni_country: 'SE',
            wni_lat: 65.85,
            wni_lon: 23.13,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'KAP',
            wni_port_name: 'KAPPELSHAMN',
            wni_unlocode: 'SEKPH',
            wni_country: 'SE',
            wni_lat: 57.85,
            wni_lon: 18.79,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'KARL',
            wni_port_name: 'KARLSKRONA',
            wni_unlocode: 'SEKAA',
            wni_country: 'SE',
            wni_lat: 56.17,
            wni_lon: 15.6,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'KLMR',
            wni_port_name: 'KALMAR',
            wni_unlocode: 'SEKLR',
            wni_country: 'SE',
            wni_lat: 56.67,
            wni_lon: 16.37,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'KLNTH',
            wni_port_name: 'KLINTEHAMN',
            wni_unlocode: 'SEKLI',
            wni_country: 'SE',
            wni_lat: 57.38,
            wni_lon: 18.2,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'KPMNH',
            wni_port_name: 'KOPMANHOLMEN',
            wni_unlocode: 'SEKMH',
            wni_country: 'SE',
            wni_lat: 63.17,
            wni_lon: 18.58,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'KPN',
            wni_port_name: 'KOPING',
            wni_unlocode: 'SEKOG',
            wni_country: 'SE',
            wni_lat: 59.5,
            wni_lon: 16.02,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'KRLSB',
            wni_port_name: 'KARLSBORG',
            wni_unlocode: 'SEKXV',
            wni_country: 'SE',
            wni_lat: 65.8,
            wni_lon: 23.28,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'KRLSE',
            wni_port_name: 'KARLSVIK',
            wni_unlocode: 'SEKAK',
            wni_country: 'SE',
            wni_lat: 65.6,
            wni_lon: 22.08,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'KRMFR',
            wni_port_name: 'KRAMFORS',
            wni_unlocode: 'SEKRF',
            wni_country: 'SE',
            wni_lat: 62.93,
            wni_lon: 17.8,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'KRSKR',
            wni_port_name: 'KARSKAR',
            wni_unlocode: 'SEKAS',
            wni_country: 'SE',
            wni_lat: 60.67,
            wni_lon: 17.3,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'KUB',
            wni_port_name: 'KUBIKENBORG',
            wni_unlocode: 'SEKUB',
            wni_country: 'SE',
            wni_lat: 62.38,
            wni_lon: 17.37,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'LJSN',
            wni_port_name: 'LJUSNE',
            wni_unlocode: 'SELJU',
            wni_country: 'SE',
            wni_lat: 61.2,
            wni_lon: 17.15,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'LMH',
            wni_port_name: 'LIMHAMN',
            wni_unlocode: 'SELIM',
            wni_country: 'SE',
            wni_lat: 55.58,
            wni_lon: 12.93,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'LND',
            wni_port_name: 'LANDSKRONA',
            wni_unlocode: 'SELAA',
            wni_country: 'SE',
            wni_lat: 55.87,
            wni_lon: 12.83,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'LUGN',
            wni_port_name: 'LUGNVIK',
            wni_unlocode: 'SELUG',
            wni_country: 'SE',
            wni_lat: 62.93,
            wni_lon: 17.97,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'MARRD',
            wni_port_name: 'MARSTRAND',
            wni_unlocode: 'SEMSD',
            wni_country: 'SE',
            wni_lat: 57.88,
            wni_lon: 11.58,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'MEM',
            wni_port_name: 'MEM',
            wni_unlocode: 'SEMEM',
            wni_country: 'SE',
            wni_lat: 58.48,
            wni_lon: 16.42,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'MNKSN',
            wni_port_name: 'MUNKSUND',
            wni_unlocode: 'SEMUN',
            wni_country: 'SE',
            wni_lat: 65.28,
            wni_lon: 21.48,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'MNST',
            wni_port_name: 'MONSTERAS',
            wni_unlocode: 'SEMON',
            wni_country: 'SE',
            wni_lat: 57.04,
            wni_lon: 16.44,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'NRRSN',
            wni_port_name: 'NORRSUNDET',
            wni_unlocode: 'SENOT',
            wni_country: 'SE',
            wni_lat: 60.93,
            wni_lon: 17.15,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'NYKPN',
            wni_port_name: 'NYKOPING',
            wni_unlocode: 'SENYO',
            wni_country: 'SE',
            wni_lat: 58.75,
            wni_lon: 17.02,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'NYN',
            wni_port_name: 'NYNASHAMN',
            wni_unlocode: 'SENYN',
            wni_country: 'SE',
            wni_lat: 58.9,
            wni_lon: 17.97,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'OBBL',
            wni_port_name: 'OBBOLA',
            wni_unlocode: 'SEOBB',
            wni_country: 'SE',
            wni_lat: 63.7,
            wni_lon: 20.33,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'ORS',
            wni_port_name: 'ORNSKOLDSVIK',
            wni_unlocode: 'SEOER',
            wni_country: 'SE',
            wni_lat: 63.28,
            wni_lon: 18.72,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'ORTSE',
            wni_port_name: 'ORTVIKEN',
            wni_unlocode: 'SEORT',
            wni_country: 'SE',
            wni_lat: 62.4,
            wni_lon: 17.37,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'OSKN',
            wni_port_name: 'OSKARSHAMN',
            wni_unlocode: 'SEOSK',
            wni_country: 'SE',
            wni_lat: 57.27,
            wni_lon: 16.45,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'OSRND',
            wni_port_name: 'OSTRAND',
            wni_unlocode: 'SEOST',
            wni_country: 'SE',
            wni_lat: 62.48,
            wni_lon: 17.37,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'PTHLM',
            wni_port_name: 'PATAHOLM',
            wni_unlocode: 'SEPHM',
            wni_country: 'SE',
            wni_lat: 56.92,
            wni_lon: 16.43,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'RNDSE',
            wni_port_name: 'RUNDVIK',
            wni_unlocode: 'SERUV',
            wni_country: 'SE',
            wni_lat: 63.53,
            wni_lon: 19.45,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'RNHMN',
            wni_port_name: 'RONEHAMN',
            wni_unlocode: 'SERNH',
            wni_country: 'SE',
            wni_lat: 57.17,
            wni_lon: 18.5,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'SANDR',
            wni_port_name: 'SANDARNE',
            wni_unlocode: 'SESAE',
            wni_country: 'SE',
            wni_lat: 61.27,
            wni_lon: 17.18,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'SDT',
            wni_port_name: 'SODERTALJE',
            wni_unlocode: 'SEIDJ',
            wni_country: 'SE',
            wni_lat: 59.18,
            wni_lon: 17.65,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'SDV',
            wni_port_name: 'SUNDSVALL',
            wni_unlocode: 'SESDL',
            wni_country: 'SE',
            wni_lat: 62.38,
            wni_lon: 17.32,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'SKTSK',
            wni_port_name: 'SKUTSKAR',
            wni_unlocode: 'SESSR',
            wni_country: 'SE',
            wni_lat: 60.65,
            wni_lon: 17.4,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'SLVSB',
            wni_port_name: 'SOLVESBORG',
            wni_unlocode: 'SESOL',
            wni_country: 'SE',
            wni_lat: 56.05,
            wni_lon: 14.58,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'SMRSH',
            wni_port_name: 'SIMRISHAMN',
            wni_unlocode: 'SESIM',
            wni_country: 'SE',
            wni_lat: 55.55,
            wni_lon: 14.37,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'SRKR',
            wni_port_name: 'SORAKER',
            wni_unlocode: 'SESOR',
            wni_country: 'SE',
            wni_lat: 62.5,
            wni_lon: 17.53,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'STOCK',
            wni_port_name: 'STOCKVIK',
            wni_unlocode: 'SESTK',
            wni_country: 'SE',
            wni_lat: 62.33,
            wni_lon: 17.38,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'STRGN',
            wni_port_name: 'STORUGNS',
            wni_unlocode: 'SESUS',
            wni_country: 'SE',
            wni_lat: 57.83,
            wni_lon: 18.82,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'SVART',
            wni_port_name: 'SVARTVIK',
            wni_unlocode: 'SESVK',
            wni_country: 'SE',
            wni_lat: 62.32,
            wni_lon: 17.38,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'TRG',
            wni_port_name: 'TRELLEBORG',
            wni_unlocode: 'SETRG',
            wni_country: 'SE',
            wni_lat: 55.37,
            wni_lon: 13.15,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'TUNDL',
            wni_port_name: 'TUNADAL',
            wni_unlocode: 'SETUN',
            wni_country: 'SE',
            wni_lat: 62.42,
            wni_lon: 17.42,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'UMEA',
            wni_port_name: 'UMEA',
            wni_unlocode: 'SEUME',
            wni_country: 'SE',
            wni_lat: 63.7,
            wni_lon: 20.35,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'UTJ',
            wni_port_name: 'UTANSJO',
            wni_unlocode: 'SEUTA',
            wni_country: 'SE',
            wni_lat: 62.77,
            wni_lon: 17.93,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'VAJA',
            wni_port_name: 'VAJA',
            wni_unlocode: 'SEVAJ',
            wni_country: 'SE',
            wni_lat: 62.98,
            wni_lon: 17.72,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'VALL',
            wni_port_name: 'VALLVIK',
            wni_unlocode: 'SEVAL',
            wni_country: 'SE',
            wni_lat: 61.2,
            wni_lon: 17.18,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'VALMR',
            wni_port_name: 'VALDEMARSVIK',
            wni_unlocode: 'SEVAK',
            wni_country: 'SE',
            wni_lat: 58.2,
            wni_lon: 16.6,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'VSTRS',
            wni_port_name: 'VASTERAS',
            wni_unlocode: 'SEVST',
            wni_country: 'SE',
            wni_lat: 59.62,
            wni_lon: 16.55,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'VSTRV',
            wni_port_name: 'VASTERVIK',
            wni_unlocode: 'SEVVK',
            wni_country: 'SE',
            wni_lat: 57.77,
            wni_lon: 16.65,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'YSTAD',
            wni_port_name: 'YSTAD',
            wni_unlocode: 'SEYST',
            wni_country: 'SE',
            wni_lat: 55.43,
            wni_lon: 13.83,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'PXP',
            wni_port_name: 'PASIR PANJANG',
            wni_unlocode: 'SGPAP',
            wni_country: 'SG',
            wni_lat: 1.28,
            wni_lon: 103.78,
            wni_tz: 'Asia/Singapore',
        },
        {
            option: 'SBRK',
            wni_port_name: 'PULAU SEBAROK',
            wni_unlocode: 'SGSEB',
            wni_country: 'SG',
            wni_lat: 1.2,
            wni_lon: 103.8,
            wni_tz: 'Asia/Singapore',
        },
        {
            option: 'SG',
            wni_port_name: 'SINGAPORE',
            wni_unlocode: 'SGSIN',
            wni_country: 'SG',
            wni_lat: 1.28,
            wni_lon: 103.85,
            wni_tz: 'Asia/Singapore',
        },
        {
            option: 'GRGTW',
            wni_port_name: 'GEORGETOWN',
            wni_unlocode: 'SHASI',
            wni_country: 'SH',
            wni_lat: -7.93,
            wni_lon: -14.42,
            wni_tz: 'Atlantic/St_Helena',
        },
        {
            option: 'JMSTW',
            wni_port_name: 'JAMESTOWN',
            wni_unlocode: 'SHSHN',
            wni_country: 'SH',
            wni_lat: -15.92,
            wni_lon: -5.72,
            wni_tz: 'Atlantic/St_Helena',
        },
        {
            option: 'IZOLA',
            wni_port_name: 'IZOLA',
            wni_unlocode: 'SIIZO',
            wni_country: 'SI',
            wni_lat: 45.53,
            wni_lon: 13.67,
            wni_tz: 'Europe/Ljubljana',
        },
        {
            option: 'PIRAN',
            wni_port_name: 'PIRAN',
            wni_unlocode: 'SIPIR',
            wni_country: 'SI',
            wni_lat: 45.53,
            wni_lon: 13.57,
            wni_tz: 'Europe/Ljubljana',
        },
        {
            option: 'BTSG',
            wni_port_name: 'BARENTSBURG',
            wni_unlocode: 'SJBAR',
            wni_country: 'SJ',
            wni_lat: 78.07,
            wni_lon: 14.23,
            wni_tz: 'Arctic/Longyearbyen',
        },
        {
            option: 'ZIG',
            wni_port_name: 'ZIGUINCHOR',
            wni_unlocode: 'SNZIG',
            wni_country: 'SN',
            wni_lat: 12.59,
            wni_lon: -16.27,
            wni_tz: 'Africa/Dakar',
        },
        {
            option: 'BRB',
            wni_port_name: 'BERBERA',
            wni_unlocode: 'SOBBO',
            wni_country: 'SO',
            wni_lat: 10.45,
            wni_lon: 45.02,
            wni_tz: 'Africa/Mogadishu',
        },
        {
            option: 'MERCA',
            wni_port_name: 'MERCA',
            wni_unlocode: 'SOMER',
            wni_country: 'SO',
            wni_lat: 1.72,
            wni_lon: 44.78,
            wni_tz: 'Africa/Mogadishu',
        },
        {
            option: 'MNG',
            wni_port_name: 'MOENGO',
            wni_unlocode: 'SRMOJ',
            wni_country: 'SR',
            wni_lat: 5.63,
            wni_lon: -54.42,
            wni_tz: 'America/Paramaribo',
        },
        {
            option: 'NSU',
            wni_port_name: 'NIEUW NICKERIE',
            wni_unlocode: 'SRICK',
            wni_country: 'SR',
            wni_lat: 5.95,
            wni_lon: -57,
            wni_tz: 'America/Paramaribo',
        },
        {
            option: 'SML',
            wni_port_name: 'SMALKALDEN',
            wni_unlocode: 'SRSMA',
            wni_country: 'SR',
            wni_lat: 5.62,
            wni_lon: -55.1,
            wni_tz: 'America/Paramaribo',
        },
        {
            option: 'WGG',
            wni_port_name: 'WAGENINGEN',
            wni_unlocode: 'SRAGI',
            wni_country: 'SR',
            wni_lat: 5.77,
            wni_lon: -56.68,
            wni_tz: 'America/Paramaribo',
        },
        {
            option: 'ATONO',
            wni_port_name: 'SANTO ANTONIO',
            wni_unlocode: 'STSAA',
            wni_country: 'ST',
            wni_lat: 1.63,
            wni_lon: 7.43,
            wni_tz: 'Africa/Sao_Tome',
        },
        {
            option: 'LBRTD',
            wni_port_name: 'LA LIBERTAD',
            wni_unlocode: 'SVLLD',
            wni_country: 'SV',
            wni_lat: 13.48,
            wni_lon: -89.32,
            wni_tz: 'America/El_Salvador',
        },
        {
            option: 'LUE',
            wni_port_name: 'LA UNION',
            wni_unlocode: 'SVLUN',
            wni_country: 'SV',
            wni_lat: 13.33,
            wni_lon: -87.83,
            wni_tz: 'America/El_Salvador',
        },
        {
            option: 'GRAND',
            wni_port_name: 'GRAND TURK',
            wni_unlocode: 'TCGDT',
            wni_country: 'TC',
            wni_lat: 21.48,
            wni_lon: -71.12,
            wni_tz: 'America/Grand_Turk',
        },
        {
            option: 'PVV',
            wni_port_name: 'PROVIDENCIALES',
            wni_unlocode: 'TCPLS',
            wni_country: 'TC',
            wni_lat: 21.76,
            wni_lon: -72.26,
            wni_tz: 'America/Grand_Turk',
        },
        {
            option: 'PUK',
            wni_port_name: 'PHUKET',
            wni_unlocode: 'THHKT',
            wni_country: 'TH',
            wni_lat: 7.82,
            wni_lon: 98.41,
            wni_tz: 'Asia/Bangkok',
        },
        {
            option: 'BKDS',
            wni_port_name: 'BEKDASH',
            wni_unlocode: 'TMBKH',
            wni_country: 'TM',
            wni_lat: 41.53,
            wni_lon: 52.57,
            wni_tz: 'Asia/Ashgabat',
        },
        {
            option: 'MZB',
            wni_port_name: 'MENZEL BOURGUIBA',
            wni_unlocode: 'TNMBA',
            wni_country: 'TN',
            wni_lat: 37.16,
            wni_lon: 9.81,
            wni_tz: 'Africa/Tunis',
        },
        {
            option: 'RAD',
            wni_port_name: 'RADES',
            wni_unlocode: 'TNRDS',
            wni_country: 'TN',
            wni_lat: 36.81,
            wni_lon: 10.27,
            wni_tz: 'Africa/Tunis',
        },
        {
            option: 'ZRZ',
            wni_port_name: 'ZARZIS',
            wni_unlocode: 'TNZAZ',
            wni_country: 'TN',
            wni_lat: 33.48,
            wni_lon: 11.12,
            wni_tz: 'Africa/Tunis',
        },
        {
            option: 'NEIAF',
            wni_port_name: 'NEIAFU',
            wni_unlocode: 'TONEI',
            wni_country: 'TO',
            wni_lat: -18.65,
            wni_lon: -173.98,
            wni_tz: 'Pacific/Tongatapu',
        },
        {
            option: 'PANGI',
            wni_port_name: 'PANGAI',
            wni_unlocode: 'TOPAN',
            wni_country: 'TO',
            wni_lat: -19.8,
            wni_lon: -174.35,
            wni_tz: 'Pacific/Tongatapu',
        },
        {
            option: 'ALNY',
            wni_port_name: 'ALANYA',
            wni_unlocode: 'TRALA',
            wni_country: 'TR',
            wni_lat: 36.53,
            wni_lon: 32,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'BOD',
            wni_port_name: 'BODRUM',
            wni_unlocode: 'TRBXN',
            wni_country: 'TR',
            wni_lat: 37.03,
            wni_lon: 27.43,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'FATSA',
            wni_port_name: 'FATSA',
            wni_unlocode: 'TRFAS',
            wni_country: 'TR',
            wni_lat: 41.05,
            wni_lon: 37.52,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'FET',
            wni_port_name: 'FETHIYE',
            wni_unlocode: 'TRFET',
            wni_country: 'TR',
            wni_lat: 36.63,
            wni_lon: 29.1,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'GBL',
            wni_port_name: 'GELIBOLU',
            wni_unlocode: 'TRGEL',
            wni_country: 'TR',
            wni_lat: 40.37,
            wni_lon: 26.63,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'GCK',
            wni_port_name: 'GOCEK',
            wni_unlocode: 'TRGCK',
            wni_country: 'TR',
            wni_lat: 36.75,
            wni_lon: 28.94,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'GIR',
            wni_port_name: 'GIRESUN',
            wni_unlocode: 'TRGIR',
            wni_country: 'TR',
            wni_lat: 40.93,
            wni_lon: 38.4,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'GUL',
            wni_port_name: 'GULLUK',
            wni_unlocode: 'TRGUL',
            wni_country: 'TR',
            wni_lat: 37.24,
            wni_lon: 27.6,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'HAYD',
            wni_port_name: 'HAYDARPASA',
            wni_unlocode: 'TRHAY',
            wni_country: 'TR',
            wni_lat: 41,
            wni_lon: 29.02,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'HPA',
            wni_port_name: 'HOPA',
            wni_unlocode: 'TRHOP',
            wni_country: 'TR',
            wni_lat: 41.42,
            wni_lon: 41.4,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'IEBL',
            wni_port_name: 'INEBOLU',
            wni_unlocode: 'TRINE',
            wni_country: 'TR',
            wni_lat: 41.98,
            wni_lon: 33.77,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'IGND',
            wni_port_name: 'IGNEADA',
            wni_unlocode: 'TRIGN',
            wni_country: 'TR',
            wni_lat: 41.87,
            wni_lon: 28,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'KRTL',
            wni_port_name: 'KARTAL',
            wni_unlocode: 'TRKAR',
            wni_country: 'TR',
            wni_lat: 40.88,
            wni_lon: 29.18,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'KSDS',
            wni_port_name: 'KUSADASI',
            wni_unlocode: 'TRKUS',
            wni_country: 'TR',
            wni_lat: 37.87,
            wni_lon: 27.25,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'MUD',
            wni_port_name: 'MUDANYA',
            wni_unlocode: 'TRMUD',
            wni_country: 'TR',
            wni_lat: 40.38,
            wni_lon: 28.88,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'ORDU',
            wni_port_name: 'ORDU',
            wni_unlocode: 'TRORD',
            wni_country: 'TR',
            wni_lat: 41,
            wni_lon: 37.88,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'RIZE',
            wni_port_name: 'RIZE',
            wni_unlocode: 'TRRIZ',
            wni_country: 'TR',
            wni_lat: 41.07,
            wni_lon: 40.52,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'SNOP',
            wni_port_name: 'SINOP',
            wni_unlocode: 'TRSIC',
            wni_country: 'TR',
            wni_lat: 42.05,
            wni_lon: 35.17,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'SSKI',
            wni_port_name: 'SARISEKI',
            wni_unlocode: 'TRSRS',
            wni_country: 'TR',
            wni_lat: 36.66,
            wni_lon: 36.2,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'TRB',
            wni_port_name: 'TRABZON',
            wni_unlocode: 'TRTZX',
            wni_country: 'TR',
            wni_lat: 41.02,
            wni_lon: 39.77,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'TSC',
            wni_port_name: 'TASUCU',
            wni_unlocode: 'TRTAS',
            wni_country: 'TR',
            wni_lat: 36.32,
            wni_lon: 33.88,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'UNY',
            wni_port_name: 'UNYE',
            wni_unlocode: 'TRUNY',
            wni_country: 'TR',
            wni_lat: 41.15,
            wni_lon: 37.32,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'YAL',
            wni_port_name: 'YALOVA',
            wni_unlocode: 'TRYAL',
            wni_country: 'TR',
            wni_lat: 40.65,
            wni_lon: 29.27,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'BROS',
            wni_port_name: 'BRIGHTON',
            wni_unlocode: 'TTLAB',
            wni_country: 'TT',
            wni_lat: 10.25,
            wni_lon: -61.63,
            wni_tz: 'America/Port_of_Spain',
        },
        {
            option: 'CHG',
            wni_port_name: 'CHAGUARAMAS',
            wni_unlocode: 'TTCHA',
            wni_country: 'TT',
            wni_lat: 10.68,
            wni_lon: -61.65,
            wni_tz: 'America/Port_of_Spain',
        },
        {
            option: 'LBR',
            wni_port_name: 'LA BREA',
            wni_unlocode: 'TTLAB',
            wni_country: 'TT',
            wni_lat: 10.17,
            wni_lon: -61.54,
            wni_tz: 'America/Port_of_Spain',
        },
        {
            option: 'LBREA',
            wni_port_name: 'LA BREA',
            wni_unlocode: 'TTLAB',
            wni_country: 'TT',
            wni_lat: 10.25,
            wni_lon: -61.63,
            wni_tz: 'America/Port_of_Spain',
        },
        {
            option: 'POSP',
            wni_port_name: 'PORT OF SPAIN',
            wni_unlocode: 'TTPOS',
            wni_country: 'TT',
            wni_lat: 10.65,
            wni_lon: -61.52,
            wni_tz: 'America/Port_of_Spain',
        },
        {
            option: 'SCAR',
            wni_port_name: 'SCARBOROUGH',
            wni_unlocode: 'TTSCA',
            wni_country: 'TT',
            wni_lat: 11.18,
            wni_lon: -60.73,
            wni_tz: 'America/Port_of_Spain',
        },
        {
            option: 'KVNJ',
            wni_port_name: 'KILWA KIVINJE',
            wni_unlocode: 'TZKIK',
            wni_country: 'TZ',
            wni_lat: -8.73,
            wni_lon: 39.42,
            wni_tz: 'Africa/Dar_es_Salaam',
        },
        {
            option: 'KWM',
            wni_port_name: 'KILWA MASOKO',
            wni_unlocode: 'TZKIM',
            wni_country: 'TZ',
            wni_lat: -8.93,
            wni_lon: 39.52,
            wni_tz: 'Africa/Dar_es_Salaam',
        },
        {
            option: 'LINDI',
            wni_port_name: 'LINDI',
            wni_unlocode: 'TZLDI',
            wni_country: 'TZ',
            wni_lat: -9.98,
            wni_lon: 39.73,
            wni_tz: 'Africa/Dar_es_Salaam',
        },
        {
            option: 'DNA',
            wni_port_name: 'UST-DUNAYSK',
            wni_unlocode: 'UAUDY',
            wni_country: 'UA',
            wni_lat: 45.47,
            wni_lon: 29.71,
            wni_tz: 'Europe/Kiev',
        },
        {
            option: 'KHR',
            wni_port_name: 'KHERSON',
            wni_unlocode: 'UAKHE',
            wni_country: 'UA',
            wni_lat: 46.62,
            wni_lon: 32.6,
            wni_tz: 'Europe/Kiev',
        },
        {
            option: 'SKDVS',
            wni_port_name: 'SKADOVSK',
            wni_unlocode: 'UASKD',
            wni_country: 'UA',
            wni_lat: 46.1,
            wni_lon: 32.92,
            wni_tz: 'Europe/Kiev',
        },
        {
            option: 'ZHD',
            wni_port_name: 'ZHDANOV',
            wni_unlocode: 'UAMPW',
            wni_country: 'UA',
            wni_lat: 47.08,
            wni_lon: 37.58,
            wni_tz: 'Europe/Kiev',
        },
        {
            option: 'MID',
            wni_port_name: 'MIDWAY ISLAND',
            wni_unlocode: 'UMMDY',
            wni_country: 'UM',
            wni_lat: 28.18,
            wni_lon: -177.37,
            wni_tz: 'Pacific/Midway',
        },
        {
            option: 'WKI',
            wni_port_name: 'WAKE ISLAND',
            wni_unlocode: 'UMAWK',
            wni_country: 'UM',
            wni_lat: 19.28,
            wni_lon: 166.62,
            wni_tz: 'Pacific/Wake',
        },
        {
            option: 'AEX',
            wni_port_name: 'ALEXANDRIA',
            wni_unlocode: 'USAXB',
            wni_country: 'US',
            wni_lat: 38.8,
            wni_lon: -77.03,
            wni_tz: 'America/New_York',
        },
        {
            option: 'ALGNC',
            wni_port_name: 'ALGONAC',
            wni_unlocode: 'USALG',
            wni_country: 'US',
            wni_lat: 42.62,
            wni_lon: -82.52,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'ALM',
            wni_port_name: 'ALAMEDA',
            wni_unlocode: 'USNGZ',
            wni_country: 'US',
            wni_lat: 37.78,
            wni_lon: -122.27,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'ALPEN',
            wni_port_name: 'ALPENA',
            wni_unlocode: 'USAPN',
            wni_country: 'US',
            wni_lat: 45.07,
            wni_lon: -83.42,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'AML',
            wni_port_name: 'AMA',
            wni_unlocode: 'USAMD',
            wni_country: 'US',
            wni_lat: 29.95,
            wni_lon: -90.31,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'APLCH',
            wni_port_name: 'APALACHICOLA',
            wni_unlocode: 'USAAF',
            wni_country: 'US',
            wni_lat: 29.72,
            wni_lon: -84.98,
            wni_tz: 'America/New_York',
        },
        {
            option: 'ARNSS',
            wni_port_name: 'PORT ARANSAS',
            wni_unlocode: 'USTZS',
            wni_country: 'US',
            wni_lat: 27.83,
            wni_lon: -97.05,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'ASB',
            wni_port_name: 'ASHTABULA',
            wni_unlocode: 'USASF',
            wni_country: 'US',
            wni_lat: 41.9,
            wni_lon: -80.8,
            wni_tz: 'America/New_York',
        },
        {
            option: 'ASHLN',
            wni_port_name: 'ASHLAND',
            wni_unlocode: 'USASX',
            wni_country: 'US',
            wni_lat: 46.6,
            wni_lon: -90.87,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'AVD',
            wni_port_name: 'AVONDALE',
            wni_unlocode: 'USAVD',
            wni_country: 'US',
            wni_lat: 29.93,
            wni_lon: -90.19,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'BAYMI',
            wni_port_name: 'BAY CITY',
            wni_unlocode: 'USYBZ',
            wni_country: 'US',
            wni_lat: 43.6,
            wni_lon: -83.87,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'BCG',
            wni_port_name: 'BOCA GRANDE',
            wni_unlocode: 'USBCG',
            wni_country: 'US',
            wni_lat: 26.7,
            wni_lon: -82.33,
            wni_tz: 'America/New_York',
        },
        {
            option: 'BCK',
            wni_port_name: 'BUCKSPORT',
            wni_unlocode: 'USBUP',
            wni_country: 'US',
            wni_lat: 44.57,
            wni_lon: -68.78,
            wni_tz: 'America/New_York',
        },
        {
            option: 'BGR',
            wni_port_name: 'BANGOR',
            wni_unlocode: 'USBGR',
            wni_country: 'US',
            wni_lat: 44.8,
            wni_lon: -68.77,
            wni_tz: 'America/New_York',
        },
        {
            option: 'BNY',
            wni_port_name: 'BUFFALO',
            wni_unlocode: 'USBUF',
            wni_country: 'US',
            wni_lat: 42.88,
            wni_lon: -78.88,
            wni_tz: 'America/New_York',
        },
        {
            option: 'BRE',
            wni_port_name: 'BREMERTON',
            wni_unlocode: 'USPWT',
            wni_country: 'US',
            wni_lat: 47.57,
            wni_lon: -122.65,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'BRKLY',
            wni_port_name: 'BERKELEY',
            wni_unlocode: 'USJBK',
            wni_country: 'US',
            wni_lat: 37.87,
            wni_lon: -122.3,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'BRME',
            wni_port_name: 'BAR HARBOR',
            wni_unlocode: 'USBHB',
            wni_country: 'US',
            wni_lat: 44.38,
            wni_lon: -68.2,
            wni_tz: 'America/New_York',
        },
        {
            option: 'BRO',
            wni_port_name: 'BROOKLYN',
            wni_unlocode: 'USBOY',
            wni_country: 'US',
            wni_lat: 40.67,
            wni_lon: -74.02,
            wni_tz: 'America/New_York',
        },
        {
            option: 'BTHL',
            wni_port_name: 'BETHEL',
            wni_unlocode: 'USBTJ',
            wni_country: 'US',
            wni_lat: 60.82,
            wni_lon: -161.72,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'BWA',
            wni_port_name: 'BAYWAY',
            wni_unlocode: 'US8BY',
            wni_country: 'US',
            wni_lat: 40.63,
            wni_lon: -74.2,
            wni_tz: 'America/New_York',
        },
        {
            option: 'CALCT',
            wni_port_name: 'CALCITE',
            wni_unlocode: 'USMI3',
            wni_country: 'US',
            wni_lat: 45.42,
            wni_lon: -83.78,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'CAMAS',
            wni_port_name: 'CAMAS',
            wni_unlocode: 'USCMS',
            wni_country: 'US',
            wni_lat: 45.58,
            wni_lon: -122.4,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'CBG',
            wni_port_name: 'CAMBRIDGE',
            wni_unlocode: 'USCGE',
            wni_country: 'US',
            wni_lat: 38.57,
            wni_lon: -76.07,
            wni_tz: 'America/New_York',
        },
        {
            option: 'CCD',
            wni_port_name: 'CONCORD',
            wni_unlocode: 'USJQQ',
            wni_country: 'US',
            wni_lat: 37.98,
            wni_lon: -122.03,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'CDV',
            wni_port_name: 'CORDOVA',
            wni_unlocode: 'USCDV',
            wni_country: 'US',
            wni_lat: 60.55,
            wni_lon: -145.77,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'CEM',
            wni_port_name: 'CEMENTON',
            wni_unlocode: 'USACS',
            wni_country: 'US',
            wni_lat: 42.14,
            wni_lon: -73.92,
            wni_tz: 'America/New_York',
        },
        {
            option: 'CES',
            wni_port_name: 'CHESTER',
            wni_unlocode: 'USCHT',
            wni_country: 'US',
            wni_lat: 39.85,
            wni_lon: -75.35,
            wni_tz: 'America/New_York',
        },
        {
            option: 'CGO',
            wni_port_name: 'CHICAGO',
            wni_unlocode: 'USCHI',
            wni_country: 'US',
            wni_lat: 41.88,
            wni_lon: -87.6,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'CGYIN',
            wni_port_name: 'GARY',
            wni_unlocode: 'USGGY',
            wni_country: 'US',
            wni_lat: 41.62,
            wni_lon: -87.33,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'CHARX',
            wni_port_name: 'CHARLEVOIX',
            wni_unlocode: 'USCSX',
            wni_country: 'US',
            wni_lat: 45.32,
            wni_lon: -85.27,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'CHBYG',
            wni_port_name: 'CHEBOYGAN',
            wni_unlocode: 'USCHG',
            wni_country: 'US',
            wni_lat: 45.65,
            wni_lon: -84.47,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'CHE',
            wni_port_name: 'CAPE HENRY',
            wni_unlocode: 'USXPY',
            wni_country: 'US',
            wni_lat: 36.93,
            wni_lon: -75.99,
            wni_tz: 'America/New_York',
        },
        {
            option: 'CHL',
            wni_port_name: 'CHALMETTE',
            wni_unlocode: 'USCLQ',
            wni_country: 'US',
            wni_lat: 29.93,
            wni_lon: -89.99,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'CLM',
            wni_port_name: 'CLAYMONT',
            wni_unlocode: 'USCLA',
            wni_country: 'US',
            wni_lat: 39.8,
            wni_lon: -75.43,
            wni_tz: 'America/New_York',
        },
        {
            option: 'CLYTN',
            wni_port_name: 'CLAYTON',
            wni_unlocode: 'USCLY',
            wni_country: 'US',
            wni_lat: 44.23,
            wni_lon: -76.05,
            wni_tz: 'America/New_York',
        },
        {
            option: 'CNNT',
            wni_port_name: 'CONNEAUT',
            wni_unlocode: 'USCDY',
            wni_country: 'US',
            wni_lat: 41.97,
            wni_lon: -80.55,
            wni_tz: 'America/New_York',
        },
        {
            option: 'COVEK',
            wni_port_name: 'KING COVE',
            wni_unlocode: 'USKVC',
            wni_country: 'US',
            wni_lat: 55.05,
            wni_lon: -162.32,
            wni_tz: 'America/Nome',
        },
        {
            option: 'CRCNT',
            wni_port_name: 'CRESCENT CITY',
            wni_unlocode: 'USCEC',
            wni_country: 'US',
            wni_lat: 41.75,
            wni_lon: -124.2,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'CRT',
            wni_port_name: 'CARTERET',
            wni_unlocode: 'USCSF',
            wni_country: 'US',
            wni_lat: 40.58,
            wni_lon: -74.22,
            wni_tz: 'America/New_York',
        },
        {
            option: 'CSW',
            wni_port_name: 'CHICKASAW',
            wni_unlocode: 'USCGW',
            wni_country: 'US',
            wni_lat: 30.77,
            wni_lon: -88.07,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'DEL',
            wni_port_name: 'DELAWARE CITY',
            wni_unlocode: 'USDCI',
            wni_country: 'US',
            wni_lat: 39.56,
            wni_lon: -75.55,
            wni_tz: 'America/New_York',
        },
        {
            option: 'DET',
            wni_port_name: 'DESTREHAN',
            wni_unlocode: 'USNEW',
            wni_country: 'US',
            wni_lat: 29.95,
            wni_lon: -90.37,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'DLLNG',
            wni_port_name: 'DILLINGHAM',
            wni_unlocode: 'USDLG',
            wni_country: 'US',
            wni_lat: 59.03,
            wni_lon: -158.48,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'DLU',
            wni_port_name: 'DULUTH',
            wni_unlocode: 'USDLH',
            wni_country: 'US',
            wni_lat: 46.77,
            wni_lon: -92.1,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'DRI',
            wni_port_name: 'DRIFT RIVER',
            wni_unlocode: 'USDRF',
            wni_country: 'US',
            wni_lat: 60.55,
            wni_lon: -152.13,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'DTT',
            wni_port_name: 'DETROIT',
            wni_unlocode: 'USDET',
            wni_country: 'US',
            wni_lat: 42.33,
            wni_lon: -83.03,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'ERIE',
            wni_port_name: 'ERIE',
            wni_unlocode: 'USERI',
            wni_country: 'US',
            wni_lat: 42.15,
            wni_lon: -80.1,
            wni_tz: 'America/New_York',
        },
        {
            option: 'ESCN',
            wni_port_name: 'ESCANABA',
            wni_unlocode: 'USESC',
            wni_country: 'US',
            wni_lat: 45.77,
            wni_lon: -87.05,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'FAL',
            wni_port_name: 'FALL RIVER',
            wni_unlocode: 'USFAV',
            wni_country: 'US',
            wni_lat: 41.7,
            wni_lon: -71.17,
            wni_tz: 'America/New_York',
        },
        {
            option: 'FOUR',
            wni_port_name: 'FOURCHON',
            wni_unlocode: 'USFOC',
            wni_country: 'US',
            wni_lat: 29.12,
            wni_lon: -90.21,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'FRPRT',
            wni_port_name: 'FAIRPORT',
            wni_unlocode: 'USFPT',
            wni_country: 'US',
            wni_lat: 41.77,
            wni_lon: -81.3,
            wni_tz: 'America/New_York',
        },
        {
            option: 'FTL',
            wni_port_name: 'FORT LAUDERDALE',
            wni_unlocode: 'USFLL',
            wni_country: 'US',
            wni_lat: 26.09,
            wni_lon: -80.12,
            wni_tz: 'America/New_York',
        },
        {
            option: 'FTP',
            wni_port_name: 'FORT PIERCE',
            wni_unlocode: 'USFPR',
            wni_country: 'US',
            wni_lat: 27.47,
            wni_lon: -80.32,
            wni_tz: 'America/New_York',
        },
        {
            option: 'GDH',
            wni_port_name: 'GOOD HOPE',
            wni_unlocode: 'USGOP',
            wni_country: 'US',
            wni_lat: 29.99,
            wni_lon: -90.41,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'GHAVN',
            wni_port_name: 'GRAND HAVEN',
            wni_unlocode: 'USGHN',
            wni_country: 'US',
            wni_lat: 43.07,
            wni_lon: -86.23,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'GLC',
            wni_port_name: 'GLOUCESTER',
            wni_unlocode: 'USGLC',
            wni_country: 'US',
            wni_lat: 39.9,
            wni_lon: -75.13,
            wni_tz: 'America/New_York',
        },
        {
            option: 'GLOCS',
            wni_port_name: 'GLOUCESTER',
            wni_unlocode: 'USGLO',
            wni_country: 'US',
            wni_lat: 42.6,
            wni_lon: -70.67,
            wni_tz: 'America/New_York',
        },
        {
            option: 'GMC',
            wni_port_name: 'GRAMERCY',
            wni_unlocode: 'USGRY',
            wni_country: 'US',
            wni_lat: 30.04,
            wni_lon: -90.68,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'GNB',
            wni_port_name: 'GREEN BAY',
            wni_unlocode: 'USGRB',
            wni_country: 'US',
            wni_lat: 44.52,
            wni_lon: -88.02,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'GRY',
            wni_port_name: 'GARYVILLE',
            wni_unlocode: 'USGYV',
            wni_country: 'US',
            wni_lat: 30.08,
            wni_lon: -90.63,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'GTN',
            wni_port_name: 'GRETNA',
            wni_unlocode: 'USGTL',
            wni_country: 'US',
            wni_lat: 29.92,
            wni_lon: -90.07,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'HIL',
            wni_port_name: 'HILO',
            wni_unlocode: 'USITO',
            wni_country: 'US',
            wni_lat: 19.73,
            wni_lon: -155.07,
            wni_tz: 'Pacific/Honolulu',
        },
        {
            option: 'HNS',
            wni_port_name: 'HAINES',
            wni_unlocode: 'USHNS',
            wni_country: 'US',
            wni_lat: 59.23,
            wni_lon: -135.43,
            wni_tz: 'America/Juneau',
        },
        {
            option: 'HOOS',
            wni_port_name: 'HOONAH',
            wni_unlocode: 'USHNH',
            wni_country: 'US',
            wni_lat: 58.12,
            wni_lon: -135.45,
            wni_tz: 'America/Juneau',
        },
        {
            option: 'HOQ',
            wni_port_name: 'HOQUIAM',
            wni_unlocode: 'USHQM',
            wni_country: 'US',
            wni_lat: 46.97,
            wni_lon: -123.9,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'HURO',
            wni_port_name: 'PORT HURON',
            wni_unlocode: 'USPHN',
            wni_country: 'US',
            wni_lat: 43,
            wni_lon: -82.43,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'HURON1',
            wni_port_name: 'HURON',
            wni_unlocode: 'USHUB',
            wni_country: 'US',
            wni_lat: 41.4,
            wni_lon: -82.55,
            wni_tz: 'America/New_York',
        },
        {
            option: 'HYNNS',
            wni_port_name: 'HYANNIS',
            wni_unlocode: 'USHYA',
            wni_country: 'US',
            wni_lat: 41.65,
            wni_lon: -70.28,
            wni_tz: 'America/New_York',
        },
        {
            option: 'INLND',
            wni_port_name: 'PORT INLAND',
            wni_unlocode: 'USGUV',
            wni_country: 'US',
            wni_lat: 45.97,
            wni_lon: -85.87,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'ISBTX',
            wni_port_name: 'PORT ISABEL',
            wni_unlocode: 'USPIS',
            wni_country: 'US',
            wni_lat: 26.08,
            wni_lon: -97.2,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'JFFRS',
            wni_port_name: 'PORT JEFFERSON',
            wni_unlocode: 'USPTJ',
            wni_country: 'US',
            wni_lat: 40.95,
            wni_lon: -73.08,
            wni_tz: 'America/New_York',
        },
        {
            option: 'JUN',
            wni_port_name: 'JUNEAU',
            wni_unlocode: 'USJNU',
            wni_country: 'US',
            wni_lat: 58.3,
            wni_lon: -134.42,
            wni_tz: 'America/Juneau',
        },
        {
            option: 'KAH',
            wni_port_name: 'KAHULUI',
            wni_unlocode: 'USOGG',
            wni_country: 'US',
            wni_lat: 20.9,
            wni_lon: -156.47,
            wni_tz: 'Pacific/Honolulu',
        },
        {
            option: 'KENSH',
            wni_port_name: 'KENOSHA',
            wni_unlocode: 'USENW',
            wni_country: 'US',
            wni_lat: 42.58,
            wni_lon: -87.82,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'KEY',
            wni_port_name: 'KEY WEST',
            wni_unlocode: 'USEYW',
            wni_country: 'US',
            wni_lat: 24.55,
            wni_lon: -81.82,
            wni_tz: 'America/New_York',
        },
        {
            option: 'KIV',
            wni_port_name: 'KIVALINA',
            wni_unlocode: 'USKVL',
            wni_country: 'US',
            wni_lat: 67.73,
            wni_lon: -164.54,
            wni_tz: 'America/Nome',
        },
        {
            option: 'KKE',
            wni_port_name: 'KAKE',
            wni_unlocode: 'USKAE',
            wni_country: 'US',
            wni_lat: 56.97,
            wni_lon: -133.93,
            wni_tz: 'America/Sitka',
        },
        {
            option: 'KNKKI',
            wni_port_name: 'KAUNAKAKAI',
            wni_unlocode: 'USKKA',
            wni_country: 'US',
            wni_lat: 21.08,
            wni_lon: -157.03,
            wni_tz: 'Pacific/Honolulu',
        },
        {
            option: 'KOD',
            wni_port_name: 'KODIAK',
            wni_unlocode: 'USADQ',
            wni_country: 'US',
            wni_lat: 57.78,
            wni_lon: -152.4,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'KWH',
            wni_port_name: 'KAWAIHAE',
            wni_unlocode: 'USKWH',
            wni_country: 'US',
            wni_lat: 20.03,
            wni_lon: -155.83,
            wni_tz: 'Pacific/Honolulu',
        },
        {
            option: 'LHN',
            wni_port_name: 'LAHAINA',
            wni_unlocode: 'USLHN',
            wni_country: 'US',
            wni_lat: 20.87,
            wni_lon: -156.67,
            wni_tz: 'Pacific/Honolulu',
        },
        {
            option: 'LORAN',
            wni_port_name: 'LORAIN',
            wni_unlocode: 'USLOR',
            wni_country: 'US',
            wni_lat: 41.47,
            wni_lon: -82.18,
            wni_tz: 'America/New_York',
        },
        {
            option: 'LUIS',
            wni_port_name: 'PORT SAN LUIS',
            wni_unlocode: 'USPSL',
            wni_country: 'US',
            wni_lat: 35.17,
            wni_lon: -120.75,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'LUN',
            wni_port_name: 'LUDINGTON',
            wni_unlocode: 'USLDM',
            wni_country: 'US',
            wni_lat: 43.95,
            wni_lon: -86.45,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'MET',
            wni_port_name: 'METLAKATLA',
            wni_unlocode: 'USMTM',
            wni_country: 'US',
            wni_lat: 55.13,
            wni_lon: -131.57,
            wni_tz: 'America/Metlakatla',
        },
        {
            option: 'MICAL',
            wni_port_name: 'ST MICHAEL',
            wni_unlocode: 'USSMK',
            wni_country: 'US',
            wni_lat: 63.48,
            wni_lon: -162.03,
            wni_tz: 'America/Nome',
        },
        {
            option: 'MNISG',
            wni_port_name: 'MUNISING',
            wni_unlocode: 'USMGS',
            wni_country: 'US',
            wni_lat: 46.42,
            wni_lon: -86.65,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'MNTEE',
            wni_port_name: 'MANISTEE',
            wni_unlocode: 'USMBL',
            wni_country: 'US',
            wni_lat: 44.25,
            wni_lon: -86.32,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'MNTWC',
            wni_port_name: 'MANITOWOC',
            wni_unlocode: 'USMTW',
            wni_country: 'US',
            wni_lat: 44.1,
            wni_lon: -87.65,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'MRECA',
            wni_port_name: 'MARE ISLAND',
            wni_unlocode: 'USMI8',
            wni_country: 'US',
            wni_lat: 38.1,
            wni_lon: -122.27,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'MRNTT',
            wni_port_name: 'MARINETTE',
            wni_unlocode: 'USMOY',
            wni_country: 'US',
            wni_lat: 45.08,
            wni_lon: -87.6,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'MRQTT',
            wni_port_name: 'MARQUETTE',
            wni_unlocode: 'USMQT',
            wni_country: 'US',
            wni_lat: 46.53,
            wni_lon: -87.38,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'MSKGN',
            wni_port_name: 'MUSKEGON',
            wni_unlocode: 'USMKG',
            wni_country: 'US',
            wni_lat: 43.23,
            wni_lon: -86.27,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'MSL',
            wni_port_name: 'MOSS LANDING',
            wni_unlocode: 'USMLG',
            wni_country: 'US',
            wni_lat: 36.8,
            wni_lon: -121.78,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'MTC',
            wni_port_name: 'MONTEREY',
            wni_unlocode: 'USMY3',
            wni_country: 'US',
            wni_lat: 36.62,
            wni_lon: -121.88,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'MYR',
            wni_port_name: 'MYRTLE GROVE',
            wni_unlocode: 'USMYG',
            wni_country: 'US',
            wni_lat: 29.63,
            wni_lon: -89.91,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'NBF',
            wni_port_name: 'NEW BEDFORD',
            wni_unlocode: 'USNBD',
            wni_country: 'US',
            wni_lat: 41.63,
            wni_lon: -70.92,
            wni_tz: 'America/New_York',
        },
        {
            option: 'NEWPT',
            wni_port_name: 'NEWPORT',
            wni_unlocode: 'USNPO',
            wni_country: 'US',
            wni_lat: 44.63,
            wni_lon: -124.05,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'NIB',
            wni_port_name: 'NEW IBERIA',
            wni_unlocode: 'USARA',
            wni_country: 'US',
            wni_lat: 30.01,
            wni_lon: -91.82,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'NKNK',
            wni_port_name: 'NAKNEK',
            wni_unlocode: 'USNNK',
            wni_country: 'US',
            wni_lat: 58.72,
            wni_lon: -157.02,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'NNT',
            wni_port_name: 'NANTUCKET',
            wni_unlocode: 'USACK',
            wni_country: 'US',
            wni_lat: 41.28,
            wni_lon: -70.1,
            wni_tz: 'America/New_York',
        },
        {
            option: 'NPR',
            wni_port_name: 'NORTHPORT',
            wni_unlocode: 'USNOP',
            wni_country: 'US',
            wni_lat: 40.96,
            wni_lon: -73.34,
            wni_tz: 'America/New_York',
        },
        {
            option: 'NRI',
            wni_port_name: 'NEWPORT',
            wni_unlocode: 'USNPT',
            wni_country: 'US',
            wni_lat: 41.5,
            wni_lon: -71.33,
            wni_tz: 'America/New_York',
        },
        {
            option: 'NRV',
            wni_port_name: 'NORTHVILLE',
            wni_unlocode: 'USRID',
            wni_country: 'US',
            wni_lat: 41,
            wni_lon: -72.65,
            wni_tz: 'America/New_York',
        },
        {
            option: 'OGDNS',
            wni_port_name: 'OGDENSBURG',
            wni_unlocode: 'USOG2',
            wni_country: 'US',
            wni_lat: 44.7,
            wni_lon: -75.5,
            wni_tz: 'America/New_York',
        },
        {
            option: 'OLEUM',
            wni_port_name: 'OLEUM',
            wni_unlocode: 'USOL2',
            wni_country: 'US',
            wni_lat: 38.05,
            wni_lon: -122.27,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'ONTNG',
            wni_port_name: 'ONTONAGON',
            wni_unlocode: 'USONG',
            wni_country: 'US',
            wni_lat: 46.88,
            wni_lon: -89.33,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'ONY',
            wni_port_name: 'OSWEGO',
            wni_unlocode: 'USOSW',
            wni_country: 'US',
            wni_lat: 43.47,
            wni_lon: -76.52,
            wni_tz: 'America/New_York',
        },
        {
            option: 'ORN',
            wni_port_name: 'ORANGE',
            wni_unlocode: 'USORG',
            wni_country: 'US',
            wni_lat: 30.08,
            wni_lon: -93.73,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'OST',
            wni_port_name: 'OSTRICA',
            wni_unlocode: 'USOST',
            wni_country: 'US',
            wni_lat: 29.37,
            wni_lon: -89.53,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'PALH',
            wni_port_name: 'PORT ALLEN',
            wni_unlocode: 'USPAL',
            wni_country: 'US',
            wni_lat: 21.9,
            wni_lon: -159.58,
            wni_tz: 'Pacific/Honolulu',
        },
        {
            option: 'PARK',
            wni_port_name: 'DEER PARK',
            wni_unlocode: 'USDEX',
            wni_country: 'US',
            wni_lat: 29.75,
            wni_lon: -95.33,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'PAX',
            wni_port_name: 'PASADENA',
            wni_unlocode: 'USPAS',
            wni_country: 'US',
            wni_lat: 29.72,
            wni_lon: -95.22,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'PCHS',
            wni_port_name: 'PORT CHESTER',
            wni_unlocode: 'USUXZ',
            wni_country: 'US',
            wni_lat: 41,
            wni_lon: -73.67,
            wni_tz: 'America/New_York',
        },
        {
            option: 'PGA',
            wni_port_name: 'PORT GAMBLE',
            wni_unlocode: 'USPGH',
            wni_country: 'US',
            wni_lat: 47.85,
            wni_lon: -122.58,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'PGS',
            wni_port_name: 'PUGET SOUND',
            wni_unlocode: 'USPGS',
            wni_country: 'US',
            wni_lat: 47.83,
            wni_lon: -122.43,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'PHR',
            wni_port_name: 'PEARL HARBOR',
            wni_unlocode: 'USPEA',
            wni_country: 'US',
            wni_lat: 21.36,
            wni_lon: -157.95,
            wni_tz: 'Pacific/Honolulu',
        },
        {
            option: 'PKN',
            wni_port_name: 'PENNSAUKEN',
            wni_unlocode: 'USPPS',
            wni_country: 'US',
            wni_lat: 39.97,
            wni_lon: -75.08,
            wni_tz: 'America/New_York',
        },
        {
            option: 'PLICN',
            wni_port_name: 'PELICAN',
            wni_unlocode: 'USPEC',
            wni_country: 'US',
            wni_lat: 57.97,
            wni_lon: -136.23,
            wni_tz: 'America/Juneau',
        },
        {
            option: 'PLQ',
            wni_port_name: 'PLAQUEMINE',
            wni_unlocode: 'USPLQ',
            wni_country: 'US',
            wni_lat: 30.29,
            wni_lon: -91.23,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'PLYMO',
            wni_port_name: 'PLYMOUTH',
            wni_unlocode: 'USPYM',
            wni_country: 'US',
            wni_lat: 41.95,
            wni_lon: -70.67,
            wni_tz: 'America/New_York',
        },
        {
            option: 'POY',
            wni_port_name: 'PORT ROYAL',
            wni_unlocode: 'USPRL',
            wni_country: 'US',
            wni_lat: 32.37,
            wni_lon: -80.68,
            wni_tz: 'America/New_York',
        },
        {
            option: 'PRS',
            wni_port_name: 'PORTSMOUTH',
            wni_unlocode: 'USPSM',
            wni_country: 'US',
            wni_lat: 41.6,
            wni_lon: -71.25,
            wni_tz: 'America/New_York',
        },
        {
            option: 'PRU',
            wni_port_name: 'PRUDHOE BAY',
            wni_unlocode: 'USSCC',
            wni_country: 'US',
            wni_lat: 70.33,
            wni_lon: -148.42,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'PRVNC',
            wni_port_name: 'PROVINCETOWN',
            wni_unlocode: 'USPVC',
            wni_country: 'US',
            wni_lat: 42.05,
            wni_lon: -70.18,
            wni_tz: 'America/New_York',
        },
        {
            option: 'PSB',
            wni_port_name: 'PAULSBORO',
            wni_unlocode: 'USPAU',
            wni_country: 'US',
            wni_lat: 39.85,
            wni_lon: -75.25,
            wni_tz: 'America/New_York',
        },
        {
            option: 'PSJ',
            wni_port_name: 'PORT ST JOE',
            wni_unlocode: 'USPSJ',
            wni_country: 'US',
            wni_lat: 29.82,
            wni_lon: -85.32,
            wni_tz: 'America/New_York',
        },
        {
            option: 'PSM',
            wni_port_name: 'PORTSMOUTH',
            wni_unlocode: 'USPTM',
            wni_country: 'US',
            wni_lat: 36.82,
            wni_lon: -76.3,
            wni_tz: 'America/New_York',
        },
        {
            option: 'PSR',
            wni_port_name: 'PORT SULPHUR',
            wni_unlocode: 'USSUL',
            wni_country: 'US',
            wni_lat: 29.48,
            wni_lon: -89.68,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'PTO',
            wni_port_name: 'PORT TOWNSEND',
            wni_unlocode: 'USTWD',
            wni_country: 'US',
            wni_lat: 48.12,
            wni_lon: -122.75,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'PWA',
            wni_port_name: 'POINT WELLS',
            wni_unlocode: 'USOW4',
            wni_country: 'US',
            wni_lat: 47.78,
            wni_lon: -122.4,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'QNC',
            wni_port_name: 'QUINCY',
            wni_unlocode: 'USQUI',
            wni_country: 'US',
            wni_lat: 42.25,
            wni_lon: -70.97,
            wni_tz: 'America/New_York',
        },
        {
            option: 'RCKLD',
            wni_port_name: 'ROCKLAND',
            wni_unlocode: 'USRKD',
            wni_country: 'US',
            wni_lat: 44.1,
            wni_lon: -69.1,
            wni_tz: 'America/New_York',
        },
        {
            option: 'RCN',
            wni_port_name: 'RACINE',
            wni_unlocode: 'USRAC',
            wni_country: 'US',
            wni_lat: 42.73,
            wni_lon: -87.78,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'RIH',
            wni_port_name: 'RICHMOND',
            wni_unlocode: 'USRIC',
            wni_country: 'US',
            wni_lat: 37.53,
            wni_lon: -77.42,
            wni_tz: 'America/New_York',
        },
        {
            option: 'RNR',
            wni_port_name: 'RAINIER',
            wni_unlocode: 'USQIE',
            wni_country: 'US',
            wni_lat: 46.08,
            wni_lon: -122.93,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'RNY',
            wni_port_name: 'ROCHESTER',
            wni_unlocode: 'USROC',
            wni_country: 'US',
            wni_lat: 43.27,
            wni_lon: -77.6,
            wni_tz: 'America/New_York',
        },
        {
            option: 'RWC',
            wni_port_name: 'REDWOOD CITY',
            wni_unlocode: 'USRWC',
            wni_country: 'US',
            wni_lat: 37.53,
            wni_lon: -122.2,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'SAT',
            wni_port_name: 'SAND POINT',
            wni_unlocode: 'USSDP',
            wni_country: 'US',
            wni_lat: 55.33,
            wni_lon: -160.53,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'SBB',
            wni_port_name: 'SANTA BARBARA',
            wni_unlocode: 'USSBA',
            wni_country: 'US',
            wni_lat: 34.42,
            wni_lon: -119.68,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'SEL',
            wni_port_name: 'SELDOVIA',
            wni_unlocode: 'USSOV',
            wni_country: 'US',
            wni_lat: 59.43,
            wni_lon: -151.73,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'SGNW',
            wni_port_name: 'WNIINAW',
            wni_unlocode: 'USSJQ',
            wni_country: 'US',
            wni_lat: 43.43,
            wni_lon: -83.93,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'SIT',
            wni_port_name: 'SITKA',
            wni_unlocode: 'USSIT',
            wni_country: 'US',
            wni_lat: 57.05,
            wni_lon: -135.33,
            wni_tz: 'America/Sitka',
        },
        {
            option: 'SLMUS',
            wni_port_name: 'SALEM',
            wni_unlocode: 'USSLM',
            wni_country: 'US',
            wni_lat: 42.52,
            wni_lon: -70.88,
            wni_tz: 'America/New_York',
        },
        {
            option: 'SLUMD',
            wni_port_name: 'SALISBURY',
            wni_unlocode: 'AUSAL',
            wni_country: 'US',
            wni_lat: 38.37,
            wni_lon: -75.6,
            wni_tz: 'America/New_York',
        },
        {
            option: 'SNDSK',
            wni_port_name: 'SANDUSKY',
            wni_unlocode: 'USSKY',
            wni_country: 'US',
            wni_lat: 41.45,
            wni_lon: -82.72,
            wni_tz: 'America/New_York',
        },
        {
            option: 'SNY',
            wni_port_name: 'SUNNY POINT',
            wni_unlocode: 'USSUT',
            wni_country: 'US',
            wni_lat: 33.98,
            wni_lon: -77.95,
            wni_tz: 'America/New_York',
        },
        {
            option: 'SPRR',
            wni_port_name: 'SUPERIOR',
            wni_unlocode: 'USSUW',
            wni_country: 'US',
            wni_lat: 46.73,
            wni_lon: -92.07,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'STH',
            wni_port_name: 'ST HELENS',
            wni_unlocode: 'USSTH',
            wni_country: 'US',
            wni_lat: 45.87,
            wni_lon: -122.8,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'STHP',
            wni_port_name: 'SOUTHPORT',
            wni_unlocode: 'USXMK',
            wni_country: 'US',
            wni_lat: 33.92,
            wni_lon: -78.02,
            wni_tz: 'America/New_York',
        },
        {
            option: 'STPGU',
            wni_port_name: 'ST PETERSBURG',
            wni_unlocode: 'USPIE',
            wni_country: 'US',
            wni_lat: 27.77,
            wni_lon: -82.62,
            wni_tz: 'America/New_York',
        },
        {
            option: 'SWRN',
            wni_port_name: 'SEWAREN',
            wni_unlocode: 'USSWN',
            wni_country: 'US',
            wni_lat: 40.55,
            wni_lon: -74.25,
            wni_tz: 'America/New_York',
        },
        {
            option: 'TBR',
            wni_port_name: 'BARROW',
            wni_unlocode: 'USTBW',
            wni_country: 'US',
            wni_lat: 71.28,
            wni_lon: -156.78,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'THEO',
            wni_port_name: 'THEODORE',
            wni_unlocode: 'USTEO',
            wni_country: 'US',
            wni_lat: 30.54,
            wni_lon: -88.18,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'TNY',
            wni_port_name: 'TONAWANDA',
            wni_unlocode: 'USXJQ',
            wni_country: 'US',
            wni_lat: 43.03,
            wni_lon: -78.88,
            wni_tz: 'America/New_York',
        },
        {
            option: 'TOWMN',
            wni_port_name: 'TWO HARBORS',
            wni_unlocode: 'USTHB',
            wni_country: 'US',
            wni_lat: 47.02,
            wni_lon: -91.65,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'TRTNJ',
            wni_port_name: 'TRENTON',
            wni_unlocode: 'USXNG',
            wni_country: 'US',
            wni_lat: 40.2,
            wni_lon: -74.77,
            wni_tz: 'America/New_York',
        },
        {
            option: 'TRVRS',
            wni_port_name: 'TRAVERSE CITY',
            wni_unlocode: 'USTVC',
            wni_country: 'US',
            wni_lat: 44.77,
            wni_lon: -85.62,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'TVRTN',
            wni_port_name: 'TIVERTON',
            wni_unlocode: 'USTIV',
            wni_country: 'US',
            wni_lat: 41.63,
            wni_lon: -71.22,
            wni_tz: 'America/New_York',
        },
        {
            option: 'UNS',
            wni_port_name: 'UNALASKA',
            wni_unlocode: 'USUAA',
            wni_country: 'US',
            wni_lat: 53.87,
            wni_lon: -166.53,
            wni_tz: 'America/Nome',
        },
        {
            option: 'WGTON',
            wni_port_name: 'PORT WASHINGTON',
            wni_unlocode: 'USPWA',
            wni_country: 'US',
            wni_lat: 43.38,
            wni_lon: -87.87,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'WHI',
            wni_port_name: 'WHITTIER',
            wni_unlocode: 'USWHR',
            wni_country: 'US',
            wni_lat: 60.83,
            wni_lon: -148.67,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'WKGN',
            wni_port_name: 'WAUKEGAN',
            wni_unlocode: 'USUGN',
            wni_country: 'US',
            wni_lat: 42.37,
            wni_lon: -87.82,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'WNTRP',
            wni_port_name: 'WINTERPORT',
            wni_unlocode: 'USWIE',
            wni_country: 'US',
            wni_lat: 44.63,
            wni_lon: -68.85,
            wni_tz: 'America/New_York',
        },
        {
            option: 'WRG',
            wni_port_name: 'WRANGELL',
            wni_unlocode: 'USWRG',
            wni_country: 'US',
            wni_lat: 56.47,
            wni_lon: -132.38,
            wni_tz: 'America/Sitka',
        },
        {
            option: 'WSHGL',
            wni_port_name: 'WASHOUGAL',
            wni_unlocode: 'USCMS',
            wni_country: 'US',
            wni_lat: 45.58,
            wni_lon: -122.35,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'WST',
            wni_port_name: 'WESTWEGO',
            wni_unlocode: 'USWWO',
            wni_country: 'US',
            wni_lat: 29.92,
            wni_lon: -90.14,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'WSTV',
            wni_port_name: 'WESTVILLE',
            wni_unlocode: 'CAWEV',
            wni_country: 'US',
            wni_lat: 39.88,
            wni_lon: -75.14,
            wni_tz: 'America/New_York',
        },
        {
            option: 'WYNDT',
            wni_port_name: 'WYANDOTTE',
            wni_unlocode: 'USWYD',
            wni_country: 'US',
            wni_lat: 42.2,
            wni_lon: -83.15,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'YAK',
            wni_port_name: 'YAKUTAT',
            wni_unlocode: 'USYAK',
            wni_country: 'US',
            wni_lat: 59.55,
            wni_lon: -139.73,
            wni_tz: 'America/Yakutat',
        },
        {
            option: 'CLNA',
            wni_port_name: 'COLONIA',
            wni_unlocode: 'UYCYR',
            wni_country: 'UY',
            wni_lat: -34.47,
            wni_lon: -57.85,
            wni_tz: 'America/Montevideo',
        },
        {
            option: 'JIG',
            wni_port_name: 'JOSE IGNACIO',
            wni_unlocode: 'UYJIT',
            wni_country: 'UY',
            wni_lat: -34.84,
            wni_lon: -54.64,
            wni_tz: 'America/Montevideo',
        },
        {
            option: 'PYSND',
            wni_port_name: 'PAYSANDU',
            wni_unlocode: 'UYPDU',
            wni_country: 'UY',
            wni_lat: -32.32,
            wni_lon: -58.07,
            wni_tz: 'America/Montevideo',
        },
        {
            option: 'ARY',
            wni_port_name: 'ARAYA',
            wni_unlocode: 'VEARA',
            wni_country: 'VE',
            wni_lat: 10.57,
            wni_lon: -64.28,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'BAQ',
            wni_port_name: 'BACHAQUERO',
            wni_unlocode: 'VEBAV',
            wni_country: 'VE',
            wni_lat: 9.95,
            wni_lon: -71.17,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'CBMS',
            wni_port_name: 'CABIMAS',
            wni_unlocode: 'VECBS',
            wni_country: 'VE',
            wni_lat: 10.38,
            wni_lon: -71.48,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'CHCHR',
            wni_port_name: 'CHICHIRIVICHE',
            wni_unlocode: 'VECHC',
            wni_country: 'VE',
            wni_lat: 10.92,
            wni_lon: -68.27,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'CLE',
            wni_port_name: 'CATIA LA MAR',
            wni_unlocode: 'VECLM',
            wni_country: 'VE',
            wni_lat: 10.6,
            wni_lon: -67.03,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'CRPT',
            wni_port_name: 'CARIPITO',
            wni_unlocode: 'VECAR',
            wni_country: 'VE',
            wni_lat: 10.15,
            wni_lon: -63.03,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'ESTCD',
            wni_port_name: 'LA ESTACADA',
            wni_unlocode: 'VELEC',
            wni_country: 'VE',
            wni_lat: 10.7,
            wni_lon: -71.53,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'GRG',
            wni_port_name: 'GUARAGUAO',
            wni_unlocode: 'VEGGU',
            wni_country: 'VE',
            wni_lat: 10.24,
            wni_lon: -64.63,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'GUV',
            wni_port_name: 'GUIRIA',
            wni_unlocode: 'VEGUI',
            wni_country: 'VE',
            wni_lat: 10.57,
            wni_lon: -62.3,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'HIERR',
            wni_port_name: 'PUERTO DE HIERRO',
            wni_unlocode: 'VEPHO',
            wni_country: 'VE',
            wni_lat: 10.63,
            wni_lon: -62.08,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'LGNLL',
            wni_port_name: 'LAGUNILLAS',
            wni_unlocode: 'VELGY',
            wni_country: 'VE',
            wni_lat: 10.13,
            wni_lon: -71.25,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'LORNZ',
            wni_port_name: 'SAN LORENZO',
            wni_unlocode: 'VESLV',
            wni_country: 'VE',
            wni_lat: 9.78,
            wni_lon: -71.07,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'MTZV',
            wni_port_name: 'MATANZAS',
            wni_unlocode: 'VEMTV',
            wni_country: 'VE',
            wni_lat: 8.31,
            wni_lon: -62.81,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'PDP',
            wni_port_name: 'PUNTA DE PALMAS',
            wni_unlocode: 'VEPLV',
            wni_country: 'VE',
            wni_lat: 10.8,
            wni_lon: -71.57,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'PLU',
            wni_port_name: 'PALUA',
            wni_unlocode: 'VEPLA',
            wni_country: 'VE',
            wni_lat: 8.37,
            wni_lon: -62.68,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'PMTCL',
            wni_port_name: 'PAMATACUAL',
            wni_unlocode: 'VEPAM',
            wni_country: 'VE',
            wni_lat: 10.23,
            wni_lon: -64.57,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'PTE',
            wni_port_name: 'PERTIGALETE',
            wni_unlocode: 'VEPRG',
            wni_country: 'VE',
            wni_lat: 10.24,
            wni_lon: -64.56,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'SFE',
            wni_port_name: 'SAN FELIX',
            wni_unlocode: 'VESFX',
            wni_country: 'VE',
            wni_lat: 8.36,
            wni_lon: -62.69,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'CHRST',
            wni_port_name: 'CHRISTIANSTED',
            wni_unlocode: 'VICTD',
            wni_country: 'VI',
            wni_lat: 17.75,
            wni_lon: -64.7,
            wni_tz: 'America/St_Thomas',
        },
        {
            option: 'CHTTA',
            wni_port_name: 'CHARLOTTE AMALIE',
            wni_unlocode: 'VICHA',
            wni_country: 'VI',
            wni_lat: 18.35,
            wni_lon: -64.93,
            wni_tz: 'America/St_Thomas',
        },
        {
            option: 'LMTR',
            wni_port_name: 'LIMETREE BAY',
            wni_unlocode: 'VILIB',
            wni_country: 'VI',
            wni_lat: 17.7,
            wni_lon: -64.75,
            wni_tz: 'America/St_Thomas',
        },
        {
            option: 'CLAI',
            wni_port_name: 'CAT LAI',
            wni_unlocode: 'VNCLI',
            wni_country: 'VN',
            wni_lat: 10.76,
            wni_lon: 106.79,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'GOU',
            wni_port_name: 'GO DAU',
            wni_unlocode: 'VNGDA',
            wni_country: 'VN',
            wni_lat: 10.65,
            wni_lon: 107.03,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'BAYH',
            wni_port_name: 'BAYAH',
            wni_unlocode: 'IDBYH',
            wni_country: 'ID',
            wni_lat: -6.95,
            wni_lon: 106.24,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'PDANIE',
            wni_port_name: 'PORT DANIEL',
            wni_unlocode: 'CAGPD',
            wni_country: 'CA',
            wni_lat: 48.18,
            wni_lon: -64.92,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'BALGAS',
            wni_port_name: 'BALINGAWNI',
            wni_unlocode: 'PHBGS',
            wni_country: 'PH',
            wni_lat: 8.77,
            wni_lon: 124.76,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'HAGAR',
            wni_port_name: 'HIAGARI',
            wni_unlocode: 'JPHIA',
            wni_country: 'JP',
            wni_lat: 33.93,
            wni_lon: 130.88,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MTNAG',
            wni_port_name: 'MATSUNAGA',
            wni_unlocode: 'JPMNG',
            wni_country: 'JP',
            wni_lat: 34.18,
            wni_lon: 133.17,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MUKSM',
            wni_port_name: 'MUKAISHIMA',
            wni_unlocode: 'JPMUK',
            wni_country: 'JP',
            wni_lat: 34.2,
            wni_lon: 133.16,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'CAICU',
            wni_port_name: 'CAI CUI',
            wni_unlocode: 'VNCCU',
            wni_country: 'VN',
            wni_lat: 9.98,
            wni_lon: 105.84,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'PNCL',
            wni_port_name: 'PUNTA COLORADA',
            wni_unlocode: 'ARPCO',
            wni_country: 'AR',
            wni_lat: -41.42,
            wni_lon: -65,
            wni_tz: 'America/Argentina/Salta',
        },
        {
            option: 'NMAZ',
            wni_port_name: 'NUMAZU',
            wni_unlocode: 'JPNUM',
            wni_country: 'JP',
            wni_lat: 35.08,
            wni_lon: 138.85,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'CGG',
            wni_port_name: 'CHANGHANG',
            wni_unlocode: 'KRCHG',
            wni_country: 'KR',
            wni_lat: 36.01,
            wni_lon: 126.45,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'PUQ',
            wni_port_name: 'PUNTA QUILLA',
            wni_unlocode: 'ARPQU',
            wni_country: 'AR',
            wni_lat: -50.07,
            wni_lon: -68.25,
            wni_tz: 'America/Argentina/Rio_Gallegos',
        },
        {
            option: 'QABN',
            wni_port_name: 'QUANG BINH',
            wni_unlocode: 'VNQBH',
            wni_country: 'VN',
            wni_lat: 17.7,
            wni_lon: 106.47,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'HATN',
            wni_port_name: 'HA TINH',
            wni_unlocode: 'VNHAT',
            wni_country: 'VN',
            wni_lat: 18.64,
            wni_lon: 105.71,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'MIHRA',
            wni_port_name: 'MIHARA',
            wni_unlocode: 'JPMHR',
            wni_country: 'JP',
            wni_lat: 34.23,
            wni_lon: 133.06,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KRASU',
            wni_port_name: 'KARASU',
            wni_unlocode: 'JPNKA',
            wni_country: 'TR',
            wni_lat: 41.12,
            wni_lon: 30.68,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'OBIS',
            wni_port_name: 'OBI Island',
            wni_unlocode: 'IDOBI',
            wni_country: 'ID',
            wni_lat: -1.6,
            wni_lon: 127.38,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'KLFA',
            wni_port_name: 'KHALIFA',
            wni_unlocode: 'AEKHL',
            wni_country: 'AE',
            wni_lat: 24.81,
            wni_lon: 54.66,
            wni_tz: 'Asia/Dubai',
        },
        {
            option: 'YMUT',
            wni_port_name: 'YUMURTALIK',
            wni_unlocode: 'TRYUM',
            wni_country: 'TR',
            wni_lat: 36.77,
            wni_lon: 35.79,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'COGA',
            wni_port_name: 'COEGA',
            wni_unlocode: 'ZAZBA',
            wni_country: 'ZA',
            wni_lat: -33.8,
            wni_lon: 25.69,
            wni_tz: 'Africa/Johannesburg',
        },
        {
            option: 'SKDRI',
            wni_port_name: 'SKARDON RIVER',
            wni_unlocode: 'AUSKA',
            wni_country: 'AU',
            wni_lat: -11.76,
            wni_lon: 142.07,
            wni_tz: 'Australia/Brisbane',
        },
        {
            option: 'RNO',
            wni_port_name: 'ROMANO',
            wni_unlocode: 'ALROM',
            wni_country: 'IT',
            wni_lat: 41.38,
            wni_lon: 19.4,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'CTC',
            wni_port_name: 'CUTUCO',
            wni_unlocode: 'SVCUT',
            wni_country: 'SV',
            wni_lat: 13.32,
            wni_lon: -87.82,
            wni_tz: 'America/El_salvador',
        },
        {
            option: 'PEN',
            wni_port_name: 'PASADENA',
            wni_unlocode: 'USPAS',
            wni_country: 'US',
            wni_lat: 29.73,
            wni_lon: -95.21,
            wni_tz: 'America/Texas',
        },
        {
            option: 'OMO',
            wni_port_name: 'OMOA',
            wni_unlocode: 'HNOMO',
            wni_country: 'HN',
            wni_lat: 15.79,
            wni_lon: -88.05,
            wni_tz: 'America/Tegucigalpa',
        },
        {
            option: 'KLMT',
            wni_port_name: 'KALAMATA',
            wni_unlocode: 'GRKLX',
            wni_country: 'GR',
            wni_lat: 37.03,
            wni_lon: 22.12,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'JEYG',
            wni_port_name: 'JIEYANG',
            wni_unlocode: 'CNJYG',
            wni_country: 'CN',
            wni_lat: 22.93,
            wni_lon: 116.51,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'JSGD',
            wni_port_name: 'JOSSINGFJORD',
            wni_unlocode: 'NOJOS',
            wni_country: 'NO',
            wni_lat: 58.32,
            wni_lon: 6.34,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'EUP',
            wni_port_name: 'EUROPA POINT',
            wni_unlocode: 'ESALG',
            wni_country: 'GI',
            wni_lat: 36.13,
            wni_lon: -5.35,
            wni_tz: 'Europe/Gibraltar',
        },
        {
            option: 'ANNAR',
            wni_port_name: 'UMM AN NAR',
            wni_unlocode: 'AEULR',
            wni_country: 'AE',
            wni_lat: 24.45,
            wni_lon: 54.48,
            wni_tz: 'Asia/Dubai',
        },
        {
            option: 'ARZNN',
            wni_port_name: 'ARZANNAH ISLAND',
            wni_unlocode: 'AEARZ',
            wni_country: 'AE',
            wni_lat: 24.78,
            wni_lon: 52.55,
            wni_tz: 'Asia/Dubai',
        },
        {
            option: 'KBL',
            wni_port_name: 'KALBA',
            wni_unlocode: 'AEFJR',
            wni_country: 'AE',
            wni_lat: 25.01,
            wni_lon: 56.35,
            wni_tz: 'Asia/Dubai',
        },
        {
            option: 'KHSH',
            wni_port_name: 'ABU AL BU KHOOSH',
            wni_unlocode: 'AEABU',
            wni_country: 'AE',
            wni_lat: 25.53,
            wni_lon: 53,
            wni_tz: 'Asia/Dubai',
        },
        {
            option: 'MUSA',
            wni_port_name: 'MUSAFFAH',
            wni_unlocode: 'AEULR',
            wni_country: 'AE',
            wni_lat: 24.39,
            wni_lon: 54.47,
            wni_tz: 'Asia/Dubai',
        },
        {
            option: 'SHJ1',
            wni_port_name: 'SHARJAH OFFSHORE',
            wni_unlocode: 'AEARP',
            wni_country: 'AE',
            wni_lat: 25.58,
            wni_lon: 55.4,
            wni_tz: 'Asia/Dubai',
        },
        {
            option: 'EHRBR',
            wni_port_name: 'PARHAM HARBOUR',
            wni_unlocode: 'AGSJO',
            wni_country: 'AG',
            wni_lat: 17.15,
            wni_lon: -61.78,
            wni_tz: 'America/Antigua',
        },
        {
            option: 'NCLO',
            wni_port_name: 'PORTO SAN NICOLO',
            wni_unlocode: 'ALVOA',
            wni_country: 'AL',
            wni_lat: 40.5,
            wni_lon: 19.28,
            wni_tz: 'Europe/Tirane',
        },
        {
            option: 'VLORA',
            wni_port_name: 'SKELE E VLORES',
            wni_unlocode: 'ALVOA',
            wni_country: 'AL',
            wni_lat: 40.47,
            wni_lon: 19.5,
            wni_tz: 'Europe/Tirane',
        },
        {
            option: 'BNGL',
            wni_port_name: 'BENGUELA',
            wni_unlocode: 'AOLOB',
            wni_country: 'AO',
            wni_lat: -12.58,
            wni_lon: 13.4,
            wni_tz: 'Africa/Luanda',
        },
        {
            option: 'LNDNA',
            wni_port_name: 'LANDANA',
            wni_unlocode: 'AOMAL',
            wni_country: 'AO',
            wni_lat: -5.23,
            wni_lon: 12.15,
            wni_tz: 'Africa/Luanda',
        },
        {
            option: 'LOMBO',
            wni_port_name: 'LOMBO EAST TERMINAL',
            wni_unlocode: 'AOPAT',
            wni_country: 'AO',
            wni_lat: -6.68,
            wni_lon: 12.37,
            wni_tz: 'Africa/Luanda',
        },
        {
            option: 'RDNDO',
            wni_port_name: 'NOVO REDONDO',
            wni_unlocode: 'AONDD',
            wni_country: 'AO',
            wni_lat: -11.2,
            wni_lon: 13.83,
            wni_tz: 'Africa/Luanda',
        },
        {
            option: 'COLON',
            wni_port_name: 'COLON',
            wni_unlocode: 'UYPDU',
            wni_country: 'AR',
            wni_lat: -32.22,
            wni_lon: -58.13,
            wni_tz: 'America/Argentina/Cordoba',
        },
        {
            option: 'ESN',
            wni_port_name: 'ENSENADA',
            wni_unlocode: 'ARLPG',
            wni_country: 'AR',
            wni_lat: -34.87,
            wni_lon: -57.9,
            wni_tz: 'America/Argentina/Buenos_Aires',
        },
        {
            option: 'IBI',
            wni_port_name: 'PUERTO IBICUY',
            wni_unlocode: 'ARIBY',
            wni_country: 'AR',
            wni_lat: -33.75,
            wni_lon: -59.18,
            wni_tz: 'America/Argentina/Cordoba',
        },
        {
            option: 'INGNR',
            wni_port_name: 'PUERTO INGENIERO WHITE',
            wni_unlocode: 'ARINW',
            wni_country: 'AR',
            wni_lat: -38.8,
            wni_lon: -62.27,
            wni_tz: 'America/Argentina/Buenos_Aires',
        },
        {
            option: 'MRTIN',
            wni_port_name: 'PUERTO SAN MARTIN',
            wni_unlocode: 'ARSMA',
            wni_country: 'AR',
            wni_lat: -32.72,
            wni_lon: -60.73,
            wni_tz: 'America/Argentina/Cordoba',
        },
        {
            option: 'NCNAL',
            wni_port_name: 'PUERTO NACIONAL',
            wni_unlocode: 'ARINW',
            wni_country: 'AR',
            wni_lat: -38.8,
            wni_lon: -62.28,
            wni_tz: 'America/Argentina/Buenos_Aires',
        },
        {
            option: 'PUV',
            wni_port_name: 'PUERTO ACEVEDO',
            wni_unlocode: 'ARVCN',
            wni_country: 'AR',
            wni_lat: -33.25,
            wni_lon: -60.29,
            wni_tz: 'America/Argentina/Buenos_Aires',
        },
        {
            option: 'URQZ',
            wni_port_name: 'VILLA URQUIZA',
            wni_unlocode: 'ARPRA',
            wni_country: 'AR',
            wni_lat: -31.67,
            wni_lon: -60.37,
            wni_tz: 'America/Argentina/Cordoba',
        },
        {
            option: 'AUGST',
            wni_port_name: 'AUGUSTA',
            wni_unlocode: 'AUCLN',
            wni_country: 'AU',
            wni_lat: -34.33,
            wni_lon: 115.17,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'CLRNC',
            wni_port_name: 'CLARENCE RIVER',
            wni_unlocode: 'AUYBA',
            wni_country: 'AU',
            wni_lat: -29.42,
            wni_lon: 153.35,
            wni_tz: 'Australia/Sydney',
        },
        {
            option: 'CMPBA',
            wni_port_name: 'PORT CAMPBELL',
            wni_unlocode: 'AUWMB',
            wni_country: 'AU',
            wni_lat: -38.62,
            wni_lon: 142.98,
            wni_tz: 'Australia/Melbourne',
        },
        {
            option: 'CRNLL',
            wni_port_name: 'CORINELLA',
            wni_unlocode: 'AUWEP',
            wni_country: 'AU',
            wni_lat: -38.42,
            wni_lon: 145.43,
            wni_tz: 'Australia/Melbourne',
        },
        {
            option: 'DVER',
            wni_port_name: 'DOVER',
            wni_unlocode: 'AUPHU',
            wni_country: 'AU',
            wni_lat: -43.32,
            wni_lon: 147.02,
            wni_tz: 'Australia/Hobart',
        },
        {
            option: 'ELCTR',
            wni_port_name: 'ELECTRONA',
            wni_unlocode: 'AUHBA',
            wni_country: 'AU',
            wni_lat: -43.07,
            wni_lon: 147.27,
            wni_tz: 'Australia/Hobart',
        },
        {
            option: 'EXG',
            wni_port_name: 'PORT EXMOUTH',
            wni_unlocode: 'AUPYE',
            wni_country: 'AU',
            wni_lat: -21.82,
            wni_lon: 114.18,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'FARY',
            wni_port_name: 'PORT FAIRY',
            wni_unlocode: 'AUWMB',
            wni_country: 'AU',
            wni_lat: -38.4,
            wni_lon: 142.25,
            wni_tz: 'Australia/Melbourne',
        },
        {
            option: 'HAMI',
            wni_port_name: 'HAMILTON ISLAND',
            wni_unlocode: 'AUHAP',
            wni_country: 'AU',
            wni_lat: -20.35,
            wni_lon: 148.95,
            wni_tz: 'Australia/Lindeman',
        },
        {
            option: 'HENDE',
            wni_port_name: 'PORT HENDERSON',
            wni_unlocode: 'AUHFR',
            wni_country: 'AU',
            wni_lat: -32.16,
            wni_lon: 115.76,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'HRBR',
            wni_port_name: 'VICTOR HARBOUR',
            wni_unlocode: 'AURAB',
            wni_country: 'AU',
            wni_lat: -35.57,
            wni_lon: 138.62,
            wni_tz: 'Australia/Adelaide',
        },
        {
            option: 'HYTHE',
            wni_port_name: 'HYTHE',
            wni_unlocode: 'AUPHU',
            wni_country: 'AU',
            wni_lat: -43.43,
            wni_lon: 147,
            wni_tz: 'Australia/Hobart',
        },
        {
            option: 'KIAMA',
            wni_port_name: 'KIAMA',
            wni_unlocode: 'AUPKL',
            wni_country: 'AU',
            wni_lat: -34.67,
            wni_lon: 150.87,
            wni_tz: 'Australia/Sydney',
        },
        {
            option: 'LTRBE',
            wni_port_name: 'LATROBE',
            wni_unlocode: 'AUDPO',
            wni_country: 'AU',
            wni_lat: -41.22,
            wni_lon: 146.43,
            wni_tz: 'Australia/Hobart',
        },
        {
            option: 'MARGT',
            wni_port_name: 'MARGATE',
            wni_unlocode: 'AUHBA',
            wni_country: 'AU',
            wni_lat: -43.03,
            wni_lon: 147.27,
            wni_tz: 'Australia/Hobart',
        },
        {
            option: 'MDDTN',
            wni_port_name: 'MIDDLETON',
            wni_unlocode: 'AUPHU',
            wni_country: 'AU',
            wni_lat: -43.23,
            wni_lon: 147.27,
            wni_tz: 'Australia/Hobart',
        },
        {
            option: 'NGNR',
            wni_port_name: 'NGANHURRA TERMINAL',
            wni_unlocode: 'AUPYE',
            wni_country: 'AU',
            wni_lat: -21.58,
            wni_lon: 114,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'PRG',
            wni_port_name: 'PORT GERMEIN',
            wni_unlocode: 'AUPPI',
            wni_country: 'AU',
            wni_lat: -33.02,
            wni_lon: 138,
            wni_tz: 'Australia/Adelaide',
        },
        {
            option: 'PSTP',
            wni_port_name: 'PORT STEPHENS',
            wni_unlocode: 'AUNTL',
            wni_country: 'AU',
            wni_lat: -32.72,
            wni_lon: 152.2,
            wni_tz: 'Australia/Sydney',
        },
        {
            option: 'SNDGT',
            wni_port_name: 'SANDGATE',
            wni_unlocode: 'AUBNE',
            wni_country: 'AU',
            wni_lat: -27.32,
            wni_lon: 153.07,
            wni_tz: 'Australia/Brisbane',
        },
        {
            option: 'SYB',
            wni_port_name: 'STYBARROW OFFSHORE TERMINAL',
            wni_unlocode: 'AUPYE',
            wni_country: 'AU',
            wni_lat: -21.45,
            wni_lon: 113.81,
            wni_tz: 'Australia/Perth',
        },
        {
            option: 'ULVRS',
            wni_port_name: 'ULVERSTONE',
            wni_unlocode: 'AUDPO',
            wni_country: 'AU',
            wni_lat: -41.17,
            wni_lon: 146.2,
            wni_tz: 'Australia/Hobart',
        },
        {
            option: 'VNCNT',
            wni_port_name: 'PORT VINCENT',
            wni_unlocode: 'AUKLP',
            wni_country: 'AU',
            wni_lat: -34.78,
            wni_lon: 137.85,
            wni_tz: 'Australia/Adelaide',
        },
        {
            option: 'WKFLD',
            wni_port_name: 'PORT WAKEFIELD',
            wni_unlocode: 'AUARD',
            wni_country: 'AU',
            wni_lat: -34.2,
            wni_lon: 138.15,
            wni_tz: 'Australia/Adelaide',
        },
        {
            option: 'WLLNG',
            wni_port_name: 'WOLLONGONG',
            wni_unlocode: 'AUPKL',
            wni_country: 'AU',
            wni_lat: -34.42,
            wni_lon: 150.9,
            wni_tz: 'Australia/Sydney',
        },
        {
            option: 'WRTH',
            wni_port_name: 'PORT WARATAH',
            wni_unlocode: 'AUNTL',
            wni_country: 'AU',
            wni_lat: -32.9,
            wni_lon: 151.77,
            wni_tz: 'Australia/Sydney',
        },
        {
            option: 'DRUIF',
            wni_port_name: 'DRUIF',
            wni_unlocode: 'AWAUA',
            wni_country: 'AW',
            wni_lat: 12.53,
            wni_lon: -70.07,
            wni_tz: 'America/Aruba',
        },
        {
            option: 'PARDN',
            wni_port_name: 'PAARDEN BAAI',
            wni_unlocode: 'AWAUA',
            wni_country: 'AW',
            wni_lat: 12.52,
            wni_lon: -70.03,
            wni_tz: 'America/Aruba',
        },
        {
            option: 'SPGHT',
            wni_port_name: 'SPEIGHTSTOWN',
            wni_unlocode: 'BBBGI',
            wni_country: 'BB',
            wni_lat: 13.25,
            wni_lon: -59.65,
            wni_tz: 'America/Barbados',
        },
        {
            option: 'BLNKG',
            wni_port_name: 'BLANKENBERGE',
            wni_unlocode: 'BEZEE',
            wni_country: 'BE',
            wni_lat: 51.32,
            wni_lon: 3.12,
            wni_tz: 'Europe/Brussels',
        },
        {
            option: 'OSE',
            wni_port_name: 'OOSTENDE',
            wni_unlocode: 'BEOST',
            wni_country: 'BE',
            wni_lat: 51.23,
            wni_lon: 2.92,
            wni_tz: 'Europe/Brussels',
        },
        {
            option: 'AKHP',
            wni_port_name: 'AKHTOPOL',
            wni_unlocode: 'TRIGN',
            wni_country: 'BG',
            wni_lat: 42.1,
            wni_lon: 27.93,
            wni_tz: 'Europe/Sofia',
        },
        {
            option: 'KVRN',
            wni_port_name: 'KAVARNA',
            wni_unlocode: 'BGBAL',
            wni_country: 'BG',
            wni_lat: 43.42,
            wni_lon: 28.4,
            wni_tz: 'Europe/Sofia',
        },
        {
            option: 'MCRIN',
            wni_port_name: 'MICHURIN',
            wni_unlocode: 'TRIGN',
            wni_country: 'BG',
            wni_lat: 42.17,
            wni_lon: 27.9,
            wni_tz: 'Europe/Sofia',
        },
        {
            option: 'MANH',
            wni_port_name: 'AL MANAMAH HARBOR',
            wni_unlocode: 'BHBAH',
            wni_country: 'BH',
            wni_lat: 26.23,
            wni_lon: 50.58,
            wni_tz: 'Asia/Bahrain',
        },
        {
            option: 'BL',
            wni_port_name: 'ST. BARTHELEMY',
            wni_unlocode: 'SXPHI',
            wni_country: 'BL',
            wni_lat: 17.91,
            wni_lon: -62.83,
            wni_tz: 'America/St_Barthelemy',
        },
        {
            option: 'GSTV',
            wni_port_name: 'GUSTAVIA',
            wni_unlocode: 'SXPHI',
            wni_country: 'BL',
            wni_lat: 17.9,
            wni_lon: -62.85,
            wni_tz: 'America/St_Barthelemy',
        },
        {
            option: 'STBA',
            wni_port_name: 'ST. BARTHELEMY',
            wni_unlocode: 'SXPHI',
            wni_country: 'BL',
            wni_lat: 17.91,
            wni_lon: -62.83,
            wni_tz: 'America/St_Barthelemy',
        },
        {
            option: 'IRLND',
            wni_port_name: 'IRELAND ISLAND',
            wni_unlocode: 'BMFPT',
            wni_country: 'BM',
            wni_lat: 32.32,
            wni_lon: -64.83,
            wni_tz: 'Atlantic/Bermuda',
        },
        {
            option: 'GOTOA',
            wni_port_name: 'GOTO OIL TERMINAL',
            wni_unlocode: 'BQBON',
            wni_country: 'BQ',
            wni_lat: 12.22,
            wni_lon: -68.38,
            wni_tz: 'America/Kralendijk',
        },
        {
            option: 'ABT',
            wni_port_name: 'ABAETETUBA',
            wni_unlocode: 'BRVIC',
            wni_country: 'BR',
            wni_lat: -1.72,
            wni_lon: -48.89,
            wni_tz: 'America/Belem',
        },
        {
            option: 'ARCRZ',
            wni_port_name: 'TERMINAL DA ARACRUZ',
            wni_unlocode: 'BRACZ',
            wni_country: 'BR',
            wni_lat: -19.85,
            wni_lon: -40.08,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'COSP',
            wni_port_name: 'COSIPA',
            wni_unlocode: 'BRCUO',
            wni_country: 'BR',
            wni_lat: -23.86,
            wni_lon: -46.37,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'FAZ',
            wni_port_name: 'FAZENDINHA PILOT',
            wni_unlocode: 'BRSAN',
            wni_country: 'BR',
            wni_lat: -0.07,
            wni_lon: -51.11,
            wni_tz: 'America/Belem',
        },
        {
            option: 'JONVL',
            wni_port_name: 'JOINVILLE',
            wni_unlocode: 'BRSFS',
            wni_country: 'BR',
            wni_lat: -26.32,
            wni_lon: -48.85,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'MANG',
            wni_port_name: 'MANGARATIBA',
            wni_unlocode: 'BRSPB',
            wni_country: 'BR',
            wni_lat: -22.96,
            wni_lon: -44.04,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'MOSQ',
            wni_port_name: 'MOSQUEIRO',
            wni_unlocode: 'BROUT',
            wni_country: 'BR',
            wni_lat: -1.16,
            wni_lon: -48.47,
            wni_tz: 'America/Belem',
        },
        {
            option: 'SDSTE',
            wni_port_name: 'PORTO SUDESTE',
            wni_unlocode: 'BRSPB',
            wni_country: 'BR',
            wni_lat: -22.93,
            wni_lon: -43.86,
            wni_tz: 'America/Sao_Paulo',
        },
        {
            option: 'USI',
            wni_port_name: 'USIBA',
            wni_unlocode: 'BRARB',
            wni_country: 'BR',
            wni_lat: -12.78,
            wni_lon: -38.48,
            wni_tz: 'America/Bahia',
        },
        {
            option: 'BIMN',
            wni_port_name: 'BIMINI ISLAND',
            wni_unlocode: 'BSBIM',
            wni_country: 'BS',
            wni_lat: 25.73,
            wni_lon: -79.25,
            wni_tz: 'America/Nassau',
        },
        {
            option: 'CNP',
            wni_port_name: 'CLIFTON PIER',
            wni_unlocode: 'BSCLP',
            wni_country: 'BS',
            wni_lat: 25,
            wni_lon: -77.55,
            wni_tz: 'America/Nassau',
        },
        {
            option: 'ABRT',
            wni_port_name: 'HAVRE AUBERT',
            wni_unlocode: 'CAAMN',
            wni_country: 'CA',
            wni_lat: 47.23,
            wni_lon: -61.83,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'ADRSW',
            wni_port_name: 'ST ANDREWS EAST',
            wni_unlocode: 'CAALF',
            wni_country: 'CA',
            wni_lat: 45.57,
            wni_lon: -74.33,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'AHOST',
            wni_port_name: 'AHOUSAT',
            wni_unlocode: 'CAGOR',
            wni_country: 'CA',
            wni_lat: 49.28,
            wni_lon: -126.07,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'ALRTC',
            wni_port_name: 'ALERT BAY',
            wni_unlocode: 'CAPMA',
            wni_country: 'CA',
            wni_lat: 50.58,
            wni_lon: -126.93,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'ANIC',
            wni_port_name: 'ST ANICET',
            wni_unlocode: 'CAVLF',
            wni_country: 'CA',
            wni_lat: 45.13,
            wni_lon: -74.37,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'ANNPL',
            wni_port_name: 'ANNAPOLIS ROYAL',
            wni_unlocode: 'CADIG',
            wni_country: 'CA',
            wni_lat: 44.75,
            wni_lon: -65.52,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'BAIE',
            wni_port_name: 'LA BAIE',
            wni_unlocode: 'CAPAF',
            wni_country: 'CA',
            wni_lat: 48.33,
            wni_lon: -70.88,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'BAYS',
            wni_port_name: 'PORT BAYSIDE NB',
            wni_unlocode: 'CABAY',
            wni_country: 'CA',
            wni_lat: 45.15,
            wni_lon: -67.13,
            wni_tz: 'America/Moncton',
        },
        {
            option: 'BCTC',
            wni_port_name: 'BUCTOUCHE',
            wni_unlocode: 'CARBT',
            wni_country: 'CA',
            wni_lat: 46.47,
            wni_lon: -64.72,
            wni_tz: 'America/Moncton',
        },
        {
            option: 'BEAV',
            wni_port_name: 'BEAVER COVE',
            wni_unlocode: 'CAPMA',
            wni_country: 'CA',
            wni_lat: 50.55,
            wni_lon: -126.85,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'BEAVR',
            wni_port_name: 'BEAVER HARBOUR',
            wni_unlocode: 'CASHH',
            wni_country: 'CA',
            wni_lat: 44.88,
            wni_lon: -62.42,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'BERGH',
            wni_port_name: 'BERGH COVE',
            wni_unlocode: 'CARUI',
            wni_country: 'CA',
            wni_lat: 50.53,
            wni_lon: -127.62,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'BHRNS',
            wni_port_name: 'BEAUHARNOIS',
            wni_unlocode: 'CAVLF',
            wni_country: 'CA',
            wni_lat: 45.32,
            wni_lon: -73.88,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'BIC',
            wni_port_name: 'BIC',
            wni_unlocode: 'CARIM',
            wni_country: 'CA',
            wni_lat: 48.37,
            wni_lon: -68.71,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'BLBL',
            wni_port_name: 'NEW BELLA BELLA',
            wni_unlocode: 'CAOFA',
            wni_country: 'CA',
            wni_lat: 52.17,
            wni_lon: -128.15,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'BLLVL',
            wni_port_name: 'BELLEVILLE',
            wni_unlocode: 'CAPIC',
            wni_country: 'CA',
            wni_lat: 44.15,
            wni_lon: -77.4,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'BLNDU',
            wni_port_name: 'CHUTE A BLONDEAU',
            wni_unlocode: 'CAALF',
            wni_country: 'CA',
            wni_lat: 45.58,
            wni_lon: -74.47,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'BMFLD',
            wni_port_name: 'BAMFIELD ISLET',
            wni_unlocode: 'CAPAB',
            wni_country: 'CA',
            wni_lat: 48.83,
            wni_lon: -125.13,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'BNVT',
            wni_port_name: 'BONAVISTA',
            wni_unlocode: 'CACAT',
            wni_country: 'CA',
            wni_lat: 48.65,
            wni_lon: -53.12,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'BRASC',
            wni_port_name: 'LITTLE BRAS D OR',
            wni_unlocode: 'CANSY',
            wni_country: 'CA',
            wni_lat: 46.25,
            wni_lon: -60.3,
            wni_tz: 'America/Glace_Bay',
        },
        {
            option: 'BRCKV',
            wni_port_name: 'BROCKVILLE',
            wni_unlocode: 'USOG2',
            wni_country: 'CA',
            wni_lat: 44.58,
            wni_lon: -75.67,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'BRDWD',
            wni_port_name: 'BURDWOOD BAY',
            wni_unlocode: 'CADCN',
            wni_country: 'CA',
            wni_lat: 50.15,
            wni_lon: -125.1,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'BRIGS',
            wni_port_name: 'BRIGUS BAY',
            wni_unlocode: 'CABYR',
            wni_country: 'CA',
            wni_lat: 47.53,
            wni_lon: -53.2,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'BRNTC',
            wni_port_name: 'BRONTE',
            wni_unlocode: 'CAOAK',
            wni_country: 'CA',
            wni_lat: 43.4,
            wni_lon: -79.72,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'BRRNG',
            wni_port_name: 'BARRINGTON PASWNIE',
            wni_unlocode: 'CASBU',
            wni_country: 'CA',
            wni_lat: 43.53,
            wni_lon: -65.6,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'BRUCE',
            wni_port_name: 'BRUCE MINES',
            wni_unlocode: 'CATHS',
            wni_country: 'CA',
            wni_lat: 46.28,
            wni_lon: -83.78,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'BRWLL',
            wni_port_name: 'PORT BURWELL',
            wni_unlocode: 'FKPSY',
            wni_country: 'CA',
            wni_lat: 42.63,
            wni_lon: -80.8,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'BTCHW',
            wni_port_name: 'BATCHAWANA BAY',
            wni_unlocode: 'CASSM',
            wni_country: 'CA',
            wni_lat: 46.92,
            wni_lon: -84.6,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'BTDL',
            wni_port_name: 'BUTEDALE',
            wni_unlocode: 'CAYTB',
            wni_country: 'CA',
            wni_lat: 53.17,
            wni_lon: -128.68,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'BURIN',
            wni_port_name: 'BURIN',
            wni_unlocode: 'CAMTN',
            wni_country: 'CA',
            wni_lat: 47.05,
            wni_lon: -55.17,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'BVH',
            wni_port_name: 'BEAVER HARBOR',
            wni_unlocode: 'CABEH',
            wni_country: 'CA',
            wni_lat: 45.07,
            wni_lon: -66.74,
            wni_tz: 'America/Moncton',
        },
        {
            option: 'BVT',
            wni_port_name: 'BAY VERTE',
            wni_unlocode: 'CAHRE',
            wni_country: 'CA',
            wni_lat: 48.08,
            wni_lon: -52.89,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'BYFLD',
            wni_port_name: 'BAYFIELD',
            wni_unlocode: 'CAGOH',
            wni_country: 'CA',
            wni_lat: 43.57,
            wni_lon: -81.7,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'BYNG',
            wni_port_name: 'BYNG INLET',
            wni_unlocode: 'CABTT',
            wni_country: 'CA',
            wni_lat: 45.77,
            wni_lon: -80.57,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'CCKBN',
            wni_port_name: 'COCKBURN',
            wni_unlocode: 'CAMDB',
            wni_country: 'CA',
            wni_lat: 45.95,
            wni_lon: -83.32,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'CGHNW',
            wni_port_name: 'CAUGHNAWAGA',
            wni_unlocode: 'CACSC',
            wni_country: 'CA',
            wni_lat: 45.35,
            wni_lon: -73.68,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'CHEST',
            wni_port_name: 'CHESTER',
            wni_unlocode: 'CALUN',
            wni_country: 'CA',
            wni_lat: 44.53,
            wni_lon: -64.25,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'CLCST',
            wni_port_name: 'COLCHESTER',
            wni_unlocode: 'CAKVL',
            wni_country: 'CA',
            wni_lat: 41.98,
            wni_lon: -82.93,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'CMPBC',
            wni_port_name: 'CAMPBELLTON',
            wni_unlocode: 'CALWP',
            wni_country: 'CA',
            wni_lat: 49.28,
            wni_lon: -54.92,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'COAL',
            wni_port_name: 'COAL HARBOR',
            wni_unlocode: 'CARUI',
            wni_country: 'CA',
            wni_lat: 50.6,
            wni_lon: -127.58,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'COBRG',
            wni_port_name: 'COBOURG',
            wni_unlocode: 'CAOPE',
            wni_country: 'CA',
            wni_lat: 43.95,
            wni_lon: -78.17,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'COMOX',
            wni_port_name: 'COMOX HARBOR',
            wni_unlocode: 'CACOX',
            wni_country: 'CA',
            wni_lat: 49.67,
            wni_lon: -124.92,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'CONCH',
            wni_port_name: 'CONCHE',
            wni_unlocode: 'CAMBR',
            wni_country: 'CA',
            wni_lat: 50.88,
            wni_lon: -55.9,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'CORTS',
            wni_port_name: 'CORTES BAY',
            wni_unlocode: 'CACAM',
            wni_country: 'CA',
            wni_lat: 50.07,
            wni_lon: -124.93,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'COVES',
            wni_port_name: 'SNUG COVE',
            wni_unlocode: 'CABIN',
            wni_country: 'CA',
            wni_lat: 49.38,
            wni_lon: -123.32,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'CPCEE',
            wni_port_name: 'CEEPEECEE',
            wni_unlocode: 'CAPTA',
            wni_country: 'CA',
            wni_lat: 49.87,
            wni_lon: -126.72,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'CQTLM',
            wni_port_name: 'PORT COQUITLAM',
            wni_unlocode: 'CAPMO',
            wni_country: 'CA',
            wni_lat: 49.27,
            wni_lon: -122.78,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'CREDT',
            wni_port_name: 'PORT CREDIT',
            wni_unlocode: 'CAMIS',
            wni_country: 'CA',
            wni_lat: 43.55,
            wni_lon: -79.58,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'CRLLN',
            wni_port_name: 'CARILLON',
            wni_unlocode: 'CAALF',
            wni_country: 'CA',
            wni_lat: 45.57,
            wni_lon: -74.37,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'CTAU',
            wni_port_name: 'COTEAU LANDING',
            wni_unlocode: 'CAVLF',
            wni_country: 'CA',
            wni_lat: 45.25,
            wni_lon: -74.2,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'CTHRS',
            wni_port_name: 'ST CATHERINE',
            wni_unlocode: 'CASCA',
            wni_country: 'CA',
            wni_lat: 43.18,
            wni_lon: -79.28,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'DEPOT',
            wni_port_name: 'DEPOT HARBOUR',
            wni_unlocode: 'CAPRS',
            wni_country: 'CA',
            wni_lat: 45.32,
            wni_lon: -80.1,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'DGLST',
            wni_port_name: 'DOUGLASTOWN',
            wni_unlocode: 'CASBH',
            wni_country: 'CA',
            wni_lat: 48.77,
            wni_lon: -64.38,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'DLD',
            wni_port_name: 'DILDO',
            wni_unlocode: 'CALOH',
            wni_country: 'CA',
            wni_lat: 47.57,
            wni_lon: -53.56,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'DLHS',
            wni_port_name: 'PORT DALHOUSIE',
            wni_unlocode: 'CAPWE',
            wni_country: 'CA',
            wni_lat: 43.22,
            wni_lon: -79.27,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'DOVR',
            wni_port_name: 'PORT DOVER',
            wni_unlocode: 'CANAN',
            wni_country: 'CA',
            wni_lat: 42.78,
            wni_lon: -80.2,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'DSBRT',
            wni_port_name: 'DESBARATS',
            wni_unlocode: 'CATHS',
            wni_country: 'CA',
            wni_lat: 46.33,
            wni_lon: -83.92,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'DSRNT',
            wni_port_name: 'DESERONTO',
            wni_unlocode: 'CAPIC',
            wni_country: 'CA',
            wni_lat: 44.2,
            wni_lon: -77.05,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'EDWD',
            wni_port_name: 'POINT EDWARD',
            wni_unlocode: 'USPHN',
            wni_country: 'CA',
            wni_lat: 43,
            wni_lon: -82.42,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'EHLTS',
            wni_port_name: 'EHLATEESE COVE',
            wni_unlocode: 'CAPAB',
            wni_country: 'CA',
            wni_lat: 48.98,
            wni_lon: -124.98,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'ELGN',
            wni_port_name: 'PORT ELGIN',
            wni_unlocode: 'CAOWS',
            wni_country: 'CA',
            wni_lat: 44.43,
            wni_lon: -81.4,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'EMRD',
            wni_port_name: 'EMERALD',
            wni_unlocode: 'CABTH',
            wni_country: 'CA',
            wni_lat: 44.15,
            wni_lon: -76.77,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'ESM',
            wni_port_name: 'ESCOUMAINS',
            wni_unlocode: 'CATAD',
            wni_country: 'CA',
            wni_lat: 48.34,
            wni_lon: -69.39,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'ESQML',
            wni_port_name: 'ESQUIMALT HARBOR',
            wni_unlocode: 'CAESQ',
            wni_country: 'CA',
            wni_lat: 48.43,
            wni_lon: -123.43,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'FGO',
            wni_port_name: 'FOGO',
            wni_unlocode: 'CATWI',
            wni_country: 'CA',
            wni_lat: 49.72,
            wni_lon: -54.28,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'FLFRD',
            wni_port_name: 'FULFORD HARBOUR',
            wni_unlocode: 'CAHAT',
            wni_country: 'CA',
            wni_lat: 48.77,
            wni_lon: -123.43,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'FLIX',
            wni_port_name: 'PORT FELIX',
            wni_unlocode: 'CACAH',
            wni_country: 'CA',
            wni_lat: 45.25,
            wni_lon: -61.22,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'FORDC',
            wni_port_name: 'FORD',
            wni_unlocode: 'CANAI',
            wni_country: 'CA',
            wni_lat: 56.47,
            wni_lon: -61.18,
            wni_tz: 'America/Goose_Bay',
        },
        {
            option: 'FORTU',
            wni_port_name: 'FORTEAU BAY',
            wni_unlocode: 'CAYBX',
            wni_country: 'CA',
            wni_lat: 51.47,
            wni_lon: -56.97,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'FOXC',
            wni_port_name: 'FOX RIVER',
            wni_unlocode: 'CAGPE',
            wni_country: 'CA',
            wni_lat: 49,
            wni_lon: -64.38,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'FRSR',
            wni_port_name: 'FRASER MILLS',
            wni_unlocode: 'CANWE',
            wni_country: 'CA',
            wni_lat: 49.22,
            wni_lon: -122.87,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'FRTUN',
            wni_port_name: 'FORTUNE HARBOR',
            wni_unlocode: 'CALWP',
            wni_country: 'CA',
            wni_lat: 49.53,
            wni_lon: -55.23,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'FSSTT',
            wni_port_name: 'FASSETT',
            wni_unlocode: 'CAALF',
            wni_country: 'CA',
            wni_lat: 45.65,
            wni_lon: -74.87,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'GLACE',
            wni_port_name: 'GLACE BAY',
            wni_unlocode: 'CASYD',
            wni_country: 'CA',
            wni_lat: 46.2,
            wni_lon: -59.95,
            wni_tz: 'America/Glace_Bay',
        },
        {
            option: 'GLDSB',
            wni_port_name: 'GOLDSBORO',
            wni_unlocode: 'CACOH',
            wni_country: 'CA',
            wni_lat: 45.18,
            wni_lon: -61.65,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'GNGS',
            wni_port_name: 'GANGES',
            wni_unlocode: 'CACRO',
            wni_country: 'CA',
            wni_lat: 48.85,
            wni_lon: -123.48,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'GNNQ',
            wni_port_name: 'GANANOQUE',
            wni_unlocode: 'USCLY',
            wni_country: 'CA',
            wni_lat: 44.33,
            wni_lon: -76.17,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'GNRRW',
            wni_port_name: 'GRAND NARROWS',
            wni_unlocode: 'CAION',
            wni_country: 'CA',
            wni_lat: 45.95,
            wni_lon: -60.78,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'GOLAS',
            wni_port_name: 'GOULAIS BAY',
            wni_unlocode: 'CASSM',
            wni_country: 'CA',
            wni_lat: 46.73,
            wni_lon: -84.5,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'GRGNT',
            wni_port_name: 'GARGANTUA',
            wni_unlocode: 'CAMIH',
            wni_country: 'CA',
            wni_lat: 47.57,
            wni_lon: -84.97,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'GRVLE',
            wni_port_name: 'GRENVILLE',
            wni_unlocode: 'CAALF',
            wni_country: 'CA',
            wni_lat: 45.63,
            wni_lon: -74.6,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'GWLLN',
            wni_port_name: 'GOWLLAND HARBOR',
            wni_unlocode: 'CADCN',
            wni_country: 'CA',
            wni_lat: 50.08,
            wni_lon: -125.25,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'GYSBR',
            wni_port_name: 'GUYSBOROUGH',
            wni_unlocode: 'CAPHW',
            wni_country: 'CA',
            wni_lat: 45.4,
            wni_lon: -61.5,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'HDSON',
            wni_port_name: 'HUDSON',
            wni_unlocode: 'CAVLF',
            wni_country: 'CA',
            wni_lat: 45.47,
            wni_lon: -74.13,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'HEATS',
            wni_port_name: 'HEARTS CONTENT',
            wni_unlocode: 'CACRB',
            wni_country: 'CA',
            wni_lat: 47.88,
            wni_lon: -53.38,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'HILLS',
            wni_port_name: 'HILLSBOROUGH',
            wni_unlocode: 'CASHE',
            wni_country: 'CA',
            wni_lat: 45.93,
            wni_lon: -64.63,
            wni_tz: 'America/Moncton',
        },
        {
            option: 'HLTON',
            wni_port_name: 'HILTON',
            wni_unlocode: 'CATHS',
            wni_country: 'CA',
            wni_lat: 46.25,
            wni_lon: -83.88,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'HONRA',
            wni_port_name: 'HONORA',
            wni_unlocode: 'CAWHF',
            wni_country: 'CA',
            wni_lat: 45.87,
            wni_lon: -82.17,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'HOOD',
            wni_port_name: 'PORT HOOD',
            wni_unlocode: 'CAMUL',
            wni_country: 'CA',
            wni_lat: 46.02,
            wni_lon: -61.53,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'HOPEC',
            wni_port_name: 'HOPE BAY',
            wni_unlocode: 'CAHAT',
            wni_country: 'CA',
            wni_lat: 48.8,
            wni_lon: -123.28,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'HRBRJ',
            wni_port_name: 'MARIE JOSEPH HARBOR',
            wni_unlocode: 'CASHH',
            wni_country: 'CA',
            wni_lat: 44.97,
            wni_lon: -62.08,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'HRBRK',
            wni_port_name: 'KEY HARBOUR',
            wni_unlocode: 'CABTT',
            wni_country: 'CA',
            wni_lat: 45.88,
            wni_lon: -80.75,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'HRBRW',
            wni_port_name: 'DIPPER HARBOUR WEST',
            wni_unlocode: 'CABEH',
            wni_country: 'CA',
            wni_lat: 45.1,
            wni_lon: -66.42,
            wni_tz: 'America/Moncton',
        },
        {
            option: 'HRSSH',
            wni_port_name: 'HORSESHOE BAY',
            wni_unlocode: 'CABIN',
            wni_country: 'CA',
            wni_lat: 49.38,
            wni_lon: -123.27,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'HSTG',
            wni_port_name: 'PORT HASTINGS',
            wni_unlocode: 'CAMUL',
            wni_country: 'CA',
            wni_lat: 45.65,
            wni_lon: -61.4,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'HWKSB',
            wni_port_name: 'HAWKESBURY',
            wni_unlocode: 'CAALF',
            wni_country: 'CA',
            wni_lat: 45.62,
            wni_lon: -74.62,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'INGNS',
            wni_port_name: 'INGONISH',
            wni_unlocode: 'CANSY',
            wni_country: 'CA',
            wni_lat: 46.63,
            wni_lon: -60.38,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'INGRM',
            wni_port_name: 'INGRAMPORT',
            wni_unlocode: 'CADAR',
            wni_country: 'CA',
            wni_lat: 44.68,
            wni_lon: -63.97,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'IRVNS',
            wni_port_name: 'IRVINES LANDING',
            wni_unlocode: 'CAYHS',
            wni_country: 'CA',
            wni_lat: 49.63,
            wni_lon: -124.05,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'ISAAC',
            wni_port_name: 'ISAACS HARBOR',
            wni_unlocode: 'CACOH',
            wni_country: 'CA',
            wni_lat: 45.17,
            wni_lon: -61.67,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'JCKFS',
            wni_port_name: 'JACKFISH',
            wni_unlocode: 'CAMAR',
            wni_country: 'CA',
            wni_lat: 48.8,
            wni_lon: -86.97,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'JDDR',
            wni_port_name: 'JEDDORE HARBOR',
            wni_unlocode: 'CASHH',
            wni_country: 'CA',
            wni_lat: 44.73,
            wni_lon: -63.01,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'KEYO',
            wni_port_name: 'KEY HARBOUR',
            wni_unlocode: 'CABTT',
            wni_country: 'CA',
            wni_lat: 45.88,
            wni_lon: -80.75,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'KGWNG',
            wni_port_name: 'KAGAWONG',
            wni_unlocode: 'CASPR',
            wni_country: 'CA',
            wni_lat: 45.92,
            wni_lon: -82.25,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'KJJQ',
            wni_port_name: 'FORT CHIMO',
            wni_unlocode: 'CAFCM',
            wni_country: 'CA',
            wni_lat: 58.1,
            wni_lon: -68.4,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'KLKTS',
            wni_port_name: 'KLIKTSOATLI HARBOR',
            wni_unlocode: 'CAOFA',
            wni_country: 'CA',
            wni_lat: 52.15,
            wni_lon: -128.08,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'KLRY',
            wni_port_name: 'KILLARNEY',
            wni_unlocode: 'CAWHF',
            wni_country: 'CA',
            wni_lat: 45.97,
            wni_lon: -81.52,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'KNCRD',
            wni_port_name: 'KINCARDINE',
            wni_unlocode: 'CAGOH',
            wni_country: 'CA',
            wni_lat: 44.17,
            wni_lon: -81.65,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'LAD',
            wni_port_name: 'LADNER',
            wni_unlocode: 'CARBC',
            wni_country: 'CA',
            wni_lat: 49.09,
            wni_lon: -123.08,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'LAKEH',
            wni_port_name: 'LAKEHEAD HARBOR',
            wni_unlocode: 'CAPOA',
            wni_country: 'CA',
            wni_lat: 48.4,
            wni_lon: -89.23,
            wni_tz: 'America/Thunder_Bay',
        },
        {
            option: 'LCOMB',
            wni_port_name: 'LISCOMB',
            wni_unlocode: 'CACOH',
            wni_country: 'CA',
            wni_lat: 45,
            wni_lon: -62.07,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'LETNG',
            wni_port_name: 'LETANG HARBOR',
            wni_unlocode: 'CABEH',
            wni_country: 'CA',
            wni_lat: 45.05,
            wni_lon: -66.83,
            wni_tz: 'America/Moncton',
        },
        {
            option: 'LIONS',
            wni_port_name: 'LIONS HEAD',
            wni_unlocode: 'CAOWS',
            wni_country: 'CA',
            wni_lat: 44.98,
            wni_lon: -81.25,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'LLAKE',
            wni_port_name: 'LOWER LAKES TERMINAL',
            wni_unlocode: 'CAPRE',
            wni_country: 'CA',
            wni_lat: 44.73,
            wni_lon: -75.47,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'LRDSS',
            wni_port_name: 'BLANC SABLON',
            wni_unlocode: 'CAYBX',
            wni_country: 'CA',
            wni_lat: 51.42,
            wni_lon: -57.13,
            wni_tz: 'America/Blanc-Sablon',
        },
        {
            option: 'LSBG',
            wni_port_name: 'LOUISBURG',
            wni_unlocode: 'CALOU',
            wni_country: 'CA',
            wni_lat: 45.92,
            wni_lon: -59.97,
            wni_tz: 'America/Goose_Bay',
        },
        {
            option: 'LTN',
            wni_port_name: 'GRAND NARROWS',
            wni_unlocode: 'CAION',
            wni_country: 'CA',
            wni_lat: 45.95,
            wni_lon: -60.78,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'LTTLC',
            wni_port_name: 'LITTLE BAY',
            wni_unlocode: 'CASPD',
            wni_country: 'CA',
            wni_lat: 49.62,
            wni_lon: -56,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'LTTLE',
            wni_port_name: 'LITTLE CURRENT',
            wni_unlocode: 'CAWHF',
            wni_country: 'CA',
            wni_lat: 45.98,
            wni_lon: -81.93,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'LUND',
            wni_port_name: 'LUND',
            wni_unlocode: 'CAPOW',
            wni_country: 'CA',
            wni_lat: 49.98,
            wni_lon: -124.77,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'LYALL',
            wni_port_name: 'LYALL HARBOR',
            wni_unlocode: 'CAHAT',
            wni_country: 'CA',
            wni_lat: 48.8,
            wni_lon: -123.2,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'MAHN',
            wni_port_name: 'MAHONE BAY',
            wni_unlocode: 'CALUN',
            wni_country: 'CA',
            wni_lat: 44.45,
            wni_lon: -64.38,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'MAIT',
            wni_port_name: 'PORT MAITLAND',
            wni_unlocode: 'CAPCO',
            wni_country: 'CA',
            wni_lat: 42.85,
            wni_lon: -79.58,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'MALBA',
            wni_port_name: 'LA MALBAIE',
            wni_unlocode: 'CAPOP',
            wni_country: 'CA',
            wni_lat: 47.65,
            wni_lon: -70.15,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'MAYNE',
            wni_port_name: 'MAYNE',
            wni_unlocode: 'CACRO',
            wni_country: 'CA',
            wni_lat: 48.85,
            wni_lon: -123.3,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'MCNCL',
            wni_port_name: 'PORT MCNICOLL',
            wni_unlocode: 'CAMID',
            wni_country: 'CA',
            wni_lat: 44.75,
            wni_lon: -79.8,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'MDA',
            wni_port_name: 'MIDDLE ARM',
            wni_unlocode: 'CASPD',
            wni_country: 'CA',
            wni_lat: 49.7,
            wni_lon: -56.1,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'MFRD',
            wni_port_name: 'MEAFORD',
            wni_unlocode: 'CAOWS',
            wni_country: 'CA',
            wni_lat: 44.62,
            wni_lon: -80.6,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'MINGN',
            wni_port_name: 'MINGAN',
            wni_unlocode: 'CAHSP',
            wni_country: 'CA',
            wni_lat: 50.28,
            wni_lon: -64.02,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'MIRC',
            wni_port_name: 'MIRAMCHI',
            wni_unlocode: 'CACHN',
            wni_country: 'CA',
            wni_lat: 47.03,
            wni_lon: -65.47,
            wni_tz: 'America/Moncton',
        },
        {
            option: 'MISSN',
            wni_port_name: 'MISSION CITY',
            wni_unlocode: 'CAIOC',
            wni_country: 'CA',
            wni_lat: 49.12,
            wni_lon: -122.25,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'MLLHV',
            wni_port_name: 'MILLHAVEN',
            wni_unlocode: 'CABTH',
            wni_country: 'CA',
            wni_lat: 44.2,
            wni_lon: -76.73,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'MLQ',
            wni_port_name: 'MONT-LOUIS',
            wni_unlocode: 'CAMOL',
            wni_country: 'CA',
            wni_lat: 49.23,
            wni_lon: -65.74,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'MNBEL',
            wni_port_name: 'MONTEBELLO',
            wni_unlocode: 'CAALF',
            wni_country: 'CA',
            wni_lat: 45.65,
            wni_lon: -74.93,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'MNCTN',
            wni_port_name: 'MONCTON',
            wni_unlocode: 'CASHE',
            wni_country: 'CA',
            wni_lat: 46.08,
            wni_lon: -64.77,
            wni_tz: 'America/Moncton',
        },
        {
            option: 'MNTWN',
            wni_port_name: 'MANITOWANING',
            wni_unlocode: 'CAWHF',
            wni_country: 'CA',
            wni_lat: 45.75,
            wni_lon: -81.8,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'MNZIS',
            wni_port_name: 'MENZIES BAY',
            wni_unlocode: 'CADCN',
            wni_country: 'CA',
            wni_lat: 50.12,
            wni_lon: -125.38,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'MONTS',
            wni_port_name: 'STE ANNE DES MONTS',
            wni_unlocode: 'CAMHN',
            wni_country: 'CA',
            wni_lat: 49.13,
            wni_lon: -66.48,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'MOTNS',
            wni_port_name: 'MORETONS HARBOR',
            wni_unlocode: 'CATWI',
            wni_country: 'CA',
            wni_lat: 49.58,
            wni_lon: -54.85,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'MRGRE',
            wni_port_name: 'MARGAREE HARBOUR',
            wni_unlocode: 'CABAD',
            wni_country: 'CA',
            wni_lat: 46.43,
            wni_lon: -61.12,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'MSQDB',
            wni_port_name: 'MUSQUODOBOIT HARBOUR',
            wni_unlocode: 'CADAR',
            wni_country: 'CA',
            wni_lat: 44.78,
            wni_lon: -63.15,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'NAPEE',
            wni_port_name: 'NAPANEE',
            wni_unlocode: 'CABTH',
            wni_country: 'CA',
            wni_lat: 44.25,
            wni_lon: -76.95,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'NIGRA',
            wni_port_name: 'NIAGARA',
            wni_unlocode: 'CAPWE',
            wni_country: 'CA',
            wni_lat: 43.25,
            wni_lon: -79.07,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'NNOOS',
            wni_port_name: 'NANOOSE HARBOR',
            wni_unlocode: 'CANNO',
            wni_country: 'CA',
            wni_lat: 49.27,
            wni_lon: -124.15,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'NRHWT',
            wni_port_name: 'NORTH WEST RIVER',
            wni_unlocode: 'CAGOO',
            wni_country: 'CA',
            wni_lat: 53.53,
            wni_lon: -60.15,
            wni_tz: 'America/Goose_Bay',
        },
        {
            option: 'NTHPT',
            wni_port_name: 'NORTHPORT',
            wni_unlocode: 'CAPIC',
            wni_country: 'CA',
            wni_lat: 44.13,
            wni_lon: -77.18,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'OKLAC',
            wni_port_name: 'OKA SUR LE LAC',
            wni_unlocode: 'CAVLF',
            wni_country: 'CA',
            wni_lat: 45.47,
            wni_lon: -74.08,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'PCCDL',
            wni_port_name: 'PICCADILLY',
            wni_unlocode: 'CALCV',
            wni_country: 'CA',
            wni_lat: 48.58,
            wni_lon: -58.9,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'PLAC',
            wni_port_name: 'PLACENTIA',
            wni_unlocode: 'CANWP',
            wni_country: 'CA',
            wni_lat: 47.25,
            wni_lon: -54,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'PLCD',
            wni_port_name: 'ST PLACIDE',
            wni_unlocode: 'CAVLF',
            wni_country: 'CA',
            wni_lat: 45.53,
            wni_lon: -74.2,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'PLEEN',
            wni_port_name: 'PELEE I NORTH WHARF',
            wni_unlocode: 'CAKVL',
            wni_country: 'CA',
            wni_lat: 41.82,
            wni_lon: -82.67,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'PLEEW',
            wni_port_name: 'PELEE I WEST DOCK',
            wni_unlocode: 'CAKVL',
            wni_country: 'CA',
            wni_lat: 41.77,
            wni_lon: -82.68,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'PLLYS',
            wni_port_name: 'PILLEYS ISLAND HARBOR',
            wni_unlocode: 'CASPD',
            wni_country: 'CA',
            wni_lat: 49.5,
            wni_lon: -55.72,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'PPC',
            wni_port_name: 'POINTE AU PIC',
            wni_unlocode: 'CAPOP',
            wni_country: 'CA',
            wni_lat: 47.63,
            wni_lon: -70.14,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'PPNVL',
            wni_port_name: 'PAPINEAUVILLE',
            wni_unlocode: 'CAALF',
            wni_country: 'CA',
            wni_lat: 45.62,
            wni_lon: -75.02,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'PRPSE',
            wni_port_name: 'PORPOISE HARBOR',
            wni_unlocode: 'ZAPED',
            wni_country: 'CA',
            wni_lat: 54.22,
            wni_lon: -130.28,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'PRTNF',
            wni_port_name: 'PORTNEUF',
            wni_unlocode: 'CAFRV',
            wni_country: 'CA',
            wni_lat: 48.63,
            wni_lon: -69.1,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'PSS',
            wni_port_name: 'PORT SIMPSON',
            wni_unlocode: 'CAPRR',
            wni_country: 'CA',
            wni_lat: 54.57,
            wni_lon: -130.43,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'QNSTN',
            wni_port_name: 'QUEENSTON',
            wni_unlocode: 'CATHD',
            wni_country: 'CA',
            wni_lat: 43.17,
            wni_lon: -79.07,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'QTHSK',
            wni_port_name: 'QUATHIASKI COVE',
            wni_unlocode: 'CACAM',
            wni_country: 'CA',
            wni_lat: 50.05,
            wni_lon: -125.22,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'QUA',
            wni_port_name: 'QUATSINO',
            wni_unlocode: 'CARUI',
            wni_country: 'CA',
            wni_lat: 50.53,
            wni_lon: -127.62,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'RCHRD',
            wni_port_name: 'RICHARDS LANDING',
            wni_unlocode: 'USSSM',
            wni_country: 'CA',
            wni_lat: 46.3,
            wni_lon: -84.03,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'RCKLN',
            wni_port_name: 'ROCKLAND',
            wni_unlocode: 'CAALF',
            wni_country: 'CA',
            wni_lat: 45.55,
            wni_lon: -75.3,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'RCKPR',
            wni_port_name: 'ROCKPORT',
            wni_unlocode: 'USCLY',
            wni_country: 'CA',
            wni_lat: 44.38,
            wni_lon: -75.93,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'RDDCK',
            wni_port_name: 'RODDICKTON',
            wni_unlocode: 'CAMBR',
            wni_country: 'CA',
            wni_lat: 50.87,
            wni_lon: -56.13,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'RVR',
            wni_port_name: 'RIVIERE DU LOUP',
            wni_unlocode: 'CAGCA',
            wni_country: 'CA',
            wni_lat: 47.83,
            wni_lon: -69.52,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'SAS',
            wni_port_name: 'ST. ALBANS NFLD',
            wni_unlocode: 'CAHBR',
            wni_country: 'CA',
            wni_lat: 47.87,
            wni_lon: -55.85,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'SCIE',
            wni_port_name: 'LA SCIE',
            wni_unlocode: 'CABVE',
            wni_country: 'CA',
            wni_lat: 49.97,
            wni_lon: -55.62,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'SCKVL',
            wni_port_name: 'SACKVILLE',
            wni_unlocode: 'CASHE',
            wni_country: 'CA',
            wni_lat: 45.88,
            wni_lon: -64.37,
            wni_tz: 'America/Moncton',
        },
        {
            option: 'SDNY',
            wni_port_name: 'SIDNEY',
            wni_unlocode: 'CAHAT',
            wni_country: 'CA',
            wni_lat: 48.65,
            wni_lon: -123.38,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'SEAL',
            wni_port_name: 'SEAL COVE',
            wni_unlocode: 'CABVE',
            wni_country: 'CA',
            wni_lat: 49.93,
            wni_lon: -56.38,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'SEVRN',
            wni_port_name: 'PORT SEVERN',
            wni_unlocode: 'CAMID',
            wni_country: 'CA',
            wni_lat: 44.8,
            wni_lon: -79.72,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'SGB',
            wni_port_name: "ST GEORGE'S",
            wni_unlocode: 'CASTV',
            wni_country: 'CA',
            wni_lat: 48.45,
            wni_lon: -58.45,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'SHGND',
            wni_port_name: 'SHEGUIANDAH',
            wni_unlocode: 'CAWHF',
            wni_country: 'CA',
            wni_lat: 45.9,
            wni_lon: -81.92,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'SHIPC',
            wni_port_name: 'SHIP HARBOUR',
            wni_unlocode: 'CASHH',
            wni_country: 'CA',
            wni_lat: 44.78,
            wni_lon: -62.82,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'SJF',
            wni_port_name: 'ST JOHNS',
            wni_unlocode: 'CASJF',
            wni_country: 'CA',
            wni_lat: 47.57,
            wni_lon: -52.7,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'SLCST',
            wni_port_name: 'SOUTH LANCASTER',
            wni_unlocode: 'CACWL',
            wni_country: 'CA',
            wni_lat: 45.13,
            wni_lon: -74.5,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'SMBR',
            wni_port_name: 'SAMBRO',
            wni_unlocode: 'CAHAL',
            wni_country: 'CA',
            wni_lat: 44.47,
            wni_lon: -63.6,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'SNV',
            wni_port_name: 'ST JOHN',
            wni_unlocode: 'CACPT',
            wni_country: 'CA',
            wni_lat: 45.27,
            wni_lon: -66.05,
            wni_tz: 'America/Moncton',
        },
        {
            option: 'SONOR',
            wni_port_name: 'SONORA',
            wni_unlocode: 'CACOH',
            wni_country: 'CA',
            wni_lat: 45.07,
            wni_lon: -61.92,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'SONTL',
            wni_port_name: 'SOINTULA',
            wni_unlocode: 'CAPMA',
            wni_country: 'CA',
            wni_lat: 50.63,
            wni_lon: -127.02,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'SOOKE',
            wni_port_name: 'SOOKE',
            wni_unlocode: 'CAESQ',
            wni_country: 'CA',
            wni_lat: 48.37,
            wni_lon: -123.72,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'SPR',
            wni_port_name: 'ST. PETERS',
            wni_unlocode: 'CAARI',
            wni_country: 'CA',
            wni_lat: 45.66,
            wni_lon: -60.88,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'SRM',
            wni_port_name: 'ST. ROMUALD',
            wni_unlocode: 'CASRO',
            wni_country: 'CA',
            wni_lat: 46.75,
            wni_lon: -71.24,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'SSM',
            wni_port_name: 'SAULT STE MARIE',
            wni_unlocode: 'CASSM',
            wni_country: 'CA',
            wni_lat: 46.52,
            wni_lon: -84.35,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'STHPT',
            wni_port_name: 'SOUTHAMPTON',
            wni_unlocode: 'CAOWS',
            wni_country: 'CA',
            wni_lat: 44.5,
            wni_lon: -81.38,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'STL',
            wni_port_name: 'GREAT ST LAWR HARBOR',
            wni_unlocode: 'CAMTN',
            wni_country: 'CA',
            wni_lat: 46.92,
            wni_lon: -55.38,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'STRDS',
            wni_port_name: 'STURDIES BAY',
            wni_unlocode: 'CACRO',
            wni_country: 'CA',
            wni_lat: 48.88,
            wni_lon: -123.32,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'STRMT',
            wni_port_name: 'STORMONT',
            wni_unlocode: 'CACOH',
            wni_country: 'CA',
            wni_lat: 45.22,
            wni_lon: -61.72,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'STVST',
            wni_port_name: 'STEVESTON',
            wni_unlocode: 'CARBC',
            wni_country: 'CA',
            wni_lat: 49.13,
            wni_lon: -123.18,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'TFFN',
            wni_port_name: 'TIFFIN',
            wni_unlocode: 'CAMID',
            wni_country: 'CA',
            wni_lat: 44.75,
            wni_lon: -79.85,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'TGRC',
            wni_port_name: 'TANGIER',
            wni_unlocode: 'CASHH',
            wni_country: 'CA',
            wni_lat: 44.8,
            wni_lon: -62.72,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'THRNB',
            wni_port_name: 'THORNBURY',
            wni_unlocode: 'CACOL',
            wni_country: 'CA',
            wni_lat: 44.57,
            wni_lon: -80.45,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'THRS',
            wni_port_name: 'THURSO',
            wni_unlocode: 'CAALF',
            wni_country: 'CA',
            wni_lat: 45.6,
            wni_lon: -75.23,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'TILTC',
            wni_port_name: 'TILT COVE',
            wni_unlocode: 'CABVE',
            wni_country: 'CA',
            wni_lat: 49.88,
            wni_lon: -55.62,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'TLGRP',
            wni_port_name: 'TELEGRAPH HARBOR',
            wni_unlocode: 'CALAD',
            wni_country: 'CA',
            wni_lat: 48.97,
            wni_lon: -123.67,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'TRNTY',
            wni_port_name: 'TRINITY',
            wni_unlocode: 'CACAT',
            wni_country: 'CA',
            wni_lat: 48.37,
            wni_lon: -53.37,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'TRTON',
            wni_port_name: 'TRENTON',
            wni_unlocode: 'CACLB',
            wni_country: 'CA',
            wni_lat: 44.1,
            wni_lon: -77.57,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'UNION',
            wni_port_name: 'PORT UNION',
            wni_unlocode: 'CACAT',
            wni_country: 'CA',
            wni_lat: 48.5,
            wni_lon: -53.08,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'VBY',
            wni_port_name: "VOISEY'S BAY",
            wni_unlocode: 'CANAI',
            wni_country: 'CA',
            wni_lat: 56.41,
            wni_lon: -62.08,
            wni_tz: 'America/Goose_Bay',
        },
        {
            option: 'VCTRH',
            wni_port_name: 'VICTORIA HARBOUR',
            wni_unlocode: 'CAMID',
            wni_country: 'CA',
            wni_lat: 44.75,
            wni_lon: -79.82,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'VDRL',
            wni_port_name: 'VAUDREUIL',
            wni_unlocode: 'CAVLF',
            wni_country: 'CA',
            wni_lat: 45.4,
            wni_lon: -74.03,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'VICCA',
            wni_port_name: 'VICTORIA HARBOR',
            wni_unlocode: 'CAVIC',
            wni_country: 'CA',
            wni_lat: 48.42,
            wni_lon: -123.4,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'VICTR',
            wni_port_name: 'VICTORIA',
            wni_unlocode: 'CASUM',
            wni_country: 'CA',
            wni_lat: 46.22,
            wni_lon: -63.48,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'WABNA',
            wni_port_name: 'WABANA',
            wni_unlocode: 'CALOP',
            wni_country: 'CA',
            wni_lat: 47.62,
            wni_lon: -52.93,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'WBSHN',
            wni_port_name: 'WAUBAUSHENE',
            wni_unlocode: 'CAMID',
            wni_country: 'CA',
            wni_lat: 44.77,
            wni_lon: -79.72,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'WHITB',
            wni_port_name: 'PORT WHITBY',
            wni_unlocode: 'CAOSH',
            wni_country: 'CA',
            wni_lat: 43.85,
            wni_lon: -78.93,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'WHTHV',
            wni_port_name: 'WHITEHAVEN HARBOR',
            wni_unlocode: 'CACAH',
            wni_country: 'CA',
            wni_lat: 45.23,
            wni_lon: -61.18,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'WHYCC',
            wni_port_name: 'WHYCOCOMAGH',
            wni_unlocode: 'CAION',
            wni_country: 'CA',
            wni_lat: 45.97,
            wni_lon: -61.13,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'WIRTN',
            wni_port_name: 'WIARTON',
            wni_unlocode: 'CAOWS',
            wni_country: 'CA',
            wni_lat: 44.75,
            wni_lon: -81.13,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'WLLC',
            wni_port_name: 'WALLACE',
            wni_unlocode: 'CAPUG',
            wni_country: 'CA',
            wni_lat: 45.82,
            wni_lon: -63.48,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'WLMSC',
            wni_port_name: 'PORT WILLIAMS',
            wni_unlocode: 'CAHPT',
            wni_country: 'CA',
            wni_lat: 45.08,
            wni_lon: -64.42,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'WLPL',
            wni_port_name: 'WALPOLE ISLAND',
            wni_unlocode: 'USALG',
            wni_country: 'CA',
            wni_lat: 42.62,
            wni_lon: -82.52,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'WLTN',
            wni_port_name: 'WALTON',
            wni_unlocode: 'CAHPT',
            wni_country: 'CA',
            wni_lat: 45.23,
            wni_lon: -64,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'WND',
            wni_port_name: 'WINDSOR',
            wni_unlocode: 'CAHPT',
            wni_country: 'CA',
            wni_lat: 45,
            wni_lon: -64.15,
            wni_tz: 'America/Halifax',
        },
        {
            option: 'WOLFE',
            wni_port_name: 'WOLFE ISLAND',
            wni_unlocode: 'CAKIN',
            wni_country: 'CA',
            wni_lat: 44.2,
            wni_lon: -76.43,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'WPOOS',
            wni_port_name: 'WAUPOOS',
            wni_unlocode: 'CAPIC',
            wni_country: 'CA',
            wni_lat: 44,
            wni_lon: -77,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'WPORT',
            wni_port_name: 'WESTPORT COVE',
            wni_unlocode: 'CABVE',
            wni_country: 'CA',
            wni_lat: 49.78,
            wni_lon: -56.62,
            wni_tz: 'America/St_Johns',
        },
        {
            option: 'WSGTN',
            wni_port_name: 'WASHINGTON BAY',
            wni_unlocode: 'USKAE',
            wni_country: 'CA',
            wni_lat: 56.73,
            wni_lon: -134.35,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'WSTVW',
            wni_port_name: 'WESTVIEW',
            wni_unlocode: 'CAPOW',
            wni_country: 'CA',
            wni_lat: 49.83,
            wni_lon: -124.53,
            wni_tz: 'America/Vancouver',
        },
        {
            option: 'ZOTIQ',
            wni_port_name: 'ST ZOTIQUE',
            wni_unlocode: 'CAVLF',
            wni_country: 'CA',
            wni_lat: 45.25,
            wni_lon: -74.25,
            wni_tz: 'America/Toronto',
        },
        {
            option: 'NSLMA',
            wni_port_name: 'NEW SELMA ISLAND',
            wni_unlocode: 'CCCCK',
            wni_country: 'CC',
            wni_lat: -12.12,
            wni_lon: 96.9,
            wni_tz: 'Indian/Cocos',
        },
        {
            option: 'DJE',
            wni_port_name: 'DJENO TERMINAL',
            wni_unlocode: 'CGDJE',
            wni_country: 'CG',
            wni_lat: -4.93,
            wni_lon: 11.9,
            wni_tz: 'Africa/Brazzaville',
        },
        {
            option: 'LOA',
            wni_port_name: 'LOANGO',
            wni_unlocode: 'CGPNR',
            wni_country: 'CG',
            wni_lat: -4.63,
            wni_lon: 11.82,
            wni_tz: 'Africa/Brazzaville',
        },
        {
            option: 'BASSM',
            wni_port_name: 'GRAND BASSAM',
            wni_unlocode: 'CIPBT',
            wni_country: 'CI',
            wni_lat: 5.2,
            wni_lon: -3.73,
            wni_tz: 'Africa/Abidjan',
        },
        {
            option: 'JCQVL',
            wni_port_name: 'JACQUEVILLE',
            wni_unlocode: 'CIBAO',
            wni_country: 'CI',
            wni_lat: 5.2,
            wni_lon: -4.4,
            wni_tz: 'Africa/Abidjan',
        },
        {
            option: 'BORES',
            wni_port_name: 'PUERTO BORIES',
            wni_unlocode: 'CLPNT',
            wni_country: 'CL',
            wni_lat: -51.72,
            wni_lon: -72.57,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'CDA',
            wni_port_name: 'PUERTO CALDERILLA',
            wni_unlocode: 'CLCLD',
            wni_country: 'CL',
            wni_lat: -27.08,
            wni_lon: -70.87,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'CHCAO',
            wni_port_name: 'CHACAO',
            wni_unlocode: 'CLZUD',
            wni_country: 'CL',
            wni_lat: -41.83,
            wni_lon: -73.53,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'CLP',
            wni_port_name: 'CALETTA PATILLOS',
            wni_unlocode: 'CLPPC',
            wni_country: 'CL',
            wni_lat: -20.8,
            wni_lon: -70.2,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'CRMN',
            wni_port_name: 'PUERTO CARMEN',
            wni_unlocode: 'CLQUV',
            wni_country: 'CL',
            wni_lat: -43.15,
            wni_lon: -73.77,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'CRRZL',
            wni_port_name: 'PUERTO CARRIZAL BAJO',
            wni_unlocode: 'CLSBA',
            wni_country: 'CL',
            wni_lat: -28.07,
            wni_lon: -71.17,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'CTR',
            wni_port_name: 'PUERTO CASTRO',
            wni_unlocode: 'CLWCA',
            wni_country: 'CL',
            wni_lat: -42.48,
            wni_lon: -73.77,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'DLCH',
            wni_port_name: 'DALCAHUE',
            wni_unlocode: 'CLWCA',
            wni_country: 'CL',
            wni_lat: -42.38,
            wni_lon: -73.65,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'FRSCA',
            wni_port_name: 'BAHIA AGUA FRESCA',
            wni_unlocode: 'CLPUQ',
            wni_country: 'CL',
            wni_lat: -53.38,
            wni_lon: -70.97,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'JURLS',
            wni_port_name: 'JURELES',
            wni_unlocode: 'CLCNL',
            wni_country: 'CL',
            wni_lat: -37.03,
            wni_lon: -73.16,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'LOS',
            wni_port_name: 'PUERTO LOS VILOS',
            wni_unlocode: 'CLLOS',
            wni_country: 'CL',
            wni_lat: -31.92,
            wni_lon: -71.52,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'MLLN',
            wni_port_name: 'MAULLIN',
            wni_unlocode: 'CLZUD',
            wni_country: 'CL',
            wni_lat: -41.62,
            wni_lon: -73.6,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'PCHCO',
            wni_port_name: 'PUCHOLO',
            wni_unlocode: 'CLCNL',
            wni_country: 'CL',
            wni_lat: -37.03,
            wni_lon: -73.16,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'PPUD',
            wni_port_name: 'PAPUDO',
            wni_unlocode: 'CLQTV',
            wni_country: 'CL',
            wni_lat: -32.5,
            wni_lon: -71.47,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'PTAD',
            wni_port_name: 'PUNTA DELGADA',
            wni_unlocode: 'CLSGR',
            wni_country: 'CL',
            wni_lat: -52.47,
            wni_lon: -69.55,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'QLLN',
            wni_port_name: 'PUERTO QUELLON',
            wni_unlocode: 'CLQUV',
            wni_country: 'CL',
            wni_lat: -43.13,
            wni_lon: -73.63,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'QMCH',
            wni_port_name: 'PUERTO QUEMCHI',
            wni_unlocode: 'CLQMC',
            wni_country: 'CL',
            wni_lat: -42.15,
            wni_lon: -73.48,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'QUELN',
            wni_port_name: 'PUERTO QUEILEN',
            wni_unlocode: 'CLQUV',
            wni_country: 'CL',
            wni_lat: -42.9,
            wni_lon: -73.5,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'SARA',
            wni_port_name: 'PUERTO SARA',
            wni_unlocode: 'CLSGR',
            wni_country: 'CL',
            wni_lat: -52.63,
            wni_lon: -70.2,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'SJC',
            wni_port_name: 'SAN JOSE',
            wni_unlocode: 'CLCBC',
            wni_country: 'CL',
            wni_lat: -41.78,
            wni_lon: -73.19,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'TLTAL',
            wni_port_name: 'PUERTO TALTAL',
            wni_unlocode: 'CLTTC',
            wni_country: 'CL',
            wni_lat: -25.4,
            wni_lon: -70.48,
            wni_tz: 'America/Santiago',
        },
        {
            option: 'BLG',
            wni_port_name: 'BEILUNGANG',
            wni_unlocode: 'CNBEI',
            wni_country: 'CN',
            wni_lat: 29.93,
            wni_lon: 121.85,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'BOH',
            wni_port_name: 'QHD BOHAI SHIJI',
            wni_unlocode: 'CNTGS',
            wni_country: 'CN',
            wni_lat: 39.03,
            wni_lon: 119.25,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'CCHNG',
            wni_port_name: 'CHEN CHIANG',
            wni_unlocode: 'CNZHE',
            wni_country: 'CN',
            wni_lat: 32.22,
            wni_lon: 119.45,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'CGY',
            wni_port_name: 'CHIANG YIN',
            wni_unlocode: 'CNJGY',
            wni_country: 'CN',
            wni_lat: 31.9,
            wni_lon: 120.27,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'CHIEH',
            wni_port_name: 'PEI CHIEH',
            wni_unlocode: 'CNJMN',
            wni_country: 'CN',
            wni_lat: 22.58,
            wni_lon: 113.1,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'CHLNG',
            wni_port_name: 'CHENG LING CHI',
            wni_unlocode: 'CNCLJ',
            wni_country: 'CN',
            wni_lat: 29.4,
            wni_lon: 113.1,
            wni_tz: 'Asia/Chongqing',
        },
        {
            option: 'CHNGQ',
            wni_port_name: 'CHUNG CHING',
            wni_unlocode: 'CNDDK',
            wni_country: 'CN',
            wni_lat: 29.57,
            wni_lon: 106.63,
            wni_tz: 'Asia/Chongqing',
        },
        {
            option: 'CNHGS',
            wni_port_name: 'CHANG SHA',
            wni_unlocode: 'CNCSH',
            wni_country: 'CN',
            wni_lat: 28.2,
            wni_lon: 112.98,
            wni_tz: 'Asia/Chongqing',
        },
        {
            option: 'CNN',
            wni_port_name: 'CANTON',
            wni_unlocode: 'CNGGZ',
            wni_country: 'CN',
            wni_lat: 23.1,
            wni_lon: 113.2,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'FAN',
            wni_port_name: 'FANGCHENG GANG',
            wni_unlocode: 'CNFAN',
            wni_country: 'CN',
            wni_lat: 21.75,
            wni_lon: 108.35,
            wni_tz: 'Asia/Chongqing',
        },
        {
            option: 'GALN',
            wni_port_name: "GAOLAN (Don't use)",
            wni_unlocode: 'CNTHG',
            wni_country: 'CN',
            wni_lat: 21.89,
            wni_lon: 113.23,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'HLG',
            wni_port_name: 'HU LU TAO',
            wni_unlocode: 'CNJNZ',
            wni_country: 'CN',
            wni_lat: 40.72,
            wni_lon: 121,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'HNG1',
            wni_port_name: 'HUANGPUXINGANG',
            wni_unlocode: 'CNXNA',
            wni_country: 'CN',
            wni_lat: 23.05,
            wni_lon: 113.5,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'HNGPX',
            wni_port_name: 'HUANGPUXINGANG',
            wni_unlocode: 'CNXNA',
            wni_country: 'CN',
            wni_lat: 23.05,
            wni_lon: 113.5,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'HSIEN',
            wni_port_name: 'WAN HSIEN',
            wni_unlocode: 'CNWAX',
            wni_country: 'CN',
            wni_lat: 30.82,
            wni_lon: 108.43,
            wni_tz: 'Asia/Chongqing',
        },
        {
            option: 'HSING',
            wni_port_name: 'LO HSING TA MAO TI',
            wni_unlocode: 'CNFZH',
            wni_country: 'CN',
            wni_lat: 25.98,
            wni_lon: 119.47,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'HSN',
            wni_port_name: 'HSINKANG',
            wni_unlocode: 'CNTGU',
            wni_country: 'CN',
            wni_lat: 38.99,
            wni_lon: 117.64,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'HUGG',
            wni_port_name: 'HUANGGANG',
            wni_unlocode: 'CNMWN',
            wni_country: 'CN',
            wni_lat: 22.5,
            wni_lon: 113.88,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'JUR',
            wni_port_name: 'JURONG',
            wni_unlocode: 'CNYIZ',
            wni_country: 'CN',
            wni_lat: 31.94,
            wni_lon: 119.16,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'KNMEN',
            wni_port_name: 'KAN MEN CHIANG',
            wni_unlocode: 'CNYUH',
            wni_country: 'CN',
            wni_lat: 28.08,
            wni_lon: 121.27,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'KUNG',
            wni_port_name: 'KUANG CHI',
            wni_unlocode: 'CNTZE',
            wni_country: 'CN',
            wni_lat: 29.85,
            wni_lon: 115.58,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'KUTOU',
            wni_port_name: 'KU AO TOU',
            wni_unlocode: 'CNWNZ',
            wni_country: 'CN',
            wni_lat: 27.6,
            wni_lon: 120.55,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'LUDA',
            wni_port_name: 'LUDA',
            wni_unlocode: 'CNDLC',
            wni_country: 'CN',
            wni_lat: 38.95,
            wni_lon: 121.68,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'LUSUN',
            wni_port_name: 'LU SHUN',
            wni_unlocode: 'CNLSH',
            wni_country: 'CN',
            wni_lat: 38.8,
            wni_lon: 121.25,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'NANQI',
            wni_port_name: 'NANQIAO',
            wni_unlocode: 'CNCJG',
            wni_country: 'CN',
            wni_lat: 30.93,
            wni_lon: 121.46,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'NIM',
            wni_port_name: 'NING PO',
            wni_unlocode: 'CNNGB',
            wni_country: 'CN',
            wni_lat: 29.88,
            wni_lon: 121.55,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'PNY',
            wni_port_name: 'PAN-YU',
            wni_unlocode: 'CNPNY',
            wni_country: 'CN',
            wni_lat: 22.94,
            wni_lon: 113.35,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'RUIAN',
            wni_port_name: 'JUI AN',
            wni_unlocode: 'CNWNZ',
            wni_country: 'CN',
            wni_lat: 27.78,
            wni_lon: 120.63,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'SHAJ',
            wni_port_name: 'SHAJIAO',
            wni_unlocode: 'CNTAP',
            wni_country: 'CN',
            wni_lat: 22.74,
            wni_lon: 113.68,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'SHENH',
            wni_port_name: 'SHENHU',
            wni_unlocode: 'CNQZJ',
            wni_country: 'CN',
            wni_lat: 24.63,
            wni_lon: 118.67,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'SHHP',
            wni_port_name: 'SHIH PU',
            wni_unlocode: 'CNXSP',
            wni_country: 'CN',
            wni_lat: 29.22,
            wni_lon: 121.95,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'SHIS',
            wni_port_name: 'SHI SHI',
            wni_unlocode: 'CNXYG',
            wni_country: 'CN',
            wni_lat: 25.32,
            wni_lon: 118.56,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'SIU',
            wni_port_name: 'SHIHU',
            wni_unlocode: 'CNQZJ',
            wni_country: 'CN',
            wni_lat: 24.82,
            wni_lon: 118.72,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'SJI',
            wni_port_name: 'SHIJIUSUO',
            wni_unlocode: 'CNRZH',
            wni_country: 'CN',
            wni_lat: 35.37,
            wni_lon: 119.54,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'SNTAO',
            wni_port_name: 'SAN TU AO',
            wni_unlocode: 'CNNDE',
            wni_country: 'CN',
            wni_lat: 26.63,
            wni_lon: 119.67,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'TGHI',
            wni_port_name: 'TING HAI',
            wni_unlocode: 'CNZOS',
            wni_country: 'CN',
            wni_lat: 30.02,
            wni_lon: 122.1,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'TGK',
            wni_port_name: 'DAGU/TANGGU',
            wni_unlocode: 'CNTGU',
            wni_country: 'CN',
            wni_lat: 38.97,
            wni_lon: 117.67,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'TNJNX',
            wni_port_name: 'TIANJINXIN GANG',
            wni_unlocode: 'CNTGU',
            wni_country: 'CN',
            wni_lat: 38.99,
            wni_lon: 117.72,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'WGQ',
            wni_port_name: 'WAI GAO QIAO',
            wni_unlocode: 'CNSGH',
            wni_country: 'CN',
            wni_lat: 31.3,
            wni_lon: 121.5,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'WHP',
            wni_port_name: 'WHAMPOA',
            wni_unlocode: 'CNHUA',
            wni_country: 'CN',
            wni_lat: 23.1,
            wni_lon: 113.43,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'WUHU',
            wni_port_name: 'WU HU',
            wni_unlocode: 'CNWHI',
            wni_country: 'CN',
            wni_lat: 31.33,
            wni_lon: 118.37,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'WUS',
            wni_port_name: 'WUSONG',
            wni_unlocode: 'CNANT',
            wni_country: 'CN',
            wni_lat: 31.41,
            wni_lon: 121.34,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'XUI',
            wni_port_name: 'XIN HUI',
            wni_unlocode: 'CNXIN',
            wni_country: 'CN',
            wni_lat: 22.22,
            wni_lon: 113.08,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'YICHG',
            wni_port_name: 'YICHANG',
            wni_unlocode: 'CNZCG',
            wni_country: 'CN',
            wni_lat: 30.7,
            wni_lon: 111.28,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'YULNH',
            wni_port_name: 'YU LIN CHIANG',
            wni_unlocode: 'CNSYX',
            wni_country: 'CN',
            wni_lat: 18.18,
            wni_lon: 109.52,
            wni_tz: 'Asia/Chongqing',
        },
        {
            option: 'ZHP',
            wni_port_name: 'ZHAPO',
            wni_unlocode: 'CNYJI',
            wni_country: 'CN',
            wni_lat: 21.58,
            wni_lon: 111.83,
            wni_tz: 'Asia/Chongqing',
        },
        {
            option: 'GOL',
            wni_port_name: 'PUERTO GOLFITO',
            wni_unlocode: 'CRGLF',
            wni_country: 'CR',
            wni_lat: 8.63,
            wni_lon: -83.18,
            wni_tz: 'America/Costa_Rica',
        },
        {
            option: 'BOQ',
            wni_port_name: 'BOQUERON',
            wni_unlocode: 'CUGUB',
            wni_country: 'CU',
            wni_lat: 19.98,
            wni_lon: -75.12,
            wni_tz: 'America/Havana',
        },
        {
            option: 'CMPCH',
            wni_port_name: 'CAMPECHUELA',
            wni_unlocode: 'CUCEI',
            wni_country: 'CU',
            wni_lat: 20.23,
            wni_lon: -77.28,
            wni_tz: 'America/Havana',
        },
        {
            option: 'DAIQR',
            wni_port_name: 'BAHIA DAIQUIRI',
            wni_unlocode: 'CUSCU',
            wni_country: 'CU',
            wni_lat: 19.92,
            wni_lon: -75.63,
            wni_tz: 'America/Havana',
        },
        {
            option: 'ENSND',
            wni_port_name: 'ENSENADA SANTA MARIA',
            wni_unlocode: 'CUBOG',
            wni_country: 'CU',
            wni_lat: 21.27,
            wni_lon: -78.52,
            wni_tz: 'America/Havana',
        },
        {
            option: 'FLTN',
            wni_port_name: 'FELTON',
            wni_unlocode: 'CUICR',
            wni_country: 'CU',
            wni_lat: 20.75,
            wni_lon: -75.6,
            wni_tz: 'America/Havana',
        },
        {
            option: 'GIBAR',
            wni_port_name: 'GIBARA',
            wni_unlocode: 'CUVIT',
            wni_country: 'CU',
            wni_lat: 21.12,
            wni_lon: -76.13,
            wni_tz: 'America/Havana',
        },
        {
            option: 'GNTN',
            wni_port_name: 'PUERTO GUANTANAMO',
            wni_unlocode: 'CUGUB',
            wni_country: 'CU',
            wni_lat: 20,
            wni_lon: -75.13,
            wni_tz: 'America/Havana',
        },
        {
            option: 'GURDC',
            wni_port_name: 'PUNTA GORDA',
            wni_unlocode: 'CUMOA',
            wni_country: 'CU',
            wni_lat: 20.63,
            wni_lon: -74.85,
            wni_tz: 'America/Havana',
        },
        {
            option: 'ISBL',
            wni_port_name: 'LA ISABELA',
            wni_unlocode: 'CUIDS',
            wni_country: 'CU',
            wni_lat: 22.95,
            wni_lon: -80,
            wni_tz: 'America/Havana',
        },
        {
            option: 'MEDIA',
            wni_port_name: 'MEDIA LUNA',
            wni_unlocode: 'CUCEI',
            wni_country: 'CU',
            wni_lat: 20.15,
            wni_lon: -77.43,
            wni_tz: 'America/Havana',
        },
        {
            option: 'MNPLA',
            wni_port_name: 'MANOPLA',
            wni_unlocode: 'CUSCS',
            wni_country: 'CU',
            wni_lat: 20.72,
            wni_lon: -77.87,
            wni_tz: 'America/Havana',
        },
        {
            option: 'NQRO',
            wni_port_name: 'NIQUERO',
            wni_unlocode: 'CUCEI',
            wni_country: 'CU',
            wni_lat: 20.05,
            wni_lon: -77.58,
            wni_tz: 'America/Havana',
        },
        {
            option: 'PILON',
            wni_port_name: 'PILON',
            wni_unlocode: 'CUCEI',
            wni_country: 'CU',
            wni_lat: 19.9,
            wni_lon: -77.32,
            wni_tz: 'America/Havana',
        },
        {
            option: 'PTLLO',
            wni_port_name: 'PUERTO PORTILLO',
            wni_unlocode: 'CUCEI',
            wni_country: 'CU',
            wni_lat: 19.9,
            wni_lon: -77.18,
            wni_tz: 'America/Havana',
        },
        {
            option: 'RAMN',
            wni_port_name: 'SAN RAMON',
            wni_unlocode: 'CUCEI',
            wni_country: 'CU',
            wni_lat: 20.22,
            wni_lon: -77.37,
            wni_tz: 'America/Havana',
        },
        {
            option: 'WNIUA',
            wni_port_name: 'DE WNIUA DE TANAMO',
            wni_unlocode: 'CUTAN',
            wni_country: 'CU',
            wni_lat: 20.7,
            wni_lon: -75.32,
            wni_tz: 'America/Bogota',
        },
        {
            option: 'SAMA',
            wni_port_name: 'BAHIA SAMA',
            wni_unlocode: 'CUVIT',
            wni_country: 'CU',
            wni_lat: 21.12,
            wni_lon: -75.77,
            wni_tz: 'America/Havana',
        },
        {
            option: 'VRDO',
            wni_port_name: 'VERADERO',
            wni_unlocode: 'CUCAR',
            wni_country: 'CU',
            wni_lat: 23.12,
            wni_lon: -81.36,
            wni_tz: 'America/Havana',
        },
        {
            option: 'VTA',
            wni_port_name: 'PUERTO VITA',
            wni_unlocode: 'CUVIT',
            wni_country: 'CU',
            wni_lat: 21.08,
            wni_lon: -75.95,
            wni_tz: 'America/Havana',
        },
        {
            option: 'SMV',
            wni_port_name: 'SANTA MARIA',
            wni_unlocode: 'CVSID',
            wni_country: 'CV',
            wni_lat: 16.6,
            wni_lon: -22.91,
            wni_tz: 'Atlantic/Cape_Verde',
        },
        {
            option: 'CRCSB',
            wni_port_name: 'CARACASBAAI',
            wni_unlocode: 'CWCRB',
            wni_country: 'CW',
            wni_lat: 12.07,
            wni_lon: -68.87,
            wni_tz: 'America/Curacao',
        },
        {
            option: 'NEWP',
            wni_port_name: 'NEWPORT',
            wni_unlocode: 'CWCRB',
            wni_country: 'CW',
            wni_lat: 12.08,
            wni_lon: -68.85,
            wni_tz: 'America/Curacao',
        },
        {
            option: 'FLYGF',
            wni_port_name: 'FLYING FISH COVE',
            wni_unlocode: 'CXXCH',
            wni_country: 'CX',
            wni_lat: -10.42,
            wni_lon: 105.7,
            wni_tz: 'Indian/Christmas',
        },
        {
            option: 'ALTO',
            wni_port_name: 'ALTONA',
            wni_unlocode: 'DEHAM',
            wni_country: 'DE',
            wni_lat: 53.55,
            wni_lon: 9.93,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'BBL1',
            wni_port_name: 'BRUNSBUTTELKOOG',
            wni_unlocode: 'DEBRB',
            wni_country: 'DE',
            wni_lat: 53.9,
            wni_lon: 9.15,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'BRGTK',
            wni_port_name: 'BURGSTAAKEN',
            wni_unlocode: 'DEBF3',
            wni_country: 'DE',
            wni_lat: 54.42,
            wni_lon: 11.2,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'ENSWR',
            wni_port_name: 'EINSWARDEN',
            wni_unlocode: 'DENHA',
            wni_country: 'DE',
            wni_lat: 53.52,
            wni_lon: 8.52,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'FARGE',
            wni_port_name: 'FARGE',
            wni_unlocode: 'DEELS',
            wni_country: 'DE',
            wni_lat: 53.2,
            wni_lon: 8.52,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'HAS',
            wni_port_name: 'HANSAPORT',
            wni_unlocode: 'DEHBU',
            wni_country: 'DE',
            wni_lat: 53.51,
            wni_lon: 9.93,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'LTBCH',
            wni_port_name: 'LAUTERBACH',
            wni_unlocode: 'DEMUK',
            wni_country: 'DE',
            wni_lat: 54.33,
            wni_lon: 13.5,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'NRDDC',
            wni_port_name: 'NORDDEICH',
            wni_unlocode: 'NLEEM',
            wni_country: 'DE',
            wni_lat: 53.63,
            wni_lon: 7.17,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'NRDRN',
            wni_port_name: 'NORDERNEY',
            wni_unlocode: 'NLEEM',
            wni_country: 'DE',
            wni_lat: 53.7,
            wni_lon: 7.17,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'TNNNG',
            wni_port_name: 'TONNING',
            wni_unlocode: 'DETOE',
            wni_country: 'DE',
            wni_lat: 54.32,
            wni_lon: 8.95,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'VGSCK',
            wni_port_name: 'VEGESACK',
            wni_unlocode: 'DEELS',
            wni_country: 'DE',
            wni_lat: 53.17,
            wni_lon: 8.62,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'WSR',
            wni_port_name: 'WESERPORT',
            wni_unlocode: 'DEBRV',
            wni_country: 'DE',
            wni_lat: 53.56,
            wni_lon: 8.55,
            wni_tz: 'Europe/Berlin',
        },
        {
            option: 'ABLTF',
            wni_port_name: 'AEBELTOFT HAVN',
            wni_unlocode: 'DKEBT',
            wni_country: 'DK',
            wni_lat: 56.2,
            wni_lon: 10.67,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'ASTBG',
            wni_port_name: 'AUGUSTENBORG',
            wni_unlocode: 'DKSGD',
            wni_country: 'DK',
            wni_lat: 54.95,
            wni_lon: 9.87,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'BGNKP',
            wni_port_name: 'BAGENKOP',
            wni_unlocode: 'DKMRS',
            wni_country: 'DK',
            wni_lat: 54.75,
            wni_lon: 10.67,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'BOGNS',
            wni_port_name: 'BOGENSE',
            wni_unlocode: 'DKFRC',
            wni_country: 'DK',
            wni_lat: 55.57,
            wni_lon: 10.08,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'CRISO',
            wni_port_name: 'CHRISTIANSO',
            wni_unlocode: 'DKSVA',
            wni_country: 'DK',
            wni_lat: 55.32,
            wni_lon: 15.18,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'EGRNS',
            wni_port_name: 'EGERNSUND',
            wni_unlocode: 'DKGRA',
            wni_country: 'DK',
            wni_lat: 54.92,
            wni_lon: 9.6,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'FBRG',
            wni_port_name: 'FABORG',
            wni_unlocode: 'DKFAA',
            wni_country: 'DK',
            wni_lat: 55.1,
            wni_lon: 10.25,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'GLDBG',
            wni_port_name: 'GULDBORG',
            wni_unlocode: 'DKSAX',
            wni_country: 'DK',
            wni_lat: 54.87,
            wni_lon: 11.75,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'GLLLJ',
            wni_port_name: 'GILLELEJE',
            wni_unlocode: 'SEHOG',
            wni_country: 'DK',
            wni_lat: 56.13,
            wni_lon: 12.32,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'HALS',
            wni_port_name: 'HALS HAVN',
            wni_unlocode: 'DKAAL',
            wni_country: 'DK',
            wni_lat: 56.98,
            wni_lon: 10.32,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'HLSTR',
            wni_port_name: 'HOLSTERBO STRUER',
            wni_unlocode: 'DKSTR',
            wni_country: 'DK',
            wni_lat: 56.5,
            wni_lon: 8.6,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'HRTS',
            wni_port_name: 'HIRTSHALS HAVN',
            wni_unlocode: 'DKHIR',
            wni_country: 'DK',
            wni_lat: 57.6,
            wni_lon: 9.97,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'HST',
            wni_port_name: 'HANSTHOLM HAVN',
            wni_unlocode: 'DKHAN',
            wni_country: 'DK',
            wni_lat: 57.13,
            wni_lon: 8.6,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'HVNSO',
            wni_port_name: 'HAVNSO HAVN',
            wni_unlocode: 'DKKAL',
            wni_country: 'DK',
            wni_lat: 55.75,
            wni_lon: 11.33,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'KYNDB',
            wni_port_name: 'KYNDBYVAERKETS HAVN',
            wni_unlocode: 'DKKBY',
            wni_country: 'DK',
            wni_lat: 55.82,
            wni_lon: 11.88,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'NYS',
            wni_port_name: 'NYSTED',
            wni_unlocode: 'DKNYF',
            wni_country: 'DK',
            wni_lat: 54.67,
            wni_lon: 11.73,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'OSBY',
            wni_port_name: 'OSTERBY HAVN',
            wni_unlocode: 'DKFDH',
            wni_country: 'DK',
            wni_lat: 57.32,
            wni_lon: 11.13,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'PRAST',
            wni_port_name: 'PRAESTO',
            wni_unlocode: 'DKFAK',
            wni_country: 'DK',
            wni_lat: 55.13,
            wni_lon: 12.07,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'RNDBJ',
            wni_port_name: 'RENDBJERG',
            wni_unlocode: 'DKGRA',
            wni_country: 'DK',
            wni_lat: 54.9,
            wni_lon: 9.63,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'RODBY',
            wni_port_name: 'RODBY HAVN',
            wni_unlocode: 'DKROD',
            wni_country: 'DK',
            wni_lat: 54.65,
            wni_lon: 11.35,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'RRVG',
            wni_port_name: 'RORVIG HAVN',
            wni_unlocode: 'DKNYS',
            wni_country: 'DK',
            wni_lat: 55.95,
            wni_lon: 11.77,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'RSKLD',
            wni_port_name: 'ROSKILDE',
            wni_unlocode: 'DKFDS',
            wni_country: 'DK',
            wni_lat: 55.65,
            wni_lon: 12.08,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'SAEBY',
            wni_port_name: 'SAEBY',
            wni_unlocode: 'DKFDH',
            wni_country: 'DK',
            wni_lat: 57.33,
            wni_lon: 10.53,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'SKSKB',
            wni_port_name: 'SAKSKOBING',
            wni_unlocode: 'DKSAX',
            wni_country: 'DK',
            wni_lat: 54.8,
            wni_lon: 11.63,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'SPJ',
            wni_port_name: 'SPODSBJERG',
            wni_unlocode: 'DKRKB',
            wni_country: 'DK',
            wni_lat: 54.93,
            wni_lon: 10.83,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'STLVL',
            wni_port_name: 'FRED STAALVALSEVAERKS',
            wni_unlocode: 'DKFDV',
            wni_country: 'DK',
            wni_lat: 55.97,
            wni_lon: 12.02,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'STRIB',
            wni_port_name: 'STRIB HAVN',
            wni_unlocode: 'DKLYO',
            wni_country: 'DK',
            wni_lat: 55.53,
            wni_lon: 9.75,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'TBRG',
            wni_port_name: 'TUBORG HAVN',
            wni_unlocode: 'DKTUB',
            wni_country: 'DK',
            wni_lat: 55.72,
            wni_lon: 12.58,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'TEJN',
            wni_port_name: 'TEJN',
            wni_unlocode: 'DKAGE',
            wni_country: 'DK',
            wni_lat: 55.25,
            wni_lon: 14.83,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'ARL',
            wni_port_name: 'ARROYO BARRIL',
            wni_unlocode: 'DOPUD',
            wni_country: 'DO',
            wni_lat: 19.2,
            wni_lon: -69.45,
            wni_tz: 'America/Santo_Domingo',
        },
        {
            option: 'CDRAS',
            wni_port_name: 'LAS CALDERAS',
            wni_unlocode: 'DOOCO',
            wni_country: 'DO',
            wni_lat: 18.22,
            wni_lon: -70.52,
            wni_tz: 'America/Santo_Domingo',
        },
        {
            option: 'CRSTI',
            wni_port_name: 'MONTE CRISTI',
            wni_unlocode: 'DOMAN',
            wni_country: 'DO',
            wni_lat: 19.87,
            wni_lon: -71.65,
            wni_tz: 'America/Santo_Domingo',
        },
        {
            option: 'PLNQ1',
            wni_port_name: 'PUNTA PALENQUE',
            wni_unlocode: 'DOPAL',
            wni_country: 'DO',
            wni_lat: 18.22,
            wni_lon: -70.17,
            wni_tz: 'America/Santo_Domingo',
        },
        {
            option: 'PLNQP',
            wni_port_name: 'PUNTA PALENQUE',
            wni_unlocode: 'DOPAL',
            wni_country: 'DO',
            wni_lat: 18.22,
            wni_lon: -70.17,
            wni_tz: 'America/Santo_Domingo',
        },
        {
            option: 'SLCD',
            wni_port_name: 'PEPILLO SALCEDO',
            wni_unlocode: 'DOMAN',
            wni_country: 'DO',
            wni_lat: 19.72,
            wni_lon: -71.75,
            wni_tz: 'America/Santo_Domingo',
        },
        {
            option: 'SOSUA',
            wni_port_name: 'SOSUA',
            wni_unlocode: 'DOPOP',
            wni_country: 'DO',
            wni_lat: 19.77,
            wni_lon: -70.52,
            wni_tz: 'America/Santo_Domingo',
        },
        {
            option: 'CHTBI',
            wni_port_name: 'CHETAIBI',
            wni_unlocode: 'DZAAE',
            wni_country: 'DZ',
            wni_lat: 37.07,
            wni_lon: 7.38,
            wni_tz: 'Africa/Algiers',
        },
        {
            option: 'KEBIR',
            wni_port_name: 'MERS EL KEBIR',
            wni_unlocode: 'DZORN',
            wni_country: 'DZ',
            wni_lat: 35.73,
            wni_lon: -0.7,
            wni_tz: 'Africa/Algiers',
        },
        {
            option: 'TIPSA',
            wni_port_name: 'TIPASA',
            wni_unlocode: 'DZCHE',
            wni_country: 'DZ',
            wni_lat: 36.6,
            wni_lon: 2.45,
            wni_tz: 'Africa/Algiers',
        },
        {
            option: 'LORZO',
            wni_port_name: 'PUERTO DE SAN LORENZO',
            wni_unlocode: 'ECSLR',
            wni_country: 'EC',
            wni_lat: 1.27,
            wni_lon: -78.85,
            wni_tz: 'America/Guayaquil',
        },
        {
            option: 'PRTMO',
            wni_port_name: 'PRTMARITIMO',
            wni_unlocode: 'ECGYE',
            wni_country: 'EC',
            wni_lat: -2.28,
            wni_lon: -79.9,
            wni_tz: 'America/Guayaquil',
        },
        {
            option: 'PUNA',
            wni_port_name: 'PUNA',
            wni_unlocode: 'ECPSJ',
            wni_country: 'EC',
            wni_lat: -2.73,
            wni_lon: -79.92,
            wni_tz: 'America/Guayaquil',
        },
        {
            option: 'STE',
            wni_port_name: 'SANTA ELENA',
            wni_unlocode: 'ECLLD',
            wni_country: 'EC',
            wni_lat: -2.2,
            wni_lon: -80.87,
            wni_tz: 'America/Guayaquil',
        },
        {
            option: 'KRSSR',
            wni_port_name: 'KURESSAARE',
            wni_unlocode: 'EEROO',
            wni_country: 'EE',
            wni_lat: 58.22,
            wni_lon: 22.47,
            wni_tz: 'Europe/Tallinn',
        },
        {
            option: 'NVT',
            wni_port_name: 'NOVOTALLINSKIY',
            wni_unlocode: 'EEMUG',
            wni_country: 'EE',
            wni_lat: 59.5,
            wni_lon: 24.96,
            wni_tz: 'Europe/Tallinn',
        },
        {
            option: 'OSMSS',
            wni_port_name: 'OSMUSSAAR',
            wni_unlocode: 'EESVI',
            wni_country: 'EE',
            wni_lat: 59.3,
            wni_lon: 23.37,
            wni_tz: 'Europe/Tallinn',
        },
        {
            option: 'TSTR',
            wni_port_name: 'TSITRI',
            wni_unlocode: 'EEMUG',
            wni_country: 'EE',
            wni_lat: 59.52,
            wni_lon: 25.58,
            wni_tz: 'Europe/Tallinn',
        },
        {
            option: 'ULGS',
            wni_port_name: 'ULGASI',
            wni_unlocode: 'EEMUG',
            wni_country: 'EE',
            wni_lat: 59.5,
            wni_lon: 25.15,
            wni_tz: 'Europe/Tallinn',
        },
        {
            option: 'GHRDQ',
            wni_port_name: 'AL GHURDAQAH',
            wni_unlocode: 'EGHRG',
            wni_country: 'EG',
            wni_lat: 27.22,
            wni_lon: 33.85,
            wni_tz: 'Africa/Cairo',
        },
        {
            option: 'HMREC',
            wni_port_name: 'EL HAMRA OIL TERMINAL',
            wni_unlocode: 'EGMAH',
            wni_country: 'EG',
            wni_lat: 30.98,
            wni_lon: 28.87,
            wni_tz: 'Africa/Cairo',
        },
        {
            option: 'ISMY',
            wni_port_name: 'EL ISMAILIYA',
            wni_unlocode: 'EGISM',
            wni_country: 'EG',
            wni_lat: 30.58,
            wni_lon: 32.28,
            wni_tz: 'Africa/Cairo',
        },
        {
            option: 'KOS',
            wni_port_name: 'AL QUSAYR',
            wni_unlocode: 'EGAQU',
            wni_country: 'EG',
            wni_lat: 26.1,
            wni_lon: 34.28,
            wni_tz: 'Africa/Cairo',
        },
        {
            option: 'PTQ',
            wni_port_name: 'PORT TAUFIQ',
            wni_unlocode: 'EGSUZ',
            wni_country: 'EG',
            wni_lat: 29.94,
            wni_lon: 32.56,
            wni_tz: 'Africa/Cairo',
        },
        {
            option: 'RASD',
            wni_port_name: 'RASHID',
            wni_unlocode: 'EGIKU',
            wni_country: 'EG',
            wni_lat: 31.4,
            wni_lon: 30.42,
            wni_tz: 'Africa/Cairo',
        },
        {
            option: 'AMRG',
            wni_port_name: 'AGUA AMARGA',
            wni_unlocode: 'ESCRS',
            wni_country: 'ES',
            wni_lat: 36.93,
            wni_lon: -1.93,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'ANDRX',
            wni_port_name: 'PUERTO DE ANDRAITX',
            wni_unlocode: 'ESPMI',
            wni_country: 'ES',
            wni_lat: 39.55,
            wni_lon: 2.38,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'ANIO',
            wni_port_name: 'SAN ANTONIO ABAD',
            wni_unlocode: 'ESIBZ',
            wni_country: 'ES',
            wni_lat: 38.98,
            wni_lon: 1.3,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'BLNS',
            wni_port_name: 'BLANES',
            wni_unlocode: 'ESSFU',
            wni_country: 'ES',
            wni_lat: 41.67,
            wni_lon: 2.8,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'BNDRM',
            wni_port_name: 'BENI DORN',
            wni_unlocode: 'ESALC',
            wni_country: 'ES',
            wni_lat: 38.53,
            wni_lon: -0.13,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'BNNZ',
            wni_port_name: 'BONANZA',
            wni_unlocode: 'ESROT',
            wni_country: 'ES',
            wni_lat: 36.8,
            wni_lon: -6.33,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'CDDL',
            wni_port_name: 'CIUDADELA',
            wni_unlocode: 'ESMAH',
            wni_country: 'ES',
            wni_lat: 40,
            wni_lon: 3.82,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'CHIP',
            wni_port_name: 'CHIPIONA',
            wni_unlocode: 'ESROT',
            wni_country: 'ES',
            wni_lat: 36.75,
            wni_lon: -6.43,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'CML',
            wni_port_name: 'CARAMINAL',
            wni_unlocode: 'ESVIL',
            wni_country: 'ES',
            wni_lat: 42.61,
            wni_lon: -8.93,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'CSRIO',
            wni_port_name: 'CASERIO DE PUERTO',
            wni_unlocode: 'ESALD',
            wni_country: 'ES',
            wni_lat: 39.83,
            wni_lon: 3.13,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'ENSVD',
            wni_port_name: 'ENSEIVADA DE ALDAN',
            wni_unlocode: 'ESVGO',
            wni_country: 'ES',
            wni_lat: 42.3,
            wni_lon: -8.83,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'ESTPN',
            wni_port_name: 'ESTEPONA',
            wni_unlocode: 'ESSRQ',
            wni_country: 'ES',
            wni_lat: 36.42,
            wni_lon: -5.13,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'FNGRL',
            wni_port_name: 'FUENGIROLA',
            wni_unlocode: 'EWNIP',
            wni_country: 'ES',
            wni_lat: 36.53,
            wni_lon: -4.62,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'FNS',
            wni_port_name: 'FINISTERRE',
            wni_unlocode: 'ESCCN',
            wni_country: 'ES',
            wni_lat: 42.91,
            wni_lon: -9.26,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'GRAO',
            wni_port_name: 'EL GRAO',
            wni_unlocode: 'ESCAS',
            wni_country: 'ES',
            wni_lat: 39.97,
            wni_lon: 0.03,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'GTRIA',
            wni_port_name: 'GUETARIA',
            wni_unlocode: 'ESEAS',
            wni_country: 'ES',
            wni_lat: 43.32,
            wni_lon: -2.2,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'HRNLL',
            wni_port_name: 'HORNILLO',
            wni_unlocode: 'EWNIU',
            wni_country: 'ES',
            wni_lat: 37.4,
            wni_lon: -1.55,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'LQT',
            wni_port_name: 'LEQUEITIO',
            wni_unlocode: 'ESBRM',
            wni_country: 'ES',
            wni_lat: 43.37,
            wni_lon: -2.5,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'MBL',
            wni_port_name: 'MARBELLA',
            wni_unlocode: 'ESSRQ',
            wni_country: 'ES',
            wni_lat: 36.5,
            wni_lon: -4.88,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'MYRNA',
            wni_port_name: 'MYRINA',
            wni_unlocode: 'GRMYR',
            wni_country: 'ES',
            wni_lat: 39.87,
            wni_lon: 25.06,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'ONDRR',
            wni_port_name: 'ONDARROA',
            wni_unlocode: 'ESBRM',
            wni_country: 'ES',
            wni_lat: 43.33,
            wni_lon: -2.43,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'PLLNS',
            wni_port_name: 'POLLENSA',
            wni_unlocode: 'ESALD',
            wni_country: 'ES',
            wni_lat: 39.9,
            wni_lon: 3.08,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'RIB',
            wni_port_name: 'RIBEIRA',
            wni_unlocode: 'ESVIL',
            wni_country: 'ES',
            wni_lat: 42.56,
            wni_lon: -8.99,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'SALOU',
            wni_port_name: 'SALOU',
            wni_unlocode: 'ESTAR',
            wni_country: 'ES',
            wni_lat: 41.05,
            wni_lon: 1.13,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'SANT',
            wni_port_name: 'SANTONA',
            wni_unlocode: 'ESSDR',
            wni_country: 'ES',
            wni_lat: 43.43,
            wni_lon: -3.45,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'SCS',
            wni_port_name: 'SAN CARLOS DELA RAPITA',
            wni_unlocode: 'ESSCR',
            wni_country: 'ES',
            wni_lat: 40.62,
            wni_lon: 0.6,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'SDP',
            wni_port_name: 'SAN PEDRO DEL PINATAR',
            wni_unlocode: 'ESTOR',
            wni_country: 'ES',
            wni_lat: 37.82,
            wni_lon: -0.75,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'SEV',
            wni_port_name: 'SEVILLA',
            wni_unlocode: 'ESSVQ',
            wni_country: 'ES',
            wni_lat: 37.38,
            wni_lon: -6,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'SLLR',
            wni_port_name: 'PUERTO DE SOLLER',
            wni_unlocode: 'ESPMI',
            wni_country: 'ES',
            wni_lat: 39.8,
            wni_lon: 2.68,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'TRF',
            wni_port_name: 'TARIFA',
            wni_unlocode: 'MAPTM',
            wni_country: 'ES',
            wni_lat: 36.02,
            wni_lon: -5.6,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'URDLS',
            wni_port_name: 'CASTRO URDIALES',
            wni_unlocode: 'ESBIO',
            wni_country: 'ES',
            wni_lat: 43.38,
            wni_lon: -3.22,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'VNRZ',
            wni_port_name: 'VINAROZ',
            wni_unlocode: 'ESACA',
            wni_country: 'ES',
            wni_lat: 40.47,
            wni_lon: 0.48,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'ZMY',
            wni_port_name: 'ZUMAYA',
            wni_unlocode: 'ESEAS',
            wni_country: 'ES',
            wni_lat: 43.3,
            wni_lon: -2.25,
            wni_tz: 'Europe/Madrid',
        },
        {
            option: 'ATTU',
            wni_port_name: 'ATTU',
            wni_unlocode: 'FIPAR',
            wni_country: 'FI',
            wni_lat: 60.18,
            wni_lon: 22.35,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'BMRSN',
            wni_port_name: 'BOMARSUND',
            wni_unlocode: 'FIMHQ',
            wni_country: 'FI',
            wni_lat: 60.22,
            wni_lon: 20.25,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'DGRBY',
            wni_port_name: 'DEGERBY',
            wni_unlocode: 'FIMHQ',
            wni_country: 'FI',
            wni_lat: 60.03,
            wni_lon: 20.38,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'DLSBR',
            wni_port_name: 'DALSBRUK',
            wni_unlocode: 'FIDLS',
            wni_country: 'FI',
            wni_lat: 60.02,
            wni_lon: 22.5,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'FORBY',
            wni_port_name: 'FORBY',
            wni_unlocode: 'FIDLS',
            wni_country: 'FI',
            wni_lat: 60.08,
            wni_lon: 22.87,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'HAVER',
            wni_port_name: 'HAVERO',
            wni_unlocode: 'FIPAR',
            wni_country: 'FI',
            wni_lat: 60.25,
            wni_lon: 22.07,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'HLLNS',
            wni_port_name: 'HELLNAS',
            wni_unlocode: 'FIVAA',
            wni_country: 'FI',
            wni_lat: 63.28,
            wni_lon: 22.23,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'HMNKA',
            wni_port_name: 'HIMANKA',
            wni_unlocode: 'FIRAH',
            wni_country: 'FI',
            wni_lat: 64.08,
            wni_lon: 23.58,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'JACO',
            wni_port_name: 'JACOBSTAD',
            wni_unlocode: 'FIPRS',
            wni_country: 'FI',
            wni_lat: 63.69,
            wni_lon: 22.69,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'JNGFR',
            wni_port_name: 'JUNGFRUSUND',
            wni_unlocode: 'FIDLS',
            wni_country: 'FI',
            wni_lat: 59.97,
            wni_lon: 22.38,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'JUSSR',
            wni_port_name: 'JUSSARO',
            wni_unlocode: 'FITAI',
            wni_country: 'FI',
            wni_lat: 59.83,
            wni_lon: 23.57,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'KNSSR',
            wni_port_name: 'KAUNISSAARI',
            wni_unlocode: 'FIOLK',
            wni_country: 'FI',
            wni_lat: 61.25,
            wni_lon: 21.53,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'KNTLX',
            wni_port_name: 'KANTLAX',
            wni_unlocode: 'FIPRS',
            wni_country: 'FI',
            wni_lat: 63.42,
            wni_lon: 22.3,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'KVLT',
            wni_port_name: 'KOIVULUOTO',
            wni_unlocode: 'FIVEI',
            wni_country: 'FI',
            wni_lat: 65.63,
            wni_lon: 24.83,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'MRTNN',
            wni_port_name: 'MARTINNIEMI',
            wni_unlocode: 'FIHAU',
            wni_country: 'FI',
            wni_lat: 65.22,
            wni_lon: 25.28,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'NYKRL',
            wni_port_name: 'NYKARLEBY',
            wni_unlocode: 'FIPRS',
            wni_country: 'FI',
            wni_lat: 63.52,
            wni_lon: 22.53,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'SGNLD',
            wni_port_name: 'SIGNILDSKAR',
            wni_unlocode: 'FIMHQ',
            wni_country: 'FI',
            wni_lat: 60.2,
            wni_lon: 19.33,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'SKNNR',
            wni_port_name: 'SKINNARVIK',
            wni_unlocode: 'FIDLS',
            wni_country: 'FI',
            wni_lat: 60.13,
            wni_lon: 22.48,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'STRBY',
            wni_port_name: 'STORBY',
            wni_unlocode: 'FIMHQ',
            wni_country: 'FI',
            wni_lat: 60.22,
            wni_lon: 19.53,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'TORON',
            wni_port_name: 'TORON',
            wni_unlocode: 'FIMHQ',
            wni_country: 'FI',
            wni_lat: 60.17,
            wni_lon: 19.62,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'YXP',
            wni_port_name: 'YKSPIHLAJA',
            wni_unlocode: 'FIKOK',
            wni_country: 'FI',
            wni_lat: 63.85,
            wni_lon: 23.02,
            wni_tz: 'Europe/Helsinki',
        },
        {
            option: 'SAVU',
            wni_port_name: 'SAVUSAVU',
            wni_unlocode: 'FJSVU',
            wni_country: 'FJ',
            wni_lat: -16.77,
            wni_lon: 179.32,
            wni_tz: 'Pacific/Fiji',
        },
        {
            option: 'PTW',
            wni_port_name: 'PORT WILLIAM',
            wni_unlocode: 'FKPSY',
            wni_country: 'FK',
            wni_lat: -51.67,
            wni_lon: -57.78,
            wni_tz: 'Atlantic/Stanley',
        },
        {
            option: 'CLNIA',
            wni_port_name: 'COLONIA',
            wni_unlocode: 'FMYAP',
            wni_country: 'FM',
            wni_lat: 9.52,
            wni_lon: 138.13,
            wni_tz: 'Pacific/Chuuk',
        },
        {
            option: 'LELE',
            wni_port_name: 'LELE',
            wni_unlocode: 'FMKSR',
            wni_country: 'FM',
            wni_lat: 5.33,
            wni_lon: 163.03,
            wni_tz: 'Pacific/Kosrae',
        },
        {
            option: 'LTTIN',
            wni_port_name: 'PORT LOTTIN',
            wni_unlocode: 'FMKSR',
            wni_country: 'FM',
            wni_lat: 5.28,
            wni_lon: 162.97,
            wni_tz: 'Pacific/Kosrae',
        },
        {
            option: 'MLKAL',
            wni_port_name: 'MALAKAL',
            wni_unlocode: 'PWROR',
            wni_country: 'FM',
            wni_lat: 7.33,
            wni_lon: 134.47,
            wni_tz: 'Pacific/Chuuk',
        },
        {
            option: 'FGLFJ',
            wni_port_name: 'FUGLAFJORDHUR',
            wni_unlocode: 'FOFUG',
            wni_country: 'FO',
            wni_lat: 62.25,
            wni_lon: -6.8,
            wni_tz: 'Atlantic/Faroe',
        },
        {
            option: 'KONGH',
            wni_port_name: 'KONGSHAVN',
            wni_unlocode: 'FORVK',
            wni_country: 'FO',
            wni_lat: 62.12,
            wni_lon: -6.73,
            wni_tz: 'Atlantic/Faroe',
        },
        {
            option: 'MANNA',
            wni_port_name: 'VEST MANNA',
            wni_unlocode: 'FOVES',
            wni_country: 'FO',
            wni_lat: 62.15,
            wni_lon: -7.17,
            wni_tz: 'Atlantic/Faroe',
        },
        {
            option: 'SRVG',
            wni_port_name: 'SORVAGUR',
            wni_unlocode: 'FOSRV',
            wni_country: 'FO',
            wni_lat: 62.07,
            wni_lon: -7.3,
            wni_tz: 'Atlantic/Faroe',
        },
        {
            option: 'AGAY',
            wni_port_name: 'AGAY',
            wni_unlocode: 'FRCEQ',
            wni_country: 'FR',
            wni_lat: 43.43,
            wni_lon: 6.87,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'AGDE',
            wni_port_name: 'AGDE',
            wni_unlocode: 'FRSET',
            wni_country: 'FR',
            wni_lat: 43.23,
            wni_lon: 3.47,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'APRN',
            wni_port_name: 'AUPIERNE',
            wni_unlocode: 'FRCAM',
            wni_country: 'FR',
            wni_lat: 48.02,
            wni_lon: -4.53,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'BANDL',
            wni_port_name: 'BANDOL',
            wni_unlocode: 'FRLCT',
            wni_country: 'FR',
            wni_lat: 43.13,
            wni_lon: 5.75,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'BERG',
            wni_port_name: 'BERGUES',
            wni_unlocode: 'FRDKK',
            wni_country: 'FR',
            wni_lat: 50.97,
            wni_lon: 2.43,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'BERNR',
            wni_port_name: 'ROCHE BERNARD',
            wni_unlocode: 'FRMTX',
            wni_country: 'FR',
            wni_lat: 47.52,
            wni_lon: -2.3,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'BFL',
            wni_port_name: 'BARFLEUR',
            wni_unlocode: 'FRURD',
            wni_country: 'FR',
            wni_lat: 49.67,
            wni_lon: -1.27,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'BINIC',
            wni_port_name: 'BINIC',
            wni_unlocode: 'FRSBK',
            wni_country: 'FR',
            wni_lat: 48.6,
            wni_lon: -2.82,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'BNDT',
            wni_port_name: 'BENODET',
            wni_unlocode: 'FRLOC',
            wni_country: 'FR',
            wni_lat: 47.88,
            wni_lon: -4.12,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'CHRNT',
            wni_port_name: 'TONNAY CHARENTE',
            wni_unlocode: 'FRTON',
            wni_country: 'FR',
            wni_lat: 45.93,
            wni_lon: -0.9,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'CHTEU',
            wni_port_name: 'LE CHATEAU',
            wni_unlocode: 'FRRCO',
            wni_country: 'FR',
            wni_lat: 45.88,
            wni_lon: -1.18,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'CNBRS',
            wni_port_name: 'ANSE DES CANEBIERS',
            wni_unlocode: 'FRSTP',
            wni_country: 'FR',
            wni_lat: 43.27,
            wni_lon: 6.67,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'CPBRT',
            wni_port_name: 'CAPBRETON',
            wni_unlocode: 'FRBAY',
            wni_country: 'FR',
            wni_lat: 43.65,
            wni_lon: -1.42,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'CRENT',
            wni_port_name: 'CARENTAN',
            wni_unlocode: 'FRURD',
            wni_country: 'FR',
            wni_lat: 49.3,
            wni_lon: -1.23,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'CRSIC',
            wni_port_name: 'LE CROISIC',
            wni_unlocode: 'FRSNR',
            wni_country: 'FR',
            wni_lat: 47.3,
            wni_lon: -2.52,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'CRSLL',
            wni_port_name: 'COURSEULLES SUR MER',
            wni_unlocode: 'FROUI',
            wni_country: 'FR',
            wni_lat: 49.33,
            wni_lon: -0.47,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'CSSS',
            wni_port_name: 'CASSIS',
            wni_unlocode: 'FRLCT',
            wni_country: 'FR',
            wni_lat: 43.22,
            wni_lon: 5.53,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'CTNR',
            wni_port_name: 'LA COTINIERE',
            wni_unlocode: 'FRLPE',
            wni_country: 'FR',
            wni_lat: 45.92,
            wni_lon: -1.33,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'DNN',
            wni_port_name: 'DOUARNENEZ',
            wni_unlocode: 'FRUIP',
            wni_country: 'FR',
            wni_lat: 48.1,
            wni_lon: -4.32,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'DVLL',
            wni_port_name: 'TROUVILLE DEAUVILLE',
            wni_unlocode: 'FRDOL',
            wni_country: 'FR',
            wni_lat: 49.37,
            wni_lon: 0.08,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'EMB',
            wni_port_name: 'PORT EN BESSIN',
            wni_unlocode: 'FRCFR',
            wni_country: 'FR',
            wni_lat: 49.35,
            wni_lon: -0.75,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'GOLFE',
            wni_port_name: 'GOLFE JUAN',
            wni_unlocode: 'FRCEQ',
            wni_country: 'FR',
            wni_lat: 43.57,
            wni_lon: 7.05,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'GRAU',
            wni_port_name: 'LE GRAU DU ROI',
            wni_unlocode: 'FRFRO',
            wni_country: 'FR',
            wni_lat: 43.53,
            wni_lon: 4.13,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'HRBDR',
            wni_port_name: 'L HERBAUDIERE',
            wni_unlocode: 'FRSNR',
            wni_country: 'FR',
            wni_lat: 47.02,
            wni_lon: -2.3,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'ISGNY',
            wni_port_name: 'ISIGNY',
            wni_unlocode: 'FRURD',
            wni_country: 'FR',
            wni_lat: 49.32,
            wni_lon: -1.1,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'JEAN',
            wni_port_name: 'ST JEAN DE LUZ',
            wni_unlocode: 'FRBIQ',
            wni_country: 'FR',
            wni_lat: 43.4,
            wni_lon: -1.67,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'JNVLL',
            wni_port_name: 'PORT JOINVILLE',
            wni_unlocode: 'FRLSO',
            wni_country: 'FR',
            wni_lat: 46.73,
            wni_lon: -2.35,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'LANO',
            wni_port_name: 'PORT LA NOUVELLE',
            wni_unlocode: 'FRNOU',
            wni_country: 'FR',
            wni_lat: 43.02,
            wni_lon: 3.07,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'LCQRC',
            wni_port_name: 'LOCQUIREC',
            wni_unlocode: 'FRMXN',
            wni_country: 'FR',
            wni_lat: 48.7,
            wni_lon: -3.65,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'LLRS',
            wni_port_name: 'LILE ROUSSE',
            wni_unlocode: 'FRILR',
            wni_country: 'FR',
            wni_lat: 42.63,
            wni_lon: 8.93,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'LNNN',
            wni_port_name: 'LANNION',
            wni_unlocode: 'FRTRE',
            wni_country: 'FR',
            wni_lat: 48.73,
            wni_lon: -3.47,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'LZRDR',
            wni_port_name: 'LEZARDRIEUX',
            wni_unlocode: 'FRPAI',
            wni_country: 'FR',
            wni_lat: 48.78,
            wni_lon: -3.1,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'MCNGG',
            wni_port_name: 'MACINAGGIO',
            wni_unlocode: 'FRBIA',
            wni_country: 'FR',
            wni_lat: 42.97,
            wni_lon: 9.47,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'MNTON',
            wni_port_name: 'MENTON',
            wni_unlocode: 'MCMON',
            wni_country: 'FR',
            wni_lat: 43.78,
            wni_lon: 7.52,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'MRAF',
            wni_port_name: 'PORT MARIA',
            wni_unlocode: 'FRVNE',
            wni_country: 'FR',
            wni_lat: 47.48,
            wni_lon: -3.13,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'MRTNF',
            wni_port_name: 'ST MARTIN',
            wni_unlocode: 'FRLPE',
            wni_country: 'FR',
            wni_lat: 46.2,
            wni_lon: -1.37,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'MXM',
            wni_port_name: 'STE MAXIME',
            wni_unlocode: 'FRSTP',
            wni_country: 'FR',
            wni_lat: 43.32,
            wni_lon: 6.67,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'NAVLO',
            wni_port_name: 'PORT NAVALO',
            wni_unlocode: 'FRVNE',
            wni_country: 'FR',
            wni_lat: 47.55,
            wni_lon: -2.92,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'NRMTR',
            wni_port_name: 'NOIRMOUTIER',
            wni_unlocode: 'FRSNR',
            wni_country: 'FR',
            wni_lat: 47,
            wni_lon: -2.25,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'OLNN',
            wni_port_name: 'LES SABLES DOLONNE',
            wni_unlocode: 'FRLSO',
            wni_country: 'FR',
            wni_lat: 46.5,
            wni_lon: -1.8,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'OUSS',
            wni_port_name: 'USHANT',
            wni_unlocode: 'FRRHP',
            wni_country: 'FR',
            wni_lat: 48.46,
            wni_lon: -5.09,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'PALAS',
            wni_port_name: 'LE PALAIS',
            wni_unlocode: 'FRVNE',
            wni_country: 'FR',
            wni_lat: 47.35,
            wni_lon: -3.15,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'PNTRX',
            wni_port_name: 'PONTRIEUX',
            wni_unlocode: 'FRTRE',
            wni_country: 'FR',
            wni_lat: 48.7,
            wni_lon: -3.15,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'PONIC',
            wni_port_name: 'PORNIC',
            wni_unlocode: 'FRSNR',
            wni_country: 'FR',
            wni_lat: 47.12,
            wni_lon: -2.1,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'PRTRX',
            wni_port_name: 'PORTRIEUX ST QUAY',
            wni_unlocode: 'FRSBK',
            wni_country: 'FR',
            wni_lat: 48.65,
            wni_lon: -2.83,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'PTHAU',
            wni_port_name: 'PORT POTHUAU',
            wni_unlocode: 'FRLCZ',
            wni_country: 'FR',
            wni_lat: 43.12,
            wni_lon: 6.2,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'QES',
            wni_port_name: 'OUESSANT',
            wni_unlocode: 'FRRHP',
            wni_country: 'FR',
            wni_lat: 48.45,
            wni_lon: -5.1,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'RPHL',
            wni_port_name: 'ST RAPHAEL',
            wni_unlocode: 'FRSTP',
            wni_country: 'FR',
            wni_lat: 43.42,
            wni_lon: 6.75,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'SLD',
            wni_port_name: 'PORT SAINT LOUIS',
            wni_unlocode: 'FRPSL',
            wni_country: 'FR',
            wni_lat: 43.38,
            wni_lon: 4.82,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'VLRY',
            wni_port_name: 'ST VALERY EN CAUX',
            wni_unlocode: 'FRDPE',
            wni_country: 'FR',
            wni_lat: 49.87,
            wni_lon: 0.72,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'VLRYS',
            wni_port_name: 'ST VALERY SUR SOMME',
            wni_unlocode: 'FRSVS',
            wni_country: 'FR',
            wni_lat: 50.18,
            wni_lon: 1.62,
            wni_tz: 'Europe/Paris',
        },
        {
            option: 'LUCNA',
            wni_port_name: 'LUCINA OIL TERMINAL',
            wni_unlocode: 'GALUC',
            wni_country: 'GA',
            wni_lat: -3.63,
            wni_lon: 10.75,
            wni_tz: 'Africa/Libreville',
        },
        {
            option: 'MYB',
            wni_port_name: 'MAYUMBA',
            wni_unlocode: 'GALUC',
            wni_country: 'GA',
            wni_lat: -3.42,
            wni_lon: 10.64,
            wni_tz: 'Africa/Libreville',
        },
        {
            option: 'OLOWI',
            wni_port_name: 'OLOWI',
            wni_unlocode: 'GANYA',
            wni_country: 'GA',
            wni_lat: -3.13,
            wni_lon: 10.19,
            wni_tz: 'Africa/Libreville',
        },
        {
            option: 'ABRYS',
            wni_port_name: 'ABERYSSTWYTH',
            wni_unlocode: 'GBABV',
            wni_country: 'GB',
            wni_lat: 52.42,
            wni_lon: -4.08,
            wni_tz: 'Europe/London',
        },
        {
            option: 'ALINE',
            wni_port_name: 'LOCH ALINE',
            wni_unlocode: 'GBLOL',
            wni_country: 'GB',
            wni_lat: 56.53,
            wni_lon: -5.77,
            wni_tz: 'Europe/London',
        },
        {
            option: 'AMLWC',
            wni_port_name: 'AMLWCH',
            wni_unlocode: 'GBHLY',
            wni_country: 'GB',
            wni_lat: 53.42,
            wni_lon: -4.33,
            wni_tz: 'Europe/London',
        },
        {
            option: 'ANDRW',
            wni_port_name: 'ST ANDREWS',
            wni_unlocode: 'GBDUN',
            wni_country: 'GB',
            wni_lat: 56.32,
            wni_lon: -2.8,
            wni_tz: 'Europe/London',
        },
        {
            option: 'ANSTR',
            wni_port_name: 'ANSTRUTHER EASTER',
            wni_unlocode: 'GBMTH',
            wni_country: 'GB',
            wni_lat: 56.22,
            wni_lon: -2.7,
            wni_tz: 'Europe/London',
        },
        {
            option: 'APPIN',
            wni_port_name: 'PORT APPIN',
            wni_unlocode: 'GBGSA',
            wni_country: 'GB',
            wni_lat: 56.55,
            wni_lon: -5.4,
            wni_tz: 'Europe/London',
        },
        {
            option: 'ARDE',
            wni_port_name: 'ARDERSIER',
            wni_unlocode: 'GBIVG',
            wni_country: 'GB',
            wni_lat: 57.57,
            wni_lon: -4.04,
            wni_tz: 'Europe/London',
        },
        {
            option: 'BANFF',
            wni_port_name: 'BANFF HARBOR',
            wni_unlocode: 'GBBFF',
            wni_country: 'GB',
            wni_lat: 57.67,
            wni_lon: -2.53,
            wni_tz: 'Europe/London',
        },
        {
            option: 'BCKI',
            wni_port_name: 'BUCKIE HARBOR',
            wni_unlocode: 'GBBUC',
            wni_country: 'GB',
            wni_lat: 57.68,
            wni_lon: -2.97,
            wni_tz: 'Europe/London',
        },
        {
            option: 'BFOOT',
            wni_port_name: 'BRAEFOOT BAY TERMINAL',
            wni_unlocode: 'GBBFB',
            wni_country: 'GB',
            wni_lat: 56.03,
            wni_lon: -3.32,
            wni_tz: 'Europe/London',
        },
        {
            option: 'BMRS',
            wni_port_name: 'BEAUMARIS',
            wni_unlocode: 'GBPPE',
            wni_country: 'GB',
            wni_lat: 53.27,
            wni_lon: -4.08,
            wni_tz: 'Europe/London',
        },
        {
            option: 'BRFRD',
            wni_port_name: 'BROADFORD BAY',
            wni_unlocode: 'GBKYL',
            wni_country: 'GB',
            wni_lat: 57.25,
            wni_lon: -5.9,
            wni_tz: 'Europe/London',
        },
        {
            option: 'BTL',
            wni_port_name: 'BUTT OF LEWIS',
            wni_unlocode: 'GBSTO',
            wni_country: 'GB',
            wni_lat: 58.52,
            wni_lon: -6.26,
            wni_tz: 'Europe/London',
        },
        {
            option: 'BURHM',
            wni_port_name: 'BURNHAM ON SEA',
            wni_unlocode: 'GBBRW',
            wni_country: 'GB',
            wni_lat: 51.23,
            wni_lon: -3,
            wni_tz: 'Europe/London',
        },
        {
            option: 'BWO',
            wni_port_name: 'BARROW IN FURNESS',
            wni_unlocode: 'GBBIF',
            wni_country: 'GB',
            wni_lat: 54.12,
            wni_lon: -3.23,
            wni_tz: 'Europe/London',
        },
        {
            option: 'CHALS',
            wni_port_name: 'CHARLESTOWN HARBOR',
            wni_unlocode: 'GBCHF',
            wni_country: 'GB',
            wni_lat: 50.33,
            wni_lon: -4.75,
            wni_tz: 'Europe/London',
        },
        {
            option: 'CHARS',
            wni_port_name: 'CHARLESTOWN',
            wni_unlocode: 'GBROY',
            wni_country: 'GB',
            wni_lat: 56.03,
            wni_lon: -3.5,
            wni_tz: 'Europe/London',
        },
        {
            option: 'CLVLL',
            wni_port_name: 'CLOVELLY',
            wni_unlocode: 'GBBID',
            wni_country: 'GB',
            wni_lat: 51,
            wni_lon: -4.4,
            wni_tz: 'Europe/London',
        },
        {
            option: 'COW',
            wni_port_name: 'COWES HARBOR',
            wni_unlocode: 'GBCOW',
            wni_country: 'GB',
            wni_lat: 50.77,
            wni_lon: -1.3,
            wni_tz: 'Europe/London',
        },
        {
            option: 'CRAIL',
            wni_port_name: 'CRAIL',
            wni_unlocode: 'GBMTH',
            wni_country: 'GB',
            wni_lat: 56.25,
            wni_lon: -2.63,
            wni_tz: 'Europe/London',
        },
        {
            option: 'CRGNR',
            wni_port_name: 'CRAIGNURE',
            wni_unlocode: 'GBLOL',
            wni_country: 'GB',
            wni_lat: 56.47,
            wni_lon: -5.7,
            wni_tz: 'Europe/London',
        },
        {
            option: 'CRINN',
            wni_port_name: 'CRINAN',
            wni_unlocode: 'GBASG',
            wni_country: 'GB',
            wni_lat: 56.08,
            wni_lon: -5.57,
            wni_tz: 'Europe/London',
        },
        {
            option: 'CRNRF',
            wni_port_name: 'CAERNARVON',
            wni_unlocode: 'GBCNV',
            wni_country: 'GB',
            wni_lat: 53.15,
            wni_lon: -4.27,
            wni_tz: 'Europe/London',
        },
        {
            option: 'CRYAN',
            wni_port_name: 'CAIRN RYAN',
            wni_unlocode: 'GBCYN',
            wni_country: 'GB',
            wni_lat: 54.97,
            wni_lon: -5.02,
            wni_tz: 'Europe/London',
        },
        {
            option: 'CVRCK',
            wni_port_name: 'COVERACK',
            wni_unlocode: 'GBFAL',
            wni_country: 'GB',
            wni_lat: 50.02,
            wni_lon: -5.1,
            wni_tz: 'Europe/London',
        },
        {
            option: 'DNRWC',
            wni_port_name: 'PORT DINORWIC',
            wni_unlocode: 'GBCNV',
            wni_country: 'GB',
            wni_lat: 53.18,
            wni_lon: -4.2,
            wni_tz: 'Europe/London',
        },
        {
            option: 'DNVGN',
            wni_port_name: 'DUNVEGAN',
            wni_unlocode: 'GBIRS',
            wni_country: 'GB',
            wni_lat: 57.43,
            wni_lon: -6.58,
            wni_tz: 'Europe/London',
        },
        {
            option: 'DVDS',
            wni_port_name: 'ST DAVIDS',
            wni_unlocode: 'GBINK',
            wni_country: 'GB',
            wni_lat: 56.03,
            wni_lon: -3.37,
            wni_tz: 'Europe/London',
        },
        {
            option: 'DYSAR',
            wni_port_name: 'DYSART',
            wni_unlocode: 'GBKKD',
            wni_country: 'GB',
            wni_lat: 56.12,
            wni_lon: -3.12,
            wni_tz: 'Europe/London',
        },
        {
            option: 'EDGAR',
            wni_port_name: 'PORT EDGAR',
            wni_unlocode: 'GBROY',
            wni_country: 'GB',
            wni_lat: 56,
            wni_lon: -3.42,
            wni_tz: 'Europe/London',
        },
        {
            option: 'ELIE',
            wni_port_name: 'ELIE',
            wni_unlocode: 'GBMTH',
            wni_country: 'GB',
            wni_lat: 56.18,
            wni_lon: -2.82,
            wni_tz: 'Europe/London',
        },
        {
            option: 'EVN',
            wni_port_name: 'EVANTON',
            wni_unlocode: 'GBIVG',
            wni_country: 'GB',
            wni_lat: 57.66,
            wni_lon: -4.34,
            wni_tz: 'Europe/London',
        },
        {
            option: 'EXMTH',
            wni_port_name: 'EXMOUTH HARBOR',
            wni_unlocode: 'GBTNM',
            wni_country: 'GB',
            wni_lat: 50.62,
            wni_lon: -3.42,
            wni_tz: 'Europe/London',
        },
        {
            option: 'EYMTH',
            wni_port_name: 'EYEMOUTH',
            wni_unlocode: 'GBBWK',
            wni_country: 'GB',
            wni_lat: 55.87,
            wni_lon: -2.08,
            wni_tz: 'Europe/London',
        },
        {
            option: 'FOL',
            wni_port_name: 'FOLKESTONE HARBOR',
            wni_unlocode: 'GBFOL',
            wni_country: 'GB',
            wni_lat: 51.08,
            wni_lon: 1.2,
            wni_tz: 'Europe/London',
        },
        {
            option: 'FRSBR',
            wni_port_name: 'FRASERBURGH HARBOR',
            wni_unlocode: 'GBFRB',
            wni_country: 'GB',
            wni_lat: 57.68,
            wni_lon: -2,
            wni_tz: 'Europe/London',
        },
        {
            option: 'GRLCH',
            wni_port_name: 'GAIRLOCH',
            wni_unlocode: 'GBAUL',
            wni_country: 'GB',
            wni_lat: 57.72,
            wni_lon: -5.68,
            wni_tz: 'Europe/London',
        },
        {
            option: 'GRNHT',
            wni_port_name: 'GREENHITHE',
            wni_unlocode: 'GBGYS',
            wni_country: 'GB',
            wni_lat: 51.45,
            wni_lon: 0.28,
            wni_tz: 'Europe/London',
        },
        {
            option: 'GRYGB',
            wni_port_name: 'GOREY',
            wni_unlocode: 'GBSTH',
            wni_country: 'GB',
            wni_lat: 49.2,
            wni_lon: -2.02,
            wni_tz: 'Europe/London',
        },
        {
            option: 'GTSHD',
            wni_port_name: 'GATESHEAD',
            wni_unlocode: 'GBNCL',
            wni_country: 'GB',
            wni_lat: 54.97,
            wni_lon: -1.58,
            wni_tz: 'Europe/London',
        },
        {
            option: 'HAYLE',
            wni_port_name: 'HAYLE',
            wni_unlocode: 'GBPEN',
            wni_country: 'GB',
            wni_lat: 50.18,
            wni_lon: -5.42,
            wni_tz: 'Europe/London',
        },
        {
            option: 'HLMSD',
            wni_port_name: 'HELMSDALE HARBOR',
            wni_unlocode: 'GBBUH',
            wni_country: 'GB',
            wni_lat: 58.12,
            wni_lon: -3.65,
            wni_tz: 'Europe/London',
        },
        {
            option: 'HLNSB',
            wni_port_name: 'HELENSBURGH',
            wni_unlocode: 'GBGRK',
            wni_country: 'GB',
            wni_lat: 56,
            wni_lon: -4.73,
            wni_tz: 'Europe/London',
        },
        {
            option: 'HRBRA',
            wni_port_name: 'ST AUBIN HARBOR',
            wni_unlocode: 'GBSTH',
            wni_country: 'GB',
            wni_lat: 49.18,
            wni_lon: -2.1,
            wni_tz: 'Europe/London',
        },
        {
            option: 'HUGH',
            wni_port_name: 'HUGH TOWN',
            wni_unlocode: 'GBLEQ',
            wni_country: 'GB',
            wni_lat: 49.92,
            wni_lon: -6.32,
            wni_tz: 'Europe/London',
        },
        {
            option: 'ICH',
            wni_port_name: 'INCHKEITH',
            wni_unlocode: 'GBMTH',
            wni_country: 'GB',
            wni_lat: 56.2,
            wni_lon: -2.99,
            wni_tz: 'Europe/London',
        },
        {
            option: 'ILFRC',
            wni_port_name: 'ILFRACOMBE',
            wni_unlocode: 'GBAPP',
            wni_country: 'GB',
            wni_lat: 51.22,
            wni_lon: -4.12,
            wni_tz: 'Europe/London',
        },
        {
            option: 'IVRRY',
            wni_port_name: 'INVERARAY',
            wni_unlocode: 'GBFNT',
            wni_country: 'GB',
            wni_lat: 56.23,
            wni_lon: -5.07,
            wni_tz: 'Europe/London',
        },
        {
            option: 'KING',
            wni_port_name: 'KINGS LYNN',
            wni_unlocode: 'GBKLN',
            wni_country: 'GB',
            wni_lat: 52.75,
            wni_lon: 0.4,
            wni_tz: 'Europe/London',
        },
        {
            option: 'KTTLT',
            wni_port_name: 'KETTLETOFT',
            wni_unlocode: 'GBPIE',
            wni_country: 'GB',
            wni_lat: 59.23,
            wni_lon: -2.6,
            wni_tz: 'Europe/London',
        },
        {
            option: 'KYLKN',
            wni_port_name: 'KYLEAKIN',
            wni_unlocode: 'GBKYL',
            wni_country: 'GB',
            wni_lat: 57.27,
            wni_lon: -5.73,
            wni_tz: 'Europe/London',
        },
        {
            option: 'LAN',
            wni_port_name: 'LANDS END',
            wni_unlocode: 'GBLEQ',
            wni_country: 'GB',
            wni_lat: 50.07,
            wni_lon: -5.7,
            wni_tz: 'Europe/London',
        },
        {
            option: 'LARG',
            wni_port_name: 'LARGO',
            wni_unlocode: 'GBMTH',
            wni_country: 'GB',
            wni_lat: 56.22,
            wni_lon: -2.95,
            wni_tz: 'Europe/London',
        },
        {
            option: 'LCHBS',
            wni_port_name: 'LOCHBOISDALE',
            wni_unlocode: 'GBBRR',
            wni_country: 'GB',
            wni_lat: 57.15,
            wni_lon: -7.3,
            wni_tz: 'Europe/London',
        },
        {
            option: 'LCHZA',
            wni_port_name: 'LOCHRANZA',
            wni_unlocode: 'GBTAB',
            wni_country: 'GB',
            wni_lat: 55.72,
            wni_lon: -5.3,
            wni_tz: 'Europe/London',
        },
        {
            option: 'LHY',
            wni_port_name: 'LISAHALLY',
            wni_unlocode: 'GBLDY',
            wni_country: 'GB',
            wni_lat: 55.04,
            wni_lon: -7.26,
            wni_tz: 'Europe/London',
        },
        {
            option: 'LMLSH',
            wni_port_name: 'LAMLASH HARBOR',
            wni_unlocode: 'GBLAH',
            wni_country: 'GB',
            wni_lat: 55.53,
            wni_lon: -5.12,
            wni_tz: 'Europe/London',
        },
        {
            option: 'LOOE',
            wni_port_name: 'LOOE HARBOR',
            wni_unlocode: 'GBFOY',
            wni_country: 'GB',
            wni_lat: 50.35,
            wni_lon: -4.45,
            wni_tz: 'Europe/London',
        },
        {
            option: 'LYM',
            wni_port_name: 'LYME REGIS',
            wni_unlocode: 'GBBRP',
            wni_country: 'GB',
            wni_lat: 50.72,
            wni_lon: -2.93,
            wni_tz: 'Europe/London',
        },
        {
            option: 'LYS',
            wni_port_name: 'LYBSTER',
            wni_unlocode: 'GBWIC',
            wni_country: 'GB',
            wni_lat: 58.31,
            wni_lon: -3.29,
            wni_tz: 'Europe/London',
        },
        {
            option: 'MADDY',
            wni_port_name: 'LOCH MADDY',
            wni_unlocode: 'GBLMA',
            wni_country: 'GB',
            wni_lat: 57.6,
            wni_lon: -7.12,
            wni_tz: 'Europe/London',
        },
        {
            option: 'MAGRT',
            wni_port_name: 'ST MARGARETS HOPE',
            wni_unlocode: 'GBBUF',
            wni_country: 'GB',
            wni_lat: 58.83,
            wni_lon: -2.95,
            wni_tz: 'Europe/London',
        },
        {
            option: 'MARYS',
            wni_port_name: 'ST MARYS',
            wni_unlocode: 'GBSFW',
            wni_country: 'GB',
            wni_lat: 58.9,
            wni_lon: -2.92,
            wni_tz: 'Europe/London',
        },
        {
            option: 'MLLG',
            wni_port_name: 'MALLAIG HARBOR',
            wni_unlocode: 'GBMLG',
            wni_country: 'GB',
            wni_lat: 57,
            wni_lon: -5.82,
            wni_tz: 'Europe/London',
        },
        {
            option: 'MLLPR',
            wni_port_name: 'MILLPORT',
            wni_unlocode: 'GBHST',
            wni_country: 'GB',
            wni_lat: 55.75,
            wni_lon: -4.92,
            wni_tz: 'Europe/London',
        },
        {
            option: 'MNHED',
            wni_port_name: 'MINEHEAD HARBOR',
            wni_unlocode: 'GBWAT',
            wni_country: 'GB',
            wni_lat: 51.2,
            wni_lon: -3.47,
            wni_tz: 'Europe/London',
        },
        {
            option: 'MNNC',
            wni_port_name: 'ST MONANCE',
            wni_unlocode: 'GBMTH',
            wni_country: 'GB',
            wni_lat: 56.2,
            wni_lon: -2.77,
            wni_tz: 'Europe/London',
        },
        {
            option: 'MRYPR',
            wni_port_name: 'MARYPORT',
            wni_unlocode: 'GBWOR',
            wni_country: 'GB',
            wni_lat: 54.72,
            wni_lon: -3.5,
            wni_tz: 'Europe/London',
        },
        {
            option: 'MVGSS',
            wni_port_name: 'MEVAGISSEY HARBOR',
            wni_unlocode: 'GBCHF',
            wni_country: 'GB',
            wni_lat: 50.27,
            wni_lon: -4.78,
            wni_tz: 'Europe/London',
        },
        {
            option: 'NWQY',
            wni_port_name: 'NEWQUAY',
            wni_unlocode: 'GBPAD',
            wni_country: 'GB',
            wni_lat: 50.42,
            wni_lon: -5.08,
            wni_tz: 'Europe/London',
        },
        {
            option: 'ORNSY',
            wni_port_name: 'ISLE ORNSAY',
            wni_unlocode: 'GBMLG',
            wni_country: 'GB',
            wni_lat: 57.15,
            wni_lon: -5.8,
            wni_tz: 'Europe/London',
        },
        {
            option: 'PLCKT',
            wni_port_name: 'PLOCKTON',
            wni_unlocode: 'GBKYL',
            wni_country: 'GB',
            wni_lat: 57.35,
            wni_lon: -5.65,
            wni_tz: 'Europe/London',
        },
        {
            option: 'PNRTH',
            wni_port_name: 'PENARTH',
            wni_unlocode: 'GBCDF',
            wni_country: 'GB',
            wni_lat: 51.43,
            wni_lon: -3.17,
            wni_tz: 'Europe/London',
        },
        {
            option: 'PRKST',
            wni_port_name: 'PARKESTON',
            wni_unlocode: 'GBHRW',
            wni_country: 'GB',
            wni_lat: 51.95,
            wni_lon: 1.25,
            wni_tz: 'Europe/London',
        },
        {
            option: 'PRTEE',
            wni_port_name: 'PORTREE HARBOR',
            wni_unlocode: 'GBPRT',
            wni_country: 'GB',
            wni_lat: 57.42,
            wni_lon: -6.15,
            wni_tz: 'Europe/London',
        },
        {
            option: 'PRTHL',
            wni_port_name: 'PORTHLEVEN',
            wni_unlocode: 'GBPEN',
            wni_country: 'GB',
            wni_lat: 50.08,
            wni_lon: -5.32,
            wni_tz: 'Europe/London',
        },
        {
            option: 'PRTKN',
            wni_port_name: 'PORTKNOCKIE',
            wni_unlocode: 'GBBUC',
            wni_country: 'GB',
            wni_lat: 57.7,
            wni_lon: -2.85,
            wni_tz: 'Europe/London',
        },
        {
            option: 'PRTMH',
            wni_port_name: 'PORTMAHOMACK HARBOR',
            wni_unlocode: 'GBCRN',
            wni_country: 'GB',
            wni_lat: 57.83,
            wni_lon: -3.83,
            wni_tz: 'Europe/London',
        },
        {
            option: 'PRTSY',
            wni_port_name: 'PORTSOY HARBOR',
            wni_unlocode: 'GBBFF',
            wni_country: 'GB',
            wni_lat: 57.68,
            wni_lon: -2.68,
            wni_tz: 'Europe/London',
        },
        {
            option: 'PTTNW',
            wni_port_name: 'PITTENWEEM',
            wni_unlocode: 'GBMTH',
            wni_country: 'GB',
            wni_lat: 56.22,
            wni_lon: -2.73,
            wni_tz: 'Europe/London',
        },
        {
            option: 'PWLLH',
            wni_port_name: 'PWLLHELI',
            wni_unlocode: 'GBPMD',
            wni_country: 'GB',
            wni_lat: 52.88,
            wni_lon: -4.4,
            wni_tz: 'Europe/London',
        },
        {
            option: 'QNSBR',
            wni_port_name: 'QUEENSBOROUGH',
            wni_unlocode: 'GBQUB',
            wni_country: 'GB',
            wni_lat: 51.42,
            wni_lon: 0.75,
            wni_tz: 'Europe/London',
        },
        {
            option: 'RFREW',
            wni_port_name: 'RENFREW',
            wni_unlocode: 'GBCLY',
            wni_country: 'GB',
            wni_lat: 55.88,
            wni_lon: -4.38,
            wni_tz: 'Europe/London',
        },
        {
            option: 'RHYL',
            wni_port_name: 'RHYL',
            wni_unlocode: 'GBLLD',
            wni_country: 'GB',
            wni_lat: 53.32,
            wni_lon: -3.48,
            wni_tz: 'Europe/London',
        },
        {
            option: 'ROSY',
            wni_port_name: 'ROSYTH DOCKYARD',
            wni_unlocode: 'GBROY',
            wni_country: 'GB',
            wni_lat: 56.02,
            wni_lon: -3.43,
            wni_tz: 'Europe/London',
        },
        {
            option: 'RTHS',
            wni_port_name: 'ROTHESAY DOCK',
            wni_unlocode: 'GBCLY',
            wni_country: 'GB',
            wni_lat: 55.9,
            wni_lon: -4.4,
            wni_tz: 'Europe/London',
        },
        {
            option: 'RTHSY',
            wni_port_name: 'ROTHESAY HARBOR',
            wni_unlocode: 'GBRAY',
            wni_country: 'GB',
            wni_lat: 55.83,
            wni_lon: -5.05,
            wni_tz: 'Europe/London',
        },
        {
            option: 'SAMPS',
            wni_port_name: 'ST SAMPSON HARBOR',
            wni_unlocode: 'GGSPT',
            wni_country: 'GB',
            wni_lat: 49.48,
            wni_lon: -2.52,
            wni_tz: 'Europe/London',
        },
        {
            option: 'SCB',
            wni_port_name: 'SCRABSTER HARBOR',
            wni_unlocode: 'GBSCR',
            wni_country: 'GB',
            wni_lat: 58.62,
            wni_lon: -3.55,
            wni_tz: 'Europe/London',
        },
        {
            option: 'SHH',
            wni_port_name: 'SHOREHAM HARBOR',
            wni_unlocode: 'GBSHO',
            wni_country: 'GB',
            wni_lat: 50.83,
            wni_lon: -0.25,
            wni_tz: 'Europe/London',
        },
        {
            option: 'SHLDS',
            wni_port_name: 'SHIELDS HARBOR',
            wni_unlocode: 'GBSSH',
            wni_country: 'GB',
            wni_lat: 55.02,
            wni_lon: -1.43,
            wni_tz: 'Europe/London',
        },
        {
            option: 'SIVES',
            wni_port_name: 'ST IVES',
            wni_unlocode: 'GBPEN',
            wni_country: 'GB',
            wni_lat: 50.22,
            wni_lon: -5.47,
            wni_tz: 'Europe/London',
        },
        {
            option: 'SLCMB',
            wni_port_name: 'SALCOMBE HARBOR',
            wni_unlocode: 'GBDTM',
            wni_country: 'GB',
            wni_lat: 50.23,
            wni_lon: -3.77,
            wni_tz: 'Europe/London',
        },
        {
            option: 'SLE',
            wni_port_name: 'SALT END',
            wni_unlocode: 'GBHUL',
            wni_country: 'GB',
            wni_lat: 53.74,
            wni_lon: -0.24,
            wni_tz: 'Europe/London',
        },
        {
            option: 'SNDRL',
            wni_port_name: 'NORTH SUNDERLAND',
            wni_unlocode: 'GBBWK',
            wni_country: 'GB',
            wni_lat: 55.58,
            wni_lon: -1.65,
            wni_tz: 'Europe/London',
        },
        {
            option: 'SNESS',
            wni_port_name: 'SOUTH NESS',
            wni_unlocode: 'GBLHP',
            wni_country: 'GB',
            wni_lat: 58.8,
            wni_lon: -3.2,
            wni_tz: 'Europe/London',
        },
        {
            option: 'SRY',
            wni_port_name: 'STORNOWAY HARBOR',
            wni_unlocode: 'GBSTO',
            wni_country: 'GB',
            wni_lat: 58.18,
            wni_lon: -6.37,
            wni_tz: 'Europe/London',
        },
        {
            option: 'STCKT',
            wni_port_name: 'STOCKTON',
            wni_unlocode: 'GBMID',
            wni_country: 'GB',
            wni_lat: 54.57,
            wni_lon: -1.3,
            wni_tz: 'Europe/London',
        },
        {
            option: 'STNHV',
            wni_port_name: 'STONEHAVEN HARBOR',
            wni_unlocode: 'GBABD',
            wni_country: 'GB',
            wni_lat: 56.97,
            wni_lon: -2.2,
            wni_tz: 'Europe/London',
        },
        {
            option: 'SUNK',
            wni_port_name: 'SUNK',
            wni_unlocode: 'GBRID',
            wni_country: 'GB',
            wni_lat: 51.35,
            wni_lon: 0.82,
            wni_tz: 'Europe/London',
        },
        {
            option: 'SWD',
            wni_port_name: 'SOUTHWOOD',
            wni_unlocode: 'GBSWD',
            wni_country: 'GB',
            wni_lat: 52.33,
            wni_lon: 1.68,
            wni_tz: 'Europe/London',
        },
        {
            option: 'TARBE',
            wni_port_name: 'TARBERT',
            wni_unlocode: 'GBLMA',
            wni_country: 'GB',
            wni_lat: 57.9,
            wni_lon: -6.82,
            wni_tz: 'Europe/London',
        },
        {
            option: 'TBRMR',
            wni_port_name: 'TOBERMORY',
            wni_unlocode: 'GBLOL',
            wni_country: 'GB',
            wni_lat: 56.62,
            wni_lon: -6.07,
            wni_tz: 'Europe/London',
        },
        {
            option: 'TGNMT',
            wni_port_name: 'TEIGNMOUTH HARBOR',
            wni_unlocode: 'GBTNM',
            wni_country: 'GB',
            wni_lat: 50.55,
            wni_lon: -3.5,
            wni_tz: 'Europe/London',
        },
        {
            option: 'TNE',
            wni_port_name: 'THE NEEDLES',
            wni_unlocode: 'USEED',
            wni_country: 'GB',
            wni_lat: 50.67,
            wni_lon: -1.57,
            wni_tz: 'Europe/London',
        },
        {
            option: 'TSO',
            wni_port_name: 'THE SOLENT',
            wni_unlocode: 'GBGOS',
            wni_country: 'GB',
            wni_lat: 50.8,
            wni_lon: -1.2,
            wni_tz: 'Europe/London',
        },
        {
            option: 'TYPRT',
            wni_port_name: 'TAYPORT',
            wni_unlocode: 'GBDUN',
            wni_country: 'GB',
            wni_lat: 56.45,
            wni_lon: -2.88,
            wni_tz: 'Europe/London',
        },
        {
            option: 'UIG',
            wni_port_name: 'UIG',
            wni_unlocode: 'GBPRT',
            wni_country: 'GB',
            wni_lat: 57.58,
            wni_lon: -6.35,
            wni_tz: 'Europe/London',
        },
        {
            option: 'VTORA',
            wni_port_name: 'PORT VICTORIA',
            wni_unlocode: 'GBTHP',
            wni_country: 'GB',
            wni_lat: 51.43,
            wni_lon: 0.7,
            wni_tz: 'Europe/London',
        },
        {
            option: 'WHTHL',
            wni_port_name: 'WHITEHALL',
            wni_unlocode: 'GBKWL',
            wni_country: 'GB',
            wni_lat: 59.15,
            wni_lon: -2.6,
            wni_tz: 'Europe/London',
        },
        {
            option: 'WLAM',
            wni_port_name: 'FORT WILLIAM',
            wni_unlocode: 'GBCOR',
            wni_country: 'GB',
            wni_lat: 56.82,
            wni_lon: -5.12,
            wni_tz: 'Europe/London',
        },
        {
            option: 'WRKWR',
            wni_port_name: 'WARKWORTH HARBOR',
            wni_unlocode: 'GBBLY',
            wni_country: 'GB',
            wni_lat: 55.33,
            wni_lon: -1.58,
            wni_tz: 'Europe/London',
        },
        {
            option: 'WSTNS',
            wni_port_name: 'WESTON SUPER MARE',
            wni_unlocode: 'GBCDF',
            wni_country: 'GB',
            wni_lat: 51.35,
            wni_lon: -2.98,
            wni_tz: 'Europe/London',
        },
        {
            option: 'WTCHT',
            wni_port_name: 'WATCHET HARBOR',
            wni_unlocode: 'GBWAT',
            wni_country: 'GB',
            wni_lat: 51.18,
            wni_lon: -3.33,
            wni_tz: 'Europe/London',
        },
        {
            option: 'YRMTH',
            wni_port_name: 'YARMOUTH HARBOR',
            wni_unlocode: 'USEED',
            wni_country: 'GB',
            wni_lat: 50.7,
            wni_lon: -1.5,
            wni_tz: 'Europe/London',
        },
        {
            option: 'GAGRA',
            wni_port_name: 'GAGRA',
            wni_unlocode: 'RUSOC',
            wni_country: 'GE',
            wni_lat: 43.33,
            wni_lon: 40.25,
            wni_tz: 'Asia/Tbilisi',
        },
        {
            option: 'GUDUT',
            wni_port_name: 'GUDAUTA',
            wni_unlocode: 'GESUI',
            wni_country: 'GE',
            wni_lat: 43.08,
            wni_lon: 40.67,
            wni_tz: 'Asia/Tbilisi',
        },
        {
            option: 'PSRTS',
            wni_port_name: 'PSIRTSKHA',
            wni_unlocode: 'GESUI',
            wni_country: 'GE',
            wni_lat: 43.07,
            wni_lon: 40.85,
            wni_tz: 'Asia/Tbilisi',
        },
        {
            option: 'SUKHM',
            wni_port_name: 'SOKHUMI',
            wni_unlocode: 'GESUI',
            wni_country: 'GE',
            wni_lat: 42.98,
            wni_lon: 40.98,
            wni_tz: 'Asia/Tbilisi',
        },
        {
            option: 'ACCRA',
            wni_port_name: 'ACCRA',
            wni_unlocode: 'GHTEM',
            wni_country: 'GH',
            wni_lat: 5.53,
            wni_lon: -0.2,
            wni_tz: 'Africa/Accra',
        },
        {
            option: 'CSTGH',
            wni_port_name: 'CAPE COAST',
            wni_unlocode: 'GHSPD',
            wni_country: 'GH',
            wni_lat: 5.1,
            wni_lon: -1.23,
            wni_tz: 'Africa/Accra',
        },
        {
            option: 'ELMNA',
            wni_port_name: 'ELMINA',
            wni_unlocode: 'GHSPD',
            wni_country: 'GH',
            wni_lat: 5.08,
            wni_lon: -1.33,
            wni_tz: 'Africa/Accra',
        },
        {
            option: 'AKNQ',
            wni_port_name: 'AKUNAQ',
            wni_unlocode: 'GLJEG',
            wni_country: 'GL',
            wni_lat: 68.75,
            wni_lon: -52.32,
            wni_tz: 'America/Godthab',
        },
        {
            option: 'FDRKS',
            wni_port_name: 'FREDERIKSDAL',
            wni_unlocode: 'GLJNN',
            wni_country: 'GL',
            wni_lat: 60,
            wni_lon: -44.67,
            wni_tz: 'America/Godthab',
        },
        {
            option: 'FRDAB',
            wni_port_name: 'FREDERIKSHAB',
            wni_unlocode: 'GLJFR',
            wni_country: 'GL',
            wni_lat: 62,
            wni_lon: -49.67,
            wni_tz: 'America/Godthab',
        },
        {
            option: 'GRNND',
            wni_port_name: 'GRONNE DAL',
            wni_unlocode: 'GLJGR',
            wni_country: 'GL',
            wni_lat: 61.23,
            wni_lon: -48.1,
            wni_tz: 'America/Godthab',
        },
        {
            option: 'IKMT',
            wni_port_name: 'IKAMIUT',
            wni_unlocode: 'GLJCH',
            wni_country: 'GL',
            wni_lat: 68.63,
            wni_lon: -51.83,
            wni_tz: 'America/Godthab',
        },
        {
            option: 'IKRSK',
            wni_port_name: 'IKERASAK',
            wni_unlocode: 'GLUMD',
            wni_country: 'GL',
            wni_lat: 70.5,
            wni_lon: -51.32,
            wni_tz: 'America/Godthab',
        },
        {
            option: 'JUB',
            wni_port_name: 'JULIANEHAB',
            wni_unlocode: 'GLJJU',
            wni_country: 'GL',
            wni_lat: 60.72,
            wni_lon: -46.05,
            wni_tz: 'America/Godthab',
        },
        {
            option: 'KGRSQ',
            wni_port_name: 'KANGERLUARSORUSEQ',
            wni_unlocode: 'GLFHN',
            wni_country: 'GL',
            wni_lat: 63.7,
            wni_lon: -51.55,
            wni_tz: 'America/Godthab',
        },
        {
            option: 'KNGMT',
            wni_port_name: 'KANGAMIUT',
            wni_unlocode: 'GLJSU',
            wni_country: 'GL',
            wni_lat: 65.82,
            wni_lon: -53.3,
            wni_tz: 'America/Godthab',
        },
        {
            option: 'LLOYD',
            wni_port_name: 'CAMP LLOYD',
            wni_unlocode: 'GLKAN',
            wni_country: 'GL',
            wni_lat: 66.97,
            wni_lon: -50.95,
            wni_tz: 'America/Godthab',
        },
        {
            option: 'NAQ',
            wni_port_name: 'NANORTALIK HAVN',
            wni_unlocode: 'GLJNN',
            wni_country: 'GL',
            wni_lat: 60.12,
            wni_lon: -45.2,
            wni_tz: 'America/Godthab',
        },
        {
            option: 'NRSS',
            wni_port_name: 'NARSSAQ',
            wni_unlocode: 'GLJNS',
            wni_country: 'GL',
            wni_lat: 60.92,
            wni_lon: -46.05,
            wni_tz: 'America/Godthab',
        },
        {
            option: 'QGSRS',
            wni_port_name: 'QAGSERSSUAK',
            wni_unlocode: 'GLJUV',
            wni_country: 'GL',
            wni_lat: 73.08,
            wni_lon: -55.75,
            wni_tz: 'America/Godthab',
        },
        {
            option: 'QRST',
            wni_port_name: 'QAERSUT',
            wni_unlocode: 'GLUMD',
            wni_country: 'GL',
            wni_lat: 70.73,
            wni_lon: -52.63,
            wni_tz: 'America/Godthab',
        },
        {
            option: 'RDBY',
            wni_port_name: 'RODEBAY',
            wni_unlocode: 'GLJAV',
            wni_country: 'GL',
            wni_lat: 69.35,
            wni_lon: -51.02,
            wni_tz: 'America/Godthab',
        },
        {
            option: 'SATUT',
            wni_port_name: 'SATUT',
            wni_unlocode: 'GLUMD',
            wni_country: 'GL',
            wni_lat: 70.82,
            wni_lon: -51.65,
            wni_tz: 'America/Godthab',
        },
        {
            option: 'THUL',
            wni_port_name: 'THULE',
            wni_unlocode: 'GLTHU',
            wni_country: 'GL',
            wni_lat: 76.53,
            wni_lon: -68.87,
            wni_tz: 'America/Thule',
        },
        {
            option: 'UMNK',
            wni_port_name: 'UMANAK HARBOR',
            wni_unlocode: 'GLUMD',
            wni_country: 'GL',
            wni_lat: 70.68,
            wni_lon: -52.15,
            wni_tz: 'America/Godthab',
        },
        {
            option: 'UVKSG',
            wni_port_name: 'UVKUSIGSSAT',
            wni_unlocode: 'GLMML',
            wni_country: 'GL',
            wni_lat: 71.07,
            wni_lon: -51.9,
            wni_tz: 'America/Godthab',
        },
        {
            option: 'BTHG',
            wni_port_name: 'BATHURST',
            wni_unlocode: 'GMBJL',
            wni_country: 'GM',
            wni_lat: 13.44,
            wni_lon: -16.57,
            wni_tz: 'Africa/Banjul',
        },
        {
            option: 'DBRK',
            wni_port_name: 'DUBREKA',
            wni_unlocode: 'GNCKY',
            wni_country: 'GN',
            wni_lat: 9.78,
            wni_lon: -13.53,
            wni_tz: 'Africa/Conakry',
        },
        {
            option: 'VICGN',
            wni_port_name: 'VICTORIA',
            wni_unlocode: 'GNKMR',
            wni_country: 'GN',
            wni_lat: 10.82,
            wni_lon: -14.57,
            wni_tz: 'Africa/Conakry',
        },
        {
            option: 'BRGGP',
            wni_port_name: 'BOURG DES SAINTES',
            wni_unlocode: 'GPLSS',
            wni_country: 'GP',
            wni_lat: 15.87,
            wni_lon: -61.58,
            wni_tz: 'America/Guadeloupe',
        },
        {
            option: 'GBORG',
            wni_port_name: 'GRAND BOURG',
            wni_unlocode: 'GPLSS',
            wni_country: 'GP',
            wni_lat: 15.88,
            wni_lon: -61.32,
            wni_tz: 'America/Guadeloupe',
        },
        {
            option: 'LACR',
            wni_port_name: 'LA CARAVELLE',
            wni_unlocode: 'GPPTP',
            wni_country: 'GP',
            wni_lat: 16.2,
            wni_lon: -61.45,
            wni_tz: 'America/Guadeloupe',
        },
        {
            option: 'LISGP',
            wni_port_name: 'PORT LOUIS',
            wni_unlocode: 'GPPTP',
            wni_country: 'GP',
            wni_lat: 16.42,
            wni_lon: -61.53,
            wni_tz: 'America/Guadeloupe',
        },
        {
            option: 'LUSGP',
            wni_port_name: 'ST LOUIS',
            wni_unlocode: 'GPLSS',
            wni_country: 'GP',
            wni_lat: 15.95,
            wni_lon: -61.32,
            wni_tz: 'America/Guadeloupe',
        },
        {
            option: 'MGT',
            wni_port_name: 'MARIE GALANTE',
            wni_unlocode: 'GPLSS',
            wni_country: 'GP',
            wni_lat: 15.87,
            wni_lon: -61.27,
            wni_tz: 'America/Guadeloupe',
        },
        {
            option: 'ADMS',
            wni_port_name: 'ADHAMAS',
            wni_unlocode: 'GRSER',
            wni_country: 'GR',
            wni_lat: 36.72,
            wni_lon: 24.45,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'ADPSS',
            wni_port_name: 'LOUTRA AIDHIPSOU',
            wni_unlocode: 'GRACL',
            wni_country: 'GR',
            wni_lat: 38.87,
            wni_lon: 23.03,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'ADROS',
            wni_port_name: 'ANDROS',
            wni_unlocode: 'GRGAV',
            wni_country: 'GR',
            wni_lat: 37.83,
            wni_lon: 24.95,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'AEG',
            wni_port_name: 'AIYION',
            wni_unlocode: 'GRGPA',
            wni_country: 'GR',
            wni_lat: 38.25,
            wni_lon: 22.08,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'AGM',
            wni_port_name: 'AGHIA MARINA',
            wni_unlocode: 'GRATH',
            wni_country: 'GR',
            wni_lat: 37.74,
            wni_lon: 23.53,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'AGRIA',
            wni_port_name: 'AGRIA',
            wni_unlocode: 'GRVOL',
            wni_country: 'GR',
            wni_lat: 39.33,
            wni_lon: 23.02,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'ALNDH',
            wni_port_name: 'ALINDHA',
            wni_unlocode: 'GRLRS',
            wni_country: 'GR',
            wni_lat: 37.15,
            wni_lon: 26.85,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'AMTOS',
            wni_port_name: 'AMARINTHOS',
            wni_unlocode: 'GRALV',
            wni_country: 'GR',
            wni_lat: 38.38,
            wni_lon: 23.88,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'ANDI',
            wni_port_name: 'ANDIKIRA',
            wni_unlocode: 'GRATK',
            wni_country: 'GR',
            wni_lat: 38.37,
            wni_lon: 22.63,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'ASP',
            wni_port_name: 'ASPRA SPITIA',
            wni_unlocode: 'GRSTN',
            wni_country: 'GR',
            wni_lat: 38.37,
            wni_lon: 22.66,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'AVLK',
            wni_port_name: 'ORMOS AVLAKI',
            wni_unlocode: 'GRLAV',
            wni_country: 'GR',
            wni_lat: 37.78,
            wni_lon: 24.08,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'AYIA',
            wni_port_name: 'AYIA MARINA',
            wni_unlocode: 'GRSYS',
            wni_country: 'GR',
            wni_lat: 38.88,
            wni_lon: 22.58,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'BTZ',
            wni_port_name: 'BOURTZI',
            wni_unlocode: 'GRHYD',
            wni_country: 'GR',
            wni_lat: 37.49,
            wni_lon: 23.48,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'CHNI',
            wni_port_name: 'LIMIN KHANION',
            wni_unlocode: 'GRGAF',
            wni_country: 'GR',
            wni_lat: 35.52,
            wni_lon: 24.03,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'CNH',
            wni_port_name: 'KORINTHOS',
            wni_unlocode: 'GRCRG',
            wni_country: 'GR',
            wni_lat: 37.95,
            wni_lon: 22.93,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'CSH',
            wni_port_name: 'KHIOS',
            wni_unlocode: 'GRJKH',
            wni_country: 'GR',
            wni_lat: 38.37,
            wni_lon: 26.13,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'DHVLS',
            wni_port_name: 'DHIAVLOS STENO',
            wni_unlocode: 'GRQKG',
            wni_country: 'GR',
            wni_lat: 38.45,
            wni_lon: 23.6,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'EGI',
            wni_port_name: 'EGIO',
            wni_unlocode: 'GRGPA',
            wni_country: 'GR',
            wni_lat: 38.25,
            wni_lon: 22.08,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'EVRPU',
            wni_port_name: 'PORTHMOS EVRIPOU',
            wni_unlocode: 'GRQKG',
            wni_country: 'GR',
            wni_lat: 38.47,
            wni_lon: 23.58,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'IDHRA',
            wni_port_name: 'LIMIN IDHRA',
            wni_unlocode: 'GRHYD',
            wni_country: 'GR',
            wni_lat: 37.35,
            wni_lon: 23.47,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'IOS',
            wni_port_name: 'NISOS IOS',
            wni_unlocode: 'GRJTR',
            wni_country: 'GR',
            wni_lat: 36.73,
            wni_lon: 25.33,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'IRKLS',
            wni_port_name: 'LIMIN IRAKLEOUS',
            wni_unlocode: 'GRKTS',
            wni_country: 'GR',
            wni_lat: 37.97,
            wni_lon: 23.6,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'ITHK',
            wni_port_name: 'ITHAKI',
            wni_unlocode: 'GRVTH',
            wni_country: 'GR',
            wni_lat: 38.37,
            wni_lon: 20.72,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'KIAT',
            wni_port_name: 'KIATON',
            wni_unlocode: 'GRCCE',
            wni_country: 'GR',
            wni_lat: 38.01,
            wni_lon: 22.75,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'KLKTH',
            wni_port_name: 'ORMOS KOLOKITHIAS',
            wni_unlocode: 'GRJKH',
            wni_country: 'GR',
            wni_lat: 38.48,
            wni_lon: 26.13,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'KLLNS',
            wni_port_name: 'KOLPOS KALLONIS',
            wni_unlocode: 'GRMJT',
            wni_country: 'GR',
            wni_lat: 39.08,
            wni_lon: 26.08,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'KLMNS',
            wni_port_name: 'KALIMNOS',
            wni_unlocode: 'GRKMI',
            wni_country: 'GR',
            wni_lat: 36.95,
            wni_lon: 26.98,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'KMLS',
            wni_port_name: 'NISOS KIMOLOS',
            wni_unlocode: 'GRSER',
            wni_country: 'GR',
            wni_lat: 36.78,
            wni_lon: 24.57,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'KMT',
            wni_port_name: 'KALAMAI',
            wni_unlocode: 'GRKLX',
            wni_country: 'GR',
            wni_lat: 37.02,
            wni_lon: 22.12,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'KNDS',
            wni_port_name: 'ORMOS KONDIAS',
            wni_unlocode: 'GRMDR',
            wni_country: 'GR',
            wni_lat: 39.85,
            wni_lon: 25.17,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'KNSTN',
            wni_port_name: 'AYIOS KONSTANDINOS',
            wni_unlocode: 'GRACL',
            wni_country: 'GR',
            wni_lat: 38.75,
            wni_lon: 22.85,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'KPR',
            wni_port_name: 'CORMOS KAPARI',
            wni_unlocode: 'GRHYD',
            wni_country: 'GR',
            wni_lat: 37.38,
            wni_lon: 23.25,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'KRKYR',
            wni_port_name: 'KERKIRA',
            wni_unlocode: 'GRCFU',
            wni_country: 'GR',
            wni_lat: 39.62,
            wni_lon: 19.93,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'KRLVS',
            wni_port_name: 'LIMIN KARLOVASI',
            wni_unlocode: 'GRKAR',
            wni_country: 'GR',
            wni_lat: 37.8,
            wni_lon: 26.68,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'KRMTI',
            wni_port_name: 'KERAMOTI',
            wni_unlocode: 'GRNKV',
            wni_country: 'GR',
            wni_lat: 40.87,
            wni_lon: 24.7,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'KRNTH',
            wni_port_name: 'KORINTHOS',
            wni_unlocode: 'GRCRG',
            wni_country: 'GR',
            wni_lat: 37.95,
            wni_lon: 22.93,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'KRYST',
            wni_port_name: 'KARISTOS',
            wni_unlocode: 'GRGAV',
            wni_country: 'GR',
            wni_lat: 38.02,
            wni_lon: 24.42,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'KSFA',
            wni_port_name: 'KHORA SFAKION',
            wni_unlocode: 'GRSUD',
            wni_country: 'GR',
            wni_lat: 35.2,
            wni_lon: 24.14,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'KVL',
            wni_port_name: 'KAVALA',
            wni_unlocode: 'GRKVA',
            wni_country: 'GR',
            wni_lat: 40.93,
            wni_lon: 24.4,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'LEF',
            wni_port_name: 'LEVKANDION',
            wni_unlocode: 'GRQKG',
            wni_country: 'GR',
            wni_lat: 38.4,
            wni_lon: 23.68,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'LIPSO',
            wni_port_name: 'LIPSOI',
            wni_unlocode: 'GRPMS',
            wni_country: 'GR',
            wni_lat: 37.3,
            wni_lon: 26.77,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'LKKN',
            wni_port_name: 'LAKKION',
            wni_unlocode: 'GRLRS',
            wni_country: 'GR',
            wni_lat: 37.13,
            wni_lon: 26.85,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'LMNS',
            wni_port_name: 'ORMOS LIMNIS',
            wni_unlocode: 'GRKYM',
            wni_country: 'GR',
            wni_lat: 38.77,
            wni_lon: 23.32,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'LNDHN',
            wni_port_name: 'LEONIDHION',
            wni_unlocode: 'GRNPL',
            wni_country: 'GR',
            wni_lat: 37.17,
            wni_lon: 22.87,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'LVKS',
            wni_port_name: 'LEVKAS',
            wni_unlocode: 'GRLEV',
            wni_country: 'GR',
            wni_lat: 38.82,
            wni_lon: 20.73,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'LYA',
            wni_port_name: 'LARIMNA',
            wni_unlocode: 'GRQKG',
            wni_country: 'GR',
            wni_lat: 38.57,
            wni_lon: 23.28,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'MDHRS',
            wni_port_name: 'ORMOS MOUDHROS',
            wni_unlocode: 'GRMDR',
            wni_country: 'GR',
            wni_lat: 39.83,
            wni_lon: 25.25,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'MIRIN',
            wni_port_name: 'MIRINA',
            wni_unlocode: 'GRMYR',
            wni_country: 'GR',
            wni_lat: 39.87,
            wni_lon: 25.07,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'MLINA',
            wni_port_name: 'MILIANA',
            wni_unlocode: 'GRAPL',
            wni_country: 'GR',
            wni_lat: 39.17,
            wni_lon: 23.22,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'MLS',
            wni_port_name: 'MILOS',
            wni_unlocode: 'GRSER',
            wni_country: 'GR',
            wni_lat: 36.72,
            wni_lon: 24.45,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'MNMVS',
            wni_port_name: 'MONEMVASIA',
            wni_unlocode: 'GRNEA',
            wni_country: 'GR',
            wni_lat: 36.68,
            wni_lon: 23.05,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'MSLNG',
            wni_port_name: 'LIMIN MESOLONGION',
            wni_unlocode: 'GRMEL',
            wni_country: 'GR',
            wni_lat: 38.37,
            wni_lon: 21.42,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'MTHN',
            wni_port_name: 'ORMOS METHONIS',
            wni_unlocode: 'GRSKG',
            wni_country: 'GR',
            wni_lat: 40.45,
            wni_lon: 22.6,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'MTLN',
            wni_port_name: 'MITILINI',
            wni_unlocode: 'GRMJT',
            wni_country: 'GR',
            wni_lat: 39.1,
            wni_lon: 26.57,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'MTSON',
            wni_port_name: 'ORMOS MOUTSOUNA',
            wni_unlocode: 'GRPAS',
            wni_country: 'GR',
            wni_lat: 37.08,
            wni_lon: 25.58,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'NAXOS',
            wni_port_name: 'NISOS NAXOS',
            wni_unlocode: 'GRPAS',
            wni_country: 'GR',
            wni_lat: 37.08,
            wni_lon: 25.48,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'NFPL',
            wni_port_name: 'NAVPLION',
            wni_unlocode: 'GRNPL',
            wni_country: 'GR',
            wni_lat: 37.57,
            wni_lon: 22.8,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'NKLA',
            wni_port_name: 'ORMOS AYIOU NIKOLAOU',
            wni_unlocode: 'GRZEA',
            wni_country: 'GR',
            wni_lat: 37.67,
            wni_lon: 24.32,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'NKLOU',
            wni_port_name: 'ORMOS AYIOU NIKOLAOU',
            wni_unlocode: 'GRLAV',
            wni_country: 'GR',
            wni_lat: 37.75,
            wni_lon: 24.07,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'NVR',
            wni_port_name: 'ORMOS NAVARINOU',
            wni_unlocode: 'GRPYL',
            wni_country: 'GR',
            wni_lat: 36.9,
            wni_lon: 21.67,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'NVSTT',
            wni_port_name: 'NAVSTATHMOS',
            wni_unlocode: 'GRPER',
            wni_country: 'GR',
            wni_lat: 37.98,
            wni_lon: 23.53,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'OROPS',
            wni_port_name: 'OROPOS',
            wni_unlocode: 'GRLVR',
            wni_country: 'GR',
            wni_lat: 38.32,
            wni_lon: 23.8,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'PILIN',
            wni_port_name: 'PILION',
            wni_unlocode: 'GRKYM',
            wni_country: 'GR',
            wni_lat: 38.77,
            wni_lon: 23.6,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'PLAI',
            wni_port_name: 'PLATYGIALI',
            wni_unlocode: 'GRAST',
            wni_country: 'GR',
            wni_lat: 38.48,
            wni_lon: 21.1,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'PLOMR',
            wni_port_name: 'PLOMARION',
            wni_unlocode: 'GRMJT',
            wni_country: 'GR',
            wni_lat: 38.98,
            wni_lon: 26.37,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'PLRN',
            wni_port_name: 'PALIOURION',
            wni_unlocode: 'GRAKI',
            wni_country: 'GR',
            wni_lat: 39.97,
            wni_lon: 23.67,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'POROS',
            wni_port_name: 'POROS',
            wni_unlocode: 'GRHYD',
            wni_country: 'GR',
            wni_lat: 37.5,
            wni_lon: 23.45,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'PRLN',
            wni_port_name: 'PARALION ASTROS',
            wni_unlocode: 'GRNPL',
            wni_country: 'GR',
            wni_lat: 37.42,
            wni_lon: 22.77,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'PRMOS',
            wni_port_name: 'NEA PERAMOS',
            wni_unlocode: 'GRKVA',
            wni_country: 'GR',
            wni_lat: 40.83,
            wni_lon: 24.3,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'PRMS',
            wni_port_name: 'NEA PERAMOS',
            wni_unlocode: 'GRAGI',
            wni_country: 'GR',
            wni_lat: 38,
            wni_lon: 23.42,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'PRTKH',
            wni_port_name: 'PORTOKHELION',
            wni_unlocode: 'GRHYD',
            wni_country: 'GR',
            wni_lat: 37.32,
            wni_lon: 23.15,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'PSARA',
            wni_port_name: 'NEA PSARA',
            wni_unlocode: 'GRQKG',
            wni_country: 'GR',
            wni_lat: 38.38,
            wni_lon: 23.78,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'PTHGR',
            wni_port_name: 'PITHAGORION',
            wni_unlocode: 'GRSMI',
            wni_country: 'GR',
            wni_lat: 37.68,
            wni_lon: 26.95,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'PTLEU',
            wni_port_name: 'ORMOS PTELEOU',
            wni_unlocode: 'GRAPL',
            wni_country: 'GR',
            wni_lat: 39.02,
            wni_lon: 22.98,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'RFTS',
            wni_port_name: 'ORMOS RAFTIS',
            wni_unlocode: 'GRRAF',
            wni_country: 'GR',
            wni_lat: 37.88,
            wni_lon: 24.05,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'SITIA',
            wni_port_name: 'SITIA',
            wni_unlocode: 'GRATL',
            wni_country: 'GR',
            wni_lat: 35.22,
            wni_lon: 26.13,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'SKALA',
            wni_port_name: 'ORMOS SKALA',
            wni_unlocode: 'GRJTR',
            wni_country: 'GR',
            wni_lat: 36.67,
            wni_lon: 25.15,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'SKPL',
            wni_port_name: 'ORMOS SKOPELOU',
            wni_unlocode: 'GRKYM',
            wni_country: 'GR',
            wni_lat: 39.13,
            wni_lon: 23.73,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'SKTHS',
            wni_port_name: 'SKIATHOS',
            wni_unlocode: 'GRKYM',
            wni_country: 'GR',
            wni_lat: 39.17,
            wni_lon: 23.5,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'SLC',
            wni_port_name: 'SALONICA',
            wni_unlocode: 'GRSKG',
            wni_country: 'GR',
            wni_lat: 40.64,
            wni_lon: 22.92,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'SLMS',
            wni_port_name: 'SALAMIS',
            wni_unlocode: 'GRAGI',
            wni_country: 'GR',
            wni_lat: 37.97,
            wni_lon: 23.48,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'SPTSS',
            wni_port_name: 'SPETSAI',
            wni_unlocode: 'GRHYD',
            wni_country: 'GR',
            wni_lat: 37.27,
            wni_lon: 23.17,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'STLS',
            wni_port_name: 'STILIS',
            wni_unlocode: 'GRLAM',
            wni_country: 'GR',
            wni_lat: 38.92,
            wni_lon: 22.62,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'STONI',
            wni_port_name: 'ORMOS STRATONI',
            wni_unlocode: 'GRSTI',
            wni_country: 'GR',
            wni_lat: 40.52,
            wni_lon: 23.83,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'THSS',
            wni_port_name: 'THASOS',
            wni_unlocode: 'GRNKV',
            wni_country: 'GR',
            wni_lat: 40.78,
            wni_lon: 24.7,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'TINOS',
            wni_port_name: 'TINOS',
            wni_unlocode: 'GRJMK',
            wni_country: 'GR',
            wni_lat: 37.53,
            wni_lon: 25.17,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'TLI',
            wni_port_name: 'TSINGELI',
            wni_unlocode: 'GRAPL',
            wni_country: 'GR',
            wni_lat: 39.17,
            wni_lon: 22.85,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'VATH',
            wni_port_name: 'ORMOS VATHI',
            wni_unlocode: 'GRQKG',
            wni_country: 'GR',
            wni_lat: 38.43,
            wni_lon: 23.6,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'VATHI',
            wni_port_name: 'ORMOS VATHI',
            wni_unlocode: 'GRSMI',
            wni_country: 'GR',
            wni_lat: 37.75,
            wni_lon: 26.97,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'VRSK',
            wni_port_name: 'VRISAKIA',
            wni_unlocode: 'GRQKG',
            wni_country: 'GR',
            wni_lat: 38.57,
            wni_lon: 23.6,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'YTHN',
            wni_port_name: 'YITHION',
            wni_unlocode: 'GRGYT',
            wni_country: 'GR',
            wni_lat: 36.75,
            wni_lon: 22.57,
            wni_tz: 'Europe/Athens',
        },
        {
            option: 'HRBRP',
            wni_port_name: 'PRINCE OLAV HARBOR',
            wni_unlocode: 'GSGRV',
            wni_country: 'GS',
            wni_lat: -54.03,
            wni_lon: -37.15,
            wni_tz: 'Atlantic/South_Georgia',
        },
        {
            option: 'LVGST',
            wni_port_name: 'LIVINGSTON',
            wni_unlocode: 'GTPBR',
            wni_country: 'GT',
            wni_lat: 15.83,
            wni_lon: -88.75,
            wni_tz: 'America/Guatemala',
        },
        {
            option: 'APR',
            wni_port_name: 'APRA HARBOR',
            wni_unlocode: 'GUGUM',
            wni_country: 'GU',
            wni_lat: 13.45,
            wni_lon: 144.62,
            wni_tz: 'Pacific/Guam',
        },
        {
            option: 'CCHEO',
            wni_port_name: 'CACHEO',
            wni_unlocode: 'SNZIG',
            wni_country: 'GW',
            wni_lat: 12.28,
            wni_lon: -16.23,
            wni_tz: 'Africa/Bissau',
        },
        {
            option: 'WNL',
            wni_port_name: 'WANG LAN',
            wni_unlocode: 'HKKTZ',
            wni_country: 'HK',
            wni_lat: 22.31,
            wni_lon: 114.21,
            wni_tz: 'Asia/Hong_Kong',
        },
        {
            option: 'AMX',
            wni_port_name: 'AMAPALA',
            wni_unlocode: 'SVCUT',
            wni_country: 'HN',
            wni_lat: 13.3,
            wni_lon: -87.65,
            wni_tz: 'America/Tegucigalpa',
        },
        {
            option: 'GNJ',
            wni_port_name: 'GUANAJA',
            wni_unlocode: 'HNPCA',
            wni_country: 'HN',
            wni_lat: 16.43,
            wni_lon: -85.92,
            wni_tz: 'America/Tegucigalpa',
        },
        {
            option: 'HEN',
            wni_port_name: 'PUERTO HENECAN',
            wni_unlocode: 'HNSLO',
            wni_country: 'HN',
            wni_lat: 13.4,
            wni_lon: -87.45,
            wni_tz: 'America/Tegucigalpa',
        },
        {
            option: 'PRTE',
            wni_port_name: 'PUERTO ESTE',
            wni_unlocode: 'HNLCE',
            wni_country: 'HN',
            wni_lat: 16.1,
            wni_lon: -86.9,
            wni_tz: 'America/Tegucigalpa',
        },
        {
            option: 'TRJH',
            wni_port_name: 'TRUJILLO',
            wni_unlocode: 'HNPCA',
            wni_country: 'HN',
            wni_lat: 15.92,
            wni_lon: -85.95,
            wni_tz: 'America/Tegucigalpa',
        },
        {
            option: 'BRICA',
            wni_port_name: 'BRSICA',
            wni_unlocode: 'HRRAS',
            wni_country: 'HR',
            wni_lat: 45.03,
            wni_lon: 14.05,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'DGI',
            wni_port_name: 'DUGIRAT',
            wni_unlocode: 'HRDUR',
            wni_country: 'HR',
            wni_lat: 43.44,
            wni_lon: 16.64,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'FNTNA',
            wni_port_name: 'FUNTANA',
            wni_unlocode: 'HRROV',
            wni_country: 'HR',
            wni_lat: 45.18,
            wni_lon: 13.6,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'GRUZ',
            wni_port_name: 'LUKA GRUZ',
            wni_unlocode: 'HRDBV',
            wni_country: 'HR',
            wni_lat: 42.67,
            wni_lon: 18.08,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'KRNC',
            wni_port_name: 'KRNICA',
            wni_unlocode: 'HRKRM',
            wni_country: 'HR',
            wni_lat: 44.95,
            wni_lon: 14.03,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'MIRNA',
            wni_port_name: 'LUKA MIRNA',
            wni_unlocode: 'SIPIR',
            wni_country: 'HR',
            wni_lat: 45.3,
            wni_lon: 13.57,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'NVIGD',
            wni_port_name: 'NOVIGRAD',
            wni_unlocode: 'SIPIR',
            wni_country: 'HR',
            wni_lat: 45.32,
            wni_lon: 13.55,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'NVIHR',
            wni_port_name: 'LUKA NOVI',
            wni_unlocode: 'HRSEN',
            wni_country: 'HR',
            wni_lat: 45.13,
            wni_lon: 14.78,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'PAGHR',
            wni_port_name: 'PAG',
            wni_unlocode: 'HRZAD',
            wni_country: 'HR',
            wni_lat: 44.45,
            wni_lon: 15.05,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'POREC',
            wni_port_name: 'LUKA POREC',
            wni_unlocode: 'HRROV',
            wni_country: 'HR',
            wni_lat: 45.23,
            wni_lon: 13.58,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'PRP',
            wni_port_name: 'LUKA CRES',
            wni_unlocode: 'HRKRM',
            wni_country: 'HR',
            wni_lat: 44.97,
            wni_lon: 14.4,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'SDRST',
            wni_port_name: 'SIDRISTE OMIS',
            wni_unlocode: 'HRDUR',
            wni_country: 'HR',
            wni_lat: 43.45,
            wni_lon: 16.7,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'SENJ',
            wni_port_name: 'LUKA SENJ',
            wni_unlocode: 'HRSEN',
            wni_country: 'HR',
            wni_lat: 44.98,
            wni_lon: 14.9,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'SVETI',
            wni_port_name: 'SVETI KAJO',
            wni_unlocode: 'HRSLN',
            wni_country: 'HR',
            wni_lat: 43.53,
            wni_lon: 16.47,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'TLRB',
            wni_port_name: 'OTOK RAB',
            wni_unlocode: 'HRSEN',
            wni_country: 'HR',
            wni_lat: 44.75,
            wni_lon: 14.77,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'UMAG',
            wni_port_name: 'UMAG',
            wni_unlocode: 'SIPIR',
            wni_country: 'HR',
            wni_lat: 45.43,
            wni_lon: 13.52,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'VRNJC',
            wni_port_name: 'VRANJIC',
            wni_unlocode: 'HRSLN',
            wni_country: 'HR',
            wni_lat: 43.53,
            wni_lon: 16.47,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'VRSAR',
            wni_port_name: 'VRSAR',
            wni_unlocode: 'HRROV',
            wni_country: 'HR',
            wni_lat: 45.15,
            wni_lon: 13.6,
            wni_tz: 'Europe/Zagreb',
        },
        {
            option: 'AQUIN',
            wni_port_name: 'AQUIN',
            wni_unlocode: 'HTMIR',
            wni_country: 'HT',
            wni_lat: 18.27,
            wni_lon: -73.38,
            wni_tz: 'America/Port-au-Prince',
        },
        {
            option: 'GOAVE',
            wni_port_name: 'PETIT GOAVE',
            wni_unlocode: 'HTMIR',
            wni_country: 'HT',
            wni_lat: 18.43,
            wni_lon: -72.87,
            wni_tz: 'America/Port-au-Prince',
        },
        {
            option: 'JCML',
            wni_port_name: 'JACMEL',
            wni_unlocode: 'HTPAP',
            wni_country: 'HT',
            wni_lat: 18.23,
            wni_lon: -72.52,
            wni_tz: 'America/Port-au-Prince',
        },
        {
            option: 'LAF',
            wni_port_name: 'LAFITEAU',
            wni_unlocode: 'HTLFF',
            wni_country: 'HT',
            wni_lat: 18.69,
            wni_lon: -72.36,
            wni_tz: 'America/Port-au-Prince',
        },
        {
            option: 'ADAUT',
            wni_port_name: 'ADAUT',
            wni_unlocode: 'IDSXK',
            wni_country: 'ID',
            wni_lat: -8.13,
            wni_lon: 131.12,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'AKSLK',
            wni_port_name: 'AKESELAKA',
            wni_unlocode: 'IDSBM',
            wni_country: 'ID',
            wni_lat: 1.03,
            wni_lon: 127.95,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'AMPNN',
            wni_port_name: 'AMPENAN',
            wni_unlocode: 'IDAMP',
            wni_country: 'ID',
            wni_lat: -8.57,
            wni_lon: 116.07,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'ARANG',
            wni_port_name: 'TANJUNG ARANG',
            wni_unlocode: 'IDBYQ',
            wni_country: 'ID',
            wni_lat: 3.47,
            wni_lon: 117.87,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'BABO',
            wni_port_name: 'BABO',
            wni_unlocode: 'IDNTI',
            wni_country: 'ID',
            wni_lat: -2.55,
            wni_lon: 133.43,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'BBD',
            wni_port_name: 'BADE',
            wni_unlocode: 'IDASI',
            wni_country: 'ID',
            wni_lat: -7.18,
            wni_lon: 139.59,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'BEE',
            wni_port_name: 'BERAU',
            wni_unlocode: 'IDBXT',
            wni_country: 'ID',
            wni_lat: 0.24,
            wni_lon: 117.29,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'BENOA',
            wni_port_name: 'BENOA BARU',
            wni_unlocode: 'IDSKI',
            wni_country: 'ID',
            wni_lat: 0.98,
            wni_lon: 117.97,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'BESKI',
            wni_port_name: 'BESUKI',
            wni_unlocode: 'IDPAI',
            wni_country: 'ID',
            wni_lat: -7.73,
            wni_lon: 113.68,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'BGL',
            wni_port_name: 'BENGALON',
            wni_unlocode: 'IDLTT',
            wni_country: 'ID',
            wni_lat: 0.76,
            wni_lon: 117.76,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'BGO',
            wni_port_name: 'BATUGONG',
            wni_unlocode: 'IDAMQ',
            wni_country: 'ID',
            wni_lat: -3.64,
            wni_lon: 128.26,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'BNDJR',
            wni_port_name: 'BANDJERMASIN',
            wni_unlocode: 'IDPUT',
            wni_country: 'ID',
            wni_lat: -3.3,
            wni_lon: 116.15,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'BOJ',
            wni_port_name: 'BOJONEGARA',
            wni_unlocode: 'IDSER',
            wni_country: 'ID',
            wni_lat: -5.98,
            wni_lon: 106.12,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'BSI',
            wni_port_name: 'BIRINGKASSI',
            wni_unlocode: 'IDBIR',
            wni_country: 'ID',
            wni_lat: -4.82,
            wni_lon: 119.49,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'BUKBT',
            wni_port_name: 'BUKITBATU',
            wni_unlocode: 'INDKI',
            wni_country: 'ID',
            wni_lat: 1.47,
            wni_lon: 102,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'BULNG',
            wni_port_name: 'BULELENG',
            wni_unlocode: 'IDCEB',
            wni_country: 'ID',
            wni_lat: -8.1,
            wni_lon: 115.1,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'CIG',
            wni_port_name: 'CILEGON',
            wni_unlocode: 'IDCIG',
            wni_country: 'ID',
            wni_lat: -6.01,
            wni_lon: 105.96,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'DJPR',
            wni_port_name: 'KALI DJAPARA',
            wni_unlocode: 'IDSRG',
            wni_country: 'ID',
            wni_lat: -6.58,
            wni_lon: 110.67,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'DNGGL',
            wni_port_name: 'DONGGALA',
            wni_unlocode: 'IDPTL',
            wni_country: 'ID',
            wni_lat: -0.65,
            wni_lon: 119.73,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'EMAS',
            wni_port_name: 'TANJUNG EMAS',
            wni_unlocode: 'IDSRG',
            wni_country: 'ID',
            wni_lat: -6.94,
            wni_lon: 110.42,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'GAJAM',
            wni_port_name: 'GAJAM',
            wni_unlocode: 'IDKAT',
            wni_country: 'ID',
            wni_lat: -7.17,
            wni_lon: 114.33,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'GALLA',
            wni_port_name: 'GALELA',
            wni_unlocode: 'IDTBO',
            wni_country: 'ID',
            wni_lat: 1.83,
            wni_lon: 127.85,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'GEREM',
            wni_port_name: 'TANJUNG GEREM',
            wni_unlocode: 'IDPNT',
            wni_country: 'ID',
            wni_lat: -5.97,
            wni_lon: 105.99,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'HNSSI',
            wni_port_name: 'HANSISI',
            wni_unlocode: 'IDKOE',
            wni_country: 'ID',
            wni_lat: -10.18,
            wni_lon: 123.5,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'IBT',
            wni_port_name: 'IBT (INDONESIA BULK TERMINAL)',
            wni_unlocode: 'BRIBT',
            wni_country: 'ID',
            wni_lat: -4.03,
            wni_lon: 115.98,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'IRI',
            wni_port_name: 'IRIAN JAYA',
            wni_unlocode: 'IDNTI',
            wni_country: 'ID',
            wni_lat: -2.34,
            wni_lon: 132.82,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'JEBUS',
            wni_port_name: 'JEBUS',
            wni_unlocode: 'IDMUO',
            wni_country: 'ID',
            wni_lat: -1.75,
            wni_lon: 105.45,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'KAUI',
            wni_port_name: 'KAU',
            wni_unlocode: 'IDSBM',
            wni_country: 'ID',
            wni_lat: 1.17,
            wni_lon: 127.92,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'KAUID',
            wni_port_name: 'KAU',
            wni_unlocode: 'IDSBM',
            wni_country: 'ID',
            wni_lat: 1.17,
            wni_lon: 127.92,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'KLND',
            wni_port_name: 'KALIANDA',
            wni_unlocode: 'IDTRH',
            wni_country: 'ID',
            wni_lat: -5.75,
            wni_lon: 105.6,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'KMAID',
            wni_port_name: 'KEMA',
            wni_unlocode: 'IDBIT',
            wni_country: 'ID',
            wni_lat: 1.37,
            wni_lon: 125.08,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'KRG',
            wni_port_name: 'KRUENG RAYA',
            wni_unlocode: 'IDBTJ',
            wni_country: 'ID',
            wni_lat: 5.6,
            wni_lon: 95.53,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'KUAND',
            wni_port_name: 'KUANDANG',
            wni_unlocode: 'IDGTO',
            wni_country: 'ID',
            wni_lat: 0.85,
            wni_lon: 122.92,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'LAIW',
            wni_port_name: 'LAIWUI',
            wni_unlocode: 'IDOBI',
            wni_country: 'ID',
            wni_lat: -1.33,
            wni_lon: 127.63,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'LAMBG',
            wni_port_name: 'LAMOBUANG',
            wni_unlocode: 'IDBGG',
            wni_country: 'ID',
            wni_lat: -1.32,
            wni_lon: 123.32,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'LBAJO',
            wni_port_name: 'LABUHANBAJO',
            wni_unlocode: 'IDKOI',
            wni_country: 'ID',
            wni_lat: -8.48,
            wni_lon: 119.88,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'LBHNH',
            wni_port_name: 'LABUHANHAJI',
            wni_unlocode: 'IDBEN',
            wni_country: 'ID',
            wni_lat: -8.7,
            wni_lon: 116.57,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'LKSL',
            wni_port_name: 'LEKSULA',
            wni_unlocode: 'IDWSS',
            wni_country: 'ID',
            wni_lat: -3.78,
            wni_lon: 126.52,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'LNGKS',
            wni_port_name: 'LINGKAS ROAD',
            wni_unlocode: 'IDTRK',
            wni_country: 'ID',
            wni_lat: 3.28,
            wni_lon: 117.6,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'MATA',
            wni_port_name: 'MATA',
            wni_unlocode: 'IDLKA',
            wni_country: 'ID',
            wni_lat: -8.2,
            wni_lon: 122.94,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'MNGGR',
            wni_port_name: 'MANGGAR',
            wni_unlocode: 'IDBLT',
            wni_country: 'ID',
            wni_lat: -2.88,
            wni_lon: 108.3,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'MNGKS',
            wni_port_name: 'MANGKASA',
            wni_unlocode: 'IDMLI',
            wni_country: 'ID',
            wni_lat: -2.73,
            wni_lon: 121.07,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'MONK',
            wni_port_name: 'MONOKWARI',
            wni_unlocode: 'IDMKW',
            wni_country: 'ID',
            wni_lat: -0.87,
            wni_lon: 134.08,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'MRNGS',
            wni_port_name: 'TANJUNG MERANGAS',
            wni_unlocode: 'IDBXT',
            wni_country: 'ID',
            wni_lat: 0.03,
            wni_lon: 117.54,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'MRO',
            wni_port_name: 'MORO',
            wni_unlocode: 'ID_KA',
            wni_country: 'ID',
            wni_lat: 0.76,
            wni_lon: 103.7,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'PAE',
            wni_port_name: 'PAREPARE',
            wni_unlocode: 'IDPAP',
            wni_country: 'ID',
            wni_lat: -4.02,
            wni_lon: 119.62,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'PCTL',
            wni_port_name: 'PETRO CHINA TERMINAL',
            wni_unlocode: 'IDKAB',
            wni_country: 'ID',
            wni_lat: 0.9,
            wni_lon: 104.06,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'PDNT',
            wni_port_name: 'PADANGTIKAR',
            wni_unlocode: 'IDTKA',
            wni_country: 'ID',
            wni_lat: -0.71,
            wni_lon: 109.25,
            wni_tz: 'Asia/Pontianak',
        },
        {
            option: 'PEK',
            wni_port_name: 'PAKANBARU',
            wni_unlocode: 'IDPKU',
            wni_country: 'ID',
            wni_lat: 0.54,
            wni_lon: 101.45,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'PGB',
            wni_port_name: 'PANGKALANBUNN',
            wni_unlocode: 'IDKUM',
            wni_country: 'ID',
            wni_lat: -2.69,
            wni_lon: 111.62,
            wni_tz: 'Asia/Pontianak',
        },
        {
            option: 'PNDNI',
            wni_port_name: 'TANJUNGPANDAN',
            wni_unlocode: 'IDTJQ',
            wni_country: 'ID',
            wni_lat: -2.75,
            wni_lon: 107.63,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'PNGKL',
            wni_port_name: 'PANGKALPINANG',
            wni_unlocode: 'IDPGX',
            wni_country: 'ID',
            wni_lat: -2.12,
            wni_lon: 106.13,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'PNGMN',
            wni_port_name: 'PANGIMANAN',
            wni_unlocode: 'IDLUW',
            wni_country: 'ID',
            wni_lat: -0.78,
            wni_lon: 122.65,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'PRAK',
            wni_port_name: 'TANJUNGPERAK',
            wni_unlocode: 'IDSUB',
            wni_country: 'ID',
            wni_lat: -7.19,
            wni_lon: 112.73,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'PRBGN',
            wni_port_name: 'PERBAUNGAN',
            wni_unlocode: 'IDMES',
            wni_country: 'ID',
            wni_lat: 3.63,
            wni_lon: 98.98,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'PRMN',
            wni_port_name: 'PARIAMAN',
            wni_unlocode: 'IDPDG',
            wni_country: 'ID',
            wni_lat: -0.63,
            wni_lon: 100.1,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'PSN',
            wni_port_name: 'PASURUAN',
            wni_unlocode: 'IDPRO',
            wni_country: 'ID',
            wni_lat: -7.62,
            wni_lon: 112.92,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'REDEB',
            wni_port_name: 'TANJUNGREDEB',
            wni_unlocode: 'IDMKJ',
            wni_country: 'ID',
            wni_lat: 2.17,
            wni_lon: 117.48,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'RSP',
            wni_port_name: 'ROTI',
            wni_unlocode: 'IDKOE',
            wni_country: 'ID',
            wni_lat: -10.47,
            wni_lon: 123.4,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'SAPE',
            wni_port_name: 'TELUK SAPE',
            wni_unlocode: 'IDBMU',
            wni_country: 'ID',
            wni_lat: -8.55,
            wni_lon: 119.03,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'SEKA',
            wni_port_name: 'SENAKIN',
            wni_unlocode: 'IDKBU',
            wni_country: 'ID',
            wni_lat: -3.02,
            wni_lon: 116.19,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'SLLF',
            wni_port_name: 'KAMPUNG SAILOLOF',
            wni_unlocode: 'IDKAS',
            wni_country: 'ID',
            wni_lat: -1.25,
            wni_lon: 130.75,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'SLW',
            wni_port_name: 'SALAWATI',
            wni_unlocode: 'IDKAS',
            wni_country: 'ID',
            wni_lat: -1.35,
            wni_lon: 130.98,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'SMNP',
            wni_port_name: 'SUMENEP',
            wni_unlocode: 'IDKAT',
            wni_country: 'ID',
            wni_lat: -7,
            wni_lon: 113.87,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'SNGGR',
            wni_port_name: 'SUNGAIGERONG',
            wni_unlocode: 'IDSUG',
            wni_country: 'ID',
            wni_lat: -2.98,
            wni_lon: 104.83,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'SOPL',
            wni_port_name: 'SOUTH PULAU LAUT',
            wni_unlocode: 'IDSTU',
            wni_country: 'ID',
            wni_lat: -4.02,
            wni_lon: 115.59,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'STGN',
            wni_port_name: 'STAGEN',
            wni_unlocode: 'IDPUT',
            wni_country: 'ID',
            wni_lat: -3.3,
            wni_lon: 116.15,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'STNKL',
            wni_port_name: 'STEENKOOL',
            wni_unlocode: 'IDNTI',
            wni_country: 'ID',
            wni_lat: -2.12,
            wni_lon: 133.52,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'TBE',
            wni_port_name: 'TAMBEA',
            wni_unlocode: 'IDKOL',
            wni_country: 'ID',
            wni_lat: -4.18,
            wni_lon: 121.6,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'TBW',
            wni_port_name: 'TRANS BAKRIE WHARF',
            wni_unlocode: 'IDSER',
            wni_country: 'ID',
            wni_lat: -5.88,
            wni_lon: 106.08,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'TEB',
            wni_port_name: 'TELUKBAYUR',
            wni_unlocode: 'IDTBR',
            wni_country: 'ID',
            wni_lat: -1,
            wni_lon: 100.37,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'TELUS',
            wni_port_name: 'TELUK SAPE',
            wni_unlocode: 'IDBMU',
            wni_country: 'ID',
            wni_lat: -8.55,
            wni_lon: 119.03,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'TIFU',
            wni_port_name: 'TIFU',
            wni_unlocode: 'IDWSS',
            wni_country: 'ID',
            wni_lat: -3.72,
            wni_lon: 126.4,
            wni_tz: 'Asia/Jayapura',
        },
        {
            option: 'TJE',
            wni_port_name: 'TANJUNG EMAS',
            wni_unlocode: 'IDSRG',
            wni_country: 'ID',
            wni_lat: -6.94,
            wni_lon: 110.42,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'TJK',
            wni_port_name: 'TANJUNGPERAK',
            wni_unlocode: 'IDSUB',
            wni_country: 'ID',
            wni_lat: -7.19,
            wni_lon: 112.73,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'TJM',
            wni_port_name: 'TANJUNG MERANGAS',
            wni_unlocode: 'IDBXT',
            wni_country: 'ID',
            wni_lat: 0.03,
            wni_lon: 117.54,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'TJPG',
            wni_port_name: 'TANJUNGPINANG',
            wni_unlocode: 'IDTNJ',
            wni_country: 'ID',
            wni_lat: 0.92,
            wni_lon: 104.45,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'TJR',
            wni_port_name: 'TANJUNGREDEB',
            wni_unlocode: 'IDMKJ',
            wni_country: 'ID',
            wni_lat: 2.17,
            wni_lon: 117.48,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'TOTOK',
            wni_port_name: 'TELUK TOTOK',
            wni_unlocode: 'IDTZD',
            wni_country: 'ID',
            wni_lat: 0.87,
            wni_lon: 124.72,
            wni_tz: 'Asia/Makassar',
        },
        {
            option: 'UBANI',
            wni_port_name: 'TANJUNGUBAN',
            wni_unlocode: 'IDITN',
            wni_country: 'ID',
            wni_lat: 1.08,
            wni_lon: 104.22,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'UDG',
            wni_port_name: 'UDANG',
            wni_unlocode: 'IDBNT',
            wni_country: 'ID',
            wni_lat: 4.07,
            wni_lon: 106.41,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'ULLH',
            wni_port_name: 'ULEELHEUE',
            wni_unlocode: 'IDBTJ',
            wni_country: 'ID',
            wni_lat: 5.57,
            wni_lon: 95.28,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'BKSOD',
            wni_port_name: 'BLACKSOD POINT',
            wni_unlocode: 'IEWES',
            wni_country: 'IE',
            wni_lat: 54.1,
            wni_lon: -10.07,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'CLFDN',
            wni_port_name: 'CLIFDEN',
            wni_unlocode: 'IEKIN',
            wni_country: 'IE',
            wni_lat: 53.48,
            wni_lon: -10.02,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'CRKHV',
            wni_port_name: 'CROOKHAVEN',
            wni_unlocode: 'IEBTM',
            wni_country: 'IE',
            wni_lat: 51.47,
            wni_lon: -9.7,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'DNGL',
            wni_port_name: 'DONEGAL',
            wni_unlocode: 'IEKBS',
            wni_country: 'IE',
            wni_lat: 54.65,
            wni_lon: -8.12,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'GLNDR',
            wni_port_name: 'GLANDORE',
            wni_unlocode: 'IEBTM',
            wni_country: 'IE',
            wni_lat: 51.55,
            wni_lon: -9.12,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'GLNGR',
            wni_port_name: 'GLENGARIFF',
            wni_unlocode: 'IEBYT',
            wni_country: 'IE',
            wni_lat: 51.7,
            wni_lon: -9.53,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'KBG',
            wni_port_name: 'KILLEYBEGS',
            wni_unlocode: 'IEKBS',
            wni_country: 'IE',
            wni_lat: 54.63,
            wni_lon: -8.45,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'RTMLL',
            wni_port_name: 'RATHMULLAN',
            wni_unlocode: 'IERAT',
            wni_country: 'IE',
            wni_lat: 55.1,
            wni_lon: -7.53,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'SCLL',
            wni_port_name: 'SKULL',
            wni_unlocode: 'IEBTM',
            wni_country: 'IE',
            wni_lat: 51.52,
            wni_lon: -9.53,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'SHNN',
            wni_port_name: 'SHANNON',
            wni_unlocode: 'IECLC',
            wni_country: 'IE',
            wni_lat: 52.71,
            wni_lon: -8.88,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'VLCA',
            wni_port_name: 'VALENCIA HARBOR',
            wni_unlocode: 'IECHE',
            wni_country: 'IE',
            wni_lat: 51.93,
            wni_lon: -10.28,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'VNTRY',
            wni_port_name: 'VENTRY',
            wni_unlocode: 'IECHE',
            wni_country: 'IE',
            wni_lat: 52.12,
            wni_lon: -10.33,
            wni_tz: 'Europe/Dublin',
        },
        {
            option: 'HERZ',
            wni_port_name: 'HERZLIYA',
            wni_unlocode: 'ILHAD',
            wni_country: 'IL',
            wni_lat: 32.16,
            wni_lon: 34.8,
            wni_tz: 'Asia/Jerusalem',
        },
        {
            option: 'TELV',
            wni_port_name: 'TEL AVIV YAFO',
            wni_unlocode: 'ILASH',
            wni_country: 'IL',
            wni_lat: 32.07,
            wni_lon: 34.77,
            wni_tz: 'Asia/Jerusalem',
        },
        {
            option: 'ERIN',
            wni_port_name: 'PORT ERIN',
            wni_unlocode: 'GBPSM',
            wni_country: 'IM',
            wni_lat: 54.08,
            wni_lon: -4.77,
            wni_tz: 'Europe/Isle_of_Man',
        },
        {
            option: 'AKH',
            wni_port_name: 'SAKHRI',
            wni_unlocode: 'INDHP',
            wni_country: 'IN',
            wni_lat: 17.59,
            wni_lon: 73.2,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'ALPPZ',
            wni_port_name: 'ALLEPPEY',
            wni_unlocode: 'INALF',
            wni_country: 'IN',
            wni_lat: 9.48,
            wni_lon: 76.32,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'AZHKL',
            wni_port_name: 'AZHIKAL',
            wni_unlocode: 'INCNN',
            wni_country: 'IN',
            wni_lat: 11.92,
            wni_lon: 75.4,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'BDG',
            wni_port_name: 'BUDGE-BUDGE',
            wni_unlocode: 'INCCU',
            wni_country: 'IN',
            wni_lat: 22.49,
            wni_lon: 88.2,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'CDP',
            wni_port_name: 'COONDAPOOR',
            wni_unlocode: 'INKUD',
            wni_country: 'IN',
            wni_lat: 13.63,
            wni_lon: 74.69,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'CLH',
            wni_port_name: 'KOLACHEL',
            wni_unlocode: 'INTRV',
            wni_country: 'IN',
            wni_lat: 8.17,
            wni_lon: 77.25,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'DIU',
            wni_port_name: 'DIU HARBOR',
            wni_unlocode: 'INMDK',
            wni_country: 'IN',
            wni_lat: 20.72,
            wni_lon: 71,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'KOLLA',
            wni_port_name: 'QUILON',
            wni_unlocode: 'INNEE',
            wni_country: 'IN',
            wni_lat: 8.88,
            wni_lon: 76.58,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'MAHE',
            wni_port_name: 'MAHE',
            wni_unlocode: 'INTEL',
            wni_country: 'IN',
            wni_lat: 11.7,
            wni_lon: 75.53,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'MAM',
            wni_port_name: 'MARMAGAO BAY',
            wni_unlocode: 'INMRM',
            wni_country: 'IN',
            wni_lat: 15.43,
            wni_lon: 73.8,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'RATN',
            wni_port_name: 'RATNAGIRI BAY',
            wni_unlocode: 'INRTC',
            wni_country: 'IN',
            wni_lat: 16.98,
            wni_lon: 73.28,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'TADRI',
            wni_port_name: 'TADRI RIVER',
            wni_unlocode: 'INTAD',
            wni_country: 'IN',
            wni_lat: 14.52,
            wni_lon: 74.33,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'VSC',
            wni_port_name: 'VASCO',
            wni_unlocode: 'INMRM',
            wni_country: 'IN',
            wni_lat: 15.41,
            wni_lon: 73.8,
            wni_tz: 'Asia/Kolkata',
        },
        {
            option: 'FAO',
            wni_port_name: 'AL FAW',
            wni_unlocode: 'IQFAO',
            wni_country: 'IQ',
            wni_lat: 29.97,
            wni_lon: 48.48,
            wni_tz: 'Asia/Baghdad',
        },
        {
            option: 'BTH',
            wni_port_name: 'BANDAR TAHERI',
            wni_unlocode: 'IRBAH',
            wni_country: 'IR',
            wni_lat: 27.66,
            wni_lon: 52.35,
            wni_tz: 'Asia/Tehran',
        },
        {
            option: 'CBH',
            wni_port_name: 'CHAH BAHAR',
            wni_unlocode: 'IRCI3',
            wni_country: 'IR',
            wni_lat: 25.27,
            wni_lon: 60.62,
            wni_tz: 'Asia/Tehran',
        },
        {
            option: 'HMZ',
            wni_port_name: 'JAZIREH YE HORMOS',
            wni_unlocode: 'IRBND',
            wni_country: 'IR',
            wni_lat: 27.1,
            wni_lon: 56.45,
            wni_tz: 'Asia/Tehran',
        },
        {
            option: 'KHSRW',
            wni_port_name: 'KHOSROWABAD',
            wni_unlocode: 'IRABD',
            wni_country: 'IR',
            wni_lat: 30.17,
            wni_lon: 48.42,
            wni_tz: 'Asia/Tehran',
        },
        {
            option: 'SIRUS',
            wni_port_name: 'SIRUS TERMINAL',
            wni_unlocode: 'IRCYT',
            wni_country: 'IR',
            wni_lat: 29.02,
            wni_lon: 49.47,
            wni_tz: 'Asia/Tehran',
        },
        {
            option: 'BDRYR',
            wni_port_name: 'BUDAREYRI',
            wni_unlocode: 'ISRFJ',
            wni_country: 'IS',
            wni_lat: 65.03,
            wni_lon: -14.22,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'BKKGR',
            wni_port_name: 'BAKKAGERDHI',
            wni_unlocode: 'ISSEY',
            wni_country: 'IS',
            wni_lat: 65.53,
            wni_lon: -13.82,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'BLDS',
            wni_port_name: 'BLONDUOS',
            wni_unlocode: 'ISSKA',
            wni_country: 'IS',
            wni_lat: 65.67,
            wni_lon: -20.3,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'BRGRN',
            wni_port_name: 'BORGARNES',
            wni_unlocode: 'ISHVR',
            wni_country: 'IS',
            wni_lat: 64.53,
            wni_lon: -21.93,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'BRKKA',
            wni_port_name: 'BREKKA',
            wni_unlocode: 'ISSEY',
            wni_country: 'IS',
            wni_lat: 65.2,
            wni_lon: -13.8,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'BUDIR',
            wni_port_name: 'BUDIR',
            wni_unlocode: 'ISFAS',
            wni_country: 'IS',
            wni_lat: 64.93,
            wni_lon: -14.02,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'EYRR',
            wni_port_name: 'EYRARBAKKI',
            wni_unlocode: 'ISHAF',
            wni_country: 'IS',
            wni_lat: 63.87,
            wni_lon: -21.15,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'FJA',
            wni_port_name: 'FJARDAAL',
            wni_unlocode: 'ISRFJ',
            wni_country: 'IS',
            wni_lat: 65.03,
            wni_lon: -14.22,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'FLTYR',
            wni_port_name: 'FLATEYRI',
            wni_unlocode: 'ISISA',
            wni_country: 'IS',
            wni_lat: 66.05,
            wni_lon: -23.52,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'HJLTY',
            wni_port_name: 'HJALTEYRI',
            wni_unlocode: 'ISGRE',
            wni_country: 'IS',
            wni_lat: 65.85,
            wni_lon: -18.2,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'KPSKR',
            wni_port_name: 'KOPASKER',
            wni_unlocode: 'ISRAU',
            wni_country: 'IS',
            wni_lat: 66.28,
            wni_lon: -16.45,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'KPV',
            wni_port_name: 'KOPAVOGUR',
            wni_unlocode: 'ISKJF',
            wni_country: 'IS',
            wni_lat: 64.11,
            wni_lon: -21.91,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'KRKJB',
            wni_port_name: 'KIRKJUBOL',
            wni_unlocode: 'ISSTD',
            wni_country: 'IS',
            wni_lat: 64.83,
            wni_lon: -13.88,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'NJA',
            wni_port_name: 'NJARDVIK',
            wni_unlocode: 'ISKEF',
            wni_country: 'IS',
            wni_lat: 63.99,
            wni_lon: -22.54,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'OLFSF',
            wni_port_name: 'OLAFSFJORHUR',
            wni_unlocode: 'ISSIG',
            wni_country: 'IS',
            wni_lat: 66.08,
            wni_lon: -18.63,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'SGLFJ',
            wni_port_name: 'SIGLUFJORHUR',
            wni_unlocode: 'ISSIG',
            wni_country: 'IS',
            wni_lat: 66.15,
            wni_lon: -18.92,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'STKKS',
            wni_port_name: 'STOKKSEYRI',
            wni_unlocode: 'ISHAF',
            wni_country: 'IS',
            wni_lat: 63.83,
            wni_lon: -21.08,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'SYDHS',
            wni_port_name: 'SEYDHISFJORDHUR',
            wni_unlocode: 'ISSEY',
            wni_country: 'IS',
            wni_lat: 65.27,
            wni_lon: -14,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'THNGY',
            wni_port_name: 'THINGEYRI',
            wni_unlocode: 'ISISA',
            wni_country: 'IS',
            wni_lat: 65.88,
            wni_lon: -23.48,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'THRSH',
            wni_port_name: 'THORSHOFN',
            wni_unlocode: 'ISRAU',
            wni_country: 'IS',
            wni_lat: 66.2,
            wni_lon: -15.33,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'VPNFJ',
            wni_port_name: 'VOPNAFJORDHUR',
            wni_unlocode: 'ISVPN',
            wni_country: 'IS',
            wni_lat: 65.75,
            wni_lon: -14.83,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'VSTMN',
            wni_port_name: 'VESTMANNAEYJAHOFN',
            wni_unlocode: 'ISVES',
            wni_country: 'IS',
            wni_lat: 63.43,
            wni_lon: -20.28,
            wni_tz: 'Atlantic/Reykjavik',
        },
        {
            option: 'ADR',
            wni_port_name: 'ADRIA',
            wni_unlocode: 'ITPVT',
            wni_country: 'IT',
            wni_lat: 45.06,
            wni_lon: 12.06,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'AGRPL',
            wni_port_name: 'AGROPOLI',
            wni_unlocode: 'ITSAL',
            wni_country: 'IT',
            wni_lat: 40.35,
            wni_lon: 14.98,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'ALSS',
            wni_port_name: 'ALASSIO',
            wni_unlocode: 'ITIMP',
            wni_country: 'IT',
            wni_lat: 44,
            wni_lon: 8.17,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'AMLF',
            wni_port_name: 'AMALFI',
            wni_unlocode: 'ITCAS',
            wni_country: 'IT',
            wni_lat: 40.63,
            wni_lon: 14.6,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'ANZI',
            wni_port_name: 'ANZIO',
            wni_unlocode: 'ITTRS',
            wni_country: 'IT',
            wni_lat: 45.6,
            wni_lon: 13.8,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'ARANC',
            wni_port_name: 'GOLFO ARANCI',
            wni_unlocode: 'ITOLB',
            wni_country: 'IT',
            wni_lat: 41,
            wni_lon: 9.63,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'BNDTT',
            wni_port_name: 'SAN BENEDETTO D TRONTO',
            wni_unlocode: 'ITSDB',
            wni_country: 'IT',
            wni_lat: 42.95,
            wni_lon: 13.88,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'BORDI',
            wni_port_name: 'BORDIGHERA',
            wni_unlocode: 'ITSRE',
            wni_country: 'IT',
            wni_lat: 43.78,
            wni_lon: 7.67,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'BOSA',
            wni_port_name: 'BOSA',
            wni_unlocode: 'ITAHO',
            wni_country: 'IT',
            wni_lat: 40.27,
            wni_lon: 8.53,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'BSCGL',
            wni_port_name: 'BISCEGLIE',
            wni_unlocode: 'ITMOL',
            wni_country: 'IT',
            wni_lat: 41.23,
            wni_lon: 16.5,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'CAVO',
            wni_port_name: 'CAVO',
            wni_unlocode: 'ITRMA',
            wni_country: 'IT',
            wni_lat: 42.85,
            wni_lon: 10.43,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'CDMR',
            wni_port_name: 'SENO DI CADIMARE',
            wni_unlocode: 'ITSPE',
            wni_country: 'IT',
            wni_lat: 44.08,
            wni_lon: 9.82,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'CESNT',
            wni_port_name: 'CESENATICO',
            wni_unlocode: 'ITRAN',
            wni_country: 'IT',
            wni_lat: 44.2,
            wni_lon: 12.4,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'CTLMM',
            wni_port_name: 'CASTELLAMMARE DEL GOLFO',
            wni_unlocode: 'ITTPS',
            wni_country: 'IT',
            wni_lat: 38.03,
            wni_lon: 12.87,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'CTNZR',
            wni_port_name: 'CATANZARO',
            wni_unlocode: 'ITVVA',
            wni_country: 'IT',
            wni_lat: 38.9,
            wni_lon: 16.6,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'ERCLE',
            wni_port_name: 'PORT ERCOLE',
            wni_unlocode: 'ITPSS',
            wni_country: 'IT',
            wni_lat: 42.38,
            wni_lon: 11.22,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'FANO',
            wni_port_name: 'FANO',
            wni_unlocode: 'ITPES',
            wni_country: 'IT',
            wni_lat: 43.85,
            wni_lon: 13.02,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'FLCNR',
            wni_port_name: 'PORTO FALCONERA',
            wni_unlocode: 'ITPAL',
            wni_country: 'IT',
            wni_lat: 45.62,
            wni_lon: 12.9,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'FORIO',
            wni_port_name: 'FORIO',
            wni_unlocode: 'ITBAI',
            wni_country: 'IT',
            wni_lat: 40.73,
            wni_lon: 13.87,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'FVGNN',
            wni_port_name: 'FAVIGNANA',
            wni_unlocode: 'ITTPS',
            wni_country: 'IT',
            wni_lat: 37.95,
            wni_lon: 12.32,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'GLNV',
            wni_port_name: 'GIULIANOVA',
            wni_unlocode: 'ITSDB',
            wni_country: 'IT',
            wni_lat: 42.75,
            wni_lon: 13.97,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'GRADO',
            wni_port_name: 'GRADO',
            wni_unlocode: 'ITPNG',
            wni_country: 'IT',
            wni_lat: 45.67,
            wni_lon: 13.37,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'GRAZI',
            wni_port_name: 'LE GRAZIE',
            wni_unlocode: 'ITSPE',
            wni_country: 'IT',
            wni_lat: 44.07,
            wni_lon: 9.83,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'GRBLD',
            wni_port_name: 'PORTO GARIBALDI',
            wni_unlocode: 'ITPCS',
            wni_country: 'IT',
            wni_lat: 44.68,
            wni_lon: 12.25,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'GRNDE',
            wni_port_name: 'MARINA GRANDE',
            wni_unlocode: 'ITPRJ',
            wni_country: 'IT',
            wni_lat: 40.55,
            wni_lon: 14.25,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'GVNNV',
            wni_port_name: 'VILLA SAN GIOVANNI',
            wni_unlocode: 'ITMSN',
            wni_country: 'IT',
            wni_lat: 38.22,
            wni_lon: 15.63,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'INNMR',
            wni_port_name: 'CALA DELL INNAMORATA',
            wni_unlocode: 'ITPAZ',
            wni_country: 'IT',
            wni_lat: 42.72,
            wni_lon: 10.37,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'ISCH',
            wni_port_name: 'ISCHIA',
            wni_unlocode: 'ITBAI',
            wni_country: 'IT',
            wni_lat: 40.73,
            wni_lon: 13.97,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'LEUCA',
            wni_port_name: 'SANTA MARIA DI LEUCA',
            wni_unlocode: 'ITOTO',
            wni_country: 'IT',
            wni_lat: 39.8,
            wni_lon: 18.36,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'LRCI',
            wni_port_name: 'LERICI',
            wni_unlocode: 'ITSPE',
            wni_country: 'IT',
            wni_lat: 44.07,
            wni_lon: 9.92,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'LVNT',
            wni_port_name: 'SESTRI LEVANTE',
            wni_unlocode: 'ITPTF',
            wni_country: 'IT',
            wni_lat: 44.27,
            wni_lon: 9.4,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'MARMI',
            wni_port_name: 'FORTE DEI MARMI',
            wni_unlocode: 'ITMDC',
            wni_country: 'IT',
            wni_lat: 43.95,
            wni_lon: 10.17,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'MASA',
            wni_port_name: 'MARINA DI MASSA',
            wni_unlocode: 'ITMDC',
            wni_country: 'IT',
            wni_lat: 44,
            wni_lon: 10.1,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'MBARI',
            wni_port_name: 'MOLO DI BARI',
            wni_unlocode: 'ITMNP',
            wni_country: 'IT',
            wni_lat: 41.05,
            wni_lon: 17.1,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'MGGIA',
            wni_port_name: 'MUGGIA',
            wni_unlocode: 'ITTRS',
            wni_country: 'IT',
            wni_lat: 45.6,
            wni_lon: 13.77,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'MGRHT',
            wni_port_name: 'SANTA MARGHERITA LIGURE',
            wni_unlocode: 'ITPTF',
            wni_country: 'IT',
            wni_lat: 44.33,
            wni_lon: 9.22,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'MLL',
            wni_port_name: 'MELLILI OIL TERMINAL',
            wni_unlocode: 'ITMEL',
            wni_country: 'IT',
            wni_lat: 37.12,
            wni_lon: 15.27,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'MMC',
            wni_port_name: 'MALAMOCCO',
            wni_unlocode: 'ITFSA',
            wni_country: 'IT',
            wni_lat: 45.33,
            wni_lon: 12.32,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'MRCNM',
            wni_port_name: 'MARCIANA MARINA',
            wni_unlocode: 'ITPFE',
            wni_country: 'IT',
            wni_lat: 42.8,
            wni_lon: 10.2,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'MRNDC',
            wni_port_name: 'MARINA DI CAMPO',
            wni_unlocode: 'ITPFE',
            wni_country: 'IT',
            wni_lat: 42.73,
            wni_lon: 10.23,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'MSENO',
            wni_port_name: 'MISENO',
            wni_unlocode: 'ITBAI',
            wni_country: 'IT',
            wni_lat: 40.78,
            wni_lon: 14.08,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'PERO',
            wni_port_name: 'CAPO PERO',
            wni_unlocode: 'ITRMA',
            wni_country: 'IT',
            wni_lat: 42.85,
            wni_lon: 10.45,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'PRCD',
            wni_port_name: 'PROCIDA',
            wni_unlocode: 'ITBAI',
            wni_country: 'IT',
            wni_lat: 40.77,
            wni_lon: 14.02,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'RDC',
            wni_port_name: 'REGGIO DI CALABRIA',
            wni_unlocode: 'ITREG',
            wni_country: 'IT',
            wni_lat: 38.1,
            wni_lon: 15.65,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'RMN',
            wni_port_name: 'PORTI DE RIMINL',
            wni_unlocode: 'ITPES',
            wni_country: 'IT',
            wni_lat: 44.07,
            wni_lon: 12.58,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'ROMNO',
            wni_port_name: 'PORTO PONTE ROMANO',
            wni_unlocode: 'ITSAT',
            wni_country: 'IT',
            wni_lat: 39.05,
            wni_lon: 8.48,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'RPO',
            wni_port_name: 'RIPOSTO',
            wni_unlocode: 'ITGIA',
            wni_country: 'IT',
            wni_lat: 37.73,
            wni_lon: 15.22,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'SCCC',
            wni_port_name: 'SCIACCA',
            wni_unlocode: 'ITPEM',
            wni_country: 'IT',
            wni_lat: 37.5,
            wni_lon: 13.08,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'SDRNO',
            wni_port_name: 'SIDERNO MARINA',
            wni_unlocode: 'ITGIT',
            wni_country: 'IT',
            wni_lat: 38.27,
            wni_lon: 16.3,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'SNGLL',
            wni_port_name: 'SENIGALLIA',
            wni_unlocode: 'ITFAL',
            wni_country: 'IT',
            wni_lat: 43.72,
            wni_lon: 13.22,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'SPRT',
            wni_port_name: 'SANTO SPIRITO',
            wni_unlocode: 'ITBRI',
            wni_country: 'IT',
            wni_lat: 41.17,
            wni_lon: 16.75,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'SSTN',
            wni_port_name: 'SISTIANA',
            wni_unlocode: 'ITMNF',
            wni_country: 'IT',
            wni_lat: 45.77,
            wni_lon: 13.63,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'SVRT',
            wni_port_name: 'SOVERATO MARINA',
            wni_unlocode: 'ITVVA',
            wni_country: 'IT',
            wni_lat: 38.7,
            wni_lon: 16.55,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'TRANI',
            wni_port_name: 'TRANI',
            wni_unlocode: 'ITBLT',
            wni_country: 'IT',
            wni_lat: 41.28,
            wni_lon: 16.42,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'TRRCN',
            wni_port_name: 'TERRACINA',
            wni_unlocode: 'ITGAE',
            wni_country: 'IT',
            wni_lat: 41.28,
            wni_lon: 13.27,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'VADO',
            wni_port_name: 'RADA DI VADO',
            wni_unlocode: 'ITVDL',
            wni_country: 'IT',
            wni_lat: 44.27,
            wni_lon: 8.47,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'VEN',
            wni_port_name: 'VENEZIA',
            wni_unlocode: 'ITVCE',
            wni_country: 'IT',
            wni_lat: 45.43,
            wni_lon: 12.34,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'VEN1',
            wni_port_name: 'LIDO',
            wni_unlocode: 'ITVCE',
            wni_country: 'IT',
            wni_lat: 45.42,
            wni_lon: 12.43,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'VRGG',
            wni_port_name: 'VIAREGGIO',
            wni_unlocode: 'ITMDC',
            wni_country: 'IT',
            wni_lat: 43.87,
            wni_lon: 10.23,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'HLRS',
            wni_port_name: 'ST HELIER HARBOR',
            wni_unlocode: 'GBSTH',
            wni_country: 'JE',
            wni_lat: 49.18,
            wni_lon: -2.12,
            wni_tz: 'Europe/Jersey',
        },
        {
            option: 'ANNTT',
            wni_port_name: 'ANNOTTO BAY',
            wni_unlocode: 'JMKIN',
            wni_country: 'JM',
            wni_lat: 18.28,
            wni_lon: -76.78,
            wni_tz: 'America/Jamaica',
        },
        {
            option: 'BLFLD',
            wni_port_name: 'BLUEFIELDS',
            wni_unlocode: 'JMSLM',
            wni_country: 'JM',
            wni_lat: 18.17,
            wni_lon: -78.03,
            wni_tz: 'America/Jamaica',
        },
        {
            option: 'FLMTH',
            wni_port_name: 'FALMOUTH',
            wni_unlocode: 'JMRIB',
            wni_country: 'JM',
            wni_lat: 18.48,
            wni_lon: -77.65,
            wni_tz: 'America/Jamaica',
        },
        {
            option: 'MNCOL',
            wni_port_name: 'MANCHIONEAL',
            wni_unlocode: 'JMPOT',
            wni_country: 'JM',
            wni_lat: 18.03,
            wni_lon: -76.28,
            wni_tz: 'America/Jamaica',
        },
        {
            option: 'MRAJM',
            wni_port_name: 'PORT MARIA BAY',
            wni_unlocode: 'JMOCJ',
            wni_country: 'JM',
            wni_lat: 18.38,
            wni_lon: -76.88,
            wni_tz: 'America/Jamaica',
        },
        {
            option: 'MRNT',
            wni_port_name: 'PORT MORANT',
            wni_unlocode: 'JMPOT',
            wni_country: 'JM',
            wni_lat: 17.87,
            wni_lon: -76.33,
            wni_tz: 'America/Jamaica',
        },
        {
            option: 'MRNT1',
            wni_port_name: 'MORANT BAY',
            wni_unlocode: 'JMPOT',
            wni_country: 'JM',
            wni_lat: 17.88,
            wni_lon: -76.42,
            wni_tz: 'America/Jamaica',
        },
        {
            option: 'ORCBS',
            wni_port_name: 'ORACABESSA',
            wni_unlocode: 'JMOCJ',
            wni_country: 'JM',
            wni_lat: 18.4,
            wni_lon: -76.95,
            wni_tz: 'America/Jamaica',
        },
        {
            option: 'PEDR',
            wni_port_name: 'LITTLE PEDRO POINT',
            wni_unlocode: 'JMPKS',
            wni_country: 'JM',
            wni_lat: 17.85,
            wni_lon: -77.6,
            wni_tz: 'America/Jamaica',
        },
        {
            option: 'SANAB',
            wni_port_name: 'ST ANNS BAY',
            wni_unlocode: 'JMOCJ',
            wni_country: 'JM',
            wni_lat: 18.43,
            wni_lon: -77.2,
            wni_tz: 'America/Jamaica',
        },
        {
            option: 'WHARF',
            wni_port_name: 'LONGS WHARF',
            wni_unlocode: 'JMPEV',
            wni_country: 'JM',
            wni_lat: 17.88,
            wni_lon: -77.13,
            wni_tz: 'America/Jamaica',
        },
        {
            option: 'NAGO',
            wni_port_name: 'NAGO',
            wni_unlocode: 'JPOKA',
            wni_country: 'JP',
            wni_lat: 26.59,
            wni_lon: 127.98,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'UNTN',
            wni_port_name: 'UNTEN',
            wni_unlocode: 'JPOKA',
            wni_country: 'JP',
            wni_lat: 26.67,
            wni_lon: 128,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TMIE',
            wni_port_name: 'TOMIE',
            wni_unlocode: 'JPAOK',
            wni_country: 'JP',
            wni_lat: 32.62,
            wni_lon: 128.77,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'FKUE',
            wni_port_name: 'FUKUE',
            wni_unlocode: 'JPAOK',
            wni_country: 'JP',
            wni_lat: 32.7,
            wni_lon: 128.85,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MIT',
            wni_port_name: 'MITSUSHIMA',
            wni_unlocode: 'JPIZH',
            wni_country: 'JP',
            wni_lat: 34.3,
            wni_lon: 129.3,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TKSKI',
            wni_port_name: 'TAKESHIKI',
            wni_unlocode: 'JPIZH',
            wni_country: 'JP',
            wni_lat: 34.29,
            wni_lon: 129.31,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SSNA',
            wni_port_name: 'SASUNA',
            wni_unlocode: 'JPIZH',
            wni_country: 'JP',
            wni_lat: 34.63,
            wni_lon: 129.4,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HTKTS',
            wni_port_name: 'HITAKATSU',
            wni_unlocode: 'JPIZH',
            wni_country: 'JP',
            wni_lat: 34.65,
            wni_lon: 129.48,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TKNKW',
            wni_port_name: 'TUKINOKAWA',
            wni_unlocode: 'JPMTS',
            wni_country: 'JP',
            wni_lat: 33.35,
            wni_lon: 129.73,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HASM',
            wni_port_name: 'HA SHIMA',
            wni_unlocode: 'JPNGS',
            wni_country: 'JP',
            wni_lat: 32.62,
            wni_lon: 129.73,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'AOUUR',
            wni_port_name: 'AOUURA',
            wni_unlocode: 'JPMTS',
            wni_country: 'JP',
            wni_lat: 33.45,
            wni_lon: 129.76,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HTBJ',
            wni_port_name: 'HUIS TEN BOSH',
            wni_unlocode: 'JPSSB',
            wni_country: 'JP',
            wni_lat: 33.08,
            wni_lon: 129.79,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KOE',
            wni_port_name: 'KOE',
            wni_unlocode: 'JPNGS',
            wni_country: 'JP',
            wni_lat: 32.76,
            wni_lon: 129.81,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TGTS',
            wni_port_name: 'TOGITSU',
            wni_unlocode: 'JPNGS',
            wni_country: 'JP',
            wni_lat: 32.85,
            wni_lon: 129.83,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'GENKI',
            wni_port_name: 'GENKAI',
            wni_unlocode: 'JPKAR',
            wni_country: 'JP',
            wni_lat: 33.47,
            wni_lon: 129.85,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MOGI',
            wni_port_name: 'MOGI',
            wni_unlocode: 'JPNGS',
            wni_country: 'JP',
            wni_lat: 32.7,
            wni_lon: 129.92,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MYKN',
            wni_port_name: 'MYOKEN',
            wni_unlocode: 'JPKAR',
            wni_country: 'JP',
            wni_lat: 33.47,
            wni_lon: 129.95,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'OOEK',
            wni_port_name: 'OE',
            wni_unlocode: 'JPRHK',
            wni_country: 'JP',
            wni_lat: 32.32,
            wni_lon: 129.99,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'USHBK',
            wni_port_name: 'USHIBUKA',
            wni_unlocode: 'JPMIN',
            wni_country: 'JP',
            wni_lat: 32.2,
            wni_lon: 130.02,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'FUTAE',
            wni_port_name: 'FUTAE',
            wni_unlocode: 'JPRHK',
            wni_country: 'JP',
            wni_lat: 32.55,
            wni_lon: 130.12,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KATUR',
            wni_port_name: 'KATAURA',
            wni_unlocode: 'JPTNY',
            wni_country: 'JP',
            wni_lat: 31.42,
            wni_lon: 130.18,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'AKUNE',
            wni_port_name: 'AKUNE',
            wni_unlocode: 'JPSEN',
            wni_country: 'JP',
            wni_lat: 32.02,
            wni_lon: 130.19,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KUO',
            wni_port_name: 'KUCHINOTSU',
            wni_unlocode: 'JPRHK',
            wni_country: 'JP',
            wni_lat: 32.6,
            wni_lon: 130.2,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SNOE',
            wni_port_name: 'SUMINOE',
            wni_unlocode: 'JPMII',
            wni_country: 'JP',
            wni_lat: 33.2,
            wni_lon: 130.22,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HROE',
            wni_port_name: 'HIROE',
            wni_unlocode: 'JPMII',
            wni_country: 'JP',
            wni_lat: 33.17,
            wni_lon: 130.28,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MAKU',
            wni_port_name: 'MAKURAZAKI',
            wni_unlocode: 'JPKII',
            wni_country: 'JP',
            wni_lat: 31.27,
            wni_lon: 130.3,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TIRA',
            wni_port_name: 'TAIRA',
            wni_unlocode: 'JPARI',
            wni_country: 'JP',
            wni_lat: 32.88,
            wni_lon: 130.31,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SIM',
            wni_port_name: 'SIMABARA',
            wni_unlocode: 'JPARI',
            wni_country: 'JP',
            wni_lat: 32.78,
            wni_lon: 130.38,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KJIR',
            wni_port_name: 'KOJIRO',
            wni_unlocode: 'JPYAT',
            wni_country: 'JP',
            wni_lat: 32.42,
            wni_lon: 130.4,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'UMED',
            wni_port_name: 'UMEDO',
            wni_unlocode: 'JPMIN',
            wni_country: 'JP',
            wni_lat: 32.22,
            wni_lon: 130.4,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'OMTA',
            wni_port_name: 'OMUTA',
            wni_unlocode: 'JPMII',
            wni_country: 'JP',
            wni_lat: 33.03,
            wni_lon: 130.45,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KWJI',
            wni_port_name: 'KAWAJIRI',
            wni_unlocode: 'JPKII',
            wni_country: 'JP',
            wni_lat: 31.18,
            wni_lon: 130.56,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HYKKN',
            wni_port_name: 'HYAKKAN',
            wni_unlocode: 'JPKMJ',
            wni_country: 'JP',
            wni_lat: 32.8,
            wni_lon: 130.6,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'YMGW',
            wni_port_name: 'YAMAGAWA',
            wni_unlocode: 'JPKII',
            wni_country: 'JP',
            wni_lat: 31.2,
            wni_lon: 130.63,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MKI',
            wni_port_name: 'MAKIYAMA',
            wni_unlocode: 'JPKSK',
            wni_country: 'JP',
            wni_lat: 33.9,
            wni_lon: 130.82,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'WAM',
            wni_port_name: 'WAKAMATSU KO',
            wni_unlocode: 'JPKSK',
            wni_country: 'JP',
            wni_lat: 33.9,
            wni_lon: 130.82,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'YUYA',
            wni_port_name: 'YUYA',
            wni_unlocode: 'JPSZK',
            wni_country: 'JP',
            wni_lat: 34.38,
            wni_lon: 130.98,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TNA',
            wni_port_name: 'TANOURA',
            wni_unlocode: 'JPMOJ',
            wni_country: 'JP',
            wni_lat: 33.96,
            wni_lon: 130.99,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HAMIK',
            wni_port_name: 'HAMI',
            wni_unlocode: 'JPSBS',
            wni_country: 'JP',
            wni_lat: 31.35,
            wni_lon: 131.03,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'BEPP',
            wni_port_name: 'BEPPU',
            wni_unlocode: 'JPOIT',
            wni_country: 'JP',
            wni_lat: 33.27,
            wni_lon: 131.52,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KAKAJ',
            wni_port_name: 'KAKAJI',
            wni_unlocode: 'JPNAT',
            wni_country: 'JP',
            wni_lat: 33.68,
            wni_lon: 131.52,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TKTZ',
            wni_port_name: 'TAKETAZU',
            wni_unlocode: 'JPNAN',
            wni_country: 'JP',
            wni_lat: 33.68,
            wni_lon: 131.57,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MMTS',
            wni_port_name: 'MIMITSU',
            wni_unlocode: 'JPHSM',
            wni_country: 'JP',
            wni_lat: 32.33,
            wni_lon: 131.62,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TTRO',
            wni_port_name: 'TOTORO',
            wni_unlocode: 'JPNOB',
            wni_country: 'JP',
            wni_lat: 32.52,
            wni_lon: 131.68,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HMESM',
            wni_port_name: 'HIMESHIMA',
            wni_unlocode: 'JPKSD',
            wni_country: 'JP',
            wni_lat: 33.73,
            wni_lon: 131.7,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MASD',
            wni_port_name: 'MASUDA',
            wni_unlocode: 'JPHMD',
            wni_country: 'JP',
            wni_lat: 34.7,
            wni_lon: 131.82,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SMOE',
            wni_port_name: 'SHIMONOE',
            wni_unlocode: 'JPIBS',
            wni_country: 'JP',
            wni_lat: 33.16,
            wni_lon: 131.83,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TOKUD',
            wni_port_name: 'TOKUYAMAKUDAMATSU',
            wni_unlocode: 'JPNYO',
            wni_country: 'JP',
            wni_lat: 34.02,
            wni_lon: 131.83,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KAMAE',
            wni_port_name: 'KAMAE',
            wni_unlocode: 'JPSAE',
            wni_country: 'JP',
            wni_lat: 32.79,
            wni_lon: 131.93,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KUKA',
            wni_port_name: 'KUKA',
            wni_unlocode: 'JPYAN',
            wni_country: 'JP',
            wni_lat: 33.95,
            wni_lon: 132.27,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'YNTS',
            wni_port_name: 'YUNOTSU',
            wni_unlocode: 'JPHMD',
            wni_country: 'JP',
            wni_lat: 35.09,
            wni_lon: 132.34,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'OKNSM',
            wni_port_name: 'OKINO SHIMA',
            wni_unlocode: 'JPSUK',
            wni_country: 'JP',
            wni_lat: 32.71,
            wni_lon: 132.55,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TKHMA',
            wni_port_name: 'TAKAHAMA KO',
            wni_unlocode: 'JPMYJ',
            wni_country: 'JP',
            wni_lat: 33.88,
            wni_lon: 132.7,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HOJO',
            wni_port_name: 'HOJO',
            wni_unlocode: 'JPKIK',
            wni_country: 'JP',
            wni_lat: 33.97,
            wni_lon: 132.77,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TSS',
            wni_port_name: 'TOSASHIMIZU',
            wni_unlocode: 'JPASR',
            wni_country: 'JP',
            wni_lat: 32.77,
            wni_lon: 132.95,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KRU',
            wni_port_name: 'KURUSHIMA',
            wni_unlocode: 'JPHAS',
            wni_country: 'JP',
            wni_lat: 34.12,
            wni_lon: 132.98,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MYUR',
            wni_port_name: 'MIYANOURA KO',
            wni_unlocode: 'JPOMS',
            wni_country: 'JP',
            wni_lat: 34.25,
            wni_lon: 133.02,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SAZ',
            wni_port_name: 'SAIZAKI',
            wni_unlocode: 'JPSTD',
            wni_country: 'JP',
            wni_lat: 34.33,
            wni_lon: 133.04,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TOYO',
            wni_port_name: 'TOYO',
            wni_unlocode: 'JPSAJ',
            wni_country: 'JP',
            wni_lat: 33.96,
            wni_lon: 133.1,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'IWG',
            wni_port_name: 'IWAGI',
            wni_unlocode: 'JPINS',
            wni_country: 'JP',
            wni_lat: 34.24,
            wni_lon: 133.15,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HABH',
            wni_port_name: 'HABU',
            wni_unlocode: 'JPINS',
            wni_country: 'JP',
            wni_lat: 34.28,
            wni_lon: 133.18,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'ONITZ',
            wni_port_name: 'ONOMICHIITOZAKI',
            wni_unlocode: 'JPMUK',
            wni_country: 'JP',
            wni_lat: 34.4,
            wni_lon: 133.2,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'CHTSE',
            wni_port_name: 'CHITOSE',
            wni_unlocode: 'JPTNI',
            wni_country: 'JP',
            wni_lat: 34.38,
            wni_lon: 133.3,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TOMO',
            wni_port_name: 'TOMO',
            wni_unlocode: 'JPTNI',
            wni_country: 'JP',
            wni_lat: 34.38,
            wni_lon: 133.38,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KOCS',
            wni_port_name: 'KOCHI SHIN',
            wni_unlocode: 'JPKCZ',
            wni_country: 'JP',
            wni_lat: 33.51,
            wni_lon: 133.59,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KRSHK',
            wni_port_name: 'KURASHIKI',
            wni_unlocode: 'JPMIZ',
            wni_country: 'JP',
            wni_lat: 34.6,
            wni_lon: 133.77,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SMTSI',
            wni_port_name: 'SHIMOTSUI',
            wni_unlocode: 'JPMIZ',
            wni_country: 'JP',
            wni_lat: 34.44,
            wni_lon: 133.79,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KOGS',
            wni_port_name: 'KOGUSHI',
            wni_unlocode: 'JPUNO',
            wni_country: 'JP',
            wni_lat: 34.6,
            wni_lon: 134.03,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'UCHNM',
            wni_port_name: 'UCHINOMI',
            wni_unlocode: 'JPTAK',
            wni_country: 'JP',
            wni_lat: 34.47,
            wni_lon: 134.31,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SKTE',
            wni_port_name: 'SAKATE',
            wni_unlocode: 'JPTAK',
            wni_country: 'JP',
            wni_lat: 34.45,
            wni_lon: 134.32,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'ISHM',
            wni_port_name: 'IESHIMA',
            wni_unlocode: 'JPABO',
            wni_country: 'JP',
            wni_lat: 34.68,
            wni_lon: 134.53,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'IMGRE',
            wni_port_name: 'IMAGIRE',
            wni_unlocode: 'JPOKJ',
            wni_country: 'JP',
            wni_lat: 34.1,
            wni_lon: 134.61,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KASMI',
            wni_port_name: 'KASUMI',
            wni_unlocode: 'JPAZJ',
            wni_country: 'JP',
            wni_lat: 35.65,
            wni_lon: 134.63,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SBYM',
            wni_port_name: 'SHIBAYAMA',
            wni_unlocode: 'JPAZJ',
            wni_country: 'JP',
            wni_lat: 35.65,
            wni_lon: 134.66,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SBYM1',
            wni_port_name: 'SHIBAYAMA',
            wni_unlocode: 'JPAZJ',
            wni_country: 'JP',
            wni_lat: 35.65,
            wni_lon: 134.66,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TIYM',
            wni_port_name: 'TSUIYAMA',
            wni_unlocode: 'JPMIY',
            wni_country: 'JP',
            wni_lat: 35.65,
            wni_lon: 134.83,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SUMOT',
            wni_port_name: 'SUMOTO',
            wni_unlocode: 'JPWAK',
            wni_country: 'JP',
            wni_lat: 34.35,
            wni_lon: 134.9,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KASWA',
            wni_port_name: 'KASHIWA',
            wni_unlocode: 'JPYUR',
            wni_country: 'JP',
            wni_lat: 33.95,
            wni_lon: 135.1,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'GOBO',
            wni_port_name: 'GOBO',
            wni_unlocode: 'JPHDK',
            wni_country: 'JP',
            wni_lat: 33.86,
            wni_lon: 135.15,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'WAD',
            wni_port_name: 'WADAMISAKI',
            wni_unlocode: 'JPUKB',
            wni_country: 'JP',
            wni_lat: 34.66,
            wni_lon: 135.18,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NNM',
            wni_port_name: 'NISHINOMIYA',
            wni_unlocode: 'JPAMA',
            wni_country: 'JP',
            wni_lat: 34.72,
            wni_lon: 135.34,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'IZMIT',
            wni_port_name: 'IZUMIOTSU',
            wni_unlocode: 'JPSBK',
            wni_country: 'JP',
            wni_lat: 34.52,
            wni_lon: 135.39,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'OSKT',
            wni_port_name: 'OSAKA KITAKO',
            wni_unlocode: 'JPOSA',
            wni_country: 'JP',
            wni_lat: 34.67,
            wni_lon: 135.42,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'OSNN',
            wni_port_name: 'OSAKA NANKO',
            wni_unlocode: 'JPOSA',
            wni_country: 'JP',
            wni_lat: 34.62,
            wni_lon: 135.43,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'OSCK',
            wni_port_name: 'OSAKA CHIKKO',
            wni_unlocode: 'JPOSA',
            wni_country: 'JP',
            wni_lat: 34.65,
            wni_lon: 135.43,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HKGW',
            wni_port_name: 'HIKI',
            wni_unlocode: 'JPTAE',
            wni_country: 'JP',
            wni_lat: 33.56,
            wni_lon: 135.45,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SUSAM',
            wni_port_name: 'SUSAMI',
            wni_unlocode: 'JPTAE',
            wni_country: 'JP',
            wni_lat: 33.55,
            wni_lon: 135.49,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TKH',
            wni_port_name: 'TAKAHAMA',
            wni_unlocode: 'JPUCR',
            wni_country: 'JP',
            wni_lat: 35.5,
            wni_lon: 135.55,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'OBM',
            wni_port_name: 'OBAMA',
            wni_unlocode: 'JPUCR',
            wni_country: 'JP',
            wni_lat: 35.5,
            wni_lon: 135.73,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KSHMT',
            wni_port_name: 'KUSHIMOTO',
            wni_unlocode: 'JPSHN',
            wni_country: 'JP',
            wni_lat: 33.47,
            wni_lon: 135.78,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TGRSU',
            wni_port_name: 'TAGARASU',
            wni_unlocode: 'JPTRG',
            wni_country: 'JP',
            wni_lat: 35.54,
            wni_lon: 135.83,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'URGM',
            wni_port_name: 'URAGAMI',
            wni_unlocode: 'JPSHN',
            wni_country: 'JP',
            wni_lat: 33.56,
            wni_lon: 135.89,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MHM',
            wni_port_name: 'MIHAMA',
            wni_unlocode: 'JPTRG',
            wni_country: 'JP',
            wni_lat: 35.62,
            wni_lon: 135.95,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NCHKT',
            wni_port_name: 'KIIKATSUURA',
            wni_unlocode: 'JPSHN',
            wni_country: 'JP',
            wni_lat: 33.62,
            wni_lon: 135.95,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'UGUI',
            wni_port_name: 'UGUI',
            wni_unlocode: 'JPSHN',
            wni_country: 'JP',
            wni_lat: 33.65,
            wni_lon: 135.97,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'ECHZN',
            wni_port_name: 'ECHIZEN',
            wni_unlocode: 'JPTXK',
            wni_country: 'JP',
            wni_lat: 35.93,
            wni_lon: 135.99,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MKN',
            wni_port_name: 'MIKUNI KO',
            wni_unlocode: 'JPTXK',
            wni_country: 'JP',
            wni_lat: 36.22,
            wni_lon: 136.15,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NSM',
            wni_port_name: 'NAGASHIMA',
            wni_unlocode: 'JPOWA',
            wni_country: 'JP',
            wni_lat: 34.2,
            wni_lon: 136.34,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NSHKI',
            wni_port_name: 'NISHIKI',
            wni_unlocode: 'JPOWA',
            wni_country: 'JP',
            wni_lat: 34.22,
            wni_lon: 136.4,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'ATAKA',
            wni_port_name: 'ATAKA',
            wni_unlocode: 'JPKNZ',
            wni_country: 'JP',
            wni_lat: 36.42,
            wni_lon: 136.42,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'IGRZ',
            wni_port_name: 'IGURAZU KO',
            wni_unlocode: 'JPTSU',
            wni_country: 'JP',
            wni_lat: 34.68,
            wni_lon: 136.55,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SKTSO',
            wni_port_name: 'SHUKUTASO',
            wni_unlocode: 'JPTOB',
            wni_country: 'JP',
            wni_lat: 34.3,
            wni_lon: 136.69,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KUWN',
            wni_port_name: 'KUWANA',
            wni_unlocode: 'JPKWE',
            wni_country: 'JP',
            wni_lat: 35.07,
            wni_lon: 136.7,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'FKUUR',
            wni_port_name: 'FUKUURA',
            wni_unlocode: 'JPNNO',
            wni_country: 'JP',
            wni_lat: 37.08,
            wni_lon: 136.72,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TAKII',
            wni_port_name: 'TAKI',
            wni_unlocode: 'JPNNO',
            wni_country: 'JP',
            wni_lat: 36.92,
            wni_lon: 136.76,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'WAGU',
            wni_port_name: 'WAGU',
            wni_unlocode: 'JPTOB',
            wni_country: 'JP',
            wni_lat: 34.25,
            wni_lon: 136.81,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'ANMZU',
            wni_port_name: 'ANAMIZU',
            wni_unlocode: 'JPNNO',
            wni_country: 'JP',
            wni_lat: 37.22,
            wni_lon: 136.91,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KHI',
            wni_port_name: 'KAMI SHIMA',
            wni_unlocode: 'JPIRK',
            wni_country: 'JP',
            wni_lat: 34.55,
            wni_lon: 136.98,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'USHTS',
            wni_port_name: 'USHITSU',
            wni_unlocode: 'JPNNO',
            wni_country: 'JP',
            wni_lat: 37.3,
            wni_lon: 137.16,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'FSKTY',
            wni_port_name: 'FUSHIKITOYAMA',
            wni_unlocode: 'JPTOY',
            wni_country: 'JP',
            wni_lat: 36.78,
            wni_lon: 137.18,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HIWS',
            wni_port_name: 'HIGASHI IWASE',
            wni_unlocode: 'JPTOY',
            wni_country: 'JP',
            wni_lat: 36.76,
            wni_lon: 137.23,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'INUYM',
            wni_port_name: 'INUYAMA',
            wni_unlocode: 'JPNNO',
            wni_country: 'JP',
            wni_lat: 37.3,
            wni_lon: 137.23,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'OGIIS',
            wni_port_name: 'OGI',
            wni_unlocode: 'JPNNO',
            wni_country: 'JP',
            wni_lat: 37.3,
            wni_lon: 137.24,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'OGW',
            wni_port_name: 'OIGAWA',
            wni_unlocode: 'JPOMZ',
            wni_country: 'JP',
            wni_lat: 34.78,
            wni_lon: 138.29,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'UGUS',
            wni_port_name: 'UGUSU',
            wni_unlocode: 'JPNUM',
            wni_country: 'JP',
            wni_lat: 34.85,
            wni_lon: 138.77,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HEDA',
            wni_port_name: 'HEDA',
            wni_unlocode: 'JPNUM',
            wni_country: 'JP',
            wni_lat: 34.97,
            wni_lon: 138.77,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TOII',
            wni_port_name: 'TOI',
            wni_unlocode: 'JPNUM',
            wni_country: 'JP',
            wni_lat: 34.91,
            wni_lon: 138.79,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MERAS',
            wni_port_name: 'MERA',
            wni_unlocode: 'JPNUM',
            wni_country: 'JP',
            wni_lat: 34.66,
            wni_lon: 138.79,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TEIS',
            wni_port_name: 'TEISHI',
            wni_unlocode: 'JPNUM',
            wni_country: 'JP',
            wni_lat: 34.63,
            wni_lon: 138.89,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SHMD',
            wni_port_name: 'SHIMODA',
            wni_unlocode: 'JPNUM',
            wni_country: 'JP',
            wni_lat: 34.67,
            wni_lon: 138.95,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'INTR',
            wni_port_name: 'INATORI',
            wni_unlocode: 'JPNUM',
            wni_country: 'JP',
            wni_lat: 34.77,
            wni_lon: 139.04,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MTSRU',
            wni_port_name: 'MANAZURU',
            wni_unlocode: 'JPNUM',
            wni_country: 'JP',
            wni_lat: 35.15,
            wni_lon: 139.15,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NIIH',
            wni_port_name: 'NIIGATA HIGASHI',
            wni_unlocode: 'JPNIH',
            wni_country: 'JP',
            wni_lat: 38.02,
            wni_lon: 139.23,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'IWAFN',
            wni_port_name: 'IWAFUNE',
            wni_unlocode: 'JPNIH',
            wni_country: 'JP',
            wni_lat: 38.2,
            wni_lon: 139.43,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SHONN',
            wni_port_name: 'SHONAN',
            wni_unlocode: 'JPYOS',
            wni_country: 'JP',
            wni_lat: 35.3,
            wni_lon: 139.49,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SUZUY',
            wni_port_name: 'SUZU',
            wni_unlocode: 'JPSKT',
            wni_country: 'JP',
            wni_lat: 38.67,
            wni_lon: 139.61,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MSI',
            wni_port_name: 'MISAKI',
            wni_unlocode: 'JPKRH',
            wni_country: 'JP',
            wni_lat: 35.14,
            wni_lon: 139.62,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'OPP',
            wni_port_name: 'OPPAMA',
            wni_unlocode: 'JPYOS',
            wni_country: 'JP',
            wni_lat: 35.31,
            wni_lon: 139.66,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SANS',
            wni_port_name: 'SANSE',
            wni_unlocode: 'JPSKT',
            wni_country: 'JP',
            wni_lat: 38.7,
            wni_lon: 139.66,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HON',
            wni_port_name: 'HONMOKO',
            wni_unlocode: 'JPYOK',
            wni_country: 'JP',
            wni_lat: 35.43,
            wni_lon: 139.68,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SNOSK',
            wni_port_name: 'SUNO SAKI KITA',
            wni_unlocode: 'JPURG',
            wni_country: 'JP',
            wni_lat: 34.98,
            wni_lon: 139.76,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TYM',
            wni_port_name: 'TATEYAMA',
            wni_unlocode: 'JPWDA',
            wni_country: 'JP',
            wni_lat: 34.98,
            wni_lon: 139.87,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KEI',
            wni_port_name: 'KEIHIN',
            wni_unlocode: 'JPSDU',
            wni_country: 'JP',
            wni_lat: 35.51,
            wni_lon: 139.89,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KONR',
            wni_port_name: 'KONORA',
            wni_unlocode: 'JPSKT',
            wni_country: 'JP',
            wni_lat: 39.26,
            wni_lon: 139.91,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SRHM',
            wni_port_name: 'AWASHIRAHAMA',
            wni_unlocode: 'JPWDA',
            wni_country: 'JP',
            wni_lat: 34.91,
            wni_lon: 139.94,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KTNAN',
            wni_port_name: 'KATUNAN KO',
            wni_unlocode: 'JPFNB',
            wni_country: 'JP',
            wni_lat: 35.67,
            wni_lon: 139.98,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NRS',
            wni_port_name: 'NARASHINO',
            wni_unlocode: 'JPFNB',
            wni_country: 'JP',
            wni_lat: 35.66,
            wni_lon: 140,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'FKUSM',
            wni_port_name: 'FUKUSHIMA',
            wni_unlocode: 'JPHKD',
            wni_country: 'JP',
            wni_lat: 41.47,
            wni_lon: 140.27,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KTSUU',
            wni_port_name: 'KATSUURA KO',
            wni_unlocode: 'JPKUR',
            wni_country: 'JP',
            wni_lat: 35.13,
            wni_lon: 140.3,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KDOMR',
            wni_port_name: 'KODOMARI',
            wni_unlocode: 'JPSCH',
            wni_country: 'JP',
            wni_lat: 41.13,
            wni_lon: 140.3,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'SHRCH',
            wni_port_name: 'SHIRIUCHI',
            wni_unlocode: 'JPHKD',
            wni_country: 'JP',
            wni_lat: 41.59,
            wni_lon: 140.43,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TOMRH',
            wni_port_name: 'SHIRIBESHITOMARI',
            wni_unlocode: 'JPOTR',
            wni_country: 'JP',
            wni_lat: 43.07,
            wni_lon: 140.49,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'IWN',
            wni_port_name: 'IWANAI',
            wni_unlocode: 'JPOTR',
            wni_country: 'JP',
            wni_lat: 42.98,
            wni_lon: 140.52,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'OOARA',
            wni_port_name: 'OARAI',
            wni_unlocode: 'JPHAG',
            wni_country: 'JP',
            wni_lat: 36.3,
            wni_lon: 140.58,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NAKA',
            wni_port_name: 'NAKAMINATO',
            wni_unlocode: 'JPHAG',
            wni_country: 'JP',
            wni_lat: 36.34,
            wni_lon: 140.6,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TAI',
            wni_port_name: 'TOKAI',
            wni_unlocode: 'JPHTC',
            wni_country: 'JP',
            wni_lat: 36.47,
            wni_lon: 140.61,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'AJIG',
            wni_port_name: 'AJIGAURA',
            wni_unlocode: 'JPHIC',
            wni_country: 'JP',
            wni_lat: 36.38,
            wni_lon: 140.62,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'IBA',
            wni_port_name: 'IBARAKI',
            wni_unlocode: 'JPHIC',
            wni_country: 'JP',
            wni_lat: 36.39,
            wni_lon: 140.67,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'IIOK',
            wni_port_name: 'IIOKA',
            wni_unlocode: 'JPKSM',
            wni_country: 'JP',
            wni_lat: 35.69,
            wni_lon: 140.73,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NARI',
            wni_port_name: 'NAARAI',
            wni_unlocode: 'JPKSM',
            wni_country: 'JP',
            wni_lat: 35.71,
            wni_lon: 140.84,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HASAK',
            wni_port_name: 'HASAKI',
            wni_unlocode: 'JPKSM',
            wni_country: 'JP',
            wni_lat: 35.75,
            wni_lon: 140.84,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'COS',
            wni_port_name: 'CHOSHI',
            wni_unlocode: 'JPKSM',
            wni_country: 'JP',
            wni_lat: 35.73,
            wni_lon: 140.85,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'OINA',
            wni_port_name: 'OINAO',
            wni_unlocode: 'JPMUR',
            wni_country: 'JP',
            wni_lat: 42.31,
            wni_lon: 140.97,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KWAUC',
            wni_port_name: 'KAWAUCHI',
            wni_unlocode: 'JPAOJ',
            wni_country: 'JP',
            wni_lat: 41.2,
            wni_lon: 140.99,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TMK',
            wni_port_name: 'TOMIOKA',
            wni_unlocode: 'JPHRM',
            wni_country: 'JP',
            wni_lat: 37.34,
            wni_lon: 141.03,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'UKDO',
            wni_port_name: 'UKEDO',
            wni_unlocode: 'JPHRM',
            wni_country: 'JP',
            wni_lat: 37.48,
            wni_lon: 141.04,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'OOMNT',
            wni_port_name: 'OMINATO',
            wni_unlocode: 'JPSYZ',
            wni_country: 'JP',
            wni_lat: 41.25,
            wni_lon: 141.15,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'ISHK',
            wni_port_name: 'ISHIKARI WAN SHIN KO',
            wni_unlocode: 'JPISS',
            wni_country: 'JP',
            wni_lat: 43.21,
            wni_lon: 141.3,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'OGNHM',
            wni_port_name: 'OGINOHAMA',
            wni_unlocode: 'JPONG',
            wni_country: 'JP',
            wni_lat: 38.37,
            wni_lon: 141.44,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MSWA',
            wni_port_name: 'MISAWA',
            wni_unlocode: 'JPHHE',
            wni_country: 'JP',
            wni_lat: 40.68,
            wni_lon: 141.44,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'MASHK',
            wni_port_name: 'MASHIKE',
            wni_unlocode: 'JPRMI',
            wni_country: 'JP',
            wni_lat: 43.85,
            wni_lon: 141.53,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KINKA',
            wni_port_name: 'KINKASAN',
            wni_unlocode: 'JPONG',
            wni_country: 'JP',
            wni_lat: 38.29,
            wni_lon: 141.55,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'TNSHI',
            wni_port_name: 'HACHINOHE TANESASHI',
            wni_unlocode: 'JPHHE',
            wni_country: 'JP',
            wni_lat: 40.51,
            wni_lon: 141.62,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HSHKM',
            wni_port_name: 'SANNOHE HASHIKAMI',
            wni_unlocode: 'JPHHE',
            wni_country: 'JP',
            wni_lat: 40.46,
            wni_lon: 141.67,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HIRON',
            wni_port_name: 'IWATE HIRONO',
            wni_unlocode: 'JPHHE',
            wni_country: 'JP',
            wni_lat: 40.41,
            wni_lon: 141.72,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'RYAGI',
            wni_port_name: 'RIKUCHU YAGI',
            wni_unlocode: 'JPHHE',
            wni_country: 'JP',
            wni_lat: 40.35,
            wni_lon: 141.77,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'NTMGW',
            wni_port_name: 'NODA TAMAGAWA',
            wni_unlocode: 'JPYQD',
            wni_country: 'JP',
            wni_lat: 40.08,
            wni_lon: 141.83,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'HRIUC',
            wni_port_name: 'IWATE HORINAI',
            wni_unlocode: 'JPYQD',
            wni_country: 'JP',
            wni_lat: 40.05,
            wni_lon: 141.86,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'OTNAB',
            wni_port_name: 'OOTANABE',
            wni_unlocode: 'JPYQD',
            wni_country: 'JP',
            wni_lat: 40.01,
            wni_lon: 141.91,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'OTW',
            wni_port_name: 'OTSUCHI',
            wni_unlocode: 'JPKIS',
            wni_country: 'JP',
            wni_lat: 39.35,
            wni_lon: 141.92,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'IWZM',
            wni_port_name: 'IWAIZUMI',
            wni_unlocode: 'JPYQD',
            wni_country: 'JP',
            wni_lat: 39.85,
            wni_lon: 142,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'ESK',
            wni_port_name: 'ERIMO',
            wni_unlocode: 'JPSAM',
            wni_country: 'JP',
            wni_lat: 41.94,
            wni_lon: 143.24,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'KOMBM',
            wni_port_name: 'KONBUMORI',
            wni_unlocode: 'JPKUH',
            wni_country: 'JP',
            wni_lat: 42.95,
            wni_lon: 144.53,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'AKKSH',
            wni_port_name: 'AKKESHI',
            wni_unlocode: 'JPKUH',
            wni_country: 'JP',
            wni_lat: 43.05,
            wni_lon: 144.85,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'PHNOM',
            wni_port_name: 'PHNOM PENH',
            wni_unlocode: 'KHPNH',
            wni_country: 'KH',
            wni_lat: 11.58,
            wni_lon: 104.92,
            wni_tz: 'Asia/Phnom_Penh',
        },
        {
            option: 'PHSAR',
            wni_port_name: 'PHSAR REAM',
            wni_unlocode: 'KHKOS',
            wni_country: 'KH',
            wni_lat: 10.5,
            wni_lon: 103.6,
            wni_tz: 'Asia/Phnom_Penh',
        },
        {
            option: 'SKL',
            wni_port_name: 'KAMPONG SAOM',
            wni_unlocode: 'KHKOS',
            wni_country: 'KH',
            wni_lat: 10.63,
            wni_lon: 103.5,
            wni_tz: 'Asia/Phnom_Penh',
        },
        {
            option: 'EGLSH',
            wni_port_name: 'ENGLISH HARBOR',
            wni_unlocode: 'KITNQ',
            wni_country: 'KI',
            wni_lat: 3.85,
            wni_lon: -159.37,
            wni_tz: 'Pacific/Kiritimati',
        },
        {
            option: 'LDNKI',
            wni_port_name: 'LONDON (KIRIBATI)',
            wni_unlocode: 'KICXI',
            wni_country: 'KI',
            wni_lat: 1.98,
            wni_lon: -157.47,
            wni_tz: 'Pacific/Kiritimati',
        },
        {
            option: 'PATSI',
            wni_port_name: 'PATSI',
            wni_unlocode: 'KMMUT',
            wni_country: 'KM',
            wni_lat: -12.13,
            wni_lon: 44.45,
            wni_tz: 'Indian/Comoro',
        },
        {
            option: 'PMON',
            wni_port_name: 'POMONI',
            wni_unlocode: 'KMMUT',
            wni_country: 'KM',
            wni_lat: -12.27,
            wni_lon: 44.42,
            wni_tz: 'Indian/Comoro',
        },
        {
            option: 'STKI',
            wni_port_name: 'ST. KITTS',
            wni_unlocode: 'KNNEV',
            wni_country: 'KN',
            wni_lat: 17.14,
            wni_lon: -62.64,
            wni_tz: 'America/St_Kitts',
        },
        {
            option: 'KMCK',
            wni_port_name: 'KIMCHAEK',
            wni_unlocode: 'KPSON',
            wni_country: 'KP',
            wni_lat: 40.67,
            wni_lon: 129.2,
            wni_tz: 'Asia/Pyongyang',
        },
        {
            option: 'KYMP',
            wni_port_name: 'KYOMIPO',
            wni_unlocode: 'KPNAM',
            wni_country: 'KP',
            wni_lat: 38.73,
            wni_lon: 125.62,
            wni_tz: 'Asia/Pyongyang',
        },
        {
            option: 'NMP',
            wni_port_name: 'NAMP O',
            wni_unlocode: 'KPNAM',
            wni_country: 'KP',
            wni_lat: 38.72,
            wni_lon: 125.4,
            wni_tz: 'Asia/Pyongyang',
        },
        {
            option: 'ODJN',
            wni_port_name: 'ODAEJIN',
            wni_unlocode: 'KPCHO',
            wni_country: 'KP',
            wni_lat: 41.38,
            wni_lon: 129.78,
            wni_tz: 'Asia/Pyongyang',
        },
        {
            option: 'POSAN',
            wni_port_name: 'POSAN',
            wni_unlocode: 'KPNAM',
            wni_country: 'KP',
            wni_lat: 38.88,
            wni_lon: 125.57,
            wni_tz: 'Asia/Pyongyang',
        },
        {
            option: 'SGM',
            wni_port_name: 'SONGNIM',
            wni_unlocode: 'KPNAM',
            wni_country: 'KP',
            wni_lat: 38.73,
            wni_lon: 125.64,
            wni_tz: 'Asia/Pyongyang',
        },
        {
            option: 'SNJ',
            wni_port_name: 'SONGJIM',
            wni_unlocode: 'KPSON',
            wni_country: 'KP',
            wni_lat: 40.67,
            wni_lon: 129.21,
            wni_tz: 'Asia/Pyongyang',
        },
        {
            option: 'UNGGI',
            wni_port_name: 'UNGGI',
            wni_unlocode: 'RUPSE',
            wni_country: 'KP',
            wni_lat: 42.33,
            wni_lon: 130.4,
            wni_tz: 'Asia/Pyongyang',
        },
        {
            option: 'YNGDN',
            wni_port_name: 'YONGDANGPO',
            wni_unlocode: 'KPHAE',
            wni_country: 'KP',
            wni_lat: 38,
            wni_lon: 125.7,
            wni_tz: 'Asia/Pyongyang',
        },
        {
            option: 'ASAN',
            wni_port_name: 'ASAN',
            wni_unlocode: 'KRPTK',
            wni_country: 'KR',
            wni_lat: 36.9,
            wni_lon: 126.9,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'GCN',
            wni_port_name: 'GAMCHON',
            wni_unlocode: 'KRPUS',
            wni_country: 'KR',
            wni_lat: 35.08,
            wni_lon: 129,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'JAN',
            wni_port_name: 'JANGSEUNGPO',
            wni_unlocode: 'KROKP',
            wni_country: 'KR',
            wni_lat: 34.87,
            wni_lon: 128.73,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'JEJU',
            wni_port_name: 'JEJU',
            wni_unlocode: 'KRCHA',
            wni_country: 'KR',
            wni_lat: 33.52,
            wni_lon: 126.53,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'KOJ',
            wni_port_name: 'KOJE',
            wni_unlocode: 'KRJGE',
            wni_country: 'KR',
            wni_lat: 34.85,
            wni_lon: 128.58,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'KWAN1',
            wni_port_name: 'KWANGYANG TERMINAL',
            wni_unlocode: 'KRKWA',
            wni_country: 'KR',
            wni_lat: 34.88,
            wni_lon: 127.8,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'KWAN2',
            wni_port_name: 'KWANGYANG TERMINAL',
            wni_unlocode: 'KRKWA',
            wni_country: 'KR',
            wni_lat: 34.9,
            wni_lon: 127.7,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'MIP',
            wni_port_name: 'MIPO',
            wni_unlocode: 'KRPUS',
            wni_country: 'KR',
            wni_lat: 35.16,
            wni_lon: 129.17,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'SNSNP',
            wni_port_name: 'SONSAN PO',
            wni_unlocode: 'KRCHA',
            wni_country: 'KR',
            wni_lat: 33.47,
            wni_lon: 126.93,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'TNGY',
            wni_port_name: 'TONGYONG',
            wni_unlocode: 'KRTYG',
            wni_country: 'KR',
            wni_lat: 34.84,
            wni_lon: 128.42,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'YGCG',
            wni_port_name: "YEONGHEUNG (Don't use)",
            wni_unlocode: 'KRYCH',
            wni_country: 'KR',
            wni_lat: 37.25,
            wni_lon: 126.32,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'KW',
            wni_port_name: 'AL KUWAYT',
            wni_unlocode: 'KWKWI',
            wni_country: 'KW',
            wni_lat: 29.38,
            wni_lon: 47.97,
            wni_tz: 'Asia/Kuwait',
        },
        {
            option: 'SHU',
            wni_port_name: 'ASH SHUAYBAH',
            wni_unlocode: 'KWSAA',
            wni_country: 'KW',
            wni_lat: 29.03,
            wni_lon: 48.13,
            wni_tz: 'Asia/Kuwait',
        },
        {
            option: 'ZWRKW',
            wni_port_name: 'MINA AZ ZAWR',
            wni_unlocode: 'KWMIS',
            wni_country: 'KW',
            wni_lat: 28.73,
            wni_lon: 48.4,
            wni_tz: 'Asia/Kuwait',
        },
        {
            option: 'DON',
            wni_port_name: 'DONDRA HEAD',
            wni_unlocode: 'LKGAL',
            wni_country: 'LK',
            wni_lat: 5.92,
            wni_lon: 80.58,
            wni_tz: 'Asia/Colombo',
        },
        {
            option: 'PDI',
            wni_port_name: 'PULMODDAI',
            wni_unlocode: 'LKTRR',
            wni_country: 'LK',
            wni_lat: 8.94,
            wni_lon: 80.99,
            wni_tz: 'Asia/Colombo',
        },
        {
            option: 'WLGM',
            wni_port_name: 'WELIGAMA BAY',
            wni_unlocode: 'LKGAL',
            wni_country: 'LK',
            wni_lat: 5.95,
            wni_lon: 80.43,
            wni_tz: 'Asia/Colombo',
        },
        {
            option: 'LBU',
            wni_port_name: 'LOWER BUCHANAN',
            wni_unlocode: 'LRUCN',
            wni_country: 'LR',
            wni_lat: 5.86,
            wni_lon: -10.05,
            wni_tz: 'Africa/Monrovia',
        },
        {
            option: 'BRYQH',
            wni_port_name: 'MARSA AL BURAYQAH',
            wni_unlocode: 'LYLMQ',
            wni_country: 'LY',
            wni_lat: 30.42,
            wni_lon: 19.6,
            wni_tz: 'Africa/Tripoli',
        },
        {
            option: 'DER',
            wni_port_name: 'DARNAH',
            wni_unlocode: 'LYDNF',
            wni_country: 'LY',
            wni_lat: 32.77,
            wni_lon: 22.65,
            wni_tz: 'Africa/Tripoli',
        },
        {
            option: 'HILAL',
            wni_port_name: 'MARSA AL HILAL',
            wni_unlocode: 'LYREH',
            wni_country: 'LY',
            wni_lat: 32.92,
            wni_lon: 22.18,
            wni_tz: 'Africa/Tripoli',
        },
        {
            option: 'SBRTH',
            wni_port_name: 'MARSA SABRATAH',
            wni_unlocode: 'LYZAW',
            wni_country: 'LY',
            wni_lat: 32.82,
            wni_lon: 12.5,
            wni_tz: 'Africa/Tripoli',
        },
        {
            option: 'SUSAH',
            wni_port_name: 'MARSA SUSAH',
            wni_unlocode: 'LYREH',
            wni_country: 'LY',
            wni_lat: 32.9,
            wni_lon: 21.97,
            wni_tz: 'Africa/Tripoli',
        },
        {
            option: 'TBK',
            wni_port_name: 'TUBRUQ',
            wni_unlocode: 'LYTOB',
            wni_country: 'LY',
            wni_lat: 32.08,
            wni_lon: 23.98,
            wni_tz: 'Africa/Tripoli',
        },
        {
            option: 'ZUWRH',
            wni_port_name: 'ZUWARAH',
            wni_unlocode: 'LYZUA',
            wni_country: 'LY',
            wni_lat: 32.93,
            wni_lon: 12.12,
            wni_tz: 'Africa/Tripoli',
        },
        {
            option: 'MEHDY',
            wni_port_name: 'MEHDIYA',
            wni_unlocode: 'MANNA',
            wni_country: 'MA',
            wni_lat: 34.27,
            wni_lon: -6.68,
            wni_tz: 'Africa/Casablanca',
        },
        {
            option: 'ZGUER',
            wni_port_name: 'ALCAZAR ZEGUER',
            wni_unlocode: 'MAPTM',
            wni_country: 'MA',
            wni_lat: 35.85,
            wni_lon: -5.55,
            wni_tz: 'Africa/Casablanca',
        },
        {
            option: 'BUDVA',
            wni_port_name: 'LUKA BUDVA',
            wni_unlocode: 'MEBIJ',
            wni_country: 'ME',
            wni_lat: 42.28,
            wni_lon: 18.83,
            wni_tz: 'Europe/Podgorica',
        },
        {
            option: 'HRCG',
            wni_port_name: 'HERCEG-NOVI',
            wni_unlocode: 'MEZEL',
            wni_country: 'ME',
            wni_lat: 42.45,
            wni_lon: 18.53,
            wni_tz: 'Europe/Podgorica',
        },
        {
            option: 'MLJN',
            wni_port_name: 'MELJINE',
            wni_unlocode: 'MEZEL',
            wni_country: 'ME',
            wni_lat: 42.45,
            wni_lon: 18.57,
            wni_tz: 'Europe/Podgorica',
        },
        {
            option: 'RISAN',
            wni_port_name: 'RISAN',
            wni_unlocode: 'MEKOT',
            wni_country: 'ME',
            wni_lat: 42.52,
            wni_lon: 18.7,
            wni_tz: 'Europe/Podgorica',
        },
        {
            option: 'ADY',
            wni_port_name: 'ANDOANY',
            wni_unlocode: 'MGNOS',
            wni_country: 'MG',
            wni_lat: -13.4,
            wni_lon: 48.28,
            wni_tz: 'Indian/Antananarivo',
        },
        {
            option: 'AMBL',
            wni_port_name: 'AMBILOBE',
            wni_unlocode: 'MGPSL',
            wni_country: 'MG',
            wni_lat: -13.2,
            wni_lon: 49.05,
            wni_tz: 'Indian/Antananarivo',
        },
        {
            option: 'ANTLH',
            wni_port_name: 'ANTATAHA',
            wni_unlocode: 'MGANM',
            wni_country: 'MG',
            wni_lat: -14.9,
            wni_lon: 50.28,
            wni_tz: 'Indian/Antananarivo',
        },
        {
            option: 'DIEGO',
            wni_port_name: 'CAP DIEGO',
            wni_unlocode: 'MGDIE',
            wni_country: 'MG',
            wni_lat: -12.27,
            wni_lon: 49.3,
            wni_tz: 'Indian/Antananarivo',
        },
        {
            option: 'HLLVL',
            wni_port_name: 'HELLVILLE',
            wni_unlocode: 'MGNOS',
            wni_country: 'MG',
            wni_lat: -13.4,
            wni_lon: 48.3,
            wni_tz: 'Indian/Antananarivo',
        },
        {
            option: 'LUCE',
            wni_port_name: 'STE LUCE',
            wni_unlocode: 'MGFTU',
            wni_country: 'MG',
            wni_lat: -24.77,
            wni_lon: 47.22,
            wni_tz: 'Indian/Antananarivo',
        },
        {
            option: 'NOSSI',
            wni_port_name: 'NOSY-BE',
            wni_unlocode: 'MGNOS',
            wni_country: 'MG',
            wni_lat: -13.41,
            wni_lon: 48.28,
            wni_tz: 'Indian/Antananarivo',
        },
        {
            option: 'NOSY',
            wni_port_name: 'NOSY HARA',
            wni_unlocode: 'MGDIE',
            wni_country: 'MG',
            wni_lat: -12.24,
            wni_lon: 49.01,
            wni_tz: 'Indian/Antananarivo',
        },
        {
            option: 'POS',
            wni_port_name: 'PORT ST. LOUIS',
            wni_unlocode: 'MGPSL',
            wni_country: 'MG',
            wni_lat: -13.09,
            wni_lon: 48.84,
            wni_tz: 'Indian/Antananarivo',
        },
        {
            option: 'TOLA',
            wni_port_name: 'TOLANARO',
            wni_unlocode: 'MGFTU',
            wni_country: 'MG',
            wni_lat: -25.03,
            wni_lon: 47,
            wni_tz: 'Indian/Antananarivo',
        },
        {
            option: 'STTW',
            wni_port_name: 'SITTWE HARBOR',
            wni_unlocode: 'MMAKY',
            wni_country: 'MM',
            wni_lat: 20.13,
            wni_lon: 92.9,
            wni_tz: 'Asia/Rangoon',
        },
        {
            option: 'VPT',
            wni_port_name: 'VICTORIA POINT HARBOUR',
            wni_unlocode: 'THUNN',
            wni_country: 'MM',
            wni_lat: 10.02,
            wni_lon: 98.57,
            wni_tz: 'Asia/Rangoon',
        },
        {
            option: 'MO',
            wni_port_name: 'MACAO',
            wni_unlocode: 'MOMFM',
            wni_country: 'MO',
            wni_lat: 22.18,
            wni_lon: 113.57,
            wni_tz: 'Asia/Macau',
        },
        {
            option: 'BUCC',
            wni_port_name: 'BUCCANEERS CREEK',
            wni_unlocode: 'MQFDF',
            wni_country: 'MQ',
            wni_lat: 14.6,
            wni_lon: -61.08,
            wni_tz: 'America/Martinique',
        },
        {
            option: 'GALON',
            wni_port_name: 'BAIE DU GALION',
            wni_unlocode: 'MQFDF',
            wni_country: 'MQ',
            wni_lat: 14.73,
            wni_lon: -60.93,
            wni_tz: 'America/Martinique',
        },
        {
            option: 'LEMRN',
            wni_port_name: 'LE MARIN',
            wni_unlocode: 'MQFDF',
            wni_country: 'MQ',
            wni_lat: 14.47,
            wni_lon: -60.88,
            wni_tz: 'America/Martinique',
        },
        {
            option: 'LRBRT',
            wni_port_name: 'LE ROBERT',
            wni_unlocode: 'MQFDF',
            wni_country: 'MQ',
            wni_lat: 14.68,
            wni_lon: -60.95,
            wni_tz: 'America/Martinique',
        },
        {
            option: 'PIRRE',
            wni_port_name: 'ST PIERRE',
            wni_unlocode: 'MQFDF',
            wni_country: 'MQ',
            wni_lat: 14.73,
            wni_lon: -61.18,
            wni_tz: 'America/Martinique',
        },
        {
            option: 'TRNIT',
            wni_port_name: 'LA TRINITE',
            wni_unlocode: 'MQFDF',
            wni_country: 'MQ',
            wni_lat: 14.75,
            wni_lon: -60.97,
            wni_tz: 'America/Martinique',
        },
        {
            option: 'PDLA',
            wni_port_name: "PORT DE L'AMITIE",
            wni_unlocode: 'MRNKC',
            wni_country: 'MR',
            wni_lat: 17.98,
            wni_lon: -16.03,
            wni_tz: 'Africa/Nouakchott',
        },
        {
            option: 'MHBRG',
            wni_port_name: 'MAHEBOURG',
            wni_unlocode: 'MUPLU',
            wni_country: 'MU',
            wni_lat: -20.42,
            wni_lon: 57.7,
            wni_tz: 'Indian/Mauritius',
        },
        {
            option: 'CABOS',
            wni_port_name: 'SAN JOSE DEL CABO',
            wni_unlocode: 'MXCSL',
            wni_country: 'MX',
            wni_lat: 23.05,
            wni_lon: -109.68,
            wni_tz: 'America/Mazatlan',
        },
        {
            option: 'CCI',
            wni_port_name: 'CALICA',
            wni_unlocode: 'MXPCM',
            wni_country: 'MX',
            wni_lat: 20.58,
            wni_lon: -87.1,
            wni_tz: 'America/Cancun',
        },
        {
            option: 'CNCN',
            wni_port_name: 'CANCUN',
            wni_unlocode: 'MXPMS',
            wni_country: 'MX',
            wni_lat: 21.06,
            wni_lon: -86.78,
            wni_tz: 'America/Cancun',
        },
        {
            option: 'ESZ',
            wni_port_name: 'EL SAUZAL',
            wni_unlocode: 'MXESE',
            wni_country: 'MX',
            wni_lat: 31.89,
            wni_lon: -116.7,
            wni_tz: 'America/Santa_Isabel',
        },
        {
            option: 'HUAT',
            wni_port_name: 'PUERTO HUATULCO',
            wni_unlocode: 'MXHTO',
            wni_country: 'MX',
            wni_lat: 15.71,
            wni_lon: -96.13,
            wni_tz: 'America/Mexico_City',
        },
        {
            option: 'MIGEL',
            wni_port_name: 'SAN MIGUEL',
            wni_unlocode: 'MXCZM',
            wni_country: 'MX',
            wni_lat: 20.5,
            wni_lon: -86.97,
            wni_tz: 'America/Cancun',
        },
        {
            option: 'MLJ',
            wni_port_name: 'MULEJE',
            wni_unlocode: 'MXSMI',
            wni_country: 'MX',
            wni_lat: 26.9,
            wni_lon: -112,
            wni_tz: 'America/Mazatlan',
        },
        {
            option: 'MORLS',
            wni_port_name: 'PUERTO MORELOS',
            wni_unlocode: 'MXPMS',
            wni_country: 'MX',
            wni_lat: 20.85,
            wni_lon: -86.9,
            wni_tz: 'America/Cancun',
        },
        {
            option: 'MRQS',
            wni_port_name: 'PUERTO MARQUES',
            wni_unlocode: 'MXACA',
            wni_country: 'MX',
            wni_lat: 16.8,
            wni_lon: -99.87,
            wni_tz: 'America/Mexico_City',
        },
        {
            option: 'MRR',
            wni_port_name: 'PUERTO MORRO REDONDO',
            wni_unlocode: 'MXISD',
            wni_country: 'MX',
            wni_lat: 28.05,
            wni_lon: -115.18,
            wni_tz: 'America/Santa_Isabel',
        },
        {
            option: 'PCDC',
            wni_port_name: 'PUERTO CUIDAD DEL CARMEN',
            wni_unlocode: 'MXCME',
            wni_country: 'MX',
            wni_lat: 18.65,
            wni_lon: -91.85,
            wni_tz: 'America/Merida',
        },
        {
            option: 'PTA',
            wni_port_name: 'PUERTO ANGEL',
            wni_unlocode: 'MXHTO',
            wni_country: 'MX',
            wni_lat: 15.65,
            wni_lon: -96.52,
            wni_tz: 'America/Mexico_City',
        },
        {
            option: 'PYS',
            wni_port_name: 'PLAYA SEBYA',
            wni_unlocode: 'MXCPE',
            wni_country: 'MX',
            wni_lat: 19.64,
            wni_lon: -90.7,
            wni_tz: 'America/Merida',
        },
        {
            option: 'SLNS',
            wni_port_name: 'BAHIA SALINAS',
            wni_unlocode: 'MXLTO',
            wni_country: 'MX',
            wni_lat: 26,
            wni_lon: -111.12,
            wni_tz: 'America/Mazatlan',
        },
        {
            option: 'TIJ',
            wni_port_name: 'TIJUANA',
            wni_unlocode: 'MXRST',
            wni_country: 'MX',
            wni_lat: 32.53,
            wni_lon: -117.02,
            wni_tz: 'America/Tijuana',
        },
        {
            option: 'ALRST',
            wni_port_name: 'ALOR SETAR',
            wni_unlocode: 'MYYAN',
            wni_country: 'MY',
            wni_lat: 6.12,
            wni_lon: 100.33,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'BGDAT',
            wni_port_name: 'BAGAN DATOH',
            wni_unlocode: 'MYTAN',
            wni_country: 'MY',
            wni_lat: 3.98,
            wni_lon: 100.78,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'BNT',
            wni_port_name: 'BINATANG',
            wni_unlocode: 'MYBTN',
            wni_country: 'MY',
            wni_lat: 2.16,
            wni_lon: 111.63,
            wni_tz: 'Asia/Kuching',
        },
        {
            option: 'KLSLG',
            wni_port_name: 'KUALA SELANGOR',
            wni_unlocode: 'MYKAP',
            wni_country: 'MY',
            wni_lat: 3.35,
            wni_lon: 101.25,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'KMM1',
            wni_port_name: 'KEMAMAN HARBOR',
            wni_unlocode: 'MYTSG',
            wni_country: 'MY',
            wni_lat: 4.25,
            wni_lon: 103.45,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'MUARR',
            wni_port_name: 'MUAR',
            wni_unlocode: 'MYMKZ',
            wni_country: 'MY',
            wni_lat: 2.05,
            wni_lon: 102.57,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'PENNG',
            wni_port_name: 'PINANG',
            wni_unlocode: 'MYPEN',
            wni_country: 'MY',
            wni_lat: 5.42,
            wni_lon: 100.35,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'PLBNN',
            wni_port_name: 'PELABONAN BASS',
            wni_unlocode: 'MYLGK',
            wni_country: 'MY',
            wni_lat: 6.32,
            wni_lon: 99.83,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'PNGOR',
            wni_port_name: 'PANGKOR',
            wni_unlocode: 'MYTRB',
            wni_country: 'MY',
            wni_lat: 4.22,
            wni_lon: 100.58,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'PSW',
            wni_port_name: 'PORT SWETTENHAM',
            wni_unlocode: 'MYPKG',
            wni_country: 'MY',
            wni_lat: 2.99,
            wni_lon: 101.39,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'SBOT',
            wni_port_name: 'SPANGAR BAY',
            wni_unlocode: 'MYSEP',
            wni_country: 'MY',
            wni_lat: 6.08,
            wni_lon: 116.12,
            wni_tz: 'Asia/Kuching',
        },
        {
            option: 'SIA',
            wni_port_name: 'SILAM',
            wni_unlocode: 'MYLDU',
            wni_country: 'MY',
            wni_lat: 4.98,
            wni_lon: 118.23,
            wni_tz: 'Asia/Kuching',
        },
        {
            option: 'SULNG',
            wni_port_name: 'TANJONG SULONG',
            wni_unlocode: 'MYTSG',
            wni_country: 'MY',
            wni_lat: 4.23,
            wni_lon: 103.47,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'TLITN',
            wni_port_name: 'TELUK INTAN',
            wni_unlocode: 'MYTAN',
            wni_country: 'MY',
            wni_lat: 4.02,
            wni_lon: 101.02,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'TUM',
            wni_port_name: 'TUMPAT',
            wni_unlocode: 'MYKBR',
            wni_country: 'MY',
            wni_lat: 6.2,
            wni_lon: 102.17,
            wni_tz: 'Asia/Kuala_Lumpur',
        },
        {
            option: 'USB',
            wni_port_name: 'USUKAN BAY',
            wni_unlocode: 'MYSEP',
            wni_country: 'MY',
            wni_lat: 6.37,
            wni_lon: 116.33,
            wni_tz: 'Asia/Kuching',
        },
        {
            option: 'AMLIA',
            wni_port_name: 'PORTO AMELIA',
            wni_unlocode: 'MZPOL',
            wni_country: 'MZ',
            wni_lat: -12.97,
            wni_lon: 40.5,
            wni_tz: 'Africa/Maputo',
        },
        {
            option: 'ANGCH',
            wni_port_name: 'PORTO DE ANGOCHE',
            wni_unlocode: 'MZANO',
            wni_country: 'MZ',
            wni_lat: -16.23,
            wni_lon: 39.9,
            wni_tz: 'Africa/Maputo',
        },
        {
            option: 'CHND',
            wni_port_name: 'VILA DO CHINDE',
            wni_unlocode: 'MZINE',
            wni_country: 'MZ',
            wni_lat: -18.53,
            wni_lon: 36.5,
            wni_tz: 'Africa/Maputo',
        },
        {
            option: 'MCMBQ',
            wni_port_name: 'MOCAMBIQUE',
            wni_unlocode: 'MZMZQ',
            wni_country: 'MZ',
            wni_lat: -15.03,
            wni_lon: 40.73,
            wni_tz: 'Africa/Maputo',
        },
        {
            option: 'PBNE',
            wni_port_name: 'PORTO DE PEBANE',
            wni_unlocode: 'MZPEB',
            wni_country: 'MZ',
            wni_lat: -17.27,
            wni_lon: 38.15,
            wni_tz: 'Africa/Maputo',
        },
        {
            option: 'QEL',
            wni_port_name: 'PORTO DE QUELIMANE',
            wni_unlocode: 'MZUEL',
            wni_country: 'MZ',
            wni_lat: -17.88,
            wni_lon: 36.88,
            wni_tz: 'Africa/Maputo',
        },
        {
            option: 'OUC',
            wni_port_name: 'OUACO',
            wni_unlocode: 'NCTUD',
            wni_country: 'NC',
            wni_lat: -20.84,
            wni_lon: 164.46,
            wni_tz: 'Pacific/Noumea',
        },
        {
            option: 'KINGS',
            wni_port_name: 'KINGSTON',
            wni_unlocode: 'NFNLK',
            wni_country: 'NF',
            wni_lat: -29.07,
            wni_lon: 167.95,
            wni_tz: 'Pacific/Norfolk',
        },
        {
            option: 'AKASS',
            wni_port_name: 'AKASSA',
            wni_unlocode: 'NGBRA',
            wni_country: 'NG',
            wni_lat: 4.32,
            wni_lon: 6.07,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'ANTN',
            wni_port_name: 'ANTAN OIL TERMINAL',
            wni_unlocode: 'NGANT',
            wni_country: 'NG',
            wni_lat: 4.22,
            wni_lon: 8.33,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'OPOBO',
            wni_port_name: 'OPOBO',
            wni_unlocode: 'NGONN',
            wni_country: 'NG',
            wni_lat: 4.58,
            wni_lon: 7.53,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'UKP',
            wni_port_name: 'UKPOKITI',
            wni_unlocode: 'NGESC',
            wni_country: 'NG',
            wni_lat: 5.69,
            wni_lon: 4.78,
            wni_tz: 'Africa/Lagos',
        },
        {
            option: 'CMH',
            wni_port_name: 'CHEMIEHAVEN',
            wni_unlocode: 'NLBOT',
            wni_country: 'NL',
            wni_lat: 51.88,
            wni_lon: 4.27,
            wni_tz: 'Europe/Amsterdam',
        },
        {
            option: 'ARE',
            wni_port_name: 'ARDAL',
            wni_unlocode: 'NOSPK',
            wni_country: 'NO',
            wni_lat: 59.15,
            wni_lon: 6.2,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'ASGRS',
            wni_port_name: 'ASGARSTRAND',
            wni_unlocode: 'NOSLG',
            wni_country: 'NO',
            wni_lat: 59.35,
            wni_lon: 10.47,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'AUS',
            wni_port_name: 'AUSTEVOLL',
            wni_unlocode: 'NOSKV',
            wni_country: 'NO',
            wni_lat: 60.1,
            wni_lon: 5.25,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'BALLD',
            wni_port_name: 'BALLSTAD',
            wni_unlocode: 'NOGRD',
            wni_country: 'NO',
            wni_lat: 68.07,
            wni_lon: 13.7,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'BATFJ',
            wni_port_name: 'BATSFJORDEN',
            wni_unlocode: 'NOBJF',
            wni_country: 'NO',
            wni_lat: 70.63,
            wni_lon: 29.73,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'BLLGN',
            wni_port_name: 'LITLE BALLANGEN',
            wni_unlocode: 'NOBLL',
            wni_country: 'NO',
            wni_lat: 68.33,
            wni_lon: 16.85,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'BRATS',
            wni_port_name: 'BRETTESNES',
            wni_unlocode: 'NOSVJ',
            wni_country: 'NO',
            wni_lat: 68.23,
            wni_lon: 14.85,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'BREI',
            wni_port_name: 'BREIVIK',
            wni_unlocode: 'NOSTY',
            wni_country: 'NO',
            wni_lat: 70.58,
            wni_lon: 22.13,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'BREID',
            wni_port_name: 'BREIDVIK',
            wni_unlocode: 'NOFND',
            wni_country: 'NO',
            wni_lat: 67.22,
            wni_lon: 15.17,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'BRGNO',
            wni_port_name: 'BERG',
            wni_unlocode: 'NOLRE',
            wni_country: 'NO',
            wni_lat: 65.37,
            wni_lon: 12.2,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'BRSND',
            wni_port_name: 'BRANDASUND',
            wni_unlocode: 'NOBOM',
            wni_country: 'NO',
            wni_lat: 59.9,
            wni_lon: 5.1,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'BRTTH',
            wni_port_name: 'BRATTHOLMEN',
            wni_unlocode: 'NOSKV',
            wni_country: 'NO',
            wni_lat: 60.35,
            wni_lon: 5.17,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'BUD',
            wni_port_name: 'BUD',
            wni_unlocode: 'NONYH',
            wni_country: 'NO',
            wni_lat: 62.9,
            wni_lon: 6.92,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'EGGSB',
            wni_port_name: 'EGGESBONES',
            wni_unlocode: 'NOULS',
            wni_country: 'NO',
            wni_lat: 62.33,
            wni_lon: 5.65,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'ESPVR',
            wni_port_name: 'ESPEVAER',
            wni_unlocode: 'NOESP',
            wni_country: 'NO',
            wni_lat: 59.58,
            wni_lon: 5.15,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'FAUSK',
            wni_port_name: 'FAUSKE',
            wni_unlocode: 'NOFND',
            wni_country: 'NO',
            wni_lat: 67.25,
            wni_lon: 15.37,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'FENO',
            wni_port_name: 'FEVIK',
            wni_unlocode: 'NOGTD',
            wni_country: 'NO',
            wni_lat: 58.38,
            wni_lon: 8.7,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'FLKKF',
            wni_port_name: 'FLEKKEFJORDEN',
            wni_unlocode: 'NOFFD',
            wni_country: 'NO',
            wni_lat: 58.3,
            wni_lon: 6.67,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'FRF',
            wni_port_name: 'FREI',
            wni_unlocode: 'NOKSU',
            wni_country: 'NO',
            wni_lat: 63.06,
            wni_lon: 7.85,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'FSK',
            wni_port_name: 'FISKAA',
            wni_unlocode: 'NOKRS',
            wni_country: 'NO',
            wni_lat: 58.13,
            wni_lon: 7.97,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'FSNVG',
            wni_port_name: 'FOSNAVAG',
            wni_unlocode: 'NOULS',
            wni_country: 'NO',
            wni_lat: 62.35,
            wni_lon: 5.63,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'GBSTD',
            wni_port_name: 'GIBOSTAD',
            wni_unlocode: 'NOFNE',
            wni_country: 'NO',
            wni_lat: 69.35,
            wni_lon: 18.08,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'GLJ',
            wni_port_name: 'GLOMFJORDEN',
            wni_unlocode: 'NOGLO',
            wni_country: 'NO',
            wni_lat: 66.82,
            wni_lon: 13.98,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'GRYLL',
            wni_port_name: 'GRYLLEFJORDEN',
            wni_unlocode: 'NOBER',
            wni_country: 'NO',
            wni_lat: 69.37,
            wni_lon: 17.07,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'HAMN',
            wni_port_name: 'HAMN',
            wni_unlocode: 'NOBER',
            wni_country: 'NO',
            wni_lat: 69.48,
            wni_lon: 17.17,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'HASVK',
            wni_port_name: 'HASVIK',
            wni_unlocode: 'NOSTY',
            wni_country: 'NO',
            wni_lat: 70.48,
            wni_lon: 22.17,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'HDG',
            wni_port_name: 'HARDANGERFJORD',
            wni_unlocode: 'NOFUS',
            wni_country: 'NO',
            wni_lat: 60.17,
            wni_lon: 6,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'HENNG',
            wni_port_name: 'HENNINGSVAER',
            wni_unlocode: 'NOSUZ',
            wni_country: 'NO',
            wni_lat: 68.15,
            wni_lon: 14.22,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'HLSY',
            wni_port_name: 'HALSOY',
            wni_unlocode: 'NOMJF',
            wni_country: 'NO',
            wni_lat: 65.87,
            wni_lon: 13.2,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'HMNSB',
            wni_port_name: 'HEMNESBERGET',
            wni_unlocode: 'NONSN',
            wni_country: 'NO',
            wni_lat: 66.22,
            wni_lon: 13.6,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'HRYSN',
            wni_port_name: 'HAROYSUND',
            wni_unlocode: 'NONYH',
            wni_country: 'NO',
            wni_lat: 62.9,
            wni_lon: 6.97,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'HUSOY',
            wni_port_name: 'HUSOY',
            wni_unlocode: 'NOBER',
            wni_country: 'NO',
            wni_lat: 69.55,
            wni_lon: 17.67,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'HVY',
            wni_port_name: 'HAVOYSUND',
            wni_unlocode: 'NOHVG',
            wni_country: 'NO',
            wni_lat: 71,
            wni_lon: 24.67,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'KJO',
            wni_port_name: 'KJOLLEFJORDEN',
            wni_unlocode: 'NOKJF',
            wni_country: 'NO',
            wni_lat: 70.95,
            wni_lon: 27.33,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'KJRRN',
            wni_port_name: 'KJERRINGOY',
            wni_unlocode: 'NOBOO',
            wni_country: 'NO',
            wni_lat: 67.52,
            wni_lon: 14.77,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'KRKHM',
            wni_port_name: 'KIRKEHAMN',
            wni_unlocode: 'NOFFD',
            wni_country: 'NO',
            wni_lat: 58.23,
            wni_lon: 6.53,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'KRSNS',
            wni_port_name: 'KORSNES',
            wni_unlocode: 'NOTRY',
            wni_country: 'NO',
            wni_lat: 68.25,
            wni_lon: 16.07,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'KVLSN',
            wni_port_name: 'KVALSUND',
            wni_unlocode: 'NOHFT',
            wni_country: 'NO',
            wni_lat: 70.5,
            wni_lon: 23.98,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'KVN',
            wni_port_name: 'KVINESDAL',
            wni_unlocode: 'NOFFD',
            wni_country: 'NO',
            wni_lat: 58.31,
            wni_lon: 6.96,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'KVY',
            wni_port_name: 'KVITSOY',
            wni_unlocode: 'NOSKU',
            wni_country: 'NO',
            wni_lat: 59.07,
            wni_lon: 5.4,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'LAKSV',
            wni_port_name: 'LAKSELV',
            wni_unlocode: 'NOHFL',
            wni_country: 'NO',
            wni_lat: 67.37,
            wni_lon: 15.6,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'LLND',
            wni_port_name: 'LILAND',
            wni_unlocode: 'DE9BH',
            wni_country: 'NO',
            wni_lat: 68.48,
            wni_lon: 16.88,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'LNGST',
            wni_port_name: 'LANGSTEIN',
            wni_unlocode: 'NOSTJ',
            wni_country: 'NO',
            wni_lat: 63.55,
            wni_lon: 10.9,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'LRVG',
            wni_port_name: 'LEIRVAG',
            wni_unlocode: 'NOHRI',
            wni_country: 'NO',
            wni_lat: 62.35,
            wni_lon: 6.08,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'MELNG',
            wni_port_name: 'MELING',
            wni_unlocode: 'NOBOM',
            wni_country: 'NO',
            wni_lat: 59.78,
            wni_lon: 5.12,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'MLDTS',
            wni_port_name: 'MOLDTUSTRANDA',
            wni_unlocode: 'NOULS',
            wni_country: 'NO',
            wni_lat: 62.3,
            wni_lon: 5.65,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'MSTRH',
            wni_port_name: 'MOSTERHAMN',
            wni_unlocode: 'NOLRI',
            wni_country: 'NO',
            wni_lat: 59.7,
            wni_lon: 5.4,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'MVK',
            wni_port_name: 'MURUVIK',
            wni_unlocode: 'NOHOK',
            wni_country: 'NO',
            wni_lat: 63.43,
            wni_lon: 10.85,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'NDK',
            wni_port_name: 'NORDKAPP',
            wni_unlocode: 'NOHVG',
            wni_country: 'NO',
            wni_lat: 70.98,
            wni_lon: 25.97,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'NRHMS',
            wni_port_name: 'NORHEIMSUND',
            wni_unlocode: 'NOAAV',
            wni_country: 'NO',
            wni_lat: 60.37,
            wni_lon: 6.15,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'OKSFJ',
            wni_port_name: 'OKSFJORDEN',
            wni_unlocode: 'NOSTY',
            wni_country: 'NO',
            wni_lat: 70.23,
            wni_lon: 22.35,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'ORNES',
            wni_port_name: 'ORNES',
            wni_unlocode: 'NOMEY',
            wni_country: 'NO',
            wni_lat: 66.87,
            wni_lon: 13.72,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'ORSTA',
            wni_port_name: 'ORSTAVIK',
            wni_unlocode: 'NOHOV',
            wni_country: 'NO',
            wni_lat: 62.2,
            wni_lon: 6.13,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'REINE',
            wni_port_name: 'REINE',
            wni_unlocode: 'NOGRD',
            wni_country: 'NO',
            wni_lat: 67.93,
            wni_lon: 13.1,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'RISA',
            wni_port_name: 'RISAVIKI',
            wni_unlocode: 'NOTAE',
            wni_country: 'NO',
            wni_lat: 58.93,
            wni_lon: 5.58,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'RKFJR',
            wni_port_name: 'REKEFJORDEN',
            wni_unlocode: 'NOREK',
            wni_country: 'NO',
            wni_lat: 58.33,
            wni_lon: 6.27,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SGVG',
            wni_port_name: 'WNIVAG',
            wni_unlocode: 'NOSRP',
            wni_country: 'NO',
            wni_lat: 59.77,
            wni_lon: 5.38,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SJVGN',
            wni_port_name: 'SJOVEGAN',
            wni_unlocode: 'NOSRA',
            wni_country: 'NO',
            wni_lat: 68.88,
            wni_lon: 17.83,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SKANE',
            wni_port_name: 'SKANEVIK',
            wni_unlocode: 'NOHUS',
            wni_country: 'NO',
            wni_lat: 59.75,
            wni_lon: 5.93,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SKRLS',
            wni_port_name: 'SKROLSVIK',
            wni_unlocode: 'NOHRD',
            wni_country: 'NO',
            wni_lat: 69.07,
            wni_lon: 16.8,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SKRV',
            wni_port_name: 'SKROVA HAVN',
            wni_unlocode: 'NOSVJ',
            wni_country: 'NO',
            wni_lat: 68.17,
            wni_lon: 14.67,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SKU',
            wni_port_name: 'SKUDENESFJORD',
            wni_unlocode: 'NOSKU',
            wni_country: 'NO',
            wni_lat: 59.12,
            wni_lon: 5.25,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SLJ',
            wni_port_name: 'SALTFJORD',
            wni_unlocode: 'NOBOO',
            wni_country: 'NO',
            wni_lat: 67.25,
            wni_lon: 14.45,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SLNGS',
            wni_port_name: 'SALANGSVERKET',
            wni_unlocode: 'NOSRA',
            wni_country: 'NO',
            wni_lat: 68.92,
            wni_lon: 17.73,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SLSBR',
            wni_port_name: 'SALSBRUKET',
            wni_unlocode: 'NORVK',
            wni_country: 'NO',
            wni_lat: 64.8,
            wni_lon: 11.87,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SNJHP',
            wni_port_name: 'SENJEHOPEN',
            wni_unlocode: 'NOBER',
            wni_country: 'NO',
            wni_lat: 69.5,
            wni_lon: 17.5,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SOGN',
            wni_port_name: 'SOGNE',
            wni_unlocode: 'NOKRS',
            wni_country: 'NO',
            wni_lat: 58.09,
            wni_lon: 7.79,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SONNO',
            wni_port_name: 'SON',
            wni_unlocode: 'NOHAN',
            wni_country: 'NO',
            wni_lat: 59.52,
            wni_lon: 10.68,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SRVR',
            wni_port_name: 'SORVAER',
            wni_unlocode: 'NOSTY',
            wni_country: 'NO',
            wni_lat: 70.63,
            wni_lon: 21.98,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'STAVN',
            wni_port_name: 'STAVERN',
            wni_unlocode: 'NOLAR',
            wni_country: 'NO',
            wni_lat: 59,
            wni_lon: 10.03,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'STKK',
            wni_port_name: 'STOKKMARKES',
            wni_unlocode: 'NOSKN',
            wni_country: 'NO',
            wni_lat: 68.57,
            wni_lon: 14.92,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'STLN',
            wni_port_name: 'STEILENE',
            wni_unlocode: 'NOSLM',
            wni_country: 'NO',
            wni_lat: 59.82,
            wni_lon: 10.6,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'STRAN',
            wni_port_name: 'STRANDVIK',
            wni_unlocode: 'NOFUS',
            wni_country: 'NO',
            wni_lat: 60.17,
            wni_lon: 5.68,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'STRUH',
            wni_port_name: 'STRUSSHAMN',
            wni_unlocode: 'NOSKV',
            wni_country: 'NO',
            wni_lat: 60.4,
            wni_lon: 5.2,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'STUS',
            wni_port_name: 'STUSVIK',
            wni_unlocode: 'NOLDS',
            wni_country: 'NO',
            wni_lat: 58,
            wni_lon: 7.03,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'SUND',
            wni_port_name: 'SUNDAL',
            wni_unlocode: 'NOTSX',
            wni_country: 'NO',
            wni_lat: 60.12,
            wni_lon: 6.27,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'TALNO',
            wni_port_name: 'TALVIK',
            wni_unlocode: 'NOALF',
            wni_country: 'NO',
            wni_lat: 70.05,
            wni_lon: 22.97,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'THN',
            wni_port_name: 'THAMSHAMN',
            wni_unlocode: 'NOORK',
            wni_country: 'NO',
            wni_lat: 63.32,
            wni_lon: 9.88,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'TJTT',
            wni_port_name: 'TJOTTA',
            wni_unlocode: 'NOSSJ',
            wni_country: 'NO',
            wni_lat: 65.83,
            wni_lon: 12.43,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'TOF',
            wni_port_name: 'TOFTE',
            wni_unlocode: 'NOHAN',
            wni_country: 'NO',
            wni_lat: 59.55,
            wni_lon: 10.57,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'ULNO',
            wni_port_name: 'ULVIK',
            wni_unlocode: 'NOFJL',
            wni_country: 'NO',
            wni_lat: 68.57,
            wni_lon: 16.33,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'VALNS',
            wni_port_name: 'VALNES',
            wni_unlocode: 'NOBOO',
            wni_country: 'NO',
            wni_lat: 67.18,
            wni_lon: 14.5,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'VRDL',
            wni_port_name: 'VERDAL HAVN',
            wni_unlocode: 'NOVER',
            wni_country: 'NO',
            wni_lat: 63.78,
            wni_lon: 11.45,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'VRTDL',
            wni_port_name: 'VARTDAL',
            wni_unlocode: 'NOHRI',
            wni_country: 'NO',
            wni_lat: 62.3,
            wni_lon: 6.1,
            wni_tz: 'Europe/Oslo',
        },
        {
            option: 'ALOFI',
            wni_port_name: 'ALOFI',
            wni_unlocode: 'NUIUE',
            wni_country: 'NU',
            wni_lat: -19.03,
            wni_lon: -169.93,
            wni_tz: 'Pacific/Niue',
        },
        {
            option: 'CLLNG',
            wni_port_name: 'COLLINGWOOD',
            wni_unlocode: 'NZTKH',
            wni_country: 'NZ',
            wni_lat: -40.68,
            wni_lon: 172.67,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'INVG',
            wni_port_name: 'INVERCARGILL',
            wni_unlocode: 'NZBLU',
            wni_country: 'NZ',
            wni_lat: -46.41,
            wni_lon: 168.36,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'MAARI',
            wni_port_name: 'MAARI',
            wni_unlocode: 'NZRAR',
            wni_country: 'NZ',
            wni_lat: -39.97,
            wni_lon: 173.28,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'MANUK',
            wni_port_name: 'MANUKAU HARBOR',
            wni_unlocode: 'NZAKL',
            wni_country: 'NZ',
            wni_lat: -37,
            wni_lon: 174.69,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'OTAG',
            wni_port_name: 'OTAGO HARBOR',
            wni_unlocode: 'NZORR',
            wni_country: 'NZ',
            wni_lat: -45.82,
            wni_lon: 170.63,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'PATEA',
            wni_port_name: 'PATEA',
            wni_unlocode: 'NZWAV',
            wni_country: 'NZ',
            wni_lat: -39.78,
            wni_lon: 174.5,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'TASB',
            wni_port_name: 'TASMAN BAY',
            wni_unlocode: 'NZTKH',
            wni_country: 'NZ',
            wni_lat: -40.55,
            wni_lon: 173.21,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'TNK',
            wni_port_name: 'TARANAKI GULF',
            wni_unlocode: 'NZNPL',
            wni_country: 'NZ',
            wni_lat: -38.9,
            wni_lon: 174.3,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'WHNGR',
            wni_port_name: 'WHANGAROA',
            wni_unlocode: 'NZOPX',
            wni_country: 'NZ',
            wni_lat: -35.05,
            wni_lon: 173.77,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'WRURU',
            wni_port_name: 'WHANGARURU SOUTH',
            wni_unlocode: 'NZOPX',
            wni_country: 'NZ',
            wni_lat: -35.37,
            wni_lon: 174.35,
            wni_tz: 'Pacific/Auckland',
        },
        {
            option: 'SURO',
            wni_port_name: 'SUR',
            wni_unlocode: 'OMQAL',
            wni_country: 'OM',
            wni_lat: 22.65,
            wni_lon: 59.44,
            wni_tz: 'Asia/Muscat',
        },
        {
            option: 'OLO',
            wni_port_name: 'COCO SOLO',
            wni_unlocode: 'PAONX',
            wni_country: 'PA',
            wni_lat: 9.37,
            wni_lon: -79.89,
            wni_tz: 'America/Panama',
        },
        {
            option: 'PARID',
            wni_port_name: 'ISLA PARIDA',
            wni_unlocode: 'PAPED',
            wni_country: 'PA',
            wni_lat: 8.12,
            wni_lon: -82.35,
            wni_tz: 'America/Panama',
        },
        {
            option: 'ANCON',
            wni_port_name: 'BAHIA DE ANCON',
            wni_unlocode: 'PEANC',
            wni_country: 'PE',
            wni_lat: -11.75,
            wni_lon: -77.18,
            wni_tz: 'America/Lima',
        },
        {
            option: 'CAZUL',
            wni_port_name: 'PUERTO DE CERRO AZUL',
            wni_unlocode: 'PEPMC',
            wni_country: 'PE',
            wni_lat: -13.05,
            wni_lon: -76.52,
            wni_tz: 'America/Lima',
        },
        {
            option: 'CLLO',
            wni_port_name: 'PUERTO DEL CALLAO',
            wni_unlocode: 'PECLL',
            wni_country: 'PE',
            wni_lat: -12.05,
            wni_lon: -77.17,
            wni_tz: 'America/Lima',
        },
        {
            option: 'ETN',
            wni_port_name: 'PUERTO ETEN',
            wni_unlocode: 'PEEEN',
            wni_country: 'PE',
            wni_lat: -6.93,
            wni_lon: -79.85,
            wni_tz: 'America/Lima',
        },
        {
            option: 'HNCHC',
            wni_port_name: 'HUANCHACO',
            wni_unlocode: 'PETRU',
            wni_country: 'PE',
            wni_lat: -8.08,
            wni_lon: -79.1,
            wni_tz: 'America/Lima',
        },
        {
            option: 'LOBS',
            wni_port_name: 'CALETA LOBITOS',
            wni_unlocode: 'PELOB',
            wni_country: 'PE',
            wni_lat: -4.45,
            wni_lon: -81.28,
            wni_tz: 'America/Lima',
        },
        {
            option: 'MLLND',
            wni_port_name: 'PUERTO MOLLENDO',
            wni_unlocode: 'PEMLQ',
            wni_country: 'PE',
            wni_lat: -17.02,
            wni_lon: -72.03,
            wni_tz: 'America/Lima',
        },
        {
            option: 'PIM',
            wni_port_name: 'PIMENTAL',
            wni_unlocode: 'PEPMT',
            wni_country: 'PE',
            wni_lat: -6.83,
            wni_lon: -79.93,
            wni_tz: 'America/Lima',
        },
        {
            option: 'RIOL',
            wni_port_name: 'RIO LURIN',
            wni_unlocode: 'PELIM',
            wni_country: 'PE',
            wni_lat: -12.28,
            wni_lon: -76.87,
            wni_tz: 'America/Lima',
        },
        {
            option: 'SANM',
            wni_port_name: 'PUERTO GEN SAN MARTIN',
            wni_unlocode: 'PEGSM',
            wni_country: 'PE',
            wni_lat: -13.8,
            wni_lon: -76.3,
            wni_tz: 'America/Lima',
        },
        {
            option: 'SJN',
            wni_port_name: 'PUERTO DE SAN JUAN',
            wni_unlocode: 'PESNX',
            wni_country: 'PE',
            wni_lat: -15.35,
            wni_lon: -75.18,
            wni_tz: 'America/Lima',
        },
        {
            option: 'SMNC',
            wni_port_name: 'NUEVO SAMANCO',
            wni_unlocode: 'PESAM',
            wni_country: 'PE',
            wni_lat: -9.23,
            wni_lon: -78.5,
            wni_tz: 'America/Lima',
        },
        {
            option: 'SUP',
            wni_port_name: 'PUERTO DE SUPE',
            wni_unlocode: 'PESUP',
            wni_country: 'PE',
            wni_lat: -10.82,
            wni_lon: -77.73,
            wni_tz: 'America/Lima',
        },
        {
            option: 'FARE',
            wni_port_name: 'FARE',
            wni_unlocode: 'PFRFP',
            wni_country: 'PF',
            wni_lat: -16.7,
            wni_lon: -151.02,
            wni_tz: 'Pacific/Tahiti',
        },
        {
            option: 'PPTOA',
            wni_port_name: 'PAPETOAI',
            wni_unlocode: 'PFPPT',
            wni_country: 'PF',
            wni_lat: -17.48,
            wni_lon: -149.85,
            wni_tz: 'Pacific/Tahiti',
        },
        {
            option: 'TAHAA',
            wni_port_name: 'TAHAA',
            wni_unlocode: 'PFRFP',
            wni_country: 'PF',
            wni_lat: -16.63,
            wni_lon: -151.48,
            wni_tz: 'Pacific/Tahiti',
        },
        {
            option: 'TAIOH',
            wni_port_name: 'BAIE TAIOHAE',
            wni_unlocode: 'PFNHV',
            wni_country: 'PF',
            wni_lat: -8.93,
            wni_lon: -140.08,
            wni_tz: 'Pacific/Marquesas',
        },
        {
            option: 'UTR',
            wni_port_name: 'UTUROA',
            wni_unlocode: 'PFRFP',
            wni_country: 'PF',
            wni_lat: -16.73,
            wni_lon: -151.45,
            wni_tz: 'Pacific/Tahiti',
        },
        {
            option: 'VTP',
            wni_port_name: 'VAITAPE',
            wni_unlocode: 'PFBOB',
            wni_country: 'PF',
            wni_lat: -16.5,
            wni_lon: -151.75,
            wni_tz: 'Pacific/Tahiti',
        },
        {
            option: 'AITPE',
            wni_port_name: 'AITAPE HARBOR',
            wni_unlocode: 'PGATP',
            wni_country: 'PG',
            wni_lat: -3.13,
            wni_lon: 142.48,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'BLU',
            wni_port_name: 'BALUMA',
            wni_unlocode: 'PGKIM',
            wni_country: 'PG',
            wni_lat: -5.53,
            wni_lon: 150.31,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'BUNA',
            wni_port_name: 'BUNA',
            wni_unlocode: 'PGROR',
            wni_country: 'PG',
            wni_lat: -8.67,
            wni_lon: 148.4,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'DISCV',
            wni_port_name: 'DISCOVERY BAY',
            wni_unlocode: 'PGGUR',
            wni_country: 'PG',
            wni_lat: -10.42,
            wni_lon: 150.42,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'HRVEY',
            wni_port_name: 'PORT HARVEY',
            wni_unlocode: 'PGROR',
            wni_country: 'PG',
            wni_lat: -8.9,
            wni_lon: 148.52,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'KKP',
            wni_port_name: 'KOKOPO',
            wni_unlocode: 'PGRAB',
            wni_country: 'PG',
            wni_lat: -4.33,
            wni_lon: 152.28,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'QCARO',
            wni_port_name: 'QUEEN CAROLA HARBOR',
            wni_unlocode: 'PGBUA',
            wni_country: 'PG',
            wni_lat: -5.17,
            wni_lon: 154.55,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'SEKPG',
            wni_port_name: 'SEK HARBOR',
            wni_unlocode: 'PGMAG',
            wni_country: 'PG',
            wni_lat: -5.08,
            wni_lon: 145.83,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'SLMUA',
            wni_port_name: 'SALAMAUA',
            wni_unlocode: 'PGLAE',
            wni_country: 'PG',
            wni_lat: -7,
            wni_lon: 147.05,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'TIN',
            wni_port_name: 'TINPUTZ',
            wni_unlocode: 'PGBUA',
            wni_country: 'PG',
            wni_lat: -5.55,
            wni_lon: 155.03,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'WEW1',
            wni_port_name: 'WEWAK HARBOR',
            wni_unlocode: 'PGWWK',
            wni_country: 'PG',
            wni_lat: -3.57,
            wni_lon: 143.63,
            wni_tz: 'Pacific/Port_Moresby',
        },
        {
            option: 'ALNRS',
            wni_port_name: 'ALONEROS',
            wni_unlocode: 'PHHON',
            wni_country: 'PH',
            wni_lat: 13.98,
            wni_lon: 122.37,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'ARVLO',
            wni_port_name: 'AREVALO',
            wni_unlocode: 'PHSIS',
            wni_country: 'PH',
            wni_lat: 11.37,
            wni_lon: 124.37,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'BACUT',
            wni_port_name: 'BACUIT',
            wni_unlocode: 'PHMAL',
            wni_country: 'PH',
            wni_lat: 11.2,
            wni_lon: 119.38,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'BELLO',
            wni_port_name: 'PORT BELLO',
            wni_unlocode: 'PHORC',
            wni_country: 'PH',
            wni_lat: 10.98,
            wni_lon: 124.53,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'BJAPH',
            wni_port_name: 'PUNTA BAJA HARBOR',
            wni_unlocode: 'PHQUE',
            wni_country: 'PH',
            wni_lat: 9.07,
            wni_lon: 117.65,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'BLNCN',
            wni_port_name: 'PORT BALANCAN',
            wni_unlocode: 'PHPGB',
            wni_country: 'PH',
            wni_lat: 13.53,
            wni_lon: 121.87,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'BLNGO',
            wni_port_name: 'BALIANGO',
            wni_unlocode: 'PHDPL',
            wni_country: 'PH',
            wni_lat: 8.67,
            wni_lon: 123.6,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'BLNT',
            wni_port_name: 'BALUANTE',
            wni_unlocode: 'PHSCR',
            wni_country: 'PH',
            wni_lat: 15.77,
            wni_lon: 119.9,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'BMM',
            wni_port_name: 'BALAMBAN',
            wni_unlocode: 'PHTLD',
            wni_country: 'PH',
            wni_lat: 10.57,
            wni_lon: 123.72,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'BOGO',
            wni_port_name: 'BOGO',
            wni_unlocode: 'PHPPN',
            wni_country: 'PH',
            wni_lat: 11.05,
            wni_lon: 124,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'BRBN',
            wni_port_name: 'BORBON',
            wni_unlocode: 'PHISL',
            wni_country: 'PH',
            wni_lat: 10.83,
            wni_lon: 124.03,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'BRNGN',
            wni_port_name: 'PORT BORONGAN',
            wni_unlocode: 'PHBGV',
            wni_country: 'PH',
            wni_lat: 11.6,
            wni_lon: 125.43,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'BRRR',
            wni_port_name: 'PORT BARRERA',
            wni_unlocode: 'PHMBT',
            wni_country: 'PH',
            wni_lat: 12.52,
            wni_lon: 123.38,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'BULUN',
            wni_port_name: 'BULAN',
            wni_unlocode: 'PHMBT',
            wni_country: 'PH',
            wni_lat: 12.67,
            wni_lon: 123.87,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'BYBY',
            wni_port_name: 'BAYBAY',
            wni_unlocode: 'PHALB',
            wni_country: 'PH',
            wni_lat: 10.68,
            wni_lon: 124.8,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'CALPH',
            wni_port_name: 'COAL HARBOR',
            wni_unlocode: 'PHLIC',
            wni_country: 'PH',
            wni_lat: 13.25,
            wni_lon: 123.92,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'CAPIZ',
            wni_port_name: 'PORT CAPIZ',
            wni_unlocode: 'PHCSI',
            wni_country: 'PH',
            wni_lat: 11.6,
            wni_lon: 122.72,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'CARMN',
            wni_port_name: 'CARMEN',
            wni_unlocode: 'PHMAN',
            wni_country: 'PH',
            wni_lat: 10.58,
            wni_lon: 124.02,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'CBOL',
            wni_port_name: 'BOLINAO',
            wni_unlocode: 'PHSUA',
            wni_country: 'PH',
            wni_lat: 16.38,
            wni_lon: 119.9,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'CLBN',
            wni_port_name: 'CALUBIAN',
            wni_unlocode: 'PHSIS',
            wni_country: 'PH',
            wni_lat: 11.45,
            wni_lon: 124.43,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'CLPN',
            wni_port_name: 'CALAPAN',
            wni_unlocode: 'PHTBG',
            wni_country: 'PH',
            wni_lat: 13.42,
            wni_lon: 121.18,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'CMNWT',
            wni_port_name: 'CAMINAWIT',
            wni_unlocode: 'PHSMR',
            wni_country: 'PH',
            wni_lat: 12.33,
            wni_lon: 121.08,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'CRZPH',
            wni_port_name: 'SANTA CRUZ',
            wni_unlocode: 'PHBLG',
            wni_country: 'PH',
            wni_lat: 13.5,
            wni_lon: 122.07,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'CSGRN',
            wni_port_name: 'CASIGURAN',
            wni_unlocode: 'PHLIC',
            wni_country: 'PH',
            wni_lat: 12.88,
            wni_lon: 124,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'CTBNG',
            wni_port_name: 'CATABANGAN',
            wni_unlocode: 'PHHON',
            wni_country: 'PH',
            wni_lat: 13.88,
            wni_lon: 122.63,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'CTNN',
            wni_port_name: 'CATANAUAN',
            wni_unlocode: 'PHBLG',
            wni_country: 'PH',
            wni_lat: 13.6,
            wni_lon: 122.32,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'CVT',
            wni_port_name: 'CAVITE',
            wni_unlocode: 'PHMNL',
            wni_country: 'PH',
            wni_lat: 14.48,
            wni_lon: 120.92,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'DALAO',
            wni_port_name: 'DALIAO',
            wni_unlocode: 'PHSAN',
            wni_country: 'PH',
            wni_lat: 7.02,
            wni_lon: 125.5,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'DAPA',
            wni_port_name: 'DAPA',
            wni_unlocode: 'PHTTO',
            wni_country: 'PH',
            wni_lat: 9.75,
            wni_lon: 126.05,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'DGPN',
            wni_port_name: 'DAGUPAN CITY',
            wni_unlocode: 'PHSFN',
            wni_country: 'PH',
            wni_lat: 16.05,
            wni_lon: 120.33,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'DHKN',
            wni_port_name: 'DAHIKAN',
            wni_unlocode: 'PHJPM',
            wni_country: 'PH',
            wni_lat: 14.32,
            wni_lon: 122.62,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'DMNJG',
            wni_port_name: 'DUMANJUG',
            wni_unlocode: 'PHGHG',
            wni_country: 'PH',
            wni_lat: 10.07,
            wni_lon: 123.43,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'DNSL',
            wni_port_name: 'DONSOL',
            wni_unlocode: 'PHLIC',
            wni_country: 'PH',
            wni_lat: 12.9,
            wni_lon: 123.58,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'ESTBN',
            wni_port_name: 'PORT SAN ESTEBAN',
            wni_unlocode: 'CRABG',
            wni_country: 'PH',
            wni_lat: 17.33,
            wni_lon: 120.43,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'GANPH',
            wni_port_name: 'GAN BAY',
            wni_unlocode: 'PHCMO',
            wni_country: 'PH',
            wni_lat: 17.98,
            wni_lon: 120.48,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'GLAN',
            wni_port_name: 'GLAN',
            wni_unlocode: 'PHGES',
            wni_country: 'PH',
            wni_lat: 5.83,
            wni_lon: 125.2,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'GNDLM',
            wni_port_name: 'GUINDULMAN BAY',
            wni_unlocode: 'PHGHE',
            wni_country: 'PH',
            wni_lat: 9.75,
            wni_lon: 124.5,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'GNRL',
            wni_port_name: 'GENERAL LUNA',
            wni_unlocode: 'PHBLG',
            wni_country: 'PH',
            wni_lat: 13.68,
            wni_lon: 122.17,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'GUIUA',
            wni_port_name: 'GUIUAN',
            wni_unlocode: 'PHMNI',
            wni_country: 'PH',
            wni_lat: 11.03,
            wni_lon: 125.72,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'HOLL',
            wni_port_name: 'PORT HOLLAND',
            wni_unlocode: 'PHISB',
            wni_country: 'PH',
            wni_lat: 6.55,
            wni_lon: 121.87,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'INMCN',
            wni_port_name: 'INAMUCAN BAY',
            wni_unlocode: 'PHJNZ',
            wni_country: 'PH',
            wni_lat: 8.6,
            wni_lon: 123.72,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'IRENE',
            wni_port_name: 'PORT IRENE',
            wni_unlocode: 'PHAPR',
            wni_country: 'PH',
            wni_lat: 18.38,
            wni_lon: 122.11,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'JAGNA',
            wni_port_name: 'JAGNA',
            wni_unlocode: 'PHGHE',
            wni_country: 'PH',
            wni_lat: 9.65,
            wni_lon: 124.37,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'JRDN',
            wni_port_name: 'JORDAN',
            wni_unlocode: 'PHILO',
            wni_country: 'PH',
            wni_lat: 10.67,
            wni_lon: 122.58,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'JSAAN',
            wni_port_name: 'JASSAN',
            wni_unlocode: 'PHJAS',
            wni_country: 'PH',
            wni_lat: 8.65,
            wni_lon: 124.76,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'JTF',
            wni_port_name: 'JETAFE',
            wni_unlocode: 'PHMAN',
            wni_country: 'PH',
            wni_lat: 10.15,
            wni_lon: 124.15,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'KOL',
            wni_port_name: 'KOLAMBUGAN',
            wni_unlocode: 'PHOZC',
            wni_country: 'PH',
            wni_lat: 8.12,
            wni_lon: 123.89,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'LAMON',
            wni_port_name: 'LAMON ANCHORAGE',
            wni_unlocode: 'PHHNT',
            wni_country: 'PH',
            wni_lat: 8.47,
            wni_lon: 126.38,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'LARAP',
            wni_port_name: 'LARAP BAY',
            wni_unlocode: 'PHJPM',
            wni_country: 'PH',
            wni_lat: 14.32,
            wni_lon: 122.65,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'LGM',
            wni_port_name: 'LAGOME',
            wni_unlocode: 'PHLIB',
            wni_country: 'PH',
            wni_lat: 10.55,
            wni_lon: 125.18,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'LGY',
            wni_port_name: 'LINGAYEN',
            wni_unlocode: 'PHSUA',
            wni_country: 'PH',
            wni_lat: 16.03,
            wni_lon: 120.13,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'LIA',
            wni_port_name: 'LIANGA',
            wni_unlocode: 'PHHNT',
            wni_country: 'PH',
            wni_lat: 8.62,
            wni_lon: 126.08,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'LLN',
            wni_port_name: 'LILOAN',
            wni_unlocode: 'PHMAA',
            wni_country: 'PH',
            wni_lat: 10.17,
            wni_lon: 125.12,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'LOG',
            wni_port_name: 'LAOAG',
            wni_unlocode: 'PHCMO',
            wni_country: 'PH',
            wni_lat: 18.2,
            wni_lon: 120.58,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'LUP',
            wni_port_name: 'LA UNION',
            wni_unlocode: 'PHMXI',
            wni_country: 'PH',
            wni_lat: 6.7,
            wni_lon: 126.09,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'LYG',
            wni_port_name: 'LEYTE',
            wni_unlocode: 'PHSIS',
            wni_country: 'PH',
            wni_lat: 11.38,
            wni_lon: 124.5,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'LZB',
            wni_port_name: 'LAZI',
            wni_unlocode: 'PHLNA',
            wni_country: 'PH',
            wni_lat: 9.13,
            wni_lon: 123.63,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'MACTH',
            wni_port_name: 'GEN MACARTHUR',
            wni_unlocode: 'PHMNI',
            wni_country: 'PH',
            wni_lat: 11.25,
            wni_lon: 125.53,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'MCEDS',
            wni_port_name: 'MERCEDES',
            wni_unlocode: 'PHTDC',
            wni_country: 'PH',
            wni_lat: 14.12,
            wni_lon: 123.02,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'MERDA',
            wni_port_name: 'MERIDA',
            wni_unlocode: 'PHORC',
            wni_country: 'PH',
            wni_lat: 10.92,
            wni_lon: 124.53,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'MGLLN',
            wni_port_name: 'MAGALLANES',
            wni_unlocode: 'PHLIC',
            wni_country: 'PH',
            wni_lat: 12.83,
            wni_lon: 123.83,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'MLBNG',
            wni_port_name: 'MALABANG',
            wni_unlocode: 'PHPLC',
            wni_country: 'PH',
            wni_lat: 7.6,
            wni_lon: 124.07,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'MLTBG',
            wni_port_name: 'MALITBOG',
            wni_unlocode: 'PHMAA',
            wni_country: 'PH',
            wni_lat: 10.17,
            wni_lon: 125,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'MNSRT',
            wni_port_name: 'MONSERAT',
            wni_unlocode: 'PHMXI',
            wni_country: 'PH',
            wni_lat: 6.6,
            wni_lon: 126.1,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'MRBJC',
            wni_port_name: 'MARIBOJOC',
            wni_unlocode: 'PHTAG',
            wni_country: 'PH',
            wni_lat: 9.75,
            wni_lon: 123.85,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'NMNC',
            wni_port_name: 'NUMANCIA',
            wni_unlocode: 'PHTTO',
            wni_country: 'PH',
            wni_lat: 9.87,
            wni_lon: 125.97,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'NSGB',
            wni_port_name: 'NASUGBU',
            wni_unlocode: 'PHCAA',
            wni_country: 'PH',
            wni_lat: 14.08,
            wni_lon: 120.62,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'NVTS',
            wni_port_name: 'NAVOTAS',
            wni_unlocode: 'PHMNL',
            wni_country: 'PH',
            wni_lat: 14.67,
            wni_lon: 120.95,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'ODNGN',
            wni_port_name: 'ODIONGAN',
            wni_unlocode: 'PHANA',
            wni_country: 'PH',
            wni_lat: 8.85,
            wni_lon: 125.15,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'ORQT',
            wni_port_name: 'OROQUIETA',
            wni_unlocode: 'PHJNZ',
            wni_country: 'PH',
            wni_lat: 8.48,
            wni_lon: 123.82,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'OZMS',
            wni_port_name: 'PORT OZAMIS',
            wni_unlocode: 'PHOZC',
            wni_country: 'PH',
            wni_lat: 8.13,
            wni_lon: 123.85,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'PAN',
            wni_port_name: 'PARANG',
            wni_unlocode: 'PHJOL',
            wni_country: 'PH',
            wni_lat: 5.92,
            wni_lon: 120.91,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'PGPS',
            wni_port_name: 'PAGAPAS',
            wni_unlocode: 'PHCAA',
            wni_country: 'PH',
            wni_lat: 13.85,
            wni_lon: 120.67,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'PLRPH',
            wni_port_name: 'PILAR',
            wni_unlocode: 'PHISL',
            wni_country: 'PH',
            wni_lat: 10.8,
            wni_lon: 124.57,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'PNB',
            wni_port_name: 'PANABO',
            wni_unlocode: 'PHSAN',
            wni_country: 'PH',
            wni_lat: 7.32,
            wni_lon: 125.68,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'PNGN',
            wni_port_name: 'PANAGAN',
            wni_unlocode: 'PHTDC',
            wni_country: 'PH',
            wni_lat: 13.73,
            wni_lon: 123.43,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'PNMNG',
            wni_port_name: 'PINAMUNGAJAN',
            wni_unlocode: 'PHTLD',
            wni_country: 'PH',
            wni_lat: 10.27,
            wni_lon: 123.58,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'PRNG',
            wni_port_name: 'PARANG',
            wni_unlocode: 'PHPLC',
            wni_country: 'PH',
            wni_lat: 7.37,
            wni_lon: 124.25,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'PRTM',
            wni_port_name: 'PUERTO SANTA MARIA',
            wni_unlocode: 'PHSMA',
            wni_country: 'PH',
            wni_lat: 7.77,
            wni_lon: 122.12,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'PULAN',
            wni_port_name: 'PULAUAN',
            wni_unlocode: 'PHDPL',
            wni_country: 'PH',
            wni_lat: 8.63,
            wni_lon: 123.4,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'RAGAY',
            wni_port_name: 'PORT RAGAY',
            wni_unlocode: 'PHHON',
            wni_country: 'PH',
            wni_lat: 13.85,
            wni_lon: 122.65,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'RCD',
            wni_port_name: 'RECODO',
            wni_unlocode: 'PHZAM',
            wni_country: 'PH',
            wni_lat: 6.95,
            wni_lon: 121.97,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'RELPH',
            wni_port_name: 'PUERTO REAL',
            wni_unlocode: 'PHMAU',
            wni_country: 'PH',
            wni_lat: 14.67,
            wni_lon: 121.62,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'SEBSN',
            wni_port_name: 'SAN SEBASTIAN',
            wni_unlocode: 'PHTAN',
            wni_country: 'PH',
            wni_lat: 9.47,
            wni_lon: 123.3,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'SIBNG',
            wni_port_name: 'SIBONGA',
            wni_unlocode: 'PHSNG',
            wni_country: 'PH',
            wni_lat: 10.02,
            wni_lon: 123.62,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'SILAY',
            wni_port_name: 'SILAY',
            wni_unlocode: 'PHSNI',
            wni_country: 'PH',
            wni_lat: 10.8,
            wni_lon: 122.97,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'SJBUV',
            wni_port_name: 'SAN JOSE DE BUENAVISTA',
            wni_unlocode: 'PHSJI',
            wni_country: 'PH',
            wni_lat: 10.73,
            wni_lon: 121.93,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'SLMG',
            wni_port_name: 'SALOMAGUE',
            wni_unlocode: 'PHCMO',
            wni_country: 'PH',
            wni_lat: 17.78,
            wni_lon: 120.42,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'SOG',
            wni_port_name: 'SOGOD BAY',
            wni_unlocode: 'PHMAN',
            wni_country: 'PH',
            wni_lat: 10.75,
            wni_lon: 124,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'SOGOD',
            wni_port_name: 'SOGOD',
            wni_unlocode: 'PHHIL',
            wni_country: 'PH',
            wni_lat: 10.38,
            wni_lon: 124.98,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'SRSGN',
            wni_port_name: 'SORSOGON',
            wni_unlocode: 'PHLIC',
            wni_country: 'PH',
            wni_lat: 12.97,
            wni_lon: 124,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'SULA',
            wni_port_name: 'SULA',
            wni_unlocode: 'PHLIC',
            wni_country: 'PH',
            wni_lat: 13.23,
            wni_lon: 123.86,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'TALN',
            wni_port_name: 'TALAAN',
            wni_unlocode: 'PHCAA',
            wni_country: 'PH',
            wni_lat: 14.02,
            wni_lon: 120.67,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'TALOM',
            wni_port_name: 'TALOMO',
            wni_unlocode: 'PHSAN',
            wni_country: 'PH',
            wni_lat: 7.05,
            wni_lon: 125.55,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'TBG',
            wni_port_name: 'TABANGAO',
            wni_unlocode: 'PHTBG',
            wni_country: 'PH',
            wni_lat: 13.72,
            wni_lon: 121.05,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'TBGN',
            wni_port_name: 'TUBIGAN',
            wni_unlocode: 'PHTAG',
            wni_country: 'PH',
            wni_lat: 9.95,
            wni_lon: 123.97,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'TBRN',
            wni_port_name: 'TUBURAN',
            wni_unlocode: 'PHTOB',
            wni_country: 'PH',
            wni_lat: 10.73,
            wni_lon: 123.82,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'TLLR',
            wni_port_name: 'TALALORA',
            wni_unlocode: 'PHCTS',
            wni_country: 'PH',
            wni_lat: 11.53,
            wni_lon: 124.83,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'TMBNG',
            wni_port_name: 'TAMBUNGON',
            wni_unlocode: 'PHSAN',
            wni_country: 'PH',
            wni_lat: 7.25,
            wni_lon: 125.67,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'TOLNG',
            wni_port_name: 'TOLONG',
            wni_unlocode: 'PHBYW',
            wni_country: 'PH',
            wni_lat: 9.37,
            wni_lon: 122.8,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'TYY',
            wni_port_name: 'TUBAY',
            wni_unlocode: 'PHMAS',
            wni_country: 'PH',
            wni_lat: 9.17,
            wni_lon: 125.53,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'UNISN',
            wni_port_name: 'UNISAN',
            wni_unlocode: 'PHBLG',
            wni_country: 'PH',
            wni_lat: 13.83,
            wni_lon: 121.97,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'VLLB',
            wni_port_name: 'VILLABA',
            wni_unlocode: 'PHPPN',
            wni_country: 'PH',
            wni_lat: 11.22,
            wni_lon: 124.4,
            wni_tz: 'Asia/Manila',
        },
        {
            option: 'NOWY',
            wni_port_name: 'NOWY PORT',
            wni_unlocode: 'PLGDN',
            wni_country: 'PL',
            wni_lat: 54.42,
            wni_lon: 18.67,
            wni_tz: 'Europe/Warsaw',
        },
        {
            option: 'POLN',
            wni_port_name: 'PORT POLNOCHNY',
            wni_unlocode: 'PLGDN',
            wni_country: 'PL',
            wni_lat: 54.4,
            wni_lon: 18.72,
            wni_tz: 'Europe/Warsaw',
        },
        {
            option: 'PUCK',
            wni_port_name: 'PUCK',
            wni_unlocode: 'PLWLA',
            wni_country: 'PL',
            wni_lat: 54.73,
            wni_lon: 18.42,
            wni_tz: 'Europe/Warsaw',
        },
        {
            option: 'MIQ',
            wni_port_name: 'MIQUELON',
            wni_unlocode: 'PMFSP',
            wni_country: 'PM',
            wni_lat: 47.1,
            wni_lon: -56.37,
            wni_tz: 'America/Miquelon',
        },
        {
            option: 'STP',
            wni_port_name: 'PORT DE ST PIERRE',
            wni_unlocode: 'PMFSP',
            wni_country: 'PM',
            wni_lat: 46.78,
            wni_lon: -56.18,
            wni_tz: 'America/Miquelon',
        },
        {
            option: 'ARRY',
            wni_port_name: 'ARROYO',
            wni_unlocode: 'PRLAM',
            wni_country: 'PR',
            wni_lat: 17.97,
            wni_lon: -66.07,
            wni_tz: 'America/Puerto_Rico',
        },
        {
            option: 'CULBR',
            wni_port_name: 'CULEBRA',
            wni_unlocode: 'VISTT',
            wni_country: 'PR',
            wni_lat: 18.32,
            wni_lon: -65.22,
            wni_tz: 'America/Puerto_Rico',
        },
        {
            option: 'ESEND',
            wni_port_name: 'ENSENADA HONDA',
            wni_unlocode: 'PRFAJ',
            wni_country: 'PR',
            wni_lat: 18.23,
            wni_lon: -65.63,
            wni_tz: 'America/Puerto_Rico',
        },
        {
            option: 'FJRD',
            wni_port_name: 'FAJARO',
            wni_unlocode: 'PRFAJ',
            wni_country: 'PR',
            wni_lat: 18.33,
            wni_lon: -65.63,
            wni_tz: 'America/Puerto_Rico',
        },
        {
            option: 'GYNS',
            wni_port_name: 'PUNTA GUAYANES',
            wni_unlocode: 'PRYAB',
            wni_country: 'PR',
            wni_lat: 18.07,
            wni_lon: -65.82,
            wni_tz: 'America/Puerto_Rico',
        },
        {
            option: 'HUMAC',
            wni_port_name: 'PUERTO DE HUMACAO',
            wni_unlocode: 'PRYAB',
            wni_country: 'PR',
            wni_lat: 18.17,
            wni_lon: -65.75,
            wni_tz: 'America/Puerto_Rico',
        },
        {
            option: 'JOBOS',
            wni_port_name: 'BAHIA DE JOBOS',
            wni_unlocode: 'PRA6U',
            wni_country: 'PR',
            wni_lat: 17.95,
            wni_lon: -66.22,
            wni_tz: 'America/Puerto_Rico',
        },
        {
            option: 'MAUNB',
            wni_port_name: 'MAUNABO',
            wni_unlocode: 'PRYAB',
            wni_country: 'PR',
            wni_lat: 18,
            wni_lon: -65.9,
            wni_tz: 'America/Puerto_Rico',
        },
        {
            option: 'NAGUB',
            wni_port_name: 'NAGUABO',
            wni_unlocode: 'PRFAJ',
            wni_country: 'PR',
            wni_lat: 18.2,
            wni_lon: -65.72,
            wni_tz: 'America/Puerto_Rico',
        },
        {
            option: 'ROOV',
            wni_port_name: 'ROOSEVELT ROADS',
            wni_unlocode: 'PRFAJ',
            wni_country: 'PR',
            wni_lat: 18.22,
            wni_lon: -65.62,
            wni_tz: 'America/Puerto_Rico',
        },
        {
            option: 'SEGND',
            wni_port_name: 'ISABEL SEGUNDA',
            wni_unlocode: 'PRFAJ',
            wni_country: 'PR',
            wni_lat: 18.15,
            wni_lon: -65.45,
            wni_tz: 'America/Puerto_Rico',
        },
        {
            option: 'TALL',
            wni_port_name: 'TALLABOA',
            wni_unlocode: 'PRGUY',
            wni_country: 'PR',
            wni_lat: 17.98,
            wni_lon: -66.76,
            wni_tz: 'America/Puerto_Rico',
        },
        {
            option: 'ANTNO',
            wni_port_name: 'VILA REAL DE S ANTONIO',
            wni_unlocode: 'PTVRL',
            wni_country: 'PT',
            wni_lat: 37.18,
            wni_lon: -7.4,
            wni_tz: 'Europe/Lisbon',
        },
        {
            option: 'BEP',
            wni_port_name: 'BELEM',
            wni_unlocode: 'PTBAN',
            wni_country: 'PT',
            wni_lat: 38.69,
            wni_lon: -9.22,
            wni_tz: 'Europe/Lisbon',
        },
        {
            option: 'CLHTA',
            wni_port_name: 'CALHETA SAO JORGE',
            wni_unlocode: 'PTLDP',
            wni_country: 'PT',
            wni_lat: 38.37,
            wni_lon: -28.03,
            wni_tz: 'Atlantic/Azores',
        },
        {
            option: 'FRNCC',
            wni_port_name: 'VILA FRANCO DO CAMPO',
            wni_unlocode: 'PTPDL',
            wni_country: 'PT',
            wni_lat: 37.7,
            wni_lon: -25.43,
            wni_tz: 'Atlantic/Azores',
        },
        {
            option: 'LAJE',
            wni_port_name: 'LAJES DO PICO',
            wni_unlocode: 'PTLDP',
            wni_country: 'PT',
            wni_lat: 38.4,
            wni_lon: -28.27,
            wni_tz: 'Atlantic/Azores',
        },
        {
            option: 'MDR',
            wni_port_name: 'MADEIRA',
            wni_unlocode: 'PTFNC',
            wni_country: 'PT',
            wni_lat: 32.65,
            wni_lon: -16.9,
            wni_tz: 'Atlantic/Madeira',
        },
        {
            option: 'MSTRS',
            wni_port_name: 'MOSTEIROS SAO MIGUEL',
            wni_unlocode: 'PTPDL',
            wni_country: 'PT',
            wni_lat: 37.37,
            wni_lon: -25.48,
            wni_tz: 'Atlantic/Azores',
        },
        {
            option: 'OUT',
            wni_port_name: 'OUTAO',
            wni_unlocode: 'PTSET',
            wni_country: 'PT',
            wni_lat: 38.49,
            wni_lon: -8.93,
            wni_tz: 'Europe/Lisbon',
        },
        {
            option: 'PCI',
            wni_port_name: 'SAO MATUES PICO',
            wni_unlocode: 'PTLDP',
            wni_country: 'PT',
            wni_lat: 38.42,
            wni_lon: -28.45,
            wni_tz: 'Atlantic/Azores',
        },
        {
            option: 'PIAA',
            wni_port_name: 'PRAIA DE VITORIA',
            wni_unlocode: 'PTPRV',
            wni_country: 'PT',
            wni_lat: 38.72,
            wni_lon: -27.05,
            wni_tz: 'Atlantic/Azores',
        },
        {
            option: 'PICPT',
            wni_port_name: 'MADALENA PICO',
            wni_unlocode: 'PTHOR',
            wni_country: 'PT',
            wni_lat: 38.53,
            wni_lon: -28.53,
            wni_tz: 'Atlantic/Azores',
        },
        {
            option: 'RIJ',
            wni_port_name: 'RIO TEJO',
            wni_unlocode: 'PTLIS',
            wni_country: 'PT',
            wni_lat: 38.76,
            wni_lon: -9.09,
            wni_tz: 'Europe/Lisbon',
        },
        {
            option: 'SAJIS',
            wni_port_name: 'VELAS SAO JORGE',
            wni_unlocode: 'PTLDP',
            wni_country: 'PT',
            wni_lat: 38.67,
            wni_lon: -28.2,
            wni_tz: 'Atlantic/Azores',
        },
        {
            option: 'SANTO',
            wni_port_name: 'PUERTO SANTO',
            wni_unlocode: 'PTPXO',
            wni_country: 'PT',
            wni_lat: 33.05,
            wni_lon: -16.33,
            wni_tz: 'Atlantic/Madeira',
        },
        {
            option: 'SBST',
            wni_port_name: 'SAO SEBASTIAO TERCEIRA',
            wni_unlocode: 'PTADH',
            wni_country: 'PT',
            wni_lat: 38.42,
            wni_lon: -27.07,
            wni_tz: 'Atlantic/Azores',
        },
        {
            option: 'SXL',
            wni_port_name: 'SEIXAL',
            wni_unlocode: 'PTBRO',
            wni_country: 'PT',
            wni_lat: 38.64,
            wni_lon: -9.11,
            wni_tz: 'Europe/Lisbon',
        },
        {
            option: 'ALUD',
            wni_port_name: 'AL UDAYD',
            wni_unlocode: 'QAUMS',
            wni_country: 'QA',
            wni_lat: 24.6,
            wni_lon: 51.33,
            wni_tz: 'Asia/Qatar',
        },
        {
            option: 'HLU',
            wni_port_name: 'JAZIRATH HALUL',
            wni_unlocode: 'QAHAL',
            wni_country: 'QA',
            wni_lat: 25.68,
            wni_lon: 52.42,
            wni_tz: 'Asia/Qatar',
        },
        {
            option: 'LAPO',
            wni_port_name: 'PORT DE LA POSSESSION',
            wni_unlocode: 'REPD2',
            wni_country: 'RE',
            wni_lat: -20.92,
            wni_lon: 55.33,
            wni_tz: 'Indian/Reunion',
        },
        {
            option: 'STDNS',
            wni_port_name: 'ST DENIS',
            wni_unlocode: 'REPD2',
            wni_country: 'RE',
            wni_lat: -20.87,
            wni_lon: 55.47,
            wni_tz: 'Indian/Reunion',
        },
        {
            option: 'STPRR',
            wni_port_name: 'ST PIERRE',
            wni_unlocode: 'REPD2',
            wni_country: 'RE',
            wni_lat: -21.33,
            wni_lon: 55.48,
            wni_tz: 'Indian/Reunion',
        },
        {
            option: 'GLT',
            wni_port_name: 'GALATI',
            wni_unlocode: 'ROGAZ',
            wni_country: 'RO',
            wni_lat: 45.42,
            wni_lon: 28.08,
            wni_tz: 'Europe/Bucharest',
        },
        {
            option: 'NVDR',
            wni_port_name: 'MIDIA NAVODARI',
            wni_unlocode: 'ROMID',
            wni_country: 'RO',
            wni_lat: 44.33,
            wni_lon: 28.68,
            wni_tz: 'Europe/Bucharest',
        },
        {
            option: 'TIGLN',
            wni_port_name: 'TIGLINA',
            wni_unlocode: 'ROGAZ',
            wni_country: 'RO',
            wni_lat: 45.38,
            wni_lon: 28.03,
            wni_tz: 'Europe/Bucharest',
        },
        {
            option: 'ABRAM',
            wni_port_name: 'MYS ABRAM',
            wni_unlocode: 'RUMMK',
            wni_country: 'RU',
            wni_lat: 68.98,
            wni_lon: 33.03,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'ADLR',
            wni_port_name: 'ADLER',
            wni_unlocode: 'RUSOC',
            wni_country: 'RU',
            wni_lat: 43.43,
            wni_lon: 39.93,
            wni_tz: 'Europe/Volgograd',
        },
        {
            option: 'AKHTN',
            wni_port_name: 'AKHTANIZOVSKAYA',
            wni_unlocode: 'RUKZP',
            wni_country: 'RU',
            wni_lat: 45.35,
            wni_lon: 37.13,
            wni_tz: 'Europe/Volgograd',
        },
        {
            option: 'ALKSY',
            wni_port_name: 'ALEKSEYEVA',
            wni_unlocode: 'RUVVO',
            wni_country: 'RU',
            wni_lat: 43,
            wni_lon: 131.93,
            wni_tz: 'Asia/Vladivostok',
        },
        {
            option: 'ANDRY',
            wni_port_name: 'BUKHTA ANDREYEVA',
            wni_unlocode: 'RUBKN',
            wni_country: 'RU',
            wni_lat: 43.1,
            wni_lon: 132.33,
            wni_tz: 'Asia/Vladivostok',
        },
        {
            option: 'ANDYR',
            wni_port_name: 'ANAOYR',
            wni_unlocode: 'RUDYR',
            wni_country: 'RU',
            wni_lat: 64.73,
            wni_lon: 177.5,
            wni_tz: 'Asia/Anadyr',
        },
        {
            option: 'BLTYT',
            wni_port_name: 'BALTIYETS',
            wni_unlocode: 'RUVYS',
            wni_country: 'RU',
            wni_lat: 60.62,
            wni_lon: 28.32,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'CHKHV',
            wni_port_name: 'CHEKHOV',
            wni_unlocode: 'RUKHO',
            wni_country: 'RU',
            wni_lat: 47.43,
            wni_lon: 141.98,
            wni_tz: 'Asia/Sakhalin',
        },
        {
            option: 'DLZHN',
            wni_port_name: 'DOLZHANSKAYA',
            wni_unlocode: 'RUYEY',
            wni_country: 'RU',
            wni_lat: 46.65,
            wni_lon: 37.82,
            wni_tz: 'Europe/Volgograd',
        },
        {
            option: 'DZHB',
            wni_port_name: 'DZHUBGA',
            wni_unlocode: 'RUTUA',
            wni_country: 'RU',
            wni_lat: 44.32,
            wni_lon: 38.7,
            wni_tz: 'Europe/Volgograd',
        },
        {
            option: 'GLNZ',
            wni_port_name: 'GELENDZHIK',
            wni_unlocode: 'RUNVS',
            wni_country: 'RU',
            wni_lat: 44.55,
            wni_lon: 38.07,
            wni_tz: 'Europe/Volgograd',
        },
        {
            option: 'GRMKH',
            wni_port_name: 'GREMIKHA',
            wni_unlocode: 'RUIOK',
            wni_country: 'RU',
            wni_lat: 68.05,
            wni_lon: 39.52,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'GYDMK',
            wni_port_name: 'BUKHTA GAYDAMAK',
            wni_unlocode: 'RUNJK',
            wni_country: 'RU',
            wni_lat: 42.87,
            wni_lon: 132.68,
            wni_tz: 'Asia/Vladivostok',
        },
        {
            option: 'ISLYM',
            wni_port_name: 'MYS ISLYAMOVA',
            wni_unlocode: 'RUVVO',
            wni_country: 'RU',
            wni_lat: 43.05,
            wni_lon: 131.83,
            wni_tz: 'Asia/Vladivostok',
        },
        {
            option: 'KAMYS',
            wni_port_name: 'KAMYSHEVATSKAYA',
            wni_unlocode: 'RUYEY',
            wni_country: 'RU',
            wni_lat: 46.42,
            wni_lon: 37.92,
            wni_tz: 'Europe/Volgograd',
        },
        {
            option: 'KHST',
            wni_port_name: 'KHOSTA',
            wni_unlocode: 'RUSOC',
            wni_country: 'RU',
            wni_lat: 43.52,
            wni_lon: 39.88,
            wni_tz: 'Europe/Volgograd',
        },
        {
            option: 'KNYSH',
            wni_port_name: 'BUKHTA KONYUSHKOVA',
            wni_unlocode: 'RUBKN',
            wni_country: 'RU',
            wni_lat: 42.87,
            wni_lon: 132.37,
            wni_tz: 'Asia/Vladivostok',
        },
        {
            option: 'KOLA',
            wni_port_name: 'KOLA',
            wni_unlocode: 'RUMMK',
            wni_country: 'RU',
            wni_lat: 68.87,
            wni_lon: 33.02,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'LAVNA',
            wni_port_name: 'LAVNA',
            wni_unlocode: 'RUMMK',
            wni_country: 'RU',
            wni_lat: 69.03,
            wni_lon: 33.02,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'LKHTR',
            wni_port_name: 'LIKHTERNAYA GAVAN',
            wni_unlocode: 'RUVVO',
            wni_country: 'RU',
            wni_lat: 43.15,
            wni_lon: 131.9,
            wni_tz: 'Asia/Vladivostok',
        },
        {
            option: 'LSGRS',
            wni_port_name: 'LESOGORSK',
            wni_unlocode: 'RUBOS',
            wni_country: 'RU',
            wni_lat: 49.45,
            wni_lon: 142.13,
            wni_tz: 'Asia/Sakhalin',
        },
        {
            option: 'MKV',
            wni_port_name: 'MOSKAL VO',
            wni_unlocode: 'RUMVO',
            wni_country: 'RU',
            wni_lat: 53.58,
            wni_lon: 142.5,
            wni_tz: 'Asia/Sakhalin',
        },
        {
            option: 'MTSST',
            wni_port_name: 'MATSESTA',
            wni_unlocode: 'RUSOC',
            wni_country: 'RU',
            wni_lat: 43.55,
            wni_lon: 39.83,
            wni_tz: 'Europe/Volgograd',
        },
        {
            option: 'NGYV',
            wni_port_name: 'NAGAEVA',
            wni_unlocode: 'RUMAG',
            wni_country: 'RU',
            wni_lat: 59.57,
            wni_lon: 150.72,
            wni_tz: 'Asia/Magadan',
        },
        {
            option: 'NIKO',
            wni_port_name: 'NIKOLAYEVSK NA AMURE',
            wni_unlocode: 'RUNIA',
            wni_country: 'RU',
            wni_lat: 53.13,
            wni_lon: 140.73,
            wni_tz: 'Asia/Vladivostok',
        },
        {
            option: 'NRY',
            wni_port_name: 'NAR YAN-MAR',
            wni_unlocode: 'RUNNM',
            wni_country: 'RU',
            wni_lat: 67.65,
            wni_lon: 53,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'OKHA',
            wni_port_name: 'OKHA',
            wni_unlocode: 'RUMVO',
            wni_country: 'RU',
            wni_lat: 53.55,
            wni_lon: 143,
            wni_tz: 'Asia/Sakhalin',
        },
        {
            option: 'PLYRN',
            wni_port_name: 'POLYARNYY',
            wni_unlocode: 'RUMMK',
            wni_country: 'RU',
            wni_lat: 69.2,
            wni_lon: 33.47,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'PTRDV',
            wni_port_name: 'PETRODVORETS',
            wni_unlocode: 'RULOM',
            wni_country: 'RU',
            wni_lat: 59.88,
            wni_lon: 29.92,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'REPLA',
            wni_port_name: 'REPOLA',
            wni_unlocode: 'RUVYS',
            wni_country: 'RU',
            wni_lat: 60.65,
            wni_lon: 28.5,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'RSTV',
            wni_port_name: 'ROSTOV-NA-DONU',
            wni_unlocode: 'RURND',
            wni_country: 'RU',
            wni_lat: 47.17,
            wni_lon: 39.72,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'SDLVT',
            wni_port_name: 'OSTROV SEDLOVATYY',
            wni_unlocode: 'RUMMK',
            wni_country: 'RU',
            wni_lat: 69.25,
            wni_lon: 33.47,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'SDZKH',
            wni_port_name: 'BUKHTA SUDZUKHE',
            wni_unlocode: 'RUKZM',
            wni_country: 'RU',
            wni_lat: 42.85,
            wni_lon: 133.67,
            wni_tz: 'Asia/Vladivostok',
        },
        {
            option: 'SLDYN',
            wni_port_name: 'SELDYANAYA',
            wni_unlocode: 'RUBKN',
            wni_country: 'RU',
            wni_lat: 43.17,
            wni_lon: 132.37,
            wni_tz: 'Asia/Vladivostok',
        },
        {
            option: 'SLMBL',
            wni_port_name: 'SOLOMBALA',
            wni_unlocode: 'RUARH',
            wni_country: 'RU',
            wni_lat: 64.58,
            wni_lon: 40.5,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'SNNY',
            wni_port_name: 'SENNAYA',
            wni_unlocode: 'RUKZP',
            wni_country: 'RU',
            wni_lat: 45.28,
            wni_lon: 36.98,
            wni_tz: 'Europe/Volgograd',
        },
        {
            option: 'SVMSK',
            wni_port_name: 'SEVEROMORSK',
            wni_unlocode: 'RUMMK',
            wni_country: 'RU',
            wni_lat: 69.08,
            wni_lon: 33.45,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'UTRSH',
            wni_port_name: 'MYS UTRISH',
            wni_unlocode: 'RUAAQ',
            wni_country: 'RU',
            wni_lat: 44.77,
            wni_lon: 37.4,
            wni_tz: 'Europe/Volgograd',
        },
        {
            option: 'VYNG',
            wni_port_name: 'VAYENGA',
            wni_unlocode: 'RUMMK',
            wni_country: 'RU',
            wni_lat: 69.08,
            wni_lon: 33.45,
            wni_tz: 'Europe/Moscow',
        },
        {
            option: 'VYZ',
            wni_port_name: 'BUKHTA GEKA',
            wni_unlocode: 'RUSKA',
            wni_country: 'RU',
            wni_lat: 42.97,
            wni_lon: 131.48,
            wni_tz: 'Asia/Vladivostok',
        },
        {
            option: 'YBLCH',
            wni_port_name: 'YABLOCHNYY',
            wni_unlocode: 'RUKHO',
            wni_country: 'RU',
            wni_lat: 47.17,
            wni_lon: 142.07,
            wni_tz: 'Asia/Sakhalin',
        },
        {
            option: 'KFATH',
            wni_port_name: 'KING FAHD PORT',
            wni_unlocode: 'SAYBI',
            wni_country: 'SA',
            wni_lat: 23.95,
            wni_lon: 38.22,
            wni_tz: 'Asia/Riyadh',
        },
        {
            option: 'ALRDY',
            wni_port_name: 'ALARDYCE',
            wni_unlocode: 'SBALB',
            wni_country: 'SB',
            wni_lat: -7.78,
            wni_lon: 158.65,
            wni_tz: 'Pacific/Guadalcanal',
        },
        {
            option: 'BILOA',
            wni_port_name: 'BILOA',
            wni_unlocode: 'SBGZO',
            wni_country: 'SB',
            wni_lat: -7.93,
            wni_lon: 156.72,
            wni_tz: 'Pacific/Guadalcanal',
        },
        {
            option: 'GZO',
            wni_port_name: 'PORT GIZO',
            wni_unlocode: 'SBGZO',
            wni_country: 'SB',
            wni_lat: -8.1,
            wni_lon: 156.85,
            wni_tz: 'Pacific/Guadalcanal',
        },
        {
            option: 'LEVER',
            wni_port_name: 'LEVER HARBOR',
            wni_unlocode: 'SBNOR',
            wni_country: 'SB',
            wni_lat: -8.02,
            wni_lon: 157.58,
            wni_tz: 'Pacific/Guadalcanal',
        },
        {
            option: 'PPSL',
            wni_port_name: 'PIPISALA BAY',
            wni_unlocode: 'SBXYA',
            wni_country: 'SB',
            wni_lat: -9,
            wni_lon: 159.12,
            wni_tz: 'Pacific/Guadalcanal',
        },
        {
            option: 'SLH',
            wni_port_name: 'SHORTLAND HARBOR',
            wni_unlocode: 'SBSHH',
            wni_country: 'SB',
            wni_lat: -7.08,
            wni_lon: 155.9,
            wni_tz: 'Pacific/Guadalcanal',
        },
        {
            option: 'SSVL',
            wni_port_name: 'SASAVELE',
            wni_unlocode: 'SBMUA',
            wni_country: 'SB',
            wni_lat: -8.33,
            wni_lon: 157.35,
            wni_tz: 'Pacific/Guadalcanal',
        },
        {
            option: 'TLGH',
            wni_port_name: 'TULAGHI HARBOR',
            wni_unlocode: 'SBTLG',
            wni_country: 'SB',
            wni_lat: -9.1,
            wni_lon: 160.15,
            wni_tz: 'Pacific/Guadalcanal',
        },
        {
            option: 'SD',
            wni_port_name: 'BUR SUDAN',
            wni_unlocode: 'SDPZU',
            wni_country: 'SD',
            wni_lat: 19.6,
            wni_lon: 37.23,
            wni_tz: 'Africa/Khartoum',
        },
        {
            option: 'ALDSE',
            wni_port_name: 'ALAND',
            wni_unlocode: 'SEHND',
            wni_country: 'SE',
            wni_lat: 62.67,
            wni_lon: 17.85,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'ARKSN',
            wni_port_name: 'ARKOSUND',
            wni_unlocode: 'SEOXE',
            wni_country: 'SE',
            wni_lat: 58.48,
            wni_lon: 16.95,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'AXMAR',
            wni_port_name: 'AXMAR',
            wni_unlocode: 'SENOT',
            wni_country: 'SE',
            wni_lat: 61,
            wni_lon: 17.15,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'AXMRB',
            wni_port_name: 'AXMARBRUK',
            wni_unlocode: 'SENOT',
            wni_country: 'SE',
            wni_lat: 61.05,
            wni_lon: 17.15,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'BCKFR',
            wni_port_name: 'BACKFORS',
            wni_unlocode: 'SEROR',
            wni_country: 'SE',
            wni_lat: 64.52,
            wni_lon: 21.42,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'BODA',
            wni_port_name: 'BODA',
            wni_unlocode: 'SEPAS',
            wni_country: 'SE',
            wni_lat: 57.23,
            wni_lon: 17.08,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'BRDNR',
            wni_port_name: 'BREDNORET',
            wni_unlocode: 'SESIK',
            wni_country: 'SE',
            wni_lat: 63.93,
            wni_lon: 20.8,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'BRGHM',
            wni_port_name: 'BERGHAMN',
            wni_unlocode: 'SEUTA',
            wni_country: 'SE',
            wni_lat: 62.82,
            wni_lon: 18.23,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'BRGKV',
            wni_port_name: 'BERGKVARA',
            wni_unlocode: 'SEDEG',
            wni_country: 'SE',
            wni_lat: 56.38,
            wni_lon: 16.1,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'BRNNF',
            wni_port_name: 'BRANNFORS',
            wni_unlocode: 'SEPIT',
            wni_country: 'SE',
            wni_lat: 65.03,
            wni_lon: 21.35,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'BRSTH',
            wni_port_name: 'BARSTAHAMN',
            wni_unlocode: 'SELUG',
            wni_country: 'SE',
            wni_lat: 62.87,
            wni_lon: 18.4,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'BUNGN',
            wni_port_name: 'BUNGENAS',
            wni_unlocode: 'SESUS',
            wni_country: 'SE',
            wni_lat: 57.82,
            wni_lon: 19.1,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'BUREA',
            wni_port_name: 'BUREA',
            wni_unlocode: 'SEROR',
            wni_country: 'SE',
            wni_lat: 64.62,
            wni_lon: 21.25,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'BURSE',
            wni_port_name: 'BURVIK',
            wni_unlocode: 'SEROR',
            wni_country: 'SE',
            wni_lat: 64.58,
            wni_lon: 21.35,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'BVLLS',
            wni_port_name: 'BOVALLSTRAND',
            wni_unlocode: 'SEBRO',
            wni_country: 'SE',
            wni_lat: 58.48,
            wni_lon: 11.33,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'BYSE',
            wni_port_name: 'BYVIKEN',
            wni_unlocode: 'SEHLD',
            wni_country: 'SE',
            wni_lat: 63.8,
            wni_lon: 20.87,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'DALRO',
            wni_port_name: 'DALARO',
            wni_unlocode: 'SESTO',
            wni_country: 'SE',
            wni_lat: 59.13,
            wni_lon: 18.42,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'DJU',
            wni_port_name: 'DJURON',
            wni_unlocode: 'SEBVK',
            wni_country: 'SE',
            wni_lat: 58.63,
            wni_lon: 16.34,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'DJUP',
            wni_port_name: 'DJUPVIKEN',
            wni_unlocode: 'SEHLD',
            wni_country: 'SE',
            wni_lat: 63.72,
            wni_lon: 20.38,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'DLKRL',
            wni_port_name: 'DALKARLSA',
            wni_unlocode: 'SESIK',
            wni_country: 'SE',
            wni_lat: 64.05,
            wni_lon: 20.88,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'DLSFJ',
            wni_port_name: 'JATTEN DALSFJARDEN',
            wni_unlocode: 'SEHUV',
            wni_country: 'SE',
            wni_lat: 61.95,
            wni_lon: 17.35,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'DYNAS',
            wni_port_name: 'DYNAS',
            wni_unlocode: 'SEVAJ',
            wni_country: 'SE',
            wni_lat: 62.97,
            wni_lon: 17.77,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'ENANG',
            wni_port_name: 'ENANGER HARBOR',
            wni_unlocode: 'SEIGG',
            wni_country: 'SE',
            wni_lat: 61.55,
            wni_lon: 17,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'ESSSE',
            wni_port_name: 'ESSVIK',
            wni_unlocode: 'SESVK',
            wni_country: 'SE',
            wni_lat: 62.32,
            wni_lon: 17.4,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'FAGER',
            wni_port_name: 'FAGERVIK',
            wni_unlocode: 'SEOST',
            wni_country: 'SE',
            wni_lat: 62.5,
            wni_lon: 17.4,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'FGER',
            wni_port_name: 'FAGERVIKEN',
            wni_unlocode: 'SESSR',
            wni_country: 'SE',
            wni_lat: 60.55,
            wni_lon: 17.75,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'FGHLM',
            wni_port_name: 'FIGEHOLM',
            wni_unlocode: 'SEOSK',
            wni_country: 'SE',
            wni_lat: 57.37,
            wni_lon: 16.55,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'FJLLB',
            wni_port_name: 'FJALLBACKA',
            wni_unlocode: 'SEBRO',
            wni_country: 'SE',
            wni_lat: 58.6,
            wni_lon: 11.28,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'FRANO',
            wni_port_name: 'FRANO',
            wni_unlocode: 'SES2N',
            wni_country: 'SE',
            wni_lat: 62.92,
            wni_lon: 17.85,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'FRGRN',
            wni_port_name: 'FURUOGRUND',
            wni_unlocode: 'SEKAG',
            wni_country: 'SE',
            wni_lat: 64.92,
            wni_lon: 21.23,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'FRJST',
            wni_port_name: 'FARJESTADEN',
            wni_unlocode: 'SEKLR',
            wni_country: 'SE',
            wni_lat: 56.65,
            wni_lon: 16.47,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'FRLLN',
            wni_port_name: 'FURILLEN',
            wni_unlocode: 'SESUS',
            wni_country: 'SE',
            wni_lat: 57.77,
            wni_lon: 19,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'FRSD',
            wni_port_name: 'FAROSUND',
            wni_unlocode: 'SEKPH',
            wni_country: 'SE',
            wni_lat: 57.87,
            wni_lon: 19.07,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'FRSND',
            wni_port_name: 'FURUSUND',
            wni_unlocode: 'SEKPS',
            wni_country: 'SE',
            wni_lat: 59.67,
            wni_lon: 18.93,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'FRSTK',
            wni_port_name: 'FROSTKAGE',
            wni_unlocode: 'SEKAG',
            wni_country: 'SE',
            wni_lat: 64.87,
            wni_lon: 21.03,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'FSHBC',
            wni_port_name: 'FISHBACKSKIL',
            wni_unlocode: 'SELYS',
            wni_country: 'SE',
            wni_lat: 58.25,
            wni_lon: 11.47,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'GASE',
            wni_port_name: 'GAVIK',
            wni_unlocode: 'SELUG',
            wni_country: 'SE',
            wni_lat: 62.88,
            wni_lon: 18.22,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'GLTST',
            wni_port_name: 'GALTSTROM',
            wni_unlocode: 'SESVK',
            wni_country: 'SE',
            wni_lat: 62.17,
            wni_lon: 17.52,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'GMBD',
            wni_port_name: 'GUMBODA',
            wni_unlocode: 'SESIK',
            wni_country: 'SE',
            wni_lat: 64.23,
            wni_lon: 21.1,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'GMLBY',
            wni_port_name: 'GAMLEBY',
            wni_unlocode: 'SEVVK',
            wni_country: 'SE',
            wni_lat: 57.9,
            wni_lon: 16.42,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'GNNN',
            wni_port_name: 'GUNNON',
            wni_unlocode: 'SEKAN',
            wni_country: 'SE',
            wni_lat: 56.15,
            wni_lon: 14.78,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'GRBBS',
            wni_port_name: 'GREBBESTAD',
            wni_unlocode: 'SESMD',
            wni_country: 'SE',
            wni_lat: 58.68,
            wni_lon: 11.27,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'GRISS',
            wni_port_name: 'GRISSLEHAMN',
            wni_unlocode: 'SEHAK',
            wni_country: 'SE',
            wni_lat: 60.1,
            wni_lon: 18.82,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'GRNSE',
            wni_port_name: 'GRANVIK',
            wni_unlocode: 'SEAXE',
            wni_country: 'SE',
            wni_lat: 65.75,
            wni_lon: 23.75,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'GROP',
            wni_port_name: 'GROPVIKEN',
            wni_unlocode: 'SEVAK',
            wni_country: 'SE',
            wni_lat: 58.35,
            wni_lon: 16.65,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'GRUNS',
            wni_port_name: 'GRUNDSUND',
            wni_unlocode: 'SELYS',
            wni_country: 'SE',
            wni_lat: 58.22,
            wni_lon: 11.42,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'GRVRN',
            wni_port_name: 'GRAVARNE',
            wni_unlocode: 'SEBRO',
            wni_country: 'SE',
            wni_lat: 58.35,
            wni_lon: 11.23,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'GRYSE',
            wni_port_name: 'GRYT',
            wni_unlocode: 'SEVAK',
            wni_country: 'SE',
            wni_lat: 58.18,
            wni_lon: 16.78,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'GUSTA',
            wni_port_name: 'GUSTAVSVIK',
            wni_unlocode: 'SES2N',
            wni_country: 'SE',
            wni_lat: 62.83,
            wni_lon: 17.88,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'GUSTV',
            wni_port_name: 'GUSTAVSBERG',
            wni_unlocode: 'SESTO',
            wni_country: 'SE',
            wni_lat: 59.32,
            wni_lon: 18.38,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'HALST',
            wni_port_name: 'HALLSTANAS',
            wni_unlocode: 'SES2N',
            wni_country: 'SE',
            wni_lat: 62.92,
            wni_lon: 17.87,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'HERR',
            wni_port_name: 'HERRVIK',
            wni_unlocode: 'SERNH',
            wni_country: 'SE',
            wni_lat: 57.42,
            wni_lon: 18.93,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'HGMRS',
            wni_port_name: 'HOGMARSO',
            wni_unlocode: 'SEKPS',
            wni_country: 'SE',
            wni_lat: 59.65,
            wni_lon: 18.85,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'HLLVK',
            wni_port_name: 'KALLVIKEN',
            wni_unlocode: 'SESIK',
            wni_country: 'SE',
            wni_lat: 64.33,
            wni_lon: 21.38,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'HNNBS',
            wni_port_name: 'HUNNEBOSTRAND',
            wni_unlocode: 'SEBRO',
            wni_country: 'SE',
            wni_lat: 58.43,
            wni_lon: 11.3,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'HVSTN',
            wni_port_name: 'HAVSTENSSUND',
            wni_unlocode: 'SESMD',
            wni_country: 'SE',
            wni_lat: 58.75,
            wni_lon: 11.18,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'JHNND',
            wni_port_name: 'JOHANNEDAL',
            wni_unlocode: 'SETUN',
            wni_country: 'SE',
            wni_lat: 62.43,
            wni_lon: 17.4,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'JRNSH',
            wni_port_name: 'JARNASHAMN',
            wni_unlocode: 'SERUV',
            wni_country: 'SE',
            wni_lat: 63.43,
            wni_lon: 19.68,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'JTTRS',
            wni_port_name: 'STORA JATTERSON',
            wni_unlocode: 'SEPAS',
            wni_country: 'SE',
            wni_lat: 57.1,
            wni_lon: 16.57,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'KLGSH',
            wni_port_name: 'KLAGSHAMN',
            wni_unlocode: 'SELIM',
            wni_country: 'SE',
            wni_lat: 55.52,
            wni_lon: 12.9,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'KLHMN',
            wni_port_name: 'KOLOHAMNEN',
            wni_unlocode: 'SEKAN',
            wni_country: 'SE',
            wni_lat: 56.15,
            wni_lon: 14.83,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'KLLSK',
            wni_port_name: 'KALLSKAR',
            wni_unlocode: 'SESAE',
            wni_country: 'SE',
            wni_lat: 61.25,
            wni_lon: 17.2,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'KLMPN',
            wni_port_name: 'KLAMPENBORG',
            wni_unlocode: 'SESVK',
            wni_country: 'SE',
            wni_lat: 62.33,
            wni_lon: 17.4,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'KOJA',
            wni_port_name: 'KOJA',
            wni_unlocode: 'SEKRF',
            wni_country: 'SE',
            wni_lat: 62.97,
            wni_lon: 17.85,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'KRLSH',
            wni_port_name: 'KARLSHALL',
            wni_unlocode: 'SEKAK',
            wni_country: 'SE',
            wni_lat: 65.62,
            wni_lon: 22.08,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'KRSSE',
            wni_port_name: 'KARLSVIK',
            wni_unlocode: 'SEORT',
            wni_country: 'SE',
            wni_lat: 62.38,
            wni_lon: 17.43,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'KYLRN',
            wni_port_name: 'KYLORN',
            wni_unlocode: 'SEHNF',
            wni_country: 'SE',
            wni_lat: 63.53,
            wni_lon: 19.77,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'LANGV',
            wni_port_name: 'LANGVIND',
            wni_unlocode: 'SESTU',
            wni_country: 'SE',
            wni_lat: 61.47,
            wni_lon: 17.13,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'LGD',
            wni_port_name: 'LAGDEA',
            wni_unlocode: 'SESIK',
            wni_country: 'SE',
            wni_lat: 64.13,
            wni_lon: 20.97,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'LINGR',
            wni_port_name: 'LINGARO',
            wni_unlocode: 'SEHUV',
            wni_country: 'SE',
            wni_lat: 61.73,
            wni_lon: 17.25,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'LLLJN',
            wni_port_name: 'LILLJUNGFRUNS',
            wni_unlocode: 'SESAE',
            wni_country: 'SE',
            wni_lat: 61.25,
            wni_lon: 17.3,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'LUNDE',
            wni_port_name: 'LUNDE',
            wni_unlocode: 'SES2N',
            wni_country: 'SE',
            wni_lat: 62.88,
            wni_lon: 17.88,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'LVDDN',
            wni_port_name: 'LOVUDDEN',
            wni_unlocode: 'SEHND',
            wni_country: 'SE',
            wni_lat: 62.6,
            wni_lon: 17.93,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'LVSL',
            wni_port_name: 'LOVSELE',
            wni_unlocode: 'SESIK',
            wni_country: 'SE',
            wni_lat: 64.3,
            wni_lon: 21.25,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'MRBYL',
            wni_port_name: 'MORBYLANGA',
            wni_unlocode: 'SEKLR',
            wni_country: 'SE',
            wni_lat: 56.53,
            wni_lon: 16.38,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'MRIBG',
            wni_port_name: 'MARIEBERG',
            wni_unlocode: 'SEVAJ',
            wni_country: 'SE',
            wni_lat: 62.98,
            wni_lon: 17.78,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'MRMRB',
            wni_port_name: 'MARMORBRUKET',
            wni_unlocode: 'SEBVK',
            wni_country: 'SE',
            wni_lat: 58.67,
            wni_lon: 16.42,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'MYRNS',
            wni_port_name: 'MYRNAS',
            wni_unlocode: 'SEORT',
            wni_country: 'SE',
            wni_lat: 62.37,
            wni_lon: 17.43,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'NRRBY',
            wni_port_name: 'NORRBYSKAR',
            wni_unlocode: 'SEHNF',
            wni_country: 'SE',
            wni_lat: 63.55,
            wni_lon: 19.88,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'NRRTL',
            wni_port_name: 'NORRTALJE',
            wni_unlocode: 'SEKPS',
            wni_country: 'SE',
            wni_lat: 59.77,
            wni_lon: 18.72,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'NSKT',
            wni_port_name: 'NASKET',
            wni_unlocode: 'SEKMH',
            wni_country: 'SE',
            wni_lat: 63.15,
            wni_lon: 18.52,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'NSSLN',
            wni_port_name: 'NASSLAND',
            wni_unlocode: 'SEHND',
            wni_country: 'SE',
            wni_lat: 62.67,
            wni_lon: 17.88,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'NTHLM',
            wni_port_name: 'NOTHOLMEN',
            wni_unlocode: 'SERUV',
            wni_country: 'SE',
            wni_lat: 63.57,
            wni_lon: 19.48,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'NYHMN',
            wni_port_name: 'SODRA NYHAMN',
            wni_unlocode: 'SESVK',
            wni_country: 'SE',
            wni_lat: 62.33,
            wni_lon: 17.42,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'ORGRN',
            wni_port_name: 'OREGRUND',
            wni_unlocode: 'SEHAN',
            wni_country: 'SE',
            wni_lat: 60.35,
            wni_lon: 18.45,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'ORSE',
            wni_port_name: 'ORVIKEN',
            wni_unlocode: 'SESKE',
            wni_country: 'SE',
            wni_lat: 64.67,
            wni_lon: 21.2,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'OSMMR',
            wni_port_name: 'OSTHAMMAR',
            wni_unlocode: 'SEHAN',
            wni_country: 'SE',
            wni_lat: 60.27,
            wni_lon: 18.38,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'RAASE',
            wni_port_name: 'RAA',
            wni_unlocode: 'SEHEL',
            wni_country: 'SE',
            wni_lat: 56,
            wni_lon: 12.75,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'RAMSE',
            wni_port_name: 'RAMVIK',
            wni_unlocode: 'SEUTA',
            wni_country: 'SE',
            wni_lat: 62.82,
            wni_lon: 17.87,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'RAMST',
            wni_port_name: 'RAMSTA',
            wni_unlocode: 'SELUG',
            wni_country: 'SE',
            wni_lat: 62.85,
            wni_lon: 18.22,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'RATAN',
            wni_port_name: 'RATAN',
            wni_unlocode: 'SESIK',
            wni_country: 'SE',
            wni_lat: 64,
            wni_lon: 20.9,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'RNNBY',
            wni_port_name: 'RONNEBYHAMN',
            wni_unlocode: 'SERNB',
            wni_country: 'SE',
            wni_lat: 56.18,
            wni_lon: 15.3,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'SALJF',
            wni_port_name: 'SALJFVIKEN',
            wni_unlocode: 'SEUTA',
            wni_country: 'SE',
            wni_lat: 62.83,
            wni_lon: 18.23,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'SALT',
            wni_port_name: 'SALTVIK',
            wni_unlocode: 'SEOSK',
            wni_country: 'SE',
            wni_lat: 57.3,
            wni_lon: 16.5,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'SANDN',
            wni_port_name: 'SANDVIKEN',
            wni_unlocode: 'SEAXE',
            wni_country: 'SE',
            wni_lat: 65.73,
            wni_lon: 23.77,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'SANDV',
            wni_port_name: 'SANDVIKEN',
            wni_unlocode: 'SEKRF',
            wni_country: 'SE',
            wni_lat: 62.95,
            wni_lon: 17.78,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'SKEDE',
            wni_port_name: 'SKEDE',
            wni_unlocode: 'SEHUS',
            wni_country: 'SE',
            wni_lat: 63.25,
            wni_lon: 19.02,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'SKGSH',
            wni_port_name: 'SKAGSHAMN',
            wni_unlocode: 'SEHUS',
            wni_country: 'SE',
            wni_lat: 63.22,
            wni_lon: 19.03,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'SKON',
            wni_port_name: 'SKONVIK',
            wni_unlocode: 'SEOST',
            wni_country: 'SE',
            wni_lat: 62.47,
            wni_lon: 17.37,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'SKPPS',
            wni_port_name: 'SKEPPSGARDEN',
            wni_unlocode: 'SEVAK',
            wni_country: 'SE',
            wni_lat: 58.03,
            wni_lon: 16.67,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'SKRST',
            wni_port_name: 'SKARSTA',
            wni_unlocode: 'SEHAK',
            wni_country: 'SE',
            wni_lat: 60.05,
            wni_lon: 18.58,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'SKTHM',
            wni_port_name: 'SKUTHAMN',
            wni_unlocode: 'SEMUN',
            wni_country: 'SE',
            wni_lat: 65.27,
            wni_lon: 21.5,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'SLTSE',
            wni_port_name: 'SALTVIK',
            wni_unlocode: 'SEHUV',
            wni_country: 'SE',
            wni_lat: 61.68,
            wni_lon: 17.25,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'SLTSJ',
            wni_port_name: 'SALTSJOBADEN',
            wni_unlocode: 'SESTO',
            wni_country: 'SE',
            wni_lat: 59.28,
            wni_lon: 18.32,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'SMOGN',
            wni_port_name: 'SMOGEN',
            wni_unlocode: 'SEBRO',
            wni_country: 'SE',
            wni_lat: 58.35,
            wni_lon: 11.22,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'SMPHM',
            wni_port_name: 'SIMPHAMN',
            wni_unlocode: 'SEOBB',
            wni_country: 'SE',
            wni_lat: 63.67,
            wni_lon: 20.23,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'SNDHM',
            wni_port_name: 'SANDHAMN',
            wni_unlocode: 'SESTO',
            wni_country: 'SE',
            wni_lat: 59.28,
            wni_lon: 18.92,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'SNDSB',
            wni_port_name: 'SUNDSBRUK',
            wni_unlocode: 'SETUN',
            wni_country: 'SE',
            wni_lat: 62.45,
            wni_lon: 17.38,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'SNDSE',
            wni_port_name: 'SANDVIK',
            wni_unlocode: 'SEHLD',
            wni_country: 'SE',
            wni_lat: 63.72,
            wni_lon: 20.38,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'STCK',
            wni_port_name: 'STOCKA',
            wni_unlocode: 'SEHUV',
            wni_country: 'SE',
            wni_lat: 61.9,
            wni_lon: 17.35,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'STLLR',
            wni_port_name: 'STILLERYDSHAMNEN',
            wni_unlocode: 'SEKAN',
            wni_country: 'SE',
            wni_lat: 56.17,
            wni_lon: 14.83,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'STMSD',
            wni_port_name: 'STROMSUND',
            wni_unlocode: 'SEKAK',
            wni_country: 'SE',
            wni_lat: 65.87,
            wni_lon: 22.38,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'STRFR',
            wni_port_name: 'STORFORS',
            wni_unlocode: 'SEMUN',
            wni_country: 'SE',
            wni_lat: 65.3,
            wni_lon: 21.42,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'STRKG',
            wni_port_name: 'STORKAGE',
            wni_unlocode: 'SEKAG',
            wni_country: 'SE',
            wni_lat: 64.83,
            wni_lon: 20.98,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'STRMS',
            wni_port_name: 'STROMSTAD',
            wni_unlocode: 'SESMD',
            wni_country: 'SE',
            wni_lat: 58.93,
            wni_lon: 11.17,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'TINGH',
            wni_port_name: 'TINGSHOLMEN',
            wni_unlocode: 'SEMUN',
            wni_country: 'SE',
            wni_lat: 65.3,
            wni_lon: 21.43,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'TMMRN',
            wni_port_name: 'TIMMERNABBEN',
            wni_unlocode: 'SEPHM',
            wni_country: 'SE',
            wni_lat: 56.97,
            wni_lon: 16.43,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'TRFRS',
            wni_port_name: 'TOREFORS',
            wni_unlocode: 'SEKAX',
            wni_country: 'SE',
            wni_lat: 65.88,
            wni_lon: 22.7,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'TRHMN',
            wni_port_name: 'TOREHAMN',
            wni_unlocode: 'SEKAX',
            wni_country: 'SE',
            wni_lat: 65.9,
            wni_lon: 22.65,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'ULVHM',
            wni_port_name: 'ULVOHAMN',
            wni_unlocode: 'SEKMH',
            wni_country: 'SE',
            wni_lat: 63.02,
            wni_lon: 18.65,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'ULVSE',
            wni_port_name: 'ULVVIK',
            wni_unlocode: 'SEHND',
            wni_country: 'SE',
            wni_lat: 62.67,
            wni_lon: 17.87,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'URSSE',
            wni_port_name: 'URSVIKEN',
            wni_unlocode: 'SESKE',
            wni_country: 'SE',
            wni_lat: 64.7,
            wni_lon: 21.18,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'VRKBC',
            wni_port_name: 'VERKEBACK',
            wni_unlocode: 'SEVVK',
            wni_country: 'SE',
            wni_lat: 57.73,
            wni_lon: 16.53,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'VVSTV',
            wni_port_name: 'VIVSTAVARV',
            wni_unlocode: 'SEOST',
            wni_country: 'SE',
            wni_lat: 62.48,
            wni_lon: 17.37,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'VXHLM',
            wni_port_name: 'VAXHOLM',
            wni_unlocode: 'SESTO',
            wni_country: 'SE',
            wni_lat: 59.4,
            wni_lon: 18.33,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'KPM',
            wni_port_name: 'KEPPEL MOORS',
            wni_unlocode: 'SGSIN',
            wni_country: 'SG',
            wni_lat: 1.26,
            wni_lon: 103.84,
            wni_tz: 'Asia/Singapore',
        },
        {
            option: 'PBU',
            wni_port_name: 'PULAU BUKUM',
            wni_unlocode: 'SGPUB',
            wni_country: 'SG',
            wni_lat: 1.23,
            wni_lon: 103.77,
            wni_tz: 'Asia/Singapore',
        },
        {
            option: 'SRNGN',
            wni_port_name: 'SERANGOON HARBOR',
            wni_unlocode: 'KELOY',
            wni_country: 'SG',
            wni_lat: 1.4,
            wni_lon: 103.95,
            wni_tz: 'Asia/Singapore',
        },
        {
            option: 'EDINB',
            wni_port_name: 'EDINBURGH',
            wni_unlocode: 'SHTDC',
            wni_country: 'SH',
            wni_lat: -37.05,
            wni_lon: -12.3,
            wni_tz: 'Atlantic/St_Helena',
        },
        {
            option: 'PRTRZ',
            wni_port_name: 'PORTOROZ',
            wni_unlocode: 'SIPIR',
            wni_country: 'SI',
            wni_lat: 45.52,
            wni_lon: 13.58,
            wni_tz: 'Europe/Ljubljana',
        },
        {
            option: 'KARAB',
            wni_port_name: 'KARABANE',
            wni_unlocode: 'SNZIG',
            wni_country: 'SN',
            wni_lat: 12.57,
            wni_lon: -16.7,
            wni_tz: 'Africa/Dakar',
        },
        {
            option: 'RFSQ',
            wni_port_name: 'RUFISQUE',
            wni_unlocode: 'SNDKR',
            wni_country: 'SN',
            wni_lat: 14.7,
            wni_lon: -17.28,
            wni_tz: 'Africa/Dakar',
        },
        {
            option: 'KMU',
            wni_port_name: 'KISMAAYO',
            wni_unlocode: 'SOKMU',
            wni_country: 'SO',
            wni_lat: -0.37,
            wni_lon: 42.55,
            wni_tz: 'Africa/Mogadishu',
        },
        {
            option: 'MOG',
            wni_port_name: 'MUQDISHO',
            wni_unlocode: 'SOMGQ',
            wni_country: 'SO',
            wni_lat: 2.03,
            wni_lon: 45.35,
            wni_tz: 'Africa/Mogadishu',
        },
        {
            option: 'BLW',
            wni_port_name: 'BELWAARDE',
            wni_unlocode: 'SRPBM',
            wni_country: 'SR',
            wni_lat: 5.85,
            wni_lon: -55.08,
            wni_tz: 'America/Paramaribo',
        },
        {
            option: 'TC',
            wni_port_name: 'TURKOISE',
            wni_unlocode: 'TCPLS',
            wni_country: 'TC',
            wni_lat: 21.81,
            wni_lon: -72.18,
            wni_tz: 'America/Grand_Turk',
        },
        {
            option: 'BTRUA',
            wni_port_name: 'BAN THA RUA',
            wni_unlocode: 'THHKT',
            wni_country: 'TH',
            wni_lat: 7.88,
            wni_lon: 98.4,
            wni_tz: 'Asia/Bangkok',
        },
        {
            option: 'CHAA',
            wni_port_name: 'CHA-AM',
            wni_unlocode: 'THPCT',
            wni_country: 'TH',
            wni_lat: 12.82,
            wni_lon: 100,
            wni_tz: 'Asia/Bangkok',
        },
        {
            option: 'KANT',
            wni_port_name: 'KATANG',
            wni_unlocode: 'THKAN',
            wni_country: 'TH',
            wni_lat: 7.4,
            wni_lon: 99.52,
            wni_tz: 'Asia/Bangkok',
        },
        {
            option: 'PRONG',
            wni_port_name: 'THUNG PRONG',
            wni_unlocode: 'THSAT',
            wni_country: 'TH',
            wni_lat: 12.7,
            wni_lon: 100.83,
            wni_tz: 'Asia/Bangkok',
        },
        {
            option: 'SAMET',
            wni_port_name: 'CHUK SAMET',
            wni_unlocode: 'THSAT',
            wni_country: 'TH',
            wni_lat: 12.62,
            wni_lon: 100.92,
            wni_tz: 'Asia/Bangkok',
        },
        {
            option: 'THLA',
            wni_port_name: 'THASALA',
            wni_unlocode: 'THTHA',
            wni_country: 'TH',
            wni_lat: 8.67,
            wni_lon: 99.97,
            wni_tz: 'Asia/Bangkok',
        },
        {
            option: 'TTH',
            wni_port_name: 'THA-THONG TERMINAL',
            wni_unlocode: 'THKSI',
            wni_country: 'TH',
            wni_lat: 13.14,
            wni_lon: 100.82,
            wni_tz: 'Asia/Bangkok',
        },
        {
            option: 'UDOM',
            wni_port_name: 'AO UDOM',
            wni_unlocode: 'THSBP',
            wni_country: 'TH',
            wni_lat: 13.12,
            wni_lon: 100.88,
            wni_tz: 'Asia/Bangkok',
        },
        {
            option: 'ALLAH',
            wni_port_name: 'RAS SIDI ABD ALLAH',
            wni_unlocode: 'TNMBA',
            wni_country: 'TN',
            wni_lat: 37.15,
            wni_lon: 9.82,
            wni_tz: 'Africa/Tunis',
        },
        {
            option: 'HWMT',
            wni_port_name: 'HAWMAT AS SUQ',
            wni_unlocode: 'TNZAZ',
            wni_country: 'TN',
            wni_lat: 33.88,
            wni_lon: 10.87,
            wni_tz: 'Africa/Tunis',
        },
        {
            option: 'TZRK',
            wni_port_name: 'TAZERKA',
            wni_unlocode: 'TNOUD',
            wni_country: 'TN',
            wni_lat: 36.6,
            wni_lon: 11.68,
            wni_tz: 'Africa/Tunis',
        },
        {
            option: 'WADI',
            wni_port_name: 'HALQ AL WADI',
            wni_unlocode: 'TNLGN',
            wni_country: 'TN',
            wni_lat: 36.82,
            wni_lon: 10.3,
            wni_tz: 'Africa/Tunis',
        },
        {
            option: 'ALE',
            wni_port_name: 'ALEM DAGI',
            wni_unlocode: 'TRHAY',
            wni_country: 'TR',
            wni_lat: 41.04,
            wni_lon: 29.12,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'ALEM',
            wni_port_name: 'ALEMDAR',
            wni_unlocode: 'TRDIL',
            wni_country: 'TR',
            wni_lat: 40.77,
            wni_lon: 29.54,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'AVR',
            wni_port_name: 'AVCILAR',
            wni_unlocode: 'TRKMX',
            wni_country: 'TR',
            wni_lat: 40.98,
            wni_lon: 28.72,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'AYVL',
            wni_port_name: 'AYVALIK',
            wni_unlocode: 'GRMJT',
            wni_country: 'TR',
            wni_lat: 39.32,
            wni_lon: 26.7,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'BART',
            wni_port_name: 'BARTIN',
            wni_unlocode: 'TRZON',
            wni_country: 'TR',
            wni_lat: 41.69,
            wni_lon: 32.23,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'BOTAS',
            wni_port_name: 'BOTAS',
            wni_unlocode: 'TRCEY',
            wni_country: 'TR',
            wni_lat: 36.88,
            wni_lon: 35.93,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'BOZ',
            wni_port_name: 'BOZCAADA',
            wni_unlocode: 'TRBZC',
            wni_country: 'TR',
            wni_lat: 39.83,
            wni_lon: 26.07,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'BRGZ',
            wni_port_name: 'BURGAZ ADASI',
            wni_unlocode: 'TRKAR',
            wni_country: 'TR',
            wni_lat: 40.87,
            wni_lon: 29.07,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'BSP',
            wni_port_name: 'BOSPORUS',
            wni_unlocode: 'TRIST',
            wni_country: 'TR',
            wni_lat: 41,
            wni_lon: 29.01,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'BURNU',
            wni_port_name: 'KUM BURNU',
            wni_unlocode: 'TRGEL',
            wni_country: 'TR',
            wni_lat: 40.63,
            wni_lon: 26.73,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'BYKCK',
            wni_port_name: 'BUYUKCEKMECE',
            wni_unlocode: 'TRAKC',
            wni_country: 'TR',
            wni_lat: 41.02,
            wni_lon: 28.58,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'BYKD',
            wni_port_name: 'BUYUKADA',
            wni_unlocode: 'TRKAR',
            wni_country: 'TR',
            wni_lat: 40.88,
            wni_lon: 29.13,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'BYKZ',
            wni_port_name: 'BEYKOZ',
            wni_unlocode: 'TRBTS',
            wni_country: 'TR',
            wni_lat: 41.13,
            wni_lon: 29.08,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'ERDEK',
            wni_port_name: 'ERDEK',
            wni_unlocode: 'TREDK',
            wni_country: 'TR',
            wni_lat: 40.38,
            wni_lon: 27.8,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'FOC',
            wni_port_name: 'FOCA',
            wni_unlocode: 'TRFET',
            wni_country: 'TR',
            wni_lat: 36.65,
            wni_lon: 29.11,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'GLCK',
            wni_port_name: 'GOLCUK',
            wni_unlocode: 'TRTUT',
            wni_country: 'TR',
            wni_lat: 40.73,
            wni_lon: 29.8,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'GRLSH',
            wni_port_name: 'GORELEISHAKLI',
            wni_unlocode: 'TRGOR',
            wni_country: 'TR',
            wni_lat: 41.08,
            wni_lon: 39.15,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'INCRK',
            wni_port_name: 'INCIRKOY',
            wni_unlocode: 'TRBTS',
            wni_country: 'TR',
            wni_lat: 41.12,
            wni_lon: 29.1,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'ISKLS',
            wni_port_name: 'GOKOVA ISKELESI',
            wni_unlocode: 'TRMRM',
            wni_country: 'TR',
            wni_lat: 37.05,
            wni_lon: 28.32,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'ISTNY',
            wni_port_name: 'ISTINYE',
            wni_unlocode: 'TRBTS',
            wni_country: 'TR',
            wni_lat: 41.12,
            wni_lon: 29.05,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'KFLMN',
            wni_port_name: 'KEFALO LIMIN',
            wni_unlocode: 'TRANZ',
            wni_country: 'TR',
            wni_lat: 40.15,
            wni_lon: 25.98,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'KILYA',
            wni_port_name: 'KILYA KOYU',
            wni_unlocode: 'TRDAN',
            wni_country: 'TR',
            wni_lat: 40.2,
            wni_lon: 26.37,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'KRCSM',
            wni_port_name: 'KURUCESME',
            wni_unlocode: 'TRBTS',
            wni_country: 'TR',
            wni_lat: 41.05,
            wni_lon: 29.03,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'KRFZ',
            wni_port_name: 'CESME KORFEZI',
            wni_unlocode: 'TRCES',
            wni_country: 'TR',
            wni_lat: 38.33,
            wni_lon: 26.3,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'KRN',
            wni_port_name: 'KROMAN',
            wni_unlocode: 'TRTUZ',
            wni_country: 'TR',
            wni_lat: 40.8,
            wni_lon: 29.34,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'KYKY',
            wni_port_name: 'KIYIKOY',
            wni_unlocode: 'TRIGN',
            wni_country: 'TR',
            wni_lat: 41.63,
            wni_lon: 28.1,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'LBRNU',
            wni_port_name: 'LAZ BURNU',
            wni_unlocode: 'TRHAY',
            wni_country: 'TR',
            wni_lat: 40.97,
            wni_lon: 29.05,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'LIMAN',
            wni_port_name: 'AK LIMAN',
            wni_unlocode: 'TRSIC',
            wni_country: 'TR',
            wni_lat: 42.05,
            wni_lon: 35.07,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'MBRNU',
            wni_port_name: 'MESAR BURNU',
            wni_unlocode: 'TRBTS',
            wni_country: 'TR',
            wni_lat: 41.17,
            wni_lon: 29.05,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'MLTP',
            wni_port_name: 'MALTEPE',
            wni_unlocode: 'TRKAR',
            wni_country: 'TR',
            wni_lat: 40.9,
            wni_lon: 29.15,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'MRD',
            wni_port_name: 'MARDAS',
            wni_unlocode: 'TRKMX',
            wni_country: 'TR',
            wni_lat: 40.97,
            wni_lon: 28.68,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'NBRNU',
            wni_port_name: 'NARA BURNU',
            wni_unlocode: 'TRDAN',
            wni_country: 'TR',
            wni_lat: 40.2,
            wni_lon: 26.4,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'PKM',
            wni_port_name: 'PETKIM',
            wni_unlocode: 'TRALI',
            wni_country: 'TR',
            wni_lat: 38.81,
            wni_lon: 26.94,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'SGCK',
            wni_port_name: 'SIGACIK',
            wni_unlocode: 'TRIZM',
            wni_country: 'TR',
            wni_lat: 38.2,
            wni_lon: 26.78,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'SILE',
            wni_port_name: 'SILE',
            wni_unlocode: 'TREYP',
            wni_country: 'TR',
            wni_lat: 41.17,
            wni_lon: 29.62,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'TVL',
            wni_port_name: 'TAVSANCIL',
            wni_unlocode: 'TRDIL',
            wni_country: 'TR',
            wni_lat: 40.77,
            wni_lon: 29.57,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'TVSN',
            wni_port_name: 'TAVSAN ADASI',
            wni_unlocode: 'TRBZC',
            wni_country: 'TR',
            wni_lat: 39.93,
            wni_lon: 26.07,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'USD',
            wni_port_name: 'USKUDAR',
            wni_unlocode: 'TRKKY',
            wni_country: 'TR',
            wni_lat: 41.02,
            wni_lon: 28.98,
            wni_tz: 'Europe/Istanbul',
        },
        {
            option: 'CRON',
            wni_port_name: 'CRONSTADT',
            wni_unlocode: 'TTCHA',
            wni_country: 'TT',
            wni_lat: 10.65,
            wni_lon: -61.63,
            wni_tz: 'America/Port_of_Spain',
        },
        {
            option: 'PLI1',
            wni_port_name: 'POINT LISAS PORT',
            wni_unlocode: 'TTPTS',
            wni_country: 'TT',
            wni_lat: 10.4,
            wni_lon: -61.5,
            wni_tz: 'America/Port_of_Spain',
        },
        {
            option: 'SFRND',
            wni_port_name: 'SAN FERNANDO',
            wni_unlocode: 'TTVBL',
            wni_country: 'TT',
            wni_lat: 10.28,
            wni_lon: -61.47,
            wni_tz: 'America/Port_of_Spain',
        },
        {
            option: 'FNFT',
            wni_port_name: 'FUNAFUTI ATOLL',
            wni_unlocode: 'TVFUN',
            wni_country: 'TV',
            wni_lat: -8.52,
            wni_lon: 179.05,
            wni_tz: 'Pacific/Funafuti',
        },
        {
            option: 'SUA',
            wni_port_name: 'SU-AO KANG',
            wni_unlocode: 'TWSUO',
            wni_country: 'TW',
            wni_lat: 24.6,
            wni_lon: 121.87,
            wni_tz: 'Asia/Taipei',
        },
        {
            option: 'TNSH',
            wni_port_name: 'TAN SHUI',
            wni_unlocode: 'TWTPE',
            wni_country: 'TW',
            wni_lat: 25.18,
            wni_lon: 121.4,
            wni_tz: 'Asia/Taipei',
        },
        {
            option: 'YNAN',
            wni_port_name: 'YUN AN LNG TERMINAL',
            wni_unlocode: 'TWYAN',
            wni_country: 'TW',
            wni_lat: 22.81,
            wni_lon: 120.2,
            wni_tz: 'Asia/Taipei',
        },
        {
            option: 'MJMWM',
            wni_port_name: 'MJIMWEMA TERMINAL',
            wni_unlocode: 'TZDAR',
            wni_country: 'TZ',
            wni_lat: -6.82,
            wni_lon: 39.37,
            wni_tz: 'Africa/Dar_es_Salaam',
        },
        {
            option: 'MKNDN',
            wni_port_name: 'MIKINDANI',
            wni_unlocode: 'TZMYW',
            wni_country: 'TZ',
            wni_lat: -10.27,
            wni_lon: 40.13,
            wni_tz: 'Africa/Dar_es_Salaam',
        },
        {
            option: 'ADZHB',
            wni_port_name: 'ADZHUBAY',
            wni_unlocode: 'UAKEH',
            wni_country: 'UA',
            wni_lat: 45.4,
            wni_lon: 36.08,
            wni_tz: 'Europe/Simferopol',
        },
        {
            option: 'ALUS',
            wni_port_name: 'ALUSHTA',
            wni_unlocode: 'UAYAL',
            wni_country: 'UA',
            wni_lat: 44.68,
            wni_lon: 34.42,
            wni_tz: 'Europe/Simferopol',
        },
        {
            option: 'ARSHN',
            wni_port_name: 'ARSHINTSEVE',
            wni_unlocode: 'UAKEH',
            wni_country: 'UA',
            wni_lat: 45.28,
            wni_lon: 36.43,
            wni_tz: 'Europe/Simferopol',
        },
        {
            option: 'BKHT',
            wni_port_name: 'BAKALS KA BUKHTA',
            wni_unlocode: 'UASKD',
            wni_country: 'UA',
            wni_lat: 45.77,
            wni_lon: 33.22,
            wni_tz: 'Europe/Simferopol',
        },
        {
            option: 'BLKLV',
            wni_port_name: 'BALAKLAVA',
            wni_unlocode: 'UASVP',
            wni_country: 'UA',
            wni_lat: 44.5,
            wni_lon: 33.6,
            wni_tz: 'Europe/Simferopol',
        },
        {
            option: 'DYRMN',
            wni_port_name: 'DYURMEN',
            wni_unlocode: 'UAFEO',
            wni_country: 'UA',
            wni_lat: 45.02,
            wni_lon: 35.98,
            wni_tz: 'Europe/Simferopol',
        },
        {
            option: 'FODO',
            wni_port_name: 'FEODOSIYA',
            wni_unlocode: 'UAFEO',
            wni_country: 'UA',
            wni_lat: 45.02,
            wni_lon: 35.43,
            wni_tz: 'Europe/Simferopol',
        },
        {
            option: 'HRZF',
            wni_port_name: 'HURZUF',
            wni_unlocode: 'UAYAL',
            wni_country: 'UA',
            wni_lat: 44.55,
            wni_lon: 34.28,
            wni_tz: 'Europe/Simferopol',
        },
        {
            option: 'ISM',
            wni_port_name: 'IZMAYIL',
            wni_unlocode: 'UAIZM',
            wni_country: 'UA',
            wni_lat: 45.35,
            wni_lon: 28.85,
            wni_tz: 'Europe/Kiev',
        },
        {
            option: 'KHRLY',
            wni_port_name: 'KHORLY',
            wni_unlocode: 'UASKD',
            wni_country: 'UA',
            wni_lat: 46.08,
            wni_lon: 33.28,
            wni_tz: 'Europe/Kiev',
        },
        {
            option: 'MBURN',
            wni_port_name: 'MYS BURNAS',
            wni_unlocode: 'UABGD',
            wni_country: 'UA',
            wni_lat: 45.82,
            wni_lon: 30.15,
            wni_tz: 'Europe/Kiev',
        },
        {
            option: 'MYSV',
            wni_port_name: 'MYSOVE',
            wni_unlocode: 'UAKEH',
            wni_country: 'UA',
            wni_lat: 45.45,
            wni_lon: 35.85,
            wni_tz: 'Europe/Simferopol',
        },
        {
            option: 'OKB',
            wni_port_name: 'OKTYABRSK',
            wni_unlocode: 'UADNB',
            wni_country: 'UA',
            wni_lat: 46.84,
            wni_lon: 31.94,
            wni_tz: 'Europe/Kiev',
        },
        {
            option: 'PLNRS',
            wni_port_name: 'PLANERSKE',
            wni_unlocode: 'UAFEO',
            wni_country: 'UA',
            wni_lat: 44.97,
            wni_lon: 35.4,
            wni_tz: 'Europe/Simferopol',
        },
        {
            option: 'STKY',
            wni_port_name: 'BUKHTA STRELETSKAYA',
            wni_unlocode: 'UASVP',
            wni_country: 'UA',
            wni_lat: 44.62,
            wni_lon: 33.47,
            wni_tz: 'Europe/Simferopol',
        },
        {
            option: 'SUDAK',
            wni_port_name: 'SUDAK',
            wni_unlocode: 'UAFEO',
            wni_country: 'UA',
            wni_lat: 44.85,
            wni_lon: 34.98,
            wni_tz: 'Europe/Simferopol',
        },
        {
            option: 'SVRNY',
            wni_port_name: 'BUKHTA SEVERNAYA',
            wni_unlocode: 'UASVP',
            wni_country: 'UA',
            wni_lat: 44.62,
            wni_lon: 33.53,
            wni_tz: 'Europe/Simferopol',
        },
        {
            option: 'TNDRV',
            wni_port_name: 'TENDRIVSKA ZATOKA',
            wni_unlocode: 'UAYUZ',
            wni_country: 'UA',
            wni_lat: 46.37,
            wni_lon: 31.52,
            wni_tz: 'Europe/Kiev',
        },
        {
            option: 'ADK',
            wni_port_name: 'ADAK NAVAL AIR STATION',
            wni_unlocode: 'USADK',
            wni_country: 'US',
            wni_lat: 51.87,
            wni_lon: -176.63,
            wni_tz: 'America/Adak',
        },
        {
            option: 'AHUKN',
            wni_port_name: 'AHUKINI LANDING',
            wni_unlocode: 'USNWL',
            wni_country: 'US',
            wni_lat: 22,
            wni_lon: -159.33,
            wni_tz: 'Pacific/Honolulu',
        },
        {
            option: 'AKUT',
            wni_port_name: 'AKUTAN HARBOR',
            wni_unlocode: 'USAKU',
            wni_country: 'US',
            wni_lat: 54.13,
            wni_lon: -165.8,
            wni_tz: 'America/Nome',
        },
        {
            option: 'ALCAN',
            wni_port_name: 'ALCAN HARBOR',
            wni_unlocode: 'USALC',
            wni_country: 'US',
            wni_lat: 52.73,
            wni_lon: 174.07,
            wni_tz: 'America/Adak',
        },
        {
            option: 'ALGM',
            wni_port_name: 'ALGOMA',
            wni_unlocode: 'USGRB',
            wni_country: 'US',
            wni_lat: 44.6,
            wni_lon: -87.43,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'ALSN',
            wni_port_name: 'ALSEN',
            wni_unlocode: 'USACS',
            wni_country: 'US',
            wni_lat: 42.16,
            wni_lon: -73.92,
            wni_tz: 'America/New_York',
        },
        {
            option: 'AMB',
            wni_port_name: 'AMBROSE PILOT',
            wni_unlocode: 'USUYU',
            wni_country: 'US',
            wni_lat: 40.46,
            wni_lon: -73.85,
            wni_tz: 'America/New_York',
        },
        {
            option: 'AMBOY',
            wni_port_name: 'SOUTH AMBOY',
            wni_unlocode: 'USPAY',
            wni_country: 'US',
            wni_lat: 40.48,
            wni_lon: -74.27,
            wni_tz: 'America/New_York',
        },
        {
            option: 'AMLA',
            wni_port_name: 'AMELIA',
            wni_unlocode: 'USZPA',
            wni_country: 'US',
            wni_lat: 29.67,
            wni_lon: -91.1,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'ANSE',
            wni_port_name: 'L ANSE',
            wni_unlocode: 'USCMX',
            wni_country: 'US',
            wni_lat: 46.77,
            wni_lon: -88.47,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'ANTCH',
            wni_port_name: 'ANTIOCH',
            wni_unlocode: 'USPHG',
            wni_country: 'US',
            wni_lat: 38.02,
            wni_lon: -121.8,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'ARBOR',
            wni_port_name: 'HARBOR BEACH',
            wni_unlocode: 'USHB4',
            wni_country: 'US',
            wni_lat: 43.85,
            wni_lon: -82.65,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'AXDRA',
            wni_port_name: 'ALEXANDRIA BAY',
            wni_unlocode: 'USCLY',
            wni_country: 'US',
            wni_lat: 44.33,
            wni_lon: -75.92,
            wni_tz: 'America/New_York',
        },
        {
            option: 'BALNE',
            wni_port_name: 'BLAINE',
            wni_unlocode: 'USCP4',
            wni_country: 'US',
            wni_lat: 49,
            wni_lon: -122.75,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'BARAG',
            wni_port_name: 'BARAGA',
            wni_unlocode: 'USCMX',
            wni_country: 'US',
            wni_lat: 46.78,
            wni_lon: -88.48,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'BASS',
            wni_port_name: 'BASS HARBOR',
            wni_unlocode: 'USBHB',
            wni_country: 'US',
            wni_lat: 44.23,
            wni_lon: -68.35,
            wni_tz: 'America/New_York',
        },
        {
            option: 'BAVER',
            wni_port_name: 'BEAVER HARBOR',
            wni_unlocode: 'USGUV',
            wni_country: 'US',
            wni_lat: 45.73,
            wni_lon: -85.52,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'BAYFD',
            wni_port_name: 'BAYFIELD',
            wni_unlocode: 'USASX',
            wni_country: 'US',
            wni_lat: 46.8,
            wni_lon: -90.82,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'BDN',
            wni_port_name: 'BANDON',
            wni_unlocode: 'USCOB',
            wni_country: 'US',
            wni_lat: 43.12,
            wni_lon: -124.42,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'BEACH',
            wni_port_name: 'PISMO BEACH',
            wni_unlocode: 'USPSL',
            wni_country: 'US',
            wni_lat: 35.13,
            wni_lon: -120.65,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'BEAU',
            wni_port_name: 'BEAUFORT',
            wni_unlocode: 'USMRH',
            wni_country: 'US',
            wni_lat: 34.72,
            wni_lon: -76.67,
            wni_tz: 'America/New_York',
        },
        {
            option: 'BERNN',
            wni_port_name: 'NEW BERN',
            wni_unlocode: 'USCPO',
            wni_country: 'US',
            wni_lat: 35.1,
            wni_lon: -77.05,
            wni_tz: 'America/New_York',
        },
        {
            option: 'BLBA',
            wni_port_name: 'BAYOU LA BATRE',
            wni_unlocode: 'USTEO',
            wni_country: 'US',
            wni_lat: 30.41,
            wni_lon: -88.26,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'BLFST',
            wni_port_name: 'BELFAST',
            wni_unlocode: 'USSRP',
            wni_country: 'US',
            wni_lat: 44.42,
            wni_lon: -69,
            wni_tz: 'America/New_York',
        },
        {
            option: 'BLKFS',
            wni_port_name: 'BELKOFSKI',
            wni_unlocode: 'USKVC',
            wni_country: 'US',
            wni_lat: 55.08,
            wni_lon: -162.03,
            wni_tz: 'America/Nome',
        },
        {
            option: 'BLNGT',
            wni_port_name: 'BURLINGTON',
            wni_unlocode: 'USFAH',
            wni_country: 'US',
            wni_lat: 40.08,
            wni_lon: -74.87,
            wni_tz: 'America/New_York',
        },
        {
            option: 'BLX',
            wni_port_name: 'BILOXI',
            wni_unlocode: 'USGPT',
            wni_country: 'US',
            wni_lat: 30.38,
            wni_lon: -88.88,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'BRAT',
            wni_port_name: 'BOCA RATON',
            wni_unlocode: 'USPEF',
            wni_country: 'US',
            wni_lat: 26.37,
            wni_lon: -80.11,
            wni_tz: 'America/New_York',
        },
        {
            option: 'BRBRS1',
            wni_port_name: 'BARBERS POINT TERMINAL',
            wni_unlocode: 'USNAX',
            wni_country: 'US',
            wni_lat: 21.27,
            wni_lon: -158.09,
            wni_tz: 'Pacific/Honolulu',
        },
        {
            option: 'BRIS',
            wni_port_name: 'BRISTOL',
            wni_unlocode: 'USTIV',
            wni_country: 'US',
            wni_lat: 41.67,
            wni_lon: -71.27,
            wni_tz: 'America/New_York',
        },
        {
            option: 'BRLF',
            wni_port_name: 'BARALOF BAY',
            wni_unlocode: 'USSDP',
            wni_country: 'US',
            wni_lat: 55.23,
            wni_lon: -160.53,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'BRMRT',
            wni_port_name: 'EAST BREMERTON',
            wni_unlocode: 'USMCR',
            wni_country: 'US',
            wni_lat: 47.57,
            wni_lon: -122.62,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'BRNTT',
            wni_port_name: 'BURNETT INLET',
            wni_unlocode: 'USWRG',
            wni_country: 'US',
            wni_lat: 56.07,
            wni_lon: -132.47,
            wni_tz: 'America/Sitka',
        },
        {
            option: 'BROOK',
            wni_port_name: 'BROOKLIN',
            wni_unlocode: 'USBHB',
            wni_country: 'US',
            wni_lat: 44.27,
            wni_lon: -68.58,
            wni_tz: 'America/New_York',
        },
        {
            option: 'BTHBY',
            wni_port_name: 'EAST BOOTHBAY',
            wni_unlocode: 'USRKD',
            wni_country: 'US',
            wni_lat: 43.87,
            wni_lon: -69.58,
            wni_tz: 'America/New_York',
        },
        {
            option: 'BTME',
            wni_port_name: 'BATH',
            wni_unlocode: 'USPWM',
            wni_country: 'US',
            wni_lat: 43.92,
            wni_lon: -69.82,
            wni_tz: 'America/New_York',
        },
        {
            option: 'BUF',
            wni_port_name: 'BUFFINGTON',
            wni_unlocode: 'USGGY',
            wni_country: 'US',
            wni_lat: 41.63,
            wni_lon: -87.42,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'BUFT',
            wni_port_name: 'BEAUFORT',
            wni_unlocode: 'USPRL',
            wni_country: 'US',
            wni_lat: 32.03,
            wni_lon: -80.67,
            wni_tz: 'America/New_York',
        },
        {
            option: 'BUKME',
            wni_port_name: 'BUCK HARBOR',
            wni_unlocode: 'USSRP',
            wni_country: 'US',
            wni_lat: 44.33,
            wni_lon: -68.73,
            wni_tz: 'America/New_York',
        },
        {
            option: 'BVRLY',
            wni_port_name: 'BEVERLY',
            wni_unlocode: 'USSLM',
            wni_country: 'US',
            wni_lat: 42.53,
            wni_lon: -70.88,
            wni_tz: 'America/New_York',
        },
        {
            option: 'BYBR',
            wni_port_name: 'BAYBORO',
            wni_unlocode: 'USCPO',
            wni_country: 'US',
            wni_lat: 35.15,
            wni_lon: -76.77,
            wni_tz: 'America/New_York',
        },
        {
            option: 'BYC',
            wni_port_name: 'BAY CITY',
            wni_unlocode: 'USHQM',
            wni_country: 'US',
            wni_lat: 46.87,
            wni_lon: -124.07,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'CALAK',
            wni_port_name: 'COAL POINT',
            wni_unlocode: 'USHOI',
            wni_country: 'US',
            wni_lat: 59.6,
            wni_lon: -151.42,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'CALAS',
            wni_port_name: 'CALAIS',
            wni_unlocode: 'CASAD',
            wni_country: 'US',
            wni_lat: 45.18,
            wni_lon: -67.28,
            wni_tz: 'America/New_York',
        },
        {
            option: 'CALUM',
            wni_port_name: 'CALUMET HARBOR',
            wni_unlocode: 'USCHI',
            wni_country: 'US',
            wni_lat: 41.73,
            wni_lon: -87.52,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'CARL',
            wni_port_name: 'CARLYSS',
            wni_unlocode: 'USWQL',
            wni_country: 'US',
            wni_lat: 30.18,
            wni_lon: -93.37,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'CARPT',
            wni_port_name: 'CARPINTERIA',
            wni_unlocode: 'USSBA',
            wni_country: 'US',
            wni_lat: 34.38,
            wni_lon: -119.52,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'CASTN',
            wni_port_name: 'CASTINE',
            wni_unlocode: 'USSRP',
            wni_country: 'US',
            wni_lat: 44.38,
            wni_lon: -68.73,
            wni_tz: 'America/New_York',
        },
        {
            option: 'CCOB',
            wni_port_name: 'COS COB',
            wni_unlocode: 'USXLX',
            wni_country: 'US',
            wni_lat: 41.03,
            wni_lon: -73.6,
            wni_tz: 'America/New_York',
        },
        {
            option: 'CEDER',
            wni_port_name: 'CEDAR RIVER',
            wni_unlocode: 'USMOY',
            wni_country: 'US',
            wni_lat: 45.4,
            wni_lon: -87.35,
            wni_tz: 'America/Menominee',
        },
        {
            option: 'CHAUM',
            wni_port_name: 'CHAUMONT',
            wni_unlocode: 'USCLY',
            wni_country: 'US',
            wni_lat: 44.07,
            wni_lon: -76.13,
            wni_tz: 'America/New_York',
        },
        {
            option: 'CHH',
            wni_port_name: 'CHATHAM',
            wni_unlocode: 'UWNIN',
            wni_country: 'US',
            wni_lat: 57.52,
            wni_lon: -134.93,
            wni_tz: 'America/Sitka',
        },
        {
            option: 'CHHM',
            wni_port_name: 'CHATHAM',
            wni_unlocode: 'USHYA',
            wni_country: 'US',
            wni_lat: 41.68,
            wni_lon: -69.95,
            wni_tz: 'America/New_York',
        },
        {
            option: 'CHLKT',
            wni_port_name: 'PORT CHILKOOT',
            wni_unlocode: 'USHNS',
            wni_country: 'US',
            wni_lat: 59.23,
            wni_lon: -135.43,
            wni_tz: 'America/Juneau',
        },
        {
            option: 'CHROM',
            wni_port_name: 'CHROME',
            wni_unlocode: 'USCSF',
            wni_country: 'US',
            wni_lat: 40.57,
            wni_lon: -74.22,
            wni_tz: 'America/New_York',
        },
        {
            option: 'CILTN',
            wni_port_name: 'PORT CLINTON',
            wni_unlocode: 'USHD9',
            wni_country: 'US',
            wni_lat: 41.52,
            wni_lon: -82.93,
            wni_tz: 'America/New_York',
        },
        {
            option: 'CLD',
            wni_port_name: 'COLD BAY',
            wni_unlocode: 'USKVC',
            wni_country: 'US',
            wni_lat: 55.2,
            wni_lon: -162.7,
            wni_tz: 'America/Nome',
        },
        {
            option: 'CLRMI',
            wni_port_name: 'ST CLAIR',
            wni_unlocode: 'USSCL',
            wni_country: 'US',
            wni_lat: 42.82,
            wni_lon: -82.48,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'CLYDE',
            wni_port_name: 'PORT CLYDE',
            wni_unlocode: 'USRKD',
            wni_country: 'US',
            wni_lat: 43.92,
            wni_lon: -69.25,
            wni_tz: 'America/New_York',
        },
        {
            option: 'CMDN',
            wni_port_name: 'CAMDEN',
            wni_unlocode: 'USRKD',
            wni_country: 'US',
            wni_lat: 44.22,
            wni_lon: -69.07,
            wni_tz: 'America/New_York',
        },
        {
            option: 'CNNRY',
            wni_port_name: 'CANNERY BAY',
            wni_unlocode: 'USDUT',
            wni_country: 'US',
            wni_lat: 53.7,
            wni_lon: -166.75,
            wni_tz: 'America/Nome',
        },
        {
            option: 'COL',
            wni_port_name: 'COLUMBIA RIVER BAR PILOT',
            wni_unlocode: 'USAST',
            wni_country: 'US',
            wni_lat: 46.2,
            wni_lon: -124.2,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'COREA',
            wni_port_name: 'COREA',
            wni_unlocode: 'USBHB',
            wni_country: 'US',
            wni_lat: 44.4,
            wni_lon: -67.97,
            wni_tz: 'America/New_York',
        },
        {
            option: 'COSTA',
            wni_port_name: 'PORT COSTA',
            wni_unlocode: 'USBNC',
            wni_country: 'US',
            wni_lat: 38.05,
            wni_lon: -122.18,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'COVE',
            wni_port_name: 'GLEN COVE',
            wni_unlocode: 'USTWD',
            wni_country: 'US',
            wni_lat: 48.08,
            wni_lon: -122.78,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'CPVLL',
            wni_port_name: 'COUPEVILLE',
            wni_unlocode: 'USTWD',
            wni_country: 'US',
            wni_lat: 48.23,
            wni_lon: -122.68,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'CRAIG',
            wni_port_name: 'CRAIG',
            wni_unlocode: 'USKLW',
            wni_country: 'US',
            wni_lat: 55.47,
            wni_lon: -133.15,
            wni_tz: 'America/Sitka',
        },
        {
            option: 'CREOS',
            wni_port_name: 'CREOSOTE',
            wni_unlocode: 'USPWT',
            wni_country: 'US',
            wni_lat: 47.62,
            wni_lon: -122.5,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'CRHVN',
            wni_port_name: 'CRIEHAVEN',
            wni_unlocode: 'USRKD',
            wni_country: 'US',
            wni_lat: 43.83,
            wni_lon: -68.88,
            wni_tz: 'America/New_York',
        },
        {
            option: 'CRKAK',
            wni_port_name: 'CLARKS POINT',
            wni_unlocode: 'USDLG',
            wni_country: 'US',
            wni_lat: 58.85,
            wni_lon: -158.55,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'CRNCP',
            wni_port_name: 'CORNUCOPIA',
            wni_unlocode: 'USASX',
            wni_country: 'US',
            wni_lat: 46.87,
            wni_lon: -91.1,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'CRRBL',
            wni_port_name: 'CARRABELLE',
            wni_unlocode: 'USAAF',
            wni_country: 'US',
            wni_lat: 29.85,
            wni_lon: -84.67,
            wni_tz: 'America/New_York',
        },
        {
            option: 'CRTLN',
            wni_port_name: 'COURTLAND',
            wni_unlocode: 'USSAC',
            wni_country: 'US',
            wni_lat: 38.33,
            wni_lon: -121.57,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'CTSKL',
            wni_port_name: 'CATSKILL',
            wni_unlocode: 'USHSF',
            wni_country: 'US',
            wni_lat: 42.22,
            wni_lon: -73.85,
            wni_tz: 'America/New_York',
        },
        {
            option: 'CTYNY',
            wni_port_name: 'CITY ISLAND',
            wni_unlocode: 'USKOI',
            wni_country: 'US',
            wni_lat: 40.85,
            wni_lon: -73.78,
            wni_tz: 'America/New_York',
        },
        {
            option: 'CUNDY',
            wni_port_name: 'CUNDY HARBOR',
            wni_unlocode: 'USPWM',
            wni_country: 'US',
            wni_lat: 43.79,
            wni_lon: -69.89,
            wni_tz: 'America/New_York',
        },
        {
            option: 'DBRY',
            wni_port_name: 'DANBURY',
            wni_unlocode: 'USHD9',
            wni_country: 'US',
            wni_lat: 41.5,
            wni_lon: -82.83,
            wni_tz: 'America/New_York',
        },
        {
            option: 'DEPER',
            wni_port_name: 'DEPERE',
            wni_unlocode: 'USGRB',
            wni_country: 'US',
            wni_lat: 44.45,
            wni_lon: -88.07,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'DEPOE',
            wni_port_name: 'DEPOE BAY',
            wni_unlocode: 'USNPO',
            wni_country: 'US',
            wni_lat: 44.8,
            wni_lon: -124.07,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'DNKRK',
            wni_port_name: 'DUNKIRK',
            wni_unlocode: 'CAPCO',
            wni_country: 'US',
            wni_lat: 42.48,
            wni_lon: -79.33,
            wni_tz: 'America/New_York',
        },
        {
            option: 'DPNT',
            wni_port_name: 'DUPONT',
            wni_unlocode: 'USJNU',
            wni_country: 'US',
            wni_lat: 58.23,
            wni_lon: -134.27,
            wni_tz: 'America/Juneau',
        },
        {
            option: 'DPWTR',
            wni_port_name: 'DEEPWATER POINT',
            wni_unlocode: 'USPGP',
            wni_country: 'US',
            wni_lat: 39.7,
            wni_lon: -75.52,
            wni_tz: 'America/New_York',
        },
        {
            option: 'DRIEN',
            wni_port_name: 'DARIEN',
            wni_unlocode: 'USSSI',
            wni_country: 'US',
            wni_lat: 31.37,
            wni_lon: -81.43,
            wni_tz: 'America/New_York',
        },
        {
            option: 'DSRT',
            wni_port_name: 'MOUNT DESERT',
            wni_unlocode: 'USBHB',
            wni_country: 'US',
            wni_lat: 44.37,
            wni_lon: -68.33,
            wni_tz: 'America/New_York',
        },
        {
            option: 'DTRT',
            wni_port_name: 'DETROIT HARBOR',
            wni_unlocode: 'USESC',
            wni_country: 'US',
            wni_lat: 45.33,
            wni_lon: -86.93,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'DUP',
            wni_port_name: 'DUPONT',
            wni_unlocode: 'USOLM',
            wni_country: 'US',
            wni_lat: 47.11,
            wni_lon: -122.62,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'DVN',
            wni_port_name: 'DAVENPORT',
            wni_unlocode: 'USMLG',
            wni_country: 'US',
            wni_lat: 37.02,
            wni_lon: -122.2,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'DXBRY',
            wni_port_name: 'DUXBURY',
            wni_unlocode: 'USPYM',
            wni_country: 'US',
            wni_lat: 41.98,
            wni_lon: -70.65,
            wni_tz: 'America/New_York',
        },
        {
            option: 'ECRS',
            wni_port_name: 'ECORSE',
            wni_unlocode: 'CAWND',
            wni_country: 'US',
            wni_lat: 42.25,
            wni_lon: -83.13,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'EDGRT',
            wni_port_name: 'EDGARTOWN',
            wni_unlocode: 'USHYA',
            wni_country: 'US',
            wni_lat: 41.38,
            wni_lon: -70.5,
            wni_tz: 'America/New_York',
        },
        {
            option: 'EDGWT',
            wni_port_name: 'EDGEWATER',
            wni_unlocode: 'USBRX',
            wni_country: 'US',
            wni_lat: 40.82,
            wni_lon: -73.98,
            wni_tz: 'America/New_York',
        },
        {
            option: 'EDWAD',
            wni_port_name: 'EDWARDS POINT',
            wni_unlocode: 'USOW4',
            wni_country: 'US',
            wni_lat: 47.8,
            wni_lon: -122.4,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'EGLMI',
            wni_port_name: 'EAGLE HARBOR',
            wni_unlocode: 'USCMX',
            wni_country: 'US',
            wni_lat: 47.47,
            wni_lon: -88.17,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'EKUK',
            wni_port_name: 'EKUK',
            wni_unlocode: 'USDLG',
            wni_country: 'US',
            wni_lat: 58.82,
            wni_lon: -158.57,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'ELFIN',
            wni_port_name: 'ELFIN COVE',
            wni_unlocode: 'USPEC',
            wni_country: 'US',
            wni_lat: 58.2,
            wni_lon: -136.35,
            wni_tz: 'America/Juneau',
        },
        {
            option: 'ELLSW',
            wni_port_name: 'ELLSWORTH',
            wni_unlocode: 'USBHB',
            wni_country: 'US',
            wni_lat: 44.55,
            wni_lon: -68.42,
            wni_tz: 'America/New_York',
        },
        {
            option: 'ELLWD',
            wni_port_name: 'ELLWOOD',
            wni_unlocode: 'USSBA',
            wni_country: 'US',
            wni_lat: 34.43,
            wni_lon: -119.92,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'EMPR',
            wni_port_name: 'EMPIRE',
            wni_unlocode: 'USCOB',
            wni_country: 'US',
            wni_lat: 43.4,
            wni_lon: -124.28,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'ENC',
            wni_port_name: 'ENCINO',
            wni_unlocode: 'USELS',
            wni_country: 'US',
            wni_lat: 34.16,
            wni_lon: -118.5,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'ESSEX',
            wni_port_name: 'ESSEX',
            wni_unlocode: 'USGON',
            wni_country: 'US',
            wni_lat: 41.35,
            wni_lon: -72.38,
            wni_tz: 'America/New_York',
        },
        {
            option: 'EXCRS',
            wni_port_name: 'EXCURSION INLET',
            wni_unlocode: 'USGST',
            wni_country: 'US',
            wni_lat: 58.42,
            wni_lon: -135.45,
            wni_tz: 'America/Juneau',
        },
        {
            option: 'FALMH',
            wni_port_name: 'FALMOUTH',
            wni_unlocode: 'USNBD',
            wni_country: 'US',
            wni_lat: 41.55,
            wni_lon: -70.62,
            wni_tz: 'America/New_York',
        },
        {
            option: 'FFORT',
            wni_port_name: 'FRANKFORT',
            wni_unlocode: 'USMBL',
            wni_country: 'US',
            wni_lat: 44.63,
            wni_lon: -86.25,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'FHAVN',
            wni_port_name: 'FAIR HAVEN',
            wni_unlocode: 'USOSW',
            wni_country: 'US',
            wni_lat: 43.33,
            wni_lon: -76.7,
            wni_tz: 'America/New_York',
        },
        {
            option: 'FLAND',
            wni_port_name: 'FIELDS LANDING',
            wni_unlocode: 'USEKA',
            wni_country: 'US',
            wni_lat: 40.72,
            wni_lon: -124.22,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'FNTR',
            wni_port_name: 'FUNTER',
            wni_unlocode: 'USHWI',
            wni_country: 'US',
            wni_lat: 58.25,
            wni_lon: -134.9,
            wni_tz: 'America/Juneau',
        },
        {
            option: 'FREDK',
            wni_port_name: 'FREDERICKSBURG',
            wni_unlocode: 'GBDUM',
            wni_country: 'US',
            wni_lat: 38.3,
            wni_lon: -77.45,
            wni_tz: 'America/New_York',
        },
        {
            option: 'FRIDY',
            wni_port_name: 'FRIDAY HARBOR',
            wni_unlocode: 'CAVIC',
            wni_country: 'US',
            wni_lat: 48.53,
            wni_lon: -123.02,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'FRN',
            wni_port_name: 'FERNANDINA BEACH',
            wni_unlocode: 'USFEB',
            wni_country: 'US',
            wni_lat: 30.68,
            wni_lon: -81.47,
            wni_tz: 'America/New_York',
        },
        {
            option: 'FRNCH',
            wni_port_name: 'FRENCHBORO',
            wni_unlocode: 'USBHB',
            wni_country: 'US',
            wni_lat: 44.12,
            wni_lon: -68.37,
            wni_tz: 'America/New_York',
        },
        {
            option: 'FRNDS',
            wni_port_name: 'FRIENDSHIP',
            wni_unlocode: 'USRKD',
            wni_country: 'US',
            wni_lat: 43.97,
            wni_lon: -69.33,
            wni_tz: 'America/New_York',
        },
        {
            option: 'GERGE',
            wni_port_name: 'GEORGE INLET',
            wni_unlocode: 'USKTN',
            wni_country: 'US',
            wni_lat: 55.38,
            wni_lon: -131.47,
            wni_tz: 'America/Sitka',
        },
        {
            option: 'GLDST',
            wni_port_name: 'GLADSTONE',
            wni_unlocode: 'USESC',
            wni_country: 'US',
            wni_lat: 45.85,
            wni_lon: -87.02,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'GLENU',
            wni_port_name: 'GLEN COVE',
            wni_unlocode: 'USTWD',
            wni_country: 'US',
            wni_lat: 48.08,
            wni_lon: -122.78,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'GLFPR',
            wni_port_name: 'GULFPORT SI',
            wni_unlocode: 'US8BY',
            wni_country: 'US',
            wni_lat: 40.63,
            wni_lon: -74.2,
            wni_tz: 'America/New_York',
        },
        {
            option: 'GRADR',
            wni_port_name: 'GARDINER',
            wni_unlocode: 'USCOB',
            wni_country: 'US',
            wni_lat: 43.72,
            wni_lon: -124.1,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'GRCME',
            wni_port_name: 'HAVRE DE GRACE',
            wni_unlocode: 'USDCI',
            wni_country: 'US',
            wni_lat: 39.53,
            wni_lon: -76.08,
            wni_tz: 'America/New_York',
        },
        {
            option: 'GRDLA',
            wni_port_name: 'GRAND ISLE',
            wni_unlocode: 'USFOC',
            wni_country: 'US',
            wni_lat: 29.23,
            wni_lon: -90,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'GRNPR',
            wni_port_name: 'GREENPORT',
            wni_unlocode: 'USRID',
            wni_country: 'US',
            wni_lat: 41.1,
            wni_lon: -72.37,
            wni_tz: 'America/New_York',
        },
        {
            option: 'GRNWC',
            wni_port_name: 'GREENWICH',
            wni_unlocode: 'USUXZ',
            wni_country: 'US',
            wni_lat: 41.02,
            wni_lon: -73.62,
            wni_tz: 'America/New_York',
        },
        {
            option: 'GRT',
            wni_port_name: 'GROTON',
            wni_unlocode: 'USGON',
            wni_country: 'US',
            wni_lat: 41.34,
            wni_lon: -72.08,
            wni_tz: 'America/New_York',
        },
        {
            option: 'GSSLL',
            wni_port_name: 'GRASSELLI',
            wni_unlocode: 'US8BY',
            wni_country: 'US',
            wni_lat: 40.62,
            wni_lon: -74.2,
            wni_tz: 'America/New_York',
        },
        {
            option: 'GVB',
            wni_port_name: 'GROVER BEACH',
            wni_unlocode: 'USPSL',
            wni_country: 'US',
            wni_lat: 35.12,
            wni_lon: -120.63,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'GVT',
            wni_port_name: 'GAVIOTA',
            wni_unlocode: 'USSBA',
            wni_country: 'US',
            wni_lat: 34.47,
            wni_lon: -120.2,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'HAB',
            wni_port_name: 'HACKBERRY',
            wni_unlocode: 'USCMU',
            wni_country: 'US',
            wni_lat: 29.98,
            wni_lon: -93.41,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'HAYNK',
            wni_port_name: 'HAYMARK TERMINAL',
            wni_unlocode: 'USWQL',
            wni_country: 'US',
            wni_lat: 30.13,
            wni_lon: -93.32,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'HBP',
            wni_port_name: 'HARBOR POINT',
            wni_unlocode: 'USOW4',
            wni_country: 'US',
            wni_lat: 47.88,
            wni_lon: -122.33,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'HLAND',
            wni_port_name: 'HOLLAND',
            wni_unlocode: 'USGHN',
            wni_country: 'US',
            wni_lat: 42.78,
            wni_lon: -86.13,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'HLYW',
            wni_port_name: 'HOLLYWOOD',
            wni_unlocode: 'USPEF',
            wni_country: 'US',
            wni_lat: 26.01,
            wni_lon: -80.14,
            wni_tz: 'America/New_York',
        },
        {
            option: 'HNDRS',
            wni_port_name: 'HENDERSON HARBOR',
            wni_unlocode: 'USCLY',
            wni_country: 'US',
            wni_lat: 43.87,
            wni_lon: -76.2,
            wni_tz: 'America/New_York',
        },
        {
            option: 'HNKAA',
            wni_port_name: 'HONOKAA',
            wni_unlocode: 'USKWH',
            wni_country: 'US',
            wni_lat: 20.1,
            wni_lon: -155.47,
            wni_tz: 'Pacific/Honolulu',
        },
        {
            option: 'HOBOK',
            wni_port_name: 'HOBOKEN',
            wni_unlocode: 'USNYC',
            wni_country: 'US',
            wni_lat: 40.75,
            wni_lon: -74.02,
            wni_tz: 'America/New_York',
        },
        {
            option: 'HODAK',
            wni_port_name: 'HOOD BAY',
            wni_unlocode: 'UWNIN',
            wni_country: 'US',
            wni_lat: 57.4,
            wni_lon: -134.5,
            wni_tz: 'America/Juneau',
        },
        {
            option: 'HOODS',
            wni_port_name: 'HOODSPORT',
            wni_unlocode: 'USOLM',
            wni_country: 'US',
            wni_lat: 47.42,
            wni_lon: -123.13,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'HOPMI',
            wni_port_name: 'PORT HOPE',
            wni_unlocode: 'USHB4',
            wni_country: 'US',
            wni_lat: 43.95,
            wni_lon: -82.7,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'HOUGT',
            wni_port_name: 'HOUGHTON',
            wni_unlocode: 'USCMX',
            wni_country: 'US',
            wni_lat: 47.12,
            wni_lon: -88.57,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'HRBOR',
            wni_port_name: 'HARBOR BEACH',
            wni_unlocode: 'USHB4',
            wni_country: 'US',
            wni_lat: 43.85,
            wni_lon: -82.65,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'HRPSW',
            wni_port_name: 'SOUTH HARPSWELL',
            wni_unlocode: 'USPWM',
            wni_country: 'US',
            wni_lat: 43.73,
            wni_lon: -70.02,
            wni_tz: 'America/New_York',
        },
        {
            option: 'HUM',
            wni_port_name: 'HOUMA',
            wni_unlocode: 'USEPB',
            wni_country: 'US',
            wni_lat: 29.59,
            wni_lon: -90.7,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'HYDAK',
            wni_port_name: 'HYDER',
            wni_unlocode: 'CASTW',
            wni_country: 'US',
            wni_lat: 55.92,
            wni_lon: -130,
            wni_tz: 'America/Sitka',
        },
        {
            option: 'HYNNS1',
            wni_port_name: 'HYANNIS PORT',
            wni_unlocode: 'USHYA',
            wni_country: 'US',
            wni_lat: 41.63,
            wni_lon: -70.3,
            wni_tz: 'America/New_York',
        },
        {
            option: 'IGL',
            wni_port_name: 'PORT INGLESIDE',
            wni_unlocode: 'USYIG',
            wni_country: 'US',
            wni_lat: 27.82,
            wni_lon: -97.18,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'IGNAC',
            wni_port_name: 'ST IGNACE',
            wni_unlocode: 'USCHG',
            wni_country: 'US',
            wni_lat: 45.85,
            wni_lon: -84.72,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'ILWC',
            wni_port_name: 'ILWACO',
            wni_unlocode: 'USAST',
            wni_country: 'US',
            wni_lat: 46.3,
            wni_lon: -124.05,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'INDA',
            wni_port_name: 'INDIANA HARBOR',
            wni_unlocode: 'USCHI',
            wni_country: 'US',
            wni_lat: 41.67,
            wni_lon: -87.43,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'ISLTN',
            wni_port_name: 'ISLETON',
            wni_unlocode: 'USPHG',
            wni_country: 'US',
            wni_lat: 38.17,
            wni_lon: -121.6,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'ISTHM',
            wni_port_name: 'ISTHMUS COVE',
            wni_unlocode: 'USCKI',
            wni_country: 'US',
            wni_lat: 33.45,
            wni_lon: -118.5,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'JAC',
            wni_port_name: 'JACINTO CITY',
            wni_unlocode: 'USGPK',
            wni_country: 'US',
            wni_lat: 29.75,
            wni_lon: -95.29,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'JACKS',
            wni_port_name: 'JACKSON HARBOR',
            wni_unlocode: 'USESC',
            wni_country: 'US',
            wni_lat: 45.4,
            wni_lon: -86.85,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'KAILU',
            wni_port_name: 'KAILUA',
            wni_unlocode: 'USKHH',
            wni_country: 'US',
            wni_lat: 19.63,
            wni_lon: -156,
            wni_tz: 'Pacific/Honolulu',
        },
        {
            option: 'KAUHK',
            wni_port_name: 'KAUHAKO BAY',
            wni_unlocode: 'USKHH',
            wni_country: 'US',
            wni_lat: 19.38,
            wni_lon: -155.9,
            wni_tz: 'Pacific/Honolulu',
        },
        {
            option: 'KEWAU',
            wni_port_name: 'KEWAUNEE',
            wni_unlocode: 'USGRB',
            wni_country: 'US',
            wni_lat: 44.47,
            wni_lon: -87.5,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'KGGNG',
            wni_port_name: 'KOGGIUNG',
            wni_unlocode: 'USNNK',
            wni_country: 'US',
            wni_lat: 58.97,
            wni_lon: -156.92,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'KHL',
            wni_port_name: 'KIHOLO',
            wni_unlocode: 'USKWH',
            wni_country: 'US',
            wni_lat: 19.87,
            wni_lon: -155.95,
            wni_tz: 'Pacific/Honolulu',
        },
        {
            option: 'KIA',
            wni_port_name: 'KASITSNA',
            wni_unlocode: 'USSOV',
            wni_country: 'US',
            wni_lat: 59.47,
            wni_lon: -151.57,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'KIMSN',
            wni_port_name: 'KIMSHAN COVE',
            wni_unlocode: 'USPEC',
            wni_country: 'US',
            wni_lat: 57.68,
            wni_lon: -136.12,
            wni_tz: 'America/Juneau',
        },
        {
            option: 'KMALO',
            wni_port_name: 'KAMALO',
            wni_unlocode: 'USKKA',
            wni_country: 'US',
            wni_lat: 21.05,
            wni_lon: -156.88,
            wni_tz: 'Pacific/Honolulu',
        },
        {
            option: 'KMLP',
            wni_port_name: 'KAUMALAPAU HARBOR',
            wni_unlocode: 'USKKA',
            wni_country: 'US',
            wni_lat: 20.78,
            wni_lon: -157,
            wni_tz: 'Pacific/Honolulu',
        },
        {
            option: 'KNDSN',
            wni_port_name: 'KNUDSON COVE',
            wni_unlocode: 'USKTN',
            wni_country: 'US',
            wni_lat: 55.47,
            wni_lon: -131.8,
            wni_tz: 'America/Sitka',
        },
        {
            option: 'KNGST',
            wni_port_name: 'KINGSTON',
            wni_unlocode: 'USACS',
            wni_country: 'US',
            wni_lat: 41.93,
            wni_lon: -73.97,
            wni_tz: 'America/New_York',
        },
        {
            option: 'KNNBN',
            wni_port_name: 'KENNEBUNKPORT',
            wni_unlocode: 'USPWM',
            wni_country: 'US',
            wni_lat: 43.37,
            wni_lon: -70.47,
            wni_tz: 'America/New_York',
        },
        {
            option: 'KSAAN',
            wni_port_name: 'KASAAN',
            wni_unlocode: 'USKTB',
            wni_country: 'US',
            wni_lat: 55.53,
            wni_lon: -132.4,
            wni_tz: 'America/Sitka',
        },
        {
            option: 'KYPRT',
            wni_port_name: 'KEYPORT',
            wni_unlocode: 'USMCR',
            wni_country: 'US',
            wni_lat: 47.7,
            wni_lon: -122.62,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'LAKES',
            wni_port_name: 'GREAT LAKES',
            wni_unlocode: 'USUGN',
            wni_country: 'US',
            wni_lat: 42.3,
            wni_lon: -87.83,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'LELND',
            wni_port_name: 'LELAND',
            wni_unlocode: 'USTVC',
            wni_country: 'US',
            wni_lat: 45.02,
            wni_lon: -85.77,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'LEONR',
            wni_port_name: 'LEONARDO',
            wni_unlocode: 'USPAY',
            wni_country: 'US',
            wni_lat: 40.43,
            wni_lon: -74.07,
            wni_tz: 'America/New_York',
        },
        {
            option: 'LIN',
            wni_port_name: 'LINNTON',
            wni_unlocode: 'USPDX',
            wni_country: 'US',
            wni_lat: 45.59,
            wni_lon: -122.78,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'LNN',
            wni_port_name: 'LYNN',
            wni_unlocode: 'USREZ',
            wni_country: 'US',
            wni_lat: 42.45,
            wni_lon: -70.95,
            wni_tz: 'America/New_York',
        },
        {
            option: 'LORNG',
            wni_port_name: 'LORING',
            wni_unlocode: 'USKTN',
            wni_country: 'US',
            wni_lat: 55.6,
            wni_lon: -131.63,
            wni_tz: 'America/Sitka',
        },
        {
            option: 'LPL',
            wni_port_name: 'LAPLACE',
            wni_unlocode: 'USRSF',
            wni_country: 'US',
            wni_lat: 30.05,
            wni_lon: -90.58,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'LSTON',
            wni_port_name: 'LEWISTON',
            wni_unlocode: 'CATHD',
            wni_country: 'US',
            wni_lat: 43.17,
            wni_lon: -79.05,
            wni_tz: 'America/New_York',
        },
        {
            option: 'LTNKF',
            wni_port_name: 'LETNIKOF COVE',
            wni_unlocode: 'USHNS',
            wni_country: 'US',
            wni_lat: 59.18,
            wni_lon: -135.4,
            wni_tz: 'America/Juneau',
        },
        {
            option: 'LUBEC',
            wni_port_name: 'LUBEC',
            wni_unlocode: 'USEPM',
            wni_country: 'US',
            wni_lat: 44.87,
            wni_lon: -66.98,
            wni_tz: 'America/New_York',
        },
        {
            option: 'LYN',
            wni_port_name: 'LYNHAVEN ROADS',
            wni_unlocode: 'USXPY',
            wni_country: 'US',
            wni_lat: 36.81,
            wni_lon: -76.07,
            wni_tz: 'America/New_York',
        },
        {
            option: 'MAURR',
            wni_port_name: 'MAURER',
            wni_unlocode: 'USSWN',
            wni_country: 'US',
            wni_lat: 40.53,
            wni_lon: -74.25,
            wni_tz: 'America/New_York',
        },
        {
            option: 'MCHS',
            wni_port_name: 'MACHIAS',
            wni_unlocode: 'USEPM',
            wni_country: 'US',
            wni_lat: 44.72,
            wni_lon: -67.47,
            wni_tz: 'America/New_York',
        },
        {
            option: 'MCHSP',
            wni_port_name: 'MACHIASPORT',
            wni_unlocode: 'USEPM',
            wni_country: 'US',
            wni_lat: 44.7,
            wni_lon: -67.4,
            wni_tz: 'America/New_York',
        },
        {
            option: 'MCKNC',
            wni_port_name: 'MACKINAC ISLAND',
            wni_unlocode: 'USCHG',
            wni_country: 'US',
            wni_lat: 45.85,
            wni_lon: -84.62,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'MCKNW',
            wni_port_name: 'MACKINAW CITY',
            wni_unlocode: 'USCHG',
            wni_country: 'US',
            wni_lat: 45.78,
            wni_lon: -84.72,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'MENO',
            wni_port_name: 'MENOMINEE',
            wni_unlocode: 'USMOY',
            wni_country: 'US',
            wni_lat: 45.1,
            wni_lon: -87.6,
            wni_tz: 'America/Menominee',
        },
        {
            option: 'MGC',
            wni_port_name: 'MORGAN CITY',
            wni_unlocode: 'USZPA',
            wni_country: 'US',
            wni_lat: 29.7,
            wni_lon: -91.22,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'MHKN',
            wni_port_name: 'MAHUKONA',
            wni_unlocode: 'USKWH',
            wni_country: 'US',
            wni_lat: 20.18,
            wni_lon: -155.9,
            wni_tz: 'Pacific/Honolulu',
        },
        {
            option: 'MIGC',
            wni_port_name: 'MICHIGAN CITY',
            wni_unlocode: 'USBNB',
            wni_country: 'US',
            wni_lat: 41.73,
            wni_lon: -86.9,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'MINTU',
            wni_port_name: 'MINTURN',
            wni_unlocode: 'USBHB',
            wni_country: 'US',
            wni_lat: 44.15,
            wni_lon: -68.45,
            wni_tz: 'America/New_York',
        },
        {
            option: 'MKLT',
            wni_port_name: 'MUKILTEO',
            wni_unlocode: 'USPAE',
            wni_country: 'US',
            wni_lat: 47.95,
            wni_lon: -122.3,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'MKSHN',
            wni_port_name: 'MAKUSHIN',
            wni_unlocode: 'USDUT',
            wni_country: 'US',
            wni_lat: 53.77,
            wni_lon: -166.98,
            wni_tz: 'America/Nome',
        },
        {
            option: 'MLBRD',
            wni_port_name: 'MILBRIDGE',
            wni_unlocode: 'USBHB',
            wni_country: 'US',
            wni_lat: 44.53,
            wni_lon: -67.88,
            wni_tz: 'America/New_York',
        },
        {
            option: 'MNHGN',
            wni_port_name: 'MONHEGAN',
            wni_unlocode: 'USRKD',
            wni_country: 'US',
            wni_lat: 43.77,
            wni_lon: -69.32,
            wni_tz: 'America/New_York',
        },
        {
            option: 'MNSTQ',
            wni_port_name: 'MANISTIQUE',
            wni_unlocode: 'USGUV',
            wni_country: 'US',
            wni_lat: 45.95,
            wni_lon: -86.25,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'MORB',
            wni_port_name: 'MORRO BAY',
            wni_unlocode: 'USPSL',
            wni_country: 'US',
            wni_lat: 35.37,
            wni_lon: -120.85,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'MRBLH',
            wni_port_name: 'MARBLEHEAD',
            wni_unlocode: 'USSLM',
            wni_country: 'US',
            wni_lat: 42.5,
            wni_lon: -70.85,
            wni_tz: 'America/New_York',
        },
        {
            option: 'MRINE',
            wni_port_name: 'MARINE CITY',
            wni_unlocode: 'CASOM',
            wni_country: 'US',
            wni_lat: 42.72,
            wni_lon: -82.5,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'MRNRS',
            wni_port_name: 'MARINERS HARBOR SI',
            wni_unlocode: 'USEZA',
            wni_country: 'US',
            wni_lat: 40.63,
            wni_lon: -74.17,
            wni_tz: 'America/New_York',
        },
        {
            option: 'MRRST',
            wni_port_name: 'MORRISTOWN',
            wni_unlocode: 'USOG2',
            wni_country: 'US',
            wni_lat: 44.58,
            wni_lon: -75.65,
            wni_tz: 'America/New_York',
        },
        {
            option: 'MRSG',
            wni_port_name: 'GRAND MARAIS',
            wni_unlocode: 'USTCH',
            wni_country: 'US',
            wni_lat: 47.75,
            wni_lon: -90.33,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'MTNCS',
            wni_port_name: 'MATINICUS',
            wni_unlocode: 'USRKD',
            wni_country: 'US',
            wni_lat: 43.87,
            wni_lon: -68.88,
            wni_tz: 'America/New_York',
        },
        {
            option: 'MTP',
            wni_port_name: 'MONTAUK HARBOR',
            wni_unlocode: 'USGON',
            wni_country: 'US',
            wni_lat: 41.07,
            wni_lon: -71.93,
            wni_tz: 'America/New_York',
        },
        {
            option: 'MYPRT',
            wni_port_name: 'MAYPORT',
            wni_unlocode: 'USJAX',
            wni_country: 'US',
            wni_lat: 30.4,
            wni_lon: -81.43,
            wni_tz: 'America/New_York',
        },
        {
            option: 'MYSTC',
            wni_port_name: 'MYSTIC',
            wni_unlocode: 'USGON',
            wni_country: 'US',
            wni_lat: 41.35,
            wni_lon: -71.97,
            wni_tz: 'America/New_York',
        },
        {
            option: 'NAHMA',
            wni_port_name: 'NAHMA',
            wni_unlocode: 'USESC',
            wni_country: 'US',
            wni_lat: 45.83,
            wni_lon: -86.67,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'NAPOO',
            wni_port_name: 'NAPOOPOO',
            wni_unlocode: 'USKHH',
            wni_country: 'US',
            wni_lat: 19.48,
            wni_lon: -155.93,
            wni_tz: 'Pacific/Honolulu',
        },
        {
            option: 'NAW',
            wni_port_name: 'NAWILIWILI BAY',
            wni_unlocode: 'USNWL',
            wni_country: 'US',
            wni_lat: 21.95,
            wni_lon: -159.35,
            wni_tz: 'Pacific/Honolulu',
        },
        {
            option: 'NBEND',
            wni_port_name: 'NORTH BEND',
            wni_unlocode: 'USCOB',
            wni_country: 'US',
            wni_lat: 43.4,
            wni_lon: -124.22,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'NCSTL',
            wni_port_name: 'NEW CASTLE',
            wni_unlocode: 'USDCI',
            wni_country: 'US',
            wni_lat: 39.65,
            wni_lon: -75.57,
            wni_tz: 'America/New_York',
        },
        {
            option: 'NEME',
            wni_port_name: 'NORTHEAST HARBOR',
            wni_unlocode: 'USBHB',
            wni_country: 'US',
            wni_lat: 44.3,
            wni_lon: -68.28,
            wni_tz: 'America/New_York',
        },
        {
            option: 'NEWBY',
            wni_port_name: 'NEWBURYPORT',
            wni_unlocode: 'USGLO',
            wni_country: 'US',
            wni_lat: 42.82,
            wni_lon: -70.87,
            wni_tz: 'America/New_York',
        },
        {
            option: 'NGRF',
            wni_port_name: 'NIAGARA FALLS',
            wni_unlocode: 'CATHD',
            wni_country: 'US',
            wni_lat: 43.08,
            wni_lon: -79.03,
            wni_tz: 'America/New_York',
        },
        {
            option: 'NHCTT',
            wni_port_name: 'NAHCOTTA',
            wni_unlocode: 'USAST',
            wni_country: 'US',
            wni_lat: 46.5,
            wni_lon: -124.03,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'NHVEN',
            wni_port_name: 'NORTH HAVEN',
            wni_unlocode: 'USRKD',
            wni_country: 'US',
            wni_lat: 44.13,
            wni_lon: -68.87,
            wni_tz: 'America/New_York',
        },
        {
            option: 'NJRY',
            wni_port_name: 'JERSEY CITY',
            wni_unlocode: 'USNYC',
            wni_country: 'US',
            wni_lat: 40.72,
            wni_lon: -74.03,
            wni_tz: 'America/New_York',
        },
        {
            option: 'NNLCH',
            wni_port_name: 'NINILCHIK',
            wni_unlocode: 'USHOI',
            wni_country: 'US',
            wni_lat: 60.05,
            wni_lon: -151.68,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'NOANK',
            wni_port_name: 'NOANK',
            wni_unlocode: 'USGON',
            wni_country: 'US',
            wni_lat: 41.32,
            wni_lon: -71.98,
            wni_tz: 'America/New_York',
        },
        {
            option: 'NRSWR',
            wni_port_name: 'NORSWORTHY',
            wni_unlocode: 'USPAS',
            wni_country: 'US',
            wni_lat: 29.73,
            wni_lon: -95.2,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'NRWCH1',
            wni_port_name: 'NORWICH',
            wni_unlocode: 'USGON',
            wni_country: 'US',
            wni_lat: 41.52,
            wni_lon: -72.08,
            wni_tz: 'America/New_York',
        },
        {
            option: 'NRWLK',
            wni_port_name: 'NORWALK',
            wni_unlocode: 'USXLX',
            wni_country: 'US',
            wni_lat: 41.1,
            wni_lon: -73.42,
            wni_tz: 'America/New_York',
        },
        {
            option: 'NSQLL',
            wni_port_name: 'NISQUALLY HEAD',
            wni_unlocode: 'USOLM',
            wni_country: 'US',
            wni_lat: 47.12,
            wni_lon: -122.75,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'NWME',
            wni_port_name: 'NEW HARBOR',
            wni_unlocode: 'USRKD',
            wni_country: 'US',
            wni_lat: 43.87,
            wni_lon: -69.48,
            wni_tz: 'America/New_York',
        },
        {
            option: 'NWPT',
            wni_port_name: 'NEWPORT BEACH',
            wni_unlocode: 'USHTD',
            wni_country: 'US',
            wni_lat: 33.62,
            wni_lon: -117.9,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'OBRN',
            wni_port_name: 'PORT OBRIEN',
            wni_unlocode: 'USAFK',
            wni_country: 'US',
            wni_lat: 57.73,
            wni_lon: -153.32,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'OCC',
            wni_port_name: 'OCEAN CITY',
            wni_unlocode: 'AUSAL',
            wni_country: 'US',
            wni_lat: 38.33,
            wni_lon: -75.08,
            wni_tz: 'America/New_York',
        },
        {
            option: 'OCNNR',
            wni_port_name: 'PORT OCONNOR',
            wni_unlocode: 'USPCR',
            wni_country: 'US',
            wni_lat: 28.45,
            wni_lon: -96.4,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'OCNT',
            wni_port_name: 'OCONTO',
            wni_unlocode: 'USGRB',
            wni_country: 'US',
            wni_lat: 44.9,
            wni_lon: -87.83,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'OLCTT',
            wni_port_name: 'OLCOTT',
            wni_unlocode: 'USXJQ',
            wni_country: 'US',
            wni_lat: 43.33,
            wni_lon: -78.72,
            wni_tz: 'America/New_York',
        },
        {
            option: 'ORCA',
            wni_port_name: 'ORCA',
            wni_unlocode: 'USCDV',
            wni_country: 'US',
            wni_lat: 60.58,
            wni_lon: -145.72,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'ORCAS',
            wni_port_name: 'ORCAS',
            wni_unlocode: 'USOTS',
            wni_country: 'US',
            wni_lat: 48.6,
            wni_lon: -122.93,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'ORCHR',
            wni_port_name: 'PORT ORCHARD',
            wni_unlocode: 'USMCR',
            wni_country: 'US',
            wni_lat: 47.53,
            wni_lon: -122.63,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'OZNK',
            wni_port_name: 'OUZINKIE',
            wni_unlocode: 'USADQ',
            wni_country: 'US',
            wni_lat: 57.92,
            wni_lon: -152.5,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'PABLO',
            wni_port_name: 'POINT SAN PABLO',
            wni_unlocode: 'USRCH',
            wni_country: 'US',
            wni_lat: 37.97,
            wni_lon: -122.43,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'PGH',
            wni_port_name: 'PORT GRAHAM',
            wni_unlocode: 'USSOV',
            wni_country: 'US',
            wni_lat: 59.35,
            wni_lon: -151.82,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'PGHKP',
            wni_port_name: 'POUGHKEEPSIE',
            wni_unlocode: 'USACS',
            wni_country: 'US',
            wni_lat: 41.7,
            wni_lon: -73.95,
            wni_tz: 'America/New_York',
        },
        {
            option: 'PIL',
            wni_port_name: 'PILOTTOWN',
            wni_unlocode: 'USQPR',
            wni_country: 'US',
            wni_lat: 29.17,
            wni_lon: -89.26,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'PINBY',
            wni_port_name: 'PUT IN BAY',
            wni_unlocode: 'USHD9',
            wni_country: 'US',
            wni_lat: 41.65,
            wni_lon: -82.82,
            wni_tz: 'America/New_York',
        },
        {
            option: 'PISMO',
            wni_port_name: 'PISMO BEACH',
            wni_unlocode: 'USPSL',
            wni_country: 'US',
            wni_lat: 35.13,
            wni_lon: -120.65,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'PLCS',
            wni_port_name: 'PALACIOS',
            wni_unlocode: 'USPCR',
            wni_country: 'US',
            wni_lat: 28.68,
            wni_lon: -96.22,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'PLE',
            wni_port_name: 'PAULINE',
            wni_unlocode: 'USGRY',
            wni_country: 'US',
            wni_lat: 30.02,
            wni_lon: -90.71,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'PLLRS',
            wni_port_name: 'BAY OF PILLARS',
            wni_unlocode: 'USKAE',
            wni_country: 'US',
            wni_lat: 56.6,
            wni_lon: -134.23,
            wni_tz: 'America/Sitka',
        },
        {
            option: 'PLSB',
            wni_port_name: 'POULSBO',
            wni_unlocode: 'USPGH',
            wni_country: 'US',
            wni_lat: 47.73,
            wni_lon: -122.65,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'PMQD',
            wni_port_name: 'PEMAQUID BEACH',
            wni_unlocode: 'USRKD',
            wni_country: 'US',
            wni_lat: 43.87,
            wni_lon: -69.53,
            wni_tz: 'America/New_York',
        },
        {
            option: 'PNOLE',
            wni_port_name: 'PINOLE POINT',
            wni_unlocode: 'USRD4',
            wni_country: 'US',
            wni_lat: 38.02,
            wni_lon: -122.37,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'PNSK',
            wni_port_name: 'PENSAUKEE',
            wni_unlocode: 'USGRB',
            wni_country: 'US',
            wni_lat: 44.82,
            wni_lon: -87.9,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'PNTWI',
            wni_port_name: 'LA POINTE',
            wni_unlocode: 'USASX',
            wni_country: 'US',
            wni_lat: 46.78,
            wni_lon: -90.78,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'PQMNG',
            wni_port_name: 'PEQUAMING',
            wni_unlocode: 'USCMX',
            wni_country: 'US',
            wni_lat: 46.85,
            wni_lon: -88.4,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'PREQU',
            wni_port_name: 'PRESQUE ISLE',
            wni_unlocode: 'USMQT',
            wni_country: 'US',
            wni_lat: 46.57,
            wni_lon: -87.38,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'PRNCT',
            wni_port_name: 'PRINCETOWN',
            wni_unlocode: 'USRWC',
            wni_country: 'US',
            wni_lat: 37.5,
            wni_lon: -122.48,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'PROSP',
            wni_port_name: 'PROSPER',
            wni_unlocode: 'USCOB',
            wni_country: 'US',
            wni_lat: 43.15,
            wni_lon: -124.37,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'PRSNR',
            wni_port_name: 'PRISONERS',
            wni_unlocode: 'USSBA',
            wni_country: 'US',
            wni_lat: 34.02,
            wni_lon: -119.68,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'PSBAK',
            wni_port_name: 'PETERSBURG',
            wni_unlocode: 'USCAI',
            wni_country: 'US',
            wni_lat: 56.82,
            wni_lon: -132.95,
            wni_tz: 'America/Sitka',
        },
        {
            option: 'PTC',
            wni_port_name: 'PORT CHICAGO',
            wni_unlocode: 'USJQQ',
            wni_country: 'US',
            wni_lat: 38.06,
            wni_lon: -122.04,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'PTCHG',
            wni_port_name: 'PATCHOGUE',
            wni_unlocode: 'USPTJ',
            wni_country: 'US',
            wni_lat: 40.75,
            wni_lon: -73.02,
            wni_tz: 'America/New_York',
        },
        {
            option: 'PTSKY',
            wni_port_name: 'PETOSKEY',
            wni_unlocode: 'USCSX',
            wni_country: 'US',
            wni_lat: 45.37,
            wni_lon: -84.97,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'PTXNT',
            wni_port_name: 'NAVAL AIR STATION PATUXENT RIVER',
            wni_unlocode: 'USCP6',
            wni_country: 'US',
            wni_lat: 38.28,
            wni_lon: -76.41,
            wni_tz: 'America/New_York',
        },
        {
            option: 'PUKOO',
            wni_port_name: 'PUKOO',
            wni_unlocode: 'USLHN',
            wni_country: 'US',
            wni_lat: 21.07,
            wni_lon: -156.8,
            wni_tz: 'Pacific/Honolulu',
        },
        {
            option: 'PVR',
            wni_port_name: 'PORT BOLIVAR',
            wni_unlocode: 'USGLS',
            wni_country: 'US',
            wni_lat: 29.36,
            wni_lon: -94.78,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'QNST',
            wni_port_name: 'QUONSET POINT',
            wni_unlocode: 'USDVV',
            wni_country: 'US',
            wni_lat: 41.58,
            wni_lon: -71.4,
            wni_tz: 'America/New_York',
        },
        {
            option: 'QRTRM',
            wni_port_name: 'QUARTERMASTER HARBOR',
            wni_unlocode: 'USTIW',
            wni_country: 'US',
            wni_lat: 47.38,
            wni_lon: -122.47,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'RAY',
            wni_port_name: 'RAYMOND',
            wni_unlocode: 'USGRV',
            wni_country: 'US',
            wni_lat: 46.68,
            wni_lon: -123.73,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'RBNHD',
            wni_port_name: 'ROBINHOOD',
            wni_unlocode: 'USPWM',
            wni_country: 'US',
            wni_lat: 43.85,
            wni_lon: -69.73,
            wni_tz: 'America/New_York',
        },
        {
            option: 'RCKMA',
            wni_port_name: 'ROCKPORT',
            wni_unlocode: 'USGLO',
            wni_country: 'US',
            wni_lat: 42.67,
            wni_lon: -70.62,
            wni_tz: 'America/New_York',
        },
        {
            option: 'RCKME',
            wni_port_name: 'ROCKPORT',
            wni_unlocode: 'USRKD',
            wni_country: 'US',
            wni_lat: 44.18,
            wni_lon: -69.07,
            wni_tz: 'America/New_York',
        },
        {
            option: 'RCKMI',
            wni_port_name: 'ROCKPORT',
            wni_unlocode: 'USAPN',
            wni_country: 'US',
            wni_lat: 45.2,
            wni_lon: -83.38,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'RCKTX',
            wni_port_name: 'ROCKPORT',
            wni_unlocode: 'USTZS',
            wni_country: 'US',
            wni_lat: 28.02,
            wni_lon: -97.05,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'RDSPR',
            wni_port_name: 'REEDSPORT',
            wni_unlocode: 'USCOB',
            wni_country: 'US',
            wni_lat: 43.7,
            wni_lon: -124.1,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'RICHM',
            wni_port_name: 'PORT RICHMOND IS',
            wni_unlocode: 'USBAY',
            wni_country: 'US',
            wni_lat: 40.65,
            wni_lon: -74.13,
            wni_tz: 'America/New_York',
        },
        {
            option: 'RICHS',
            wni_port_name: 'RICHARDSON',
            wni_unlocode: 'USOTS',
            wni_country: 'US',
            wni_lat: 48.45,
            wni_lon: -122.9,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'RIVP',
            wni_port_name: 'RIVERSIDE',
            wni_unlocode: 'USPPS',
            wni_country: 'US',
            wni_lat: 40.04,
            wni_lon: -74.96,
            wni_tz: 'America/New_York',
        },
        {
            option: 'RNSSL',
            wni_port_name: 'RENSSELAER',
            wni_unlocode: 'USALB',
            wni_country: 'US',
            wni_lat: 42.65,
            wni_lon: -73.75,
            wni_tz: 'America/New_York',
        },
        {
            option: 'ROCWA',
            wni_port_name: 'ROCHE HARBOR',
            wni_unlocode: 'CABAM',
            wni_country: 'US',
            wni_lat: 48.62,
            wni_lon: -123.17,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'ROGRS',
            wni_port_name: 'ROGERS CITY',
            wni_unlocode: 'USMI3',
            wni_country: 'US',
            wni_lat: 45.45,
            wni_lon: -83.82,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'ROSAK',
            wni_port_name: 'ROSE INLET',
            wni_unlocode: 'USHYG',
            wni_country: 'US',
            wni_lat: 54.95,
            wni_lon: -132.97,
            wni_tz: 'America/Sitka',
        },
        {
            option: 'ROUGE',
            wni_port_name: 'ROUGE RIVER',
            wni_unlocode: 'CAWND',
            wni_country: 'US',
            wni_lat: 42.28,
            wni_lon: -83.12,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'SACO',
            wni_port_name: 'SACO',
            wni_unlocode: 'USPWM',
            wni_country: 'US',
            wni_lat: 43.5,
            wni_lon: -70.45,
            wni_tz: 'America/New_York',
        },
        {
            option: 'SAMO',
            wni_port_name: 'SANTA MONICA',
            wni_unlocode: 'USELS',
            wni_country: 'US',
            wni_lat: 34.01,
            wni_lon: -118.5,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'SAMOA',
            wni_port_name: 'SAMOA',
            wni_unlocode: 'USEKA',
            wni_country: 'US',
            wni_lat: 40.82,
            wni_lon: -124.18,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'SANL',
            wni_port_name: 'SAN LUIS OBISPO',
            wni_unlocode: 'USPSL',
            wni_country: 'US',
            wni_lat: 35.32,
            wni_lon: -120.83,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'SBDWA',
            wni_port_name: 'SOUTH BEND',
            wni_unlocode: 'USGRV',
            wni_country: 'US',
            wni_lat: 46.67,
            wni_lon: -123.78,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'SBRIS',
            wni_port_name: 'SOUTH BRISTOL',
            wni_unlocode: 'USRKD',
            wni_country: 'US',
            wni_lat: 43.87,
            wni_lon: -69.55,
            wni_tz: 'America/New_York',
        },
        {
            option: 'SCITU',
            wni_port_name: 'SCITUATE',
            wni_unlocode: 'USBTC',
            wni_country: 'US',
            wni_lat: 42.2,
            wni_lon: -70.72,
            wni_tz: 'America/New_York',
        },
        {
            option: 'SCKTS',
            wni_port_name: 'SACKETS HARBOR',
            wni_unlocode: 'USCLY',
            wni_country: 'US',
            wni_lat: 43.95,
            wni_lon: -76.12,
            wni_tz: 'America/New_York',
        },
        {
            option: 'SCNY',
            wni_port_name: 'PORT SOCONY',
            wni_unlocode: 'USSWN',
            wni_country: 'US',
            wni_lat: 40.55,
            wni_lon: -74.25,
            wni_tz: 'America/New_York',
        },
        {
            option: 'SGTCK',
            wni_port_name: 'SAUGATUCK',
            wni_unlocode: 'USGHN',
            wni_country: 'US',
            wni_lat: 42.67,
            wni_lon: -86.2,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'SHLTN',
            wni_port_name: 'SHELTON',
            wni_unlocode: 'USOLM',
            wni_country: 'US',
            wni_lat: 47.22,
            wni_lon: -123.1,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'SHPRD',
            wni_port_name: 'SHEPARD POINT',
            wni_unlocode: 'USCDV',
            wni_country: 'US',
            wni_lat: 60.63,
            wni_lon: -145.67,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'SINCO',
            wni_port_name: 'SINCO',
            wni_unlocode: 'USPAS',
            wni_country: 'US',
            wni_lat: 29.72,
            wni_lon: -95.23,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'SKOOT',
            wni_port_name: 'SKOOT COVE',
            wni_unlocode: 'USALC',
            wni_country: 'US',
            wni_lat: 52.72,
            wni_lon: 174.07,
            wni_tz: 'America/Adak',
        },
        {
            option: 'SLDL',
            wni_port_name: 'SLIDELL',
            wni_unlocode: 'USMXP',
            wni_country: 'US',
            wni_lat: 30.27,
            wni_lon: -89.78,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'SLEM',
            wni_port_name: 'SALEM NJ',
            wni_unlocode: 'USDCI',
            wni_country: 'US',
            wni_lat: 39.57,
            wni_lon: -75.48,
            wni_tz: 'America/New_York',
        },
        {
            option: 'SLVRD',
            wni_port_name: 'SILVERDALE',
            wni_unlocode: 'USMCR',
            wni_country: 'US',
            wni_lat: 47.65,
            wni_lon: -122.7,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'SMB',
            wni_port_name: 'SMITHS BLUFF',
            wni_unlocode: 'USSML',
            wni_country: 'US',
            wni_lat: 30,
            wni_lon: -93.98,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'SMHM',
            wni_port_name: 'SEMIAHMOO',
            wni_unlocode: 'USCP4',
            wni_country: 'US',
            wni_lat: 48.98,
            wni_lon: -122.77,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'SNDYP',
            wni_port_name: 'SANDYPOINT',
            wni_unlocode: 'USBUP',
            wni_country: 'US',
            wni_lat: 44.52,
            wni_lon: -68.82,
            wni_tz: 'America/New_York',
        },
        {
            option: 'SNZ',
            wni_port_name: 'SANTA CRUZ',
            wni_unlocode: 'USMLG',
            wni_country: 'US',
            wni_lat: 36.97,
            wni_lon: -122.02,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'SODUS',
            wni_port_name: 'SODUS BAY',
            wni_unlocode: 'USOSW',
            wni_country: 'US',
            wni_lat: 43.27,
            wni_lon: -76.98,
            wni_tz: 'America/New_York',
        },
        {
            option: 'SOLMO',
            wni_port_name: 'SOLOMONS ISLAND',
            wni_unlocode: 'USCP6',
            wni_country: 'US',
            wni_lat: 38.32,
            wni_lon: -76.45,
            wni_tz: 'America/New_York',
        },
        {
            option: 'SOLOM',
            wni_port_name: 'SOLOMON',
            wni_unlocode: 'USOME',
            wni_country: 'US',
            wni_lat: 64.55,
            wni_lon: -164.4,
            wni_tz: 'America/Nome',
        },
        {
            option: 'SOMRS',
            wni_port_name: 'SOMERS COVE MARINA',
            wni_unlocode: 'AUSAL',
            wni_country: 'US',
            wni_lat: 37.98,
            wni_lon: -75.86,
            wni_tz: 'America/New_York',
        },
        {
            option: 'SORRT',
            wni_port_name: 'SORRENTO',
            wni_unlocode: 'USBHB',
            wni_country: 'US',
            wni_lat: 44.47,
            wni_lon: -68.18,
            wni_tz: 'America/New_York',
        },
        {
            option: 'SOTCT',
            wni_port_name: 'SOUTHPORT',
            wni_unlocode: 'USBDR',
            wni_country: 'US',
            wni_lat: 41.13,
            wni_lon: -73.28,
            wni_tz: 'America/New_York',
        },
        {
            option: 'SPGMI',
            wni_port_name: 'HARBOR SPRINGS',
            wni_unlocode: 'USCSX',
            wni_country: 'US',
            wni_lat: 45.43,
            wni_lon: -84.98,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'SPIP',
            wni_port_name: 'SANDPIPER',
            wni_unlocode: 'USFPR',
            wni_country: 'US',
            wni_lat: 27.24,
            wni_lon: -80.25,
            wni_tz: 'America/New_York',
        },
        {
            option: 'SPP',
            wni_port_name: 'SPARROWS POINT',
            wni_unlocode: 'USBAL',
            wni_country: 'US',
            wni_lat: 39.27,
            wni_lon: -76.58,
            wni_tz: 'America/New_York',
        },
        {
            option: 'SPRC',
            wni_port_name: 'DRY SPRUCE BAY',
            wni_unlocode: 'USAFK',
            wni_country: 'US',
            wni_lat: 57.93,
            wni_lon: -153.03,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'SSLT',
            wni_port_name: 'SAUSALITO',
            wni_unlocode: 'USSFO',
            wni_country: 'US',
            wni_lat: 37.85,
            wni_lon: -122.48,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'SSM1',
            wni_port_name: 'SAULT STE MARIE',
            wni_unlocode: 'USSSM',
            wni_country: 'US',
            wni_lat: 46.5,
            wni_lon: -84.35,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'STEMB',
            wni_port_name: 'STEAMBOAT BAY',
            wni_unlocode: 'USKLW',
            wni_country: 'US',
            wni_lat: 55.53,
            wni_lon: -133.63,
            wni_tz: 'America/Sitka',
        },
        {
            option: 'STGTN',
            wni_port_name: 'STONINGTON',
            wni_unlocode: 'USRKD',
            wni_country: 'US',
            wni_lat: 44.15,
            wni_lon: -68.67,
            wni_tz: 'America/New_York',
        },
        {
            option: 'STHWS',
            wni_port_name: 'SOUTHWEST HARBOR',
            wni_unlocode: 'USBHB',
            wni_country: 'US',
            wni_lat: 44.28,
            wni_lon: -68.32,
            wni_tz: 'America/New_York',
        },
        {
            option: 'STONN',
            wni_port_name: 'STONINGTON',
            wni_unlocode: 'USGON',
            wni_country: 'US',
            wni_lat: 41.33,
            wni_lon: -71.9,
            wni_tz: 'America/New_York',
        },
        {
            option: 'STPLT',
            wni_port_name: 'STAPLETON IS',
            wni_unlocode: 'USBAY',
            wni_country: 'US',
            wni_lat: 40.63,
            wni_lon: -74.07,
            wni_tz: 'America/New_York',
        },
        {
            option: 'STURG',
            wni_port_name: 'STURGEON BAY',
            wni_unlocode: 'USMOY',
            wni_country: 'US',
            wni_lat: 44.83,
            wni_lon: -87.38,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'SUNT',
            wni_port_name: 'SUNOCO OIL TERMINAL',
            wni_unlocode: 'USMAH',
            wni_country: 'US',
            wni_lat: 39.8,
            wni_lon: -75.41,
            wni_tz: 'America/New_York',
        },
        {
            option: 'SVL',
            wni_port_name: 'SUNNYVALE',
            wni_unlocode: 'USRWC',
            wni_country: 'US',
            wni_lat: 37.36,
            wni_lon: -122.03,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'SWAN',
            wni_port_name: 'SWANS ISLAND',
            wni_unlocode: 'USBHB',
            wni_country: 'US',
            wni_lat: 44.13,
            wni_lon: -68.45,
            wni_tz: 'America/New_York',
        },
        {
            option: 'SWNPR',
            wni_port_name: 'SWANPORT',
            wni_unlocode: 'USVDZ',
            wni_country: 'US',
            wni_lat: 61.08,
            wni_lon: -146.4,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'SWNSB',
            wni_port_name: 'SWANSBORO',
            wni_unlocode: 'USOAJ',
            wni_country: 'US',
            wni_lat: 34.68,
            wni_lon: -77.13,
            wni_tz: 'America/New_York',
        },
        {
            option: 'SYRVL',
            wni_port_name: 'SAYREVILLE',
            wni_unlocode: 'USPAY',
            wni_country: 'US',
            wni_lat: 40.47,
            wni_lon: -74.37,
            wni_tz: 'America/New_York',
        },
        {
            option: 'TANAN',
            wni_port_name: 'TANANI POINT',
            wni_unlocode: 'USHNS',
            wni_country: 'US',
            wni_lat: 59.28,
            wni_lon: -135.45,
            wni_tz: 'America/Juneau',
        },
        {
            option: 'THMST',
            wni_port_name: 'THOMASTON',
            wni_unlocode: 'USRKD',
            wni_country: 'US',
            wni_lat: 44.07,
            wni_lon: -69.18,
            wni_tz: 'America/New_York',
        },
        {
            option: 'TMPKN',
            wni_port_name: 'TOMPKINSVILLE IS',
            wni_unlocode: 'USBAY',
            wni_country: 'US',
            wni_lat: 40.63,
            wni_lon: -74.07,
            wni_tz: 'America/New_York',
        },
        {
            option: 'TNKSP',
            wni_port_name: 'TENAKEE SPRINGS',
            wni_unlocode: 'USHNH',
            wni_country: 'US',
            wni_lat: 57.78,
            wni_lon: -135.2,
            wni_tz: 'America/Juneau',
        },
        {
            option: 'TODD',
            wni_port_name: 'TODD',
            wni_unlocode: 'UWNIN',
            wni_country: 'US',
            wni_lat: 57.47,
            wni_lon: -135.05,
            wni_tz: 'America/Juneau',
        },
        {
            option: 'TOLED',
            wni_port_name: 'TOLEDO',
            wni_unlocode: 'USNPO',
            wni_country: 'US',
            wni_lat: 44.62,
            wni_lon: -123.93,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'TOUNG',
            wni_port_name: 'TONGUE POINT',
            wni_unlocode: 'USAST',
            wni_country: 'US',
            wni_lat: 46.2,
            wni_lon: -123.75,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'TRAVR',
            wni_port_name: 'GRAND TRAVERSE BAY',
            wni_unlocode: 'USCMX',
            wni_country: 'US',
            wni_lat: 47.2,
            wni_lon: -88.2,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'TRICT',
            wni_port_name: 'TRI-CITY PORT',
            wni_unlocode: 'USGZI',
            wni_country: 'US',
            wni_lat: 38.72,
            wni_lon: -90.2,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'TRNTN',
            wni_port_name: 'TRENTON',
            wni_unlocode: 'CAAMH',
            wni_country: 'US',
            wni_lat: 42.13,
            wni_lon: -83.17,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'TROU',
            wni_port_name: 'TROUTDALE',
            wni_unlocode: 'USCMS',
            wni_country: 'US',
            wni_lat: 45.55,
            wni_lon: -122.39,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'TROYN',
            wni_port_name: 'TROY',
            wni_unlocode: 'USALB',
            wni_country: 'US',
            wni_lat: 42.73,
            wni_lon: -73.7,
            wni_tz: 'America/New_York',
        },
        {
            option: 'TRPON',
            wni_port_name: 'TARPON SPRINGS',
            wni_unlocode: 'USPIE',
            wni_country: 'US',
            wni_lat: 28.15,
            wni_lon: -82.77,
            wni_tz: 'America/New_York',
        },
        {
            option: 'TWOWI',
            wni_port_name: 'TWO RIVERS',
            wni_unlocode: 'USMTW',
            wni_country: 'US',
            wni_lat: 44.15,
            wni_lon: -87.57,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'TYO',
            wni_port_name: 'TYONEK',
            wni_unlocode: 'USNIK',
            wni_country: 'US',
            wni_lat: 61.07,
            wni_lon: -151.17,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'UNGA',
            wni_port_name: 'UNGA',
            wni_unlocode: 'USSDP',
            wni_country: 'US',
            wni_lat: 55.18,
            wni_lon: -160.5,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'UNIN',
            wni_port_name: 'UNION BAY',
            wni_unlocode: 'USKTB',
            wni_country: 'US',
            wni_lat: 55.77,
            wni_lon: -132.22,
            wni_tz: 'America/Sitka',
        },
        {
            option: 'VCTNY',
            wni_port_name: 'CAPE VINCENT',
            wni_unlocode: 'CAKIN',
            wni_country: 'US',
            wni_lat: 44.13,
            wni_lon: -76.33,
            wni_tz: 'America/New_York',
        },
        {
            option: 'VERML',
            wni_port_name: 'VERMILION',
            wni_unlocode: 'USHUB',
            wni_country: 'US',
            wni_lat: 41.43,
            wni_lon: -82.37,
            wni_tz: 'America/New_York',
        },
        {
            option: 'VILLG',
            wni_port_name: 'VILLAGE COVE',
            wni_unlocode: 'USSNP',
            wni_country: 'US',
            wni_lat: 57.13,
            wni_lon: -170.27,
            wni_tz: 'America/Adak',
        },
        {
            option: 'VISCA',
            wni_port_name: 'RIO VISTA',
            wni_unlocode: 'USPHG',
            wni_country: 'US',
            wni_lat: 38.15,
            wni_lon: -121.7,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'VITA',
            wni_port_name: 'PORT VITA',
            wni_unlocode: 'USAFK',
            wni_country: 'US',
            wni_lat: 58.07,
            wni_lon: -153.07,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'VLJ',
            wni_port_name: 'SOUTH VALLEJO',
            wni_unlocode: 'USMI8',
            wni_country: 'US',
            wni_lat: 38.08,
            wni_lon: -122.25,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'VNLHV',
            wni_port_name: 'VINALHAVEN',
            wni_unlocode: 'USRKD',
            wni_country: 'US',
            wni_lat: 44.05,
            wni_lon: -68.83,
            wni_tz: 'America/New_York',
        },
        {
            option: 'VNYRD',
            wni_port_name: 'VINEYARD HAVEN',
            wni_unlocode: 'USNBD',
            wni_country: 'US',
            wni_lat: 41.45,
            wni_lon: -70.6,
            wni_tz: 'America/New_York',
        },
        {
            option: 'WAKAK',
            wni_port_name: 'PORT WAKEFIELD',
            wni_unlocode: 'USAFK',
            wni_country: 'US',
            wni_lat: 58.05,
            wni_lon: -153.05,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'WARD',
            wni_port_name: 'FORT WARD',
            wni_unlocode: 'USMCR',
            wni_country: 'US',
            wni_lat: 47.58,
            wni_lon: -122.52,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'WARRT',
            wni_port_name: 'WARRENTON',
            wni_unlocode: 'USAST',
            wni_country: 'US',
            wni_lat: 46.17,
            wni_lon: -123.92,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'WARWC',
            wni_port_name: 'WARWICK',
            wni_unlocode: 'USRIC',
            wni_country: 'US',
            wni_lat: 37.45,
            wni_lon: -77.42,
            wni_tz: 'America/New_York',
        },
        {
            option: 'WEST',
            wni_port_name: 'WEST PALM BEACH',
            wni_unlocode: 'USPAB',
            wni_country: 'US',
            wni_lat: 26.75,
            wni_lon: -80.13,
            wni_tz: 'America/New_York',
        },
        {
            option: 'WHAVN',
            wni_port_name: 'WESTHAVEN COVE',
            wni_unlocode: 'USHQM',
            wni_country: 'US',
            wni_lat: 46.92,
            wni_lon: -124.12,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'WHITE',
            wni_port_name: 'WHITE LAKE',
            wni_unlocode: 'USMKG',
            wni_country: 'US',
            wni_lat: 43.38,
            wni_lon: -86.35,
            wni_tz: 'America/Detroit',
        },
        {
            option: 'WHWKN',
            wni_port_name: 'WEEHAWKEN',
            wni_unlocode: 'USNYC',
            wni_country: 'US',
            wni_lat: 40.77,
            wni_lon: -74.02,
            wni_tz: 'America/New_York',
        },
        {
            option: 'WIL',
            wni_port_name: 'WILLAPA HARBOR',
            wni_unlocode: 'USGRV',
            wni_country: 'US',
            wni_lat: 46.68,
            wni_lon: -123.75,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'WINCHS',
            wni_port_name: 'WINCHESTER BAY',
            wni_unlocode: 'USCOB',
            wni_country: 'US',
            wni_lat: 43.68,
            wni_lon: -124.18,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'WINCS',
            wni_port_name: 'WINCHESTER BAY',
            wni_unlocode: 'USCOB',
            wni_country: 'US',
            wni_lat: 43.68,
            wni_lon: -124.18,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'WING',
            wni_port_name: 'PORT WING',
            wni_unlocode: 'USTHB',
            wni_country: 'US',
            wni_lat: 46.78,
            wni_lon: -91.38,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'WINSW',
            wni_port_name: 'WINSLOW',
            wni_unlocode: 'USMCR',
            wni_country: 'US',
            wni_lat: 47.62,
            wni_lon: -122.52,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'WLA',
            wni_port_name: 'WEST LAKE',
            wni_unlocode: 'USWQL',
            wni_country: 'US',
            wni_lat: 30.25,
            wni_lon: -93.27,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'WLDPR',
            wni_port_name: 'WALDPORT',
            wni_unlocode: 'USNPO',
            wni_country: 'US',
            wni_lat: 44.43,
            wni_lon: -124.07,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'WLMTT',
            wni_port_name: 'WILMETTE',
            wni_unlocode: 'USCLH',
            wni_country: 'US',
            wni_lat: 42.08,
            wni_lon: -87.68,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'WLNT',
            wni_port_name: 'WALNUT GROVE',
            wni_unlocode: 'USSCK',
            wni_country: 'US',
            wni_lat: 38.23,
            wni_lon: -121.52,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'WLSN',
            wni_port_name: 'WILSON COVE',
            wni_unlocode: 'USENC',
            wni_country: 'US',
            wni_lat: 33,
            wni_lon: -118.55,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'WMNS',
            wni_port_name: 'WOMENS BAY',
            wni_unlocode: 'USADQ',
            wni_country: 'US',
            wni_lat: 57.72,
            wni_lon: -152.52,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'WNTER',
            wni_port_name: 'WINTER HARBOR',
            wni_unlocode: 'USBHB',
            wni_country: 'US',
            wni_lat: 44.38,
            wni_lon: -68.08,
            wni_tz: 'America/New_York',
        },
        {
            option: 'WOODS',
            wni_port_name: 'WOODS HOLE',
            wni_unlocode: 'USNBD',
            wni_country: 'US',
            wni_lat: 41.52,
            wni_lon: -70.67,
            wni_tz: 'America/New_York',
        },
        {
            option: 'WPVA',
            wni_port_name: 'WEST POINT',
            wni_unlocode: 'USYKW',
            wni_country: 'US',
            wni_lat: 37.53,
            wni_lon: -76.8,
            wni_tz: 'America/New_York',
        },
        {
            option: 'WRD',
            wni_port_name: 'WARD COVE',
            wni_unlocode: 'USKTN',
            wni_country: 'US',
            wni_lat: 55.4,
            wni_lon: -131.73,
            wni_tz: 'America/Sitka',
        },
        {
            option: 'WRIGH',
            wni_port_name: 'WRIGHTSVILLE',
            wni_unlocode: 'USILM',
            wni_country: 'US',
            wni_lat: 34.22,
            wni_lon: -77.82,
            wni_tz: 'America/New_York',
        },
        {
            option: 'WSGDC1',
            wni_port_name: 'WASHINGTON NAVY YARD',
            wni_unlocode: 'USAXB',
            wni_country: 'US',
            wni_lat: 38.87,
            wni_lon: -77,
            wni_tz: 'America/New_York',
        },
        {
            option: 'WSHBR',
            wni_port_name: 'WASHBURN',
            wni_unlocode: 'USASX',
            wni_country: 'US',
            wni_lat: 46.67,
            wni_lon: -90.88,
            wni_tz: 'America/Chicago',
        },
        {
            option: 'WSTOR',
            wni_port_name: 'WESTPORT',
            wni_unlocode: 'USYCK',
            wni_country: 'US',
            wni_lat: 46.13,
            wni_lon: -123.38,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'WTRFL',
            wni_port_name: 'WATERFALL',
            wni_unlocode: 'USKLW',
            wni_country: 'US',
            wni_lat: 55.3,
            wni_lon: -133.23,
            wni_tz: 'America/Sitka',
        },
        {
            option: 'WYMAN',
            wni_port_name: 'WYMAN',
            wni_unlocode: 'USBHB',
            wni_country: 'US',
            wni_lat: 44.52,
            wni_lon: -67.87,
            wni_tz: 'America/New_York',
        },
        {
            option: 'YERBB',
            wni_port_name: 'YERBABUENA ISLAND',
            wni_unlocode: 'USSFO',
            wni_country: 'US',
            wni_lat: 37.82,
            wni_lon: -122.37,
            wni_tz: 'America/Los_Angeles',
        },
        {
            option: 'YNGNY',
            wni_port_name: 'YOUNGSTOWN',
            wni_unlocode: 'CAPWE',
            wni_country: 'US',
            wni_lat: 43.25,
            wni_lon: -79.05,
            wni_tz: 'America/New_York',
        },
        {
            option: 'YNKRS',
            wni_port_name: 'YONKERS',
            wni_unlocode: 'USKOI',
            wni_country: 'US',
            wni_lat: 40.93,
            wni_lon: -73.9,
            wni_tz: 'America/New_York',
        },
        {
            option: 'IDL',
            wni_port_name: 'ISLA DE LOBOS',
            wni_unlocode: 'UYPDP',
            wni_country: 'UY',
            wni_lat: -34.97,
            wni_lon: -54.94,
            wni_tz: 'America/Montevideo',
        },
        {
            option: 'QBA',
            wni_port_name: 'QUEBRACHO',
            wni_unlocode: 'UYPDU',
            wni_country: 'UY',
            wni_lat: -31.93,
            wni_lon: -57.91,
            wni_tz: 'America/Montevideo',
        },
        {
            option: 'ROH',
            wni_port_name: 'ROCHA',
            wni_unlocode: 'UYLAP',
            wni_country: 'UY',
            wni_lat: -34.5,
            wni_lon: -54.33,
            wni_tz: 'America/Montevideo',
        },
        {
            option: 'RPP',
            wni_port_name: 'RIVER PLATE',
            wni_unlocode: 'UYMVD',
            wni_country: 'UY',
            wni_lat: -35.12,
            wni_lon: -56,
            wni_tz: 'America/Montevideo',
        },
        {
            option: 'SAUCE',
            wni_port_name: 'PUERTO SAUCE',
            wni_unlocode: 'UYCYR',
            wni_country: 'UY',
            wni_lat: -34.43,
            wni_lon: -57.45,
            wni_tz: 'America/Montevideo',
        },
        {
            option: 'ASMIR',
            wni_port_name: 'ADMIRALTY BAY',
            wni_unlocode: 'VCBQU',
            wni_country: 'VC',
            wni_lat: 13,
            wni_lon: -61.25,
            wni_tz: 'America/St_Vincent',
        },
        {
            option: 'AMY',
            wni_port_name: 'BAHIA DE AMUAY',
            wni_unlocode: 'VEAMY',
            wni_country: 'VE',
            wni_lat: 11.75,
            wni_lon: -70.23,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'BAEV',
            wni_port_name: 'BARCELONA',
            wni_unlocode: 'VEGUT',
            wni_country: 'VE',
            wni_lat: 10.13,
            wni_lon: -64.69,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'CAMU',
            wni_port_name: 'CAMURI',
            wni_unlocode: 'VECLM',
            wni_country: 'VE',
            wni_lat: 10.61,
            wni_lon: -66.87,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'CHAC',
            wni_port_name: 'CHACOPATA',
            wni_unlocode: 'VEEGU',
            wni_country: 'VE',
            wni_lat: 10.7,
            wni_lon: -63.82,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'CHAUR',
            wni_port_name: 'EL CHAURE',
            wni_unlocode: 'VEPCZ',
            wni_country: 'VE',
            wni_lat: 10.25,
            wni_lon: -64.62,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'CRU',
            wni_port_name: 'PUERTO CARUPANO',
            wni_unlocode: 'VECUP',
            wni_country: 'VE',
            wni_lat: 10.67,
            wni_lon: -63.25,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'CRV',
            wni_port_name: 'CARACAS',
            wni_unlocode: 'VECLM',
            wni_country: 'VE',
            wni_lat: 10.49,
            wni_lon: -66.9,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'CUMB',
            wni_port_name: 'PUERTO CUMAREBO',
            wni_unlocode: 'VECMR',
            wni_country: 'VE',
            wni_lat: 11.48,
            wni_lon: -69.35,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'DIC',
            wni_port_name: 'DIANCA',
            wni_unlocode: 'VEELC',
            wni_country: 'VE',
            wni_lat: 10.46,
            wni_lon: -67.99,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'GNC',
            wni_port_name: 'GUANOCO',
            wni_unlocode: 'VECAR',
            wni_country: 'VE',
            wni_lat: 10.17,
            wni_lon: -62.93,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'MORN',
            wni_port_name: 'MORON',
            wni_unlocode: 'VEELP',
            wni_country: 'VE',
            wni_lat: 10.53,
            wni_lon: -68.18,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'PBOR',
            wni_port_name: 'PUERTO BORBURATA',
            wni_unlocode: 'VEPBL',
            wni_country: 'VE',
            wni_lat: 10.48,
            wni_lon: -67.98,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'PDRNL',
            wni_port_name: 'PUERTO PEDERNALES',
            wni_unlocode: 'VECXA',
            wni_country: 'VE',
            wni_lat: 9.98,
            wni_lon: -62.25,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'PDRSL',
            wni_port_name: 'BAHIA BOGA DE PIEDRAS',
            wni_unlocode: 'VELSP',
            wni_country: 'VE',
            wni_lat: 11.72,
            wni_lon: -70.22,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'PLMJ',
            wni_port_name: 'PALMAREJO',
            wni_unlocode: 'VEPLV',
            wni_country: 'VE',
            wni_lat: 10.44,
            wni_lon: -71.64,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'PMPTR',
            wni_port_name: 'PAMPATAR',
            wni_unlocode: 'VEEGU',
            wni_country: 'VE',
            wni_lat: 10.98,
            wni_lon: -63.8,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'PRLMR',
            wni_port_name: 'PORLAMAR',
            wni_unlocode: 'VEEGU',
            wni_country: 'VE',
            wni_lat: 10.95,
            wni_lon: -63.85,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'SAJN',
            wni_port_name: 'SAN JUAN',
            wni_unlocode: 'VECAR',
            wni_country: 'VE',
            wni_lat: 10.15,
            wni_lon: -63.03,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'TCCS',
            wni_port_name: 'TUCACAS',
            wni_unlocode: 'VECHC',
            wni_country: 'VE',
            wni_lat: 10.8,
            wni_lon: -68.3,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'VELA',
            wni_port_name: 'LA VELA',
            wni_unlocode: 'VECMR',
            wni_country: 'VE',
            wni_lat: 11.47,
            wni_lon: -69.58,
            wni_tz: 'America/Caracas',
        },
        {
            option: 'RDT',
            wni_port_name: 'ROAD HARBOR',
            wni_unlocode: 'VGPUR',
            wni_country: 'VG',
            wni_lat: 18.42,
            wni_lon: -64.62,
            wni_tz: 'America/Tortola',
        },
        {
            option: 'CRUZB',
            wni_port_name: 'CRUZ BAY',
            wni_unlocode: 'VISTT',
            wni_country: 'VI',
            wni_lat: 18.33,
            wni_lon: -64.8,
            wni_tz: 'America/St_Thomas',
        },
        {
            option: 'HVN',
            wni_port_name: 'HOVENSA',
            wni_unlocode: 'VIHOC',
            wni_country: 'VI',
            wni_lat: 17.69,
            wni_lon: -64.74,
            wni_tz: 'America/St_Thomas',
        },
        {
            option: 'STT',
            wni_port_name: 'ST. THOMAS',
            wni_unlocode: 'VISTT',
            wni_country: 'VI',
            wni_lat: 18.33,
            wni_lon: -64.93,
            wni_tz: 'America/St_Thomas',
        },
        {
            option: 'ANOA',
            wni_port_name: 'AN HOA',
            wni_unlocode: 'VNXNG',
            wni_country: 'VN',
            wni_lat: 15.04,
            wni_lon: 108.74,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'BSE',
            wni_port_name: 'BARIA SERECE',
            wni_unlocode: 'VNPHU',
            wni_country: 'VN',
            wni_lat: 10.59,
            wni_lon: 107.03,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'CHOI',
            wni_port_name: 'CUA HOI',
            wni_unlocode: 'VNHAT',
            wni_country: 'VN',
            wni_lat: 18.77,
            wni_lon: 105.77,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'DUONG',
            wni_port_name: 'DUONG DONG',
            wni_unlocode: 'VNPQC',
            wni_country: 'VN',
            wni_lat: 10.22,
            wni_lon: 103.97,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'GOG',
            wni_port_name: 'GO GIA',
            wni_unlocode: 'VNTOT',
            wni_country: 'VN',
            wni_lat: 10.52,
            wni_lon: 107.01,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'ORSKR',
            wni_port_name: 'ORRSKAR',
            wni_unlocode: 'SELJU',
            wni_country: 'SE',
            wni_lat: 61.21,
            wni_lon: 17.16,
            wni_tz: 'Europe/Stockholm',
        },
        {
            option: 'TIEHN',
            wni_port_name: 'TIESHAN ANCHORAGE',
            wni_unlocode: 'CNBHT',
            wni_country: 'CN',
            wni_lat: 21.36,
            wni_lon: 109.58,
            wni_tz: 'Asia/Chongqing',
        },
        {
            option: 'GRBAY',
            wni_port_name: 'GORE BAY',
            wni_unlocode: 'AUPYR',
            wni_country: 'AU',
            wni_lat: -33.83,
            wni_lon: 151.28,
            wni_tz: 'Australia/Sydney',
        },
        {
            option: 'BGUYON',
            wni_port_name: 'BGUKPYON',
            wni_unlocode: 'KRSUK',
            wni_country: 'KR',
            wni_lat: 37.29,
            wni_lon: 129.08,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'DAGAG',
            wni_port_name: 'DAGANG',
            wni_unlocode: 'CNJSU',
            wni_country: 'CN',
            wni_lat: 33.19,
            wni_lon: 120.1,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'QGNNH',
            wni_port_name: 'QUANG NINH',
            wni_unlocode: 'VNCLN',
            wni_country: 'VN',
            wni_lat: 20.96,
            wni_lon: 107.07,
            wni_tz: 'Asia/Ho_Chi_Minh',
        },
        {
            option: 'XXAKO',
            wni_port_name: 'XIXIAKOU',
            wni_unlocode: 'CNLGY',
            wni_country: 'CN',
            wni_lat: 37.38,
            wni_lon: 122.66,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'HSINTA',
            wni_port_name: 'HSNTA',
            wni_unlocode: 'TWYAN',
            wni_country: 'TW',
            wni_lat: 22.84,
            wni_lon: 120.18,
            wni_tz: 'Asia/Taipei',
        },
        {
            option: 'KTGMA',
            wni_port_name: 'KATOUGOUMA',
            wni_unlocode: 'GNBRP',
            wni_country: 'GN',
            wni_lat: 10.9,
            wni_lon: -14.5,
            wni_tz: 'Africa/Conakry',
        },
        {
            option: 'MKZE',
            wni_port_name: 'Port MacKenzie',
            wni_unlocode: 'USANC',
            wni_country: 'US',
            wni_lat: 61.27,
            wni_lon: -149.92,
            wni_tz: 'America/Anchorage',
        },
        {
            option: 'MLTA',
            wni_port_name: 'MALTA(TBC)',
            wni_unlocode: 'MTMLA',
            wni_country: 'MT',
            wni_lat: 35.93,
            wni_lon: 14.53,
            wni_tz: 'Europe/Malta',
        },
        {
            option: 'COGH',
            wni_port_name: 'CAPE OF GOOD HOPE',
            wni_unlocode: 'ZASMN',
            wni_country: 'ZA',
            wni_lat: -34.36,
            wni_lon: 18.47,
            wni_tz: 'Africa/Johannesburg',
        },
        {
            option: 'PBFF',
            wni_port_name: 'PORT DE BOFFA',
            wni_unlocode: 'GNBFA',
            wni_country: 'GN',
            wni_lat: 10.01,
            wni_lon: -14.1,
            wni_tz: 'Africa/Conakry',
        },
        {
            option: 'ISGO',
            wni_port_name: 'ISOGO',
            wni_unlocode: 'JPYOK',
            wni_country: 'JP',
            wni_lat: 35.4,
            wni_lon: 139.64,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'ART',
            wni_port_name: 'ARDEA LPG TERMINAL',
            wni_unlocode: 'BRCMA',
            wni_country: 'IT',
            wni_lat: 41.55,
            wni_lon: 12.52,
            wni_tz: 'Europe/Rome',
        },
        {
            option: 'MDI',
            wni_port_name: 'MALTA FREEPORT DISTRIPARK',
            wni_unlocode: 'MTMAR',
            wni_country: 'MT',
            wni_lat: 35.82,
            wni_lon: 14.55,
            wni_tz: 'Europe/Valeta',
        },
        {
            option: 'JBT',
            wni_port_name: 'JABUNG TERMINAL',
            wni_unlocode: 'IDMSK',
            wni_country: 'ID',
            wni_lat: -0.89,
            wni_lon: 104.07,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'KFX',
            wni_port_name: 'KORFEX',
            wni_unlocode: 'TREYP',
            wni_country: 'TR',
            wni_lat: 40.77,
            wni_lon: 29.72,
            wni_tz: 'Europe/Ankara',
        },
        {
            option: 'SKW',
            wni_port_name: 'SKAW LIGHTERING',
            wni_unlocode: 'DKSKA',
            wni_country: 'DK',
            wni_lat: 57.73,
            wni_lon: 10.63,
            wni_tz: 'Europe/Copenhagen',
        },
        {
            option: 'RPN',
            wni_port_name: 'REPAUNO',
            wni_unlocode: 'USPAU',
            wni_country: 'US',
            wni_lat: 39.84,
            wni_lon: -75.3,
            wni_tz: 'America/New_Jersey',
        },
        {
            option: 'TJKH',
            wni_port_name: 'TANJUNG KAMEAH',
            wni_unlocode: 'IDAPI',
            wni_country: 'ID',
            wni_lat: -2.18,
            wni_lon: 104.9,
            wni_tz: 'Asia/Jakarta',
        },
        {
            option: 'ANIN',
            wni_port_name: 'ANIN',
            wni_unlocode: 'KROKK',
            wni_country: 'KR',
            wni_lat: 37.75,
            wni_lon: 129.01,
            wni_tz: 'Asia/Seoul',
        },
        {
            option: 'YSNR',
            wni_port_name: 'YOSHINOURA',
            wni_unlocode: 'JPNHR',
            wni_country: 'JP',
            wni_lat: 26.26,
            wni_lon: 127.82,
            wni_tz: 'Asia/Tokyo',
        },
        {
            option: 'LNQO',
            wni_port_name: 'LANQIAO',
            wni_unlocode: 'CNLSN',
            wni_country: 'CN',
            wni_lat: 35.1,
            wni_lon: 119.42,
            wni_tz: 'Asia/Shanghai',
        },
        {
            option: 'OSGN',
            wni_port_name: 'OFFSHORE GUYANA',
            wni_unlocode: 'GYLDE',
            wni_country: 'BR',
            wni_lat: 8,
            wni_lon: -56.98,
            wni_tz: 'America/Guyana',
        },
    ],
    reportSwellDir: [
        {
            Direction: 0,
            // 16 Direction
            "option": 'N',
        },
        {
            Direction: 22.5,
            "option": 'NNE',
        },
        {
            Direction: 45,
            "option": 'NE',
        },
        {
            Direction: 67.5,
            "option": 'ENE',
        },
        {
            Direction: 90,
            "option": 'E',
        },
        {
            Direction: 112.5,
            "option": 'ESE',
        },
        {
            Direction: 135,
            "option": 'SE',
        },
        {
            Direction: 157.5,
            "option": 'SSE',
        },
        {
            Direction: 180,
            "option": 'S',
        },
        {
            Direction: 202.5,
            "option": 'SSW',
        },
        {
            Direction: 225,
            "option": 'SW',
        },
        {
            Direction: 247.5,
            "option": 'WSW',
        },
        {
            Direction: 270,
            "option": 'W',
        },
        {
            Direction: 292.5,
            "option": 'WNW',
        },
        {
            Direction: 315,
            "option": 'NW',
        },
        {
            Direction: 337.5,
            "option": 'NNW',
        },
    ],
    event:[
        {
          "key": "start_stoppage",
          // option
          "option": "Start stoppage"
        },
        {
          "key": "end_stoppage",
          "option": "End stoppage"
        },
        {
          "key": "start_transit_strait",
          "option": "Start transit strait"
        },
        {
          "key": "end_transit_strait",
          "option": "End transit strait"
        },
        {
          "key": "start_changeover_eca",
          "option": "Start fuel changeover (FO to others)"
        },
        {
          "key": "end_changeover_eca",
          "option": "End fuel changeover (others to FO)"
        },
        {
          "key": "speed_change",
          "option": "Speed change"
        },
        {
          "key": "desitination_change",
          "option": "Destination change"
        },
        {
          "key": "diverted_route",
          "option": "Diverted route"
        },
        {
          "key": "start_ice_passage",
          "option": "Start ice passage"
        },
        {
          "key": "end_ice_passage",
          "option": "End ice passage"
        },
        {
          "key": "start_rescue",
          "option": "Start rescue"
        },
        {
          "key": "end_rescue",
          "option": "End rescue"
        },
        {
          "key": "start_pirate",
          "option": "Start pirate"
        },
        {
          "key": "end_pirate",
          "option": "End pirate"
        },
        {
          "key": "start_drydock",
          "option": "Start dry-docking"
        },
        {
          "key": "end_drydock",
          "option": "End dry-docking"
        },
        {
          "key": "start_laidup",
          "option": "Start laid-up"
        },
        {
          "key": "end_laidup",
          "option": "End laid-up"
        }
      ],
      loadingCondition:[
        {
            option:"Laden"
        },
        {
            option:"Ballast"
        }
      ]
}
